import * as B from "react";
import rt, { forwardRef as _u, useContext as nr, isValidElement as ja, cloneElement as qa, Children as r0, Component as xr, createContext as Tr, useReducer as ho, useEffect as Ai, Fragment as er, useState as a0, useMemo as WU, useRef as $y } from "react";
import { styled as cn, alpha as Zo, useThemeProps as KU, useTheme as Uy } from "@mui/material/styles";
import { Divider as _l, Typography as ye, Card as zx, CardHeader as Gx, CardContent as Hx, AccordionDetails as jy, List as YU, ListItem as XU, ListItemText as ZU, Menu as JU, MenuItem as QU, styled as i0, Chip as du, Button as Wl, TableRow as Oa, TableCell as qe, Table as ej, TableHead as tj, TableBody as nj, Accordion as o0, AccordionSummary as s0, Box as qy } from "@mui/material";
import ha from "react-dom";
function Cu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Dd = { exports: {} }, qo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vx;
function rj() {
  if (Vx) return qo;
  Vx = 1;
  var e = rt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, d) {
    var p, f = {}, m = null, h = null;
    d !== void 0 && (m = "" + d), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (p in c) r.call(c, p) && !i.hasOwnProperty(p) && (f[p] = c[p]);
    if (u && u.defaultProps) for (p in c = u.defaultProps, c) f[p] === void 0 && (f[p] = c[p]);
    return { $$typeof: t, type: u, key: m, ref: h, props: f, _owner: a.current };
  }
  return qo.Fragment = n, qo.jsx = s, qo.jsxs = s, qo;
}
var Wx;
function aj() {
  return Wx || (Wx = 1, Dd.exports = rj()), Dd.exports;
}
var R = aj();
function l0(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = l0(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function pt() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = l0(e)) && (r && (r += " "), r += t);
  return r;
}
function Dn(e, t, n = void 0) {
  const r = {};
  for (const a in e) {
    const i = e[a];
    let s = "", u = !0;
    for (let c = 0; c < i.length; c += 1) {
      const d = i[c];
      d && (s += (u === !0 ? "" : " ") + t(d), u = !1, n && n[d] && (s += " " + n[d]));
    }
    r[a] = s;
  }
  return r;
}
function Si(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function En(e) {
  if (typeof e != "string")
    throw new Error(Si(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var Md = { exports: {} }, it = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kx;
function ij() {
  if (Kx) return it;
  Kx = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h = Symbol.for("react.client.reference");
  function E(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case n:
            case a:
            case r:
            case c:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case u:
                case f:
                case p:
                  return y;
                case i:
                  return y;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return it.ContextConsumer = i, it.ContextProvider = s, it.Element = e, it.ForwardRef = u, it.Fragment = n, it.Lazy = f, it.Memo = p, it.Portal = t, it.Profiler = a, it.StrictMode = r, it.Suspense = c, it.SuspenseList = d, it.isContextConsumer = function(y) {
    return E(y) === i;
  }, it.isContextProvider = function(y) {
    return E(y) === s;
  }, it.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, it.isForwardRef = function(y) {
    return E(y) === u;
  }, it.isFragment = function(y) {
    return E(y) === n;
  }, it.isLazy = function(y) {
    return E(y) === f;
  }, it.isMemo = function(y) {
    return E(y) === p;
  }, it.isPortal = function(y) {
    return E(y) === t;
  }, it.isProfiler = function(y) {
    return E(y) === a;
  }, it.isStrictMode = function(y) {
    return E(y) === r;
  }, it.isSuspense = function(y) {
    return E(y) === c;
  }, it.isSuspenseList = function(y) {
    return E(y) === d;
  }, it.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === a || y === r || y === c || y === d || y === m || typeof y == "object" && y !== null && (y.$$typeof === f || y.$$typeof === p || y.$$typeof === s || y.$$typeof === i || y.$$typeof === u || y.$$typeof === h || y.getModuleId !== void 0);
  }, it.typeOf = E, it;
}
var Yx;
function oj() {
  return Yx || (Yx = 1, Md.exports = /* @__PURE__ */ ij()), Md.exports;
}
var u0 = /* @__PURE__ */ oj();
function Kr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function c0(e) {
  if (/* @__PURE__ */ B.isValidElement(e) || u0.isValidElementType(e) || !Kr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = c0(e[n]);
  }), t;
}
function Xn(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Kr(e) && Kr(t) && Object.keys(t).forEach((a) => {
    /* @__PURE__ */ B.isValidElement(t[a]) || u0.isValidElementType(t[a]) ? r[a] = t[a] : Kr(t[a]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, a) && Kr(e[a]) ? r[a] = Xn(e[a], t[a], n) : n.clone ? r[a] = Kr(t[a]) ? c0(t[a]) : t[a] : r[a] = t[a];
  }), r;
}
function os(e, t) {
  return t ? Xn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function sj(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, a) => {
    const i = /min-width:\s*([0-9.]+)/;
    return +(r.match(i)?.[1] || 0) - +(a.match(i)?.[1] || 0);
  });
  return n.length ? n.reduce((r, a) => {
    const i = t[a];
    return delete r[a], r[a] = i, r;
  }, {
    ...t
  }) : t;
}
function lj(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function uj(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, a] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(a).up(i);
}
function cj(e) {
  const t = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function n(i, s) {
    i.up = (...u) => t(e.breakpoints.up(...u), s), i.down = (...u) => t(e.breakpoints.down(...u), s), i.between = (...u) => t(e.breakpoints.between(...u), s), i.only = (...u) => t(e.breakpoints.only(...u), s), i.not = (...u) => {
      const c = t(e.breakpoints.not(...u), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, a = (i) => (n(r, i), r);
  return n(a), {
    ...e,
    containerQueries: a
  };
}
const ku = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Xx = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${ku[e]}px)`
}, dj = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : ku[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function ya(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || Xx;
    return t.reduce((s, u, c) => (s[i.up(i.keys[c])] = n(t[c]), s), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || Xx;
    return Object.keys(t).reduce((s, u) => {
      if (lj(i.keys, u)) {
        const c = uj(r.containerQueries ? r : dj, u);
        c && (s[c] = n(t[u], u));
      } else if (Object.keys(i.values || ku).includes(u)) {
        const c = i.up(u);
        s[c] = n(t[u], u);
      } else {
        const c = u;
        s[c] = t[c];
      }
      return s;
    }, {});
  }
  return n(t);
}
function pj(e = {}) {
  return e.keys?.reduce((n, r) => {
    const a = e.up(r);
    return n[a] = {}, n;
  }, {}) || {};
}
function fj(e, t) {
  return e.reduce((n, r) => {
    const a = n[r];
    return (!a || Object.keys(a).length === 0) && delete n[r], n;
  }, t);
}
function Nu(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((a, i) => a && a[i] ? a[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, a) => r && r[a] != null ? r[a] : null, e);
}
function pu(e, t, n, r = n) {
  let a;
  return typeof e == "function" ? a = e(n) : Array.isArray(e) ? a = e[n] || r : a = Nu(e, n) || r, t && (a = t(a, r, e)), a;
}
function zt(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: a
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const u = s[t], c = s.theme, d = Nu(c, r) || {};
    return ya(s, u, (f) => {
      let m = pu(d, a, f);
      return f === m && typeof f == "string" && (m = pu(d, a, `${t}${f === "default" ? "" : En(f)}`, f)), n === !1 ? m : {
        [n]: m
      };
    });
  };
  return i.propTypes = {}, i.filterProps = [t], i;
}
function gj(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const mj = {
  m: "margin",
  p: "padding"
}, hj = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Zx = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, bj = gj((e) => {
  if (e.length > 2)
    if (Zx[e])
      e = Zx[e];
    else
      return [e];
  const [t, n] = e.split(""), r = mj[t], a = hj[n] || "";
  return Array.isArray(a) ? a.map((i) => r + i) : [r + a];
}), zy = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Gy = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...zy, ...Gy];
function ws(e, t, n, r) {
  const a = Nu(e, t, !0) ?? n;
  return typeof a == "number" || typeof a == "string" ? (i) => typeof i == "string" ? i : typeof a == "string" ? `calc(${i} * ${a})` : a * i : Array.isArray(a) ? (i) => {
    if (typeof i == "string")
      return i;
    const s = Math.abs(i), u = a[s];
    return i >= 0 ? u : typeof u == "number" ? -u : `-${u}`;
  } : typeof a == "function" ? a : () => {
  };
}
function Hy(e) {
  return ws(e, "spacing", 8);
}
function As(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function yj(e, t) {
  return (n) => e.reduce((r, a) => (r[a] = As(t, n), r), {});
}
function vj(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const a = bj(n), i = yj(a, r), s = e[n];
  return ya(e, s, i);
}
function d0(e, t) {
  const n = Hy(e.theme);
  return Object.keys(e).map((r) => vj(e, t, r, n)).reduce(os, {});
}
function Dt(e) {
  return d0(e, zy);
}
Dt.propTypes = {};
Dt.filterProps = zy;
function Mt(e) {
  return d0(e, Gy);
}
Mt.propTypes = {};
Mt.filterProps = Gy;
function Ou(...e) {
  const t = e.reduce((r, a) => (a.filterProps.forEach((i) => {
    r[i] = a;
  }), r), {}), n = (r) => Object.keys(r).reduce((a, i) => t[i] ? os(a, t[i](r)) : a, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, a) => r.concat(a.filterProps), []), n;
}
function hr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function wr(e, t) {
  return zt({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Ej = wr("border", hr), Sj = wr("borderTop", hr), xj = wr("borderRight", hr), Tj = wr("borderBottom", hr), wj = wr("borderLeft", hr), Aj = wr("borderColor"), Ij = wr("borderTopColor"), Rj = wr("borderRightColor"), _j = wr("borderBottomColor"), Cj = wr("borderLeftColor"), kj = wr("outline", hr), Nj = wr("outlineColor"), Lu = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = ws(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: As(t, r)
    });
    return ya(e, e.borderRadius, n);
  }
  return null;
};
Lu.propTypes = {};
Lu.filterProps = ["borderRadius"];
Ou(Ej, Sj, xj, Tj, wj, Aj, Ij, Rj, _j, Cj, Lu, kj, Nj);
const Du = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = ws(e.theme, "spacing", 8), n = (r) => ({
      gap: As(t, r)
    });
    return ya(e, e.gap, n);
  }
  return null;
};
Du.propTypes = {};
Du.filterProps = ["gap"];
const Mu = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = ws(e.theme, "spacing", 8), n = (r) => ({
      columnGap: As(t, r)
    });
    return ya(e, e.columnGap, n);
  }
  return null;
};
Mu.propTypes = {};
Mu.filterProps = ["columnGap"];
const Fu = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = ws(e.theme, "spacing", 8), n = (r) => ({
      rowGap: As(t, r)
    });
    return ya(e, e.rowGap, n);
  }
  return null;
};
Fu.propTypes = {};
Fu.filterProps = ["rowGap"];
const Oj = zt({
  prop: "gridColumn"
}), Lj = zt({
  prop: "gridRow"
}), Dj = zt({
  prop: "gridAutoFlow"
}), Mj = zt({
  prop: "gridAutoColumns"
}), Fj = zt({
  prop: "gridAutoRows"
}), Pj = zt({
  prop: "gridTemplateColumns"
}), Bj = zt({
  prop: "gridTemplateRows"
}), $j = zt({
  prop: "gridTemplateAreas"
}), Uj = zt({
  prop: "gridArea"
});
Ou(Du, Mu, Fu, Oj, Lj, Dj, Mj, Fj, Pj, Bj, $j, Uj);
function no(e, t) {
  return t === "grey" ? t : e;
}
const jj = zt({
  prop: "color",
  themeKey: "palette",
  transform: no
}), qj = zt({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: no
}), zj = zt({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: no
});
Ou(jj, qj, zj);
function Wn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Gj = zt({
  prop: "width",
  transform: Wn
}), Vy = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      const r = e.theme?.breakpoints?.values?.[n] || ku[n];
      return r ? e.theme?.breakpoints?.unit !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: Wn(n)
      };
    };
    return ya(e, e.maxWidth, t);
  }
  return null;
};
Vy.filterProps = ["maxWidth"];
const Hj = zt({
  prop: "minWidth",
  transform: Wn
}), Vj = zt({
  prop: "height",
  transform: Wn
}), Wj = zt({
  prop: "maxHeight",
  transform: Wn
}), Kj = zt({
  prop: "minHeight",
  transform: Wn
});
zt({
  prop: "size",
  cssProperty: "width",
  transform: Wn
});
zt({
  prop: "size",
  cssProperty: "height",
  transform: Wn
});
const Yj = zt({
  prop: "boxSizing"
});
Ou(Gj, Vy, Hj, Vj, Wj, Kj, Yj);
const Is = {
  // borders
  border: {
    themeKey: "borders",
    transform: hr
  },
  borderTop: {
    themeKey: "borders",
    transform: hr
  },
  borderRight: {
    themeKey: "borders",
    transform: hr
  },
  borderBottom: {
    themeKey: "borders",
    transform: hr
  },
  borderLeft: {
    themeKey: "borders",
    transform: hr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: hr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Lu
  },
  // palette
  color: {
    themeKey: "palette",
    transform: no
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: no
  },
  backgroundColor: {
    themeKey: "palette",
    transform: no
  },
  // spacing
  p: {
    style: Mt
  },
  pt: {
    style: Mt
  },
  pr: {
    style: Mt
  },
  pb: {
    style: Mt
  },
  pl: {
    style: Mt
  },
  px: {
    style: Mt
  },
  py: {
    style: Mt
  },
  padding: {
    style: Mt
  },
  paddingTop: {
    style: Mt
  },
  paddingRight: {
    style: Mt
  },
  paddingBottom: {
    style: Mt
  },
  paddingLeft: {
    style: Mt
  },
  paddingX: {
    style: Mt
  },
  paddingY: {
    style: Mt
  },
  paddingInline: {
    style: Mt
  },
  paddingInlineStart: {
    style: Mt
  },
  paddingInlineEnd: {
    style: Mt
  },
  paddingBlock: {
    style: Mt
  },
  paddingBlockStart: {
    style: Mt
  },
  paddingBlockEnd: {
    style: Mt
  },
  m: {
    style: Dt
  },
  mt: {
    style: Dt
  },
  mr: {
    style: Dt
  },
  mb: {
    style: Dt
  },
  ml: {
    style: Dt
  },
  mx: {
    style: Dt
  },
  my: {
    style: Dt
  },
  margin: {
    style: Dt
  },
  marginTop: {
    style: Dt
  },
  marginRight: {
    style: Dt
  },
  marginBottom: {
    style: Dt
  },
  marginLeft: {
    style: Dt
  },
  marginX: {
    style: Dt
  },
  marginY: {
    style: Dt
  },
  marginInline: {
    style: Dt
  },
  marginInlineStart: {
    style: Dt
  },
  marginInlineEnd: {
    style: Dt
  },
  marginBlock: {
    style: Dt
  },
  marginBlockStart: {
    style: Dt
  },
  marginBlockEnd: {
    style: Dt
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Du
  },
  rowGap: {
    style: Fu
  },
  columnGap: {
    style: Mu
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Wn
  },
  maxWidth: {
    style: Vy
  },
  minWidth: {
    transform: Wn
  },
  height: {
    transform: Wn
  },
  maxHeight: {
    transform: Wn
  },
  minHeight: {
    transform: Wn
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Xj(...e) {
  const t = e.reduce((r, a) => r.concat(Object.keys(a)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function Zj(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Jj() {
  function e(n, r, a, i) {
    const s = {
      [n]: r,
      theme: a
    }, u = i[n];
    if (!u)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: d,
      transform: p,
      style: f
    } = u;
    if (r == null)
      return null;
    if (d === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const m = Nu(a, d) || {};
    return f ? f(s) : ya(s, r, (E) => {
      let y = pu(m, p, E);
      return E === y && typeof E == "string" && (y = pu(m, p, `${n}${E === "default" ? "" : En(E)}`, E)), c === !1 ? y : {
        [c]: y
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: a = {}
    } = n || {};
    if (!r)
      return null;
    const i = a.unstable_sxConfig ?? Is;
    function s(u) {
      let c = u;
      if (typeof u == "function")
        c = u(a);
      else if (typeof u != "object")
        return u;
      if (!c)
        return null;
      const d = pj(a.breakpoints), p = Object.keys(d);
      let f = d;
      return Object.keys(c).forEach((m) => {
        const h = Zj(c[m], a);
        if (h != null)
          if (typeof h == "object")
            if (i[m])
              f = os(f, e(m, h, a, i));
            else {
              const E = ya({
                theme: a
              }, h, (y) => ({
                [m]: y
              }));
              Xj(E, h) ? f[m] = t({
                sx: h,
                theme: a
              }) : f = os(f, E);
            }
          else
            f = os(f, e(m, h, a, i));
      }), sj(a, fj(p, f));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const xi = Jj();
xi.filterProps = ["sx"];
const Qj = (e) => {
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = e?.theme?.unstable_sxConfig ?? Is;
  return Object.keys(e).forEach((r) => {
    n[r] ? t.systemProps[r] = e[r] : t.otherProps[r] = e[r];
  }), t;
};
function Wy(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: a
  } = Qj(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...s) => {
    const u = t(...s);
    return Kr(u) ? {
      ...r,
      ...u
    } : r;
  } : i = {
    ...r,
    ...t
  }, {
    ...a,
    sx: i
  };
}
function K() {
  return K = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, K.apply(null, arguments);
}
function eq(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function tq(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var nq = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, i), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(tq(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = eq(a);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var a;
      return (a = r.parentNode) == null ? void 0 : a.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), fn = "-ms-", fu = "-moz-", Ve = "-webkit-", p0 = "comm", Ky = "rule", Yy = "decl", rq = "@import", f0 = "@keyframes", aq = "@layer", iq = Math.abs, Pu = String.fromCharCode, oq = Object.assign;
function sq(e, t) {
  return ln(e, 0) ^ 45 ? (((t << 2 ^ ln(e, 0)) << 2 ^ ln(e, 1)) << 2 ^ ln(e, 2)) << 2 ^ ln(e, 3) : 0;
}
function g0(e) {
  return e.trim();
}
function lq(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ke(e, t, n) {
  return e.replace(t, n);
}
function ey(e, t) {
  return e.indexOf(t);
}
function ln(e, t) {
  return e.charCodeAt(t) | 0;
}
function ds(e, t, n) {
  return e.slice(t, n);
}
function zr(e) {
  return e.length;
}
function Xy(e) {
  return e.length;
}
function Cl(e, t) {
  return t.push(e), e;
}
function uq(e, t) {
  return e.map(t).join("");
}
var Bu = 1, fo = 1, m0 = 0, On = 0, Wt = 0, bo = "";
function $u(e, t, n, r, a, i, s) {
  return { value: e, root: t, parent: n, type: r, props: a, children: i, line: Bu, column: fo, length: s, return: "" };
}
function zo(e, t) {
  return oq($u("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function cq() {
  return Wt;
}
function dq() {
  return Wt = On > 0 ? ln(bo, --On) : 0, fo--, Wt === 10 && (fo = 1, Bu--), Wt;
}
function Zn() {
  return Wt = On < m0 ? ln(bo, On++) : 0, fo++, Wt === 10 && (fo = 1, Bu++), Wt;
}
function Zr() {
  return ln(bo, On);
}
function Kl() {
  return On;
}
function Rs(e, t) {
  return ds(bo, e, t);
}
function ps(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function h0(e) {
  return Bu = fo = 1, m0 = zr(bo = e), On = 0, [];
}
function b0(e) {
  return bo = "", e;
}
function Yl(e) {
  return g0(Rs(On - 1, ty(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function pq(e) {
  for (; (Wt = Zr()) && Wt < 33; )
    Zn();
  return ps(e) > 2 || ps(Wt) > 3 ? "" : " ";
}
function fq(e, t) {
  for (; --t && Zn() && !(Wt < 48 || Wt > 102 || Wt > 57 && Wt < 65 || Wt > 70 && Wt < 97); )
    ;
  return Rs(e, Kl() + (t < 6 && Zr() == 32 && Zn() == 32));
}
function ty(e) {
  for (; Zn(); )
    switch (Wt) {
      // ] ) " '
      case e:
        return On;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && ty(Wt);
        break;
      // (
      case 40:
        e === 41 && ty(e);
        break;
      // \
      case 92:
        Zn();
        break;
    }
  return On;
}
function gq(e, t) {
  for (; Zn() && e + Wt !== 57; )
    if (e + Wt === 84 && Zr() === 47)
      break;
  return "/*" + Rs(t, On - 1) + "*" + Pu(e === 47 ? e : Zn());
}
function mq(e) {
  for (; !ps(Zr()); )
    Zn();
  return Rs(e, On);
}
function hq(e) {
  return b0(Xl("", null, null, null, [""], e = h0(e), 0, [0], e));
}
function Xl(e, t, n, r, a, i, s, u, c) {
  for (var d = 0, p = 0, f = s, m = 0, h = 0, E = 0, y = 1, w = 1, x = 1, I = 0, S = "", C = a, T = i, A = r, O = S; w; )
    switch (E = I, I = Zn()) {
      // (
      case 40:
        if (E != 108 && ln(O, f - 1) == 58) {
          ey(O += Ke(Yl(I), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += Yl(I);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += pq(E);
        break;
      // \
      case 92:
        O += fq(Kl() - 1, 7);
        continue;
      // /
      case 47:
        switch (Zr()) {
          case 42:
          case 47:
            Cl(bq(gq(Zn(), Kl()), t, n), c);
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * y:
        u[d++] = zr(O) * x;
      // } ; \0
      case 125 * y:
      case 59:
      case 0:
        switch (I) {
          // \0 }
          case 0:
          case 125:
            w = 0;
          // ;
          case 59 + p:
            x == -1 && (O = Ke(O, /\f/g, "")), h > 0 && zr(O) - f && Cl(h > 32 ? Qx(O + ";", r, n, f - 1) : Qx(Ke(O, " ", "") + ";", r, n, f - 2), c);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (Cl(A = Jx(O, t, n, d, p, a, u, S, C = [], T = [], f), i), I === 123)
              if (p === 0)
                Xl(O, t, A, A, C, i, f, u, T);
              else
                switch (m === 99 && ln(O, 3) === 110 ? 100 : m) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Xl(e, A, A, r && Cl(Jx(e, A, A, 0, 0, a, u, S, a, C = [], f), T), a, T, f, u, r ? C : T);
                    break;
                  default:
                    Xl(O, A, A, A, [""], T, 0, u, T);
                }
        }
        d = p = h = 0, y = x = 1, S = O = "", f = s;
        break;
      // :
      case 58:
        f = 1 + zr(O), h = E;
      default:
        if (y < 1) {
          if (I == 123)
            --y;
          else if (I == 125 && y++ == 0 && dq() == 125)
            continue;
        }
        switch (O += Pu(I), I * y) {
          // &
          case 38:
            x = p > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            u[d++] = (zr(O) - 1) * x, x = 1;
            break;
          // @
          case 64:
            Zr() === 45 && (O += Yl(Zn())), m = Zr(), p = f = zr(S = O += mq(Kl())), I++;
            break;
          // -
          case 45:
            E === 45 && zr(O) == 2 && (y = 0);
        }
    }
  return i;
}
function Jx(e, t, n, r, a, i, s, u, c, d, p) {
  for (var f = a - 1, m = a === 0 ? i : [""], h = Xy(m), E = 0, y = 0, w = 0; E < r; ++E)
    for (var x = 0, I = ds(e, f + 1, f = iq(y = s[E])), S = e; x < h; ++x)
      (S = g0(y > 0 ? m[x] + " " + I : Ke(I, /&\f/g, m[x]))) && (c[w++] = S);
  return $u(e, t, n, a === 0 ? Ky : u, c, d, p);
}
function bq(e, t, n) {
  return $u(e, t, n, p0, Pu(cq()), ds(e, 2, -2), 0);
}
function Qx(e, t, n, r) {
  return $u(e, t, n, Yy, ds(e, 0, r), ds(e, r + 1, -1), r);
}
function ro(e, t) {
  for (var n = "", r = Xy(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function yq(e, t, n, r) {
  switch (e.type) {
    case aq:
      if (e.children.length) break;
    case rq:
    case Yy:
      return e.return = e.return || e.value;
    case p0:
      return "";
    case f0:
      return e.return = e.value + "{" + ro(e.children, r) + "}";
    case Ky:
      e.value = e.props.join(",");
  }
  return zr(n = ro(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function vq(e) {
  var t = Xy(e);
  return function(n, r, a, i) {
    for (var s = "", u = 0; u < t; u++)
      s += e[u](n, r, a, i) || "";
    return s;
  };
}
function Eq(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function y0(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Sq = function(t, n, r) {
  for (var a = 0, i = 0; a = i, i = Zr(), a === 38 && i === 12 && (n[r] = 1), !ps(i); )
    Zn();
  return Rs(t, On);
}, xq = function(t, n) {
  var r = -1, a = 44;
  do
    switch (ps(a)) {
      case 0:
        a === 38 && Zr() === 12 && (n[r] = 1), t[r] += Sq(On - 1, n, r);
        break;
      case 2:
        t[r] += Yl(a);
        break;
      case 4:
        if (a === 44) {
          t[++r] = Zr() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += Pu(a);
    }
  while (a = Zn());
  return t;
}, Tq = function(t, n) {
  return b0(xq(h0(t), n));
}, eT = /* @__PURE__ */ new WeakMap(), wq = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, a = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !eT.get(r)) && !a) {
      eT.set(t, !0);
      for (var i = [], s = Tq(n, i), u = r.props, c = 0, d = 0; c < s.length; c++)
        for (var p = 0; p < u.length; p++, d++)
          t.props[d] = i[c] ? s[c].replace(/&\f/g, u[p]) : u[p] + " " + s[c];
    }
  }
}, Aq = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function v0(e, t) {
  switch (sq(e, t)) {
    // color-adjust
    case 5103:
      return Ve + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ve + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ve + e + fu + e + fn + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Ve + e + fn + e + e;
    // order
    case 6165:
      return Ve + e + fn + "flex-" + e + e;
    // align-items
    case 5187:
      return Ve + e + Ke(e, /(\w+).+(:[^]+)/, Ve + "box-$1$2" + fn + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Ve + e + fn + "flex-item-" + Ke(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Ve + e + fn + "flex-line-pack" + Ke(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Ve + e + fn + Ke(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Ve + e + fn + Ke(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Ve + "box-" + Ke(e, "-grow", "") + Ve + e + fn + Ke(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Ve + Ke(e, /([^-])(transform)/g, "$1" + Ve + "$2") + e;
    // cursor
    case 6187:
      return Ke(Ke(Ke(e, /(zoom-|grab)/, Ve + "$1"), /(image-set)/, Ve + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Ke(e, /(image-set\([^]*)/, Ve + "$1$`$1");
    // justify-content
    case 4968:
      return Ke(Ke(e, /(.+:)(flex-)?(.*)/, Ve + "box-pack:$3" + fn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ve + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ke(e, /(.+)-inline(.+)/, Ve + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (zr(e) - 1 - t > 6) switch (ln(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (ln(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Ke(e, /(.+:)(.+)-([^]+)/, "$1" + Ve + "$2-$3$1" + fu + (ln(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~ey(e, "stretch") ? v0(Ke(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (ln(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (ln(e, zr(e) - 3 - (~ey(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Ke(e, ":", ":" + Ve) + e;
        // (inline-)?fl(e)x
        case 101:
          return Ke(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ve + (ln(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ve + "$2$3$1" + fn + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (ln(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Ve + e + fn + Ke(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Ve + e + fn + Ke(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Ve + e + fn + Ke(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ve + e + fn + e + e;
  }
  return e;
}
var Iq = function(t, n, r, a) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Yy:
      t.return = v0(t.value, t.length);
      break;
    case f0:
      return ro([zo(t, {
        value: Ke(t.value, "@", "@" + Ve)
      })], a);
    case Ky:
      if (t.length) return uq(t.props, function(i) {
        switch (lq(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return ro([zo(t, {
              props: [Ke(i, /:(read-\w+)/, ":" + fu + "$1")]
            })], a);
          // :placeholder
          case "::placeholder":
            return ro([zo(t, {
              props: [Ke(i, /:(plac\w+)/, ":" + Ve + "input-$1")]
            }), zo(t, {
              props: [Ke(i, /:(plac\w+)/, ":" + fu + "$1")]
            }), zo(t, {
              props: [Ke(i, /:(plac\w+)/, fn + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, Rq = [Iq], _q = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(y) {
      var w = y.getAttribute("data-emotion");
      w.indexOf(" ") !== -1 && (document.head.appendChild(y), y.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || Rq, i = {}, s, u = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(y) {
      for (var w = y.getAttribute("data-emotion").split(" "), x = 1; x < w.length; x++)
        i[w[x]] = !0;
      u.push(y);
    }
  );
  var c, d = [wq, Aq];
  {
    var p, f = [yq, Eq(function(y) {
      p.insert(y);
    })], m = vq(d.concat(a, f)), h = function(w) {
      return ro(hq(w), m);
    };
    c = function(w, x, I, S) {
      p = I, h(w ? w + "{" + x.styles + "}" : x.styles), S && (E.inserted[x.name] = !0);
    };
  }
  var E = {
    key: n,
    sheet: new nq({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return E.sheet.hydrate(u), E;
}, Fd = { exports: {} }, Qe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tT;
function Cq() {
  if (tT) return Qe;
  tT = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function S(T) {
    if (typeof T == "object" && T !== null) {
      var A = T.$$typeof;
      switch (A) {
        case t:
          switch (T = T.type, T) {
            case c:
            case d:
            case r:
            case i:
            case a:
            case f:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case u:
                case p:
                case E:
                case h:
                case s:
                  return T;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function C(T) {
    return S(T) === d;
  }
  return Qe.AsyncMode = c, Qe.ConcurrentMode = d, Qe.ContextConsumer = u, Qe.ContextProvider = s, Qe.Element = t, Qe.ForwardRef = p, Qe.Fragment = r, Qe.Lazy = E, Qe.Memo = h, Qe.Portal = n, Qe.Profiler = i, Qe.StrictMode = a, Qe.Suspense = f, Qe.isAsyncMode = function(T) {
    return C(T) || S(T) === c;
  }, Qe.isConcurrentMode = C, Qe.isContextConsumer = function(T) {
    return S(T) === u;
  }, Qe.isContextProvider = function(T) {
    return S(T) === s;
  }, Qe.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, Qe.isForwardRef = function(T) {
    return S(T) === p;
  }, Qe.isFragment = function(T) {
    return S(T) === r;
  }, Qe.isLazy = function(T) {
    return S(T) === E;
  }, Qe.isMemo = function(T) {
    return S(T) === h;
  }, Qe.isPortal = function(T) {
    return S(T) === n;
  }, Qe.isProfiler = function(T) {
    return S(T) === i;
  }, Qe.isStrictMode = function(T) {
    return S(T) === a;
  }, Qe.isSuspense = function(T) {
    return S(T) === f;
  }, Qe.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === d || T === i || T === a || T === f || T === m || typeof T == "object" && T !== null && (T.$$typeof === E || T.$$typeof === h || T.$$typeof === s || T.$$typeof === u || T.$$typeof === p || T.$$typeof === w || T.$$typeof === x || T.$$typeof === I || T.$$typeof === y);
  }, Qe.typeOf = S, Qe;
}
var nT;
function kq() {
  return nT || (nT = 1, Fd.exports = Cq()), Fd.exports;
}
var Pd, rT;
function Nq() {
  if (rT) return Pd;
  rT = 1;
  var e = kq(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = r, i[e.Memo] = a;
  function s(E) {
    return e.isMemo(E) ? a : i[E.$$typeof] || t;
  }
  var u = Object.defineProperty, c = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, m = Object.prototype;
  function h(E, y, w) {
    if (typeof y != "string") {
      if (m) {
        var x = f(y);
        x && x !== m && h(E, x, w);
      }
      var I = c(y);
      d && (I = I.concat(d(y)));
      for (var S = s(E), C = s(y), T = 0; T < I.length; ++T) {
        var A = I[T];
        if (!n[A] && !(w && w[A]) && !(C && C[A]) && !(S && S[A])) {
          var O = p(y, A);
          try {
            u(E, A, O);
          } catch {
          }
        }
      }
    }
    return E;
  }
  return Pd = h, Pd;
}
Nq();
var Oq = !0;
function E0(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : a && (r += a + " ");
  }), r;
}
var Zy = function(t, n, r) {
  var a = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Oq === !1) && t.registered[a] === void 0 && (t.registered[a] = n.styles);
}, S0 = function(t, n, r) {
  Zy(t, n, r);
  var a = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + a : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Lq(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Dq = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Mq = /[A-Z]|^ms/g, Fq = /_EMO_([^_]+?)_([^]*?)_EMO_/g, x0 = function(t) {
  return t.charCodeAt(1) === 45;
}, aT = function(t) {
  return t != null && typeof t != "boolean";
}, Bd = /* @__PURE__ */ y0(function(e) {
  return x0(e) ? e : e.replace(Mq, "-$&").toLowerCase();
}), iT = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Fq, function(r, a, i) {
          return Gr = {
            name: a,
            styles: i,
            next: Gr
          }, a;
        });
  }
  return Dq[t] !== 1 && !x0(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function fs(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var a = n;
      if (a.anim === 1)
        return Gr = {
          name: a.name,
          styles: a.styles,
          next: Gr
        }, a.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Gr = {
              name: s.name,
              styles: s.styles,
              next: Gr
            }, s = s.next;
        var u = i.styles + ";";
        return u;
      }
      return Pq(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Gr, d = n(e);
        return Gr = c, fs(e, t, d);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var f = t[p];
  return f !== void 0 ? f : p;
}
function Pq(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += fs(e, t, n[a]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var u = s;
        t != null && t[u] !== void 0 ? r += i + "{" + t[u] + "}" : aT(u) && (r += Bd(i) + ":" + iT(i, u) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          aT(s[c]) && (r += Bd(i) + ":" + iT(i, s[c]) + ";");
      else {
        var d = fs(e, t, s);
        switch (i) {
          case "animation":
          case "animationName": {
            r += Bd(i) + ":" + d + ";";
            break;
          }
          default:
            r += i + "{" + d + "}";
        }
      }
    }
  return r;
}
var oT = /label:\s*([^\s;{]+)\s*(;|$)/g, Gr;
function Uu(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, a = "";
  Gr = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, a += fs(n, t, i);
  else {
    var s = i;
    a += s[0];
  }
  for (var u = 1; u < e.length; u++)
    if (a += fs(n, t, e[u]), r) {
      var c = i;
      a += c[u];
    }
  oT.lastIndex = 0;
  for (var d = "", p; (p = oT.exec(a)) !== null; )
    d += "-" + p[1];
  var f = Lq(a) + d;
  return {
    name: f,
    styles: a,
    next: Gr
  };
}
var Bq = function(t) {
  return t();
}, $q = B.useInsertionEffect ? B.useInsertionEffect : !1, T0 = $q || Bq, w0 = /* @__PURE__ */ B.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ _q({
    key: "css"
  }) : null
);
w0.Provider;
var A0 = function(t) {
  return /* @__PURE__ */ _u(function(n, r) {
    var a = nr(w0);
    return t(n, a, r);
  });
}, Jy = /* @__PURE__ */ B.createContext({}), Qy = {}.hasOwnProperty, ny = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Uq = function(t, n) {
  var r = {};
  for (var a in n)
    Qy.call(n, a) && (r[a] = n[a]);
  return r[ny] = t, r;
}, jq = function(t) {
  var n = t.cache, r = t.serialized, a = t.isStringTag;
  return Zy(n, r, a), T0(function() {
    return S0(n, r, a);
  }), null;
}, qq = /* @__PURE__ */ A0(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var a = e[ny], i = [r], s = "";
  typeof e.className == "string" ? s = E0(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var u = Uu(i, void 0, B.useContext(Jy));
  s += t.key + "-" + u.name;
  var c = {};
  for (var d in e)
    Qy.call(e, d) && d !== "css" && d !== ny && (c[d] = e[d]);
  return c.className = s, n && (c.ref = n), /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(jq, {
    cache: t,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ B.createElement(a, c));
}), zq = qq, sT = function(t, n) {
  var r = arguments;
  if (n == null || !Qy.call(n, "css"))
    return B.createElement.apply(void 0, r);
  var a = r.length, i = new Array(a);
  i[0] = zq, i[1] = Uq(t, n);
  for (var s = 2; s < a; s++)
    i[s] = r[s];
  return B.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(sT || (sT = {}));
function Gq() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Uu(t);
}
function ev() {
  var e = Gq.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var Hq = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Vq = /* @__PURE__ */ y0(
  function(e) {
    return Hq.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Wq = Vq, Kq = function(t) {
  return t !== "theme";
}, lT = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Wq : Kq;
}, uT = function(t, n, r) {
  var a;
  if (n) {
    var i = n.shouldForwardProp;
    a = t.__emotion_forwardProp && i ? function(s) {
      return t.__emotion_forwardProp(s) && i(s);
    } : i;
  }
  return typeof a != "function" && r && (a = t.__emotion_forwardProp), a;
}, Yq = function(t) {
  var n = t.cache, r = t.serialized, a = t.isStringTag;
  return Zy(n, r, a), T0(function() {
    return S0(n, r, a);
  }), null;
}, Xq = function e(t, n) {
  var r = t.__emotion_real === t, a = r && t.__emotion_base || t, i, s;
  n !== void 0 && (i = n.label, s = n.target);
  var u = uT(t, n, r), c = u || lT(a), d = !c("as");
  return function() {
    var p = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), p[0] == null || p[0].raw === void 0)
      f.push.apply(f, p);
    else {
      var m = p[0];
      f.push(m[0]);
      for (var h = p.length, E = 1; E < h; E++)
        f.push(p[E], m[E]);
    }
    var y = A0(function(w, x, I) {
      var S = d && w.as || a, C = "", T = [], A = w;
      if (w.theme == null) {
        A = {};
        for (var O in w)
          A[O] = w[O];
        A.theme = B.useContext(Jy);
      }
      typeof w.className == "string" ? C = E0(x.registered, T, w.className) : w.className != null && (C = w.className + " ");
      var U = Uu(f.concat(T), x.registered, A);
      C += x.key + "-" + U.name, s !== void 0 && (C += " " + s);
      var P = d && u === void 0 ? lT(S) : c, b = {};
      for (var L in w)
        d && L === "as" || P(L) && (b[L] = w[L]);
      return b.className = C, I && (b.ref = I), /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(Yq, {
        cache: x,
        serialized: U,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ B.createElement(S, b));
    });
    return y.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = a, y.__emotion_styles = f, y.__emotion_forwardProp = u, Object.defineProperty(y, "toString", {
      value: function() {
        return "." + s;
      }
    }), y.withComponent = function(w, x) {
      var I = e(w, K({}, n, x, {
        shouldForwardProp: uT(y, x, !0)
      }));
      return I.apply(void 0, f);
    }, y;
  };
}, Zq = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], ry = Xq.bind(null);
Zq.forEach(function(e) {
  ry[e] = ry(e);
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function I0(e, t) {
  return ry(e, t);
}
function Jq(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const cT = [];
function dT(e) {
  return cT[0] = e, Uu(cT);
}
const Qq = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function ez(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...a
  } = e, i = Qq(t), s = Object.keys(i);
  function u(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n})`;
  }
  function c(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - r / 100}${n})`;
  }
  function d(m, h) {
    const E = s.indexOf(h);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n}) and (max-width:${(E !== -1 && typeof t[s[E]] == "number" ? t[s[E]] : h) - r / 100}${n})`;
  }
  function p(m) {
    return s.indexOf(m) + 1 < s.length ? d(m, s[s.indexOf(m) + 1]) : u(m);
  }
  function f(m) {
    const h = s.indexOf(m);
    return h === 0 ? u(s[1]) : h === s.length - 1 ? c(s[h]) : d(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: i,
    up: u,
    down: c,
    between: d,
    only: p,
    not: f,
    unit: n,
    ...a
  };
}
const tz = {
  borderRadius: 4
};
function R0(e = 8, t = Hy({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((i) => {
    const s = t(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" ");
  return n.mui = !0, n;
}
function nz(e, t) {
  const n = this;
  if (n.vars) {
    if (!n.colorSchemes?.[e] || typeof n.getColorSchemeSelector != "function")
      return {};
    let r = n.getColorSchemeSelector(e);
    return r === "&" ? t : ((r.includes("data-") || r.includes(".")) && (r = `*:where(${r.replace(/\s*&$/, "")}) &`), {
      [r]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function ju(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: a,
    shape: i = {},
    ...s
  } = e, u = ez(n), c = R0(a);
  let d = Xn({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...tz,
      ...i
    }
  }, s);
  return d = cj(d), d.applyStyles = nz, d = t.reduce((p, f) => Xn(p, f), d), d.unstable_sxConfig = {
    ...Is,
    ...s?.unstable_sxConfig
  }, d.unstable_sx = function(f) {
    return xi({
      sx: f,
      theme: this
    });
  }, d;
}
function rz(e) {
  return Object.keys(e).length === 0;
}
function az(e = null) {
  const t = B.useContext(Jy);
  return !t || rz(t) ? e : t;
}
const iz = ju();
function qu(e = iz) {
  return az(e);
}
const pT = (e) => e, oz = () => {
  let e = pT;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = pT;
    }
  };
}, _0 = oz();
function sz(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: a
  } = e, i = I0("div", {
    shouldForwardProp: (u) => u !== "theme" && u !== "sx" && u !== "as"
  })(xi);
  return /* @__PURE__ */ B.forwardRef(function(c, d) {
    const p = qu(n), {
      className: f,
      component: m = "div",
      ...h
    } = Wy(c);
    return /* @__PURE__ */ R.jsx(i, {
      as: m,
      ref: d,
      className: pt(f, a ? a(r) : r),
      theme: t && p[t] || p,
      ...h
    });
  });
}
const lz = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Sn(e, t, n = "Mui") {
  const r = lz[t];
  return r ? `${n}-${r}` : `${_0.generate(e)}-${t}`;
}
function xn(e, t, n = "Mui") {
  const r = {};
  return t.forEach((a) => {
    r[a] = Sn(e, a, n);
  }), r;
}
function C0(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: dT(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((a) => {
    typeof a.style != "function" && (a.style = dT(a.style));
  }), r;
}
const uz = ju();
function $d(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function cz(e) {
  return e ? (t, n) => n[e] : null;
}
function dz(e, t, n) {
  e.theme = fz(e.theme) ? n : e.theme[t] || e.theme;
}
function Zl(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => Zl(e, r));
  if (Array.isArray(n?.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: a,
        ...i
      } = n;
      r = i;
    }
    return k0(e, n.variants, [r]);
  }
  return n?.isProcessed ? n.style : n;
}
function k0(e, t, n = []) {
  let r;
  e: for (let a = 0; a < t.length; a += 1) {
    const i = t[a];
    if (typeof i.props == "function") {
      if (r ??= {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }, !i.props(r))
        continue;
    } else
      for (const s in i.props)
        if (e[s] !== i.props[s] && e.ownerState?.[s] !== i.props[s])
          continue e;
    typeof i.style == "function" ? (r ??= {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }, n.push(i.style(r))) : n.push(i.style);
  }
  return n;
}
function N0(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = uz,
    rootShouldForwardProp: r = $d,
    slotShouldForwardProp: a = $d
  } = e;
  function i(u) {
    dz(u, t, n);
  }
  return (u, c = {}) => {
    Jq(u, (T) => T.filter((A) => A !== xi));
    const {
      name: d,
      slot: p,
      skipVariantsResolver: f,
      skipSx: m,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = cz(mz(p)),
      ...E
    } = c, y = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      p && p !== "Root" && p !== "root" || !1
    ), w = m || !1;
    let x = $d;
    p === "Root" || p === "root" ? x = r : p ? x = a : gz(u) && (x = void 0);
    const I = I0(u, {
      shouldForwardProp: x,
      label: pz(),
      ...E
    }), S = (T) => {
      if (typeof T == "function" && T.__emotion_real !== T)
        return function(O) {
          return Zl(O, T);
        };
      if (Kr(T)) {
        const A = C0(T);
        return A.variants ? function(U) {
          return Zl(U, A);
        } : A.style;
      }
      return T;
    }, C = (...T) => {
      const A = [], O = T.map(S), U = [];
      if (A.push(i), d && h && U.push(function(j) {
        const H = j.theme.components?.[d]?.styleOverrides;
        if (!H)
          return null;
        const ne = {};
        for (const ue in H)
          ne[ue] = Zl(j, H[ue]);
        return h(j, ne);
      }), d && !y && U.push(function(j) {
        const H = j.theme?.components?.[d]?.variants;
        return H ? k0(j, H) : null;
      }), w || U.push(xi), Array.isArray(O[0])) {
        const L = O.shift(), j = new Array(A.length).fill(""), G = new Array(U.length).fill("");
        let H;
        H = [...j, ...L, ...G], H.raw = [...j, ...L.raw, ...G], A.unshift(H);
      }
      const P = [...A, ...O, ...U], b = I(...P);
      return u.muiName && (b.muiName = u.muiName), b;
    };
    return I.withConfig && (C.withConfig = I.withConfig), C;
  };
}
function pz(e, t) {
  return void 0;
}
function fz(e) {
  for (const t in e)
    return !1;
  return !0;
}
function gz(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function mz(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const hz = N0();
function gu(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const a = r;
      if (a === "components" || a === "slots")
        n[a] = {
          ...e[a],
          ...n[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const i = e[a], s = t[a];
        if (!s)
          n[a] = i || {};
        else if (!i)
          n[a] = s;
        else {
          n[a] = {
            ...s
          };
          for (const u in i)
            if (Object.prototype.hasOwnProperty.call(i, u)) {
              const c = u;
              n[a][c] = gu(i[c], s[c]);
            }
        }
      } else n[a] === void 0 && (n[a] = e[a]);
    }
  return n;
}
function bz(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : gu(t.components[n].defaultProps, r);
}
function yz({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let a = qu(n);
  return r && (a = a[r] || a), bz({
    theme: a,
    name: t,
    props: e
  });
}
const vz = typeof window < "u" ? B.useLayoutEffect : B.useEffect;
function Ez(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function tv(e, t = 0, n = 1) {
  return Ez(e, t, n);
}
function Sz(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, a) => a < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ga(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ga(Sz(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(Si(9, e));
  let r = e.substring(t + 1, e.length - 1), a;
  if (n === "color") {
    if (r = r.split(" "), a = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(a))
      throw new Error(Si(10, a));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: a
  };
}
const xz = (e) => {
  const t = Ga(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, Jo = (e, t) => {
  try {
    return xz(e);
  } catch {
    return e;
  }
};
function zu(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((a, i) => i < 3 ? parseInt(a, 10) : a) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function O0(e) {
  e = Ga(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, a = t[2] / 100, i = r * Math.min(a, 1 - a), s = (d, p = (d + n / 30) % 12) => a - i * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let u = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (u += "a", c.push(t[3])), zu({
    type: u,
    values: c
  });
}
function ay(e) {
  e = Ga(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Ga(O0(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Tz(e, t) {
  const n = ay(e), r = ay(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Ti(e, t) {
  return e = Ga(e), t = tv(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, zu(e);
}
function kl(e, t, n) {
  try {
    return Ti(e, t);
  } catch {
    return e;
  }
}
function Gu(e, t) {
  if (e = Ga(e), t = tv(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return zu(e);
}
function lt(e, t, n) {
  try {
    return Gu(e, t);
  } catch {
    return e;
  }
}
function Hu(e, t) {
  if (e = Ga(e), t = tv(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return zu(e);
}
function ut(e, t, n) {
  try {
    return Hu(e, t);
  } catch {
    return e;
  }
}
function wz(e, t = 0.15) {
  return ay(e) > 0.5 ? Gu(e, t) : Hu(e, t);
}
function Nl(e, t, n) {
  try {
    return wz(e, t);
  } catch {
    return e;
  }
}
function Az(e, t) {
  return /* @__PURE__ */ B.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? e.type?._payload?.value?.muiName
  ) !== -1;
}
function Iz(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Rz({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: a
  } = B.useRef(e !== void 0), [i, s] = B.useState(t), u = a ? e : i, c = B.useCallback((d) => {
    a || s(d);
  }, []);
  return [u, c];
}
function Jl(e) {
  const t = B.useRef(e);
  return vz(() => {
    t.current = e;
  }), B.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function mu(...e) {
  return B.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Iz(n, t);
    });
  }, e);
}
const fT = {};
function L0(e, t) {
  const n = B.useRef(fT);
  return n.current === fT && (n.current = e(t)), n;
}
const _z = [];
function Cz(e) {
  B.useEffect(e, _z);
}
class nv {
  static create() {
    return new nv();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
  clear = () => {
    this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
  };
  disposeEffect = () => this.clear;
}
function D0() {
  const e = L0(nv.create).current;
  return Cz(e.disposeEffect), e;
}
function gT(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
function kz(e) {
  return typeof e == "string";
}
function Nz(e, t, n) {
  return e === void 0 || kz(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Oz(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function mT(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function Lz(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const h = pt(n?.className, i, a?.className, r?.className), E = {
      ...n?.style,
      ...a?.style,
      ...r?.style
    }, y = {
      ...n,
      ...a,
      ...r
    };
    return h.length > 0 && (y.className = h), Object.keys(E).length > 0 && (y.style = E), {
      props: y,
      internalRef: void 0
    };
  }
  const s = Oz({
    ...a,
    ...r
  }), u = mT(r), c = mT(a), d = t(s), p = pt(d?.className, n?.className, i, a?.className, r?.className), f = {
    ...d?.style,
    ...n?.style,
    ...a?.style,
    ...r?.style
  }, m = {
    ...d,
    ...n,
    ...c,
    ...u
  };
  return p.length > 0 && (m.className = p), Object.keys(f).length > 0 && (m.style = f), {
    props: m,
    internalRef: d.ref
  };
}
function Dz(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
const Mz = /* @__PURE__ */ B.createContext(void 0);
function Fz(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const a = t.components[n];
  return a.defaultProps ? gu(a.defaultProps, r) : !a.styleOverrides && !a.variants ? gu(a, r) : r;
}
function Pz({
  props: e,
  name: t
}) {
  const n = B.useContext(Mz);
  return Fz({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const hT = {
  theme: void 0
};
function Bz(e) {
  let t, n;
  return function(a) {
    let i = t;
    return (i === void 0 || a.theme !== n) && (hT.theme = a.theme, i = C0(e(hT)), t = i, n = a.theme), i;
  };
}
function $z(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const a = r[0];
    return typeof a == "string" && !a.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${a}${t(...r.slice(1))})` : `, ${a}`;
  }
  return (r, ...a) => `var(--${e ? `${e}-` : ""}${r}${t(...a)})`;
}
const bT = (e, t, n, r = []) => {
  let a = e;
  t.forEach((i, s) => {
    s === t.length - 1 ? Array.isArray(a) ? a[Number(i)] = n : a && typeof a == "object" && (a[i] = n) : a && typeof a == "object" && (a[i] || (a[i] = r.includes(i) ? [] : {}), a = a[i]);
  });
}, Uz = (e, t, n) => {
  function r(a, i = [], s = []) {
    Object.entries(a).forEach(([u, c]) => {
      (!n || n && !n([...i, u])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...i, u], Array.isArray(c) ? [...s, u] : s) : t([...i, u], c, s));
    });
  }
  r(e);
}, jz = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Ud(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, a = {}, i = {}, s = {};
  return Uz(
    e,
    (u, c, d) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(u, c))) {
        const p = `--${n ? `${n}-` : ""}${u.join("-")}`, f = jz(u, c);
        Object.assign(a, {
          [p]: f
        }), bT(i, u, `var(${p})`, d), bT(s, u, `var(${p}, ${f})`, d);
      }
    },
    (u) => u[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: a,
    vars: i,
    varsWithDefaults: s
  };
}
function qz(e, t = {}) {
  const {
    getSelector: n = w,
    disableCssColorScheme: r,
    colorSchemeSelector: a
  } = t, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: u = "light",
    ...c
  } = e, {
    vars: d,
    css: p,
    varsWithDefaults: f
  } = Ud(c, t);
  let m = f;
  const h = {}, {
    [u]: E,
    ...y
  } = i;
  if (Object.entries(y || {}).forEach(([S, C]) => {
    const {
      vars: T,
      css: A,
      varsWithDefaults: O
    } = Ud(C, t);
    m = Xn(m, O), h[S] = {
      css: A,
      vars: T
    };
  }), E) {
    const {
      css: S,
      vars: C,
      varsWithDefaults: T
    } = Ud(E, t);
    m = Xn(m, T), h[u] = {
      css: S,
      vars: C
    };
  }
  function w(S, C) {
    let T = a;
    if (a === "class" && (T = ".%s"), a === "data" && (T = "[data-%s]"), a?.startsWith("data-") && !a.includes("%s") && (T = `[${a}="%s"]`), S) {
      if (T === "media")
        return e.defaultColorScheme === S ? ":root" : {
          [`@media (prefers-color-scheme: ${i[S]?.palette?.mode || S})`]: {
            ":root": C
          }
        };
      if (T)
        return e.defaultColorScheme === S ? `:root, ${T.replace("%s", String(S))}` : T.replace("%s", String(S));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let S = {
        ...d
      };
      return Object.entries(h).forEach(([, {
        vars: C
      }]) => {
        S = Xn(S, C);
      }), S;
    },
    generateStyleSheets: () => {
      const S = [], C = e.defaultColorScheme || "light";
      function T(U, P) {
        Object.keys(P).length && S.push(typeof U == "string" ? {
          [U]: {
            ...P
          }
        } : U);
      }
      T(n(void 0, {
        ...p
      }), p);
      const {
        [C]: A,
        ...O
      } = h;
      if (A) {
        const {
          css: U
        } = A, P = i[C]?.palette?.mode, b = !r && P ? {
          colorScheme: P,
          ...U
        } : {
          ...U
        };
        T(n(C, {
          ...b
        }), b);
      }
      return Object.entries(O).forEach(([U, {
        css: P
      }]) => {
        const b = i[U]?.palette?.mode, L = !r && b ? {
          colorScheme: b,
          ...P
        } : {
          ...P
        };
        T(n(U, {
          ...L
        }), L);
      }), S;
    }
  };
}
function zz(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const Gz = (e, t) => e.filter((n) => t.includes(n)), yo = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((a, i) => {
    n((s, u) => {
      i <= e.keys.length - 1 && (i === 0 ? Object.assign(s, u) : s[e.up(e.keys[i])] = u);
    }, a);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : Gz(e.keys, Object.keys(t))).forEach((i) => {
    if (e.keys.includes(i)) {
      const s = t[i];
      s !== void 0 && n((u, c) => {
        r === i ? Object.assign(u, c) : u[e.up(i)] = c;
      }, s);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((a, i) => {
    Object.assign(a, i);
  }, t);
};
function hu(e) {
  return `--Grid-${e}Spacing`;
}
function Vu(e) {
  return `--Grid-parent-${e}Spacing`;
}
const yT = "--Grid-columns", ao = "--Grid-parent-columns", Hz = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return yo(e.breakpoints, t.size, (r, a) => {
    let i = {};
    a === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), a === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof a == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${a} / var(${ao}) - (var(${ao}) - ${a}) * (var(${Vu("column")}) / var(${ao})))`
    }), r(n, i);
  }), n;
}, Vz = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return yo(e.breakpoints, t.offset, (r, a) => {
    let i = {};
    a === "auto" && (i = {
      marginLeft: "auto"
    }), typeof a == "number" && (i = {
      marginLeft: a === 0 ? "0px" : `calc(100% * ${a} / var(${ao}) + var(${Vu("column")}) * ${a} / var(${ao}))`
    }), r(n, i);
  }), n;
}, Wz = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [yT]: 12
  };
  return yo(e.breakpoints, t.columns, (r, a) => {
    const i = a ?? 12;
    r(n, {
      [yT]: i,
      "> *": {
        [ao]: i
      }
    });
  }), n;
}, Kz = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return yo(e.breakpoints, t.rowSpacing, (r, a) => {
    const i = typeof a == "string" ? a : e.spacing?.(a);
    r(n, {
      [hu("row")]: i,
      "> *": {
        [Vu("row")]: i
      }
    });
  }), n;
}, Yz = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return yo(e.breakpoints, t.columnSpacing, (r, a) => {
    const i = typeof a == "string" ? a : e.spacing?.(a);
    r(n, {
      [hu("column")]: i,
      "> *": {
        [Vu("column")]: i
      }
    });
  }), n;
}, Xz = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return yo(e.breakpoints, t.direction, (r, a) => {
    r(n, {
      flexDirection: a
    });
  }), n;
}, Zz = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${hu("row")}) var(${hu("column")})`
  }
}), Jz = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, Qz = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([a, i]) => {
      n(i) && r.push(`spacing-${a}-${String(i)}`);
    }), r;
  }
  return [];
}, eG = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], tG = ju(), nG = hz("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function rG(e) {
  return yz({
    props: e,
    name: "MuiGrid",
    defaultTheme: tG
  });
}
function aG(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = nG,
    useThemeProps: n = rG,
    useTheme: r = qu,
    componentName: a = "MuiGrid"
  } = e, i = (d, p) => {
    const {
      container: f,
      direction: m,
      spacing: h,
      wrap: E,
      size: y
    } = d, w = {
      root: ["root", f && "container", E !== "wrap" && `wrap-xs-${String(E)}`, ...eG(m), ...Jz(y), ...f ? Qz(h, p.breakpoints.keys[0]) : []]
    };
    return Dn(w, (x) => Sn(a, x), {});
  };
  function s(d, p, f = () => !0) {
    const m = {};
    return d === null || (Array.isArray(d) ? d.forEach((h, E) => {
      h !== null && f(h) && p.keys[E] && (m[p.keys[E]] = h);
    }) : typeof d == "object" ? Object.keys(d).forEach((h) => {
      const E = d[h];
      E != null && f(E) && (m[h] = E);
    }) : m[p.keys[0]] = d), m;
  }
  const u = t(Wz, Yz, Kz, Hz, Xz, Zz, Vz), c = /* @__PURE__ */ B.forwardRef(function(p, f) {
    const m = r(), h = n(p), E = Wy(h), {
      className: y,
      children: w,
      columns: x = 12,
      container: I = !1,
      component: S = "div",
      direction: C = "row",
      wrap: T = "wrap",
      size: A = {},
      offset: O = {},
      spacing: U = 0,
      rowSpacing: P = U,
      columnSpacing: b = U,
      unstable_level: L = 0,
      ...j
    } = E, G = s(A, m.breakpoints, (le) => le !== !1), H = s(O, m.breakpoints), ne = p.columns ?? (L ? void 0 : x), ue = p.spacing ?? (L ? void 0 : U), ce = p.rowSpacing ?? p.spacing ?? (L ? void 0 : P), Q = p.columnSpacing ?? p.spacing ?? (L ? void 0 : b), de = {
      ...E,
      level: L,
      columns: ne,
      container: I,
      direction: C,
      wrap: T,
      spacing: ue,
      rowSpacing: ce,
      columnSpacing: Q,
      size: G,
      offset: H
    }, D = i(de, m);
    return /* @__PURE__ */ R.jsx(u, {
      ref: f,
      as: S,
      ownerState: de,
      className: pt(D.root, y),
      ...j,
      children: B.Children.map(w, (le) => /* @__PURE__ */ B.isValidElement(le) && Az(le, ["Grid"]) && I && le.props.container ? /* @__PURE__ */ B.cloneElement(le, {
        unstable_level: le.props?.unstable_level ?? L + 1
      }) : le)
    });
  });
  return c.muiName = "Grid", c;
}
const gs = {
  black: "#000",
  white: "#fff"
}, Ql = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Da = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2",
  800: "#6a1b9a"
}, Gi = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Go = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Ma = {
  50: "#e3f2fd",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  700: "#1976d2",
  800: "#1565c0"
}, Hi = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, ci = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function M0() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: gs.white,
      default: gs.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const iG = M0();
function F0() {
  return {
    text: {
      primary: gs.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: gs.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const vT = F0();
function ET(e, t, n, r) {
  const a = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Hu(e.main, a) : t === "dark" && (e.dark = Gu(e.main, i)));
}
function oG(e = "light") {
  return e === "dark" ? {
    main: Ma[200],
    light: Ma[50],
    dark: Ma[400]
  } : {
    main: Ma[700],
    light: Ma[400],
    dark: Ma[800]
  };
}
function sG(e = "light") {
  return e === "dark" ? {
    main: Da[200],
    light: Da[50],
    dark: Da[400]
  } : {
    main: Da[500],
    light: Da[300],
    dark: Da[700]
  };
}
function lG(e = "light") {
  return e === "dark" ? {
    main: Gi[500],
    light: Gi[300],
    dark: Gi[700]
  } : {
    main: Gi[700],
    light: Gi[400],
    dark: Gi[800]
  };
}
function uG(e = "light") {
  return e === "dark" ? {
    main: Hi[400],
    light: Hi[300],
    dark: Hi[700]
  } : {
    main: Hi[700],
    light: Hi[500],
    dark: Hi[900]
  };
}
function cG(e = "light") {
  return e === "dark" ? {
    main: ci[400],
    light: ci[300],
    dark: ci[700]
  } : {
    main: ci[800],
    light: ci[500],
    dark: ci[900]
  };
}
function dG(e = "light") {
  return e === "dark" ? {
    main: Go[400],
    light: Go[300],
    dark: Go[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Go[500],
    dark: Go[900]
  };
}
function rv(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...a
  } = e, i = e.primary || oG(t), s = e.secondary || sG(t), u = e.error || lG(t), c = e.info || uG(t), d = e.success || cG(t), p = e.warning || dG(t);
  function f(y) {
    return Tz(y, vT.text.primary) >= n ? vT.text.primary : iG.text.primary;
  }
  const m = ({
    color: y,
    name: w,
    mainShade: x = 500,
    lightShade: I = 300,
    darkShade: S = 700
  }) => {
    if (y = {
      ...y
    }, !y.main && y[x] && (y.main = y[x]), !y.hasOwnProperty("main"))
      throw new Error(Si(11, w ? ` (${w})` : "", x));
    if (typeof y.main != "string")
      throw new Error(Si(12, w ? ` (${w})` : "", JSON.stringify(y.main)));
    return ET(y, "light", I, r), ET(y, "dark", S, r), y.contrastText || (y.contrastText = f(y.main)), y;
  };
  let h;
  return t === "light" ? h = M0() : t === "dark" && (h = F0()), Xn({
    // A collection of common colors.
    common: {
      ...gs
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: Ql,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...h
  }, a);
}
function pG(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [a, i] = r;
    typeof i == "object" && (t[a] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function fG(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function gG(e) {
  return Math.round(e * 1e5) / 1e5;
}
const ST = {
  textTransform: "uppercase"
}, xT = '"Roboto", "Helvetica", "Arial", sans-serif';
function mG(e, t) {
  const {
    fontFamily: n = xT,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: p,
    ...f
  } = typeof t == "function" ? t(e) : t, m = r / 14, h = p || ((w) => `${w / c * m}rem`), E = (w, x, I, S, C) => ({
    fontFamily: n,
    fontWeight: w,
    fontSize: h(x),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: I,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === xT ? {
      letterSpacing: `${gG(S / x)}em`
    } : {},
    ...C,
    ...d
  }), y = {
    h1: E(a, 96, 1.167, -1.5),
    h2: E(a, 60, 1.2, -0.5),
    h3: E(i, 48, 1.167, 0),
    h4: E(i, 34, 1.235, 0.25),
    h5: E(i, 24, 1.334, 0),
    h6: E(s, 20, 1.6, 0.15),
    subtitle1: E(i, 16, 1.75, 0.15),
    subtitle2: E(s, 14, 1.57, 0.1),
    body1: E(i, 16, 1.5, 0.15),
    body2: E(i, 14, 1.43, 0.15),
    button: E(s, 14, 1.75, 0.4, ST),
    caption: E(i, 12, 1.66, 0.4),
    overline: E(i, 12, 2.66, 1, ST),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Xn({
    htmlFontSize: c,
    pxToRem: h,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: a,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: u,
    ...y
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const hG = 0.2, bG = 0.14, yG = 0.12;
function wt(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${hG})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${bG})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${yG})`].join(",");
}
const vG = ["none", wt(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), wt(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), wt(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), wt(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), wt(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), wt(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), wt(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), wt(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), wt(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), wt(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), wt(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), wt(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), wt(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), wt(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), wt(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), wt(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), wt(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), wt(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), wt(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), wt(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), wt(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), wt(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), wt(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), wt(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], EG = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, P0 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function TT(e) {
  return `${Math.round(e)}ms`;
}
function SG(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function xG(e) {
  const t = {
    ...EG,
    ...e.easing
  }, n = {
    ...P0,
    ...e.duration
  };
  return {
    getAutoHeightDuration: SG,
    create: (a = ["all"], i = {}) => {
      const {
        duration: s = n.standard,
        easing: u = t.easeInOut,
        delay: c = 0,
        ...d
      } = i;
      return (Array.isArray(a) ? a : [a]).map((p) => `${p} ${typeof s == "string" ? s : TT(s)} ${u} ${typeof c == "string" ? c : TT(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const TG = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function wG(e) {
  return Kr(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function B0(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const a = Object.entries(r);
    for (let i = 0; i < a.length; i++) {
      const [s, u] = a[i];
      !wG(u) || s.startsWith("unstable_") ? delete r[s] : Kr(u) && (r[s] = {
        ...u
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function iy(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: a,
    palette: i = {},
    transitions: s = {},
    typography: u = {},
    shape: c,
    ...d
  } = e;
  if (e.vars)
    throw new Error(Si(20));
  const p = rv(i), f = ju(e);
  let m = Xn(f, {
    mixins: fG(f.breakpoints, r),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: vG.slice(),
    typography: mG(p, u),
    transitions: xG(s),
    zIndex: {
      ...TG
    }
  });
  return m = Xn(m, d), m = t.reduce((h, E) => Xn(h, E), m), m.unstable_sxConfig = {
    ...Is,
    ...d?.unstable_sxConfig
  }, m.unstable_sx = function(E) {
    return xi({
      sx: E,
      theme: this
    });
  }, m.toRuntimeSource = B0, m;
}
function oy(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const AG = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = oy(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function $0(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function U0(e) {
  return e === "dark" ? AG : [];
}
function IG(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...a
  } = e, i = rv(t);
  return {
    palette: i,
    opacity: {
      ...$0(i.mode),
      ...n
    },
    overlays: r || U0(i.mode),
    ...a
  };
}
function RG(e) {
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const _G = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], CG = (e) => (t, n) => {
  const r = e.rootSelector || ":root", a = e.colorSchemeSelector;
  let i = a;
  if (a === "class" && (i = ".%s"), a === "data" && (i = "[data-%s]"), a?.startsWith("data-") && !a.includes("%s") && (i = `[${a}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return _G(e.cssVarPrefix).forEach((u) => {
        s[u] = n[u], delete n[u];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : i ? {
        [i.replace("%s", t)]: s,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function kG(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function X(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Qo(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : O0(e);
}
function ua(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Jo(Qo(e[t])));
}
function NG(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Br = (e) => {
  try {
    return e();
  } catch {
  }
}, OG = (e = "mui") => $z(e);
function jd(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const a = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = IG({
      ...t,
      palette: {
        mode: a,
        ...t?.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...s
  } = iy({
    ...n,
    palette: {
      mode: a,
      ...t?.palette
    }
  });
  return e[r] = {
    ...t,
    palette: i,
    opacity: {
      ...$0(a),
      ...t?.opacity
    },
    overlays: t?.overlays || U0(a)
  }, s;
}
function LG(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: a = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = RG,
    colorSchemeSelector: u = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...d
  } = e, p = Object.keys(n)[0], f = r || (n.light && p !== "light" ? "light" : p), m = OG(i), {
    [f]: h,
    light: E,
    dark: y,
    ...w
  } = n, x = {
    ...w
  };
  let I = h;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && (I = !0), !I)
    throw new Error(Si(21, f));
  const S = jd(x, I, d, f);
  E && !x.light && jd(x, E, void 0, "light"), y && !x.dark && jd(x, y, void 0, "dark");
  let C = {
    defaultColorScheme: f,
    ...S,
    cssVarPrefix: i,
    colorSchemeSelector: u,
    rootSelector: c,
    getCssVar: m,
    colorSchemes: x,
    font: {
      ...pG(S.typography),
      ...S.font
    },
    spacing: NG(d.spacing)
  };
  Object.keys(C.colorSchemes).forEach((P) => {
    const b = C.colorSchemes[P].palette, L = (j) => {
      const G = j.split("-"), H = G[1], ne = G[2];
      return m(j, b[H][ne]);
    };
    if (b.mode === "light" && (X(b.common, "background", "#fff"), X(b.common, "onBackground", "#000")), b.mode === "dark" && (X(b.common, "background", "#000"), X(b.common, "onBackground", "#fff")), kG(b, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), b.mode === "light") {
      X(b.Alert, "errorColor", lt(b.error.light, 0.6)), X(b.Alert, "infoColor", lt(b.info.light, 0.6)), X(b.Alert, "successColor", lt(b.success.light, 0.6)), X(b.Alert, "warningColor", lt(b.warning.light, 0.6)), X(b.Alert, "errorFilledBg", L("palette-error-main")), X(b.Alert, "infoFilledBg", L("palette-info-main")), X(b.Alert, "successFilledBg", L("palette-success-main")), X(b.Alert, "warningFilledBg", L("palette-warning-main")), X(b.Alert, "errorFilledColor", Br(() => b.getContrastText(b.error.main))), X(b.Alert, "infoFilledColor", Br(() => b.getContrastText(b.info.main))), X(b.Alert, "successFilledColor", Br(() => b.getContrastText(b.success.main))), X(b.Alert, "warningFilledColor", Br(() => b.getContrastText(b.warning.main))), X(b.Alert, "errorStandardBg", ut(b.error.light, 0.9)), X(b.Alert, "infoStandardBg", ut(b.info.light, 0.9)), X(b.Alert, "successStandardBg", ut(b.success.light, 0.9)), X(b.Alert, "warningStandardBg", ut(b.warning.light, 0.9)), X(b.Alert, "errorIconColor", L("palette-error-main")), X(b.Alert, "infoIconColor", L("palette-info-main")), X(b.Alert, "successIconColor", L("palette-success-main")), X(b.Alert, "warningIconColor", L("palette-warning-main")), X(b.AppBar, "defaultBg", L("palette-grey-100")), X(b.Avatar, "defaultBg", L("palette-grey-400")), X(b.Button, "inheritContainedBg", L("palette-grey-300")), X(b.Button, "inheritContainedHoverBg", L("palette-grey-A100")), X(b.Chip, "defaultBorder", L("palette-grey-400")), X(b.Chip, "defaultAvatarColor", L("palette-grey-700")), X(b.Chip, "defaultIconColor", L("palette-grey-700")), X(b.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), X(b.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), X(b.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), X(b.LinearProgress, "primaryBg", ut(b.primary.main, 0.62)), X(b.LinearProgress, "secondaryBg", ut(b.secondary.main, 0.62)), X(b.LinearProgress, "errorBg", ut(b.error.main, 0.62)), X(b.LinearProgress, "infoBg", ut(b.info.main, 0.62)), X(b.LinearProgress, "successBg", ut(b.success.main, 0.62)), X(b.LinearProgress, "warningBg", ut(b.warning.main, 0.62)), X(b.Skeleton, "bg", `rgba(${L("palette-text-primaryChannel")} / 0.11)`), X(b.Slider, "primaryTrack", ut(b.primary.main, 0.62)), X(b.Slider, "secondaryTrack", ut(b.secondary.main, 0.62)), X(b.Slider, "errorTrack", ut(b.error.main, 0.62)), X(b.Slider, "infoTrack", ut(b.info.main, 0.62)), X(b.Slider, "successTrack", ut(b.success.main, 0.62)), X(b.Slider, "warningTrack", ut(b.warning.main, 0.62));
      const j = Nl(b.background.default, 0.8);
      X(b.SnackbarContent, "bg", j), X(b.SnackbarContent, "color", Br(() => b.getContrastText(j))), X(b.SpeedDialAction, "fabHoverBg", Nl(b.background.paper, 0.15)), X(b.StepConnector, "border", L("palette-grey-400")), X(b.StepContent, "border", L("palette-grey-400")), X(b.Switch, "defaultColor", L("palette-common-white")), X(b.Switch, "defaultDisabledColor", L("palette-grey-100")), X(b.Switch, "primaryDisabledColor", ut(b.primary.main, 0.62)), X(b.Switch, "secondaryDisabledColor", ut(b.secondary.main, 0.62)), X(b.Switch, "errorDisabledColor", ut(b.error.main, 0.62)), X(b.Switch, "infoDisabledColor", ut(b.info.main, 0.62)), X(b.Switch, "successDisabledColor", ut(b.success.main, 0.62)), X(b.Switch, "warningDisabledColor", ut(b.warning.main, 0.62)), X(b.TableCell, "border", ut(kl(b.divider, 1), 0.88)), X(b.Tooltip, "bg", kl(b.grey[700], 0.92));
    }
    if (b.mode === "dark") {
      X(b.Alert, "errorColor", ut(b.error.light, 0.6)), X(b.Alert, "infoColor", ut(b.info.light, 0.6)), X(b.Alert, "successColor", ut(b.success.light, 0.6)), X(b.Alert, "warningColor", ut(b.warning.light, 0.6)), X(b.Alert, "errorFilledBg", L("palette-error-dark")), X(b.Alert, "infoFilledBg", L("palette-info-dark")), X(b.Alert, "successFilledBg", L("palette-success-dark")), X(b.Alert, "warningFilledBg", L("palette-warning-dark")), X(b.Alert, "errorFilledColor", Br(() => b.getContrastText(b.error.dark))), X(b.Alert, "infoFilledColor", Br(() => b.getContrastText(b.info.dark))), X(b.Alert, "successFilledColor", Br(() => b.getContrastText(b.success.dark))), X(b.Alert, "warningFilledColor", Br(() => b.getContrastText(b.warning.dark))), X(b.Alert, "errorStandardBg", lt(b.error.light, 0.9)), X(b.Alert, "infoStandardBg", lt(b.info.light, 0.9)), X(b.Alert, "successStandardBg", lt(b.success.light, 0.9)), X(b.Alert, "warningStandardBg", lt(b.warning.light, 0.9)), X(b.Alert, "errorIconColor", L("palette-error-main")), X(b.Alert, "infoIconColor", L("palette-info-main")), X(b.Alert, "successIconColor", L("palette-success-main")), X(b.Alert, "warningIconColor", L("palette-warning-main")), X(b.AppBar, "defaultBg", L("palette-grey-900")), X(b.AppBar, "darkBg", L("palette-background-paper")), X(b.AppBar, "darkColor", L("palette-text-primary")), X(b.Avatar, "defaultBg", L("palette-grey-600")), X(b.Button, "inheritContainedBg", L("palette-grey-800")), X(b.Button, "inheritContainedHoverBg", L("palette-grey-700")), X(b.Chip, "defaultBorder", L("palette-grey-700")), X(b.Chip, "defaultAvatarColor", L("palette-grey-300")), X(b.Chip, "defaultIconColor", L("palette-grey-300")), X(b.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), X(b.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), X(b.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), X(b.LinearProgress, "primaryBg", lt(b.primary.main, 0.5)), X(b.LinearProgress, "secondaryBg", lt(b.secondary.main, 0.5)), X(b.LinearProgress, "errorBg", lt(b.error.main, 0.5)), X(b.LinearProgress, "infoBg", lt(b.info.main, 0.5)), X(b.LinearProgress, "successBg", lt(b.success.main, 0.5)), X(b.LinearProgress, "warningBg", lt(b.warning.main, 0.5)), X(b.Skeleton, "bg", `rgba(${L("palette-text-primaryChannel")} / 0.13)`), X(b.Slider, "primaryTrack", lt(b.primary.main, 0.5)), X(b.Slider, "secondaryTrack", lt(b.secondary.main, 0.5)), X(b.Slider, "errorTrack", lt(b.error.main, 0.5)), X(b.Slider, "infoTrack", lt(b.info.main, 0.5)), X(b.Slider, "successTrack", lt(b.success.main, 0.5)), X(b.Slider, "warningTrack", lt(b.warning.main, 0.5));
      const j = Nl(b.background.default, 0.98);
      X(b.SnackbarContent, "bg", j), X(b.SnackbarContent, "color", Br(() => b.getContrastText(j))), X(b.SpeedDialAction, "fabHoverBg", Nl(b.background.paper, 0.15)), X(b.StepConnector, "border", L("palette-grey-600")), X(b.StepContent, "border", L("palette-grey-600")), X(b.Switch, "defaultColor", L("palette-grey-300")), X(b.Switch, "defaultDisabledColor", L("palette-grey-600")), X(b.Switch, "primaryDisabledColor", lt(b.primary.main, 0.55)), X(b.Switch, "secondaryDisabledColor", lt(b.secondary.main, 0.55)), X(b.Switch, "errorDisabledColor", lt(b.error.main, 0.55)), X(b.Switch, "infoDisabledColor", lt(b.info.main, 0.55)), X(b.Switch, "successDisabledColor", lt(b.success.main, 0.55)), X(b.Switch, "warningDisabledColor", lt(b.warning.main, 0.55)), X(b.TableCell, "border", lt(kl(b.divider, 1), 0.68)), X(b.Tooltip, "bg", kl(b.grey[700], 0.92));
    }
    ua(b.background, "default"), ua(b.background, "paper"), ua(b.common, "background"), ua(b.common, "onBackground"), ua(b, "divider"), Object.keys(b).forEach((j) => {
      const G = b[j];
      j !== "tonalOffset" && G && typeof G == "object" && (G.main && X(b[j], "mainChannel", Jo(Qo(G.main))), G.light && X(b[j], "lightChannel", Jo(Qo(G.light))), G.dark && X(b[j], "darkChannel", Jo(Qo(G.dark))), G.contrastText && X(b[j], "contrastTextChannel", Jo(Qo(G.contrastText))), j === "text" && (ua(b[j], "primary"), ua(b[j], "secondary")), j === "action" && (G.active && ua(b[j], "active"), G.selected && ua(b[j], "selected")));
    });
  }), C = t.reduce((P, b) => Xn(P, b), C);
  const T = {
    prefix: i,
    disableCssColorScheme: a,
    shouldSkipGeneratingVar: s,
    getSelector: CG(C)
  }, {
    vars: A,
    generateThemeVars: O,
    generateStyleSheets: U
  } = qz(C, T);
  return C.vars = A, Object.entries(C.colorSchemes[C.defaultColorScheme]).forEach(([P, b]) => {
    C[P] = b;
  }), C.generateThemeVars = O, C.generateStyleSheets = U, C.generateSpacing = function() {
    return R0(d.spacing, Hy(this));
  }, C.getColorSchemeSelector = zz(u), C.spacing = C.generateSpacing(), C.shouldSkipGeneratingVar = s, C.unstable_sxConfig = {
    ...Is,
    ...d?.unstable_sxConfig
  }, C.unstable_sx = function(b) {
    return xi({
      sx: b,
      theme: this
    });
  }, C.toRuntimeSource = B0, C;
}
function wT(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: rv({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function j0(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: a = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n?.mode,
    ...s
  } = e, u = i || "light", c = a?.[u], d = {
    ...a,
    ...n ? {
      [u]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return iy(e, ...t);
    let p = n;
    "palette" in e || d[u] && (d[u] !== !0 ? p = d[u].palette : u === "dark" && (p = {
      mode: "dark"
    }));
    const f = iy({
      ...e,
      palette: p
    }, ...t);
    return f.defaultColorScheme = u, f.colorSchemes = d, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...d.light !== !0 && d.light,
      palette: f.palette
    }, wT(f, "dark", d.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...d.dark !== !0 && d.dark,
      palette: f.palette
    }, wT(f, "light", d.light)), f;
  }
  return !n && !("light" in d) && u === "light" && (d.light = !0), LG({
    ...s,
    colorSchemes: d,
    defaultColorScheme: u,
    ...typeof r != "boolean" && r
  }, ...t);
}
const q0 = j0(), av = "$$material";
function iv() {
  const e = qu(q0);
  return e[av] || e;
}
function DG(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const MG = (e) => DG(e) && e !== "classes", Gt = N0({
  themeId: av,
  defaultTheme: q0,
  rootShouldForwardProp: MG
});
function FG() {
  return Wy;
}
const tr = Bz;
function Tn(e) {
  return Pz(e);
}
function Be(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function sy(e, t) {
  return sy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, sy(e, t);
}
function z0(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, sy(e, t);
}
const AT = {
  disabled: !1
}, bu = rt.createContext(null);
var PG = function(t) {
  return t.scrollTop;
}, es = "unmounted", di = "exited", pi = "entering", Ji = "entered", ly = "exiting", Ea = /* @__PURE__ */ function(e) {
  z0(t, e);
  function t(r, a) {
    var i;
    i = e.call(this, r, a) || this;
    var s = a, u = s && !s.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? u ? (c = di, i.appearStatus = pi) : c = Ji : r.unmountOnExit || r.mountOnEnter ? c = es : c = di, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(a, i) {
    var s = a.in;
    return s && i.status === es ? {
      status: di
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(a) {
    var i = null;
    if (a !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== pi && s !== Ji && (i = pi) : (s === pi || s === Ji) && (i = ly);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var a = this.props.timeout, i, s, u;
    return i = s = u = a, a != null && typeof a != "number" && (i = a.exit, s = a.enter, u = a.appear !== void 0 ? a.appear : s), {
      exit: i,
      enter: s,
      appear: u
    };
  }, n.updateStatus = function(a, i) {
    if (a === void 0 && (a = !1), i !== null)
      if (this.cancelNextCallback(), i === pi) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : ha.findDOMNode(this);
          s && PG(s);
        }
        this.performEnter(a);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === di && this.setState({
      status: es
    });
  }, n.performEnter = function(a) {
    var i = this, s = this.props.enter, u = this.context ? this.context.isMounting : a, c = this.props.nodeRef ? [u] : [ha.findDOMNode(this), u], d = c[0], p = c[1], f = this.getTimeouts(), m = u ? f.appear : f.enter;
    if (!a && !s || AT.disabled) {
      this.safeSetState({
        status: Ji
      }, function() {
        i.props.onEntered(d);
      });
      return;
    }
    this.props.onEnter(d, p), this.safeSetState({
      status: pi
    }, function() {
      i.props.onEntering(d, p), i.onTransitionEnd(m, function() {
        i.safeSetState({
          status: Ji
        }, function() {
          i.props.onEntered(d, p);
        });
      });
    });
  }, n.performExit = function() {
    var a = this, i = this.props.exit, s = this.getTimeouts(), u = this.props.nodeRef ? void 0 : ha.findDOMNode(this);
    if (!i || AT.disabled) {
      this.safeSetState({
        status: di
      }, function() {
        a.props.onExited(u);
      });
      return;
    }
    this.props.onExit(u), this.safeSetState({
      status: ly
    }, function() {
      a.props.onExiting(u), a.onTransitionEnd(s.exit, function() {
        a.safeSetState({
          status: di
        }, function() {
          a.props.onExited(u);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(a, i) {
    i = this.setNextCallback(i), this.setState(a, i);
  }, n.setNextCallback = function(a) {
    var i = this, s = !0;
    return this.nextCallback = function(u) {
      s && (s = !1, i.nextCallback = null, a(u));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(a, i) {
    this.setNextCallback(i);
    var s = this.props.nodeRef ? this.props.nodeRef.current : ha.findDOMNode(this), u = a == null && !this.props.addEndListener;
    if (!s || u) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], d = c[0], p = c[1];
      this.props.addEndListener(d, p);
    }
    a != null && setTimeout(this.nextCallback, a);
  }, n.render = function() {
    var a = this.state.status;
    if (a === es)
      return null;
    var i = this.props, s = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var u = Be(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ rt.createElement(bu.Provider, {
        value: null
      }, typeof s == "function" ? s(a, u) : rt.cloneElement(rt.Children.only(s), u))
    );
  }, t;
}(rt.Component);
Ea.contextType = bu;
Ea.propTypes = {};
function Vi() {
}
Ea.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Vi,
  onEntering: Vi,
  onEntered: Vi,
  onExit: Vi,
  onExiting: Vi,
  onExited: Vi
};
Ea.UNMOUNTED = es;
Ea.EXITED = di;
Ea.ENTERING = pi;
Ea.ENTERED = Ji;
Ea.EXITING = ly;
function BG(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ov(e, t) {
  var n = function(i) {
    return t && ja(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && r0.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    r[a.key] = n(a);
  }), r;
}
function $G(e, t) {
  e = e || {}, t = t || {};
  function n(p) {
    return p in t ? t[p] : e[p];
  }
  var r = /* @__PURE__ */ Object.create(null), a = [];
  for (var i in e)
    i in t ? a.length && (r[i] = a, a = []) : a.push(i);
  var s, u = {};
  for (var c in t) {
    if (r[c])
      for (s = 0; s < r[c].length; s++) {
        var d = r[c][s];
        u[r[c][s]] = n(d);
      }
    u[c] = n(c);
  }
  for (s = 0; s < a.length; s++)
    u[a[s]] = n(a[s]);
  return u;
}
function bi(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function UG(e, t) {
  return ov(e.children, function(n) {
    return qa(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: bi(n, "appear", e),
      enter: bi(n, "enter", e),
      exit: bi(n, "exit", e)
    });
  });
}
function jG(e, t, n) {
  var r = ov(e.children), a = $G(t, r);
  return Object.keys(a).forEach(function(i) {
    var s = a[i];
    if (ja(s)) {
      var u = i in t, c = i in r, d = t[i], p = ja(d) && !d.props.in;
      c && (!u || p) ? a[i] = qa(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: bi(s, "exit", e),
        enter: bi(s, "enter", e)
      }) : !c && u && !p ? a[i] = qa(s, {
        in: !1
      }) : c && u && ja(d) && (a[i] = qa(s, {
        onExited: n.bind(null, s),
        in: d.props.in,
        exit: bi(s, "exit", e),
        enter: bi(s, "enter", e)
      }));
    }
  }), a;
}
var qG = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, zG = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, sv = /* @__PURE__ */ function(e) {
  z0(t, e);
  function t(r, a) {
    var i;
    i = e.call(this, r, a) || this;
    var s = i.handleExited.bind(BG(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, i) {
    var s = i.children, u = i.handleExited, c = i.firstRender;
    return {
      children: c ? UG(a, u) : jG(a, s, u),
      firstRender: !1
    };
  }, n.handleExited = function(a, i) {
    var s = ov(this.props.children);
    a.key in s || (a.props.onExited && a.props.onExited(i), this.mounted && this.setState(function(u) {
      var c = K({}, u.children);
      return delete c[a.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var a = this.props, i = a.component, s = a.childFactory, u = Be(a, ["component", "childFactory"]), c = this.state.contextValue, d = qG(this.state.children).map(s);
    return delete u.appear, delete u.enter, delete u.exit, i === null ? /* @__PURE__ */ rt.createElement(bu.Provider, {
      value: c
    }, d) : /* @__PURE__ */ rt.createElement(bu.Provider, {
      value: c
    }, /* @__PURE__ */ rt.createElement(i, u, d));
  }, t;
}(rt.Component);
sv.propTypes = {};
sv.defaultProps = zG;
function IT(e, t) {
  const {
    timeout: n,
    easing: r,
    style: a = {}
  } = e;
  return {
    duration: a.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: a.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: a.transitionDelay
  };
}
function GG(e) {
  return Sn("MuiSvgIcon", e);
}
xn("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const HG = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, a = {
    root: ["root", t !== "inherit" && `color${En(t)}`, `fontSize${En(n)}`]
  };
  return Dn(a, GG, r);
}, VG = Gt("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${En(n.color)}`], t[`fontSize${En(n.fontSize)}`]];
  }
})(tr(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: e.transitions?.create?.("fill", {
    duration: (e.vars ?? e).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (t) => !t.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((e.vars ?? e).palette).filter(([, t]) => t && t.main).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (e.vars ?? e).palette?.[t]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
}))), uy = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: i,
    color: s = "inherit",
    component: u = "svg",
    fontSize: c = "medium",
    htmlColor: d,
    inheritViewBox: p = !1,
    titleAccess: f,
    viewBox: m = "0 0 24 24",
    ...h
  } = r, E = /* @__PURE__ */ B.isValidElement(a) && a.type === "svg", y = {
    ...r,
    color: s,
    component: u,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: m,
    hasSvgAsChild: E
  }, w = {};
  p || (w.viewBox = m);
  const x = HG(y);
  return /* @__PURE__ */ R.jsxs(VG, {
    as: u,
    className: pt(x.root, i),
    focusable: "false",
    color: d,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n,
    ...w,
    ...h,
    ...E && a.props,
    ownerState: y,
    children: [E ? a.props.children : a, f ? /* @__PURE__ */ R.jsx("title", {
      children: f
    }) : null]
  });
});
uy.muiName = "SvgIcon";
function lv(e, t) {
  function n(r, a) {
    return /* @__PURE__ */ R.jsx(uy, {
      "data-testid": `${t}Icon`,
      ref: a,
      ...r,
      children: e
    });
  }
  return n.muiName = uy.muiName, /* @__PURE__ */ B.memo(/* @__PURE__ */ B.forwardRef(n));
}
function WG(e) {
  return Sn("MuiCollapse", e);
}
xn("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const KG = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Dn(r, WG, n);
}, YG = Gt("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(tr(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), XG = Gt("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), ZG = Gt("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), cy = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: a,
    children: i,
    className: s,
    collapsedSize: u = "0px",
    component: c,
    easing: d,
    in: p,
    onEnter: f,
    onEntered: m,
    onEntering: h,
    onExit: E,
    onExited: y,
    onExiting: w,
    orientation: x = "vertical",
    style: I,
    timeout: S = P0.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = Ea,
    ...T
  } = r, A = {
    ...r,
    orientation: x,
    collapsedSize: u
  }, O = KG(A), U = iv(), P = D0(), b = B.useRef(null), L = B.useRef(), j = typeof u == "number" ? `${u}px` : u, G = x === "horizontal", H = G ? "width" : "height", ne = B.useRef(null), ue = mu(n, ne), ce = (ie) => (xe) => {
    if (ie) {
      const _e = ne.current;
      xe === void 0 ? ie(_e) : ie(_e, xe);
    }
  }, Q = () => b.current ? b.current[G ? "clientWidth" : "clientHeight"] : 0, de = ce((ie, xe) => {
    b.current && G && (b.current.style.position = "absolute"), ie.style[H] = j, f && f(ie, xe);
  }), D = ce((ie, xe) => {
    const _e = Q();
    b.current && G && (b.current.style.position = "");
    const {
      duration: Le,
      easing: tt
    } = IT({
      style: I,
      timeout: S,
      easing: d
    }, {
      mode: "enter"
    });
    if (S === "auto") {
      const at = U.transitions.getAutoHeightDuration(_e);
      ie.style.transitionDuration = `${at}ms`, L.current = at;
    } else
      ie.style.transitionDuration = typeof Le == "string" ? Le : `${Le}ms`;
    ie.style[H] = `${_e}px`, ie.style.transitionTimingFunction = tt, h && h(ie, xe);
  }), le = ce((ie, xe) => {
    ie.style[H] = "auto", m && m(ie, xe);
  }), Ae = ce((ie) => {
    ie.style[H] = `${Q()}px`, E && E(ie);
  }), M = ce(y), he = ce((ie) => {
    const xe = Q(), {
      duration: _e,
      easing: Le
    } = IT({
      style: I,
      timeout: S,
      easing: d
    }, {
      mode: "exit"
    });
    if (S === "auto") {
      const tt = U.transitions.getAutoHeightDuration(xe);
      ie.style.transitionDuration = `${tt}ms`, L.current = tt;
    } else
      ie.style.transitionDuration = typeof _e == "string" ? _e : `${_e}ms`;
    ie.style[H] = j, ie.style.transitionTimingFunction = Le, w && w(ie);
  }), se = (ie) => {
    S === "auto" && P.start(L.current || 0, ie), a && a(ne.current, ie);
  };
  return /* @__PURE__ */ R.jsx(C, {
    in: p,
    onEnter: de,
    onEntered: le,
    onEntering: D,
    onExit: Ae,
    onExited: M,
    onExiting: he,
    addEndListener: se,
    nodeRef: ne,
    timeout: S === "auto" ? null : S,
    ...T,
    children: (ie, {
      ownerState: xe,
      ..._e
    }) => /* @__PURE__ */ R.jsx(YG, {
      as: c,
      className: pt(O.root, s, {
        entered: O.entered,
        exited: !p && j === "0px" && O.hidden
      }[ie]),
      style: {
        [G ? "minWidth" : "minHeight"]: j,
        ...I
      },
      ref: ue,
      ownerState: {
        ...A,
        state: ie
      },
      ..._e,
      children: /* @__PURE__ */ R.jsx(XG, {
        ownerState: {
          ...A,
          state: ie
        },
        className: O.wrapper,
        ref: b,
        children: /* @__PURE__ */ R.jsx(ZG, {
          ownerState: {
            ...A,
            state: ie
          },
          className: O.wrapperInner,
          children: i
        })
      })
    })
  });
});
cy && (cy.muiSupportAuto = !0);
function JG(e) {
  return Sn("MuiPaper", e);
}
xn("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const QG = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: a
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Dn(i, JG, a);
}, e2 = Gt("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(tr(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), t2 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiPaper"
  }), a = iv(), {
    className: i,
    component: s = "div",
    elevation: u = 1,
    square: c = !1,
    variant: d = "elevation",
    ...p
  } = r, f = {
    ...r,
    component: s,
    elevation: u,
    square: c,
    variant: d
  }, m = QG(f);
  return /* @__PURE__ */ R.jsx(e2, {
    as: s,
    ownerState: f,
    className: pt(m.root, i),
    ref: n,
    ...p,
    style: {
      ...d === "elevation" && {
        "--Paper-shadow": (a.vars || a).shadows[u],
        ...a.vars && {
          "--Paper-overlay": a.vars.overlays?.[u]
        },
        ...!a.vars && a.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Ti("#fff", oy(u))}, ${Ti("#fff", oy(u))})`
        }
      },
      ...p.style
    }
  });
}), G0 = /* @__PURE__ */ B.createContext({});
function RT(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: a,
    externalForwardedProps: i,
    internalForwardedProps: s,
    ...u
  } = t, {
    component: c,
    slots: d = {
      [e]: void 0
    },
    slotProps: p = {
      [e]: void 0
    },
    ...f
  } = i, m = d[e] || r, h = Dz(p[e], a), {
    props: {
      component: E,
      ...y
    },
    internalRef: w
  } = Lz({
    className: n,
    ...u,
    externalForwardedProps: e === "root" ? f : void 0,
    externalSlotProps: h
  }), x = mu(w, h?.ref, t.ref), I = e === "root" ? E || c : E, S = Nz(m, {
    ...e === "root" && !c && !d[e] && s,
    ...e !== "root" && !d[e] && s,
    ...y,
    ...I && {
      as: I
    },
    ref: x
  }, a);
  return [m, S];
}
function n2(e) {
  return Sn("MuiAccordion", e);
}
const Ol = xn("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]), r2 = (e) => {
  const {
    classes: t,
    square: n,
    expanded: r,
    disabled: a,
    disableGutters: i
  } = e;
  return Dn({
    root: ["root", !n && "rounded", r && "expanded", a && "disabled", !i && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, n2, t);
}, a2 = Gt(t2, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Ol.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(tr(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${Ol.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${Ol.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), tr(({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${Ol.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), i2 = Gt("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, t) => t.heading
})({
  all: "unset"
}), uv = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiAccordion"
  }), {
    children: a,
    className: i,
    defaultExpanded: s = !1,
    disabled: u = !1,
    disableGutters: c = !1,
    expanded: d,
    onChange: p,
    square: f = !1,
    slots: m = {},
    slotProps: h = {},
    TransitionComponent: E,
    TransitionProps: y,
    ...w
  } = r, [x, I] = Rz({
    controlled: d,
    default: s,
    name: "Accordion",
    state: "expanded"
  }), S = B.useCallback((ue) => {
    I(!x), p && p(ue, !x);
  }, [x, p, I]), [C, ...T] = B.Children.toArray(a), A = B.useMemo(() => ({
    expanded: x,
    disabled: u,
    disableGutters: c,
    toggle: S
  }), [x, u, c, S]), O = {
    ...r,
    square: f,
    disabled: u,
    disableGutters: c,
    expanded: x
  }, U = r2(O), P = {
    transition: E,
    ...m
  }, b = {
    transition: y,
    ...h
  }, L = {
    slots: P,
    slotProps: b
  }, [j, G] = RT("heading", {
    elementType: i2,
    externalForwardedProps: L,
    className: U.heading,
    ownerState: O
  }), [H, ne] = RT("transition", {
    elementType: cy,
    externalForwardedProps: L,
    ownerState: O
  });
  return /* @__PURE__ */ R.jsxs(a2, {
    className: pt(U.root, i),
    ref: n,
    ownerState: O,
    square: f,
    ...w,
    children: [/* @__PURE__ */ R.jsx(j, {
      ...G,
      children: /* @__PURE__ */ R.jsx(G0.Provider, {
        value: A,
        children: C
      })
    }), /* @__PURE__ */ R.jsx(H, {
      in: x,
      timeout: "auto",
      ...ne,
      children: /* @__PURE__ */ R.jsx("div", {
        "aria-labelledby": C.props.id,
        id: C.props["aria-controls"],
        role: "region",
        className: U.region,
        children: T
      })
    })]
  });
});
class yu {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new yu();
  }
  static use() {
    const t = L0(yu.create).current, [n, r] = B.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, B.useEffect(t.mountEffect, [n]), t;
  }
  constructor() {
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  mount() {
    return this.mounted || (this.mounted = s2(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  mountEffect = () => {
    this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
  };
  /* Ripple API */
  start(...t) {
    this.mount().then(() => this.ref.current?.start(...t));
  }
  stop(...t) {
    this.mount().then(() => this.ref.current?.stop(...t));
  }
  pulsate(...t) {
    this.mount().then(() => this.ref.current?.pulsate(...t));
  }
}
function o2() {
  return yu.use();
}
function s2() {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}
function l2(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: a,
    rippleY: i,
    rippleSize: s,
    in: u,
    onExited: c,
    timeout: d
  } = e, [p, f] = B.useState(!1), m = pt(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), h = {
    width: s,
    height: s,
    top: -(s / 2) + i,
    left: -(s / 2) + a
  }, E = pt(n.child, p && n.childLeaving, r && n.childPulsate);
  return !u && !p && f(!0), B.useEffect(() => {
    if (!u && c != null) {
      const y = setTimeout(c, d);
      return () => {
        clearTimeout(y);
      };
    }
  }, [c, u, d]), /* @__PURE__ */ R.jsx("span", {
    className: m,
    style: h,
    children: /* @__PURE__ */ R.jsx("span", {
      className: E
    })
  });
}
const gr = xn("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), dy = 550, u2 = 80, c2 = ev`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, d2 = ev`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, p2 = ev`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, f2 = Gt("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), g2 = Gt(l2, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${gr.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${c2};
    animation-duration: ${dy}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${gr.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${gr.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${gr.childLeaving} {
    opacity: 0;
    animation-name: ${d2};
    animation-duration: ${dy}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${gr.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${p2};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, m2 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: a = !1,
    classes: i = {},
    className: s,
    ...u
  } = r, [c, d] = B.useState([]), p = B.useRef(0), f = B.useRef(null);
  B.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const m = B.useRef(!1), h = D0(), E = B.useRef(null), y = B.useRef(null), w = B.useCallback((C) => {
    const {
      pulsate: T,
      rippleX: A,
      rippleY: O,
      rippleSize: U,
      cb: P
    } = C;
    d((b) => [...b, /* @__PURE__ */ R.jsx(g2, {
      classes: {
        ripple: pt(i.ripple, gr.ripple),
        rippleVisible: pt(i.rippleVisible, gr.rippleVisible),
        ripplePulsate: pt(i.ripplePulsate, gr.ripplePulsate),
        child: pt(i.child, gr.child),
        childLeaving: pt(i.childLeaving, gr.childLeaving),
        childPulsate: pt(i.childPulsate, gr.childPulsate)
      },
      timeout: dy,
      pulsate: T,
      rippleX: A,
      rippleY: O,
      rippleSize: U
    }, p.current)]), p.current += 1, f.current = P;
  }, [i]), x = B.useCallback((C = {}, T = {}, A = () => {
  }) => {
    const {
      pulsate: O = !1,
      center: U = a || T.pulsate,
      fakeElement: P = !1
      // For test purposes
    } = T;
    if (C?.type === "mousedown" && m.current) {
      m.current = !1;
      return;
    }
    C?.type === "touchstart" && (m.current = !0);
    const b = P ? null : y.current, L = b ? b.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let j, G, H;
    if (U || C === void 0 || C.clientX === 0 && C.clientY === 0 || !C.clientX && !C.touches)
      j = Math.round(L.width / 2), G = Math.round(L.height / 2);
    else {
      const {
        clientX: ne,
        clientY: ue
      } = C.touches && C.touches.length > 0 ? C.touches[0] : C;
      j = Math.round(ne - L.left), G = Math.round(ue - L.top);
    }
    if (U)
      H = Math.sqrt((2 * L.width ** 2 + L.height ** 2) / 3), H % 2 === 0 && (H += 1);
    else {
      const ne = Math.max(Math.abs((b ? b.clientWidth : 0) - j), j) * 2 + 2, ue = Math.max(Math.abs((b ? b.clientHeight : 0) - G), G) * 2 + 2;
      H = Math.sqrt(ne ** 2 + ue ** 2);
    }
    C?.touches ? E.current === null && (E.current = () => {
      w({
        pulsate: O,
        rippleX: j,
        rippleY: G,
        rippleSize: H,
        cb: A
      });
    }, h.start(u2, () => {
      E.current && (E.current(), E.current = null);
    })) : w({
      pulsate: O,
      rippleX: j,
      rippleY: G,
      rippleSize: H,
      cb: A
    });
  }, [a, w, h]), I = B.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), S = B.useCallback((C, T) => {
    if (h.clear(), C?.type === "touchend" && E.current) {
      E.current(), E.current = null, h.start(0, () => {
        S(C, T);
      });
      return;
    }
    E.current = null, d((A) => A.length > 0 ? A.slice(1) : A), f.current = T;
  }, [h]);
  return B.useImperativeHandle(n, () => ({
    pulsate: I,
    start: x,
    stop: S
  }), [I, x, S]), /* @__PURE__ */ R.jsx(f2, {
    className: pt(gr.root, i.root, s),
    ref: y,
    ...u,
    children: /* @__PURE__ */ R.jsx(sv, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
function h2(e) {
  return Sn("MuiButtonBase", e);
}
const b2 = xn("MuiButtonBase", ["root", "disabled", "focusVisible"]), y2 = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: a
  } = e, s = Dn({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, h2, a);
  return n && r && (s.root += ` ${r}`), s;
}, v2 = Gt("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${b2.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), E2 = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: a,
    centerRipple: i = !1,
    children: s,
    className: u,
    component: c = "button",
    disabled: d = !1,
    disableRipple: p = !1,
    disableTouchRipple: f = !1,
    focusRipple: m = !1,
    focusVisibleClassName: h,
    LinkComponent: E = "a",
    onBlur: y,
    onClick: w,
    onContextMenu: x,
    onDragLeave: I,
    onFocus: S,
    onFocusVisible: C,
    onKeyDown: T,
    onKeyUp: A,
    onMouseDown: O,
    onMouseLeave: U,
    onMouseUp: P,
    onTouchEnd: b,
    onTouchMove: L,
    onTouchStart: j,
    tabIndex: G = 0,
    TouchRippleProps: H,
    touchRippleRef: ne,
    type: ue,
    ...ce
  } = r, Q = B.useRef(null), de = o2(), D = mu(de.ref, ne), [le, Ae] = B.useState(!1);
  d && le && Ae(!1), B.useImperativeHandle(a, () => ({
    focusVisible: () => {
      Ae(!0), Q.current.focus();
    }
  }), []);
  const M = de.shouldMount && !p && !d;
  B.useEffect(() => {
    le && m && !p && de.pulsate();
  }, [p, m, le, de]);
  const he = ca(de, "start", O, f), se = ca(de, "stop", x, f), ie = ca(de, "stop", I, f), xe = ca(de, "stop", P, f), _e = ca(de, "stop", (Ee) => {
    le && Ee.preventDefault(), U && U(Ee);
  }, f), Le = ca(de, "start", j, f), tt = ca(de, "stop", b, f), at = ca(de, "stop", L, f), tn = ca(de, "stop", (Ee) => {
    gT(Ee.target) || Ae(!1), y && y(Ee);
  }, !1), Ge = Jl((Ee) => {
    Q.current || (Q.current = Ee.currentTarget), gT(Ee.target) && (Ae(!0), C && C(Ee)), S && S(Ee);
  }), St = () => {
    const Ee = Q.current;
    return c && c !== "button" && !(Ee.tagName === "A" && Ee.href);
  }, nn = Jl((Ee) => {
    m && !Ee.repeat && le && Ee.key === " " && de.stop(Ee, () => {
      de.start(Ee);
    }), Ee.target === Ee.currentTarget && St() && Ee.key === " " && Ee.preventDefault(), T && T(Ee), Ee.target === Ee.currentTarget && St() && Ee.key === "Enter" && !d && (Ee.preventDefault(), w && w(Ee));
  }), kt = Jl((Ee) => {
    m && Ee.key === " " && le && !Ee.defaultPrevented && de.stop(Ee, () => {
      de.pulsate(Ee);
    }), A && A(Ee), w && Ee.target === Ee.currentTarget && St() && Ee.key === " " && !Ee.defaultPrevented && w(Ee);
  });
  let Ze = c;
  Ze === "button" && (ce.href || ce.to) && (Ze = E);
  const Nt = {};
  Ze === "button" ? (Nt.type = ue === void 0 ? "button" : ue, Nt.disabled = d) : (!ce.href && !ce.to && (Nt.role = "button"), d && (Nt["aria-disabled"] = d));
  const wn = mu(n, Q), Rt = {
    ...r,
    centerRipple: i,
    component: c,
    disabled: d,
    disableRipple: p,
    disableTouchRipple: f,
    focusRipple: m,
    tabIndex: G,
    focusVisible: le
  }, me = y2(Rt);
  return /* @__PURE__ */ R.jsxs(v2, {
    as: Ze,
    className: pt(me.root, u),
    ownerState: Rt,
    onBlur: tn,
    onClick: w,
    onContextMenu: se,
    onFocus: Ge,
    onKeyDown: nn,
    onKeyUp: kt,
    onMouseDown: he,
    onMouseLeave: _e,
    onMouseUp: xe,
    onDragLeave: ie,
    onTouchEnd: tt,
    onTouchMove: at,
    onTouchStart: Le,
    ref: wn,
    tabIndex: d ? -1 : G,
    type: ue,
    ...Nt,
    ...ce,
    children: [s, M ? /* @__PURE__ */ R.jsx(m2, {
      ref: D,
      center: i,
      ...H
    }) : null]
  });
});
function ca(e, t, n, r = !1) {
  return Jl((a) => (n && n(a), r || e[t](a), !0));
}
function S2(e) {
  return Sn("MuiAccordionSummary", e);
}
const eo = xn("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), x2 = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: r,
    disableGutters: a
  } = e;
  return Dn({
    root: ["root", n && "expanded", r && "disabled", !a && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !a && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, S2, t);
}, T2 = Gt(E2, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(tr(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    width: "100%",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${eo.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${eo.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${eo.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${eo.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), w2 = Gt("span", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(tr(({
  theme: e
}) => ({
  display: "flex",
  textAlign: "start",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${eo.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), A2 = Gt("span", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(tr(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${eo.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), cv = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: a,
    className: i,
    expandIcon: s,
    focusVisibleClassName: u,
    onClick: c,
    ...d
  } = r, {
    disabled: p = !1,
    disableGutters: f,
    expanded: m,
    toggle: h
  } = B.useContext(G0), E = (x) => {
    h && h(x), c && c(x);
  }, y = {
    ...r,
    expanded: m,
    disabled: p,
    disableGutters: f
  }, w = x2(y);
  return /* @__PURE__ */ R.jsxs(T2, {
    focusRipple: !1,
    disableRipple: !0,
    disabled: p,
    "aria-expanded": m,
    className: pt(w.root, i),
    focusVisibleClassName: pt(w.focusVisible, u),
    onClick: E,
    ref: n,
    ownerState: y,
    ...d,
    children: [/* @__PURE__ */ R.jsx(w2, {
      className: w.content,
      ownerState: y,
      children: a
    }), s && /* @__PURE__ */ R.jsx(A2, {
      className: w.expandIconWrapper,
      ownerState: y,
      children: s
    })]
  });
});
function I2(e) {
  return Sn("MuiAccordionDetails", e);
}
xn("MuiAccordionDetails", ["root"]);
const R2 = (e) => {
  const {
    classes: t
  } = e;
  return Dn({
    root: ["root"]
  }, I2, t);
}, _2 = Gt("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(tr(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), fr = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: a,
    ...i
  } = r, s = r, u = R2(s);
  return /* @__PURE__ */ R.jsx(_2, {
    className: pt(u.root, a),
    ref: n,
    ownerState: s,
    ...i
  });
}), _s = lv(/* @__PURE__ */ R.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
var C2 = Object.defineProperty, k2 = (e, t, n) => t in e ? C2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, eu = (e, t, n) => k2(e, typeof t != "symbol" ? t + "" : t, n);
function N2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _T = { exports: {} }, Ho = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CT;
function O2() {
  if (CT) return Ho;
  CT = 1;
  var e = rt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, d) {
    var p, f = {}, m = null, h = null;
    d !== void 0 && (m = "" + d), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (p in c) r.call(c, p) && !i.hasOwnProperty(p) && (f[p] = c[p]);
    if (u && u.defaultProps) for (p in c = u.defaultProps, c) f[p] === void 0 && (f[p] = c[p]);
    return { $$typeof: t, type: u, key: m, ref: h, props: f, _owner: a.current };
  }
  return Ho.Fragment = n, Ho.jsx = s, Ho.jsxs = s, Ho;
}
var kT;
function L2() {
  return kT || (kT = 1, _T.exports = O2()), _T.exports;
}
var V = L2(), Ll = {}, NT;
function D2() {
  if (NT) return Ll;
  NT = 1;
  var e = ha;
  return Ll.createRoot = e.createRoot, Ll.hydrateRoot = e.hydrateRoot, Ll;
}
D2();
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ve.apply(null, arguments);
}
var qd = { exports: {} }, zd, OT;
function M2() {
  if (OT) return zd;
  OT = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zd = e, zd;
}
var Gd, LT;
function F2() {
  if (LT) return Gd;
  LT = 1;
  var e = /* @__PURE__ */ M2();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Gd = function() {
    function r(s, u, c, d, p, f) {
      if (f !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Gd;
}
var DT;
function P2() {
  return DT || (DT = 1, qd.exports = /* @__PURE__ */ F2()()), qd.exports;
}
var B2 = /* @__PURE__ */ P2();
const io = /* @__PURE__ */ N2(B2);
function Ka(e, t, n = void 0) {
  const r = {};
  for (const a in e) {
    const i = e[a];
    let s = "", u = !0;
    for (let c = 0; c < i.length; c += 1) {
      const d = i[c];
      d && (s += (u === !0 ? "" : " ") + t(d), u = !1, n && n[d] && (s += " " + n[d]));
    }
    r[a] = s;
  }
  return r;
}
function $2(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Ha(...e) {
  return B.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      $2(n, t);
    });
  }, e);
}
function U2(e) {
  return typeof e == "string";
}
function j2(e, t, n) {
  return e === void 0 || U2(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function H0(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = H0(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Qt() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = H0(e)) && (r && (r += " "), r += t);
  return r;
}
function py(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function MT(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function q2(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: a,
    className: i
  } = e;
  if (!t) {
    const h = Qt(n?.className, i, a?.className, r?.className), E = {
      ...n?.style,
      ...a?.style,
      ...r?.style
    }, y = {
      ...n,
      ...a,
      ...r
    };
    return h.length > 0 && (y.className = h), Object.keys(E).length > 0 && (y.style = E), {
      props: y,
      internalRef: void 0
    };
  }
  const s = py({
    ...a,
    ...r
  }), u = MT(r), c = MT(a), d = t(s), p = Qt(d?.className, n?.className, i, a?.className, r?.className), f = {
    ...d?.style,
    ...n?.style,
    ...a?.style,
    ...r?.style
  }, m = {
    ...d,
    ...n,
    ...c,
    ...u
  };
  return p.length > 0 && (m.className = p), Object.keys(f).length > 0 && (m.style = f), {
    props: m,
    internalRef: d.ref
  };
}
function fi(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function ts(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: a,
    skipResolvingSlotProps: i = !1,
    ...s
  } = e, u = i ? {} : fi(r, a), {
    props: c,
    internalRef: d
  } = q2({
    ...s,
    externalSlotProps: u
  }), p = Ha(d, u?.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return j2(n, {
    ...c,
    ref: p
  }, a);
}
function V0(e) {
  return KU;
}
const FT = (e) => e, z2 = () => {
  let e = FT;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = FT;
    }
  };
}, G2 = z2(), H2 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Sa(e, t, n = "Mui") {
  const r = H2[t];
  return r ? `${n}-${r}` : `${G2.generate(e)}-${t}`;
}
function Ya(e, t, n = "Mui") {
  const r = {};
  return t.forEach((a) => {
    r[a] = Sa(e, a, n);
  }), r;
}
function V2(e) {
  return Sa("MuiSimpleTreeView", e);
}
Ya("MuiSimpleTreeView", ["root"]);
const W2 = (e, t) => {
  const n = B.useRef({}), [r, a] = B.useState(() => {
    const s = {};
    return e.forEach((u) => {
      u.models && Object.entries(u.models).forEach(([c, d]) => {
        n.current[c] = {
          isControlled: t[c] !== void 0,
          getDefaultValue: d.getDefaultValue
        }, s[c] = d.getDefaultValue(t);
      });
    }), s;
  });
  return Object.fromEntries(Object.entries(n.current).map(([s, u]) => {
    const c = t[s] ?? r[s];
    return [s, {
      value: c,
      setControlledValue: (d) => {
        u.isControlled || a((p) => ve({}, p, {
          [s]: d
        }));
      }
    }];
  }));
};
class K2 {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, r = {}) {
    let a = this.events[t];
    a || (a = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = a), r.isFirst ? a.highPriority.set(n, !0) : a.regular.set(n, !0);
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const r = this.events[t];
    if (!r)
      return;
    const a = Array.from(r.highPriority.keys()), i = Array.from(r.regular.keys());
    for (let s = a.length - 1; s >= 0; s -= 1) {
      const u = a[s];
      r.highPriority.has(u) && u.apply(this, n);
    }
    for (let s = 0; s < i.length; s += 1) {
      const u = i[s];
      r.regular.has(u) && u.apply(this, n);
    }
  }
  once(t, n) {
    const r = this;
    this.on(t, function a(...i) {
      r.removeListener(t, a), n.apply(r, i);
    });
  }
}
const Y2 = (e) => e.isPropagationStopped !== void 0, W0 = () => {
  const [e] = B.useState(() => new K2()), t = B.useCallback((...r) => {
    const [a, i, s = {}] = r;
    s.defaultMuiPrevented = !1, !(Y2(s) && s.isPropagationStopped()) && e.emit(a, i, s);
  }, [e]), n = B.useCallback((r, a) => (e.on(r, a), () => {
    e.removeListener(r, a);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: n
    }
  };
};
W0.params = {};
const K0 = ({
  plugins: e
}) => {
  const t = new Set(e);
  return {
    instance: {
      getAvailablePlugins: () => t
    }
  };
};
K0.params = {};
let PT = 0;
const X2 = () => (PT += 1, `mui-tree-view-${PT}`), Wu = ({
  id: e,
  treeId: t = "",
  itemId: n
}) => e ?? `${t}-${n}`, dv = ({
  params: e,
  state: t,
  setState: n
}) => {
  B.useEffect(() => {
    n((a) => a.id.treeId === e.id && a.id.treeId !== void 0 ? a : ve({}, a, {
      id: ve({}, a.id, {
        treeId: e.id ?? X2()
      })
    }));
  }, [n, e.id]);
  const r = e.id ?? t.id.treeId;
  return {
    getRootProps: () => ({
      id: r
    }),
    contextValue: {
      treeId: r
    }
  };
};
dv.params = {
  id: !0
};
dv.getInitialState = ({
  id: e
}) => ({
  id: {
    treeId: e ?? void 0
  }
});
const Z2 = [W0, K0, dv];
function ba(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
const J2 = ["slots", "slotProps", "apiRef", "experimentalFeatures"], Q2 = (e) => {
  let {
    props: {
      slots: t,
      slotProps: n,
      apiRef: r,
      experimentalFeatures: a
    },
    plugins: i
  } = e, s = ba(e.props, J2);
  const u = {};
  i.forEach((m) => {
    Object.assign(u, m.params);
  });
  const c = {}, d = {};
  Object.keys(s).forEach((m) => {
    const h = s[m];
    u[m] ? c[m] = h : d[m] = h;
  });
  const p = a ?? {}, f = i.reduce((m, h) => h.getDefaultizedParams ? h.getDefaultizedParams({
    params: m,
    experimentalFeatures: p
  }) : m, c);
  return {
    apiRef: r,
    forwardedProps: d,
    pluginParams: f,
    slots: t ?? {},
    slotProps: n ?? {},
    experimentalFeatures: p
  };
}, e5 = ({
  plugins: e,
  instance: t,
  publicAPI: n,
  rootRef: r
}) => ({
  runItemPlugins: (a) => {
    let i = null, s = null;
    const u = [], c = {};
    e.forEach((f) => {
      if (!f.itemPlugin)
        return;
      const m = f.itemPlugin({
        props: a,
        rootRef: i,
        contentRef: s
      });
      m != null && m.rootRef && (i = m.rootRef), m != null && m.contentRef && (s = m.contentRef), m != null && m.propsEnhancers && (u.push(m.propsEnhancers), Object.keys(m.propsEnhancers).forEach((h) => {
        c[h] = !0;
      }));
    });
    const d = (f) => (m) => {
      const h = {};
      return u.forEach((E) => {
        const y = E[f];
        y != null && Object.assign(h, y(m));
      }), h;
    }, p = Object.fromEntries(Object.keys(c).map((f) => [f, d(f)]));
    return {
      contentRef: s,
      rootRef: i,
      propsEnhancers: p
    };
  },
  wrapItem: ({
    itemId: a,
    children: i
  }) => {
    let s = i;
    for (let u = e.length - 1; u >= 0; u -= 1) {
      const c = e[u];
      c.wrapItem && (s = c.wrapItem({
        itemId: a,
        children: s,
        instance: t
      }));
    }
    return s;
  },
  wrapRoot: ({
    children: a
  }) => {
    let i = a;
    for (let s = e.length - 1; s >= 0; s -= 1) {
      const u = e[s];
      u.wrapRoot && (i = u.wrapRoot({
        children: i,
        instance: t
      }));
    }
    return i;
  },
  instance: t,
  rootRef: r,
  publicAPI: n
});
function t5(e) {
  const t = B.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const n5 = ({
  plugins: e,
  rootRef: t,
  props: n
}) => {
  const r = [...Z2, ...e], {
    pluginParams: a,
    forwardedProps: i,
    apiRef: s,
    experimentalFeatures: u,
    slots: c,
    slotProps: d
  } = Q2({
    plugins: r,
    props: n
  }), p = W2(r, a), f = B.useRef({}).current, m = t5(s), h = B.useRef(null), E = Ha(h, t), y = e5({
    plugins: r,
    instance: f,
    publicAPI: m,
    rootRef: h
  }), [w, x] = B.useState(() => {
    const C = {};
    return r.forEach((T) => {
      T.getInitialState && Object.assign(C, T.getInitialState(a));
    }), C;
  }), I = [], S = (C) => {
    const T = C({
      instance: f,
      params: a,
      slots: c,
      slotProps: d,
      experimentalFeatures: u,
      state: w,
      setState: x,
      rootRef: h,
      models: p,
      plugins: r
    });
    T.getRootProps && I.push(T.getRootProps), T.publicAPI && Object.assign(m, T.publicAPI), T.instance && Object.assign(f, T.instance), T.contextValue && Object.assign(y, T.contextValue);
  };
  return r.forEach(S), {
    getRootProps: (C = {}) => {
      const T = ve({
        role: "tree"
      }, i, C, {
        ref: E
      });
      return I.forEach((A) => {
        Object.assign(T, A(C));
      }), T;
    },
    rootRef: E,
    contextValue: y,
    instance: f
  };
}, Y0 = /* @__PURE__ */ B.createContext(null);
function r5(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ V.jsx(Y0.Provider, {
    value: t,
    children: t.wrapRoot({
      children: n,
      instance: t.instance
    })
  });
}
const vo = () => {
  const e = B.useContext(Y0);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
}, X0 = (e, t, n) => {
  e.$$publishEvent(t, n);
}, yi = "__TREE_VIEW_ROOT_PARENT_ID__", Z0 = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[n] = r;
  }), t;
}, ms = /* @__PURE__ */ B.createContext(() => -1), a5 = ["children"], J0 = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: n,
  getItemId: r
}) => {
  const a = {}, i = {}, s = {
    [yi]: []
  }, u = (d, p, f) => {
    var m, h;
    const E = r ? r(d) : d.id;
    if (E == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(d)].join(`
`));
    if (a[E] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${E}"`].join(`
`));
    const y = n ? n(d) : d.label;
    if (y == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(d)].join(`
`));
    a[E] = {
      id: E,
      label: y,
      parentId: f,
      idAttribute: void 0,
      expandable: !!((m = d.children) != null && m.length),
      disabled: t ? t(d) : !1,
      depth: p
    }, i[E] = d;
    const w = f ?? yi;
    s[w] || (s[w] = []), s[w].push(E), (h = d.children) == null || h.forEach((x) => u(x, p + 1, E));
  };
  e.forEach((d) => u(d, 0, null));
  const c = {};
  return Object.keys(s).forEach((d) => {
    c[d] = Z0(s[d]);
  }), {
    itemMetaMap: a,
    itemMap: i,
    itemOrderedChildrenIds: s,
    itemChildrenIndexes: c
  };
}, Cs = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  experimentalFeatures: a
}) => {
  const i = B.useCallback((w) => n.items.itemMetaMap[w], [n.items.itemMetaMap]), s = B.useCallback((w) => n.items.itemMap[w], [n.items.itemMap]), u = B.useCallback(() => {
    const w = (x) => {
      const I = n.items.itemMap[x], S = ba(I, a5), C = n.items.itemOrderedChildrenIds[x];
      return C && (S.children = C.map(w)), S;
    };
    return n.items.itemOrderedChildrenIds[yi].map(w);
  }, [n.items.itemMap, n.items.itemOrderedChildrenIds]), c = B.useCallback((w) => {
    if (w == null)
      return !1;
    let x = e.getItemMeta(w);
    if (!x)
      return !1;
    if (x.disabled)
      return !0;
    for (; x.parentId != null; )
      if (x = e.getItemMeta(x.parentId), x.disabled)
        return !0;
    return !1;
  }, [e]), d = B.useCallback((w) => {
    const x = e.getItemMeta(w).parentId ?? yi;
    return n.items.itemChildrenIndexes[x][w];
  }, [e, n.items.itemChildrenIndexes]), p = B.useCallback((w) => n.items.itemOrderedChildrenIds[w ?? yi] ?? [], [n.items.itemOrderedChildrenIds]), f = (w) => {
    const x = e.getItemMeta(w);
    return x == null ? null : document.getElementById(Wu({
      treeId: n.id.treeId,
      itemId: w,
      id: x.idAttribute
    }));
  }, m = (w) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(w), h = B.useRef(!1), E = B.useCallback(() => {
    h.current = !0;
  }, []), y = B.useCallback(() => h.current, []);
  return B.useEffect(() => {
    e.areItemUpdatesPrevented() || r((w) => {
      const x = J0({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(w.items.itemMetaMap).forEach((I) => {
        x.itemMetaMap[I.id] || X0(e, "removeItem", {
          id: I.id
        });
      }), ve({}, w, {
        items: x
      });
    });
  }, [e, r, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: s,
      getItemDOMElement: f,
      getItemTree: u,
      getItemOrderedChildrenIds: p
    },
    instance: {
      getItemMeta: i,
      getItem: s,
      getItemTree: u,
      getItemsToRender: () => {
        const w = (x) => {
          var I;
          const S = n.items.itemMetaMap[x];
          return {
            label: S.label,
            itemId: S.id,
            id: S.idAttribute,
            children: (I = n.items.itemOrderedChildrenIds[x]) == null ? void 0 : I.map(w)
          };
        };
        return n.items.itemOrderedChildrenIds[yi].map(w);
      },
      getItemIndex: d,
      getItemDOMElement: f,
      getItemOrderedChildrenIds: p,
      isItemDisabled: c,
      isItemNavigable: m,
      preventItemUpdates: E,
      areItemUpdatesPrevented: y
    },
    contextValue: {
      items: {
        onItemClick: t.onItemClick,
        disabledItemsFocusable: t.disabledItemsFocusable,
        indentationAtItemLevel: a.indentationAtItemLevel ?? !1
      }
    }
  };
};
Cs.getInitialState = (e) => ({
  items: J0({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
Cs.getDefaultizedParams = ({
  params: e
}) => ve({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
Cs.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ V.jsx(ms.Provider, {
  value: (n) => {
    var r;
    return ((r = t.getItemMeta(n)) == null ? void 0 : r.depth) ?? 0;
  },
  children: e
});
Cs.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  onItemClick: !0,
  itemChildrenIndentation: !0
};
const Q0 = typeof window < "u" ? B.useLayoutEffect : B.useEffect;
function Sr(e) {
  const t = B.useRef(e);
  return Q0(() => {
    t.current = e;
  }), B.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
const Ku = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = B.useMemo(() => {
    const f = /* @__PURE__ */ new Map();
    return n.expandedItems.value.forEach((m) => {
      f.set(m, !0);
    }), f;
  }, [n.expandedItems.value]), a = (f, m) => {
    var h;
    (h = t.onExpandedItemsChange) == null || h.call(t, f, m), n.expandedItems.setControlledValue(m);
  }, i = B.useCallback((f) => r.has(f), [r]), s = B.useCallback((f) => {
    var m;
    return !!((m = e.getItemMeta(f)) != null && m.expandable);
  }, [e]), u = Sr((f, m) => {
    const h = e.isItemExpanded(m);
    e.setItemExpansion(f, m, !h);
  }), c = Sr((f, m, h) => {
    if (e.isItemExpanded(m) === h)
      return;
    let E;
    h ? E = [m].concat(n.expandedItems.value) : E = n.expandedItems.value.filter((y) => y !== m), t.onItemExpansionToggle && t.onItemExpansionToggle(f, m, h), a(f, E);
  }), d = (f, m) => {
    const h = e.getItemMeta(m), E = e.getItemOrderedChildrenIds(h.parentId).filter((w) => e.isItemExpandable(w) && !e.isItemExpanded(w)), y = n.expandedItems.value.concat(E);
    E.length > 0 && (t.onItemExpansionToggle && E.forEach((w) => {
      t.onItemExpansionToggle(f, w, !0);
    }), a(f, y));
  }, p = B.useMemo(() => t.expansionTrigger ? t.expansionTrigger : e.isTreeViewEditable ? "iconContainer" : "content", [t.expansionTrigger, e.isTreeViewEditable]);
  return {
    publicAPI: {
      setItemExpansion: c
    },
    instance: {
      isItemExpanded: i,
      isItemExpandable: s,
      setItemExpansion: c,
      toggleItemExpansion: u,
      expandAllSiblings: d
    },
    contextValue: {
      expansion: {
        expansionTrigger: p
      }
    }
  };
};
Ku.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const i5 = [];
Ku.getDefaultizedParams = ({
  params: e
}) => ve({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? i5
});
Ku.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0,
  expansionTrigger: !0
};
const eN = (e, t) => {
  let n = t.length - 1;
  for (; n >= 0 && !e.isItemNavigable(t[n]); )
    n -= 1;
  if (n !== -1)
    return t[n];
}, tN = (e, t) => {
  const n = e.getItemMeta(t), r = e.getItemOrderedChildrenIds(n.parentId), a = e.getItemIndex(t);
  if (a === 0)
    return n.parentId;
  let i = a - 1;
  for (; !e.isItemNavigable(r[i]) && i >= 0; )
    i -= 1;
  if (i === -1)
    return n.parentId == null ? null : tN(e, n.parentId);
  let s = r[i], u = eN(e, e.getItemOrderedChildrenIds(s));
  for (; e.isItemExpanded(s) && u != null; )
    s = u, u = e.getItemOrderedChildrenIds(s).find(e.isItemNavigable);
  return s;
}, tu = (e, t) => {
  if (e.isItemExpanded(t)) {
    const r = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (r != null)
      return r;
  }
  let n = e.getItemMeta(t);
  for (; n != null; ) {
    const r = e.getItemOrderedChildrenIds(n.parentId), a = e.getItemIndex(n.id);
    if (a < r.length - 1) {
      let i = a + 1;
      for (; !e.isItemNavigable(r[i]) && i < r.length - 1; )
        i += 1;
      if (e.isItemNavigable(r[i]))
        return r[i];
    }
    n = e.getItemMeta(n.parentId);
  }
  return null;
}, nN = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const n = e.getItemOrderedChildrenIds(t), r = eN(e, n);
    if (r == null)
      return t;
    t = r;
  }
  return t;
}, hs = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), rN = (e, t, n) => {
  if (t === n)
    return [t, n];
  const r = e.getItemMeta(t), a = e.getItemMeta(n);
  if (r.parentId === a.id || a.parentId === r.id)
    return a.parentId === r.id ? [r.id, a.id] : [a.id, r.id];
  const i = [r.id], s = [a.id];
  let u = r.parentId, c = a.parentId, d = s.indexOf(u) !== -1, p = i.indexOf(c) !== -1, f = !0, m = !0;
  for (; !p && !d; )
    f && (i.push(u), d = s.indexOf(u) !== -1, f = u !== null, !d && f && (u = e.getItemMeta(u).parentId)), m && !d && (s.push(c), p = i.indexOf(c) !== -1, m = c !== null, !p && m && (c = e.getItemMeta(c).parentId));
  const h = d ? u : c, E = e.getItemOrderedChildrenIds(h), y = i[i.indexOf(h) - 1], w = s[s.indexOf(h) - 1];
  return E.indexOf(y) < E.indexOf(w) ? [t, n] : [n, t];
}, o5 = (e, t, n) => {
  const r = (c) => {
    if (e.isItemExpandable(c) && e.isItemExpanded(c))
      return e.getItemOrderedChildrenIds(c)[0];
    let d = e.getItemMeta(c);
    for (; d != null; ) {
      const p = e.getItemOrderedChildrenIds(d.parentId), f = e.getItemIndex(d.id);
      if (f < p.length - 1)
        return p[f + 1];
      d = e.getItemMeta(d.parentId);
    }
    throw new Error("Invalid range");
  }, [a, i] = rN(e, t, n), s = [a];
  let u = a;
  for (; u !== i; )
    u = r(u), e.isItemDisabled(u) || s.push(u);
  return s;
}, s5 = (e) => {
  let t = hs(e);
  const n = [];
  for (; t != null; )
    n.push(t), t = tu(e, t);
  return n;
}, fy = (e, t) => t !== e.closest('*[role="treeitem"]'), nu = (e) => Array.isArray(e) ? e : e != null ? [e] : [], Hd = (e) => {
  const t = {};
  return e.forEach((n) => {
    t[n] = !0;
  }), t;
}, Yu = ({
  instance: e,
  params: t,
  models: n
}) => {
  const r = B.useRef(null), a = B.useRef({}), i = B.useMemo(() => {
    const p = /* @__PURE__ */ new Map();
    return Array.isArray(n.selectedItems.value) ? n.selectedItems.value.forEach((f) => {
      p.set(f, !0);
    }) : n.selectedItems.value != null && p.set(n.selectedItems.value, !0), p;
  }, [n.selectedItems.value]), s = (p, f) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const m = f.filter((E) => !e.isItemSelected(E)), h = n.selectedItems.value.filter((E) => !f.includes(E));
        m.forEach((E) => {
          t.onItemSelectionToggle(p, E, !0);
        }), h.forEach((E) => {
          t.onItemSelectionToggle(p, E, !1);
        });
      } else f !== n.selectedItems.value && (n.selectedItems.value != null && t.onItemSelectionToggle(p, n.selectedItems.value, !1), f != null && t.onItemSelectionToggle(p, f, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(p, f), n.selectedItems.setControlledValue(f);
  }, u = (p) => i.has(p), c = ({
    event: p,
    itemId: f,
    keepExistingSelection: m = !1,
    shouldBeSelected: h
  }) => {
    if (t.disableSelection)
      return;
    let E;
    if (m) {
      const y = nu(n.selectedItems.value), w = e.isItemSelected(f);
      w && (h === !1 || h == null) ? E = y.filter((x) => x !== f) : !w && (h === !0 || h == null) ? E = [f].concat(y) : E = y;
    } else
      h === !1 || h == null && e.isItemSelected(f) ? E = t.multiSelect ? [] : null : E = t.multiSelect ? [f] : f;
    s(p, E), r.current = f, a.current = {};
  }, d = (p, [f, m]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let h = nu(n.selectedItems.value).slice();
    Object.keys(a.current).length > 0 && (h = h.filter((x) => !a.current[x]));
    const E = Hd(h), y = o5(e, f, m), w = y.filter((x) => !E[x]);
    h = h.concat(w), s(p, h), a.current = Hd(y);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    publicAPI: {
      selectItem: c
    },
    instance: {
      isItemSelected: u,
      selectItem: c,
      selectAllNavigableItems: (p) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const f = s5(e);
        s(p, f), a.current = Hd(f);
      },
      expandSelectionRange: (p, f) => {
        if (r.current != null) {
          const [m, h] = rN(e, f, r.current);
          d(p, [m, h]);
        }
      },
      selectRangeFromStartToItem: (p, f) => {
        d(p, [hs(e), f]);
      },
      selectRangeFromItemToEnd: (p, f) => {
        d(p, [f, nN(e)]);
      },
      selectItemFromArrowNavigation: (p, f, m) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let h = nu(n.selectedItems.value).slice();
        Object.keys(a.current).length === 0 ? (h.push(m), a.current = {
          [f]: !0,
          [m]: !0
        }) : (a.current[f] || (a.current = {}), a.current[m] ? (h = h.filter((E) => E !== f), delete a.current[f]) : (h.push(m), a.current[m] = !0)), s(p, h);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
Yu.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const l5 = [];
Yu.getDefaultizedParams = ({
  params: e
}) => ve({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? l5 : null)
});
Yu.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
function u5(e) {
  return e && e.ownerDocument || document;
}
const BT = 1e3;
class c5 {
  constructor(t = BT) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = BT, this.cleanupTimeout = t;
  }
  register(t, n, r) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const a = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(r.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(r.cleanupToken, a);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class d5 {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, r) {
    this.registry.register(t, n, r);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class p5 {
}
function f5(e) {
  let t = 0;
  return function(n, r, a) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new d5() : new c5());
    const [i] = B.useState(new p5()), s = B.useRef(null), u = B.useRef();
    u.current = a;
    const c = B.useRef(null);
    if (!s.current && u.current) {
      const d = (p, f) => {
        var m;
        f.defaultMuiPrevented || (m = u.current) == null || m.call(u, p, f);
      };
      s.current = n.$$subscribeEvent(r, d), t += 1, c.current = {
        cleanupToken: t
      }, e.registry.register(
        i,
        // The callback below will be called once this reference stops being retained
        () => {
          var p;
          (p = s.current) == null || p.call(s), s.current = null, c.current = null;
        },
        c.current
      );
    } else !u.current && s.current && (s.current(), s.current = null, c.current && (e.registry.unregister(c.current), c.current = null));
    B.useEffect(() => {
      if (!s.current && u.current) {
        const d = (p, f) => {
          var m;
          f.defaultMuiPrevented || (m = u.current) == null || m.call(u, p, f);
        };
        s.current = n.$$subscribeEvent(r, d);
      }
      return c.current && e.registry && (e.registry.unregister(c.current), c.current = null), () => {
        var d;
        (d = s.current) == null || d.call(s), s.current = null;
      };
    }, [n, r]);
  };
}
const g5 = {
  registry: null
}, m5 = f5(g5), aN = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? aN(t.shadowRoot) : t : null;
};
function h5(e) {
  return e.replace(/["\\]/g, "\\$&");
}
const b5 = (e, t) => {
  let n = nu(t).find((r) => {
    if (!e.isItemNavigable(r))
      return !1;
    const a = e.getItemMeta(r);
    return a && (a.parentId == null || e.isItemExpanded(a.parentId));
  });
  return n == null && (n = hs(e)), n;
}, pv = ({
  instance: e,
  params: t,
  state: n,
  setState: r,
  models: a,
  rootRef: i
}) => {
  const s = b5(e, a.selectedItems.value), u = Sr((w) => {
    const x = typeof w == "function" ? w(n.focusedItemId) : w;
    n.focusedItemId !== x && r((I) => ve({}, I, {
      focusedItemId: x
    }));
  }), c = B.useCallback(() => !!i.current && i.current.contains(aN(u5(i.current))), [i]), d = B.useCallback((w) => n.focusedItemId === w && c(), [n.focusedItemId, c]), p = (w) => {
    const x = e.getItemMeta(w);
    return x && (x.parentId == null || e.isItemExpanded(x.parentId));
  }, f = (w, x) => {
    const I = e.getItemDOMElement(x);
    I && I.focus(), u(x), t.onItemFocus && t.onItemFocus(w, x);
  }, m = Sr((w, x) => {
    p(x) && f(w, x);
  }), h = Sr(() => {
    if (n.focusedItemId != null) {
      if (e.getItemMeta(n.focusedItemId)) {
        const w = e.getItemDOMElement(n.focusedItemId);
        w && w.blur();
      }
      u(null);
    }
  }), E = (w) => w === s;
  m5(e, "removeItem", ({
    id: w
  }) => {
    n.focusedItemId === w && f(null, s);
  });
  const y = (w) => (x) => {
    var I;
    (I = w.onFocus) == null || I.call(w, x), !x.defaultMuiPrevented && x.target === x.currentTarget && f(x, s);
  };
  return {
    getRootProps: (w) => ({
      onFocus: y(w)
    }),
    publicAPI: {
      focusItem: m
    },
    instance: {
      isItemFocused: d,
      canItemBeTabbed: E,
      focusItem: m,
      removeFocusedItem: h
    }
  };
};
pv.getInitialState = () => ({
  focusedItemId: null
});
pv.params = {
  onItemFocus: !0
};
const y5 = /* @__PURE__ */ B.createContext(), v5 = () => B.useContext(y5) ?? !1, ru = (e, t) => e.getAvailablePlugins().has(t), E5 = ({
  props: e
}) => {
  const {
    instance: t
  } = vo(), {
    label: n,
    itemId: r
  } = e, [a, i] = B.useState(n), s = t.isItemBeingEdited(r);
  return B.useEffect(() => {
    s || i(n);
  }, [s, n]), {
    propsEnhancers: {
      labelInput: ({
        externalEventHandlers: u,
        interactions: c
      }) => t.isItemEditable(r) ? {
        value: a ?? "",
        "data-element": "labelInput",
        onChange: (d) => {
          var p;
          (p = u.onChange) == null || p.call(u, d), i(d.target.value);
        },
        onKeyDown: (d) => {
          var p;
          if ((p = u.onKeyDown) == null || p.call(u, d), d.defaultMuiPrevented)
            return;
          const f = d.target;
          d.key === "Enter" && f.value ? c.handleSaveItemLabel(d, f.value) : d.key === "Escape" && c.handleCancelItemLabelEditing(d);
        },
        onBlur: (d) => {
          var p;
          (p = u.onBlur) == null || p.call(u, d), !d.defaultMuiPrevented && d.target.value && c.handleSaveItemLabel(d, d.target.value);
        },
        autoFocus: !0,
        type: "text"
      } : {}
    }
  };
}, za = ({
  instance: e,
  state: t,
  setState: n,
  params: r
}) => {
  const a = B.useRef(t.editedItemId), i = (f) => a.current === f, s = (f) => {
    n((m) => ve({}, m, {
      editedItemId: f
    })), a.current = f;
  }, u = (f) => f === t.editedItemId, c = !!r.isItemEditable, d = (f) => {
    if (f == null || !c)
      return !1;
    const m = e.getItem(f);
    return m ? typeof r.isItemEditable == "function" ? r.isItemEditable(m) : !!r.isItemEditable : !1;
  }, p = (f, m) => {
    if (!m)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "The label of an item cannot be empty.", f].join(`
`));
    n((h) => {
      const E = h.items.itemMetaMap[f];
      return E.label !== m ? ve({}, h, {
        items: ve({}, h.items, {
          itemMetaMap: ve({}, h.items.itemMetaMap, {
            [f]: ve({}, E, {
              label: m
            })
          })
        })
      }) : h;
    }), r.onItemLabelChange && r.onItemLabelChange(f, m);
  };
  return {
    instance: {
      setEditedItemId: s,
      isItemBeingEdited: u,
      updateItemLabel: p,
      isItemEditable: d,
      isTreeViewEditable: c,
      isItemBeingEditedRef: i
    },
    publicAPI: {
      updateItemLabel: p
    }
  };
};
za.itemPlugin = E5;
za.getDefaultizedParams = ({
  params: e,
  experimentalFeatures: t
}) => {
  const n = t?.labelEditing;
  return ve({}, e, {
    isItemEditable: n ? e.isItemEditable ?? !1 : !1
  });
};
za.getInitialState = () => ({
  editedItemId: null
});
za.params = {
  onItemLabelChange: !0,
  isItemEditable: !0
};
function S5(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const iN = ({
  instance: e,
  params: t,
  state: n
}) => {
  const r = v5(), a = B.useRef({}), i = Sr((d) => {
    a.current = d(a.current);
  });
  B.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const d = {}, p = (f) => {
      d[f.id] = f.label.substring(0, 1).toLowerCase();
    };
    Object.values(n.items.itemMetaMap).forEach(p), a.current = d;
  }, [n.items.itemMetaMap, t.getItemId, e]);
  const s = (d, p) => {
    const f = p.toLowerCase(), m = (w) => {
      const x = tu(e, w);
      return x === null ? hs(e) : x;
    };
    let h = null, E = m(d);
    const y = {};
    for (; h == null && !y[E]; )
      a.current[E] === f ? h = E : (y[E] = !0, E = m(E));
    return h;
  }, u = (d) => !t.disableSelection && !e.isItemDisabled(d), c = (d) => !e.isItemDisabled(d) && e.isItemExpandable(d);
  return {
    instance: {
      updateFirstCharMap: i,
      handleItemKeyDown: (d, p) => {
        if (d.defaultMuiPrevented || d.altKey || fy(d.target, d.currentTarget))
          return;
        const f = d.ctrlKey || d.metaKey, m = d.key;
        switch (!0) {
          // Select the item when pressing "Space"
          case (m === " " && u(p)): {
            d.preventDefault(), t.multiSelect && d.shiftKey ? e.expandSelectionRange(d, p) : e.selectItem({
              event: d,
              itemId: p,
              keepExistingSelection: t.multiSelect,
              shouldBeSelected: t.multiSelect ? void 0 : !0
            });
            break;
          }
          // If the focused item has children, we expand it.
          // If the focused item has no children, we select it.
          case m === "Enter": {
            ru(e, za) && e.isItemEditable(p) && !e.isItemBeingEdited(p) ? e.setEditedItemId(p) : c(p) ? (e.toggleItemExpansion(d, p), d.preventDefault()) : u(p) && (t.multiSelect ? (d.preventDefault(), e.selectItem({
              event: d,
              itemId: p,
              keepExistingSelection: !0
            })) : e.isItemSelected(p) || (e.selectItem({
              event: d,
              itemId: p
            }), d.preventDefault()));
            break;
          }
          // Focus the next focusable item
          case m === "ArrowDown": {
            const h = tu(e, p);
            h && (d.preventDefault(), e.focusItem(d, h), t.multiSelect && d.shiftKey && u(h) && e.selectItemFromArrowNavigation(d, p, h));
            break;
          }
          // Focuses the previous focusable item
          case m === "ArrowUp": {
            const h = tN(e, p);
            h && (d.preventDefault(), e.focusItem(d, h), t.multiSelect && d.shiftKey && u(h) && e.selectItemFromArrowNavigation(d, p, h));
            break;
          }
          // If the focused item is expanded, we move the focus to its first child
          // If the focused item is collapsed and has children, we expand it
          case (m === "ArrowRight" && !r || m === "ArrowLeft" && r): {
            if (f)
              return;
            if (e.isItemExpanded(p)) {
              const h = tu(e, p);
              h && (e.focusItem(d, h), d.preventDefault());
            } else c(p) && (e.toggleItemExpansion(d, p), d.preventDefault());
            break;
          }
          // If the focused item is expanded, we collapse it
          // If the focused item is collapsed and has a parent, we move the focus to this parent
          case (m === "ArrowLeft" && !r || m === "ArrowRight" && r): {
            if (f)
              return;
            if (c(p) && e.isItemExpanded(p))
              e.toggleItemExpansion(d, p), d.preventDefault();
            else {
              const h = e.getItemMeta(p).parentId;
              h && (e.focusItem(d, h), d.preventDefault());
            }
            break;
          }
          // Focuses the first item in the tree
          case m === "Home": {
            u(p) && t.multiSelect && f && d.shiftKey ? e.selectRangeFromStartToItem(d, p) : e.focusItem(d, hs(e)), d.preventDefault();
            break;
          }
          // Focuses the last item in the tree
          case m === "End": {
            u(p) && t.multiSelect && f && d.shiftKey ? e.selectRangeFromItemToEnd(d, p) : e.focusItem(d, nN(e)), d.preventDefault();
            break;
          }
          // Expand all siblings that are at the same level as the focused item
          case m === "*": {
            e.expandAllSiblings(d, p), d.preventDefault();
            break;
          }
          // Multi select behavior when pressing Ctrl + a
          // Selects all the items
          case (String.fromCharCode(d.keyCode) === "A" && f && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(d), d.preventDefault();
            break;
          }
          // Type-ahead
          // TODO: Support typing multiple characters
          case (!f && !d.shiftKey && S5(m)): {
            const h = s(p, m);
            h != null && (e.focusItem(d, h), d.preventDefault());
            break;
          }
        }
      }
    }
  };
};
iN.params = {};
const oN = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
oN.params = {};
const sN = /* @__PURE__ */ B.createContext(null);
function lN(e) {
  const {
    children: t,
    itemId: n = null
  } = e, {
    instance: r,
    treeId: a,
    rootRef: i
  } = vo(), s = B.useRef(/* @__PURE__ */ new Map());
  B.useEffect(() => {
    if (!i.current)
      return;
    let c = null;
    if (n == null)
      c = i.current.id;
    else {
      const h = r.getItemMeta(n);
      h !== void 0 && (c = Wu({
        itemId: n,
        treeId: a,
        id: h.idAttribute
      }));
    }
    if (c == null)
      return;
    const d = r.getItemOrderedChildrenIds(n ?? null) ?? [], p = h5(c), f = i.current.querySelectorAll(`${n == null ? "" : `*[id="${p}"] `}[role="treeitem"]:not(*[id="${p}"] [role="treeitem"] [role="treeitem"])`), m = Array.from(f).map((h) => s.current.get(h.id));
    (m.length !== d.length || m.some((h, E) => h !== d[E])) && r.setJSXItemsOrderedChildrenIds(n ?? null, m);
  });
  const u = B.useMemo(() => ({
    registerChild: (c, d) => s.current.set(c, d),
    unregisterChild: (c) => s.current.delete(c),
    parentId: n
  }), [n]);
  return /* @__PURE__ */ V.jsx(sN.Provider, {
    value: u,
    children: t
  });
}
const ks = ({
  instance: e,
  setState: t
}) => {
  e.preventItemUpdates();
  const n = Sr((i) => (t((s) => {
    if (s.items.itemMetaMap[i.id] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${i.id}"`].join(`
`));
    return ve({}, s, {
      items: ve({}, s.items, {
        itemMetaMap: ve({}, s.items.itemMetaMap, {
          [i.id]: i
        }),
        // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
        itemMap: ve({}, s.items.itemMap, {
          [i.id]: {
            id: i.id,
            label: i.label
          }
        })
      })
    });
  }), () => {
    t((s) => {
      const u = ve({}, s.items.itemMetaMap), c = ve({}, s.items.itemMap);
      return delete u[i.id], delete c[i.id], ve({}, s, {
        items: ve({}, s.items, {
          itemMetaMap: u,
          itemMap: c
        })
      });
    }), X0(e, "removeItem", {
      id: i.id
    });
  })), r = (i, s) => {
    const u = i ?? yi;
    t((c) => ve({}, c, {
      items: ve({}, c.items, {
        itemOrderedChildrenIds: ve({}, c.items.itemOrderedChildrenIds, {
          [u]: s
        }),
        itemChildrenIndexes: ve({}, c.items.itemChildrenIndexes, {
          [u]: Z0(s)
        })
      })
    }));
  }, a = Sr((i, s) => (e.updateFirstCharMap((u) => (u[i] = s, u)), () => {
    e.updateFirstCharMap((u) => {
      const c = ve({}, u);
      return delete c[i], c;
    });
  }));
  return {
    instance: {
      insertJSXItem: n,
      setJSXItemsOrderedChildrenIds: r,
      mapFirstCharFromJSX: a
    }
  };
}, uN = (e) => Array.isArray(e) ? e.length > 0 && e.some(uN) : !!e, x5 = ({
  props: e,
  rootRef: t,
  contentRef: n
}) => {
  const {
    instance: r,
    treeId: a
  } = vo(), {
    children: i,
    disabled: s = !1,
    label: u,
    itemId: c,
    id: d
  } = e, p = B.useContext(sN);
  if (p == null)
    throw new Error(["MUI X: Could not find the Tree View Children Item context.", "It looks like you rendered your component outside of a SimpleTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  const {
    registerChild: f,
    unregisterChild: m,
    parentId: h
  } = p, E = uN(i), y = B.useRef(null), w = Ha(y, n);
  return Q0(() => {
    const x = Wu({
      itemId: c,
      treeId: a,
      id: d
    });
    return f(x, c), () => {
      m(x);
    };
  }, [f, m, c, d, a]), B.useEffect(() => r.insertJSXItem({
    id: c,
    idAttribute: d,
    parentId: h,
    expandable: E,
    disabled: s
  }), [r, h, c, E, s, d]), B.useEffect(() => {
    var x;
    if (u)
      return r.mapFirstCharFromJSX(c, (((x = y.current) == null ? void 0 : x.textContent) ?? "").substring(0, 1).toLowerCase());
  }, [r, c, u]), {
    contentRef: w,
    rootRef: t
  };
};
ks.itemPlugin = x5;
ks.wrapItem = ({
  children: e,
  itemId: t
}) => {
  const n = B.useContext(ms);
  return /* @__PURE__ */ V.jsx(lN, {
    itemId: t,
    children: /* @__PURE__ */ V.jsx(ms.Provider, {
      value: n + 1,
      children: e
    })
  });
};
ks.wrapRoot = ({
  children: e
}) => /* @__PURE__ */ V.jsx(lN, {
  children: /* @__PURE__ */ V.jsx(ms.Provider, {
    value: 0,
    children: e
  })
});
ks.params = {};
const T5 = [Cs, Ku, Yu, pv, iN, oN, ks], w5 = V0(), A5 = (e) => {
  const {
    classes: t
  } = e;
  return Ka({
    root: ["root"]
  }, V2, t);
}, I5 = cn("ul", {
  name: "MuiSimpleTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
}), R5 = [], _5 = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = w5({
    props: e,
    name: "MuiSimpleTreeView"
  }), r = n, {
    getRootProps: a,
    contextValue: i
  } = n5({
    plugins: T5,
    rootRef: t,
    props: ve({}, n, {
      items: R5
    })
  }), {
    slots: s,
    slotProps: u
  } = n, c = A5(n), d = s?.root ?? I5, p = ts({
    elementType: d,
    externalSlotProps: u?.root,
    className: c.root,
    getSlotProps: a,
    ownerState: r
  });
  return /* @__PURE__ */ V.jsx(r5, {
    value: i,
    children: /* @__PURE__ */ V.jsx(d, ve({}, p))
  });
});
function gy(e, t) {
  return gy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, gy(e, t);
}
function cN(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, gy(e, t);
}
const $T = {
  disabled: !1
}, vu = rt.createContext(null);
var C5 = function(e) {
  return e.scrollTop;
}, ns = "unmounted", gi = "exited", mi = "entering", Qi = "entered", my = "exiting", xa = /* @__PURE__ */ function(e) {
  cN(t, e);
  function t(r, a) {
    var i;
    i = e.call(this, r, a) || this;
    var s = a, u = s && !s.isMounting ? r.enter : r.appear, c;
    return i.appearStatus = null, r.in ? u ? (c = gi, i.appearStatus = mi) : c = Qi : r.unmountOnExit || r.mountOnEnter ? c = ns : c = gi, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(r, a) {
    var i = r.in;
    return i && a.status === ns ? {
      status: gi
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(r) {
    var a = null;
    if (r !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== mi && i !== Qi && (a = mi) : (i === mi || i === Qi) && (a = my);
    }
    this.updateStatus(!1, a);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var r = this.props.timeout, a, i, s;
    return a = i = s = r, r != null && typeof r != "number" && (a = r.exit, i = r.enter, s = r.appear !== void 0 ? r.appear : i), {
      exit: a,
      enter: i,
      appear: s
    };
  }, n.updateStatus = function(r, a) {
    if (r === void 0 && (r = !1), a !== null)
      if (this.cancelNextCallback(), a === mi) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var i = this.props.nodeRef ? this.props.nodeRef.current : ha.findDOMNode(this);
          i && C5(i);
        }
        this.performEnter(r);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === gi && this.setState({
      status: ns
    });
  }, n.performEnter = function(r) {
    var a = this, i = this.props.enter, s = this.context ? this.context.isMounting : r, u = this.props.nodeRef ? [s] : [ha.findDOMNode(this), s], c = u[0], d = u[1], p = this.getTimeouts(), f = s ? p.appear : p.enter;
    if (!r && !i || $T.disabled) {
      this.safeSetState({
        status: Qi
      }, function() {
        a.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, d), this.safeSetState({
      status: mi
    }, function() {
      a.props.onEntering(c, d), a.onTransitionEnd(f, function() {
        a.safeSetState({
          status: Qi
        }, function() {
          a.props.onEntered(c, d);
        });
      });
    });
  }, n.performExit = function() {
    var r = this, a = this.props.exit, i = this.getTimeouts(), s = this.props.nodeRef ? void 0 : ha.findDOMNode(this);
    if (!a || $T.disabled) {
      this.safeSetState({
        status: gi
      }, function() {
        r.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: my
    }, function() {
      r.props.onExiting(s), r.onTransitionEnd(i.exit, function() {
        r.safeSetState({
          status: gi
        }, function() {
          r.props.onExited(s);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(r, a) {
    a = this.setNextCallback(a), this.setState(r, a);
  }, n.setNextCallback = function(r) {
    var a = this, i = !0;
    return this.nextCallback = function(s) {
      i && (i = !1, a.nextCallback = null, r(s));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(r, a) {
    this.setNextCallback(a);
    var i = this.props.nodeRef ? this.props.nodeRef.current : ha.findDOMNode(this), s = r == null && !this.props.addEndListener;
    if (!i || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], c = u[0], d = u[1];
      this.props.addEndListener(c, d);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, n.render = function() {
    var r = this.state.status;
    if (r === ns)
      return null;
    var a = this.props, i = a.children;
    a.in, a.mountOnEnter, a.unmountOnExit, a.appear, a.enter, a.exit, a.timeout, a.addEndListener, a.onEnter, a.onEntering, a.onEntered, a.onExit, a.onExiting, a.onExited, a.nodeRef;
    var s = ba(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ rt.createElement(vu.Provider, {
        value: null
      }, typeof i == "function" ? i(r, s) : rt.cloneElement(rt.Children.only(i), s))
    );
  }, t;
}(rt.Component);
xa.contextType = vu;
xa.propTypes = {};
function Wi() {
}
xa.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Wi,
  onEntering: Wi,
  onEntered: Wi,
  onExit: Wi,
  onExiting: Wi,
  onExited: Wi
};
xa.UNMOUNTED = ns;
xa.EXITED = gi;
xa.ENTERING = mi;
xa.ENTERED = Qi;
xa.EXITING = my;
function k5(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fv(e, t) {
  var n = function(a) {
    return t && ja(a) ? t(a) : a;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && r0.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    r[a.key] = n(a);
  }), r;
}
function N5(e, t) {
  e = e || {}, t = t || {};
  function n(p) {
    return p in t ? t[p] : e[p];
  }
  var r = /* @__PURE__ */ Object.create(null), a = [];
  for (var i in e)
    i in t ? a.length && (r[i] = a, a = []) : a.push(i);
  var s, u = {};
  for (var c in t) {
    if (r[c])
      for (s = 0; s < r[c].length; s++) {
        var d = r[c][s];
        u[r[c][s]] = n(d);
      }
    u[c] = n(c);
  }
  for (s = 0; s < a.length; s++)
    u[a[s]] = n(a[s]);
  return u;
}
function vi(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function O5(e, t) {
  return fv(e.children, function(n) {
    return qa(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: vi(n, "appear", e),
      enter: vi(n, "enter", e),
      exit: vi(n, "exit", e)
    });
  });
}
function L5(e, t, n) {
  var r = fv(e.children), a = N5(t, r);
  return Object.keys(a).forEach(function(i) {
    var s = a[i];
    if (ja(s)) {
      var u = i in t, c = i in r, d = t[i], p = ja(d) && !d.props.in;
      c && (!u || p) ? a[i] = qa(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: vi(s, "exit", e),
        enter: vi(s, "enter", e)
      }) : !c && u && !p ? a[i] = qa(s, {
        in: !1
      }) : c && u && ja(d) && (a[i] = qa(s, {
        onExited: n.bind(null, s),
        in: d.props.in,
        exit: vi(s, "exit", e),
        enter: vi(s, "enter", e)
      }));
    }
  }), a;
}
var D5 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, M5 = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, gv = /* @__PURE__ */ function(e) {
  cN(t, e);
  function t(r, a) {
    var i;
    i = e.call(this, r, a) || this;
    var s = i.handleExited.bind(k5(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(r, a) {
    var i = a.children, s = a.handleExited, u = a.firstRender;
    return {
      children: u ? O5(r, s) : L5(r, i, s),
      firstRender: !1
    };
  }, n.handleExited = function(r, a) {
    var i = fv(this.props.children);
    r.key in i || (r.props.onExited && r.props.onExited(a), this.mounted && this.setState(function(s) {
      var u = ve({}, s.children);
      return delete u[r.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var r = this.props, a = r.component, i = r.childFactory, s = ba(r, ["component", "childFactory"]), u = this.state.contextValue, c = D5(this.state.children).map(i);
    return delete s.appear, delete s.enter, delete s.exit, a === null ? /* @__PURE__ */ rt.createElement(vu.Provider, {
      value: u
    }, c) : /* @__PURE__ */ rt.createElement(vu.Provider, {
      value: u
    }, /* @__PURE__ */ rt.createElement(a, s, c));
  }, t;
}(rt.Component);
gv.propTypes = {};
gv.defaultProps = M5;
const UT = {};
function dN(e, t) {
  const n = B.useRef(UT);
  return n.current === UT && (n.current = e(t)), n;
}
const F5 = [];
function P5(e) {
  B.useEffect(e, F5);
}
class mv {
  constructor() {
    eu(this, "currentId", null), eu(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }), eu(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new mv();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function pN() {
  const e = dN(mv.create).current;
  return P5(e.disposeEffect), e;
}
function B5(e, t) {
  return () => null;
}
B5(io.elementType);
function wi(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function Nr(e) {
  if (typeof e != "string")
    throw new Error(wi(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var jT = { exports: {} }, ot = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qT;
function $5() {
  if (qT) return ot;
  qT = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), h = Symbol.for("react.client.reference");
  function E(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case n:
            case a:
            case r:
            case c:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case u:
                case f:
                case p:
                  return y;
                case i:
                  return y;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return ot.ContextConsumer = i, ot.ContextProvider = s, ot.Element = e, ot.ForwardRef = u, ot.Fragment = n, ot.Lazy = f, ot.Memo = p, ot.Portal = t, ot.Profiler = a, ot.StrictMode = r, ot.Suspense = c, ot.SuspenseList = d, ot.isContextConsumer = function(y) {
    return E(y) === i;
  }, ot.isContextProvider = function(y) {
    return E(y) === s;
  }, ot.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, ot.isForwardRef = function(y) {
    return E(y) === u;
  }, ot.isFragment = function(y) {
    return E(y) === n;
  }, ot.isLazy = function(y) {
    return E(y) === f;
  }, ot.isMemo = function(y) {
    return E(y) === p;
  }, ot.isPortal = function(y) {
    return E(y) === t;
  }, ot.isProfiler = function(y) {
    return E(y) === a;
  }, ot.isStrictMode = function(y) {
    return E(y) === r;
  }, ot.isSuspense = function(y) {
    return E(y) === c;
  }, ot.isSuspenseList = function(y) {
    return E(y) === d;
  }, ot.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === a || y === r || y === c || y === d || y === m || typeof y == "object" && y !== null && (y.$$typeof === f || y.$$typeof === p || y.$$typeof === s || y.$$typeof === i || y.$$typeof === u || y.$$typeof === h || y.getModuleId !== void 0);
  }, ot.typeOf = E, ot;
}
var zT;
function U5() {
  return zT || (zT = 1, jT.exports = /* @__PURE__ */ $5()), jT.exports;
}
var fN = /* @__PURE__ */ U5();
function Yr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function gN(e) {
  if (/* @__PURE__ */ B.isValidElement(e) || fN.isValidElementType(e) || !Yr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = gN(e[n]);
  }), t;
}
function Jn(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Yr(e) && Yr(t) && Object.keys(t).forEach((a) => {
    /* @__PURE__ */ B.isValidElement(t[a]) || fN.isValidElementType(t[a]) ? r[a] = t[a] : Yr(t[a]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, a) && Yr(e[a]) ? r[a] = Jn(e[a], t[a], n) : n.clone ? r[a] = Yr(t[a]) ? gN(t[a]) : t[a] : r[a] = t[a];
  }), r;
}
function ss(e, t) {
  return t ? Jn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function j5(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, a) => {
    var i, s;
    const u = /min-width:\s*([0-9.]+)/;
    return +(((i = r.match(u)) == null ? void 0 : i[1]) || 0) - +(((s = a.match(u)) == null ? void 0 : s[1]) || 0);
  });
  return n.length ? n.reduce((r, a) => {
    const i = t[a];
    return delete r[a], r[a] = i, r;
  }, {
    ...t
  }) : t;
}
function q5(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function z5(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, r, a] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(a).up(i);
}
function G5(e) {
  const t = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function n(i, s) {
    i.up = (...u) => t(e.breakpoints.up(...u), s), i.down = (...u) => t(e.breakpoints.down(...u), s), i.between = (...u) => t(e.breakpoints.between(...u), s), i.only = (...u) => t(e.breakpoints.only(...u), s), i.not = (...u) => {
      const c = t(e.breakpoints.not(...u), s);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const r = {}, a = (i) => (n(r, i), r);
  return n(a), {
    ...e,
    containerQueries: a
  };
}
const Xu = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, GT = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Xu[e]}px)`
}, H5 = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Xu[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function va(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const a = r.breakpoints || GT;
    return t.reduce((i, s, u) => (i[a.up(a.keys[u])] = n(t[u]), i), {});
  }
  if (typeof t == "object") {
    const a = r.breakpoints || GT;
    return Object.keys(t).reduce((i, s) => {
      if (q5(a.keys, s)) {
        const u = z5(r.containerQueries ? r : H5, s);
        u && (i[u] = n(t[s], s));
      } else if (Object.keys(a.values || Xu).includes(s)) {
        const u = a.up(s);
        i[u] = n(t[s], s);
      } else {
        const u = s;
        i[u] = t[u];
      }
      return i;
    }, {});
  }
  return n(t);
}
function V5(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, r) => {
    const a = e.up(r);
    return n[a] = {}, n;
  }, {})) || {};
}
function W5(e, t) {
  return e.reduce((n, r) => {
    const a = n[r];
    return (!a || Object.keys(a).length === 0) && delete n[r], n;
  }, t);
}
function Zu(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((a, i) => a && a[i] ? a[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, a) => r && r[a] != null ? r[a] : null, e);
}
function Eu(e, t, n, r = n) {
  let a;
  return typeof e == "function" ? a = e(n) : Array.isArray(e) ? a = e[n] || r : a = Zu(e, n) || r, t && (a = t(a, r, e)), a;
}
function Ht(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: a
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const u = s[t], c = s.theme, d = Zu(c, r) || {};
    return va(s, u, (p) => {
      let f = Eu(d, a, p);
      return p === f && typeof p == "string" && (f = Eu(d, a, `${t}${p === "default" ? "" : Nr(p)}`, p)), n === !1 ? f : {
        [n]: f
      };
    });
  };
  return i.propTypes = {}, i.filterProps = [t], i;
}
function K5(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const Y5 = {
  m: "margin",
  p: "padding"
}, X5 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, HT = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Z5 = K5((e) => {
  if (e.length > 2)
    if (HT[e])
      e = HT[e];
    else
      return [e];
  const [t, n] = e.split(""), r = Y5[t], a = X5[n] || "";
  return Array.isArray(a) ? a.map((i) => r + i) : [r + a];
}), hv = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], bv = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...hv, ...bv];
function Ns(e, t, n, r) {
  const a = Zu(e, t, !0) ?? n;
  return typeof a == "number" || typeof a == "string" ? (i) => typeof i == "string" ? i : typeof a == "string" ? `calc(${i} * ${a})` : a * i : Array.isArray(a) ? (i) => {
    if (typeof i == "string")
      return i;
    const s = Math.abs(i), u = a[s];
    return i >= 0 ? u : typeof u == "number" ? -u : `-${u}`;
  } : typeof a == "function" ? a : () => {
  };
}
function yv(e) {
  return Ns(e, "spacing", 8);
}
function Os(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function J5(e, t) {
  return (n) => e.reduce((r, a) => (r[a] = Os(t, n), r), {});
}
function Q5(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const a = Z5(n), i = J5(a, r), s = e[n];
  return va(e, s, i);
}
function mN(e, t) {
  const n = yv(e.theme);
  return Object.keys(e).map((r) => Q5(e, t, r, n)).reduce(ss, {});
}
function Ft(e) {
  return mN(e, hv);
}
Ft.propTypes = {};
Ft.filterProps = hv;
function Pt(e) {
  return mN(e, bv);
}
Pt.propTypes = {};
Pt.filterProps = bv;
function Ju(...e) {
  const t = e.reduce((r, a) => (a.filterProps.forEach((i) => {
    r[i] = a;
  }), r), {}), n = (r) => Object.keys(r).reduce((a, i) => t[i] ? ss(a, t[i](r)) : a, {});
  return n.propTypes = {}, n.filterProps = e.reduce((r, a) => r.concat(a.filterProps), []), n;
}
function br(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ar(e, t) {
  return Ht({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const e3 = Ar("border", br), t3 = Ar("borderTop", br), n3 = Ar("borderRight", br), r3 = Ar("borderBottom", br), a3 = Ar("borderLeft", br), i3 = Ar("borderColor"), o3 = Ar("borderTopColor"), s3 = Ar("borderRightColor"), l3 = Ar("borderBottomColor"), u3 = Ar("borderLeftColor"), c3 = Ar("outline", br), d3 = Ar("outlineColor"), Qu = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Ns(e.theme, "shape.borderRadius", 4), n = (r) => ({
      borderRadius: Os(t, r)
    });
    return va(e, e.borderRadius, n);
  }
  return null;
};
Qu.propTypes = {};
Qu.filterProps = ["borderRadius"];
Ju(e3, t3, n3, r3, a3, i3, o3, s3, l3, u3, Qu, c3, d3);
const ec = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Ns(e.theme, "spacing", 8), n = (r) => ({
      gap: Os(t, r)
    });
    return va(e, e.gap, n);
  }
  return null;
};
ec.propTypes = {};
ec.filterProps = ["gap"];
const tc = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Ns(e.theme, "spacing", 8), n = (r) => ({
      columnGap: Os(t, r)
    });
    return va(e, e.columnGap, n);
  }
  return null;
};
tc.propTypes = {};
tc.filterProps = ["columnGap"];
const nc = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Ns(e.theme, "spacing", 8), n = (r) => ({
      rowGap: Os(t, r)
    });
    return va(e, e.rowGap, n);
  }
  return null;
};
nc.propTypes = {};
nc.filterProps = ["rowGap"];
const p3 = Ht({
  prop: "gridColumn"
}), f3 = Ht({
  prop: "gridRow"
}), g3 = Ht({
  prop: "gridAutoFlow"
}), m3 = Ht({
  prop: "gridAutoColumns"
}), h3 = Ht({
  prop: "gridAutoRows"
}), b3 = Ht({
  prop: "gridTemplateColumns"
}), y3 = Ht({
  prop: "gridTemplateRows"
}), v3 = Ht({
  prop: "gridTemplateAreas"
}), E3 = Ht({
  prop: "gridArea"
});
Ju(ec, tc, nc, p3, f3, g3, m3, h3, b3, y3, v3, E3);
function oo(e, t) {
  return t === "grey" ? t : e;
}
const S3 = Ht({
  prop: "color",
  themeKey: "palette",
  transform: oo
}), x3 = Ht({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: oo
}), T3 = Ht({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: oo
});
Ju(S3, x3, T3);
function Kn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const w3 = Ht({
  prop: "width",
  transform: Kn
}), vv = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, a, i, s, u;
      const c = ((i = (a = (r = e.theme) == null ? void 0 : r.breakpoints) == null ? void 0 : a.values) == null ? void 0 : i[n]) || Xu[n];
      return c ? ((u = (s = e.theme) == null ? void 0 : s.breakpoints) == null ? void 0 : u.unit) !== "px" ? {
        maxWidth: `${c}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: c
      } : {
        maxWidth: Kn(n)
      };
    };
    return va(e, e.maxWidth, t);
  }
  return null;
};
vv.filterProps = ["maxWidth"];
const A3 = Ht({
  prop: "minWidth",
  transform: Kn
}), I3 = Ht({
  prop: "height",
  transform: Kn
}), R3 = Ht({
  prop: "maxHeight",
  transform: Kn
}), _3 = Ht({
  prop: "minHeight",
  transform: Kn
});
Ht({
  prop: "size",
  cssProperty: "width",
  transform: Kn
});
Ht({
  prop: "size",
  cssProperty: "height",
  transform: Kn
});
const C3 = Ht({
  prop: "boxSizing"
});
Ju(w3, vv, A3, I3, R3, _3, C3);
const Ls = {
  // borders
  border: {
    themeKey: "borders",
    transform: br
  },
  borderTop: {
    themeKey: "borders",
    transform: br
  },
  borderRight: {
    themeKey: "borders",
    transform: br
  },
  borderBottom: {
    themeKey: "borders",
    transform: br
  },
  borderLeft: {
    themeKey: "borders",
    transform: br
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: br
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Qu
  },
  // palette
  color: {
    themeKey: "palette",
    transform: oo
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: oo
  },
  backgroundColor: {
    themeKey: "palette",
    transform: oo
  },
  // spacing
  p: {
    style: Pt
  },
  pt: {
    style: Pt
  },
  pr: {
    style: Pt
  },
  pb: {
    style: Pt
  },
  pl: {
    style: Pt
  },
  px: {
    style: Pt
  },
  py: {
    style: Pt
  },
  padding: {
    style: Pt
  },
  paddingTop: {
    style: Pt
  },
  paddingRight: {
    style: Pt
  },
  paddingBottom: {
    style: Pt
  },
  paddingLeft: {
    style: Pt
  },
  paddingX: {
    style: Pt
  },
  paddingY: {
    style: Pt
  },
  paddingInline: {
    style: Pt
  },
  paddingInlineStart: {
    style: Pt
  },
  paddingInlineEnd: {
    style: Pt
  },
  paddingBlock: {
    style: Pt
  },
  paddingBlockStart: {
    style: Pt
  },
  paddingBlockEnd: {
    style: Pt
  },
  m: {
    style: Ft
  },
  mt: {
    style: Ft
  },
  mr: {
    style: Ft
  },
  mb: {
    style: Ft
  },
  ml: {
    style: Ft
  },
  mx: {
    style: Ft
  },
  my: {
    style: Ft
  },
  margin: {
    style: Ft
  },
  marginTop: {
    style: Ft
  },
  marginRight: {
    style: Ft
  },
  marginBottom: {
    style: Ft
  },
  marginLeft: {
    style: Ft
  },
  marginX: {
    style: Ft
  },
  marginY: {
    style: Ft
  },
  marginInline: {
    style: Ft
  },
  marginInlineStart: {
    style: Ft
  },
  marginInlineEnd: {
    style: Ft
  },
  marginBlock: {
    style: Ft
  },
  marginBlockStart: {
    style: Ft
  },
  marginBlockEnd: {
    style: Ft
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: ec
  },
  rowGap: {
    style: nc
  },
  columnGap: {
    style: tc
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Kn
  },
  maxWidth: {
    style: vv
  },
  minWidth: {
    transform: Kn
  },
  height: {
    transform: Kn
  },
  maxHeight: {
    transform: Kn
  },
  minHeight: {
    transform: Kn
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function k3(...e) {
  const t = e.reduce((r, a) => r.concat(Object.keys(a)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function N3(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function O3() {
  function e(n, r, a, i) {
    const s = {
      [n]: r,
      theme: a
    }, u = i[n];
    if (!u)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: d,
      transform: p,
      style: f
    } = u;
    if (r == null)
      return null;
    if (d === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const m = Zu(a, d) || {};
    return f ? f(s) : va(s, r, (h) => {
      let E = Eu(m, p, h);
      return h === E && typeof h == "string" && (E = Eu(m, p, `${n}${h === "default" ? "" : Nr(h)}`, h)), c === !1 ? E : {
        [c]: E
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: a = {}
    } = n || {};
    if (!r)
      return null;
    const i = a.unstable_sxConfig ?? Ls;
    function s(u) {
      let c = u;
      if (typeof u == "function")
        c = u(a);
      else if (typeof u != "object")
        return u;
      if (!c)
        return null;
      const d = V5(a.breakpoints), p = Object.keys(d);
      let f = d;
      return Object.keys(c).forEach((m) => {
        const h = N3(c[m], a);
        if (h != null)
          if (typeof h == "object")
            if (i[m])
              f = ss(f, e(m, h, a, i));
            else {
              const E = va({
                theme: a
              }, h, (y) => ({
                [m]: y
              }));
              k3(E, h) ? f[m] = t({
                sx: h,
                theme: a
              }) : f = ss(f, E);
            }
          else
            f = ss(f, e(m, h, a, i));
      }), j5(a, W5(p, f));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const go = O3();
go.filterProps = ["sx"];
const L3 = (e) => {
  var t;
  const n = {
    systemProps: {},
    otherProps: {}
  }, r = ((t = e?.theme) == null ? void 0 : t.unstable_sxConfig) ?? Ls;
  return Object.keys(e).forEach((a) => {
    r[a] ? n.systemProps[a] = e[a] : n.otherProps[a] = e[a];
  }), n;
};
function D3(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: a
  } = L3(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...s) => {
    const u = t(...s);
    return Yr(u) ? {
      ...r,
      ...u
    } : r;
  } : i = {
    ...r,
    ...t
  }, {
    ...a,
    sx: i
  };
}
function M3(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function F3(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var P3 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, i), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(F3(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = M3(r);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var r;
      return (r = n.parentNode) == null ? void 0 : r.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), gn = "-ms-", Su = "-moz-", We = "-webkit-", hN = "comm", Ev = "rule", Sv = "decl", B3 = "@import", bN = "@keyframes", $3 = "@layer", U3 = Math.abs, rc = String.fromCharCode, j3 = Object.assign;
function q3(e, t) {
  return un(e, 0) ^ 45 ? (((t << 2 ^ un(e, 0)) << 2 ^ un(e, 1)) << 2 ^ un(e, 2)) << 2 ^ un(e, 3) : 0;
}
function yN(e) {
  return e.trim();
}
function z3(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ye(e, t, n) {
  return e.replace(t, n);
}
function hy(e, t) {
  return e.indexOf(t);
}
function un(e, t) {
  return e.charCodeAt(t) | 0;
}
function bs(e, t, n) {
  return e.slice(t, n);
}
function Hr(e) {
  return e.length;
}
function xv(e) {
  return e.length;
}
function Dl(e, t) {
  return t.push(e), e;
}
function G3(e, t) {
  return e.map(t).join("");
}
var ac = 1, mo = 1, vN = 0, Ln = 0, Kt = 0, Eo = "";
function ic(e, t, n, r, a, i, s) {
  return { value: e, root: t, parent: n, type: r, props: a, children: i, line: ac, column: mo, length: s, return: "" };
}
function Vo(e, t) {
  return j3(ic("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function H3() {
  return Kt;
}
function V3() {
  return Kt = Ln > 0 ? un(Eo, --Ln) : 0, mo--, Kt === 10 && (mo = 1, ac--), Kt;
}
function Qn() {
  return Kt = Ln < vN ? un(Eo, Ln++) : 0, mo++, Kt === 10 && (mo = 1, ac++), Kt;
}
function Jr() {
  return un(Eo, Ln);
}
function au() {
  return Ln;
}
function Ds(e, t) {
  return bs(Eo, e, t);
}
function ys(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function EN(e) {
  return ac = mo = 1, vN = Hr(Eo = e), Ln = 0, [];
}
function SN(e) {
  return Eo = "", e;
}
function iu(e) {
  return yN(Ds(Ln - 1, by(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function W3(e) {
  for (; (Kt = Jr()) && Kt < 33; )
    Qn();
  return ys(e) > 2 || ys(Kt) > 3 ? "" : " ";
}
function K3(e, t) {
  for (; --t && Qn() && !(Kt < 48 || Kt > 102 || Kt > 57 && Kt < 65 || Kt > 70 && Kt < 97); )
    ;
  return Ds(e, au() + (t < 6 && Jr() == 32 && Qn() == 32));
}
function by(e) {
  for (; Qn(); )
    switch (Kt) {
      // ] ) " '
      case e:
        return Ln;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && by(Kt);
        break;
      // (
      case 40:
        e === 41 && by(e);
        break;
      // \
      case 92:
        Qn();
        break;
    }
  return Ln;
}
function Y3(e, t) {
  for (; Qn() && e + Kt !== 57 && !(e + Kt === 84 && Jr() === 47); )
    ;
  return "/*" + Ds(t, Ln - 1) + "*" + rc(e === 47 ? e : Qn());
}
function X3(e) {
  for (; !ys(Jr()); )
    Qn();
  return Ds(e, Ln);
}
function Z3(e) {
  return SN(ou("", null, null, null, [""], e = EN(e), 0, [0], e));
}
function ou(e, t, n, r, a, i, s, u, c) {
  for (var d = 0, p = 0, f = s, m = 0, h = 0, E = 0, y = 1, w = 1, x = 1, I = 0, S = "", C = a, T = i, A = r, O = S; w; )
    switch (E = I, I = Qn()) {
      // (
      case 40:
        if (E != 108 && un(O, f - 1) == 58) {
          hy(O += Ye(iu(I), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += iu(I);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += W3(E);
        break;
      // \
      case 92:
        O += K3(au() - 1, 7);
        continue;
      // /
      case 47:
        switch (Jr()) {
          case 42:
          case 47:
            Dl(J3(Y3(Qn(), au()), t, n), c);
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * y:
        u[d++] = Hr(O) * x;
      // } ; \0
      case 125 * y:
      case 59:
      case 0:
        switch (I) {
          // \0 }
          case 0:
          case 125:
            w = 0;
          // ;
          case 59 + p:
            x == -1 && (O = Ye(O, /\f/g, "")), h > 0 && Hr(O) - f && Dl(h > 32 ? WT(O + ";", r, n, f - 1) : WT(Ye(O, " ", "") + ";", r, n, f - 2), c);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (Dl(A = VT(O, t, n, d, p, a, u, S, C = [], T = [], f), i), I === 123)
              if (p === 0)
                ou(O, t, A, A, C, i, f, u, T);
              else
                switch (m === 99 && un(O, 3) === 110 ? 100 : m) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ou(e, A, A, r && Dl(VT(e, A, A, 0, 0, a, u, S, a, C = [], f), T), a, T, f, u, r ? C : T);
                    break;
                  default:
                    ou(O, A, A, A, [""], T, 0, u, T);
                }
        }
        d = p = h = 0, y = x = 1, S = O = "", f = s;
        break;
      // :
      case 58:
        f = 1 + Hr(O), h = E;
      default:
        if (y < 1) {
          if (I == 123)
            --y;
          else if (I == 125 && y++ == 0 && V3() == 125)
            continue;
        }
        switch (O += rc(I), I * y) {
          // &
          case 38:
            x = p > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            u[d++] = (Hr(O) - 1) * x, x = 1;
            break;
          // @
          case 64:
            Jr() === 45 && (O += iu(Qn())), m = Jr(), p = f = Hr(S = O += X3(au())), I++;
            break;
          // -
          case 45:
            E === 45 && Hr(O) == 2 && (y = 0);
        }
    }
  return i;
}
function VT(e, t, n, r, a, i, s, u, c, d, p) {
  for (var f = a - 1, m = a === 0 ? i : [""], h = xv(m), E = 0, y = 0, w = 0; E < r; ++E)
    for (var x = 0, I = bs(e, f + 1, f = U3(y = s[E])), S = e; x < h; ++x)
      (S = yN(y > 0 ? m[x] + " " + I : Ye(I, /&\f/g, m[x]))) && (c[w++] = S);
  return ic(e, t, n, a === 0 ? Ev : u, c, d, p);
}
function J3(e, t, n) {
  return ic(e, t, n, hN, rc(H3()), bs(e, 2, -2), 0);
}
function WT(e, t, n, r) {
  return ic(e, t, n, Sv, bs(e, 0, r), bs(e, r + 1, -1), r);
}
function so(e, t) {
  for (var n = "", r = xv(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function Q3(e, t, n, r) {
  switch (e.type) {
    case $3:
      if (e.children.length) break;
    case B3:
    case Sv:
      return e.return = e.return || e.value;
    case hN:
      return "";
    case bN:
      return e.return = e.value + "{" + so(e.children, r) + "}";
    case Ev:
      e.value = e.props.join(",");
  }
  return Hr(n = so(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function eH(e) {
  var t = xv(e);
  return function(n, r, a, i) {
    for (var s = "", u = 0; u < t; u++)
      s += e[u](n, r, a, i) || "";
    return s;
  };
}
function tH(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function xN(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var nH = function(e, t, n) {
  for (var r = 0, a = 0; r = a, a = Jr(), r === 38 && a === 12 && (t[n] = 1), !ys(a); )
    Qn();
  return Ds(e, Ln);
}, rH = function(e, t) {
  var n = -1, r = 44;
  do
    switch (ys(r)) {
      case 0:
        r === 38 && Jr() === 12 && (t[n] = 1), e[n] += nH(Ln - 1, t, n);
        break;
      case 2:
        e[n] += iu(r);
        break;
      case 4:
        if (r === 44) {
          e[++n] = Jr() === 58 ? "&\f" : "", t[n] = e[n].length;
          break;
        }
      // fallthrough
      default:
        e[n] += rc(r);
    }
  while (r = Qn());
  return e;
}, aH = function(e, t) {
  return SN(rH(EN(e), t));
}, KT = /* @__PURE__ */ new WeakMap(), iH = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !KT.get(n)) && !r) {
      KT.set(e, !0);
      for (var a = [], i = aH(t, a), s = n.props, u = 0, c = 0; u < i.length; u++)
        for (var d = 0; d < s.length; d++, c++)
          e.props[c] = a[u] ? i[u].replace(/&\f/g, s[d]) : s[d] + " " + i[u];
    }
  }
}, oH = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function TN(e, t) {
  switch (q3(e, t)) {
    // color-adjust
    case 5103:
      return We + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return We + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return We + e + Su + e + gn + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return We + e + gn + e + e;
    // order
    case 6165:
      return We + e + gn + "flex-" + e + e;
    // align-items
    case 5187:
      return We + e + Ye(e, /(\w+).+(:[^]+)/, We + "box-$1$2" + gn + "flex-$1$2") + e;
    // align-self
    case 5443:
      return We + e + gn + "flex-item-" + Ye(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return We + e + gn + "flex-line-pack" + Ye(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return We + e + gn + Ye(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return We + e + gn + Ye(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return We + "box-" + Ye(e, "-grow", "") + We + e + gn + Ye(e, "grow", "positive") + e;
    // transition
    case 4554:
      return We + Ye(e, /([^-])(transform)/g, "$1" + We + "$2") + e;
    // cursor
    case 6187:
      return Ye(Ye(Ye(e, /(zoom-|grab)/, We + "$1"), /(image-set)/, We + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Ye(e, /(image-set\([^]*)/, We + "$1$`$1");
    // justify-content
    case 4968:
      return Ye(Ye(e, /(.+:)(flex-)?(.*)/, We + "box-pack:$3" + gn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + We + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ye(e, /(.+)-inline(.+)/, We + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Hr(e) - 1 - t > 6) switch (un(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (un(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Ye(e, /(.+:)(.+)-([^]+)/, "$1" + We + "$2-$3$1" + Su + (un(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~hy(e, "stretch") ? TN(Ye(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (un(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (un(e, Hr(e) - 3 - (~hy(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Ye(e, ":", ":" + We) + e;
        // (inline-)?fl(e)x
        case 101:
          return Ye(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + We + (un(e, 14) === 45 ? "inline-" : "") + "box$3$1" + We + "$2$3$1" + gn + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (un(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return We + e + gn + Ye(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return We + e + gn + Ye(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return We + e + gn + Ye(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return We + e + gn + e + e;
  }
  return e;
}
var sH = function(e, t, n, r) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case Sv:
      e.return = TN(e.value, e.length);
      break;
    case bN:
      return so([Vo(e, {
        value: Ye(e.value, "@", "@" + We)
      })], r);
    case Ev:
      if (e.length) return G3(e.props, function(a) {
        switch (z3(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return so([Vo(e, {
              props: [Ye(a, /:(read-\w+)/, ":" + Su + "$1")]
            })], r);
          // :placeholder
          case "::placeholder":
            return so([Vo(e, {
              props: [Ye(a, /:(plac\w+)/, ":" + We + "input-$1")]
            }), Vo(e, {
              props: [Ye(a, /:(plac\w+)/, ":" + Su + "$1")]
            }), Vo(e, {
              props: [Ye(a, /:(plac\w+)/, gn + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, lH = [sH], uH = function(e) {
  var t = e.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(E) {
      var y = E.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var r = e.stylisPlugins || lH, a = {}, i, s = [];
  i = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(E) {
      for (var y = E.getAttribute("data-emotion").split(" "), w = 1; w < y.length; w++)
        a[y[w]] = !0;
      s.push(E);
    }
  );
  var u, c = [iH, oH];
  {
    var d, p = [Q3, tH(function(E) {
      d.insert(E);
    })], f = eH(c.concat(r, p)), m = function(E) {
      return so(Z3(E), f);
    };
    u = function(E, y, w, x) {
      d = w, m(E ? E + "{" + y.styles + "}" : y.styles), x && (h.inserted[y.name] = !0);
    };
  }
  var h = {
    key: t,
    sheet: new P3({
      key: t,
      container: i,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: u
  };
  return h.sheet.hydrate(s), h;
}, YT = { exports: {} }, et = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var XT;
function cH() {
  if (XT) return et;
  XT = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function S(T) {
    if (typeof T == "object" && T !== null) {
      var A = T.$$typeof;
      switch (A) {
        case t:
          switch (T = T.type, T) {
            case c:
            case d:
            case r:
            case i:
            case a:
            case f:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case u:
                case p:
                case E:
                case h:
                case s:
                  return T;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function C(T) {
    return S(T) === d;
  }
  return et.AsyncMode = c, et.ConcurrentMode = d, et.ContextConsumer = u, et.ContextProvider = s, et.Element = t, et.ForwardRef = p, et.Fragment = r, et.Lazy = E, et.Memo = h, et.Portal = n, et.Profiler = i, et.StrictMode = a, et.Suspense = f, et.isAsyncMode = function(T) {
    return C(T) || S(T) === c;
  }, et.isConcurrentMode = C, et.isContextConsumer = function(T) {
    return S(T) === u;
  }, et.isContextProvider = function(T) {
    return S(T) === s;
  }, et.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, et.isForwardRef = function(T) {
    return S(T) === p;
  }, et.isFragment = function(T) {
    return S(T) === r;
  }, et.isLazy = function(T) {
    return S(T) === E;
  }, et.isMemo = function(T) {
    return S(T) === h;
  }, et.isPortal = function(T) {
    return S(T) === n;
  }, et.isProfiler = function(T) {
    return S(T) === i;
  }, et.isStrictMode = function(T) {
    return S(T) === a;
  }, et.isSuspense = function(T) {
    return S(T) === f;
  }, et.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === d || T === i || T === a || T === f || T === m || typeof T == "object" && T !== null && (T.$$typeof === E || T.$$typeof === h || T.$$typeof === s || T.$$typeof === u || T.$$typeof === p || T.$$typeof === w || T.$$typeof === x || T.$$typeof === I || T.$$typeof === y);
  }, et.typeOf = S, et;
}
var ZT;
function dH() {
  return ZT || (ZT = 1, YT.exports = cH()), YT.exports;
}
var Vd, JT;
function pH() {
  if (JT) return Vd;
  JT = 1;
  var e = dH(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = r, i[e.Memo] = a;
  function s(E) {
    return e.isMemo(E) ? a : i[E.$$typeof] || t;
  }
  var u = Object.defineProperty, c = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, m = Object.prototype;
  function h(E, y, w) {
    if (typeof y != "string") {
      if (m) {
        var x = f(y);
        x && x !== m && h(E, x, w);
      }
      var I = c(y);
      d && (I = I.concat(d(y)));
      for (var S = s(E), C = s(y), T = 0; T < I.length; ++T) {
        var A = I[T];
        if (!n[A] && !(w && w[A]) && !(C && C[A]) && !(S && S[A])) {
          var O = p(y, A);
          try {
            u(E, A, O);
          } catch {
          }
        }
      }
    }
    return E;
  }
  return Vd = h, Vd;
}
pH();
var fH = !0;
function wN(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : a && (r += a + " ");
  }), r;
}
var Tv = function(e, t, n) {
  var r = e.key + "-" + t.name;
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  fH === !1) && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, AN = function(e, t, n) {
  Tv(e, t, n);
  var r = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var a = t;
    do
      e.insert(t === a ? "." + r : "", a, e.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function gH(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var mH = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hH = /[A-Z]|^ms/g, bH = /_EMO_([^_]+?)_([^]*?)_EMO_/g, IN = function(e) {
  return e.charCodeAt(1) === 45;
}, QT = function(e) {
  return e != null && typeof e != "boolean";
}, Wd = /* @__PURE__ */ xN(function(e) {
  return IN(e) ? e : e.replace(hH, "-$&").toLowerCase();
}), ew = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(bH, function(n, r, a) {
          return Vr = {
            name: r,
            styles: a,
            next: Vr
          }, r;
        });
  }
  return mH[e] !== 1 && !IN(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function vs(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var a = n;
      if (a.anim === 1)
        return Vr = {
          name: a.name,
          styles: a.styles,
          next: Vr
        }, a.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Vr = {
              name: s.name,
              styles: s.styles,
              next: Vr
            }, s = s.next;
        var u = i.styles + ";";
        return u;
      }
      return yH(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Vr, d = n(e);
        return Vr = c, vs(e, t, d);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var f = t[p];
  return f !== void 0 ? f : p;
}
function yH(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += vs(e, t, n[a]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var u = s;
        t != null && t[u] !== void 0 ? r += i + "{" + t[u] + "}" : QT(u) && (r += Wd(i) + ":" + ew(i, u) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          QT(s[c]) && (r += Wd(i) + ":" + ew(i, s[c]) + ";");
      else {
        var d = vs(e, t, s);
        switch (i) {
          case "animation":
          case "animationName": {
            r += Wd(i) + ":" + d + ";";
            break;
          }
          default:
            r += i + "{" + d + "}";
        }
      }
    }
  return r;
}
var tw = /label:\s*([^\s;{]+)\s*(;|$)/g, Vr;
function oc(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, a = "";
  Vr = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, a += vs(n, t, i);
  else {
    var s = i;
    a += s[0];
  }
  for (var u = 1; u < e.length; u++)
    if (a += vs(n, t, e[u]), r) {
      var c = i;
      a += c[u];
    }
  tw.lastIndex = 0;
  for (var d = "", p; (p = tw.exec(a)) !== null; )
    d += "-" + p[1];
  var f = gH(a) + d;
  return {
    name: f,
    styles: a,
    next: Vr
  };
}
var vH = function(e) {
  return e();
}, EH = B.useInsertionEffect ? B.useInsertionEffect : !1, RN = EH || vH, _N = /* @__PURE__ */ B.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ uH({
    key: "css"
  }) : null
);
_N.Provider;
var CN = function(e) {
  return /* @__PURE__ */ _u(function(t, n) {
    var r = nr(_N);
    return e(t, r, n);
  });
}, wv = /* @__PURE__ */ B.createContext({}), Av = {}.hasOwnProperty, yy = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", SH = function(e, t) {
  var n = {};
  for (var r in t)
    Av.call(t, r) && (n[r] = t[r]);
  return n[yy] = e, n;
}, xH = function(e) {
  var t = e.cache, n = e.serialized, r = e.isStringTag;
  return Tv(t, n, r), RN(function() {
    return AN(t, n, r);
  }), null;
}, TH = /* @__PURE__ */ CN(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var a = e[yy], i = [r], s = "";
  typeof e.className == "string" ? s = wN(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var u = oc(i, void 0, B.useContext(wv));
  s += t.key + "-" + u.name;
  var c = {};
  for (var d in e)
    Av.call(e, d) && d !== "css" && d !== yy && (c[d] = e[d]);
  return c.className = s, n && (c.ref = n), /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(xH, {
    cache: t,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ B.createElement(a, c));
}), wH = TH, nw = function(e, t) {
  var n = arguments;
  if (t == null || !Av.call(t, "css"))
    return B.createElement.apply(void 0, n);
  var r = n.length, a = new Array(r);
  a[0] = wH, a[1] = SH(e, t);
  for (var i = 2; i < r; i++)
    a[i] = n[i];
  return B.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(nw || (nw = {}));
function AH() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return oc(t);
}
function Iv() {
  var e = AH.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var IH = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, RH = /* @__PURE__ */ xN(
  function(e) {
    return IH.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), _H = RH, CH = function(e) {
  return e !== "theme";
}, rw = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? _H : CH;
}, aw = function(e, t, n) {
  var r;
  if (t) {
    var a = t.shouldForwardProp;
    r = e.__emotion_forwardProp && a ? function(i) {
      return e.__emotion_forwardProp(i) && a(i);
    } : a;
  }
  return typeof r != "function" && n && (r = e.__emotion_forwardProp), r;
}, kH = function(e) {
  var t = e.cache, n = e.serialized, r = e.isStringTag;
  return Tv(t, n, r), RN(function() {
    return AN(t, n, r);
  }), null;
}, NH = function e(t, n) {
  var r = t.__emotion_real === t, a = r && t.__emotion_base || t, i, s;
  n !== void 0 && (i = n.label, s = n.target);
  var u = aw(t, n, r), c = u || rw(a), d = !c("as");
  return function() {
    var p = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), p[0] == null || p[0].raw === void 0)
      f.push.apply(f, p);
    else {
      var m = p[0];
      f.push(m[0]);
      for (var h = p.length, E = 1; E < h; E++)
        f.push(p[E], m[E]);
    }
    var y = CN(function(w, x, I) {
      var S = d && w.as || a, C = "", T = [], A = w;
      if (w.theme == null) {
        A = {};
        for (var O in w)
          A[O] = w[O];
        A.theme = B.useContext(wv);
      }
      typeof w.className == "string" ? C = wN(x.registered, T, w.className) : w.className != null && (C = w.className + " ");
      var U = oc(f.concat(T), x.registered, A);
      C += x.key + "-" + U.name, s !== void 0 && (C += " " + s);
      var P = d && u === void 0 ? rw(S) : c, b = {};
      for (var L in w)
        d && L === "as" || P(L) && (b[L] = w[L]);
      return b.className = C, I && (b.ref = I), /* @__PURE__ */ B.createElement(B.Fragment, null, /* @__PURE__ */ B.createElement(kH, {
        cache: x,
        serialized: U,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ B.createElement(S, b));
    });
    return y.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = a, y.__emotion_styles = f, y.__emotion_forwardProp = u, Object.defineProperty(y, "toString", {
      value: function() {
        return "." + s;
      }
    }), y.withComponent = function(w, x) {
      var I = e(w, ve({}, n, x, {
        shouldForwardProp: aw(y, x, !0)
      }));
      return I.apply(void 0, f);
    }, y;
  };
}, OH = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], vy = NH.bind(null);
OH.forEach(function(e) {
  vy[e] = vy(e);
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function LH(e, t) {
  return vy(e, t);
}
function DH(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const iw = [];
function ow(e) {
  return iw[0] = e, oc(iw);
}
const MH = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function FH(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...a
  } = e, i = MH(t), s = Object.keys(i);
  function u(m) {
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n})`;
  }
  function c(m) {
    return `@media (max-width:${(typeof t[m] == "number" ? t[m] : m) - r / 100}${n})`;
  }
  function d(m, h) {
    const E = s.indexOf(h);
    return `@media (min-width:${typeof t[m] == "number" ? t[m] : m}${n}) and (max-width:${(E !== -1 && typeof t[s[E]] == "number" ? t[s[E]] : h) - r / 100}${n})`;
  }
  function p(m) {
    return s.indexOf(m) + 1 < s.length ? d(m, s[s.indexOf(m) + 1]) : u(m);
  }
  function f(m) {
    const h = s.indexOf(m);
    return h === 0 ? u(s[1]) : h === s.length - 1 ? c(s[h]) : d(m, s[s.indexOf(m) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: i,
    up: u,
    down: c,
    between: d,
    only: p,
    not: f,
    unit: n,
    ...a
  };
}
const PH = {
  borderRadius: 4
};
function kN(e = 8, t = yv({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (r.length === 0 ? [1] : r).map((a) => {
    const i = t(a);
    return typeof i == "number" ? `${i}px` : i;
  }).join(" ");
  return n.mui = !0, n;
}
function BH(e, t) {
  var n;
  const r = this;
  if (r.vars) {
    if (!((n = r.colorSchemes) != null && n[e]) || typeof r.getColorSchemeSelector != "function")
      return {};
    let a = r.getColorSchemeSelector(e);
    return a === "&" ? t : ((a.includes("data-") || a.includes(".")) && (a = `*:where(${a.replace(/\s*&$/, "")}) &`), {
      [a]: t
    });
  }
  return r.palette.mode === e ? t : {};
}
function sc(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: a,
    shape: i = {},
    ...s
  } = e, u = FH(n), c = kN(a);
  let d = Jn({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: c,
    shape: {
      ...PH,
      ...i
    }
  }, s);
  return d = G5(d), d.applyStyles = BH, d = t.reduce((p, f) => Jn(p, f), d), d.unstable_sxConfig = {
    ...Ls,
    ...s?.unstable_sxConfig
  }, d.unstable_sx = function(p) {
    return go({
      sx: p,
      theme: this
    });
  }, d;
}
function $H(e) {
  return Object.keys(e).length === 0;
}
function UH(e = null) {
  const t = B.useContext(wv);
  return !t || $H(t) ? e : t;
}
const jH = sc();
function Rv(e = jH) {
  return UH(e);
}
function NN(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: ow(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((a) => {
    typeof a.style != "function" && (a.style = ow(a.style));
  }), r;
}
const qH = sc();
function lo(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function zH(e) {
  return e ? (t, n) => n[e] : null;
}
function GH(e, t, n) {
  e.theme = VH(e.theme) ? n : e.theme[t] || e.theme;
}
function su(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => su(e, r));
  if (Array.isArray(n?.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: a,
        ...i
      } = n;
      r = i;
    }
    return ON(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function ON(e, t, n = []) {
  var r;
  let a;
  e: for (let i = 0; i < t.length; i += 1) {
    const s = t[i];
    if (typeof s.props == "function") {
      if (a ?? (a = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !s.props(a))
        continue;
    } else
      for (const u in s.props)
        if (e[u] !== s.props[u] && ((r = e.ownerState) == null ? void 0 : r[u]) !== s.props[u])
          continue e;
    typeof s.style == "function" ? (a ?? (a = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(s.style(a))) : n.push(s.style);
  }
  return n;
}
function LN(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = qH,
    rootShouldForwardProp: r = lo,
    slotShouldForwardProp: a = lo
  } = e;
  function i(s) {
    GH(s, t, n);
  }
  return (s, u = {}) => {
    DH(s, (C) => C.filter((T) => T !== go));
    const {
      name: c,
      slot: d,
      skipVariantsResolver: p,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: m = zH(KH(d)),
      ...h
    } = u, E = p !== void 0 ? p : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), y = f || !1;
    let w = lo;
    d === "Root" || d === "root" ? w = r : d ? w = a : WH(s) && (w = void 0);
    const x = LH(s, {
      shouldForwardProp: w,
      label: HH(),
      ...h
    }), I = (C) => {
      if (typeof C == "function" && C.__emotion_real !== C)
        return function(T) {
          return su(T, C);
        };
      if (Yr(C)) {
        const T = NN(C);
        return T.variants ? function(A) {
          return su(A, T);
        } : T.style;
      }
      return C;
    }, S = (...C) => {
      const T = [], A = C.map(I), O = [];
      if (T.push(i), c && m && O.push(function(b) {
        var L, j;
        const G = (j = (L = b.theme.components) == null ? void 0 : L[c]) == null ? void 0 : j.styleOverrides;
        if (!G)
          return null;
        const H = {};
        for (const ne in G)
          H[ne] = su(b, G[ne]);
        return m(b, H);
      }), c && !E && O.push(function(b) {
        var L, j;
        const G = b.theme, H = (j = (L = G?.components) == null ? void 0 : L[c]) == null ? void 0 : j.variants;
        return H ? ON(b, H) : null;
      }), y || O.push(go), Array.isArray(A[0])) {
        const b = A.shift(), L = new Array(T.length).fill(""), j = new Array(O.length).fill("");
        let G;
        G = [...L, ...b, ...j], G.raw = [...L, ...b.raw, ...j], T.unshift(G);
      }
      const U = [...T, ...A, ...O], P = x(...U);
      return s.muiName && (P.muiName = s.muiName), P;
    };
    return x.withConfig && (S.withConfig = x.withConfig), S;
  };
}
function HH(e, t) {
  return void 0;
}
function VH(e) {
  for (const t in e)
    return !1;
  return !0;
}
function WH(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function KH(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const YH = LN();
function xu(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const a = r;
      if (a === "components" || a === "slots")
        n[a] = {
          ...e[a],
          ...n[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const i = e[a], s = t[a];
        if (!s)
          n[a] = i || {};
        else if (!i)
          n[a] = s;
        else {
          n[a] = {
            ...s
          };
          for (const u in i)
            if (Object.prototype.hasOwnProperty.call(i, u)) {
              const c = u;
              n[a][c] = xu(i[c], s[c]);
            }
        }
      } else n[a] === void 0 && (n[a] = e[a]);
    }
  return n;
}
function XH(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : xu(t.components[n].defaultProps, r);
}
function ZH({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let a = Rv(n);
  return r && (a = a[r] || a), XH({
    theme: a,
    name: t,
    props: e
  });
}
function JH(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function _v(e, t = 0, n = 1) {
  return JH(e, t, n);
}
function QH(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, a) => a < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Va(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Va(QH(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(wi(9, e));
  let r = e.substring(t + 1, e.length - 1), a;
  if (n === "color") {
    if (r = r.split(" "), a = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(a))
      throw new Error(wi(10, a));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: a
  };
}
const e4 = (e) => {
  const t = Va(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, rs = (e, t) => {
  try {
    return e4(e);
  } catch {
    return e;
  }
};
function lc(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((a, i) => i < 3 ? parseInt(a, 10) : a) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function DN(e) {
  e = Va(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, a = t[2] / 100, i = r * Math.min(a, 1 - a), s = (d, p = (d + n / 30) % 12) => a - i * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let u = "rgb";
  const c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (u += "a", c.push(t[3])), lc({
    type: u,
    values: c
  });
}
function Ey(e) {
  e = Va(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Va(DN(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function t4(e, t) {
  const n = Ey(e), r = Ey(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Sy(e, t) {
  return e = Va(e), t = _v(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, lc(e);
}
function Ml(e, t, n) {
  try {
    return Sy(e, t);
  } catch {
    return e;
  }
}
function Cv(e, t) {
  if (e = Va(e), t = _v(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return lc(e);
}
function ct(e, t, n) {
  try {
    return Cv(e, t);
  } catch {
    return e;
  }
}
function kv(e, t) {
  if (e = Va(e), t = _v(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return lc(e);
}
function dt(e, t, n) {
  try {
    return kv(e, t);
  } catch {
    return e;
  }
}
function n4(e, t = 0.15) {
  return Ey(e) > 0.5 ? Cv(e, t) : kv(e, t);
}
function Fl(e, t, n) {
  try {
    return n4(e, t);
  } catch {
    return e;
  }
}
io.oneOfType([io.func, io.object]);
function r4(e, t) {
  var n, r, a;
  return /* @__PURE__ */ B.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((a = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : a.muiName)
  ) !== -1;
}
function a4({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: a
  } = B.useRef(e !== void 0), [i, s] = B.useState(t), u = a ? e : i, c = B.useCallback((d) => {
    a || s(d);
  }, []);
  return [u, c];
}
function sw(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
const i4 = /* @__PURE__ */ B.createContext(void 0);
function o4(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const a = t.components[n];
  return a.defaultProps ? xu(a.defaultProps, r) : !a.styleOverrides && !a.variants ? xu(a, r) : r;
}
function s4({
  props: e,
  name: t
}) {
  const n = B.useContext(i4);
  return o4({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const lw = {
  theme: void 0
};
function l4(e) {
  let t, n;
  return function(r) {
    let a = t;
    return (a === void 0 || r.theme !== n) && (lw.theme = r.theme, a = NN(e(lw)), t = a, n = r.theme), a;
  };
}
function u4(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const r = n[0];
    return typeof r == "string" && !r.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${r}${t(...n.slice(1))})` : `, ${r}`;
  }
  return (n, ...r) => `var(--${e ? `${e}-` : ""}${n}${t(...r)})`;
}
const uw = (e, t, n, r = []) => {
  let a = e;
  t.forEach((i, s) => {
    s === t.length - 1 ? Array.isArray(a) ? a[Number(i)] = n : a && typeof a == "object" && (a[i] = n) : a && typeof a == "object" && (a[i] || (a[i] = r.includes(i) ? [] : {}), a = a[i]);
  });
}, c4 = (e, t, n) => {
  function r(a, i = [], s = []) {
    Object.entries(a).forEach(([u, c]) => {
      (!n || n && !n([...i, u])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? r(c, [...i, u], Array.isArray(c) ? [...s, u] : s) : t([...i, u], c, s));
    });
  }
  r(e);
}, d4 = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Kd(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, a = {}, i = {}, s = {};
  return c4(
    e,
    (u, c, d) => {
      if ((typeof c == "string" || typeof c == "number") && (!r || !r(u, c))) {
        const p = `--${n ? `${n}-` : ""}${u.join("-")}`, f = d4(u, c);
        Object.assign(a, {
          [p]: f
        }), uw(i, u, `var(${p})`, d), uw(s, u, `var(${p}, ${f})`, d);
      }
    },
    (u) => u[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: a,
    vars: i,
    varsWithDefaults: s
  };
}
function p4(e, t = {}) {
  const {
    getSelector: n = w,
    disableCssColorScheme: r,
    colorSchemeSelector: a
  } = t, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: u = "light",
    ...c
  } = e, {
    vars: d,
    css: p,
    varsWithDefaults: f
  } = Kd(c, t);
  let m = f;
  const h = {}, {
    [u]: E,
    ...y
  } = i;
  if (Object.entries(y || {}).forEach(([x, I]) => {
    const {
      vars: S,
      css: C,
      varsWithDefaults: T
    } = Kd(I, t);
    m = Jn(m, T), h[x] = {
      css: C,
      vars: S
    };
  }), E) {
    const {
      css: x,
      vars: I,
      varsWithDefaults: S
    } = Kd(E, t);
    m = Jn(m, S), h[u] = {
      css: x,
      vars: I
    };
  }
  function w(x, I) {
    var S, C;
    let T = a;
    if (a === "class" && (T = ".%s"), a === "data" && (T = "[data-%s]"), a != null && a.startsWith("data-") && !a.includes("%s") && (T = `[${a}="%s"]`), x) {
      if (T === "media")
        return e.defaultColorScheme === x ? ":root" : {
          [`@media (prefers-color-scheme: ${((C = (S = i[x]) == null ? void 0 : S.palette) == null ? void 0 : C.mode) || x})`]: {
            ":root": I
          }
        };
      if (T)
        return e.defaultColorScheme === x ? `:root, ${T.replace("%s", String(x))}` : T.replace("%s", String(x));
    }
    return ":root";
  }
  return {
    vars: m,
    generateThemeVars: () => {
      let x = {
        ...d
      };
      return Object.entries(h).forEach(([, {
        vars: I
      }]) => {
        x = Jn(x, I);
      }), x;
    },
    generateStyleSheets: () => {
      var x, I;
      const S = [], C = e.defaultColorScheme || "light";
      function T(U, P) {
        Object.keys(P).length && S.push(typeof U == "string" ? {
          [U]: {
            ...P
          }
        } : U);
      }
      T(n(void 0, {
        ...p
      }), p);
      const {
        [C]: A,
        ...O
      } = h;
      if (A) {
        const {
          css: U
        } = A, P = (I = (x = i[C]) == null ? void 0 : x.palette) == null ? void 0 : I.mode, b = !r && P ? {
          colorScheme: P,
          ...U
        } : {
          ...U
        };
        T(n(C, {
          ...b
        }), b);
      }
      return Object.entries(O).forEach(([U, {
        css: P
      }]) => {
        var b, L;
        const j = (L = (b = i[U]) == null ? void 0 : b.palette) == null ? void 0 : L.mode, G = !r && j ? {
          colorScheme: j,
          ...P
        } : {
          ...P
        };
        T(n(U, {
          ...G
        }), G);
      }), S;
    }
  };
}
function f4(e) {
  return function(t) {
    return e === "media" ? `@media (prefers-color-scheme: ${t})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${t}"] &` : e === "class" ? `.${t} &` : e === "data" ? `[data-${t}] &` : `${e.replace("%s", t)} &` : "&";
  };
}
const g4 = (e, t) => e.filter((n) => t.includes(n)), So = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((a, i) => {
    n((s, u) => {
      i <= e.keys.length - 1 && (i === 0 ? Object.assign(s, u) : s[e.up(e.keys[i])] = u);
    }, a);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : g4(e.keys, Object.keys(t))).forEach((a) => {
    if (e.keys.includes(a)) {
      const i = t[a];
      i !== void 0 && n((s, u) => {
        r === a ? Object.assign(s, u) : s[e.up(a)] = u;
      }, i);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((a, i) => {
    Object.assign(a, i);
  }, t);
};
function Tu(e) {
  return `--Grid-${e}Spacing`;
}
function uc(e) {
  return `--Grid-parent-${e}Spacing`;
}
const cw = "--Grid-columns", uo = "--Grid-parent-columns", m4 = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return So(e.breakpoints, t.size, (r, a) => {
    let i = {};
    a === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), a === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof a == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${a} / var(${uo}) - (var(${uo}) - ${a}) * (var(${uc("column")}) / var(${uo})))`
    }), r(n, i);
  }), n;
}, h4 = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return So(e.breakpoints, t.offset, (r, a) => {
    let i = {};
    a === "auto" && (i = {
      marginLeft: "auto"
    }), typeof a == "number" && (i = {
      marginLeft: a === 0 ? "0px" : `calc(100% * ${a} / var(${uo}) + var(${uc("column")}) * ${a} / var(${uo}))`
    }), r(n, i);
  }), n;
}, b4 = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [cw]: 12
  };
  return So(e.breakpoints, t.columns, (r, a) => {
    const i = a ?? 12;
    r(n, {
      [cw]: i,
      "> *": {
        [uo]: i
      }
    });
  }), n;
}, y4 = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return So(e.breakpoints, t.rowSpacing, (r, a) => {
    var i;
    const s = typeof a == "string" ? a : (i = e.spacing) == null ? void 0 : i.call(e, a);
    r(n, {
      [Tu("row")]: s,
      "> *": {
        [uc("row")]: s
      }
    });
  }), n;
}, v4 = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return So(e.breakpoints, t.columnSpacing, (r, a) => {
    var i;
    const s = typeof a == "string" ? a : (i = e.spacing) == null ? void 0 : i.call(e, a);
    r(n, {
      [Tu("column")]: s,
      "> *": {
        [uc("column")]: s
      }
    });
  }), n;
}, E4 = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return So(e.breakpoints, t.direction, (r, a) => {
    r(n, {
      flexDirection: a
    });
  }), n;
}, S4 = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${Tu("row")}) var(${Tu("column")})`
  }
}), x4 = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, T4 = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([a, i]) => {
      n(i) && r.push(`spacing-${a}-${String(i)}`);
    }), r;
  }
  return [];
}, w4 = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], A4 = sc(), I4 = YH("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function R4(e) {
  return ZH({
    props: e,
    name: "MuiGrid",
    defaultTheme: A4
  });
}
function _4(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = I4,
    useThemeProps: n = R4,
    useTheme: r = Rv,
    componentName: a = "MuiGrid"
  } = e, i = (d, p) => {
    const {
      container: f,
      direction: m,
      spacing: h,
      wrap: E,
      size: y
    } = d, w = {
      root: ["root", f && "container", E !== "wrap" && `wrap-xs-${String(E)}`, ...w4(m), ...x4(y), ...f ? T4(h, p.breakpoints.keys[0]) : []]
    };
    return Ka(w, (x) => Sa(a, x), {});
  };
  function s(d, p, f = () => !0) {
    const m = {};
    return d === null || (Array.isArray(d) ? d.forEach((h, E) => {
      h !== null && f(h) && p.keys[E] && (m[p.keys[E]] = h);
    }) : typeof d == "object" ? Object.keys(d).forEach((h) => {
      const E = d[h];
      E != null && f(E) && (m[h] = E);
    }) : m[p.keys[0]] = d), m;
  }
  const u = t(b4, v4, y4, m4, E4, S4, h4), c = /* @__PURE__ */ B.forwardRef(function(d, p) {
    const f = r(), m = n(d), h = D3(m), {
      className: E,
      children: y,
      columns: w = 12,
      container: x = !1,
      component: I = "div",
      direction: S = "row",
      wrap: C = "wrap",
      size: T = {},
      offset: A = {},
      spacing: O = 0,
      rowSpacing: U = O,
      columnSpacing: P = O,
      unstable_level: b = 0,
      ...L
    } = h, j = s(T, f.breakpoints, (D) => D !== !1), G = s(A, f.breakpoints), H = d.columns ?? (b ? void 0 : w), ne = d.spacing ?? (b ? void 0 : O), ue = d.rowSpacing ?? d.spacing ?? (b ? void 0 : U), ce = d.columnSpacing ?? d.spacing ?? (b ? void 0 : P), Q = {
      ...h,
      level: b,
      columns: H,
      container: x,
      direction: S,
      wrap: C,
      spacing: ne,
      rowSpacing: ue,
      columnSpacing: ce,
      size: j,
      offset: G
    }, de = i(Q, f);
    return /* @__PURE__ */ V.jsx(u, {
      ref: p,
      as: I,
      ownerState: Q,
      className: Qt(de.root, E),
      ...L,
      children: B.Children.map(y, (D) => {
        var le;
        return /* @__PURE__ */ B.isValidElement(D) && r4(D, ["Grid"]) && x && D.props.container ? /* @__PURE__ */ B.cloneElement(D, {
          unstable_level: ((le = D.props) == null ? void 0 : le.unstable_level) ?? b + 1
        }) : D;
      })
    });
  });
  return c.muiName = "Grid", c;
}
const Es = {
  black: "#000",
  white: "#fff"
}, lu = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Fa = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2",
  800: "#6a1b9a"
}, Ki = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Wo = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, yr = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  500: "#2196f3",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A700: "#2962ff"
}, Yi = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Pa = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function MN() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Es.white,
      default: Es.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const C4 = MN();
function FN() {
  return {
    text: {
      primary: Es.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Es.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dw = FN();
function pw(e, t, n, r) {
  const a = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = kv(e.main, a) : t === "dark" && (e.dark = Cv(e.main, i)));
}
function k4(e = "light") {
  return e === "dark" ? {
    main: yr[200],
    light: yr[50],
    dark: yr[400]
  } : {
    main: yr[700],
    light: yr[400],
    dark: yr[800]
  };
}
function N4(e = "light") {
  return e === "dark" ? {
    main: Fa[200],
    light: Fa[50],
    dark: Fa[400]
  } : {
    main: Fa[500],
    light: Fa[300],
    dark: Fa[700]
  };
}
function O4(e = "light") {
  return e === "dark" ? {
    main: Ki[500],
    light: Ki[300],
    dark: Ki[700]
  } : {
    main: Ki[700],
    light: Ki[400],
    dark: Ki[800]
  };
}
function L4(e = "light") {
  return e === "dark" ? {
    main: Yi[400],
    light: Yi[300],
    dark: Yi[700]
  } : {
    main: Yi[700],
    light: Yi[500],
    dark: Yi[900]
  };
}
function D4(e = "light") {
  return e === "dark" ? {
    main: Pa[400],
    light: Pa[300],
    dark: Pa[700]
  } : {
    main: Pa[800],
    light: Pa[500],
    dark: Pa[900]
  };
}
function M4(e = "light") {
  return e === "dark" ? {
    main: Wo[400],
    light: Wo[300],
    dark: Wo[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Wo[500],
    dark: Wo[900]
  };
}
function Nv(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...a
  } = e, i = e.primary || k4(t), s = e.secondary || N4(t), u = e.error || O4(t), c = e.info || L4(t), d = e.success || D4(t), p = e.warning || M4(t);
  function f(E) {
    return t4(E, dw.text.primary) >= n ? dw.text.primary : C4.text.primary;
  }
  const m = ({
    color: E,
    name: y,
    mainShade: w = 500,
    lightShade: x = 300,
    darkShade: I = 700
  }) => {
    if (E = {
      ...E
    }, !E.main && E[w] && (E.main = E[w]), !E.hasOwnProperty("main"))
      throw new Error(wi(11, y ? ` (${y})` : "", w));
    if (typeof E.main != "string")
      throw new Error(wi(12, y ? ` (${y})` : "", JSON.stringify(E.main)));
    return pw(E, "light", x, r), pw(E, "dark", I, r), E.contrastText || (E.contrastText = f(E.main)), E;
  };
  let h;
  return t === "light" ? h = MN() : t === "dark" && (h = FN()), Jn({
    // A collection of common colors.
    common: {
      ...Es
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: m({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: m({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: m({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: m({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: m({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: m({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: lu,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: m,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...h
  }, a);
}
function F4(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [r, a] = n;
    typeof a == "object" && (t[r] = `${a.fontStyle ? `${a.fontStyle} ` : ""}${a.fontVariant ? `${a.fontVariant} ` : ""}${a.fontWeight ? `${a.fontWeight} ` : ""}${a.fontStretch ? `${a.fontStretch} ` : ""}${a.fontSize || ""}${a.lineHeight ? `/${a.lineHeight} ` : ""}${a.fontFamily || ""}`);
  }), t;
}
function P4(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function B4(e) {
  return Math.round(e * 1e5) / 1e5;
}
const fw = {
  textTransform: "uppercase"
}, gw = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4(e, t) {
  const {
    fontFamily: n = gw,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: p,
    ...f
  } = typeof t == "function" ? t(e) : t, m = r / 14, h = p || ((w) => `${w / c * m}rem`), E = (w, x, I, S, C) => ({
    fontFamily: n,
    fontWeight: w,
    fontSize: h(x),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: I,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === gw ? {
      letterSpacing: `${B4(S / x)}em`
    } : {},
    ...C,
    ...d
  }), y = {
    h1: E(a, 96, 1.167, -1.5),
    h2: E(a, 60, 1.2, -0.5),
    h3: E(i, 48, 1.167, 0),
    h4: E(i, 34, 1.235, 0.25),
    h5: E(i, 24, 1.334, 0),
    h6: E(s, 20, 1.6, 0.15),
    subtitle1: E(i, 16, 1.75, 0.15),
    subtitle2: E(s, 14, 1.57, 0.1),
    body1: E(i, 16, 1.5, 0.15),
    body2: E(i, 14, 1.43, 0.15),
    button: E(s, 14, 1.75, 0.4, fw),
    caption: E(i, 12, 1.66, 0.4),
    overline: E(i, 12, 2.66, 1, fw),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Jn({
    htmlFontSize: c,
    pxToRem: h,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: a,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: u,
    ...y
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const U4 = 0.2, j4 = 0.14, q4 = 0.12;
function At(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${U4})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${j4})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${q4})`].join(",");
}
const z4 = ["none", At(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), At(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), At(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), At(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), At(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), At(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), At(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), At(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), At(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), At(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), At(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), At(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), At(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), At(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), At(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), At(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), At(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), At(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), At(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), At(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), At(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), At(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), At(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), At(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], G4 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, PN = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function mw(e) {
  return `${Math.round(e)}ms`;
}
function H4(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function V4(e) {
  const t = {
    ...G4,
    ...e.easing
  }, n = {
    ...PN,
    ...e.duration
  };
  return {
    getAutoHeightDuration: H4,
    create: (r = ["all"], a = {}) => {
      const {
        duration: i = n.standard,
        easing: s = t.easeInOut,
        delay: u = 0,
        ...c
      } = a;
      return (Array.isArray(r) ? r : [r]).map((d) => `${d} ${typeof i == "string" ? i : mw(i)} ${s} ${typeof u == "string" ? u : mw(u)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const W4 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function K4(e) {
  return Yr(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function BN(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const a = Object.entries(r);
    for (let i = 0; i < a.length; i++) {
      const [s, u] = a[i];
      !K4(u) || s.startsWith("unstable_") ? delete r[s] : Yr(u) && (r[s] = {
        ...u
      }, n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function xy(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: a,
    palette: i = {},
    transitions: s = {},
    typography: u = {},
    shape: c,
    ...d
  } = e;
  if (e.vars)
    throw new Error(wi(20));
  const p = Nv(i), f = sc(e);
  let m = Jn(f, {
    mixins: P4(f.breakpoints, r),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: z4.slice(),
    typography: $4(p, u),
    transitions: V4(s),
    zIndex: {
      ...W4
    }
  });
  return m = Jn(m, d), m = t.reduce((h, E) => Jn(h, E), m), m.unstable_sxConfig = {
    ...Ls,
    ...d?.unstable_sxConfig
  }, m.unstable_sx = function(h) {
    return go({
      sx: h,
      theme: this
    });
  }, m.toRuntimeSource = BN, m;
}
function Y4(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const X4 = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Y4(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function $N(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function UN(e) {
  return e === "dark" ? X4 : [];
}
function Z4(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...a
  } = e, i = Nv(t);
  return {
    palette: i,
    opacity: {
      ...$N(i.mode),
      ...n
    },
    overlays: r || UN(i.mode),
    ...a
  };
}
function J4(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Q4 = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], eV = (e) => (t, n) => {
  const r = e.rootSelector || ":root", a = e.colorSchemeSelector;
  let i = a;
  if (a === "class" && (i = ".%s"), a === "data" && (i = "[data-%s]"), a != null && a.startsWith("data-") && !a.includes("%s") && (i = `[${a}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Q4(e.cssVarPrefix).forEach((u) => {
        s[u] = n[u], delete n[u];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : i ? {
        [i.replace("%s", t)]: s,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...s
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function tV(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function Z(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function as(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : DN(e);
}
function da(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = rs(as(e[t])));
}
function nV(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const $r = (e) => {
  try {
    return e();
  } catch {
  }
}, rV = (e = "mui") => u4(e);
function Yd(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const a = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = Z4({
      ...t,
      palette: {
        mode: a,
        ...t?.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...s
  } = xy({
    ...n,
    palette: {
      mode: a,
      ...t?.palette
    }
  });
  return e[r] = {
    ...t,
    palette: i,
    opacity: {
      ...$N(a),
      ...t?.opacity
    },
    overlays: t?.overlays || UN(a)
  }, s;
}
function aV(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: a = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = J4,
    colorSchemeSelector: u = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...d
  } = e, p = Object.keys(n)[0], f = r || (n.light && p !== "light" ? "light" : p), m = rV(i), {
    [f]: h,
    light: E,
    dark: y,
    ...w
  } = n, x = {
    ...w
  };
  let I = h;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && (I = !0), !I)
    throw new Error(wi(21, f));
  const S = Yd(x, I, d, f);
  E && !x.light && Yd(x, E, void 0, "light"), y && !x.dark && Yd(x, y, void 0, "dark");
  let C = {
    defaultColorScheme: f,
    ...S,
    cssVarPrefix: i,
    colorSchemeSelector: u,
    rootSelector: c,
    getCssVar: m,
    colorSchemes: x,
    font: {
      ...F4(S.typography),
      ...S.font
    },
    spacing: nV(d.spacing)
  };
  Object.keys(C.colorSchemes).forEach((P) => {
    const b = C.colorSchemes[P].palette, L = (j) => {
      const G = j.split("-"), H = G[1], ne = G[2];
      return m(j, b[H][ne]);
    };
    if (b.mode === "light" && (Z(b.common, "background", "#fff"), Z(b.common, "onBackground", "#000")), b.mode === "dark" && (Z(b.common, "background", "#000"), Z(b.common, "onBackground", "#fff")), tV(b, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), b.mode === "light") {
      Z(b.Alert, "errorColor", ct(b.error.light, 0.6)), Z(b.Alert, "infoColor", ct(b.info.light, 0.6)), Z(b.Alert, "successColor", ct(b.success.light, 0.6)), Z(b.Alert, "warningColor", ct(b.warning.light, 0.6)), Z(b.Alert, "errorFilledBg", L("palette-error-main")), Z(b.Alert, "infoFilledBg", L("palette-info-main")), Z(b.Alert, "successFilledBg", L("palette-success-main")), Z(b.Alert, "warningFilledBg", L("palette-warning-main")), Z(b.Alert, "errorFilledColor", $r(() => b.getContrastText(b.error.main))), Z(b.Alert, "infoFilledColor", $r(() => b.getContrastText(b.info.main))), Z(b.Alert, "successFilledColor", $r(() => b.getContrastText(b.success.main))), Z(b.Alert, "warningFilledColor", $r(() => b.getContrastText(b.warning.main))), Z(b.Alert, "errorStandardBg", dt(b.error.light, 0.9)), Z(b.Alert, "infoStandardBg", dt(b.info.light, 0.9)), Z(b.Alert, "successStandardBg", dt(b.success.light, 0.9)), Z(b.Alert, "warningStandardBg", dt(b.warning.light, 0.9)), Z(b.Alert, "errorIconColor", L("palette-error-main")), Z(b.Alert, "infoIconColor", L("palette-info-main")), Z(b.Alert, "successIconColor", L("palette-success-main")), Z(b.Alert, "warningIconColor", L("palette-warning-main")), Z(b.AppBar, "defaultBg", L("palette-grey-100")), Z(b.Avatar, "defaultBg", L("palette-grey-400")), Z(b.Button, "inheritContainedBg", L("palette-grey-300")), Z(b.Button, "inheritContainedHoverBg", L("palette-grey-A100")), Z(b.Chip, "defaultBorder", L("palette-grey-400")), Z(b.Chip, "defaultAvatarColor", L("palette-grey-700")), Z(b.Chip, "defaultIconColor", L("palette-grey-700")), Z(b.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Z(b.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Z(b.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Z(b.LinearProgress, "primaryBg", dt(b.primary.main, 0.62)), Z(b.LinearProgress, "secondaryBg", dt(b.secondary.main, 0.62)), Z(b.LinearProgress, "errorBg", dt(b.error.main, 0.62)), Z(b.LinearProgress, "infoBg", dt(b.info.main, 0.62)), Z(b.LinearProgress, "successBg", dt(b.success.main, 0.62)), Z(b.LinearProgress, "warningBg", dt(b.warning.main, 0.62)), Z(b.Skeleton, "bg", `rgba(${L("palette-text-primaryChannel")} / 0.11)`), Z(b.Slider, "primaryTrack", dt(b.primary.main, 0.62)), Z(b.Slider, "secondaryTrack", dt(b.secondary.main, 0.62)), Z(b.Slider, "errorTrack", dt(b.error.main, 0.62)), Z(b.Slider, "infoTrack", dt(b.info.main, 0.62)), Z(b.Slider, "successTrack", dt(b.success.main, 0.62)), Z(b.Slider, "warningTrack", dt(b.warning.main, 0.62));
      const j = Fl(b.background.default, 0.8);
      Z(b.SnackbarContent, "bg", j), Z(b.SnackbarContent, "color", $r(() => b.getContrastText(j))), Z(b.SpeedDialAction, "fabHoverBg", Fl(b.background.paper, 0.15)), Z(b.StepConnector, "border", L("palette-grey-400")), Z(b.StepContent, "border", L("palette-grey-400")), Z(b.Switch, "defaultColor", L("palette-common-white")), Z(b.Switch, "defaultDisabledColor", L("palette-grey-100")), Z(b.Switch, "primaryDisabledColor", dt(b.primary.main, 0.62)), Z(b.Switch, "secondaryDisabledColor", dt(b.secondary.main, 0.62)), Z(b.Switch, "errorDisabledColor", dt(b.error.main, 0.62)), Z(b.Switch, "infoDisabledColor", dt(b.info.main, 0.62)), Z(b.Switch, "successDisabledColor", dt(b.success.main, 0.62)), Z(b.Switch, "warningDisabledColor", dt(b.warning.main, 0.62)), Z(b.TableCell, "border", dt(Ml(b.divider, 1), 0.88)), Z(b.Tooltip, "bg", Ml(b.grey[700], 0.92));
    }
    if (b.mode === "dark") {
      Z(b.Alert, "errorColor", dt(b.error.light, 0.6)), Z(b.Alert, "infoColor", dt(b.info.light, 0.6)), Z(b.Alert, "successColor", dt(b.success.light, 0.6)), Z(b.Alert, "warningColor", dt(b.warning.light, 0.6)), Z(b.Alert, "errorFilledBg", L("palette-error-dark")), Z(b.Alert, "infoFilledBg", L("palette-info-dark")), Z(b.Alert, "successFilledBg", L("palette-success-dark")), Z(b.Alert, "warningFilledBg", L("palette-warning-dark")), Z(b.Alert, "errorFilledColor", $r(() => b.getContrastText(b.error.dark))), Z(b.Alert, "infoFilledColor", $r(() => b.getContrastText(b.info.dark))), Z(b.Alert, "successFilledColor", $r(() => b.getContrastText(b.success.dark))), Z(b.Alert, "warningFilledColor", $r(() => b.getContrastText(b.warning.dark))), Z(b.Alert, "errorStandardBg", ct(b.error.light, 0.9)), Z(b.Alert, "infoStandardBg", ct(b.info.light, 0.9)), Z(b.Alert, "successStandardBg", ct(b.success.light, 0.9)), Z(b.Alert, "warningStandardBg", ct(b.warning.light, 0.9)), Z(b.Alert, "errorIconColor", L("palette-error-main")), Z(b.Alert, "infoIconColor", L("palette-info-main")), Z(b.Alert, "successIconColor", L("palette-success-main")), Z(b.Alert, "warningIconColor", L("palette-warning-main")), Z(b.AppBar, "defaultBg", L("palette-grey-900")), Z(b.AppBar, "darkBg", L("palette-background-paper")), Z(b.AppBar, "darkColor", L("palette-text-primary")), Z(b.Avatar, "defaultBg", L("palette-grey-600")), Z(b.Button, "inheritContainedBg", L("palette-grey-800")), Z(b.Button, "inheritContainedHoverBg", L("palette-grey-700")), Z(b.Chip, "defaultBorder", L("palette-grey-700")), Z(b.Chip, "defaultAvatarColor", L("palette-grey-300")), Z(b.Chip, "defaultIconColor", L("palette-grey-300")), Z(b.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Z(b.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Z(b.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Z(b.LinearProgress, "primaryBg", ct(b.primary.main, 0.5)), Z(b.LinearProgress, "secondaryBg", ct(b.secondary.main, 0.5)), Z(b.LinearProgress, "errorBg", ct(b.error.main, 0.5)), Z(b.LinearProgress, "infoBg", ct(b.info.main, 0.5)), Z(b.LinearProgress, "successBg", ct(b.success.main, 0.5)), Z(b.LinearProgress, "warningBg", ct(b.warning.main, 0.5)), Z(b.Skeleton, "bg", `rgba(${L("palette-text-primaryChannel")} / 0.13)`), Z(b.Slider, "primaryTrack", ct(b.primary.main, 0.5)), Z(b.Slider, "secondaryTrack", ct(b.secondary.main, 0.5)), Z(b.Slider, "errorTrack", ct(b.error.main, 0.5)), Z(b.Slider, "infoTrack", ct(b.info.main, 0.5)), Z(b.Slider, "successTrack", ct(b.success.main, 0.5)), Z(b.Slider, "warningTrack", ct(b.warning.main, 0.5));
      const j = Fl(b.background.default, 0.98);
      Z(b.SnackbarContent, "bg", j), Z(b.SnackbarContent, "color", $r(() => b.getContrastText(j))), Z(b.SpeedDialAction, "fabHoverBg", Fl(b.background.paper, 0.15)), Z(b.StepConnector, "border", L("palette-grey-600")), Z(b.StepContent, "border", L("palette-grey-600")), Z(b.Switch, "defaultColor", L("palette-grey-300")), Z(b.Switch, "defaultDisabledColor", L("palette-grey-600")), Z(b.Switch, "primaryDisabledColor", ct(b.primary.main, 0.55)), Z(b.Switch, "secondaryDisabledColor", ct(b.secondary.main, 0.55)), Z(b.Switch, "errorDisabledColor", ct(b.error.main, 0.55)), Z(b.Switch, "infoDisabledColor", ct(b.info.main, 0.55)), Z(b.Switch, "successDisabledColor", ct(b.success.main, 0.55)), Z(b.Switch, "warningDisabledColor", ct(b.warning.main, 0.55)), Z(b.TableCell, "border", ct(Ml(b.divider, 1), 0.68)), Z(b.Tooltip, "bg", Ml(b.grey[700], 0.92));
    }
    da(b.background, "default"), da(b.background, "paper"), da(b.common, "background"), da(b.common, "onBackground"), da(b, "divider"), Object.keys(b).forEach((j) => {
      const G = b[j];
      j !== "tonalOffset" && G && typeof G == "object" && (G.main && Z(b[j], "mainChannel", rs(as(G.main))), G.light && Z(b[j], "lightChannel", rs(as(G.light))), G.dark && Z(b[j], "darkChannel", rs(as(G.dark))), G.contrastText && Z(b[j], "contrastTextChannel", rs(as(G.contrastText))), j === "text" && (da(b[j], "primary"), da(b[j], "secondary")), j === "action" && (G.active && da(b[j], "active"), G.selected && da(b[j], "selected")));
    });
  }), C = t.reduce((P, b) => Jn(P, b), C);
  const T = {
    prefix: i,
    disableCssColorScheme: a,
    shouldSkipGeneratingVar: s,
    getSelector: eV(C)
  }, {
    vars: A,
    generateThemeVars: O,
    generateStyleSheets: U
  } = p4(C, T);
  return C.vars = A, Object.entries(C.colorSchemes[C.defaultColorScheme]).forEach(([P, b]) => {
    C[P] = b;
  }), C.generateThemeVars = O, C.generateStyleSheets = U, C.generateSpacing = function() {
    return kN(d.spacing, yv(this));
  }, C.getColorSchemeSelector = f4(u), C.spacing = C.generateSpacing(), C.shouldSkipGeneratingVar = s, C.unstable_sxConfig = {
    ...Ls,
    ...d?.unstable_sxConfig
  }, C.unstable_sx = function(P) {
    return go({
      sx: P,
      theme: this
    });
  }, C.toRuntimeSource = BN, C;
}
function hw(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Nv({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function iV(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: a = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n?.mode,
    ...s
  } = e, u = i || "light", c = a?.[u], d = {
    ...a,
    ...n ? {
      [u]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return xy(e, ...t);
    let p = n;
    "palette" in e || d[u] && (d[u] !== !0 ? p = d[u].palette : u === "dark" && (p = {
      mode: "dark"
    }));
    const f = xy({
      ...e,
      palette: p
    }, ...t);
    return f.defaultColorScheme = u, f.colorSchemes = d, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...d.light !== !0 && d.light,
      palette: f.palette
    }, hw(f, "dark", d.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...d.dark !== !0 && d.dark,
      palette: f.palette
    }, hw(f, "light", d.light)), f;
  }
  return !n && !("light" in d) && u === "light" && (d.light = !0), aV({
    ...s,
    colorSchemes: d,
    defaultColorScheme: u,
    ...typeof r != "boolean" && r
  }, ...t);
}
const jN = iV(), qN = "$$material";
function zN() {
  const e = Rv(jN);
  return e[qN] || e;
}
function oV(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Ov = (e) => oV(e) && e !== "classes", Or = LN({
  themeId: qN,
  defaultTheme: jN,
  rootShouldForwardProp: Ov
}), Lv = l4;
function xo(e) {
  return s4(e);
}
function bw(e, t) {
  const {
    timeout: n,
    easing: r,
    style: a = {}
  } = e;
  return {
    duration: a.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: a.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: a.transitionDelay
  };
}
function sV(e) {
  return Sa("MuiSvgIcon", e);
}
Ya("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const lV = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, a = {
    root: ["root", t !== "inherit" && `color${Nr(t)}`, `fontSize${Nr(n)}`]
  };
  return Ka(a, sV, r);
}, uV = Or("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Nr(n.color)}`], t[`fontSize${Nr(n.fontSize)}`]];
  }
})(Lv(({
  theme: e
}) => {
  var t, n, r, a, i, s, u, c, d, p, f, m, h, E;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (a = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : a.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (y) => !y.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((s = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : s.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((c = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : c.call(u, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((p = (d = e.typography) == null ? void 0 : d.pxToRem) == null ? void 0 : p.call(d, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, y]) => y && y.main).map(([y]) => {
        var w, x;
        return {
          props: {
            color: y
          },
          style: {
            color: (x = (w = (e.vars ?? e).palette) == null ? void 0 : w[y]) == null ? void 0 : x.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (m = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : m.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (E = (h = (e.vars ?? e).palette) == null ? void 0 : h.action) == null ? void 0 : E.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Ty = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = xo({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: a,
    color: i = "inherit",
    component: s = "svg",
    fontSize: u = "medium",
    htmlColor: c,
    inheritViewBox: d = !1,
    titleAccess: p,
    viewBox: f = "0 0 24 24",
    ...m
  } = n, h = /* @__PURE__ */ B.isValidElement(r) && r.type === "svg", E = {
    ...n,
    color: i,
    component: s,
    fontSize: u,
    instanceFontSize: e.fontSize,
    inheritViewBox: d,
    viewBox: f,
    hasSvgAsChild: h
  }, y = {};
  d || (y.viewBox = f);
  const w = lV(E);
  return /* @__PURE__ */ V.jsxs(uV, {
    as: s,
    className: Qt(w.root, a),
    focusable: "false",
    color: c,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: t,
    ...y,
    ...m,
    ...h && r.props,
    ownerState: E,
    children: [h ? r.props.children : r, p ? /* @__PURE__ */ V.jsx("title", {
      children: p
    }) : null]
  });
});
Ty.muiName = "SvgIcon";
function Ii(e, t) {
  function n(r, a) {
    return /* @__PURE__ */ V.jsx(Ty, {
      "data-testid": `${t}Icon`,
      ref: a,
      ...r,
      children: e
    });
  }
  return n.muiName = Ty.muiName, /* @__PURE__ */ B.memo(/* @__PURE__ */ B.forwardRef(n));
}
function cV(e) {
  return Sa("MuiCollapse", e);
}
Ya("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const dV = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Ka(r, cV, n);
}, pV = Or("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(Lv(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), fV = Or("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), gV = Or("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), wy = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = xo({
    props: e,
    name: "MuiCollapse"
  }), {
    addEndListener: r,
    children: a,
    className: i,
    collapsedSize: s = "0px",
    component: u,
    easing: c,
    in: d,
    onEnter: p,
    onEntered: f,
    onEntering: m,
    onExit: h,
    onExited: E,
    onExiting: y,
    orientation: w = "vertical",
    style: x,
    timeout: I = PN.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = xa,
    ...C
  } = n, T = {
    ...n,
    orientation: w,
    collapsedSize: s
  }, A = dV(T), O = zN(), U = pN(), P = B.useRef(null), b = B.useRef(), L = typeof s == "number" ? `${s}px` : s, j = w === "horizontal", G = j ? "width" : "height", H = B.useRef(null), ne = Ha(t, H), ue = (se) => (ie) => {
    if (se) {
      const xe = H.current;
      ie === void 0 ? se(xe) : se(xe, ie);
    }
  }, ce = () => P.current ? P.current[j ? "clientWidth" : "clientHeight"] : 0, Q = ue((se, ie) => {
    P.current && j && (P.current.style.position = "absolute"), se.style[G] = L, p && p(se, ie);
  }), de = ue((se, ie) => {
    const xe = ce();
    P.current && j && (P.current.style.position = "");
    const {
      duration: _e,
      easing: Le
    } = bw({
      style: x,
      timeout: I,
      easing: c
    }, {
      mode: "enter"
    });
    if (I === "auto") {
      const tt = O.transitions.getAutoHeightDuration(xe);
      se.style.transitionDuration = `${tt}ms`, b.current = tt;
    } else
      se.style.transitionDuration = typeof _e == "string" ? _e : `${_e}ms`;
    se.style[G] = `${xe}px`, se.style.transitionTimingFunction = Le, m && m(se, ie);
  }), D = ue((se, ie) => {
    se.style[G] = "auto", f && f(se, ie);
  }), le = ue((se) => {
    se.style[G] = `${ce()}px`, h && h(se);
  }), Ae = ue(E), M = ue((se) => {
    const ie = ce(), {
      duration: xe,
      easing: _e
    } = bw({
      style: x,
      timeout: I,
      easing: c
    }, {
      mode: "exit"
    });
    if (I === "auto") {
      const Le = O.transitions.getAutoHeightDuration(ie);
      se.style.transitionDuration = `${Le}ms`, b.current = Le;
    } else
      se.style.transitionDuration = typeof xe == "string" ? xe : `${xe}ms`;
    se.style[G] = L, se.style.transitionTimingFunction = _e, y && y(se);
  }), he = (se) => {
    I === "auto" && U.start(b.current || 0, se), r && r(H.current, se);
  };
  return /* @__PURE__ */ V.jsx(S, {
    in: d,
    onEnter: Q,
    onEntered: D,
    onEntering: de,
    onExit: le,
    onExited: Ae,
    onExiting: M,
    addEndListener: he,
    nodeRef: H,
    timeout: I === "auto" ? null : I,
    ...C,
    children: (se, {
      ownerState: ie,
      ...xe
    }) => /* @__PURE__ */ V.jsx(pV, {
      as: u,
      className: Qt(A.root, i, {
        entered: A.entered,
        exited: !d && L === "0px" && A.hidden
      }[se]),
      style: {
        [j ? "minWidth" : "minHeight"]: L,
        ...x
      },
      ref: ne,
      ownerState: {
        ...T,
        state: se
      },
      ...xe,
      children: /* @__PURE__ */ V.jsx(fV, {
        ownerState: {
          ...T,
          state: se
        },
        className: A.wrapper,
        ref: P,
        children: /* @__PURE__ */ V.jsx(gV, {
          ownerState: {
            ...T,
            state: se
          },
          className: A.wrapperInner,
          children: a
        })
      })
    })
  });
});
wy && (wy.muiSupportAuto = !0);
const mV = /* @__PURE__ */ B.createContext(void 0);
function hV() {
  return B.useContext(mV);
}
class wu {
  constructor() {
    eu(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    }), this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new wu();
  }
  static use() {
    const t = dN(wu.create).current, [n, r] = B.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, B.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = yV(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function bV() {
  return wu.use();
}
function yV() {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}
function vV(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: a,
    rippleY: i,
    rippleSize: s,
    in: u,
    onExited: c,
    timeout: d
  } = e, [p, f] = B.useState(!1), m = Qt(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), h = {
    width: s,
    height: s,
    top: -(s / 2) + i,
    left: -(s / 2) + a
  }, E = Qt(n.child, p && n.childLeaving, r && n.childPulsate);
  return !u && !p && f(!0), B.useEffect(() => {
    if (!u && c != null) {
      const y = setTimeout(c, d);
      return () => {
        clearTimeout(y);
      };
    }
  }, [c, u, d]), /* @__PURE__ */ V.jsx("span", {
    className: m,
    style: h,
    children: /* @__PURE__ */ V.jsx("span", {
      className: E
    })
  });
}
const mr = Ya("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Ay = 550, EV = 80, SV = Iv`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, xV = Iv`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, TV = Iv`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, wV = Or("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), AV = Or(vV, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${mr.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${SV};
    animation-duration: ${Ay}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${mr.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${mr.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${mr.childLeaving} {
    opacity: 0;
    animation-name: ${xV};
    animation-duration: ${Ay}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${mr.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${TV};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, IV = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = xo({
    props: e,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: a = {},
    className: i,
    ...s
  } = n, [u, c] = B.useState([]), d = B.useRef(0), p = B.useRef(null);
  B.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [u]);
  const f = B.useRef(!1), m = pN(), h = B.useRef(null), E = B.useRef(null), y = B.useCallback((S) => {
    const {
      pulsate: C,
      rippleX: T,
      rippleY: A,
      rippleSize: O,
      cb: U
    } = S;
    c((P) => [...P, /* @__PURE__ */ V.jsx(AV, {
      classes: {
        ripple: Qt(a.ripple, mr.ripple),
        rippleVisible: Qt(a.rippleVisible, mr.rippleVisible),
        ripplePulsate: Qt(a.ripplePulsate, mr.ripplePulsate),
        child: Qt(a.child, mr.child),
        childLeaving: Qt(a.childLeaving, mr.childLeaving),
        childPulsate: Qt(a.childPulsate, mr.childPulsate)
      },
      timeout: Ay,
      pulsate: C,
      rippleX: T,
      rippleY: A,
      rippleSize: O
    }, d.current)]), d.current += 1, p.current = U;
  }, [a]), w = B.useCallback((S = {}, C = {}, T = () => {
  }) => {
    const {
      pulsate: A = !1,
      center: O = r || C.pulsate,
      fakeElement: U = !1
      // For test purposes
    } = C;
    if (S?.type === "mousedown" && f.current) {
      f.current = !1;
      return;
    }
    S?.type === "touchstart" && (f.current = !0);
    const P = U ? null : E.current, b = P ? P.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let L, j, G;
    if (O || S === void 0 || S.clientX === 0 && S.clientY === 0 || !S.clientX && !S.touches)
      L = Math.round(b.width / 2), j = Math.round(b.height / 2);
    else {
      const {
        clientX: H,
        clientY: ne
      } = S.touches && S.touches.length > 0 ? S.touches[0] : S;
      L = Math.round(H - b.left), j = Math.round(ne - b.top);
    }
    if (O)
      G = Math.sqrt((2 * b.width ** 2 + b.height ** 2) / 3), G % 2 === 0 && (G += 1);
    else {
      const H = Math.max(Math.abs((P ? P.clientWidth : 0) - L), L) * 2 + 2, ne = Math.max(Math.abs((P ? P.clientHeight : 0) - j), j) * 2 + 2;
      G = Math.sqrt(H ** 2 + ne ** 2);
    }
    S != null && S.touches ? h.current === null && (h.current = () => {
      y({
        pulsate: A,
        rippleX: L,
        rippleY: j,
        rippleSize: G,
        cb: T
      });
    }, m.start(EV, () => {
      h.current && (h.current(), h.current = null);
    })) : y({
      pulsate: A,
      rippleX: L,
      rippleY: j,
      rippleSize: G,
      cb: T
    });
  }, [r, y, m]), x = B.useCallback(() => {
    w({}, {
      pulsate: !0
    });
  }, [w]), I = B.useCallback((S, C) => {
    if (m.clear(), S?.type === "touchend" && h.current) {
      h.current(), h.current = null, m.start(0, () => {
        I(S, C);
      });
      return;
    }
    h.current = null, c((T) => T.length > 0 ? T.slice(1) : T), p.current = C;
  }, [m]);
  return B.useImperativeHandle(t, () => ({
    pulsate: x,
    start: w,
    stop: I
  }), [x, w, I]), /* @__PURE__ */ V.jsx(wV, {
    className: Qt(mr.root, a.root, i),
    ref: E,
    ...s,
    children: /* @__PURE__ */ V.jsx(gv, {
      component: null,
      exit: !0,
      children: u
    })
  });
});
function RV(e) {
  return Sa("MuiButtonBase", e);
}
const _V = Ya("MuiButtonBase", ["root", "disabled", "focusVisible"]), CV = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: a
  } = e, i = Ka({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, RV, a);
  return n && r && (i.root += ` ${r}`), i;
}, kV = Or("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${_V.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), NV = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = xo({
    props: e,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: a = !1,
    children: i,
    className: s,
    component: u = "button",
    disabled: c = !1,
    disableRipple: d = !1,
    disableTouchRipple: p = !1,
    focusRipple: f = !1,
    focusVisibleClassName: m,
    LinkComponent: h = "a",
    onBlur: E,
    onClick: y,
    onContextMenu: w,
    onDragLeave: x,
    onFocus: I,
    onFocusVisible: S,
    onKeyDown: C,
    onKeyUp: T,
    onMouseDown: A,
    onMouseLeave: O,
    onMouseUp: U,
    onTouchEnd: P,
    onTouchMove: b,
    onTouchStart: L,
    tabIndex: j = 0,
    TouchRippleProps: G,
    touchRippleRef: H,
    type: ne,
    ...ue
  } = n, ce = B.useRef(null), Q = bV(), de = Ha(Q.ref, H), [D, le] = B.useState(!1);
  c && D && le(!1), B.useImperativeHandle(r, () => ({
    focusVisible: () => {
      le(!0), ce.current.focus();
    }
  }), []);
  const Ae = Q.shouldMount && !d && !c;
  B.useEffect(() => {
    D && f && !d && Q.pulsate();
  }, [d, f, D, Q]);
  const M = pa(Q, "start", A, p), he = pa(Q, "stop", w, p), se = pa(Q, "stop", x, p), ie = pa(Q, "stop", U, p), xe = pa(Q, "stop", (me) => {
    D && me.preventDefault(), O && O(me);
  }, p), _e = pa(Q, "start", L, p), Le = pa(Q, "stop", P, p), tt = pa(Q, "stop", b, p), at = pa(Q, "stop", (me) => {
    sw(me.target) || le(!1), E && E(me);
  }, !1), tn = Sr((me) => {
    ce.current || (ce.current = me.currentTarget), sw(me.target) && (le(!0), S && S(me)), I && I(me);
  }), Ge = () => {
    const me = ce.current;
    return u && u !== "button" && !(me.tagName === "A" && me.href);
  }, St = Sr((me) => {
    f && !me.repeat && D && me.key === " " && Q.stop(me, () => {
      Q.start(me);
    }), me.target === me.currentTarget && Ge() && me.key === " " && me.preventDefault(), C && C(me), me.target === me.currentTarget && Ge() && me.key === "Enter" && !c && (me.preventDefault(), y && y(me));
  }), nn = Sr((me) => {
    f && me.key === " " && D && !me.defaultPrevented && Q.stop(me, () => {
      Q.pulsate(me);
    }), T && T(me), y && me.target === me.currentTarget && Ge() && me.key === " " && !me.defaultPrevented && y(me);
  });
  let kt = u;
  kt === "button" && (ue.href || ue.to) && (kt = h);
  const Ze = {};
  kt === "button" ? (Ze.type = ne === void 0 ? "button" : ne, Ze.disabled = c) : (!ue.href && !ue.to && (Ze.role = "button"), c && (Ze["aria-disabled"] = c));
  const Nt = Ha(t, ce), wn = {
    ...n,
    centerRipple: a,
    component: u,
    disabled: c,
    disableRipple: d,
    disableTouchRipple: p,
    focusRipple: f,
    tabIndex: j,
    focusVisible: D
  }, Rt = CV(wn);
  return /* @__PURE__ */ V.jsxs(kV, {
    as: kt,
    className: Qt(Rt.root, s),
    ownerState: wn,
    onBlur: at,
    onClick: y,
    onContextMenu: he,
    onFocus: tn,
    onKeyDown: St,
    onKeyUp: nn,
    onMouseDown: M,
    onMouseLeave: xe,
    onMouseUp: ie,
    onDragLeave: se,
    onTouchEnd: Le,
    onTouchMove: tt,
    onTouchStart: _e,
    ref: Nt,
    tabIndex: c ? -1 : j,
    type: ne,
    ...Ze,
    ...ue,
    children: [i, Ae ? /* @__PURE__ */ V.jsx(IV, {
      ref: de,
      center: a,
      ...G
    }) : null]
  });
});
function pa(e, t, n, r = !1) {
  return Sr((a) => (n && n(a), r || e[t](a), !0));
}
function OV(e) {
  return Sa("PrivateSwitchBase", e);
}
Ya("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const LV = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: a
  } = e, i = {
    root: ["root", n && "checked", r && "disabled", a && `edge${Nr(a)}`],
    input: ["input"]
  };
  return Ka(i, OV, t);
}, DV = Or(NV)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), MV = Or("input", {
  shouldForwardProp: Ov
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), FV = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    autoFocus: n,
    checked: r,
    checkedIcon: a,
    className: i,
    defaultChecked: s,
    disabled: u,
    disableFocusRipple: c = !1,
    edge: d = !1,
    icon: p,
    id: f,
    inputProps: m,
    inputRef: h,
    name: E,
    onBlur: y,
    onChange: w,
    onFocus: x,
    readOnly: I,
    required: S = !1,
    tabIndex: C,
    type: T,
    value: A,
    ...O
  } = e, [U, P] = a4({
    controlled: r,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), b = hV(), L = (Q) => {
    x && x(Q), b && b.onFocus && b.onFocus(Q);
  }, j = (Q) => {
    y && y(Q), b && b.onBlur && b.onBlur(Q);
  }, G = (Q) => {
    if (Q.nativeEvent.defaultPrevented)
      return;
    const de = Q.target.checked;
    P(de), w && w(Q, de);
  };
  let H = u;
  b && typeof H > "u" && (H = b.disabled);
  const ne = T === "checkbox" || T === "radio", ue = {
    ...e,
    checked: U,
    disabled: H,
    disableFocusRipple: c,
    edge: d
  }, ce = LV(ue);
  return /* @__PURE__ */ V.jsxs(DV, {
    component: "span",
    className: Qt(ce.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: H,
    tabIndex: null,
    role: void 0,
    onFocus: L,
    onBlur: j,
    ownerState: ue,
    ref: t,
    ...O,
    children: [/* @__PURE__ */ V.jsx(MV, {
      autoFocus: n,
      checked: r,
      defaultChecked: s,
      className: ce.input,
      disabled: H,
      id: ne ? f : void 0,
      name: E,
      onChange: G,
      readOnly: I,
      ref: h,
      required: S,
      ownerState: ue,
      tabIndex: C,
      type: T,
      ...T === "checkbox" && A === void 0 ? {} : {
        value: A
      },
      ...m
    }), U ? a : p]
  });
}), PV = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), BV = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), $V = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function UV(e) {
  return Sa("MuiCheckbox", e);
}
const Xd = Ya("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]);
function jV(e) {
  return typeof e.main == "string";
}
function qV(e, t = []) {
  if (!jV(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function yw(e = []) {
  return ([, t]) => t && qV(t, e);
}
const zV = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: a
  } = e, i = {
    root: ["root", n && "indeterminate", `color${Nr(r)}`, `size${Nr(a)}`]
  }, s = Ka(i, UV, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...s
  };
}, GV = Or(FV, {
  shouldForwardProp: (e) => Ov(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Nr(n.size)}`], n.color !== "default" && t[`color${Nr(n.color)}`]];
  }
})(Lv(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Sy(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(yw()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Sy(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(yw()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Xd.checked}, &.${Xd.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${Xd.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), HV = /* @__PURE__ */ V.jsx(BV, {}), VV = /* @__PURE__ */ V.jsx(PV, {}), WV = /* @__PURE__ */ V.jsx($V, {}), KV = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const n = xo({
    props: e,
    name: "MuiCheckbox"
  }), {
    checkedIcon: r = HV,
    color: a = "primary",
    icon: i = VV,
    indeterminate: s = !1,
    indeterminateIcon: u = WV,
    inputProps: c,
    size: d = "medium",
    disableRipple: p = !1,
    className: f,
    ...m
  } = n, h = s ? u : i, E = s ? u : r, y = {
    ...n,
    disableRipple: p,
    color: a,
    indeterminate: s,
    size: d
  }, w = zV(y);
  return /* @__PURE__ */ V.jsx(GV, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": s,
      ...c
    },
    icon: /* @__PURE__ */ B.cloneElement(h, {
      fontSize: h.props.fontSize ?? d
    }),
    checkedIcon: /* @__PURE__ */ B.cloneElement(E, {
      fontSize: E.props.fontSize ?? d
    }),
    ownerState: y,
    ref: t,
    className: Qt(w.root, f),
    disableRipple: p,
    ...m,
    classes: w
  });
});
function GN(e) {
  const {
    instance: t,
    items: {
      onItemClick: n
    },
    selection: {
      multiSelect: r,
      checkboxSelection: a,
      disableSelection: i
    },
    expansion: {
      expansionTrigger: s
    }
  } = vo(), u = t.isItemExpandable(e), c = t.isItemExpanded(e), d = t.isItemFocused(e), p = t.isItemSelected(e), f = t.isItemDisabled(e), m = t != null && t.isItemBeingEdited ? t?.isItemBeingEdited(e) : !1, h = t.isItemEditable ? t.isItemEditable(e) : !1, E = (S) => {
    if (!f) {
      d || t.focusItem(S, e);
      const C = r && (S.shiftKey || S.ctrlKey || S.metaKey);
      u && !(C && t.isItemExpanded(e)) && t.toggleItemExpansion(S, e);
    }
  }, y = (S) => {
    f || (d || t.focusItem(S, e), r && (S.shiftKey || S.ctrlKey || S.metaKey) ? S.shiftKey ? t.expandSelectionRange(S, e) : t.selectItem({
      event: S,
      itemId: e,
      keepExistingSelection: !0
    }) : t.selectItem({
      event: S,
      itemId: e,
      shouldBeSelected: !0
    }));
  }, w = (S) => {
    if (i || f)
      return;
    const C = S.nativeEvent.shiftKey;
    r && C ? t.expandSelectionRange(S, e) : t.selectItem({
      event: S,
      itemId: e,
      keepExistingSelection: r,
      shouldBeSelected: S.target.checked
    });
  }, x = (S) => {
    (S.shiftKey || S.ctrlKey || S.metaKey || f) && S.preventDefault();
  }, I = () => {
    ru(t, za) && t.isItemEditable(e) && (t.isItemBeingEdited(e) ? t.setEditedItemId(null) : t.setEditedItemId(e));
  };
  return {
    disabled: f,
    expanded: c,
    selected: p,
    focused: d,
    editable: h,
    editing: m,
    disableSelection: i,
    checkboxSelection: a,
    handleExpansion: E,
    handleSelection: y,
    handleCheckboxSelection: w,
    handleContentClick: n,
    preventSelection: x,
    expansionTrigger: s,
    toggleItemEditing: I,
    handleSaveItemLabel: (S, C) => {
      ru(t, za) && t.isItemBeingEditedRef(e) && (t.updateItemLabel(e, C), I(), t.focusItem(S, e));
    },
    handleCancelItemLabelEditing: (S) => {
      ru(t, za) && t.isItemBeingEditedRef(e) && (I(), t.focusItem(S, e));
    }
  };
}
const YV = cn("div", {
  name: "MuiTreeItem2DragAndDropOverlay",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => lo(e) && e !== "action"
})(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  display: "flex",
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: "none",
  variants: [{
    props: {
      action: "make-child"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderRadius: e.shape.borderRadius,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.darkChannel} / ${e.vars.palette.action.focusOpacity})` : Zo(e.palette.primary.dark, e.palette.action.focusOpacity)
    }
  }, {
    props: {
      action: "reorder-above"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderTop: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "reorder-below"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "move-to-parent"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }]
}));
function XV(e) {
  return e.action == null ? null : /* @__PURE__ */ V.jsx(YV, ve({}, e));
}
const ZV = cn("input", {
  name: "MuiTreeItem2",
  slot: "LabelInput",
  overridesResolver: (e, t) => t.labelInput
})(({
  theme: e
}) => ve({}, e.typography.body1, {
  width: "100%",
  backgroundColor: e.palette.background.paper,
  borderRadius: e.shape.borderRadius,
  border: "none",
  padding: "0 2px",
  boxSizing: "border-box",
  "&:focus": {
    outline: `1px solid ${e.palette.primary.main}`
  }
})), JV = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown", "dragAndDropOverlayProps", "labelInputProps"], HN = /* @__PURE__ */ B.forwardRef(function(e, t) {
  const {
    classes: n,
    className: r,
    displayIcon: a,
    expansionIcon: i,
    icon: s,
    label: u,
    itemId: c,
    onClick: d,
    onMouseDown: p,
    dragAndDropOverlayProps: f,
    labelInputProps: m
  } = e, h = ba(e, JV), {
    disabled: E,
    expanded: y,
    selected: w,
    focused: x,
    editing: I,
    editable: S,
    disableSelection: C,
    checkboxSelection: T,
    handleExpansion: A,
    handleSelection: O,
    handleCheckboxSelection: U,
    handleContentClick: P,
    preventSelection: b,
    expansionTrigger: L,
    toggleItemEditing: j
  } = GN(c), G = s || i || a, H = B.useRef(null), ne = (Q) => {
    b(Q), p && p(Q);
  }, ue = (Q) => {
    var de;
    P?.(Q, c), !((de = H.current) != null && de.contains(Q.target)) && (L === "content" && A(Q), T || O(Q), d && d(Q));
  }, ce = (Q) => {
    Q.defaultMuiPrevented || j();
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ V.jsxs("div", ve({}, h, {
      className: Qt(n.root, r, y && n.expanded, w && n.selected, x && n.focused, E && n.disabled, I && n.editing, S && n.editable),
      onClick: ue,
      onMouseDown: ne,
      ref: t,
      children: [/* @__PURE__ */ V.jsx("div", {
        className: n.iconContainer,
        children: G
      }), T && /* @__PURE__ */ V.jsx(KV, {
        className: n.checkbox,
        checked: w,
        onChange: U,
        disabled: E || C,
        ref: H,
        tabIndex: -1
      }), I ? /* @__PURE__ */ V.jsx(ZV, ve({}, m, {
        className: n.labelInput
      })) : /* @__PURE__ */ V.jsx("div", ve({
        className: n.label
      }, S && {
        onDoubleClick: ce
      }, {
        children: u
      })), f && /* @__PURE__ */ V.jsx(XV, ve({}, f))]
    }))
  );
});
function QV(e) {
  return Sa("MuiTreeItem", e);
}
const fa = Ya("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox", "labelInput", "editable", "editing", "dragAndDropOverlay"]), eW = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), tW = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function VN(e) {
  const {
    children: t,
    itemId: n
  } = e, {
    wrapItem: r,
    instance: a
  } = vo();
  return r({
    children: t,
    itemId: n,
    instance: a
  });
}
VN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: io.node,
  itemId: io.string.isRequired
};
const nW = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], rW = ["ownerState"], aW = ["ownerState"], iW = ["ownerState"], oW = V0(), sW = (e) => {
  const {
    classes: t
  } = e;
  return Ka({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    labelInput: ["labelInput"],
    editing: ["editing"],
    editable: ["editable"],
    groupTransition: ["groupTransition"]
  }, QV, t);
}, lW = cn("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), uW = cn(HN, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${fa.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${fa.label}`]: t.label
  }],
  shouldForwardProp: (e) => lo(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${fa.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${fa.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${fa.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Zo(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Zo(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Zo(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${fa.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Zo(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${fa.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${fa.label}`]: ve({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${fa.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), cW = cn(wy, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => lo(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), It = /* @__PURE__ */ B.forwardRef(function(e, t) {
  var n, r, a, i;
  const {
    icons: s,
    runItemPlugins: u,
    items: {
      disabledItemsFocusable: c,
      indentationAtItemLevel: d
    },
    selection: {
      disableSelection: p
    },
    expansion: {
      expansionTrigger: f
    },
    treeId: m,
    instance: h
  } = vo(), E = B.useContext(ms), y = oW({
    props: e,
    name: "MuiTreeItem"
  }), {
    children: w,
    className: x,
    slots: I,
    slotProps: S,
    ContentComponent: C = HN,
    ContentProps: T,
    itemId: A,
    id: O,
    label: U,
    onClick: P,
    onMouseDown: b,
    onBlur: L,
    onKeyDown: j
  } = y, G = ba(y, nW), {
    expanded: H,
    focused: ne,
    selected: ue,
    disabled: ce,
    editing: Q,
    handleExpansion: de,
    handleCancelItemLabelEditing: D,
    handleSaveItemLabel: le
  } = GN(A), {
    contentRef: Ae,
    rootRef: M,
    propsEnhancers: he
  } = u(y), se = B.useRef(null), ie = B.useRef(null), xe = Ha(t, M, se), _e = Ha(T?.ref, Ae, ie), Le = {
    expandIcon: I?.expandIcon ?? s.slots.expandIcon ?? eW,
    collapseIcon: I?.collapseIcon ?? s.slots.collapseIcon ?? tW,
    endIcon: I?.endIcon ?? s.slots.endIcon,
    icon: I?.icon,
    groupTransition: I?.groupTransition
  }, tt = (Te) => Array.isArray(Te) ? Te.length > 0 && Te.some(tt) : !!Te, at = tt(w), tn = ve({}, y, {
    expanded: H,
    focused: ne,
    selected: ue,
    disabled: ce,
    indentationAtItemLevel: d
  }), Ge = sW(tn), St = Le.groupTransition ?? void 0, nn = ts({
    elementType: St,
    ownerState: {},
    externalSlotProps: S?.groupTransition,
    additionalProps: ve({
      unmountOnExit: !0,
      in: H,
      component: "ul",
      role: "group"
    }, d ? {
      indentationAtItemLevel: !0
    } : {}),
    className: Ge.groupTransition
  }), kt = (Te) => {
    f === "iconContainer" && de(Te);
  }, Ze = H ? Le.collapseIcon : Le.expandIcon, Nt = ts({
    elementType: Ze,
    ownerState: {},
    externalSlotProps: (Te) => H ? ve({}, fi(s.slotProps.collapseIcon, Te), fi(S?.collapseIcon, Te)) : ve({}, fi(s.slotProps.expandIcon, Te), fi(S?.expandIcon, Te)),
    additionalProps: {
      onClick: kt
    }
  }), wn = ba(Nt, rW), Rt = at && Ze ? /* @__PURE__ */ V.jsx(Ze, ve({}, wn)) : null, me = at ? void 0 : Le.endIcon, Ee = ts({
    elementType: me,
    ownerState: {},
    externalSlotProps: (Te) => at ? {} : ve({}, fi(s.slotProps.endIcon, Te), fi(S?.endIcon, Te))
  }), ar = ba(Ee, aW), Bn = me ? /* @__PURE__ */ V.jsx(me, ve({}, ar)) : null, bt = Le.icon, Y = ts({
    elementType: bt,
    ownerState: {},
    externalSlotProps: S?.icon
  }), re = ba(Y, iW), fe = bt ? /* @__PURE__ */ V.jsx(bt, ve({}, re)) : null;
  let Se;
  ue ? Se = !0 : p || ce ? Se = void 0 : Se = !1;
  function Pe(Te) {
    !ne && (!ce || c) && Te.currentTarget === Te.target && h.focusItem(Te, A);
  }
  function Bt(Te) {
    var An, Dr, Ja, Qa;
    L?.(Te), !(Q || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    Te.relatedTarget && fy(Te.relatedTarget, se.current) && (Te.target && ((Dr = (An = Te.target) == null ? void 0 : An.dataset) == null ? void 0 : Dr.element) === "labelInput" && fy(Te.target, se.current) || ((Qa = (Ja = Te.relatedTarget) == null ? void 0 : Ja.dataset) == null ? void 0 : Qa.element) === "labelInput")) && h.removeFocusedItem();
  }
  const $t = (Te) => {
    var An, Dr;
    j?.(Te), ((Dr = (An = Te.target) == null ? void 0 : An.dataset) == null ? void 0 : Dr.element) !== "labelInput" && h.handleItemKeyDown(Te, A);
  }, Ut = Wu({
    itemId: A,
    treeId: m,
    id: O
  }), Yt = h.canItemBeTabbed(A) ? 0 : -1, xt = {
    rootRefObject: se,
    contentRefObject: ie,
    interactions: {
      handleSaveItemLabel: le,
      handleCancelItemLabelEditing: D
    }
  }, Ot = ((n = he.root) == null ? void 0 : n.call(he, ve({}, xt, {
    externalEventHandlers: py(G)
  }))) ?? {}, rn = ((r = he.content) == null ? void 0 : r.call(he, ve({}, xt, {
    externalEventHandlers: py(T)
  }))) ?? {}, Xt = ((a = he.dragAndDropOverlay) == null ? void 0 : a.call(he, ve({}, xt, {
    externalEventHandlers: {}
  }))) ?? {}, hn = ((i = he.labelInput) == null ? void 0 : i.call(he, ve({}, xt, {
    externalEventHandlers: {}
  }))) ?? {};
  return /* @__PURE__ */ V.jsx(VN, {
    itemId: A,
    children: /* @__PURE__ */ V.jsxs(lW, ve({
      className: Qt(Ge.root, x),
      role: "treeitem",
      "aria-expanded": at ? H : void 0,
      "aria-selected": Se,
      "aria-disabled": ce || void 0,
      id: Ut,
      tabIndex: Yt
    }, G, {
      ownerState: tn,
      onFocus: Pe,
      onBlur: Bt,
      onKeyDown: $t,
      ref: xe,
      style: d ? ve({}, G.style, {
        "--TreeView-itemDepth": typeof E == "function" ? E(A) : E
      }) : G.style
    }, Ot, {
      children: [/* @__PURE__ */ V.jsx(uW, ve({
        as: C,
        classes: {
          root: Ge.content,
          expanded: Ge.expanded,
          selected: Ge.selected,
          focused: Ge.focused,
          disabled: Ge.disabled,
          editable: Ge.editable,
          editing: Ge.editing,
          iconContainer: Ge.iconContainer,
          label: Ge.label,
          labelInput: Ge.labelInput,
          checkbox: Ge.checkbox
        },
        label: U,
        itemId: A,
        onClick: P,
        onMouseDown: b,
        icon: fe,
        expansionIcon: Rt,
        displayIcon: Bn,
        ownerState: tn
      }, T, rn, Xt.action == null ? {} : {
        dragAndDropOverlayProps: Xt
      }, hn.value == null ? {} : {
        labelInputProps: hn
      }, {
        ref: _e
      })), w && /* @__PURE__ */ V.jsx(cW, ve({
        as: St
      }, nn, {
        children: w
      }))]
    }))
  });
}), dW = {
  500: "#673ab7"
}, pW = {
  900: "#f57f17"
}, fW = {
  500: "#ff5722"
}, Ur = _4({
  createStyledComponent: Or("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => xo({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: zN
}), gW = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), mW = Ii(/* @__PURE__ */ V.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
var vw = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), hW = new Uint8Array(16);
function bW() {
  if (!vw)
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return vw(hW);
}
var WN = [];
for (var Pl = 0; Pl < 256; ++Pl)
  WN[Pl] = (Pl + 256).toString(16).substr(1);
function yW(e, t) {
  var n = 0, r = WN;
  return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("");
}
function vt(e, t, n) {
  var r = t && n || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var a = e.random || (e.rng || bW)();
  if (a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, t)
    for (var i = 0; i < 16; ++i)
      t[r + i] = a[i];
  return t || yW(a);
}
const vW = (e) => Array.isArray(e) ? e.join(" | ") : e, Et = {
  any: lu[500],
  array: yr[400],
  boolean: yr[500],
  integer: Fa[800],
  null: pW[900],
  number: Fa[500],
  string: Pa[500],
  undefined: lu[500],
  object: yr[900],
  properties: dW[500],
  required: fW[500],
  oneof: yr.A100,
  anyof: yr[200],
  allof: yr.A700,
  enum: Pa[900],
  union: lu[500]
}, jr = ({ schema: e, required: t }) => {
  if (e.anyOf) {
    const n = vt();
    return /* @__PURE__ */ V.jsx(
      It,
      {
        itemId: n,
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.anyof }, children: "Any Of" }),
        children: e.anyOf.map((r, a) => /* @__PURE__ */ V.jsxs(rt.Fragment, { children: [
          /* @__PURE__ */ V.jsx(jr, { schema: r }),
          e && e.anyOf && a !== e.anyOf.length - 1 ? /* @__PURE__ */ V.jsx(
            _l,
            {
              style: {
                width: "100px",
                marginBottom: "10px",
                marginTop: "10px",
                height: "3px"
              },
              variant: "inset"
            }
          ) : null
        ] }, vt()))
      }
    );
  }
  return e.allOf ? /* @__PURE__ */ V.jsx(
    It,
    {
      itemId: vt(),
      label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.allof }, children: "All Of" }),
      children: e.allOf.map((n, r) => /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
        /* @__PURE__ */ V.jsx(jr, { schema: n }),
        e && e.allOf && r !== e.allOf.length - 1 ? /* @__PURE__ */ V.jsx(
          _l,
          {
            style: {
              width: "100px",
              marginBottom: "10px",
              marginTop: "10px",
              height: "3px"
            },
            variant: "inset"
          }
        ) : null
      ] }))
    }
  ) : e.oneOf ? /* @__PURE__ */ V.jsxs(
    It,
    {
      itemId: vt(),
      label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.oneof }, children: "One Of" }),
      children: [
        /* @__PURE__ */ V.jsx("div", { style: { marginTop: "10px", marginBottom: "10px" } }),
        e.oneOf.map((n, r) => /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          /* @__PURE__ */ V.jsx(jr, { schema: n }),
          e && e.oneOf && r !== e.oneOf.length - 1 ? /* @__PURE__ */ V.jsx(
            _l,
            {
              style: {
                width: "100px",
                marginBottom: "10px",
                marginTop: "10px",
                height: "3px"
              },
              variant: "inset"
            }
          ) : null
        ] })),
        /* @__PURE__ */ V.jsx("div", { style: { marginTop: "10px", marginBottom: "10px" } })
      ]
    }
  ) : e.items instanceof Array ? /* @__PURE__ */ V.jsxs(
    It,
    {
      itemId: vt(),
      label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.array }, children: "Array" }),
      children: [
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: e.description ? /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
              /* @__PURE__ */ V.jsx(
                ye,
                {
                  style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
                  variant: "caption",
                  children: "description"
                }
              ),
              /* @__PURE__ */ V.jsx(ye, { children: e.description })
            ] }) : null,
            itemId: vt()
          }
        ),
        e.items.map((n, r) => /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          /* @__PURE__ */ V.jsx(jr, { schema: n }),
          e && e.items && r !== e.items.length - 1 ? /* @__PURE__ */ V.jsx(
            _l,
            {
              style: {
                width: "100px",
                marginBottom: "10px",
                marginTop: "10px",
                height: "3px"
              },
              variant: "inset"
            }
          ) : null
        ] }))
      ]
    }
  ) : e.items instanceof Object ? /* @__PURE__ */ V.jsxs(
    It,
    {
      itemId: vt(),
      label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.array }, children: "Array" }),
      children: [
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: e.title ? /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
              /* @__PURE__ */ V.jsx(
                ye,
                {
                  style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
                  variant: "caption",
                  children: "title"
                }
              ),
              /* @__PURE__ */ V.jsx(ye, { children: e.title })
            ] }) : null,
            itemId: vt()
          }
        ),
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: e.description ? /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
              /* @__PURE__ */ V.jsx(
                ye,
                {
                  style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
                  variant: "caption",
                  children: "description"
                }
              ),
              /* @__PURE__ */ V.jsx(ye, { children: e.description })
            ] }) : null,
            itemId: vt()
          }
        ),
        /* @__PURE__ */ V.jsx(jr, { schema: e.items })
      ]
    }
  ) : e.properties ? /* @__PURE__ */ V.jsxs(
    It,
    {
      itemId: vt(),
      label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.object }, children: "Object" }),
      children: [
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: e.title ? /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
              /* @__PURE__ */ V.jsx(
                ye,
                {
                  style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
                  variant: "caption",
                  children: "title"
                }
              ),
              /* @__PURE__ */ V.jsx(ye, { children: e.title })
            ] }) : null,
            itemId: vt()
          }
        ),
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: e.description ? /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
              /* @__PURE__ */ V.jsx(
                ye,
                {
                  style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
                  variant: "caption",
                  children: "description"
                }
              ),
              /* @__PURE__ */ V.jsx(ye, { children: e.description })
            ] }) : null,
            itemId: vt()
          }
        ),
        /* @__PURE__ */ V.jsx(
          It,
          {
            label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.properties }, children: "properties" }),
            itemId: vt(),
            children: e.properties && Object.entries(e.properties).map(([n, r], a) => {
              const i = r;
              return /* @__PURE__ */ V.jsx(It, { label: n, itemId: vt(), children: /* @__PURE__ */ V.jsx(
                jr,
                {
                  schema: i,
                  required: e.required && e.required.includes(n)
                }
              ) }, `schema-${a}`);
            })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    e.title && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
              variant: "caption",
              children: "title"
            }
          ),
          /* @__PURE__ */ V.jsx(ye, { style: { color: Et.title }, children: e.title })
        ] }),
        itemId: vt()
      }
    ),
    e.type && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
              variant: "caption",
              children: "type"
            }
          ),
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: {
                color: Array.isArray(e.type) ? Et.union : Et[e.type]
              },
              children: vW(e.type)
            }
          )
        ] }),
        itemId: vt()
      }
    ),
    e.description && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
              variant: "caption",
              children: "description"
            }
          ),
          /* @__PURE__ */ V.jsx(ye, { children: e.description })
        ] }),
        itemId: vt()
      }
    ),
    e.pattern && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
              variant: "caption",
              children: "pattern"
            }
          ),
          /* @__PURE__ */ V.jsx(ye, { children: e.pattern })
        ] }),
        itemId: vt()
      }
    ),
    e.const && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsxs(Ur, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 1, children: [
          /* @__PURE__ */ V.jsx(
            ye,
            {
              style: { color: Et.undefined, marginRight: "4px", marginLeft: "4px" },
              variant: "caption",
              children: "const"
            }
          ),
          /* @__PURE__ */ V.jsx(ye, { children: e.const })
        ] }),
        itemId: vt()
      }
    ),
    t && /* @__PURE__ */ V.jsx(
      It,
      {
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.required }, children: "required" }),
        itemId: vt()
      }
    ),
    e.enum && /* @__PURE__ */ V.jsx(
      It,
      {
        itemId: vt(),
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.enum, marginRight: "4px", marginLeft: "4px" }, children: "enum" }),
        children: e.enum.map((n, r) => {
          const a = n ? n.toString() : null;
          return /* @__PURE__ */ V.jsx(
            It,
            {
              itemId: vt(),
              label: /* @__PURE__ */ V.jsx(ye, { style: { marginRight: "4px", marginLeft: "4px" }, children: a })
            },
            `enum-${r}`
          );
        })
      }
    ),
    e.if && /* @__PURE__ */ V.jsx(
      It,
      {
        itemId: vt(),
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.enum, marginRight: "4px", marginLeft: "4px" }, children: "if" }),
        children: /* @__PURE__ */ V.jsx(jr, { schema: e.if })
      }
    ),
    e.then && /* @__PURE__ */ V.jsx(
      It,
      {
        itemId: vt(),
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.enum, marginRight: "4px", marginLeft: "4px" }, children: "then" }),
        children: /* @__PURE__ */ V.jsx(jr, { schema: e.then })
      }
    ),
    e.else && /* @__PURE__ */ V.jsx(
      It,
      {
        itemId: vt(),
        label: /* @__PURE__ */ V.jsx(ye, { style: { color: Et.enum, marginRight: "4px", marginLeft: "4px" }, children: "else" }),
        children: /* @__PURE__ */ V.jsx(jr, { schema: e.else })
      }
    )
  ] });
}, KN = ({ schema: e }) => /* @__PURE__ */ V.jsx(
  _5,
  {
    "aria-label": "json schema tree",
    slots: {
      expandIcon: mW,
      collapseIcon: gW
    },
    children: /* @__PURE__ */ V.jsx(jr, { schema: e })
  }
);
function EW(e, t) {
  if (e == null) return {};
  var n, r, a = Be(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
function Iy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function SW(e) {
  if (Array.isArray(e)) return Iy(e);
}
function xW(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function TW(e, t) {
  if (e) {
    if (typeof e == "string") return Iy(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Iy(e, t) : void 0;
  }
}
function wW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ry(e) {
  return SW(e) || xW(e) || TW(e) || wW();
}
function Ss(e) {
  "@babel/helpers - typeof";
  return Ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ss(e);
}
function AW(e, t) {
  if (Ss(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ss(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function IW(e) {
  var t = AW(e, "string");
  return Ss(t) == "symbol" ? t : t + "";
}
function YN(e, t, n) {
  return (t = IW(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ew(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function to(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ew(Object(n), !0).forEach(function(r) {
      YN(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ew(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function RW(e) {
  var t = e.length;
  if (t === 0 || t === 1) return e;
  if (t === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (t === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (t >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var Zd = {};
function _W(e) {
  if (e.length === 0 || e.length === 1) return e;
  var t = e.join(".");
  return Zd[t] || (Zd[t] = RW(e)), Zd[t];
}
function CW(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = e.filter(function(i) {
    return i !== "token";
  }), a = _W(r);
  return a.reduce(function(i, s) {
    return to(to({}, i), n[s]);
  }, t);
}
function Sw(e) {
  return e.join(" ");
}
function kW(e, t) {
  var n = 0;
  return function(r) {
    return n += 1, r.map(function(a, i) {
      return XN({
        node: a,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(n, "-").concat(i)
      });
    });
  };
}
function XN(e) {
  var t = e.node, n = e.stylesheet, r = e.style, a = r === void 0 ? {} : r, i = e.useInlineStyles, s = e.key, u = t.properties, c = t.type, d = t.tagName, p = t.value;
  if (c === "text")
    return p;
  if (d) {
    var f = kW(n, i), m;
    if (!i)
      m = to(to({}, u), {}, {
        className: Sw(u.className)
      });
    else {
      var h = Object.keys(n).reduce(function(x, I) {
        return I.split(".").forEach(function(S) {
          x.includes(S) || x.push(S);
        }), x;
      }, []), E = u.className && u.className.includes("token") ? ["token"] : [], y = u.className && E.concat(u.className.filter(function(x) {
        return !h.includes(x);
      }));
      m = to(to({}, u), {}, {
        className: Sw(y) || void 0,
        style: CW(u.className, Object.assign({}, u.style, a), n)
      });
    }
    var w = f(t.children);
    return /* @__PURE__ */ rt.createElement(d, K({
      key: s
    }, m), w);
  }
}
const NW = function(e, t) {
  var n = e.listLanguages();
  return n.indexOf(t) !== -1;
};
var OW = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function xw(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $a(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xw(Object(n), !0).forEach(function(r) {
      YN(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xw(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var LW = /\n/g;
function DW(e) {
  return e.match(LW);
}
function MW(e) {
  var t = e.lines, n = e.startingLineNumber, r = e.style;
  return t.map(function(a, i) {
    var s = i + n;
    return /* @__PURE__ */ rt.createElement("span", {
      key: "line-".concat(i),
      className: "react-syntax-highlighter-line-number",
      style: typeof r == "function" ? r(s) : r
    }, "".concat(s, `
`));
  });
}
function FW(e) {
  var t = e.codeString, n = e.codeStyle, r = e.containerStyle, a = r === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : r, i = e.numberStyle, s = i === void 0 ? {} : i, u = e.startingLineNumber;
  return /* @__PURE__ */ rt.createElement("code", {
    style: Object.assign({}, n, a)
  }, MW({
    lines: t.replace(/\n$/, "").split(`
`),
    style: s,
    startingLineNumber: u
  }));
}
function PW(e) {
  return "".concat(e.toString().length, ".25em");
}
function ZN(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function JN(e, t, n) {
  var r = {
    display: "inline-block",
    minWidth: PW(n),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, a = typeof e == "function" ? e(t) : e, i = $a($a({}, r), a);
  return i;
}
function uu(e) {
  var t = e.children, n = e.lineNumber, r = e.lineNumberStyle, a = e.largestLineNumber, i = e.showInlineLineNumbers, s = e.lineProps, u = s === void 0 ? {} : s, c = e.className, d = c === void 0 ? [] : c, p = e.showLineNumbers, f = e.wrapLongLines, m = e.wrapLines, h = m === void 0 ? !1 : m, E = h ? $a({}, typeof u == "function" ? u(n) : u) : {};
  if (E.className = E.className ? [].concat(Ry(E.className.trim().split(/\s+/)), Ry(d)) : d, n && i) {
    var y = JN(r, n, a);
    t.unshift(ZN(n, y));
  }
  return f & p && (E.style = $a({
    display: "flex"
  }, E.style)), {
    type: "element",
    tagName: "span",
    properties: E,
    children: t
  };
}
function QN(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = 0; r < e.length; r++) {
    var a = e[r];
    if (a.type === "text")
      n.push(uu({
        children: [a],
        className: Ry(new Set(t))
      }));
    else if (a.children) {
      var i = t.concat(a.properties.className);
      QN(a.children, i).forEach(function(s) {
        return n.push(s);
      });
    }
  }
  return n;
}
function BW(e, t, n, r, a, i, s, u, c) {
  var d, p = QN(e.value), f = [], m = -1, h = 0;
  function E(T, A) {
    var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return uu({
      children: T,
      lineNumber: A,
      lineNumberStyle: u,
      largestLineNumber: s,
      showInlineLineNumbers: a,
      lineProps: n,
      className: O,
      showLineNumbers: r,
      wrapLongLines: c,
      wrapLines: t
    });
  }
  function y(T, A) {
    if (r && A && a) {
      var O = JN(u, A, s);
      T.unshift(ZN(A, O));
    }
    return T;
  }
  function w(T, A) {
    var O = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || O.length > 0 ? E(T, A, O) : y(T, A);
  }
  for (var x = function() {
    var A = p[h], O = A.children[0].value, U = DW(O);
    if (U) {
      var P = O.split(`
`);
      P.forEach(function(b, L) {
        var j = r && f.length + i, G = {
          type: "text",
          value: "".concat(b, `
`)
        };
        if (L === 0) {
          var H = p.slice(m + 1, h).concat(uu({
            children: [G],
            className: A.properties.className
          })), ne = w(H, j);
          f.push(ne);
        } else if (L === P.length - 1) {
          var ue = p[h + 1] && p[h + 1].children && p[h + 1].children[0], ce = {
            type: "text",
            value: "".concat(b)
          };
          if (ue) {
            var Q = uu({
              children: [ce],
              className: A.properties.className
            });
            p.splice(h + 1, 0, Q);
          } else {
            var de = [ce], D = w(de, j, A.properties.className);
            f.push(D);
          }
        } else {
          var le = [G], Ae = w(le, j, A.properties.className);
          f.push(Ae);
        }
      }), m = h;
    }
    h++;
  }; h < p.length; )
    x();
  if (m !== p.length - 1) {
    var I = p.slice(m + 1, p.length);
    if (I && I.length) {
      var S = r && f.length + i, C = w(I, S);
      f.push(C);
    }
  }
  return t ? f : (d = []).concat.apply(d, f);
}
function $W(e) {
  var t = e.rows, n = e.stylesheet, r = e.useInlineStyles;
  return t.map(function(a, i) {
    return XN({
      node: a,
      stylesheet: n,
      useInlineStyles: r,
      key: "code-segement".concat(i)
    });
  });
}
function e1(e) {
  return e && typeof e.highlightAuto < "u";
}
function UW(e) {
  var t = e.astGenerator, n = e.language, r = e.code, a = e.defaultCodeValue;
  if (e1(t)) {
    var i = NW(t, n);
    return n === "text" ? {
      value: a,
      language: "text"
    } : i ? t.highlight(n, r) : t.highlightAuto(r);
  }
  try {
    return n && n !== "text" ? {
      value: t.highlight(r, n)
    } : {
      value: a
    };
  } catch {
    return {
      value: a
    };
  }
}
function jW(e, t) {
  return function(r) {
    var a = r.language, i = r.children, s = r.style, u = s === void 0 ? t : s, c = r.customStyle, d = c === void 0 ? {} : c, p = r.codeTagProps, f = p === void 0 ? {
      className: a ? "language-".concat(a) : void 0,
      style: $a($a({}, u['code[class*="language-"]']), u['code[class*="language-'.concat(a, '"]')])
    } : p, m = r.useInlineStyles, h = m === void 0 ? !0 : m, E = r.showLineNumbers, y = E === void 0 ? !1 : E, w = r.showInlineLineNumbers, x = w === void 0 ? !0 : w, I = r.startingLineNumber, S = I === void 0 ? 1 : I, C = r.lineNumberContainerStyle, T = r.lineNumberStyle, A = T === void 0 ? {} : T, O = r.wrapLines, U = r.wrapLongLines, P = U === void 0 ? !1 : U, b = r.lineProps, L = b === void 0 ? {} : b, j = r.renderer, G = r.PreTag, H = G === void 0 ? "pre" : G, ne = r.CodeTag, ue = ne === void 0 ? "code" : ne, ce = r.code, Q = ce === void 0 ? (Array.isArray(i) ? i[0] : i) || "" : ce, de = r.astGenerator, D = EW(r, OW);
    de = de || e;
    var le = y ? /* @__PURE__ */ rt.createElement(FW, {
      containerStyle: C,
      codeStyle: f.style || {},
      numberStyle: A,
      startingLineNumber: S,
      codeString: Q
    }) : null, Ae = u.hljs || u['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, M = e1(de) ? "hljs" : "prismjs", he = h ? Object.assign({}, D, {
      style: Object.assign({}, Ae, d)
    }) : Object.assign({}, D, {
      className: D.className ? "".concat(M, " ").concat(D.className) : M,
      style: Object.assign({}, d)
    });
    if (P ? f.style = $a({
      whiteSpace: "pre-wrap"
    }, f.style) : f.style = $a({
      whiteSpace: "pre"
    }, f.style), !de)
      return /* @__PURE__ */ rt.createElement(H, he, le, /* @__PURE__ */ rt.createElement(ue, f, Q));
    (O === void 0 && j || P) && (O = !0), j = j || $W;
    var se = [{
      type: "text",
      value: Q
    }], ie = UW({
      astGenerator: de,
      language: a,
      code: Q,
      defaultCodeValue: se
    });
    ie.language === null && (ie.value = se);
    var xe = ie.value.length;
    xe === 1 && ie.value[0].type === "text" && (xe = ie.value[0].value.split(`
`).length);
    var _e = xe + S, Le = BW(ie, O, L, y, x, S, _e, A, P);
    return /* @__PURE__ */ rt.createElement(H, he, /* @__PURE__ */ rt.createElement(ue, f, !x && le, j({
      rows: Le,
      stylesheet: u,
      useInlineStyles: h
    })));
  };
}
const qW = ["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apex", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "asmatmel", "aspnet", "autohotkey", "autoit", "avisynth", "avro-idl", "bash", "basic", "batch", "bbcode", "bicep", "birb", "bison", "bnf", "brainfuck", "brightscript", "bro", "bsl", "c", "cfscript", "chaiscript", "cil", "clike", "clojure", "cmake", "cobol", "coffeescript", "concurnas", "coq", "cpp", "crystal", "csharp", "cshtml", "csp", "css-extras", "css", "csv", "cypher", "d", "dart", "dataweave", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "dot", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "false", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gap", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "gn", "go-module", "go", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hoon", "hpkp", "hsts", "http", "ichigojam", "icon", "icu-message-format", "idris", "iecst", "ignore", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jexl", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keepalived", "keyman", "kotlin", "kumir", "kusto", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "log", "lolcode", "lua", "magma", "makefile", "markdown", "markup-templating", "markup", "matlab", "maxscript", "mel", "mermaid", "mizar", "mongodb", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "naniscript", "nasm", "neon", "nevod", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "openqasm", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php-extras", "php", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "promql", "properties", "protobuf", "psl", "pug", "puppet", "pure", "purebasic", "purescript", "python", "q", "qml", "qore", "qsharp", "r", "racket", "reason", "regex", "rego", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "sml", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "squirrel", "stan", "stylus", "swift", "systemd", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tremor", "tsx", "tt2", "turtle", "twig", "typescript", "typoscript", "unrealscript", "uorazor", "uri", "v", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "web-idl", "wiki", "wolfram", "wren", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"];
var Jd, Tw;
function zW() {
  if (Tw) return Jd;
  Tw = 1, Jd = t;
  var e = Object.prototype.hasOwnProperty;
  function t() {
    for (var n = {}, r = 0; r < arguments.length; r++) {
      var a = arguments[r];
      for (var i in a)
        e.call(a, i) && (n[i] = a[i]);
    }
    return n;
  }
  return Jd;
}
var Qd, ww;
function t1() {
  if (ww) return Qd;
  ww = 1, Qd = t;
  var e = t.prototype;
  e.space = null, e.normal = {}, e.property = {};
  function t(n, r, a) {
    this.property = n, this.normal = r, a && (this.space = a);
  }
  return Qd;
}
var ep, Aw;
function GW() {
  if (Aw) return ep;
  Aw = 1;
  var e = zW(), t = t1();
  ep = n;
  function n(r) {
    for (var a = r.length, i = [], s = [], u = -1, c, d; ++u < a; )
      c = r[u], i.push(c.property), s.push(c.normal), d = c.space;
    return new t(
      e.apply(null, i),
      e.apply(null, s),
      d
    );
  }
  return ep;
}
var tp, Iw;
function Dv() {
  if (Iw) return tp;
  Iw = 1, tp = e;
  function e(t) {
    return t.toLowerCase();
  }
  return tp;
}
var np, Rw;
function n1() {
  if (Rw) return np;
  Rw = 1, np = t;
  var e = t.prototype;
  e.space = null, e.attribute = null, e.property = null, e.boolean = !1, e.booleanish = !1, e.overloadedBoolean = !1, e.number = !1, e.commaSeparated = !1, e.spaceSeparated = !1, e.commaOrSpaceSeparated = !1, e.mustUseProperty = !1, e.defined = !1;
  function t(n, r) {
    this.property = n, this.attribute = r;
  }
  return np;
}
var ga = {}, _w;
function Mv() {
  if (_w) return ga;
  _w = 1;
  var e = 0;
  ga.boolean = t(), ga.booleanish = t(), ga.overloadedBoolean = t(), ga.number = t(), ga.spaceSeparated = t(), ga.commaSeparated = t(), ga.commaOrSpaceSeparated = t();
  function t() {
    return Math.pow(2, ++e);
  }
  return ga;
}
var rp, Cw;
function r1() {
  if (Cw) return rp;
  Cw = 1;
  var e = n1(), t = Mv();
  rp = a, a.prototype = new e(), a.prototype.defined = !0;
  var n = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
  ], r = n.length;
  function a(s, u, c, d) {
    var p = -1, f;
    for (i(this, "space", d), e.call(this, s, u); ++p < r; )
      f = n[p], i(this, f, (c & t[f]) === t[f]);
  }
  function i(s, u, c) {
    c && (s[u] = c);
  }
  return rp;
}
var ap, kw;
function Ms() {
  if (kw) return ap;
  kw = 1;
  var e = Dv(), t = t1(), n = r1();
  ap = r;
  function r(a) {
    var i = a.space, s = a.mustUseProperty || [], u = a.attributes || {}, c = a.properties, d = a.transform, p = {}, f = {}, m, h;
    for (m in c)
      h = new n(
        m,
        d(u, m),
        c[m],
        i
      ), s.indexOf(m) !== -1 && (h.mustUseProperty = !0), p[m] = h, f[e(m)] = m, f[e(h.attribute)] = m;
    return new t(p, f, i);
  }
  return ap;
}
var ip, Nw;
function HW() {
  if (Nw) return ip;
  Nw = 1;
  var e = Ms();
  ip = e({
    space: "xlink",
    transform: t,
    properties: {
      xLinkActuate: null,
      xLinkArcRole: null,
      xLinkHref: null,
      xLinkRole: null,
      xLinkShow: null,
      xLinkTitle: null,
      xLinkType: null
    }
  });
  function t(n, r) {
    return "xlink:" + r.slice(5).toLowerCase();
  }
  return ip;
}
var op, Ow;
function VW() {
  if (Ow) return op;
  Ow = 1;
  var e = Ms();
  op = e({
    space: "xml",
    transform: t,
    properties: {
      xmlLang: null,
      xmlBase: null,
      xmlSpace: null
    }
  });
  function t(n, r) {
    return "xml:" + r.slice(3).toLowerCase();
  }
  return op;
}
var sp, Lw;
function WW() {
  if (Lw) return sp;
  Lw = 1, sp = e;
  function e(t, n) {
    return n in t ? t[n] : n;
  }
  return sp;
}
var lp, Dw;
function a1() {
  if (Dw) return lp;
  Dw = 1;
  var e = WW();
  lp = t;
  function t(n, r) {
    return e(n, r.toLowerCase());
  }
  return lp;
}
var up, Mw;
function KW() {
  if (Mw) return up;
  Mw = 1;
  var e = Ms(), t = a1();
  return up = e({
    space: "xmlns",
    attributes: {
      xmlnsxlink: "xmlns:xlink"
    },
    transform: t,
    properties: {
      xmlns: null,
      xmlnsXLink: null
    }
  }), up;
}
var cp, Fw;
function YW() {
  if (Fw) return cp;
  Fw = 1;
  var e = Mv(), t = Ms(), n = e.booleanish, r = e.number, a = e.spaceSeparated;
  cp = t({
    transform: i,
    properties: {
      ariaActiveDescendant: null,
      ariaAtomic: n,
      ariaAutoComplete: null,
      ariaBusy: n,
      ariaChecked: n,
      ariaColCount: r,
      ariaColIndex: r,
      ariaColSpan: r,
      ariaControls: a,
      ariaCurrent: null,
      ariaDescribedBy: a,
      ariaDetails: null,
      ariaDisabled: n,
      ariaDropEffect: a,
      ariaErrorMessage: null,
      ariaExpanded: n,
      ariaFlowTo: a,
      ariaGrabbed: n,
      ariaHasPopup: null,
      ariaHidden: n,
      ariaInvalid: null,
      ariaKeyShortcuts: null,
      ariaLabel: null,
      ariaLabelledBy: a,
      ariaLevel: r,
      ariaLive: null,
      ariaModal: n,
      ariaMultiLine: n,
      ariaMultiSelectable: n,
      ariaOrientation: null,
      ariaOwns: a,
      ariaPlaceholder: null,
      ariaPosInSet: r,
      ariaPressed: n,
      ariaReadOnly: n,
      ariaRelevant: null,
      ariaRequired: n,
      ariaRoleDescription: a,
      ariaRowCount: r,
      ariaRowIndex: r,
      ariaRowSpan: r,
      ariaSelected: n,
      ariaSetSize: r,
      ariaSort: null,
      ariaValueMax: r,
      ariaValueMin: r,
      ariaValueNow: r,
      ariaValueText: null,
      role: null
    }
  });
  function i(s, u) {
    return u === "role" ? u : "aria-" + u.slice(4).toLowerCase();
  }
  return cp;
}
var dp, Pw;
function XW() {
  if (Pw) return dp;
  Pw = 1;
  var e = Mv(), t = Ms(), n = a1(), r = e.boolean, a = e.overloadedBoolean, i = e.booleanish, s = e.number, u = e.spaceSeparated, c = e.commaSeparated;
  return dp = t({
    space: "html",
    attributes: {
      acceptcharset: "accept-charset",
      classname: "class",
      htmlfor: "for",
      httpequiv: "http-equiv"
    },
    transform: n,
    mustUseProperty: ["checked", "multiple", "muted", "selected"],
    properties: {
      // Standard Properties.
      abbr: null,
      accept: c,
      acceptCharset: u,
      accessKey: u,
      action: null,
      allow: null,
      allowFullScreen: r,
      allowPaymentRequest: r,
      allowUserMedia: r,
      alt: null,
      as: null,
      async: r,
      autoCapitalize: null,
      autoComplete: u,
      autoFocus: r,
      autoPlay: r,
      capture: r,
      charSet: null,
      checked: r,
      cite: null,
      className: u,
      cols: s,
      colSpan: null,
      content: null,
      contentEditable: i,
      controls: r,
      controlsList: u,
      coords: s | c,
      crossOrigin: null,
      data: null,
      dateTime: null,
      decoding: null,
      default: r,
      defer: r,
      dir: null,
      dirName: null,
      disabled: r,
      download: a,
      draggable: i,
      encType: null,
      enterKeyHint: null,
      form: null,
      formAction: null,
      formEncType: null,
      formMethod: null,
      formNoValidate: r,
      formTarget: null,
      headers: u,
      height: s,
      hidden: r,
      high: s,
      href: null,
      hrefLang: null,
      htmlFor: u,
      httpEquiv: u,
      id: null,
      imageSizes: null,
      imageSrcSet: c,
      inputMode: null,
      integrity: null,
      is: null,
      isMap: r,
      itemId: null,
      itemProp: u,
      itemRef: u,
      itemScope: r,
      itemType: u,
      kind: null,
      label: null,
      lang: null,
      language: null,
      list: null,
      loading: null,
      loop: r,
      low: s,
      manifest: null,
      max: null,
      maxLength: s,
      media: null,
      method: null,
      min: null,
      minLength: s,
      multiple: r,
      muted: r,
      name: null,
      nonce: null,
      noModule: r,
      noValidate: r,
      onAbort: null,
      onAfterPrint: null,
      onAuxClick: null,
      onBeforePrint: null,
      onBeforeUnload: null,
      onBlur: null,
      onCancel: null,
      onCanPlay: null,
      onCanPlayThrough: null,
      onChange: null,
      onClick: null,
      onClose: null,
      onContextMenu: null,
      onCopy: null,
      onCueChange: null,
      onCut: null,
      onDblClick: null,
      onDrag: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragExit: null,
      onDragLeave: null,
      onDragOver: null,
      onDragStart: null,
      onDrop: null,
      onDurationChange: null,
      onEmptied: null,
      onEnded: null,
      onError: null,
      onFocus: null,
      onFormData: null,
      onHashChange: null,
      onInput: null,
      onInvalid: null,
      onKeyDown: null,
      onKeyPress: null,
      onKeyUp: null,
      onLanguageChange: null,
      onLoad: null,
      onLoadedData: null,
      onLoadedMetadata: null,
      onLoadEnd: null,
      onLoadStart: null,
      onMessage: null,
      onMessageError: null,
      onMouseDown: null,
      onMouseEnter: null,
      onMouseLeave: null,
      onMouseMove: null,
      onMouseOut: null,
      onMouseOver: null,
      onMouseUp: null,
      onOffline: null,
      onOnline: null,
      onPageHide: null,
      onPageShow: null,
      onPaste: null,
      onPause: null,
      onPlay: null,
      onPlaying: null,
      onPopState: null,
      onProgress: null,
      onRateChange: null,
      onRejectionHandled: null,
      onReset: null,
      onResize: null,
      onScroll: null,
      onSecurityPolicyViolation: null,
      onSeeked: null,
      onSeeking: null,
      onSelect: null,
      onSlotChange: null,
      onStalled: null,
      onStorage: null,
      onSubmit: null,
      onSuspend: null,
      onTimeUpdate: null,
      onToggle: null,
      onUnhandledRejection: null,
      onUnload: null,
      onVolumeChange: null,
      onWaiting: null,
      onWheel: null,
      open: r,
      optimum: s,
      pattern: null,
      ping: u,
      placeholder: null,
      playsInline: r,
      poster: null,
      preload: null,
      readOnly: r,
      referrerPolicy: null,
      rel: u,
      required: r,
      reversed: r,
      rows: s,
      rowSpan: s,
      sandbox: u,
      scope: null,
      scoped: r,
      seamless: r,
      selected: r,
      shape: null,
      size: s,
      sizes: null,
      slot: null,
      span: s,
      spellCheck: i,
      src: null,
      srcDoc: null,
      srcLang: null,
      srcSet: c,
      start: s,
      step: null,
      style: null,
      tabIndex: s,
      target: null,
      title: null,
      translate: null,
      type: null,
      typeMustMatch: r,
      useMap: null,
      value: i,
      width: s,
      wrap: null,
      // Legacy.
      // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
      align: null,
      // Several. Use CSS `text-align` instead,
      aLink: null,
      // `<body>`. Use CSS `a:active {color}` instead
      archive: u,
      // `<object>`. List of URIs to archives
      axis: null,
      // `<td>` and `<th>`. Use `scope` on `<th>`
      background: null,
      // `<body>`. Use CSS `background-image` instead
      bgColor: null,
      // `<body>` and table elements. Use CSS `background-color` instead
      border: s,
      // `<table>`. Use CSS `border-width` instead,
      borderColor: null,
      // `<table>`. Use CSS `border-color` instead,
      bottomMargin: s,
      // `<body>`
      cellPadding: null,
      // `<table>`
      cellSpacing: null,
      // `<table>`
      char: null,
      // Several table elements. When `align=char`, sets the character to align on
      charOff: null,
      // Several table elements. When `char`, offsets the alignment
      classId: null,
      // `<object>`
      clear: null,
      // `<br>`. Use CSS `clear` instead
      code: null,
      // `<object>`
      codeBase: null,
      // `<object>`
      codeType: null,
      // `<object>`
      color: null,
      // `<font>` and `<hr>`. Use CSS instead
      compact: r,
      // Lists. Use CSS to reduce space between items instead
      declare: r,
      // `<object>`
      event: null,
      // `<script>`
      face: null,
      // `<font>`. Use CSS instead
      frame: null,
      // `<table>`
      frameBorder: null,
      // `<iframe>`. Use CSS `border` instead
      hSpace: s,
      // `<img>` and `<object>`
      leftMargin: s,
      // `<body>`
      link: null,
      // `<body>`. Use CSS `a:link {color: *}` instead
      longDesc: null,
      // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
      lowSrc: null,
      // `<img>`. Use a `<picture>`
      marginHeight: s,
      // `<body>`
      marginWidth: s,
      // `<body>`
      noResize: r,
      // `<frame>`
      noHref: r,
      // `<area>`. Use no href instead of an explicit `nohref`
      noShade: r,
      // `<hr>`. Use background-color and height instead of borders
      noWrap: r,
      // `<td>` and `<th>`
      object: null,
      // `<applet>`
      profile: null,
      // `<head>`
      prompt: null,
      // `<isindex>`
      rev: null,
      // `<link>`
      rightMargin: s,
      // `<body>`
      rules: null,
      // `<table>`
      scheme: null,
      // `<meta>`
      scrolling: i,
      // `<frame>`. Use overflow in the child context
      standby: null,
      // `<object>`
      summary: null,
      // `<table>`
      text: null,
      // `<body>`. Use CSS `color` instead
      topMargin: s,
      // `<body>`
      valueType: null,
      // `<param>`
      version: null,
      // `<html>`. Use a doctype.
      vAlign: null,
      // Several. Use CSS `vertical-align` instead
      vLink: null,
      // `<body>`. Use CSS `a:visited {color}` instead
      vSpace: s,
      // `<img>` and `<object>`
      // Non-standard Properties.
      allowTransparency: null,
      autoCorrect: null,
      autoSave: null,
      disablePictureInPicture: r,
      disableRemotePlayback: r,
      prefix: null,
      property: null,
      results: s,
      security: null,
      unselectable: null
    }
  }), dp;
}
var pp, Bw;
function ZW() {
  if (Bw) return pp;
  Bw = 1;
  var e = GW(), t = HW(), n = VW(), r = KW(), a = YW(), i = XW();
  return pp = e([n, t, r, a, i]), pp;
}
var fp, $w;
function JW() {
  if ($w) return fp;
  $w = 1;
  var e = Dv(), t = r1(), n = n1(), r = "data";
  fp = u;
  var a = /^data[-\w.:]+$/i, i = /-[a-z]/g, s = /[A-Z]/g;
  function u(m, h) {
    var E = e(h), y = h, w = n;
    return E in m.normal ? m.property[m.normal[E]] : (E.length > 4 && E.slice(0, 4) === r && a.test(h) && (h.charAt(4) === "-" ? y = c(h) : h = d(h), w = t), new w(y, h));
  }
  function c(m) {
    var h = m.slice(5).replace(i, f);
    return r + h.charAt(0).toUpperCase() + h.slice(1);
  }
  function d(m) {
    var h = m.slice(4);
    return i.test(h) ? m : (h = h.replace(s, p), h.charAt(0) !== "-" && (h = "-" + h), r + h);
  }
  function p(m) {
    return "-" + m.toLowerCase();
  }
  function f(m) {
    return m.charAt(1).toUpperCase();
  }
  return fp;
}
var gp, Uw;
function QW() {
  if (Uw) return gp;
  Uw = 1, gp = t;
  var e = /[#.]/g;
  function t(n, r) {
    for (var a = n || "", i = r || "div", s = {}, u = 0, c, d, p; u < a.length; )
      e.lastIndex = u, p = e.exec(a), c = a.slice(u, p ? p.index : a.length), c && (d ? d === "#" ? s.id = c : s.className ? s.className.push(c) : s.className = [c] : i = c, u += c.length), p && (d = p[0], u++);
    return { type: "element", tagName: i, properties: s, children: [] };
  }
  return gp;
}
var Bl = {}, jw;
function e6() {
  if (jw) return Bl;
  jw = 1, Bl.parse = r, Bl.stringify = a;
  var e = "", t = " ", n = /[ \t\n\r\f]+/g;
  function r(i) {
    var s = String(i || e).trim();
    return s === e ? [] : s.split(n);
  }
  function a(i) {
    return i.join(t).trim();
  }
  return Bl;
}
var $l = {}, qw;
function t6() {
  if (qw) return $l;
  qw = 1, $l.parse = r, $l.stringify = a;
  var e = ",", t = " ", n = "";
  function r(i) {
    for (var s = [], u = String(i || n), c = u.indexOf(e), d = 0, p = !1, f; !p; )
      c === -1 && (c = u.length, p = !0), f = u.slice(d, c).trim(), (f || !p) && s.push(f), d = c + 1, c = u.indexOf(e, d);
    return s;
  }
  function a(i, s) {
    var u = s || {}, c = u.padLeft === !1 ? n : t, d = u.padRight ? t : n;
    return i[i.length - 1] === n && (i = i.concat(n)), i.join(d + e + c).trim();
  }
  return $l;
}
var mp, zw;
function n6() {
  if (zw) return mp;
  zw = 1;
  var e = JW(), t = Dv(), n = QW(), r = e6().parse, a = t6().parse;
  mp = s;
  var i = {}.hasOwnProperty;
  function s(E, y, w) {
    var x = w ? h(w) : null;
    return I;
    function I(C, T) {
      var A = n(C, y), O = Array.prototype.slice.call(arguments, 2), U = A.tagName.toLowerCase(), P;
      if (A.tagName = x && i.call(x, U) ? x[U] : U, T && u(T, A) && (O.unshift(T), T = null), T)
        for (P in T)
          S(A.properties, P, T[P]);
      return d(A.children, O), A.tagName === "template" && (A.content = { type: "root", children: A.children }, A.children = []), A;
    }
    function S(C, T, A) {
      var O, U, P;
      A == null || A !== A || (O = e(E, T), U = O.property, P = A, typeof P == "string" && (O.spaceSeparated ? P = r(P) : O.commaSeparated ? P = a(P) : O.commaOrSpaceSeparated && (P = r(a(P).join(" ")))), U === "style" && typeof A != "string" && (P = m(P)), U === "className" && C.className && (P = C.className.concat(P)), C[U] = p(O, U, P));
    }
  }
  function u(E, y) {
    return typeof E == "string" || "length" in E || c(y.tagName, E);
  }
  function c(E, y) {
    var w = y.type;
    return E === "input" || !w || typeof w != "string" ? !1 : typeof y.children == "object" && "length" in y.children ? !0 : (w = w.toLowerCase(), E === "button" ? w !== "menu" && w !== "submit" && w !== "reset" && w !== "button" : "value" in y);
  }
  function d(E, y) {
    var w, x;
    if (typeof y == "string" || typeof y == "number") {
      E.push({ type: "text", value: String(y) });
      return;
    }
    if (typeof y == "object" && "length" in y) {
      for (w = -1, x = y.length; ++w < x; )
        d(E, y[w]);
      return;
    }
    if (typeof y != "object" || !("type" in y))
      throw new Error("Expected node, nodes, or string, got `" + y + "`");
    E.push(y);
  }
  function p(E, y, w) {
    var x, I, S;
    if (typeof w != "object" || !("length" in w))
      return f(E, y, w);
    for (I = w.length, x = -1, S = []; ++x < I; )
      S[x] = f(E, y, w[x]);
    return S;
  }
  function f(E, y, w) {
    var x = w;
    return E.number || E.positiveNumber ? !isNaN(x) && x !== "" && (x = Number(x)) : (E.boolean || E.overloadedBoolean) && typeof x == "string" && (x === "" || t(w) === t(y)) && (x = !0), x;
  }
  function m(E) {
    var y = [], w;
    for (w in E)
      y.push([w, E[w]].join(": "));
    return y.join("; ");
  }
  function h(E) {
    for (var y = E.length, w = -1, x = {}, I; ++w < y; )
      I = E[w], x[I.toLowerCase()] = I;
    return x;
  }
  return mp;
}
var hp, Gw;
function r6() {
  if (Gw) return hp;
  Gw = 1;
  var e = ZW(), t = n6(), n = t(e, "div");
  return n.displayName = "html", hp = n, hp;
}
var bp, Hw;
function a6() {
  return Hw || (Hw = 1, bp = r6()), bp;
}
const i6 = "Æ", o6 = "&", s6 = "Á", l6 = "Â", u6 = "À", c6 = "Å", d6 = "Ã", p6 = "Ä", f6 = "©", g6 = "Ç", m6 = "Ð", h6 = "É", b6 = "Ê", y6 = "È", v6 = "Ë", E6 = ">", S6 = "Í", x6 = "Î", T6 = "Ì", w6 = "Ï", A6 = "<", I6 = "Ñ", R6 = "Ó", _6 = "Ô", C6 = "Ò", k6 = "Ø", N6 = "Õ", O6 = "Ö", L6 = '"', D6 = "®", M6 = "Þ", F6 = "Ú", P6 = "Û", B6 = "Ù", $6 = "Ü", U6 = "Ý", j6 = "á", q6 = "â", z6 = "´", G6 = "æ", H6 = "à", V6 = "&", W6 = "å", K6 = "ã", Y6 = "ä", X6 = "¦", Z6 = "ç", J6 = "¸", Q6 = "¢", e9 = "©", t9 = "¤", n9 = "°", r9 = "÷", a9 = "é", i9 = "ê", o9 = "è", s9 = "ð", l9 = "ë", u9 = "½", c9 = "¼", d9 = "¾", p9 = ">", f9 = "í", g9 = "î", m9 = "¡", h9 = "ì", b9 = "¿", y9 = "ï", v9 = "«", E9 = "<", S9 = "¯", x9 = "µ", T9 = "·", w9 = " ", A9 = "¬", I9 = "ñ", R9 = "ó", _9 = "ô", C9 = "ò", k9 = "ª", N9 = "º", O9 = "ø", L9 = "õ", D9 = "ö", M9 = "¶", F9 = "±", P9 = "£", B9 = '"', $9 = "»", U9 = "®", j9 = "§", q9 = "­", z9 = "¹", G9 = "²", H9 = "³", V9 = "ß", W9 = "þ", K9 = "×", Y9 = "ú", X9 = "û", Z9 = "ù", J9 = "¨", Q9 = "ü", eK = "ý", tK = "¥", nK = "ÿ", rK = {
  AElig: i6,
  AMP: o6,
  Aacute: s6,
  Acirc: l6,
  Agrave: u6,
  Aring: c6,
  Atilde: d6,
  Auml: p6,
  COPY: f6,
  Ccedil: g6,
  ETH: m6,
  Eacute: h6,
  Ecirc: b6,
  Egrave: y6,
  Euml: v6,
  GT: E6,
  Iacute: S6,
  Icirc: x6,
  Igrave: T6,
  Iuml: w6,
  LT: A6,
  Ntilde: I6,
  Oacute: R6,
  Ocirc: _6,
  Ograve: C6,
  Oslash: k6,
  Otilde: N6,
  Ouml: O6,
  QUOT: L6,
  REG: D6,
  THORN: M6,
  Uacute: F6,
  Ucirc: P6,
  Ugrave: B6,
  Uuml: $6,
  Yacute: U6,
  aacute: j6,
  acirc: q6,
  acute: z6,
  aelig: G6,
  agrave: H6,
  amp: V6,
  aring: W6,
  atilde: K6,
  auml: Y6,
  brvbar: X6,
  ccedil: Z6,
  cedil: J6,
  cent: Q6,
  copy: e9,
  curren: t9,
  deg: n9,
  divide: r9,
  eacute: a9,
  ecirc: i9,
  egrave: o9,
  eth: s9,
  euml: l9,
  frac12: u9,
  frac14: c9,
  frac34: d9,
  gt: p9,
  iacute: f9,
  icirc: g9,
  iexcl: m9,
  igrave: h9,
  iquest: b9,
  iuml: y9,
  laquo: v9,
  lt: E9,
  macr: S9,
  micro: x9,
  middot: T9,
  nbsp: w9,
  not: A9,
  ntilde: I9,
  oacute: R9,
  ocirc: _9,
  ograve: C9,
  ordf: k9,
  ordm: N9,
  oslash: O9,
  otilde: L9,
  ouml: D9,
  para: M9,
  plusmn: F9,
  pound: P9,
  quot: B9,
  raquo: $9,
  reg: U9,
  sect: j9,
  shy: q9,
  sup1: z9,
  sup2: G9,
  sup3: H9,
  szlig: V9,
  thorn: W9,
  times: K9,
  uacute: Y9,
  ucirc: X9,
  ugrave: Z9,
  uml: J9,
  uuml: Q9,
  yacute: eK,
  yen: tK,
  yuml: nK
}, aK = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
var yp, Vw;
function i1() {
  if (Vw) return yp;
  Vw = 1, yp = e;
  function e(t) {
    var n = typeof t == "string" ? t.charCodeAt(0) : t;
    return n >= 48 && n <= 57;
  }
  return yp;
}
var vp, Ww;
function iK() {
  if (Ww) return vp;
  Ww = 1, vp = e;
  function e(t) {
    var n = typeof t == "string" ? t.charCodeAt(0) : t;
    return n >= 97 && n <= 102 || n >= 65 && n <= 70 || n >= 48 && n <= 57;
  }
  return vp;
}
var Ep, Kw;
function oK() {
  if (Kw) return Ep;
  Kw = 1, Ep = e;
  function e(t) {
    var n = typeof t == "string" ? t.charCodeAt(0) : t;
    return n >= 97 && n <= 122 || n >= 65 && n <= 90;
  }
  return Ep;
}
var Sp, Yw;
function sK() {
  if (Yw) return Sp;
  Yw = 1;
  var e = oK(), t = i1();
  Sp = n;
  function n(r) {
    return e(r) || t(r);
  }
  return Sp;
}
var xp, Xw;
function lK() {
  if (Xw) return xp;
  Xw = 1;
  var e, t = 59;
  xp = n;
  function n(r) {
    var a = "&" + r + ";", i;
    return e = e || document.createElement("i"), e.innerHTML = a, i = e.textContent, i.charCodeAt(i.length - 1) === t && r !== "semi" || i === a ? !1 : i;
  }
  return xp;
}
var Tp, Zw;
function uK() {
  if (Zw) return Tp;
  Zw = 1;
  var e = rK, t = aK, n = i1(), r = iK(), a = sK(), i = lK();
  Tp = de;
  var s = {}.hasOwnProperty, u = String.fromCharCode, c = Function.prototype, d = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: !1,
    nonTerminated: !0
  }, p = 9, f = 10, m = 12, h = 32, E = 38, y = 59, w = 60, x = 61, I = 35, S = 88, C = 120, T = 65533, A = "named", O = "hexadecimal", U = "decimal", P = {};
  P[O] = 16, P[U] = 10;
  var b = {};
  b[A] = a, b[U] = n, b[O] = r;
  var L = 1, j = 2, G = 3, H = 4, ne = 5, ue = 6, ce = 7, Q = {};
  Q[L] = "Named character references must be terminated by a semicolon", Q[j] = "Numeric character references must be terminated by a semicolon", Q[G] = "Named character references cannot be empty", Q[H] = "Numeric character references cannot be empty", Q[ne] = "Named character references must be known", Q[ue] = "Numeric character references cannot be disallowed", Q[ce] = "Numeric character references cannot be outside the permissible Unicode range";
  function de(M, he) {
    var se = {}, ie, xe;
    he || (he = {});
    for (xe in d)
      ie = he[xe], se[xe] = ie ?? d[xe];
    return (se.position.indent || se.position.start) && (se.indent = se.position.indent || [], se.position = se.position.start), D(M, se);
  }
  function D(M, he) {
    var se = he.additional, ie = he.nonTerminated, xe = he.text, _e = he.reference, Le = he.warning, tt = he.textContext, at = he.referenceContext, tn = he.warningContext, Ge = he.position, St = he.indent || [], nn = M.length, kt = 0, Ze = -1, Nt = Ge.column || 1, wn = Ge.line || 1, Rt = "", me = [], Ee, ar, Bn, bt, Y, re, fe, Se, Pe, Bt, $t, Ut, Yt, xt, Ot, rn, Xt, hn, Te;
    for (typeof se == "string" && (se = se.charCodeAt(0)), rn = An(), Se = Le ? Dr : c, kt--, nn++; ++kt < nn; )
      if (Y === f && (Nt = St[Ze] || 1), Y = M.charCodeAt(kt), Y === E) {
        if (fe = M.charCodeAt(kt + 1), fe === p || fe === f || fe === m || fe === h || fe === E || fe === w || fe !== fe || se && fe === se) {
          Rt += u(Y), Nt++;
          continue;
        }
        for (Yt = kt + 1, Ut = Yt, Te = Yt, fe === I ? (Te = ++Ut, fe = M.charCodeAt(Te), fe === S || fe === C ? (xt = O, Te = ++Ut) : xt = U) : xt = A, Ee = "", $t = "", bt = "", Ot = b[xt], Te--; ++Te < nn && (fe = M.charCodeAt(Te), !!Ot(fe)); )
          bt += u(fe), xt === A && s.call(e, bt) && (Ee = bt, $t = e[bt]);
        Bn = M.charCodeAt(Te) === y, Bn && (Te++, ar = xt === A ? i(bt) : !1, ar && (Ee = bt, $t = ar)), hn = 1 + Te - Yt, !Bn && !ie || (bt ? xt === A ? (Bn && !$t ? Se(ne, 1) : (Ee !== bt && (Te = Ut + Ee.length, hn = 1 + Te - Ut, Bn = !1), Bn || (Pe = Ee ? L : G, he.attribute ? (fe = M.charCodeAt(Te), fe === x ? (Se(Pe, hn), $t = null) : a(fe) ? $t = null : Se(Pe, hn)) : Se(Pe, hn))), re = $t) : (Bn || Se(j, hn), re = parseInt(bt, P[xt]), le(re) ? (Se(ce, hn), re = u(T)) : re in t ? (Se(ue, hn), re = t[re]) : (Bt = "", Ae(re) && Se(ue, hn), re > 65535 && (re -= 65536, Bt += u(re >>> 10 | 55296), re = 56320 | re & 1023), re = Bt + u(re))) : xt !== A && Se(H, hn)), re ? (Ja(), rn = An(), kt = Te - 1, Nt += Te - Yt + 1, me.push(re), Xt = An(), Xt.offset++, _e && _e.call(
          at,
          re,
          { start: rn, end: Xt },
          M.slice(Yt - 1, Te)
        ), rn = Xt) : (bt = M.slice(Yt - 1, Te), Rt += bt, Nt += bt.length, kt = Te - 1);
      } else
        Y === 10 && (wn++, Ze++, Nt = 0), Y === Y ? (Rt += u(Y), Nt++) : Ja();
    return me.join("");
    function An() {
      return {
        line: wn,
        column: Nt,
        offset: kt + (Ge.offset || 0)
      };
    }
    function Dr(Qa, $s) {
      var Io = An();
      Io.column += $s, Io.offset += $s, Le.call(tn, Q[Qa], Io, Qa);
    }
    function Ja() {
      Rt && (me.push(Rt), xe && xe.call(tt, Rt, { start: rn, end: An() }), Rt = "");
    }
  }
  function le(M) {
    return M >= 55296 && M <= 57343 || M > 1114111;
  }
  function Ae(M) {
    return M >= 1 && M <= 8 || M === 11 || M >= 13 && M <= 31 || M >= 127 && M <= 159 || M >= 64976 && M <= 65007 || (M & 65535) === 65535 || (M & 65535) === 65534;
  }
  return Tp;
}
var wp = { exports: {} }, Jw;
function cK() {
  return Jw || (Jw = 1, function(e) {
    var t = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
    /**
     * Prism: Lightweight, robust, elegant syntax highlighting
     *
     * @license MIT <https://opensource.org/licenses/MIT>
     * @author Lea Verou <https://lea.verou.me>
     * @namespace
     * @public
     */
    var n = function(r) {
      var a = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, i = 0, s = {}, u = {
        /**
         * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
         * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
         * additional languages or plugins yourself.
         *
         * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
         *
         * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.manual = true;
         * // add a new <script> to load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        manual: r.Prism && r.Prism.manual,
        /**
         * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
         * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
         * own worker, you don't want it to do this.
         *
         * By setting this value to `true`, Prism will not add its own listeners to the worker.
         *
         * You obviously have to change this value before Prism executes. To do this, you can add an
         * empty Prism object into the global scope before loading the Prism script like this:
         *
         * ```js
         * window.Prism = window.Prism || {};
         * Prism.disableWorkerMessageHandler = true;
         * // Load Prism's script
         * ```
         *
         * @default false
         * @type {boolean}
         * @memberof Prism
         * @public
         */
        disableWorkerMessageHandler: r.Prism && r.Prism.disableWorkerMessageHandler,
        /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */
        util: {
          encode: function I(S) {
            return S instanceof c ? new c(S.type, I(S.content), S.alias) : Array.isArray(S) ? S.map(I) : S.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
          },
          /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */
          type: function(I) {
            return Object.prototype.toString.call(I).slice(8, -1);
          },
          /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */
          objId: function(I) {
            return I.__id || Object.defineProperty(I, "__id", { value: ++i }), I.__id;
          },
          /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */
          clone: function I(S, C) {
            C = C || {};
            var T, A;
            switch (u.util.type(S)) {
              case "Object":
                if (A = u.util.objId(S), C[A])
                  return C[A];
                T = /** @type {Record<string, any>} */
                {}, C[A] = T;
                for (var O in S)
                  S.hasOwnProperty(O) && (T[O] = I(S[O], C));
                return (
                  /** @type {any} */
                  T
                );
              case "Array":
                return A = u.util.objId(S), C[A] ? C[A] : (T = [], C[A] = T, S.forEach(function(U, P) {
                  T[P] = I(U, C);
                }), /** @type {any} */
                T);
              default:
                return S;
            }
          },
          /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */
          getLanguage: function(I) {
            for (; I; ) {
              var S = a.exec(I.className);
              if (S)
                return S[1].toLowerCase();
              I = I.parentElement;
            }
            return "none";
          },
          /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */
          setLanguage: function(I, S) {
            I.className = I.className.replace(RegExp(a, "gi"), ""), I.classList.add("language-" + S);
          },
          /**
           * Returns the script element that is currently executing.
           *
           * This does __not__ work for line script element.
           *
           * @returns {HTMLScriptElement | null}
           */
          currentScript: function() {
            if (typeof document > "u")
              return null;
            if ("currentScript" in document)
              return (
                /** @type {any} */
                document.currentScript
              );
            try {
              throw new Error();
            } catch (T) {
              var I = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(T.stack) || [])[1];
              if (I) {
                var S = document.getElementsByTagName("script");
                for (var C in S)
                  if (S[C].src == I)
                    return S[C];
              }
              return null;
            }
          },
          /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */
          isActive: function(I, S, C) {
            for (var T = "no-" + S; I; ) {
              var A = I.classList;
              if (A.contains(S))
                return !0;
              if (A.contains(T))
                return !1;
              I = I.parentElement;
            }
            return !!C;
          }
        },
        /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */
        languages: {
          /**
           * The grammar for plain, unformatted text.
           */
          plain: s,
          plaintext: s,
          text: s,
          txt: s,
          /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */
          extend: function(I, S) {
            var C = u.util.clone(u.languages[I]);
            for (var T in S)
              C[T] = S[T];
            return C;
          },
          /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */
          insertBefore: function(I, S, C, T) {
            T = T || /** @type {any} */
            u.languages;
            var A = T[I], O = {};
            for (var U in A)
              if (A.hasOwnProperty(U)) {
                if (U == S)
                  for (var P in C)
                    C.hasOwnProperty(P) && (O[P] = C[P]);
                C.hasOwnProperty(U) || (O[U] = A[U]);
              }
            var b = T[I];
            return T[I] = O, u.languages.DFS(u.languages, function(L, j) {
              j === b && L != I && (this[L] = O);
            }), O;
          },
          // Traverse a language definition with Depth First Search
          DFS: function I(S, C, T, A) {
            A = A || {};
            var O = u.util.objId;
            for (var U in S)
              if (S.hasOwnProperty(U)) {
                C.call(S, U, S[U], T || U);
                var P = S[U], b = u.util.type(P);
                b === "Object" && !A[O(P)] ? (A[O(P)] = !0, I(P, C, null, A)) : b === "Array" && !A[O(P)] && (A[O(P)] = !0, I(P, C, U, A));
              }
          }
        },
        plugins: {},
        /**
         * This is the most high-level function in Prism’s API.
         * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
         * each one of them.
         *
         * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
         *
         * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
         * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
         * @memberof Prism
         * @public
         */
        highlightAll: function(I, S) {
          u.highlightAllUnder(document, I, S);
        },
        /**
         * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
         * {@link Prism.highlightElement} on each one of them.
         *
         * The following hooks will be run:
         * 1. `before-highlightall`
         * 2. `before-all-elements-highlight`
         * 3. All hooks of {@link Prism.highlightElement} for each element.
         *
         * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
         * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
         * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
         * @memberof Prism
         * @public
         */
        highlightAllUnder: function(I, S, C) {
          var T = {
            callback: C,
            container: I,
            selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
          };
          u.hooks.run("before-highlightall", T), T.elements = Array.prototype.slice.apply(T.container.querySelectorAll(T.selector)), u.hooks.run("before-all-elements-highlight", T);
          for (var A = 0, O; O = T.elements[A++]; )
            u.highlightElement(O, S === !0, T.callback);
        },
        /**
         * Highlights the code inside a single element.
         *
         * The following hooks will be run:
         * 1. `before-sanity-check`
         * 2. `before-highlight`
         * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
         * 4. `before-insert`
         * 5. `after-highlight`
         * 6. `complete`
         *
         * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
         * the element's language.
         *
         * @param {Element} element The element containing the code.
         * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
         * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
         * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
         * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
         *
         * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
         * asynchronous highlighting to work. You can build your own bundle on the
         * [Download page](https://prismjs.com/download.html).
         * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
         * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
         * @memberof Prism
         * @public
         */
        highlightElement: function(I, S, C) {
          var T = u.util.getLanguage(I), A = u.languages[T];
          u.util.setLanguage(I, T);
          var O = I.parentElement;
          O && O.nodeName.toLowerCase() === "pre" && u.util.setLanguage(O, T);
          var U = I.textContent, P = {
            element: I,
            language: T,
            grammar: A,
            code: U
          };
          function b(j) {
            P.highlightedCode = j, u.hooks.run("before-insert", P), P.element.innerHTML = P.highlightedCode, u.hooks.run("after-highlight", P), u.hooks.run("complete", P), C && C.call(P.element);
          }
          if (u.hooks.run("before-sanity-check", P), O = P.element.parentElement, O && O.nodeName.toLowerCase() === "pre" && !O.hasAttribute("tabindex") && O.setAttribute("tabindex", "0"), !P.code) {
            u.hooks.run("complete", P), C && C.call(P.element);
            return;
          }
          if (u.hooks.run("before-highlight", P), !P.grammar) {
            b(u.util.encode(P.code));
            return;
          }
          if (S && r.Worker) {
            var L = new Worker(u.filename);
            L.onmessage = function(j) {
              b(j.data);
            }, L.postMessage(JSON.stringify({
              language: P.language,
              code: P.code,
              immediateClose: !0
            }));
          } else
            b(u.highlight(P.code, P.grammar, P.language));
        },
        /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */
        highlight: function(I, S, C) {
          var T = {
            code: I,
            grammar: S,
            language: C
          };
          if (u.hooks.run("before-tokenize", T), !T.grammar)
            throw new Error('The language "' + T.language + '" has no grammar.');
          return T.tokens = u.tokenize(T.code, T.grammar), u.hooks.run("after-tokenize", T), c.stringify(u.util.encode(T.tokens), T.language);
        },
        /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */
        tokenize: function(I, S) {
          var C = S.rest;
          if (C) {
            for (var T in C)
              S[T] = C[T];
            delete S.rest;
          }
          var A = new f();
          return m(A, A.head, I), p(I, A, S, A.head, 0), E(A);
        },
        /**
         * @namespace
         * @memberof Prism
         * @public
         */
        hooks: {
          all: {},
          /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */
          add: function(I, S) {
            var C = u.hooks.all;
            C[I] = C[I] || [], C[I].push(S);
          },
          /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */
          run: function(I, S) {
            var C = u.hooks.all[I];
            if (!(!C || !C.length))
              for (var T = 0, A; A = C[T++]; )
                A(S);
          }
        },
        Token: c
      };
      r.Prism = u;
      function c(I, S, C, T) {
        this.type = I, this.content = S, this.alias = C, this.length = (T || "").length | 0;
      }
      c.stringify = function I(S, C) {
        if (typeof S == "string")
          return S;
        if (Array.isArray(S)) {
          var T = "";
          return S.forEach(function(b) {
            T += I(b, C);
          }), T;
        }
        var A = {
          type: S.type,
          content: I(S.content, C),
          tag: "span",
          classes: ["token", S.type],
          attributes: {},
          language: C
        }, O = S.alias;
        O && (Array.isArray(O) ? Array.prototype.push.apply(A.classes, O) : A.classes.push(O)), u.hooks.run("wrap", A);
        var U = "";
        for (var P in A.attributes)
          U += " " + P + '="' + (A.attributes[P] || "").replace(/"/g, "&quot;") + '"';
        return "<" + A.tag + ' class="' + A.classes.join(" ") + '"' + U + ">" + A.content + "</" + A.tag + ">";
      };
      function d(I, S, C, T) {
        I.lastIndex = S;
        var A = I.exec(C);
        if (A && T && A[1]) {
          var O = A[1].length;
          A.index += O, A[0] = A[0].slice(O);
        }
        return A;
      }
      function p(I, S, C, T, A, O) {
        for (var U in C)
          if (!(!C.hasOwnProperty(U) || !C[U])) {
            var P = C[U];
            P = Array.isArray(P) ? P : [P];
            for (var b = 0; b < P.length; ++b) {
              if (O && O.cause == U + "," + b)
                return;
              var L = P[b], j = L.inside, G = !!L.lookbehind, H = !!L.greedy, ne = L.alias;
              if (H && !L.pattern.global) {
                var ue = L.pattern.toString().match(/[imsuy]*$/)[0];
                L.pattern = RegExp(L.pattern.source, ue + "g");
              }
              for (var ce = L.pattern || L, Q = T.next, de = A; Q !== S.tail && !(O && de >= O.reach); de += Q.value.length, Q = Q.next) {
                var D = Q.value;
                if (S.length > I.length)
                  return;
                if (!(D instanceof c)) {
                  var le = 1, Ae;
                  if (H) {
                    if (Ae = d(ce, de, I, G), !Ae || Ae.index >= I.length)
                      break;
                    var ie = Ae.index, M = Ae.index + Ae[0].length, he = de;
                    for (he += Q.value.length; ie >= he; )
                      Q = Q.next, he += Q.value.length;
                    if (he -= Q.value.length, de = he, Q.value instanceof c)
                      continue;
                    for (var se = Q; se !== S.tail && (he < M || typeof se.value == "string"); se = se.next)
                      le++, he += se.value.length;
                    le--, D = I.slice(de, he), Ae.index -= de;
                  } else if (Ae = d(ce, 0, D, G), !Ae)
                    continue;
                  var ie = Ae.index, xe = Ae[0], _e = D.slice(0, ie), Le = D.slice(ie + xe.length), tt = de + D.length;
                  O && tt > O.reach && (O.reach = tt);
                  var at = Q.prev;
                  _e && (at = m(S, at, _e), de += _e.length), h(S, at, le);
                  var tn = new c(U, j ? u.tokenize(xe, j) : xe, ne, xe);
                  if (Q = m(S, at, tn), Le && m(S, Q, Le), le > 1) {
                    var Ge = {
                      cause: U + "," + b,
                      reach: tt
                    };
                    p(I, S, C, Q.prev, de, Ge), O && Ge.reach > O.reach && (O.reach = Ge.reach);
                  }
                }
              }
            }
          }
      }
      function f() {
        var I = { value: null, prev: null, next: null }, S = { value: null, prev: I, next: null };
        I.next = S, this.head = I, this.tail = S, this.length = 0;
      }
      function m(I, S, C) {
        var T = S.next, A = { value: C, prev: S, next: T };
        return S.next = A, T.prev = A, I.length++, A;
      }
      function h(I, S, C) {
        for (var T = S.next, A = 0; A < C && T !== I.tail; A++)
          T = T.next;
        S.next = T, T.prev = S, I.length -= A;
      }
      function E(I) {
        for (var S = [], C = I.head.next; C !== I.tail; )
          S.push(C.value), C = C.next;
        return S;
      }
      if (!r.document)
        return r.addEventListener && (u.disableWorkerMessageHandler || r.addEventListener("message", function(I) {
          var S = JSON.parse(I.data), C = S.language, T = S.code, A = S.immediateClose;
          r.postMessage(u.highlight(T, u.languages[C], C)), A && r.close();
        }, !1)), u;
      var y = u.util.currentScript();
      y && (u.filename = y.src, y.hasAttribute("data-manual") && (u.manual = !0));
      function w() {
        u.manual || u.highlightAll();
      }
      if (!u.manual) {
        var x = document.readyState;
        x === "loading" || x === "interactive" && y && y.defer ? document.addEventListener("DOMContentLoaded", w) : window.requestAnimationFrame ? window.requestAnimationFrame(w) : window.setTimeout(w, 16);
      }
      return u;
    }(t);
    e.exports && (e.exports = n), typeof globalThis < "u" && (globalThis.Prism = n);
  }(wp)), wp.exports;
}
var Ap, Qw;
function dK() {
  if (Qw) return Ap;
  Qw = 1, Ap = e, e.displayName = "markup", e.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function e(t) {
    t.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, t.languages.markup.tag.inside["attr-value"].inside.entity = t.languages.markup.entity, t.languages.markup.doctype.inside["internal-subset"].inside = t.languages.markup, t.hooks.add("wrap", function(n) {
      n.type === "entity" && (n.attributes.title = n.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(t.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: function(r, a) {
        var i = {};
        i["language-" + a] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: t.languages[a]
        }, i.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var s = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: i
          }
        };
        s["language-" + a] = {
          pattern: /[\s\S]+/,
          inside: t.languages[a]
        };
        var u = {};
        u[r] = {
          pattern: RegExp(
            /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
              /__/g,
              function() {
                return r;
              }
            ),
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: s
        }, t.languages.insertBefore("markup", "cdata", u);
      }
    }), Object.defineProperty(t.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: function(n, r) {
        t.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + n + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [r, "language-" + r],
                  inside: t.languages[r]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }
    }), t.languages.html = t.languages.markup, t.languages.mathml = t.languages.markup, t.languages.svg = t.languages.markup, t.languages.xml = t.languages.extend("markup", {}), t.languages.ssml = t.languages.xml, t.languages.atom = t.languages.xml, t.languages.rss = t.languages.xml;
  }
  return Ap;
}
var Ip, eA;
function pK() {
  if (eA) return Ip;
  eA = 1, Ip = e, e.displayName = "css", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      n.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp(
            "\\burl\\((?:" + r.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
            "i"
          ),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + r.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(
            `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + r.source + ")*(?=\\s*\\{)"
          ),
          lookbehind: !0
        },
        string: {
          pattern: r,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, n.languages.css.atrule.inside.rest = n.languages.css;
      var a = n.languages.markup;
      a && (a.tag.addInlined("style", "css"), a.tag.addAttribute("style", "css"));
    })(t);
  }
  return Ip;
}
var Rp, tA;
function fK() {
  if (tA) return Rp;
  tA = 1, Rp = e, e.displayName = "clike", e.aliases = [];
  function e(t) {
    t.languages.clike = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b\w+(?=\()/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return Rp;
}
var _p, nA;
function gK() {
  if (nA) return _p;
  nA = 1, _p = e, e.displayName = "javascript", e.aliases = ["js"];
  function e(t) {
    t.languages.javascript = t.languages.extend("clike", {
      "class-name": [
        t.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), t.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t.languages.insertBefore("javascript", "keyword", {
      regex: {
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: t.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: t.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), t.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: t.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), t.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), t.languages.markup && (t.languages.markup.tag.addInlined("script", "javascript"), t.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
      "javascript"
    )), t.languages.js = t.languages.javascript;
  }
  return _p;
}
var Cp, rA;
function mK() {
  if (rA) return Cp;
  rA = 1;
  var e = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof globalThis == "object" ? globalThis : {}, t = T();
  e.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
  var n = a6(), r = uK(), a = cK(), i = dK(), s = pK(), u = fK(), c = gK();
  t();
  var d = {}.hasOwnProperty;
  function p() {
  }
  p.prototype = a;
  var f = new p();
  Cp = f, f.highlight = E, f.register = m, f.alias = h, f.registered = y, f.listLanguages = w, m(i), m(s), m(u), m(c), f.util.encode = S, f.Token.stringify = x;
  function m(A) {
    if (typeof A != "function" || !A.displayName)
      throw new Error("Expected `function` for `grammar`, got `" + A + "`");
    f.languages[A.displayName] === void 0 && A(f);
  }
  function h(A, O) {
    var U = f.languages, P = A, b, L, j, G;
    O && (P = {}, P[A] = O);
    for (b in P)
      for (L = P[b], L = typeof L == "string" ? [L] : L, j = L.length, G = -1; ++G < j; )
        U[L[G]] = U[b];
  }
  function E(A, O) {
    var U = a.highlight, P;
    if (typeof A != "string")
      throw new Error("Expected `string` for `value`, got `" + A + "`");
    if (f.util.type(O) === "Object")
      P = O, O = null;
    else {
      if (typeof O != "string")
        throw new Error("Expected `string` for `name`, got `" + O + "`");
      if (d.call(f.languages, O))
        P = f.languages[O];
      else
        throw new Error("Unknown language: `" + O + "` is not registered");
    }
    return U.call(this, A, P, O);
  }
  function y(A) {
    if (typeof A != "string")
      throw new Error("Expected `string` for `language`, got `" + A + "`");
    return d.call(f.languages, A);
  }
  function w() {
    var A = f.languages, O = [], U;
    for (U in A)
      d.call(A, U) && typeof A[U] == "object" && O.push(U);
    return O;
  }
  function x(A, O, U) {
    var P;
    return typeof A == "string" ? { type: "text", value: A } : f.util.type(A) === "Array" ? I(A, O) : (P = {
      type: A.type,
      content: f.Token.stringify(A.content, O, U),
      tag: "span",
      classes: ["token", A.type],
      attributes: {},
      language: O,
      parent: U
    }, A.alias && (P.classes = P.classes.concat(A.alias)), f.hooks.run("wrap", P), n(
      P.tag + "." + P.classes.join("."),
      C(P.attributes),
      P.content
    ));
  }
  function I(A, O) {
    for (var U = [], P = A.length, b = -1, L; ++b < P; )
      L = A[b], L !== "" && L !== null && L !== void 0 && U.push(L);
    for (b = -1, P = U.length; ++b < P; )
      L = U[b], U[b] = f.Token.stringify(L, O, U);
    return U;
  }
  function S(A) {
    return A;
  }
  function C(A) {
    var O;
    for (O in A)
      A[O] = r(A[O]);
    return A;
  }
  function T() {
    var A = "Prism" in e, O = A ? e.Prism : void 0;
    return U;
    function U() {
      A ? e.Prism = O : delete e.Prism, A = void 0, O = void 0;
    }
  }
  return Cp;
}
const hK = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "#f5f2f0",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto"
  },
  'pre[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#f5f2f0",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "slategray"
  },
  prolog: {
    color: "slategray"
  },
  doctype: {
    color: "slategray"
  },
  cdata: {
    color: "slategray"
  },
  punctuation: {
    color: "#999"
  },
  namespace: {
    Opacity: ".7"
  },
  property: {
    color: "#905"
  },
  tag: {
    color: "#905"
  },
  boolean: {
    color: "#905"
  },
  number: {
    color: "#905"
  },
  constant: {
    color: "#905"
  },
  symbol: {
    color: "#905"
  },
  deleted: {
    color: "#905"
  },
  selector: {
    color: "#690"
  },
  "attr-name": {
    color: "#690"
  },
  string: {
    color: "#690"
  },
  char: {
    color: "#690"
  },
  builtin: {
    color: "#690"
  },
  inserted: {
    color: "#690"
  },
  operator: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  entity: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)",
    cursor: "help"
  },
  url: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  atrule: {
    color: "#07a"
  },
  "attr-value": {
    color: "#07a"
  },
  keyword: {
    color: "#07a"
  },
  function: {
    color: "#DD4A68"
  },
  "class-name": {
    color: "#DD4A68"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "bold"
  },
  variable: {
    color: "#e90"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
};
var kp, aA;
function bK() {
  if (aA) return kp;
  aA = 1, kp = e, e.displayName = "abap", e.aliases = [];
  function e(t) {
    t.languages.abap = {
      comment: /^\*.*/m,
      string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "string-template": {
        pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
        lookbehind: !0,
        alias: "string"
      },
      /* End Of Line comments should not interfere with strings when the
      quote character occurs within them. We assume a string being highlighted
      inside an EOL comment is more acceptable than the opposite.
      */
      "eol-comment": {
        pattern: /(^|\s)".*/m,
        lookbehind: !0,
        alias: "comment"
      },
      keyword: {
        pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
        lookbehind: !0
      },
      /* Numbers can be only integers. Decimal or Hex appear only as strings */
      number: /\b\d+\b/,
      /* Operators must always be surrounded by whitespace, they cannot be put
      adjacent to operands.
      */
      operator: {
        pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
        lookbehind: !0
      },
      "string-operator": {
        pattern: /(\s)&&?(?=\s)/,
        lookbehind: !0,
        /* The official editor highlights */
        alias: "keyword"
      },
      "token-operator": [
        {
          /* Special operators used to access structure components, class methods/attributes, etc. */
          pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        {
          /* Special tokens used do delimit string templates */
          pattern: /[|{}]/,
          alias: "punctuation"
        }
      ],
      punctuation: /[,.:()]/
    };
  }
  return kp;
}
var Np, iA;
function yK() {
  if (iA) return Np;
  iA = 1, Np = e, e.displayName = "abnf", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = "(?:ALPHA|BIT|CHAR|CR|CRLF|CTL|DIGIT|DQUOTE|HEXDIG|HTAB|LF|LWSP|OCTET|SP|VCHAR|WSP)";
      n.languages.abnf = {
        comment: /;.*/,
        string: {
          pattern: /(?:%[is])?"[^"\n\r]*"/,
          greedy: !0,
          inside: {
            punctuation: /^%[is]/
          }
        },
        range: {
          pattern: /%(?:b[01]+-[01]+|d\d+-\d+|x[A-F\d]+-[A-F\d]+)/i,
          alias: "number"
        },
        terminal: {
          pattern: /%(?:b[01]+(?:\.[01]+)*|d\d+(?:\.\d+)*|x[A-F\d]+(?:\.[A-F\d]+)*)/i,
          alias: "number"
        },
        repetition: {
          pattern: /(^|[^\w-])(?:\d*\*\d*|\d+)/,
          lookbehind: !0,
          alias: "operator"
        },
        definition: {
          pattern: /(^[ \t]*)(?:[a-z][\w-]*|<[^<>\r\n]*>)(?=\s*=)/m,
          lookbehind: !0,
          alias: "keyword",
          inside: {
            punctuation: /<|>/
          }
        },
        "core-rule": {
          pattern: RegExp(
            "(?:(^|[^<\\w-])" + r + "|<" + r + ">)(?![\\w-])",
            "i"
          ),
          lookbehind: !0,
          alias: ["rule", "constant"],
          inside: {
            punctuation: /<|>/
          }
        },
        rule: {
          pattern: /(^|[^<\w-])[a-z][\w-]*|<[^<>\r\n]*>/i,
          lookbehind: !0,
          inside: {
            punctuation: /<|>/
          }
        },
        operator: /=\/?|\//,
        punctuation: /[()\[\]]/
      };
    })(t);
  }
  return Np;
}
var Op, oA;
function vK() {
  if (oA) return Op;
  oA = 1, Op = e, e.displayName = "actionscript", e.aliases = [];
  function e(t) {
    t.languages.actionscript = t.languages.extend("javascript", {
      keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
      operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
    }), t.languages.actionscript["class-name"].alias = "function", delete t.languages.actionscript.parameter, delete t.languages.actionscript["literal-property"], t.languages.markup && t.languages.insertBefore("actionscript", "string", {
      xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: !0,
        inside: t.languages.markup
      }
    });
  }
  return Op;
}
var Lp, sA;
function EK() {
  if (sA) return Lp;
  sA = 1, Lp = e, e.displayName = "ada", e.aliases = [];
  function e(t) {
    t.languages.ada = {
      comment: /--.*/,
      string: /"(?:""|[^"\r\f\n])*"/,
      number: [
        {
          pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
        },
        {
          pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
        }
      ],
      "attr-name": /\b'\w+/,
      keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|new|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|return|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
      boolean: /\b(?:false|true)\b/i,
      operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
      punctuation: /\.\.?|[,;():]/,
      char: /'.'/,
      variable: /\b[a-z](?:\w)*\b/i
    };
  }
  return Lp;
}
var Dp, lA;
function SK() {
  if (lA) return Dp;
  lA = 1, Dp = e, e.displayName = "agda", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.agda = {
        comment: /\{-[\s\S]*?(?:-\}|$)|--.*/,
        string: {
          pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
          greedy: !0
        },
        punctuation: /[(){}⦃⦄.;@]/,
        "class-name": {
          pattern: /((?:data|record) +)\S+/,
          lookbehind: !0
        },
        function: {
          pattern: /(^[ \t]*)(?!\s)[^:\r\n]+(?=:)/m,
          lookbehind: !0
        },
        operator: {
          pattern: /(^\s*|\s)(?:[=|:∀→λ\\?_]|->)(?=\s)/,
          lookbehind: !0
        },
        keyword: /\b(?:Set|abstract|constructor|data|eta-equality|field|forall|hiding|import|in|inductive|infix|infixl|infixr|instance|let|macro|module|mutual|no-eta-equality|open|overlap|pattern|postulate|primitive|private|public|quote|quoteContext|quoteGoal|quoteTerm|record|renaming|rewrite|syntax|tactic|unquote|unquoteDecl|unquoteDef|using|variable|where|with)\b/
      };
    })(t);
  }
  return Dp;
}
var Mp, uA;
function xK() {
  if (uA) return Mp;
  uA = 1, Mp = e, e.displayName = "al", e.aliases = [];
  function e(t) {
    t.languages.al = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      function: {
        pattern: /(\b(?:event|procedure|trigger)\s+|(?:^|[^.])\.\s*)[a-z_]\w*(?=\s*\()/i,
        lookbehind: !0
      },
      keyword: [
        // keywords
        /\b(?:array|asserterror|begin|break|case|do|downto|else|end|event|exit|for|foreach|function|if|implements|in|indataset|interface|internal|local|of|procedure|program|protected|repeat|runonclient|securityfiltering|suppressdispose|temporary|then|to|trigger|until|var|while|with|withevents)\b/i,
        // objects and metadata that are used like keywords
        /\b(?:action|actions|addafter|addbefore|addfirst|addlast|area|assembly|chartpart|codeunit|column|controladdin|cuegroup|customizes|dataitem|dataset|dotnet|elements|enum|enumextension|extends|field|fieldattribute|fieldelement|fieldgroup|fieldgroups|fields|filter|fixed|grid|group|key|keys|label|labels|layout|modify|moveafter|movebefore|movefirst|movelast|page|pagecustomization|pageextension|part|profile|query|repeater|report|requestpage|schema|separator|systempart|table|tableelement|tableextension|textattribute|textelement|type|usercontrol|value|xmlport)\b/i
      ],
      number: /\b(?:0x[\da-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)(?:F|LL?|U(?:LL?)?)?\b/i,
      boolean: /\b(?:false|true)\b/i,
      variable: /\b(?:Curr(?:FieldNo|Page|Report)|x?Rec|RequestOptionsPage)\b/,
      "class-name": /\b(?:automation|biginteger|bigtext|blob|boolean|byte|char|clienttype|code|completiontriggererrorlevel|connectiontype|database|dataclassification|datascope|date|dateformula|datetime|decimal|defaultlayout|dialog|dictionary|dotnetassembly|dotnettypedeclaration|duration|errorinfo|errortype|executioncontext|executionmode|fieldclass|fieldref|fieldtype|file|filterpagebuilder|guid|httpclient|httpcontent|httpheaders|httprequestmessage|httpresponsemessage|instream|integer|joker|jsonarray|jsonobject|jsontoken|jsonvalue|keyref|list|moduledependencyinfo|moduleinfo|none|notification|notificationscope|objecttype|option|outstream|pageresult|record|recordid|recordref|reportformat|securityfilter|sessionsettings|tableconnectiontype|tablefilter|testaction|testfield|testfilterfield|testpage|testpermissions|testrequestpage|text|textbuilder|textconst|textencoding|time|transactionmodel|transactiontype|variant|verbosity|version|view|views|webserviceactioncontext|webserviceactionresultcode|xmlattribute|xmlattributecollection|xmlcdata|xmlcomment|xmldeclaration|xmldocument|xmldocumenttype|xmlelement|xmlnamespacemanager|xmlnametable|xmlnode|xmlnodelist|xmlprocessinginstruction|xmlreadoptions|xmltext|xmlwriteoptions)\b/i,
      operator: /\.\.|:[=:]|[-+*/]=?|<>|[<>]=?|=|\b(?:and|div|mod|not|or|xor)\b/i,
      punctuation: /[()\[\]{}:.;,]/
    };
  }
  return Mp;
}
var Fp, cA;
function TK() {
  if (cA) return Fp;
  cA = 1, Fp = e, e.displayName = "antlr4", e.aliases = ["g4"];
  function e(t) {
    t.languages.antlr4 = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      string: {
        pattern: /'(?:\\.|[^\\'\r\n])*'/,
        greedy: !0
      },
      "character-class": {
        pattern: /\[(?:\\.|[^\\\]\r\n])*\]/,
        greedy: !0,
        alias: "regex",
        inside: {
          range: {
            pattern: /([^[]|(?:^|[^\\])(?:\\\\)*\\\[)-(?!\])/,
            lookbehind: !0,
            alias: "punctuation"
          },
          escape: /\\(?:u(?:[a-fA-F\d]{4}|\{[a-fA-F\d]+\})|[pP]\{[=\w-]+\}|[^\r\nupP])/,
          punctuation: /[\[\]]/
        }
      },
      action: {
        pattern: /\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\}/,
        greedy: !0,
        inside: {
          content: {
            // this might be C, C++, Python, Java, C#, or any other language ANTLR4 compiles to
            pattern: /(\{)[\s\S]+(?=\})/,
            lookbehind: !0
          },
          punctuation: /[{}]/
        }
      },
      command: {
        pattern: /(->\s*(?!\s))(?:\s*(?:,\s*)?\b[a-z]\w*(?:\s*\([^()\r\n]*\))?)+(?=\s*;)/i,
        lookbehind: !0,
        inside: {
          function: /\b\w+(?=\s*(?:[,(]|$))/,
          punctuation: /[,()]/
        }
      },
      annotation: {
        pattern: /@\w+(?:::\w+)*/,
        alias: "keyword"
      },
      label: {
        pattern: /#[ \t]*\w+/,
        alias: "punctuation"
      },
      keyword: /\b(?:catch|channels|finally|fragment|grammar|import|lexer|locals|mode|options|parser|returns|throws|tokens)\b/,
      definition: [
        {
          pattern: /\b[a-z]\w*(?=\s*:)/,
          alias: ["rule", "class-name"]
        },
        {
          pattern: /\b[A-Z]\w*(?=\s*:)/,
          alias: ["token", "constant"]
        }
      ],
      constant: /\b[A-Z][A-Z_]*\b/,
      operator: /\.\.|->|[|~]|[*+?]\??/,
      punctuation: /[;:()=]/
    }, t.languages.g4 = t.languages.antlr4;
  }
  return Fp;
}
var Pp, dA;
function wK() {
  if (dA) return Pp;
  dA = 1, Pp = e, e.displayName = "apacheconf", e.aliases = [];
  function e(t) {
    t.languages.apacheconf = {
      comment: /#.*/,
      "directive-inline": {
        pattern: /(^[\t ]*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|Add(?:Alt|AltByEncoding|AltByType|Charset|DefaultCharset|Description|Encoding|Handler|Icon|IconByEncoding|IconByType|InputFilter|Language|ModuleInfo|OutputFilter|OutputFilterByType|Type)|Alias|AliasMatch|Allow(?:CONNECT|EncodedSlashes|Methods|Override|OverrideList)?|Anonymous(?:_LogEmail|_MustGiveEmail|_NoUserID|_VerifyEmail)?|AsyncRequestWorkerFactor|Auth(?:BasicAuthoritative|BasicFake|BasicProvider|BasicUseDigestAlgorithm|DBDUserPWQuery|DBDUserRealmQuery|DBMGroupFile|DBMType|DBMUserFile|Digest(?:Algorithm|Domain|NonceLifetime|Provider|Qop|ShmemSize)|Form(?:Authoritative|Body|DisableNoStore|FakeBasicAuth|Location|LoginRequiredLocation|LoginSuccessLocation|LogoutLocation|Method|Mimetype|Password|Provider|SitePassphrase|Size|Username)|GroupFile|LDAP(?:AuthorizePrefix|BindAuthoritative|BindDN|BindPassword|CharsetConfig|CompareAsUser|CompareDNOnServer|DereferenceAliases|GroupAttribute|GroupAttributeIsDN|InitialBindAsUser|InitialBindPattern|MaxSubGroupDepth|RemoteUserAttribute|RemoteUserIsDN|SearchAsUser|SubGroupAttribute|SubGroupClass|Url)|Merging|Name|nCache(?:Context|Enable|ProvideFor|SOCache|Timeout)|nzFcgiCheckAuthnProvider|nzFcgiDefineProvider|Type|UserFile|zDBDLoginToReferer|zDBDQuery|zDBDRedirectQuery|zDBMType|zSendForbiddenOnFailure)|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|Cache(?:DefaultExpire|DetailHeader|DirLength|DirLevels|Disable|Enable|File|Header|IgnoreCacheControl|IgnoreHeaders|IgnoreNoLastMod|IgnoreQueryString|IgnoreURLSessionIdentifiers|KeyBaseURL|LastModifiedFactor|Lock|LockMaxAge|LockPath|MaxExpire|MaxFileSize|MinExpire|MinFileSize|NegotiatedDocs|QuickHandler|ReadSize|ReadTime|Root|Socache(?:MaxSize|MaxTime|MinTime|ReadSize|ReadTime)?|StaleOnError|StoreExpired|StoreNoStore|StorePrivate)|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|Deflate(?:BufferSize|CompressionLevel|FilterNote|InflateLimitRequestBody|InflateRatio(?:Burst|Limit)|MemLevel|WindowSize)|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|Heartbeat(?:Address|Listen|MaxServers|Storage)|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|Index(?:HeadInsert|Ignore|IgnoreReset|Options|OrderDefault|StyleSheet)|InputSed|ISAPI(?:AppendLogToErrors|AppendLogToQuery|CacheFile|FakeAsync|LogNotSupported|ReadAheadBuffer)|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAP(?:CacheEntries|CacheTTL|ConnectionPoolTTL|ConnectionTimeout|LibraryDebug|OpCacheEntries|OpCacheTTL|ReferralHopLimit|Referrals|Retries|RetryDelay|SharedCacheFile|SharedCacheSize|Timeout|TrustedClientCert|TrustedGlobalCert|TrustedMode|VerifyServerCert)|Limit(?:InternalRecursion|Request(?:Body|Fields|FieldSize|Line)|XMLRequestBody)|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|Lua(?:Hook(?:AccessChecker|AuthChecker|CheckUserID|Fixups|InsertFilter|Log|MapToStorage|TranslateName|TypeChecker)|Inherit|InputFilter|MapHandler|OutputFilter|PackageCPath|PackagePath|QuickHandler|Root|Scope)|Max(?:ConnectionsPerChild|KeepAliveRequests|MemFree|RangeOverlaps|RangeReversals|Ranges|RequestWorkers|SpareServers|SpareThreads|Threads)|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|Proxy(?:AddHeaders|BadHeader|Block|Domain|ErrorOverride|ExpressDBMFile|ExpressDBMType|ExpressEnable|FtpDirCharset|FtpEscapeWildcards|FtpListOnWildcard|HTML(?:BufSize|CharsetOut|DocType|Enable|Events|Extended|Fixups|Interp|Links|Meta|StripComments|URLMap)|IOBufferSize|MaxForwards|Pass(?:Inherit|InterpolateEnv|Match|Reverse|ReverseCookieDomain|ReverseCookiePath)?|PreserveHost|ReceiveBufferSize|Remote|RemoteMatch|Requests|SCGIInternalRedirect|SCGISendfile|Set|SourceAddress|Status|Timeout|Via)|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIP(?:Header|InternalProxy|InternalProxyList|ProxiesHeader|TrustedProxy|TrustedProxyList)|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|Rewrite(?:Base|Cond|Engine|Map|Options|Rule)|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script(?:Alias|AliasMatch|InterpreterSource|Log|LogBuffer|LogLength|Sock)?|SecureListen|SeeRequestTail|SendBufferSize|Server(?:Admin|Alias|Limit|Name|Path|Root|Signature|Tokens)|Session(?:Cookie(?:Name|Name2|Remove)|Crypto(?:Cipher|Driver|Passphrase|PassphraseFile)|DBD(?:CookieName|CookieName2|CookieRemove|DeleteLabel|InsertLabel|PerUser|SelectLabel|UpdateLabel)|Env|Exclude|Header|Include|MaxAge)?|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSL(?:CACertificateFile|CACertificatePath|CADNRequestFile|CADNRequestPath|CARevocationCheck|CARevocationFile|CARevocationPath|CertificateChainFile|CertificateFile|CertificateKeyFile|CipherSuite|Compression|CryptoDevice|Engine|FIPS|HonorCipherOrder|InsecureRenegotiation|OCSP(?:DefaultResponder|Enable|OverrideResponder|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|UseRequestNonce)|OpenSSLConfCmd|Options|PassPhraseDialog|Protocol|Proxy(?:CACertificateFile|CACertificatePath|CARevocation(?:Check|File|Path)|CheckPeer(?:CN|Expire|Name)|CipherSuite|Engine|MachineCertificate(?:ChainFile|File|Path)|Protocol|Verify|VerifyDepth)|RandomSeed|RenegBufferSize|Require|RequireSSL|Session(?:Cache|CacheTimeout|TicketKeyFile|Tickets)|SRPUnknownUserSeed|SRPVerifierFile|Stapling(?:Cache|ErrorCacheTimeout|FakeTryLater|ForceURL|ResponderTimeout|ResponseMaxAge|ResponseTimeSkew|ReturnResponderErrors|StandardCacheTimeout)|StrictSNIVHostCheck|UserName|UseStapling|VerifyClient|VerifyDepth)|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|Virtual(?:DocumentRoot|ScriptAlias)(?:IP)?|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
        lookbehind: !0,
        alias: "property"
      },
      "directive-block": {
        pattern: /<\/?\b(?:Auth[nz]ProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|Require(?:All|Any|None)|VirtualHost)\b.*>/i,
        inside: {
          "directive-block": {
            pattern: /^<\/?\w+/,
            inside: {
              punctuation: /^<\/?/
            },
            alias: "tag"
          },
          "directive-block-parameter": {
            pattern: /.*[^>]/,
            inside: {
              punctuation: /:/,
              string: {
                pattern: /("|').*\1/,
                inside: {
                  variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
                }
              }
            },
            alias: "attr-value"
          },
          punctuation: />/
        },
        alias: "tag"
      },
      "directive-flags": {
        pattern: /\[(?:[\w=],?)+\]/,
        alias: "keyword"
      },
      string: {
        pattern: /("|').*\1/,
        inside: {
          variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
        }
      },
      variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
      regex: /\^?.*\$|\^.*\$?/
    };
  }
  return Pp;
}
var Bp, pA;
function Fv() {
  if (pA) return Bp;
  pA = 1, Bp = e, e.displayName = "sql", e.aliases = [];
  function e(t) {
    t.languages.sql = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: !0
      },
      variable: [
        {
          pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
          greedy: !0
        },
        /@[\w.$]+/
      ],
      string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: !0,
        lookbehind: !0
      },
      identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: !0,
        lookbehind: !0,
        inside: {
          punctuation: /^`|`$/
        }
      },
      function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
      // Should we highlight user defined functions too?
      keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
      punctuation: /[;[\]()`,.]/
    };
  }
  return Bp;
}
var $p, fA;
function AK() {
  if (fA) return $p;
  fA = 1;
  var e = Fv();
  $p = t, t.displayName = "apex", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\b(?:(?:after|before)(?=\s+[a-z])|abstract|activate|and|any|array|as|asc|autonomous|begin|bigdecimal|blob|boolean|break|bulk|by|byte|case|cast|catch|char|class|collect|commit|const|continue|currency|date|datetime|decimal|default|delete|desc|do|double|else|end|enum|exception|exit|export|extends|final|finally|float|for|from|get(?=\s*[{};])|global|goto|group|having|hint|if|implements|import|in|inner|insert|instanceof|int|integer|interface|into|join|like|limit|list|long|loop|map|merge|new|not|null|nulls|number|object|of|on|or|outer|override|package|parallel|pragma|private|protected|public|retrieve|return|rollback|select|set|short|sObject|sort|static|string|super|switch|synchronized|system|testmethod|then|this|throw|time|transaction|transient|trigger|try|undelete|update|upsert|using|virtual|void|webservice|when|where|while|(?:inherited|with|without)\s+sharing)\b/i, i = /\b(?:(?=[a-z_]\w*\s*[<\[])|(?!<keyword>))[A-Z_]\w*(?:\s*\.\s*[A-Z_]\w*)*\b(?:\s*(?:\[\s*\]|<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>))*/.source.replace(
        /<keyword>/g,
        function() {
          return a.source;
        }
      );
      function s(c) {
        return RegExp(
          c.replace(/<CLASS-NAME>/g, function() {
            return i;
          }),
          "i"
        );
      }
      var u = {
        keyword: a,
        punctuation: /[()\[\]{};,:.<>]/
      };
      r.languages.apex = {
        comment: r.languages.clike.comment,
        string: r.languages.clike.string,
        sql: {
          pattern: /((?:[=,({:]|\breturn)\s*)\[[^\[\]]*\]/i,
          lookbehind: !0,
          greedy: !0,
          alias: "language-sql",
          inside: r.languages.sql
        },
        annotation: {
          pattern: /@\w+\b/,
          alias: "punctuation"
        },
        "class-name": [
          {
            pattern: s(
              /(\b(?:class|enum|extends|implements|instanceof|interface|new|trigger\s+\w+\s+on)\s+)<CLASS-NAME>/.source
            ),
            lookbehind: !0,
            inside: u
          },
          {
            // cast
            pattern: s(
              /(\(\s*)<CLASS-NAME>(?=\s*\)\s*[\w(])/.source
            ),
            lookbehind: !0,
            inside: u
          },
          {
            // variable/parameter declaration and return types
            pattern: s(/<CLASS-NAME>(?=\s*\w+\s*[;=,(){:])/.source),
            inside: u
          }
        ],
        trigger: {
          pattern: /(\btrigger\s+)\w+\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        keyword: a,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        boolean: /\b(?:false|true)\b/i,
        number: /(?:\B\.\d+|\b\d+(?:\.\d+|L)?)\b/i,
        operator: /[!=](?:==?)?|\?\.?|&&|\|\||--|\+\+|[-+*/^&|]=?|:|<<?=?|>{1,3}=?/,
        punctuation: /[()\[\]{};,.]/
      };
    }(n);
  }
  return $p;
}
var Up, gA;
function IK() {
  if (gA) return Up;
  gA = 1, Up = e, e.displayName = "apl", e.aliases = [];
  function e(t) {
    t.languages.apl = {
      comment: /(?:⍝|#[! ]).*$/m,
      string: {
        pattern: /'(?:[^'\r\n]|'')*'/,
        greedy: !0
      },
      number: /¯?(?:\d*\.?\b\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:(?:\d+(?:\.\d+)?|\.\d+)(?:e[+¯]?\d+)?|¯|∞))?/i,
      statement: /:[A-Z][a-z][A-Za-z]*\b/,
      "system-function": {
        pattern: /⎕[A-Z]+/i,
        alias: "function"
      },
      constant: /[⍬⌾#⎕⍞]/,
      function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
      "monadic-operator": {
        pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
        alias: "operator"
      },
      "dyadic-operator": {
        pattern: /[.⍣⍠⍤∘⌸@⌺⍥]/,
        alias: "operator"
      },
      assignment: {
        pattern: /←/,
        alias: "keyword"
      },
      punctuation: /[\[;\]()◇⋄]/,
      dfn: {
        pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
        alias: "builtin"
      }
    };
  }
  return Up;
}
var jp, mA;
function RK() {
  if (mA) return jp;
  mA = 1, jp = e, e.displayName = "applescript", e.aliases = [];
  function e(t) {
    t.languages.applescript = {
      comment: [
        // Allow one level of nesting
        /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
        /--.+/,
        /#.+/
      ],
      string: /"(?:\\.|[^"\\\r\n])*"/,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?\b/i,
      operator: [
        /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
        /\b(?:(?:begin|end|start)s? with|(?:contains?|(?:does not|doesn't) contain)|(?:is|isn't|is not) (?:contained by|in)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:comes|(?:does not|doesn't) come) (?:after|before)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equal to|equals|is not|isn't)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|as|div|mod|not|or))\b/
      ],
      keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
      "class-name": /\b(?:POSIX file|RGB color|alias|application|boolean|centimeters|centimetres|class|constant|cubic centimeters|cubic centimetres|cubic feet|cubic inches|cubic meters|cubic metres|cubic yards|date|degrees Celsius|degrees Fahrenheit|degrees Kelvin|feet|file|gallons|grams|inches|integer|kilograms|kilometers|kilometres|list|liters|litres|meters|metres|miles|number|ounces|pounds|quarts|real|record|reference|script|square feet|square kilometers|square kilometres|square meters|square metres|square miles|square yards|text|yards)\b/,
      punctuation: /[{}():,¬«»《》]/
    };
  }
  return jp;
}
var qp, hA;
function _K() {
  if (hA) return qp;
  hA = 1, qp = e, e.displayName = "aql", e.aliases = [];
  function e(t) {
    t.languages.aql = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      property: {
        pattern: /([{,]\s*)(?:(?!\d)\w+|(["'´`])(?:(?!\2)[^\\\r\n]|\\.)*\2)(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /([´`])(?:(?!\1)[^\\\r\n]|\\.)*\1/,
        greedy: !0
      },
      variable: /@@?\w+/,
      keyword: [
        {
          pattern: /(\bWITH\s+)COUNT(?=\s+INTO\b)/i,
          lookbehind: !0
        },
        /\b(?:AGGREGATE|ALL|AND|ANY|ASC|COLLECT|DESC|DISTINCT|FILTER|FOR|GRAPH|IN|INBOUND|INSERT|INTO|K_PATHS|K_SHORTEST_PATHS|LET|LIKE|LIMIT|NONE|NOT|NULL|OR|OUTBOUND|REMOVE|REPLACE|RETURN|SHORTEST_PATH|SORT|UPDATE|UPSERT|WINDOW|WITH)\b/i,
        // pseudo keywords get a lookbehind to avoid false positives
        {
          pattern: /(^|[^\w.[])(?:KEEP|PRUNE|SEARCH|TO)\b/i,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.[])(?:CURRENT|NEW|OLD)\b/,
          lookbehind: !0
        },
        {
          pattern: /\bOPTIONS(?=\s*\{)/i
        }
      ],
      function: /\b(?!\d)\w+(?=\s*\()/,
      boolean: /\b(?:false|true)\b/i,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      number: [
        /\b0b[01]+/i,
        /\b0x[0-9a-f]+/i,
        /(?:\B\.\d+|\b(?:0|[1-9]\d*)(?:\.\d+)?)(?:e[+-]?\d+)?/i
      ],
      operator: /\*{2,}|[=!]~|[!=<>]=?|&&|\|\||[-+*/%]/,
      punctuation: /::|[?.:,;()[\]{}]/
    };
  }
  return qp;
}
var zp, bA;
function Ri() {
  if (bA) return zp;
  bA = 1, zp = e, e.displayName = "c", e.aliases = [];
  function e(t) {
    t.languages.c = t.languages.extend("clike", {
      comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      string: {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: !0
      },
      keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
      operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
    }), t.languages.insertBefore("c", "string", {
      char: {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: !0
      }
    }), t.languages.insertBefore("c", "string", {
      macro: {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          string: [
            {
              // highlight the path of the include statement as a string
              pattern: /^(#\s*include\s*)<[^>]+>/,
              lookbehind: !0
            },
            t.languages.c.string
          ],
          char: t.languages.c.char,
          comment: t.languages.c.comment,
          "macro-name": [
            {
              pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
              lookbehind: !0
            },
            {
              pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
              lookbehind: !0,
              alias: "function"
            }
          ],
          // highlight macro directives as keywords
          directive: {
            pattern: /^(#\s*)[a-z]+/,
            lookbehind: !0,
            alias: "keyword"
          },
          "directive-hash": /^#/,
          punctuation: /##|\\(?=[\r\n])/,
          expression: {
            pattern: /\S[\s\S]*/,
            inside: t.languages.c
          }
        }
      }
    }), t.languages.insertBefore("c", "function", {
      // highlight predefined macros as constants
      constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
    }), delete t.languages.c.boolean;
  }
  return zp;
}
var Gp, yA;
function Pv() {
  if (yA) return Gp;
  yA = 1;
  var e = Ri();
  Gp = t, t.displayName = "cpp", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, i = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(
        /<keyword>/g,
        function() {
          return a.source;
        }
      );
      r.languages.cpp = r.languages.extend("c", {
        "class-name": [
          {
            pattern: RegExp(
              /(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(
                /<keyword>/g,
                function() {
                  return a.source;
                }
              )
            ),
            lookbehind: !0
          },
          // This is intended to capture the class name of method implementations like:
          //   void foo::bar() const {}
          // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
          // it starts with an uppercase letter. This approximation should give decent results.
          /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
          // This will capture the class name before destructors like:
          //   Foo::~Foo() {}
          /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
          // This also intends to capture the class name of method implementations but here the class has template
          // parameters, so it can't be a namespace (until C++ adds generic namespaces).
          /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: a,
        number: {
          pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
          greedy: !0
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
      }), r.languages.insertBefore("cpp", "string", {
        module: {
          // https://en.cppreference.com/w/cpp/language/modules
          pattern: RegExp(
            /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(
              /<mod-name>/g,
              function() {
                return i;
              }
            ) + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: /^[<"][\s\S]+/,
            operator: /:/,
            punctuation: /\./
          }
        },
        "raw-string": {
          pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
          alias: "string",
          greedy: !0
        }
      }), r.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
          pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<[\s\S]+/,
              alias: "class-name",
              inside: r.languages.cpp
            }
          }
        }
      }), r.languages.insertBefore("cpp", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      }), r.languages.insertBefore("cpp", "class-name", {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        "base-clause": {
          pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: r.languages.extend("cpp", {})
        }
      }), r.languages.insertBefore(
        "inside",
        "double-colon",
        {
          // All untokenized words that are not namespaces should be class names
          "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
        },
        r.languages.cpp["base-clause"]
      );
    }(n);
  }
  return Gp;
}
var Hp, vA;
function CK() {
  if (vA) return Hp;
  vA = 1;
  var e = Pv();
  Hp = t, t.displayName = "arduino", t.aliases = ["ino"];
  function t(n) {
    n.register(e), n.languages.arduino = n.languages.extend("cpp", {
      keyword: /\b(?:String|array|bool|boolean|break|byte|case|catch|continue|default|do|double|else|finally|for|function|goto|if|in|instanceof|int|integer|long|loop|new|null|return|setup|string|switch|throw|try|void|while|word)\b/,
      constant: /\b(?:ANALOG_MESSAGE|DEFAULT|DIGITAL_MESSAGE|EXTERNAL|FIRMATA_STRING|HIGH|INPUT|INPUT_PULLUP|INTERNAL|INTERNAL1V1|INTERNAL2V56|LED_BUILTIN|LOW|OUTPUT|REPORT_ANALOG|REPORT_DIGITAL|SET_PIN_MODE|SYSEX_START|SYSTEM_RESET)\b/,
      builtin: /\b(?:Audio|BSSID|Bridge|Client|Console|EEPROM|Esplora|EsploraTFT|Ethernet|EthernetClient|EthernetServer|EthernetUDP|File|FileIO|FileSystem|Firmata|GPRS|GSM|GSMBand|GSMClient|GSMModem|GSMPIN|GSMScanner|GSMServer|GSMVoiceCall|GSM_SMS|HttpClient|IPAddress|IRread|Keyboard|KeyboardController|LiquidCrystal|LiquidCrystal_I2C|Mailbox|Mouse|MouseController|PImage|Process|RSSI|RobotControl|RobotMotor|SD|SPI|SSID|Scheduler|Serial|Server|Servo|SoftwareSerial|Stepper|Stream|TFT|Task|USBHost|WiFi|WiFiClient|WiFiServer|WiFiUDP|Wire|YunClient|YunServer|abs|addParameter|analogRead|analogReadResolution|analogReference|analogWrite|analogWriteResolution|answerCall|attach|attachGPRS|attachInterrupt|attached|autoscroll|available|background|beep|begin|beginPacket|beginSD|beginSMS|beginSpeaker|beginTFT|beginTransmission|beginWrite|bit|bitClear|bitRead|bitSet|bitWrite|blink|blinkVersion|buffer|changePIN|checkPIN|checkPUK|checkReg|circle|cityNameRead|cityNameWrite|clear|clearScreen|click|close|compassRead|config|connect|connected|constrain|cos|countryNameRead|countryNameWrite|createChar|cursor|debugPrint|delay|delayMicroseconds|detach|detachInterrupt|digitalRead|digitalWrite|disconnect|display|displayLogos|drawBMP|drawCompass|encryptionType|end|endPacket|endSMS|endTransmission|endWrite|exists|exitValue|fill|find|findUntil|flush|gatewayIP|get|getAsynchronously|getBand|getButton|getCurrentCarrier|getIMEI|getKey|getModifiers|getOemKey|getPINUsed|getResult|getSignalStrength|getSocket|getVoiceCallStatus|getXChange|getYChange|hangCall|height|highByte|home|image|interrupts|isActionDone|isDirectory|isListening|isPIN|isPressed|isValid|keyPressed|keyReleased|keyboardRead|knobRead|leftToRight|line|lineFollowConfig|listen|listenOnLocalhost|loadImage|localIP|lowByte|macAddress|maintain|map|max|messageAvailable|micros|millis|min|mkdir|motorsStop|motorsWrite|mouseDragged|mouseMoved|mousePressed|mouseReleased|move|noAutoscroll|noBlink|noBuffer|noCursor|noDisplay|noFill|noInterrupts|noListenOnLocalhost|noStroke|noTone|onReceive|onRequest|open|openNextFile|overflow|parseCommand|parseFloat|parseInt|parsePacket|pauseMode|peek|pinMode|playFile|playMelody|point|pointTo|position|pow|prepare|press|print|printFirmwareVersion|printVersion|println|process|processInput|pulseIn|put|random|randomSeed|read|readAccelerometer|readBlue|readButton|readBytes|readBytesUntil|readGreen|readJoystickButton|readJoystickSwitch|readJoystickX|readJoystickY|readLightSensor|readMessage|readMicrophone|readNetworks|readRed|readSlider|readString|readStringUntil|readTemperature|ready|rect|release|releaseAll|remoteIP|remoteNumber|remotePort|remove|requestFrom|retrieveCallingNumber|rewindDirectory|rightToLeft|rmdir|robotNameRead|robotNameWrite|run|runAsynchronously|runShellCommand|runShellCommandAsynchronously|running|scanNetworks|scrollDisplayLeft|scrollDisplayRight|seek|sendAnalog|sendDigitalPortPair|sendDigitalPorts|sendString|sendSysex|serialEvent|setBand|setBitOrder|setClockDivider|setCursor|setDNS|setDataMode|setFirmwareVersion|setMode|setPINUsed|setSpeed|setTextSize|setTimeout|shiftIn|shiftOut|shutdown|sin|size|sqrt|startLoop|step|stop|stroke|subnetMask|switchPIN|tan|tempoWrite|text|tone|transfer|tuneWrite|turn|updateIR|userNameRead|userNameWrite|voiceCall|waitContinue|width|write|writeBlue|writeGreen|writeJSON|writeMessage|writeMicroseconds|writeRGB|writeRed|yield)\b/
    }), n.languages.ino = n.languages.arduino;
  }
  return Hp;
}
var Vp, EA;
function kK() {
  if (EA) return Vp;
  EA = 1, Vp = e, e.displayName = "arff", e.aliases = [];
  function e(t) {
    t.languages.arff = {
      comment: /%.*/,
      string: {
        pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /@(?:attribute|data|end|relation)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      punctuation: /[{},]/
    };
  }
  return Vp;
}
var Wp, SA;
function NK() {
  if (SA) return Wp;
  SA = 1, Wp = e, e.displayName = "asciidoc", e.aliases = ["adoc"];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\[\]\\]|\\.)*\]|[^\[\]\\"'$`]|\\.)*\]/m,
        lookbehind: !0,
        inside: {
          quoted: {
            pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
            inside: {
              punctuation: /^[$`]|[$`]$/
            }
          },
          interpreted: {
            pattern: /'(?:[^'\\]|\\.)*'/,
            inside: {
              punctuation: /^'|'$/
              // See rest below
            }
          },
          string: /"(?:[^"\\]|\\.)*"/,
          variable: /\w+(?==)/,
          punctuation: /^\[|\]$|,/,
          operator: /=/,
          // The negative look-ahead prevents blank matches
          "attr-value": /(?!^\s+$).+/
        }
      }, a = n.languages.asciidoc = {
        "comment-block": {
          pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
          alias: "comment"
        },
        table: {
          pattern: /^\|={3,}(?:(?:\r?\n|\r(?!\n)).*)*?(?:\r?\n|\r)\|={3,}$/m,
          inside: {
            specifiers: {
              pattern: /(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*](?:[<^>](?:\.[<^>])?|\.[<^>])?|[<^>](?:\.[<^>])?|\.[<^>])[a-z]*|[a-z]+)(?=\|)/,
              alias: "attr-value"
            },
            punctuation: {
              pattern: /(^|[^\\])[|!]=*/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        "passthrough-block": {
          pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^\++|\++$/
            // See rest below
          }
        },
        // Literal blocks and listing blocks
        "literal-block": {
          pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
            // See rest below
          }
        },
        // Sidebar blocks, quote blocks, example blocks and open blocks
        "other-block": {
          pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
          inside: {
            punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
            // See rest below
          }
        },
        // list-punctuation and list-label must appear before indented-block
        "list-punctuation": {
          pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
          lookbehind: !0,
          alias: "punctuation"
        },
        "list-label": {
          pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
          lookbehind: !0,
          alias: "symbol"
        },
        "indented-block": {
          pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
          lookbehind: !0
        },
        comment: /^\/\/.*/m,
        title: {
          pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} .+|^\.(?![\s.]).*/m,
          alias: "important",
          inside: {
            punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
            // See rest below
          }
        },
        "attribute-entry": {
          pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
          alias: "tag"
        },
        attributes: r,
        hr: {
          pattern: /^'{3,}$/m,
          alias: "punctuation"
        },
        "page-break": {
          pattern: /^<{3,}$/m,
          alias: "punctuation"
        },
        admonition: {
          pattern: /^(?:CAUTION|IMPORTANT|NOTE|TIP|WARNING):/m,
          alias: "keyword"
        },
        callout: [
          {
            pattern: /(^[ \t]*)<?\d*>/m,
            lookbehind: !0,
            alias: "symbol"
          },
          {
            pattern: /<\d+>/,
            alias: "symbol"
          }
        ],
        macro: {
          pattern: /\b[a-z\d][a-z\d-]*::?(?:[^\s\[\]]*\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
          inside: {
            function: /^[a-z\d-]+(?=:)/,
            punctuation: /^::?/,
            attributes: {
              pattern: /(?:\[(?:[^\]\\"']|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
              inside: r.inside
            }
          }
        },
        inline: {
          /*
          The initial look-behind prevents the highlighting of escaped quoted text.
          Quoted text can be multi-line but cannot span an empty line.
          All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
          First, we handle the constrained quotes.
          Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
          They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
          Then we handle the unconstrained quotes.
          Those do not have the restrictions of the constrained quotes.
          They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
          */
          pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"']|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?:[^`'\s]|\s+\S)+['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"']|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
          lookbehind: !0,
          inside: {
            attributes: r,
            url: {
              pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
              inside: {
                punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
              }
            },
            "attribute-ref": {
              pattern: /^\{.+\}$/,
              inside: {
                variable: {
                  pattern: /(^\{)[a-z\d,+_-]+/,
                  lookbehind: !0
                },
                operator: /^[=?!#%@$]|!(?=[:}])/,
                punctuation: /^\{|\}$|::?/
              }
            },
            italic: {
              pattern: /^(['_])[\s\S]+\1$/,
              inside: {
                punctuation: /^(?:''?|__?)|(?:''?|__?)$/
              }
            },
            bold: {
              pattern: /^\*[\s\S]+\*$/,
              inside: {
                punctuation: /^\*\*?|\*\*?$/
              }
            },
            punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
          }
        },
        replacement: {
          pattern: /\((?:C|R|TM)\)/,
          alias: "builtin"
        },
        entity: /&#?[\da-z]{1,8};/i,
        "line-continuation": {
          pattern: /(^| )\+$/m,
          lookbehind: !0,
          alias: "punctuation"
        }
      };
      function i(s) {
        s = s.split(" ");
        for (var u = {}, c = 0, d = s.length; c < d; c++)
          u[s[c]] = a[s[c]];
        return u;
      }
      r.inside.interpreted.inside.rest = i(
        "macro inline replacement entity"
      ), a["passthrough-block"].inside.rest = i("macro"), a["literal-block"].inside.rest = i("callout"), a.table.inside.rest = i(
        "comment-block passthrough-block literal-block other-block list-punctuation indented-block comment title attribute-entry attributes hr page-break admonition list-label callout macro inline replacement entity line-continuation"
      ), a["other-block"].inside.rest = i(
        "table list-punctuation indented-block comment attribute-entry attributes hr page-break admonition list-label macro inline replacement entity line-continuation"
      ), a.title.inside.rest = i(
        "macro inline replacement entity"
      ), n.hooks.add("wrap", function(s) {
        s.type === "entity" && (s.attributes.title = s.content.value.replace(/&amp;/, "&"));
      }), n.languages.adoc = n.languages.asciidoc;
    })(t);
  }
  return Wp;
}
var Kp, xA;
function OK() {
  if (xA) return Kp;
  xA = 1, Kp = e, e.displayName = "asm6502", e.aliases = [];
  function e(t) {
    t.languages.asm6502 = {
      comment: /;.*/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      "op-code": {
        pattern: /\b(?:ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA|adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{1,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[xya]\b/i,
        alias: "variable"
      },
      punctuation: /[(),:]/
    };
  }
  return Kp;
}
var Yp, TA;
function LK() {
  if (TA) return Yp;
  TA = 1, Yp = e, e.displayName = "asmatmel", e.aliases = [];
  function e(t) {
    t.languages.asmatmel = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      constant: /\b(?:PORT[A-Z]|DDR[A-Z]|(?:DD|P)[A-Z](?:\d|[0-2]\d|3[01]))\b/,
      directive: {
        pattern: /\.\w+(?= )/,
        alias: "property"
      },
      "r-register": {
        pattern: /\br(?:\d|[12]\d|3[01])\b/,
        alias: "variable"
      },
      "op-code": {
        pattern: /\b(?:ADC|ADD|ADIW|AND|ANDI|ASR|BCLR|BLD|BRBC|BRBS|BRCC|BRCS|BREAK|BREQ|BRGE|BRHC|BRHS|BRID|BRIE|BRLO|BRLT|BRMI|BRNE|BRPL|BRSH|BRTC|BRTS|BRVC|BRVS|BSET|BST|CALL|CBI|CBR|CLC|CLH|CLI|CLN|CLR|CLS|CLT|CLV|CLZ|COM|CP|CPC|CPI|CPSE|DEC|DES|EICALL|EIJMP|ELPM|EOR|FMUL|FMULS|FMULSU|ICALL|IJMP|IN|INC|JMP|LAC|LAS|LAT|LD|LD[A-Za-z0-9]|LPM|LSL|LSR|MOV|MOVW|MUL|MULS|MULSU|NEG|NOP|OR|ORI|OUT|POP|PUSH|RCALL|RET|RETI|RJMP|ROL|ROR|SBC|SBCI|SBI|SBIC|SBIS|SBIW|SBR|SBRC|SBRS|SEC|SEH|SEI|SEN|SER|SES|SET|SEV|SEZ|SLEEP|SPM|ST|ST[A-Z0-9]|SUB|SUBI|SWAP|TST|WDR|XCH|adc|add|adiw|and|andi|asr|bclr|bld|brbc|brbs|brcc|brcs|break|breq|brge|brhc|brhs|brid|brie|brlo|brlt|brmi|brne|brpl|brsh|brtc|brts|brvc|brvs|bset|bst|call|cbi|cbr|clc|clh|cli|cln|clr|cls|clt|clv|clz|com|cp|cpc|cpi|cpse|dec|des|eicall|eijmp|elpm|eor|fmul|fmuls|fmulsu|icall|ijmp|in|inc|jmp|lac|las|lat|ld|ld[a-z0-9]|lpm|lsl|lsr|mov|movw|mul|muls|mulsu|neg|nop|or|ori|out|pop|push|rcall|ret|reti|rjmp|rol|ror|sbc|sbci|sbi|sbic|sbis|sbiw|sbr|sbrc|sbrs|sec|seh|sei|sen|ser|ses|set|sev|sez|sleep|spm|st|st[a-zA-Z0-9]|sub|subi|swap|tst|wdr|xch)\b/,
        alias: "keyword"
      },
      "hex-number": {
        pattern: /#?\$[\da-f]{2,4}\b/i,
        alias: "number"
      },
      "binary-number": {
        pattern: /#?%[01]+\b/,
        alias: "number"
      },
      "decimal-number": {
        pattern: /#?\b\d+\b/,
        alias: "number"
      },
      register: {
        pattern: /\b[acznvshtixy]\b/i,
        alias: "variable"
      },
      operator: />>=?|<<=?|&&?|\|\|?|[-+*/%&|^!=<>?]=?/,
      punctuation: /[(),:]/
    };
  }
  return Yp;
}
var Xp, wA;
function cc() {
  if (wA) return Xp;
  wA = 1, Xp = e, e.displayName = "csharp", e.aliases = ["dotnet", "cs"];
  function e(t) {
    (function(n) {
      function r(le, Ae) {
        return le.replace(/<<(\d+)>>/g, function(M, he) {
          return "(?:" + Ae[+he] + ")";
        });
      }
      function a(le, Ae, M) {
        return RegExp(r(le, Ae), "");
      }
      function i(le, Ae) {
        for (var M = 0; M < Ae; M++)
          le = le.replace(/<<self>>/g, function() {
            return "(?:" + le + ")";
          });
        return le.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var s = {
        // keywords which represent a return or variable type
        type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
        // keywords which are used to declare a type
        typeDeclaration: "class enum interface record struct",
        // contextual keywords
        // ("var" and "dynamic" are missing because they are used like types)
        contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
        // all other keywords
        other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
      };
      function u(le) {
        return "\\b(?:" + le.trim().replace(/ /g, "|") + ")\\b";
      }
      var c = u(
        s.typeDeclaration
      ), d = RegExp(
        u(
          s.type + " " + s.typeDeclaration + " " + s.contextual + " " + s.other
        )
      ), p = u(
        s.typeDeclaration + " " + s.contextual + " " + s.other
      ), f = u(
        s.type + " " + s.typeDeclaration + " " + s.other
      ), m = i(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), h = i(/\((?:[^()]|<<self>>)*\)/.source, 2), E = /@?\b[A-Za-z_]\w*\b/.source, y = r(/<<0>>(?:\s*<<1>>)?/.source, [E, m]), w = r(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
        p,
        y
      ]), x = /\[\s*(?:,\s*)*\]/.source, I = r(
        /<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source,
        [w, x]
      ), S = r(
        /[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source,
        [m, h, x]
      ), C = r(/\(<<0>>+(?:,<<0>>+)+\)/.source, [S]), T = r(
        /(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source,
        [C, w, x]
      ), A = {
        keyword: d,
        punctuation: /[<>()?,.:[\]]/
      }, O = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, U = /"(?:\\.|[^\\"\r\n])*"/.source, P = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
      n.languages.csharp = n.languages.extend("clike", {
        string: [
          {
            pattern: a(/(^|[^$\\])<<0>>/.source, [P]),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: a(/(^|[^@$\\])<<0>>/.source, [U]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // Using static
            // using static System.Math;
            pattern: a(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
              w
            ]),
            lookbehind: !0,
            inside: A
          },
          {
            // Using alias (type)
            // using Project = PC.MyCompany.Project;
            pattern: a(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
              E,
              T
            ]),
            lookbehind: !0,
            inside: A
          },
          {
            // Using alias (alias)
            // using Project = PC.MyCompany.Project;
            pattern: a(/(\busing\s+)<<0>>(?=\s*=)/.source, [E]),
            lookbehind: !0
          },
          {
            // Type declarations
            // class Foo<A, B>
            // interface Foo<out A, B>
            pattern: a(/(\b<<0>>\s+)<<1>>/.source, [
              c,
              y
            ]),
            lookbehind: !0,
            inside: A
          },
          {
            // Single catch exception declaration
            // catch(Foo)
            // (things like catch(Foo e) is covered by variable declaration)
            pattern: a(/(\bcatch\s*\(\s*)<<0>>/.source, [w]),
            lookbehind: !0,
            inside: A
          },
          {
            // Name of the type parameter of generic constraints
            // where Foo : class
            pattern: a(/(\bwhere\s+)<<0>>/.source, [E]),
            lookbehind: !0
          },
          {
            // Casts and checks via as and is.
            // as Foo<A>, is Bar<B>
            // (things like if(a is Foo b) is covered by variable declaration)
            pattern: a(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
              I
            ]),
            lookbehind: !0,
            inside: A
          },
          {
            // Variable, field and parameter declaration
            // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
            pattern: a(
              /\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source,
              [T, f, E]
            ),
            inside: A
          }
        ],
        keyword: d,
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
        number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
        operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
        punctuation: /\?\.?|::|[{}[\];(),.:]/
      }), n.languages.insertBefore("csharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      }), n.languages.insertBefore("csharp", "punctuation", {
        "named-parameter": {
          pattern: a(/([(,]\s*)<<0>>(?=\s*:)/.source, [E]),
          lookbehind: !0,
          alias: "punctuation"
        }
      }), n.languages.insertBefore("csharp", "class-name", {
        namespace: {
          // namespace Foo.Bar {}
          // using Foo.Bar;
          pattern: a(
            /(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source,
            [E]
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        "type-expression": {
          // default(Foo), typeof(Foo<Bar>), sizeof(int)
          pattern: a(
            /(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source,
            [h]
          ),
          lookbehind: !0,
          alias: "class-name",
          inside: A
        },
        "return-type": {
          // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
          // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
          // int Foo => 0; int Foo { get; set } = 0;
          pattern: a(
            /<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source,
            [T, w]
          ),
          inside: A,
          alias: "class-name"
        },
        "constructor-invocation": {
          // new List<Foo<Bar[]>> { }
          pattern: a(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [T]),
          lookbehind: !0,
          inside: A,
          alias: "class-name"
        },
        /*'explicit-implementation': {
        // int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
        pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
        inside: classNameInside,
        alias: 'class-name'
        },*/
        "generic-method": {
          // foo<Bar>()
          pattern: a(/<<0>>\s*<<1>>(?=\s*\()/.source, [E, m]),
          inside: {
            function: a(/^<<0>>/.source, [E]),
            generic: {
              pattern: RegExp(m),
              alias: "class-name",
              inside: A
            }
          }
        },
        "type-list": {
          // The list of types inherited or of generic constraints
          // class Foo<F> : Bar, IList<FooBar>
          // where F : Bar, IList<int>
          pattern: a(
            /\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source,
            [
              c,
              y,
              E,
              T,
              d.source,
              h,
              /\bnew\s*\(\s*\)/.source
            ]
          ),
          lookbehind: !0,
          inside: {
            "record-arguments": {
              pattern: a(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                y,
                h
              ]),
              lookbehind: !0,
              greedy: !0,
              inside: n.languages.csharp
            },
            keyword: d,
            "class-name": {
              pattern: RegExp(T),
              greedy: !0,
              inside: A
            },
            punctuation: /[,()]/
          }
        },
        preprocessor: {
          pattern: /(^[\t ]*)#.*/m,
          lookbehind: !0,
          alias: "property",
          inside: {
            // highlight preprocessor directives as keywords
            directive: {
              pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
              lookbehind: !0,
              alias: "keyword"
            }
          }
        }
      });
      var b = U + "|" + O, L = r(
        /\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source,
        [b]
      ), j = i(
        r(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          L
        ]),
        2
      ), G = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, H = r(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
        w,
        j
      ]);
      n.languages.insertBefore("csharp", "class-name", {
        attribute: {
          // Attributes
          // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
          pattern: a(
            /((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source,
            [G, H]
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            target: {
              pattern: a(/^<<0>>(?=\s*:)/.source, [G]),
              alias: "keyword"
            },
            "attribute-arguments": {
              pattern: a(/\(<<0>>*\)/.source, [j]),
              inside: n.languages.csharp
            },
            "class-name": {
              pattern: RegExp(w),
              inside: {
                punctuation: /\./
              }
            },
            punctuation: /[:,]/
          }
        }
      });
      var ne = /:[^}\r\n]+/.source, ue = i(
        r(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
          L
        ]),
        2
      ), ce = r(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        ue,
        ne
      ]), Q = i(
        r(
          /[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source,
          [b]
        ),
        2
      ), de = r(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        Q,
        ne
      ]);
      function D(le, Ae) {
        return {
          interpolation: {
            pattern: a(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [le]),
            lookbehind: !0,
            inside: {
              "format-string": {
                pattern: a(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                  Ae,
                  ne
                ]),
                lookbehind: !0,
                inside: {
                  punctuation: /^:/
                }
              },
              punctuation: /^\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                alias: "language-csharp",
                inside: n.languages.csharp
              }
            }
          },
          string: /[\s\S]+/
        };
      }
      n.languages.insertBefore("csharp", "string", {
        "interpolation-string": [
          {
            pattern: a(
              /(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source,
              [ce]
            ),
            lookbehind: !0,
            greedy: !0,
            inside: D(ce, ue)
          },
          {
            pattern: a(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
              de
            ]),
            lookbehind: !0,
            greedy: !0,
            inside: D(de, Q)
          }
        ],
        char: {
          pattern: RegExp(O),
          greedy: !0
        }
      }), n.languages.dotnet = n.languages.cs = n.languages.csharp;
    })(t);
  }
  return Xp;
}
var Zp, AA;
function DK() {
  if (AA) return Zp;
  AA = 1;
  var e = cc();
  Zp = t, t.displayName = "aspnet", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.aspnet = n.languages.extend("markup", {
      "page-directive": {
        pattern: /<%\s*@.*%>/,
        alias: "tag",
        inside: {
          "page-directive": {
            pattern: /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
            alias: "tag"
          },
          rest: n.languages.markup.tag.inside
        }
      },
      directive: {
        pattern: /<%.*%>/,
        alias: "tag",
        inside: {
          directive: {
            pattern: /<%\s*?[$=%#:]{0,2}|%>/,
            alias: "tag"
          },
          rest: n.languages.csharp
        }
      }
    }), n.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, n.languages.insertBefore(
      "inside",
      "punctuation",
      {
        directive: n.languages.aspnet.directive
      },
      n.languages.aspnet.tag.inside["attr-value"]
    ), n.languages.insertBefore("aspnet", "comment", {
      "asp-comment": {
        pattern: /<%--[\s\S]*?--%>/,
        alias: ["asp", "comment"]
      }
    }), n.languages.insertBefore(
      "aspnet",
      n.languages.javascript ? "script" : "tag",
      {
        "asp-script": {
          pattern: /(<script(?=.*runat=['"]?server\b)[^>]*>)[\s\S]*?(?=<\/script>)/i,
          lookbehind: !0,
          alias: ["asp", "script"],
          inside: n.languages.csharp || {}
        }
      }
    );
  }
  return Zp;
}
var Jp, IA;
function MK() {
  if (IA) return Jp;
  IA = 1, Jp = e, e.displayName = "autohotkey", e.aliases = [];
  function e(t) {
    t.languages.autohotkey = {
      comment: [
        {
          pattern: /(^|\s);.*/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*)\/\*(?:[\r\n](?![ \t]*\*\/)|[^\r\n])*(?:[\r\n][ \t]*\*\/)?/m,
          lookbehind: !0,
          greedy: !0
        }
      ],
      tag: {
        // labels
        pattern: /^([ \t]*)[^\s,`":]+(?=:[ \t]*$)/m,
        lookbehind: !0
      },
      string: /"(?:[^"\n\r]|"")*"/,
      variable: /%\w+%/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
      boolean: /\b(?:false|true)\b/,
      selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetRegView|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
      constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_fileencoding|a_formatfloat|a_formatinteger|a_gui|a_guicontrol|a_guicontrolevent|a_guievent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_is64bitos|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|a_priorkey|a_programfiles|a_programs|a_programscommon|a_ptrsize|a_regview|a_screendpi|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scripthwnd|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel|programfiles)\b/i,
      builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|comobjactive|comobjarray|comobjconnect|comobjcreate|comobjerror|comobjflags|comobjget|comobjquery|comobjtype|comobjvalue|cos|dllcall|exp|fileexist|Fileopen|floor|format|il_add|il_create|il_destroy|instr|isfunc|islabel|IsObject|ln|log|ltrim|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|numget|numput|onmessage|regexmatch|regexreplace|registercallback|round|rtrim|sb_seticon|sb_setparts|sb_settext|sin|sqrt|strlen|strreplace|strsplit|substr|tan|tv_add|tv_delete|tv_get|tv_getchild|tv_getcount|tv_getnext|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__Call|__Get|__New|__Set)\b/i,
      symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
      important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|DerefChar|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|If|IfTimeout|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InputLevel|InstallKeybdHook|InstallMouseHook|KeyHistory|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|MenuMaskKey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|Warn|WinActivateForce)\b/i,
      keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_exe|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Catch|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|Finally|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|Region|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Throw|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|Try|TryAgain|Type|UnCheck|underline|Unicode|Unlock|Until|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i,
      function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+(?=\()/,
      punctuation: /[{}[\]():,]/
    };
  }
  return Jp;
}
var Qp, RA;
function FK() {
  if (RA) return Qp;
  RA = 1, Qp = e, e.displayName = "autoit", e.aliases = [];
  function e(t) {
    t.languages.autoit = {
      comment: [
        /;.*/,
        {
          // The multi-line comments delimiters can actually be commented out with ";"
          pattern: /(^[\t ]*)#(?:comments-start|cs)[\s\S]*?^[ \t]*#(?:ce|comments-end)/m,
          lookbehind: !0
        }
      ],
      url: {
        pattern: /(^[\t ]*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
        greedy: !0,
        inside: {
          variable: /([%$@])\w+\1/
        }
      },
      directive: {
        pattern: /(^[\t ]*)#[\w-]+/m,
        lookbehind: !0,
        alias: "keyword"
      },
      function: /\b\w+(?=\()/,
      // Variables and macros
      variable: /[$@]\w+/,
      keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      boolean: /\b(?:False|True)\b/i,
      operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Not|Or)\b/i,
      punctuation: /[\[\]().,:]/
    };
  }
  return Qp;
}
var ef, _A;
function PK() {
  if (_A) return ef;
  _A = 1, ef = e, e.displayName = "avisynth", e.aliases = ["avs"];
  function e(t) {
    (function(n) {
      function r(p, f) {
        return p.replace(/<<(\d+)>>/g, function(m, h) {
          return f[+h];
        });
      }
      function a(p, f, m) {
        return RegExp(r(p, f), m);
      }
      var i = /bool|clip|float|int|string|val/.source, s = [
        // bools
        /is(?:bool|clip|float|int|string)|defined|(?:(?:internal)?function|var)?exists?/.source,
        // control
        /apply|assert|default|eval|import|nop|select|undefined/.source,
        // global
        /opt_(?:allowfloataudio|avipadscanlines|dwchannelmask|enable_(?:b64a|planartopackedrgb|v210|y3_10_10|y3_10_16)|usewaveextensible|vdubplanarhack)|set(?:cachemode|maxcpu|memorymax|planarlegacyalignment|workingdir)/.source,
        // conv
        /hex(?:value)?|value/.source,
        // numeric
        /abs|ceil|continued(?:denominator|numerator)?|exp|floor|fmod|frac|log(?:10)?|max|min|muldiv|pi|pow|rand|round|sign|spline|sqrt/.source,
        // trig
        /a?sinh?|a?cosh?|a?tan[2h]?/.source,
        // bit
        /(?:bit(?:and|not|x?or|[lr]?shift[aslu]?|sh[lr]|sa[lr]|[lr]rotatel?|ro[rl]|te?st|set(?:count)?|cl(?:ea)?r|ch(?:an)?ge?))/.source,
        // runtime
        /average(?:[bgr]|chroma[uv]|luma)|(?:[rgb]|chroma[uv]|luma|rgb|[yuv](?=difference(?:fromprevious|tonext)))difference(?:fromprevious|tonext)?|[yuvrgb]plane(?:median|min|max|minmaxdifference)/.source,
        // script
        /getprocessinfo|logmsg|script(?:dir(?:utf8)?|file(?:utf8)?|name(?:utf8)?)|setlogparams/.source,
        // string
        /chr|(?:fill|find|left|mid|replace|rev|right)str|format|[lu]case|ord|str(?:cmpi?|fromutf8|len|toutf8)|time|trim(?:all|left|right)/.source,
        // version
        /isversionorgreater|version(?:number|string)/.source,
        // helper
        /buildpixeltype|colorspacenametopixeltype/.source,
        // avsplus
        /addautoloaddir|on(?:cpu|cuda)|prefetch|setfiltermtmode/.source
      ].join("|"), u = [
        // content
        /has(?:audio|video)/.source,
        // resolution
        /height|width/.source,
        // framerate
        /frame(?:count|rate)|framerate(?:denominator|numerator)/.source,
        // interlacing
        /getparity|is(?:field|frame)based/.source,
        // color format
        /bitspercomponent|componentsize|hasalpha|is(?:planar(?:rgba?)?|interleaved|rgb(?:24|32|48|64)?|y(?:8|u(?:va?|y2))?|yv(?:12|16|24|411)|420|422|444|packedrgb)|numcomponents|pixeltype/.source,
        // audio
        /audio(?:bits|channels|duration|length(?:[fs]|hi|lo)?|rate)|isaudio(?:float|int)/.source
      ].join("|"), c = [
        // source
        /avi(?:file)?source|directshowsource|image(?:reader|source|sourceanim)|opendmlsource|segmented(?:avisource|directshowsource)|wavsource/.source,
        // color
        /coloryuv|convertbacktoyuy2|convertto(?:RGB(?:24|32|48|64)|(?:planar)?RGBA?|Y8?|YV(?:12|16|24|411)|YUVA?(?:411|420|422|444)|YUY2)|fixluminance|gr[ae]yscale|invert|levels|limiter|mergea?rgb|merge(?:chroma|luma)|rgbadjust|show(?:alpha|blue|green|red)|swapuv|tweak|[uv]toy8?|ytouv/.source,
        // overlay
        /(?:colorkey|reset)mask|layer|mask(?:hs)?|merge|overlay|subtract/.source,
        // geometry
        /addborders|(?:bicubic|bilinear|blackman|gauss|lanczos4|lanczos|point|sinc|spline(?:16|36|64))resize|crop(?:bottom)?|flip(?:horizontal|vertical)|(?:horizontal|vertical)?reduceby2|letterbox|skewrows|turn(?:180|left|right)/.source,
        // pixel
        /blur|fixbrokenchromaupsampling|generalconvolution|(?:spatial|temporal)soften|sharpen/.source,
        // timeline
        /trim|(?:un)?alignedsplice|(?:assume|assumescaled|change|convert)FPS|(?:delete|duplicate)frame|dissolve|fade(?:in|io|out)[02]?|freezeframe|interleave|loop|reverse|select(?:even|odd|(?:range)?every)/.source,
        // interlace
        /assume[bt]ff|assume(?:field|frame)based|bob|complementparity|doubleweave|peculiarblend|pulldown|separate(?:columns|fields|rows)|swapfields|weave(?:columns|rows)?/.source,
        // audio
        /amplify(?:db)?|assumesamplerate|audiodub(?:ex)?|audiotrim|convertaudioto(?:(?:8|16|24|32)bit|float)|converttomono|delayaudio|ensurevbrmp3sync|get(?:left|right)?channel|kill(?:audio|video)|mergechannels|mixaudio|monotostereo|normalize|resampleaudio|ssrc|supereq|timestretch/.source,
        // conditional
        /animate|applyrange|conditional(?:filter|reader|select)|frameevaluate|scriptclip|tcp(?:server|source)|writefile(?:end|if|start)?/.source,
        // export
        /imagewriter/.source,
        // debug
        /blackness|blankclip|colorbars(?:hd)?|compare|dumpfiltergraph|echo|histogram|info|messageclip|preroll|setgraphanalysis|show(?:framenumber|smpte|time)|showfiveversions|stack(?:horizontal|vertical)|subtitle|tone|version/.source
      ].join("|"), d = [s, u, c].join("|");
      n.languages.avisynth = {
        comment: [
          {
            // Matches [* *] nestable block comments, but only supports 1 level of nested comments
            // /\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|<self>)*\*\]/
            pattern: /(^|[^\\])\[\*(?:[^\[*]|\[(?!\*)|\*(?!\])|\[\*(?:[^\[*]|\[(?!\*)|\*(?!\]))*\*\])*\*\]/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches /* */ block comments
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // Matches # comments
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // Handle before strings because optional arguments are surrounded by double quotes
        argument: {
          pattern: a(/\b(?:<<0>>)\s+("?)\w+\1/.source, [i], "i"),
          inside: {
            keyword: /^\w+/
          }
        },
        // Optional argument assignment
        "argument-label": {
          pattern: /([,(][\s\\]*)\w+\s*=(?!=)/,
          lookbehind: !0,
          inside: {
            "argument-name": {
              pattern: /^\w+/,
              alias: "punctuation"
            },
            punctuation: /=$/
          }
        },
        string: [
          {
            // triple double-quoted
            pattern: /"""[\s\S]*?"""/,
            greedy: !0
          },
          {
            // single double-quoted
            pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              constant: {
                // These *are* case-sensitive!
                pattern: /\b(?:DEFAULT_MT_MODE|(?:MAINSCRIPT|PROGRAM|SCRIPT)DIR|(?:MACHINE|USER)_(?:CLASSIC|PLUS)_PLUGINS)\b/
              }
            }
          }
        ],
        // The special "last" variable that takes the value of the last implicitly returned clip
        variable: /\b(?:last)\b/i,
        boolean: /\b(?:false|no|true|yes)\b/i,
        keyword: /\b(?:catch|else|for|function|global|if|return|try|while|__END__)\b/i,
        constant: /\bMT_(?:MULTI_INSTANCE|NICE_FILTER|SERIALIZED|SPECIAL_MT)\b/,
        // AviSynth's internal functions, filters, and properties
        "builtin-function": {
          pattern: a(/\b(?:<<0>>)\b/.source, [d], "i"),
          alias: "function"
        },
        "type-cast": {
          pattern: a(/\b(?:<<0>>)(?=\s*\()/.source, [i], "i"),
          alias: "keyword"
        },
        // External/user-defined filters
        function: {
          pattern: /\b[a-z_]\w*(?=\s*\()|(\.)[a-z_]\w*\b/i,
          lookbehind: !0
        },
        // Matches a \ as the first or last character on a line
        "line-continuation": {
          pattern: /(^[ \t]*)\\|\\(?=[ \t]*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        number: /\B\$(?:[\da-f]{6}|[\da-f]{8})\b|(?:(?:\b|\B-)\d+(?:\.\d*)?\b|\B\.\d+\b)/i,
        operator: /\+\+?|[!=<>]=?|&&|\|\||[?:*/%-]/,
        punctuation: /[{}\[\]();,.]/
      }, n.languages.avs = n.languages.avisynth;
    })(t);
  }
  return ef;
}
var tf, CA;
function BK() {
  if (CA) return tf;
  CA = 1, tf = e, e.displayName = "avroIdl", e.aliases = [];
  function e(t) {
    t.languages["avro-idl"] = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      annotation: {
        pattern: /@(?:[$\w.-]|`[^\r\n`]+`)+/,
        greedy: !0,
        alias: "function"
      },
      "function-identifier": {
        pattern: /`[^\r\n`]+`(?=\s*\()/,
        greedy: !0,
        alias: "function"
      },
      identifier: {
        pattern: /`[^\r\n`]+`/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:enum|error|protocol|record|throws)\b\s+)[$\w]+/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:array|boolean|bytes|date|decimal|double|enum|error|false|fixed|float|idl|import|int|local_timestamp_ms|long|map|null|oneway|protocol|record|schema|string|throws|time_ms|timestamp_ms|true|union|uuid|void)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: [
        {
          pattern: /(^|[^\w.])-?(?:(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|0x(?:[a-f0-9]+(?:\.[a-f0-9]*)?|\.[a-f0-9]+)(?:p[+-]?\d+)?)[dfl]?(?![\w.])/i,
          lookbehind: !0
        },
        /-?\b(?:Infinity|NaN)\b/
      ],
      operator: /=/,
      punctuation: /[()\[\]{}<>.:,;-]/
    }, t.languages.avdl = t.languages["avro-idl"];
  }
  return tf;
}
var nf, kA;
function o1() {
  if (kA) return nf;
  kA = 1, nf = e, e.displayName = "bash", e.aliases = ["shell"];
  function e(t) {
    (function(n) {
      var r = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", a = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: !0,
        alias: "punctuation",
        // this looks reasonably well in all themes
        inside: null
        // see below
      }, i = {
        bash: a,
        environment: {
          pattern: RegExp("\\$" + r),
          alias: "constant"
        },
        variable: [
          // [0]: Arithmetic Environment
          {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            greedy: !0,
            inside: {
              // If there is a $ sign at the beginning highlight $(( and )) as variable
              variable: [
                {
                  pattern: /(^\$\(\([\s\S]+)\)\)/,
                  lookbehind: !0
                },
                /^\$\(\(/
              ],
              number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
              // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
              operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
              // If there is no $ sign at the beginning highlight (( and )) as punctuation
              punctuation: /\(\(?|\)\)?|,|;/
            }
          },
          // [1]: Command Substitution
          {
            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
            greedy: !0,
            inside: {
              variable: /^\$\(|^`|\)$|`$/
            }
          },
          // [2]: Brace expansion
          {
            pattern: /\$\{[^}]+\}/,
            greedy: !0,
            inside: {
              operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
              punctuation: /[\[\]]/,
              environment: {
                pattern: RegExp("(\\{)" + r),
                lookbehind: !0,
                alias: "constant"
              }
            }
          },
          /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
      };
      n.languages.bash = {
        shebang: {
          pattern: /^#!\s*\/.*/,
          alias: "important"
        },
        comment: {
          pattern: /(^|[^"{\\$])#.*/,
          lookbehind: !0
        },
        "function-name": [
          // a) function foo {
          // b) foo() {
          // c) function foo() {
          // but not “foo {”
          {
            // a) and c)
            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
            lookbehind: !0,
            alias: "function"
          },
          {
            // b)
            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
            alias: "function"
          }
        ],
        // Highlight variable names as variables in for and select beginnings.
        "for-or-select": {
          pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
          alias: "variable",
          lookbehind: !0
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        "assign-left": {
          pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
          inside: {
            environment: {
              pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + r),
              lookbehind: !0,
              alias: "constant"
            }
          },
          alias: "variable",
          lookbehind: !0
        },
        string: [
          // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
          {
            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
            lookbehind: !0,
            greedy: !0,
            inside: i
          },
          // Here-document with quotes around the tag
          // → No expansion (so no “inside”).
          {
            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              bash: a
            }
          },
          // “Normal” string
          {
            // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
            lookbehind: !0,
            greedy: !0,
            inside: i
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
            pattern: /(^|[^$\\])'[^']*'/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
            greedy: !0,
            inside: {
              entity: i.entity
            }
          }
        ],
        environment: {
          pattern: RegExp("\\$?" + r),
          alias: "constant"
        },
        variable: i.variable,
        function: {
          pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        keyword: {
          pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        builtin: {
          pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
          lookbehind: !0,
          // Alias added to make those easier to distinguish from strings.
          alias: "class-name"
        },
        boolean: {
          pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        "file-descriptor": {
          pattern: /\B&\d\b/,
          alias: "important"
        },
        operator: {
          // Lots of redirections here, but not just that.
          pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
          inside: {
            "file-descriptor": {
              pattern: /^\d/,
              alias: "important"
            }
          }
        },
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        number: {
          pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
          lookbehind: !0
        }
      }, a.inside = n.languages.bash;
      for (var s = [
        "comment",
        "function-name",
        "for-or-select",
        "assign-left",
        "string",
        "environment",
        "function",
        "keyword",
        "builtin",
        "boolean",
        "file-descriptor",
        "operator",
        "punctuation",
        "number"
      ], u = i.variable[1].inside, c = 0; c < s.length; c++)
        u[s[c]] = n.languages.bash[s[c]];
      n.languages.shell = n.languages.bash;
    })(t);
  }
  return nf;
}
var rf, NA;
function s1() {
  if (NA) return rf;
  NA = 1, rf = e, e.displayName = "basic", e.aliases = [];
  function e(t) {
    t.languages.basic = {
      comment: {
        pattern: /(?:!|REM\b).+/i,
        inside: {
          keyword: /^REM/i
        }
      },
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SELECT CASE|SHARED|SHELL|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
      function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
      operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
      punctuation: /[,;:()]/
    };
  }
  return rf;
}
var af, OA;
function $K() {
  if (OA) return af;
  OA = 1, af = e, e.displayName = "batch", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /%%?[~:\w]+%?|!\S+!/, a = {
        pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
        alias: "attr-name",
        inside: {
          punctuation: /:/
        }
      }, i = /"(?:[\\"]"|[^"])*"(?!")/, s = /(?:\b|-)\d+\b/;
      n.languages.batch = {
        comment: [
          /^::.*/m,
          {
            pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0
          }
        ],
        label: {
          pattern: /^:.*/m,
          alias: "property"
        },
        command: [
          {
            // FOR command
            pattern: /((?:^|[&(])[ \t]*)for(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* \S+ in \([^)]+\) do/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:do|in)\b|^for\b/i,
              string: i,
              parameter: a,
              variable: r,
              number: s,
              punctuation: /[()',]/
            }
          },
          {
            // IF command
            pattern: /((?:^|[&(])[ \t]*)if(?: \/[a-z?](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|(?!")(?:(?!==)\S)+)?(?:==| (?:equ|geq|gtr|leq|lss|neq) )(?:"[^"]*"|[^\s"]\S*))/im,
            lookbehind: !0,
            inside: {
              keyword: /\b(?:cmdextversion|defined|errorlevel|exist|not)\b|^if\b/i,
              string: i,
              parameter: a,
              variable: r,
              number: s,
              operator: /\^|==|\b(?:equ|geq|gtr|leq|lss|neq)\b/i
            }
          },
          {
            // ELSE command
            pattern: /((?:^|[&()])[ \t]*)else\b/im,
            lookbehind: !0,
            inside: {
              keyword: /^else\b/i
            }
          },
          {
            // SET command
            pattern: /((?:^|[&(])[ \t]*)set(?: \/[a-z](?:[ :](?:"[^"]*"|[^\s"/]\S*))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
            lookbehind: !0,
            inside: {
              keyword: /^set\b/i,
              string: i,
              parameter: a,
              variable: [r, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
              number: s,
              operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
              punctuation: /[()',]/
            }
          },
          {
            // Other commands
            pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:"(?:[\\"]"|[^"])*"(?!")|[^"^&)\r\n]|\^(?:\r\n|[\s\S]))*/m,
            lookbehind: !0,
            inside: {
              keyword: /^\w+\b/,
              string: i,
              parameter: a,
              label: {
                pattern: /(^\s*):\S+/m,
                lookbehind: !0,
                alias: "property"
              },
              variable: r,
              number: s,
              operator: /\^/
            }
          }
        ],
        operator: /[&@]/,
        punctuation: /[()']/
      };
    })(t);
  }
  return af;
}
var of, LA;
function UK() {
  if (LA) return of;
  LA = 1, of = e, e.displayName = "bbcode", e.aliases = ["shortcode"];
  function e(t) {
    t.languages.bbcode = {
      tag: {
        pattern: /\[\/?[^\s=\]]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))?(?:\s+[^\s=\]]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+))*\s*\]/,
        inside: {
          tag: {
            pattern: /^\[\/?[^\s=\]]+/,
            inside: {
              punctuation: /^\[\/?/
            }
          },
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'"\]=]+)/,
            inside: {
              punctuation: [
                /^=/,
                {
                  pattern: /^(\s*)["']|["']$/,
                  lookbehind: !0
                }
              ]
            }
          },
          punctuation: /\]/,
          "attr-name": /[^\s=\]]+/
        }
      }
    }, t.languages.shortcode = t.languages.bbcode;
  }
  return of;
}
var sf, DA;
function jK() {
  if (DA) return sf;
  DA = 1, sf = e, e.displayName = "bicep", e.aliases = [];
  function e(t) {
    t.languages.bicep = {
      comment: [
        {
          // multiline comments eg /* ASDF */
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          // singleline comments eg // ASDF
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      property: [
        {
          pattern: /([\r\n][ \t]*)[a-z_]\w*(?=[ \t]*:)/i,
          lookbehind: !0
        },
        {
          pattern: /([\r\n][ \t]*)'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'(?=[ \t]*:)/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: /'''[^'][\s\S]*?'''/,
          greedy: !0
        },
        {
          pattern: /(^|[^\\'])'(?:\\.|\$(?!\{)|[^'\\\r\n$])*'/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      "interpolated-string": {
        pattern: /(^|[^\\'])'(?:\\.|\$(?:(?!\{)|\{[^{}\r\n]*\})|[^'\\\r\n$])*'/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}\r\n]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0
              },
              punctuation: /^\$\{|\}$/
            }
          },
          string: /[\s\S]+/
        }
      },
      datatype: {
        pattern: /(\b(?:output|param)\b[ \t]+\w+[ \t]+)\w+\b/,
        lookbehind: !0,
        alias: "class-name"
      },
      boolean: /\b(?:false|true)\b/,
      // https://github.com/Azure/bicep/blob/114a3251b4e6e30082a58729f19a8cc4e374ffa6/src/textmate/bicep.tmlanguage#L184
      keyword: /\b(?:existing|for|if|in|module|null|output|param|resource|targetScope|var)\b/,
      decorator: /@\w+\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.bicep["interpolated-string"].inside.interpolation.inside.expression.inside = t.languages.bicep;
  }
  return sf;
}
var lf, MA;
function qK() {
  if (MA) return lf;
  MA = 1, lf = e, e.displayName = "birb", e.aliases = [];
  function e(t) {
    t.languages.birb = t.languages.extend("clike", {
      string: {
        pattern: /r?("|')(?:\\.|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      "class-name": [
        /\b[A-Z](?:[\d_]*[a-zA-Z]\w*)?\b/,
        // matches variable and function return types (parameters as well).
        /\b(?:[A-Z]\w*|(?!(?:var|void)\b)[a-z]\w*)(?=\s+\w+\s*[;,=()])/
      ],
      keyword: /\b(?:assert|break|case|class|const|default|else|enum|final|follows|for|grab|if|nest|new|next|noSeeb|return|static|switch|throw|var|void|while)\b/,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?|:/,
      variable: /\b[a-z_]\w*\b/
    }), t.languages.insertBefore("birb", "function", {
      metadata: {
        pattern: /<\w+>/,
        greedy: !0,
        alias: "symbol"
      }
    });
  }
  return lf;
}
var uf, FA;
function zK() {
  if (FA) return uf;
  FA = 1;
  var e = Ri();
  uf = t, t.displayName = "bison", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.bison = n.languages.extend("c", {}), n.languages.insertBefore("bison", "comment", {
      bison: {
        // This should match all the beginning of the file
        // including the prologue(s), the bison declarations and
        // the grammar rules.
        pattern: /^(?:[^%]|%(?!%))*%%[\s\S]*?%%/,
        inside: {
          c: {
            // Allow for one level of nested braces
            pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
            inside: {
              delimiter: {
                pattern: /^%?\{|%?\}$/,
                alias: "punctuation"
              },
              "bison-variable": {
                pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
                alias: "variable",
                inside: {
                  punctuation: /<|>/
                }
              },
              rest: n.languages.c
            }
          },
          comment: n.languages.c.comment,
          string: n.languages.c.string,
          property: /\S+(?=:)/,
          keyword: /%\w+/,
          number: {
            pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
            lookbehind: !0
          },
          punctuation: /%[%?]|[|:;\[\]<>]/
        }
      }
    });
  }
  return uf;
}
var cf, PA;
function GK() {
  if (PA) return cf;
  PA = 1, cf = e, e.displayName = "bnf", e.aliases = ["rbnf"];
  function e(t) {
    t.languages.bnf = {
      string: {
        pattern: /"[^\r\n"]*"|'[^\r\n']*'/
      },
      definition: {
        pattern: /<[^<>\r\n\t]+>(?=\s*::=)/,
        alias: ["rule", "keyword"],
        inside: {
          punctuation: /^<|>$/
        }
      },
      rule: {
        pattern: /<[^<>\r\n\t]+>/,
        inside: {
          punctuation: /^<|>$/
        }
      },
      operator: /::=|[|()[\]{}*+?]|\.{3}/
    }, t.languages.rbnf = t.languages.bnf;
  }
  return cf;
}
var df, BA;
function HK() {
  if (BA) return df;
  BA = 1, df = e, e.displayName = "brainfuck", e.aliases = [];
  function e(t) {
    t.languages.brainfuck = {
      pointer: {
        pattern: /<|>/,
        alias: "keyword"
      },
      increment: {
        pattern: /\+/,
        alias: "inserted"
      },
      decrement: {
        pattern: /-/,
        alias: "deleted"
      },
      branching: {
        pattern: /\[|\]/,
        alias: "important"
      },
      operator: /[.,]/,
      comment: /\S+/
    };
  }
  return df;
}
var pf, $A;
function VK() {
  if ($A) return pf;
  $A = 1, pf = e, e.displayName = "brightscript", e.aliases = [];
  function e(t) {
    t.languages.brightscript = {
      comment: /(?:\brem|').*/i,
      "directive-statement": {
        pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
        lookbehind: !0,
        alias: "property",
        inside: {
          "error-message": {
            pattern: /(^#error).+/,
            lookbehind: !0
          },
          directive: {
            pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
            alias: "keyword"
          },
          expression: {
            pattern: /[\s\S]+/,
            inside: null
            // see below
          }
        }
      },
      property: {
        pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\bAs[\t ]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?!\d)\w+(?=[\t ]*\()/,
      number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
      operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
      punctuation: /[.,;()[\]{}]/,
      constant: /\b(?:LINE_NUM)\b/i
    }, t.languages.brightscript["directive-statement"].inside.expression.inside = t.languages.brightscript;
  }
  return pf;
}
var ff, UA;
function WK() {
  if (UA) return ff;
  UA = 1, ff = e, e.displayName = "bro", e.aliases = [];
  function e(t) {
    t.languages.bro = {
      comment: {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: !0,
        inside: {
          italic: /\b(?:FIXME|TODO|XXX)\b/
        }
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      boolean: /\b[TF]\b/,
      function: {
        pattern: /(\b(?:event|function|hook)[ \t]+)\w+(?:::\w+)?/,
        lookbehind: !0
      },
      builtin: /(?:@(?:load(?:-(?:plugin|sigs))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:add_func|create_expire|default|delete_func|encrypt|error_handler|expire_func|group|log|mergeable|optional|persistent|priority|raw_output|read_expire|redef|rotate_interval|rotate_size|synchronized|type_column|write_expire))/,
      constant: {
        pattern: /(\bconst[ \t]+)\w+/i,
        lookbehind: !0
      },
      keyword: /\b(?:add|addr|alarm|any|bool|break|const|continue|count|delete|double|else|enum|event|export|file|for|function|global|hook|if|in|int|interval|local|module|next|of|opaque|pattern|port|print|record|return|schedule|set|string|subnet|table|time|timeout|using|vector|when)\b/,
      operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return ff;
}
var gf, jA;
function KK() {
  if (jA) return gf;
  jA = 1, gf = e, e.displayName = "bsl", e.aliases = [];
  function e(t) {
    t.languages.bsl = {
      comment: /\/\/.*/,
      string: [
        // Строки
        // Strings
        {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        // Дата и время
        // Date & time
        {
          pattern: /'(?:[^'\r\n\\]|\\.)*'/
        }
      ],
      keyword: [
        {
          // RU
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:пока|для|новый|прервать|попытка|исключение|вызватьисключение|иначе|конецпопытки|неопределено|функция|перем|возврат|конецфункции|если|иначеесли|процедура|конецпроцедуры|тогда|знач|экспорт|конецесли|из|каждого|истина|ложь|по|цикл|конеццикла|выполнить)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        {
          // EN
          pattern: /\b(?:break|do|each|else|elseif|enddo|endfunction|endif|endprocedure|endtry|except|execute|export|false|for|function|if|in|new|null|procedure|raise|return|then|to|true|try|undefined|val|var|while)\b/i
        }
      ],
      number: {
        pattern: /(^(?=\d)|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:\d+(?:\.\d*)?|\.\d+)(?:E[+-]?\d+)?/i,
        lookbehind: !0
      },
      operator: [
        /[<>+\-*/]=?|[%=]/,
        // RU
        {
          pattern: /(^|[^\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])(?:и|или|не)(?![\w\u0400-\u0484\u0487-\u052f\u1d2b\u1d78\u2de0-\u2dff\ua640-\ua69f\ufe2e\ufe2f])/i,
          lookbehind: !0
        },
        // EN
        {
          pattern: /\b(?:and|not|or)\b/i
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/,
      directive: [
        // Теги препроцессора вида &Клиент, &Сервер, ...
        // Preprocessor tags of the type &Client, &Server, ...
        {
          pattern: /^([ \t]*)&.*/m,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        },
        // Инструкции препроцессора вида:
        // #Если Сервер Тогда
        // ...
        // #КонецЕсли
        // Preprocessor instructions of the form:
        // #If Server Then
        // ...
        // #EndIf
        {
          pattern: /^([ \t]*)#.*/gm,
          lookbehind: !0,
          greedy: !0,
          alias: "important"
        }
      ]
    }, t.languages.oscript = t.languages.bsl;
  }
  return gf;
}
var mf, qA;
function YK() {
  if (qA) return mf;
  qA = 1, mf = e, e.displayName = "cfscript", e.aliases = [];
  function e(t) {
    t.languages.cfscript = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          inside: {
            annotation: {
              pattern: /(?:^|[^.])@[\w\.]+/,
              alias: "punctuation"
            }
          }
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|break|catch|component|continue|default|do|else|extends|final|finally|for|function|if|in|include|package|private|property|public|remote|required|rethrow|return|static|switch|throw|try|var|while|xml)\b(?!\s*=)/,
      operator: [
        /\+\+|--|&&|\|\||::|=>|[!=]==|<=?|>=?|[-+*/%&|^!=<>]=?|\?(?:\.|:)?|[?:]/,
        /\b(?:and|contains|eq|equal|eqv|gt|gte|imp|is|lt|lte|mod|not|or|xor)\b/
      ],
      scope: {
        pattern: /\b(?:application|arguments|cgi|client|cookie|local|session|super|this|variables)\b/,
        alias: "global"
      },
      type: {
        pattern: /\b(?:any|array|binary|boolean|date|guid|numeric|query|string|struct|uuid|void|xml)\b/,
        alias: "builtin"
      }
    }), t.languages.insertBefore("cfscript", "keyword", {
      // This must be declared before keyword because we use "function" inside the lookahead
      "function-variable": {
        pattern: /[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      }
    }), delete t.languages.cfscript["class-name"], t.languages.cfc = t.languages.cfscript;
  }
  return mf;
}
var hf, zA;
function XK() {
  if (zA) return hf;
  zA = 1;
  var e = Pv();
  hf = t, t.displayName = "chaiscript", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.chaiscript = n.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])'(?:[^'\\]|\\[\s\S])*'/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": [
        {
          // e.g. class Rectangle { ... }
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        {
          // e.g. attr Rectangle::height, def Rectangle::area() { ... }
          pattern: /(\b(?:attr|def)\s+)\w+(?=\s*::)/,
          lookbehind: !0
        }
      ],
      keyword: /\b(?:attr|auto|break|case|catch|class|continue|def|default|else|finally|for|fun|global|if|return|switch|this|try|var|while)\b/,
      number: [n.languages.cpp.number, /\b(?:Infinity|NaN)\b/],
      operator: />>=?|<<=?|\|\||&&|:[:=]?|--|\+\+|[=!<>+\-*/%|&^]=?|[?~]|`[^`\r\n]{1,4}`/
    }), n.languages.insertBefore("chaiscript", "operator", {
      "parameter-type": {
        // e.g. def foo(int x, Vector y) {...}
        pattern: /([,(]\s*)\w+(?=\s+\w)/,
        lookbehind: !0,
        alias: "class-name"
      }
    }), n.languages.insertBefore("chaiscript", "string", {
      "string-interpolation": {
        pattern: /(^|[^\\])"(?:[^"$\\]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/,
            lookbehind: !0,
            inside: {
              "interpolation-expression": {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                inside: n.languages.chaiscript
              },
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    });
  }
  return hf;
}
var bf, GA;
function ZK() {
  if (GA) return bf;
  GA = 1, bf = e, e.displayName = "cil", e.aliases = [];
  function e(t) {
    t.languages.cil = {
      comment: /\/\/.*/,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      directive: {
        pattern: /(^|\W)\.[a-z]+(?=\s)/,
        lookbehind: !0,
        alias: "class-name"
      },
      // Actually an assembly reference
      variable: /\[[\w\.]+\]/,
      keyword: /\b(?:abstract|ansi|assembly|auto|autochar|beforefieldinit|bool|bstr|byvalstr|catch|char|cil|class|currency|date|decimal|default|enum|error|explicit|extends|extern|famandassem|family|famorassem|final(?:ly)?|float32|float64|hidebysig|u?int(?:8|16|32|64)?|iant|idispatch|implements|import|initonly|instance|interface|iunknown|literal|lpstr|lpstruct|lptstr|lpwstr|managed|method|native(?:Type)?|nested|newslot|object(?:ref)?|pinvokeimpl|private|privatescope|public|reqsecobj|rtspecialname|runtime|sealed|sequential|serializable|specialname|static|string|struct|syschar|tbstr|unicode|unmanagedexp|unsigned|value(?:type)?|variant|virtual|void)\b/,
      function: /\b(?:(?:constrained|no|readonly|tail|unaligned|volatile)\.)?(?:conv\.(?:[iu][1248]?|ovf\.[iu][1248]?(?:\.un)?|r\.un|r4|r8)|ldc\.(?:i4(?:\.\d+|\.[mM]1|\.s)?|i8|r4|r8)|ldelem(?:\.[iu][1248]?|\.r[48]|\.ref|a)?|ldind\.(?:[iu][1248]?|r[48]|ref)|stelem\.?(?:i[1248]?|r[48]|ref)?|stind\.(?:i[1248]?|r[48]|ref)?|end(?:fault|filter|finally)|ldarg(?:\.[0-3s]|a(?:\.s)?)?|ldloc(?:\.\d+|\.s)?|sub(?:\.ovf(?:\.un)?)?|mul(?:\.ovf(?:\.un)?)?|add(?:\.ovf(?:\.un)?)?|stloc(?:\.[0-3s])?|refany(?:type|val)|blt(?:\.un)?(?:\.s)?|ble(?:\.un)?(?:\.s)?|bgt(?:\.un)?(?:\.s)?|bge(?:\.un)?(?:\.s)?|unbox(?:\.any)?|init(?:blk|obj)|call(?:i|virt)?|brfalse(?:\.s)?|bne\.un(?:\.s)?|ldloca(?:\.s)?|brzero(?:\.s)?|brtrue(?:\.s)?|brnull(?:\.s)?|brinst(?:\.s)?|starg(?:\.s)?|leave(?:\.s)?|shr(?:\.un)?|rem(?:\.un)?|div(?:\.un)?|clt(?:\.un)?|alignment|castclass|ldvirtftn|beq(?:\.s)?|ckfinite|ldsflda|ldtoken|localloc|mkrefany|rethrow|cgt\.un|arglist|switch|stsfld|sizeof|newobj|newarr|ldsfld|ldnull|ldflda|isinst|throw|stobj|stfld|ldstr|ldobj|ldlen|ldftn|ldfld|cpobj|cpblk|break|br\.s|xor|shl|ret|pop|not|nop|neg|jmp|dup|cgt|ceq|box|and|or|br)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b-?(?:0x[0-9a-f]+|\d+)(?:\.[0-9a-f]+)?\b/i,
      punctuation: /[{}[\];(),:=]|IL_[0-9A-Za-z]+/
    };
  }
  return bf;
}
var yf, HA;
function JK() {
  if (HA) return yf;
  HA = 1, yf = e, e.displayName = "clojure", e.aliases = [];
  function e(t) {
    t.languages.clojure = {
      comment: {
        pattern: /;.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\.)*"/,
        greedy: !0
      },
      char: /\\\w+/,
      symbol: {
        pattern: /(^|[\s()\[\]{},])::?[\w*+!?'<>=/.-]+/,
        lookbehind: !0
      },
      keyword: {
        pattern: /(\()(?:-|->|->>|\.|\.\.|\*|\/|\+|<|<=|=|==|>|>=|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|cond|conj|cons|constantly|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|declare|def|def-|definline|definterface|defmacro|defmethod|defmulti|defn|defn-|defonce|defproject|defprotocol|defrecord|defstruct|deftype|deref|difference|disj|dissoc|distinct|do|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|fn|fnseq|for|frest|gensym|get|get-proxy-class|hash-map|hash-set|identical\?|identity|if|if-let|if-not|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|let|line-seq|list|list\*|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|monitor-enter|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|quote|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|recur|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|set!|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|throw|time|to-array|to-array-2d|tree-seq|true\?|try|union|up|update-proxy|val|vals|var|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[\s)]|$)/,
        lookbehind: !0
      },
      boolean: /\b(?:false|nil|true)\b/,
      number: {
        pattern: /(^|[^\w$@])(?:\d+(?:[/.]\d+)?(?:e[+-]?\d+)?|0x[a-f0-9]+|[1-9]\d?r[a-z0-9]+)[lmn]?(?![\w$@])/i,
        lookbehind: !0
      },
      function: {
        pattern: /((?:^|[^'])\()[\w*+!?'<>=/.-]+(?=[\s)]|$)/,
        lookbehind: !0
      },
      operator: /[#@^`~]/,
      punctuation: /[{}\[\](),]/
    };
  }
  return yf;
}
var vf, VA;
function QK() {
  if (VA) return vf;
  VA = 1, vf = e, e.displayName = "cmake", e.aliases = [];
  function e(t) {
    t.languages.cmake = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{(?:[^{}$]|\$\{[^{}$]*\})*\}/,
            inside: {
              punctuation: /\$\{|\}/,
              variable: /\w+/
            }
          }
        }
      },
      variable: /\b(?:CMAKE_\w+|\w+_(?:(?:BINARY|SOURCE)_DIR|DESCRIPTION|HOMEPAGE_URL|ROOT|VERSION(?:_MAJOR|_MINOR|_PATCH|_TWEAK)?)|(?:ANDROID|APPLE|BORLAND|BUILD_SHARED_LIBS|CACHE|CPACK_(?:ABSOLUTE_DESTINATION_FILES|COMPONENT_INCLUDE_TOPLEVEL_DIRECTORY|ERROR_ON_ABSOLUTE_INSTALL_DESTINATION|INCLUDE_TOPLEVEL_DIRECTORY|INSTALL_DEFAULT_DIRECTORY_PERMISSIONS|INSTALL_SCRIPT|PACKAGING_INSTALL_PREFIX|SET_DESTDIR|WARN_ON_ABSOLUTE_INSTALL_DESTINATION)|CTEST_(?:BINARY_DIRECTORY|BUILD_COMMAND|BUILD_NAME|BZR_COMMAND|BZR_UPDATE_OPTIONS|CHANGE_ID|CHECKOUT_COMMAND|CONFIGURATION_TYPE|CONFIGURE_COMMAND|COVERAGE_COMMAND|COVERAGE_EXTRA_FLAGS|CURL_OPTIONS|CUSTOM_(?:COVERAGE_EXCLUDE|ERROR_EXCEPTION|ERROR_MATCH|ERROR_POST_CONTEXT|ERROR_PRE_CONTEXT|MAXIMUM_FAILED_TEST_OUTPUT_SIZE|MAXIMUM_NUMBER_OF_(?:ERRORS|WARNINGS)|MAXIMUM_PASSED_TEST_OUTPUT_SIZE|MEMCHECK_IGNORE|POST_MEMCHECK|POST_TEST|PRE_MEMCHECK|PRE_TEST|TESTS_IGNORE|WARNING_EXCEPTION|WARNING_MATCH)|CVS_CHECKOUT|CVS_COMMAND|CVS_UPDATE_OPTIONS|DROP_LOCATION|DROP_METHOD|DROP_SITE|DROP_SITE_CDASH|DROP_SITE_PASSWORD|DROP_SITE_USER|EXTRA_COVERAGE_GLOB|GIT_COMMAND|GIT_INIT_SUBMODULES|GIT_UPDATE_CUSTOM|GIT_UPDATE_OPTIONS|HG_COMMAND|HG_UPDATE_OPTIONS|LABELS_FOR_SUBPROJECTS|MEMORYCHECK_(?:COMMAND|COMMAND_OPTIONS|SANITIZER_OPTIONS|SUPPRESSIONS_FILE|TYPE)|NIGHTLY_START_TIME|P4_CLIENT|P4_COMMAND|P4_OPTIONS|P4_UPDATE_OPTIONS|RUN_CURRENT_SCRIPT|SCP_COMMAND|SITE|SOURCE_DIRECTORY|SUBMIT_URL|SVN_COMMAND|SVN_OPTIONS|SVN_UPDATE_OPTIONS|TEST_LOAD|TEST_TIMEOUT|TRIGGER_SITE|UPDATE_COMMAND|UPDATE_OPTIONS|UPDATE_VERSION_ONLY|USE_LAUNCHERS)|CYGWIN|ENV|EXECUTABLE_OUTPUT_PATH|GHS-MULTI|IOS|LIBRARY_OUTPUT_PATH|MINGW|MSVC(?:10|11|12|14|60|70|71|80|90|_IDE|_TOOLSET_VERSION|_VERSION)?|MSYS|PROJECT_(?:BINARY_DIR|DESCRIPTION|HOMEPAGE_URL|NAME|SOURCE_DIR|VERSION|VERSION_(?:MAJOR|MINOR|PATCH|TWEAK))|UNIX|WIN32|WINCE|WINDOWS_PHONE|WINDOWS_STORE|XCODE|XCODE_VERSION))\b/,
      property: /\b(?:cxx_\w+|(?:ARCHIVE_OUTPUT_(?:DIRECTORY|NAME)|COMPILE_DEFINITIONS|COMPILE_PDB_NAME|COMPILE_PDB_OUTPUT_DIRECTORY|EXCLUDE_FROM_DEFAULT_BUILD|IMPORTED_(?:IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_LANGUAGES|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|NO_SONAME|OBJECTS|SONAME)|INTERPROCEDURAL_OPTIMIZATION|LIBRARY_OUTPUT_DIRECTORY|LIBRARY_OUTPUT_NAME|LINK_FLAGS|LINK_INTERFACE_LIBRARIES|LINK_INTERFACE_MULTIPLICITY|LOCATION|MAP_IMPORTED_CONFIG|OSX_ARCHITECTURES|OUTPUT_NAME|PDB_NAME|PDB_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_DIRECTORY|RUNTIME_OUTPUT_NAME|STATIC_LIBRARY_FLAGS|VS_CSHARP|VS_DOTNET_REFERENCEPROP|VS_DOTNET_REFERENCE|VS_GLOBAL_SECTION_POST|VS_GLOBAL_SECTION_PRE|VS_GLOBAL|XCODE_ATTRIBUTE)_\w+|\w+_(?:CLANG_TIDY|COMPILER_LAUNCHER|CPPCHECK|CPPLINT|INCLUDE_WHAT_YOU_USE|OUTPUT_NAME|POSTFIX|VISIBILITY_PRESET)|ABSTRACT|ADDITIONAL_MAKE_CLEAN_FILES|ADVANCED|ALIASED_TARGET|ALLOW_DUPLICATE_CUSTOM_TARGETS|ANDROID_(?:ANT_ADDITIONAL_OPTIONS|API|API_MIN|ARCH|ASSETS_DIRECTORIES|GUI|JAR_DEPENDENCIES|NATIVE_LIB_DEPENDENCIES|NATIVE_LIB_DIRECTORIES|PROCESS_MAX|PROGUARD|PROGUARD_CONFIG_PATH|SECURE_PROPS_PATH|SKIP_ANT_STEP|STL_TYPE)|ARCHIVE_OUTPUT_DIRECTORY|ATTACHED_FILES|ATTACHED_FILES_ON_FAIL|AUTOGEN_(?:BUILD_DIR|ORIGIN_DEPENDS|PARALLEL|SOURCE_GROUP|TARGETS_FOLDER|TARGET_DEPENDS)|AUTOMOC|AUTOMOC_(?:COMPILER_PREDEFINES|DEPEND_FILTERS|EXECUTABLE|MACRO_NAMES|MOC_OPTIONS|SOURCE_GROUP|TARGETS_FOLDER)|AUTORCC|AUTORCC_EXECUTABLE|AUTORCC_OPTIONS|AUTORCC_SOURCE_GROUP|AUTOUIC|AUTOUIC_EXECUTABLE|AUTOUIC_OPTIONS|AUTOUIC_SEARCH_PATHS|BINARY_DIR|BUILDSYSTEM_TARGETS|BUILD_RPATH|BUILD_RPATH_USE_ORIGIN|BUILD_WITH_INSTALL_NAME_DIR|BUILD_WITH_INSTALL_RPATH|BUNDLE|BUNDLE_EXTENSION|CACHE_VARIABLES|CLEAN_NO_CUSTOM|COMMON_LANGUAGE_RUNTIME|COMPATIBLE_INTERFACE_(?:BOOL|NUMBER_MAX|NUMBER_MIN|STRING)|COMPILE_(?:DEFINITIONS|FEATURES|FLAGS|OPTIONS|PDB_NAME|PDB_OUTPUT_DIRECTORY)|COST|CPACK_DESKTOP_SHORTCUTS|CPACK_NEVER_OVERWRITE|CPACK_PERMANENT|CPACK_STARTUP_SHORTCUTS|CPACK_START_MENU_SHORTCUTS|CPACK_WIX_ACL|CROSSCOMPILING_EMULATOR|CUDA_EXTENSIONS|CUDA_PTX_COMPILATION|CUDA_RESOLVE_DEVICE_SYMBOLS|CUDA_SEPARABLE_COMPILATION|CUDA_STANDARD|CUDA_STANDARD_REQUIRED|CXX_EXTENSIONS|CXX_STANDARD|CXX_STANDARD_REQUIRED|C_EXTENSIONS|C_STANDARD|C_STANDARD_REQUIRED|DEBUG_CONFIGURATIONS|DEFINE_SYMBOL|DEFINITIONS|DEPENDS|DEPLOYMENT_ADDITIONAL_FILES|DEPLOYMENT_REMOTE_DIRECTORY|DISABLED|DISABLED_FEATURES|ECLIPSE_EXTRA_CPROJECT_CONTENTS|ECLIPSE_EXTRA_NATURES|ENABLED_FEATURES|ENABLED_LANGUAGES|ENABLE_EXPORTS|ENVIRONMENT|EXCLUDE_FROM_ALL|EXCLUDE_FROM_DEFAULT_BUILD|EXPORT_NAME|EXPORT_PROPERTIES|EXTERNAL_OBJECT|EchoString|FAIL_REGULAR_EXPRESSION|FIND_LIBRARY_USE_LIB32_PATHS|FIND_LIBRARY_USE_LIB64_PATHS|FIND_LIBRARY_USE_LIBX32_PATHS|FIND_LIBRARY_USE_OPENBSD_VERSIONING|FIXTURES_CLEANUP|FIXTURES_REQUIRED|FIXTURES_SETUP|FOLDER|FRAMEWORK|Fortran_FORMAT|Fortran_MODULE_DIRECTORY|GENERATED|GENERATOR_FILE_NAME|GENERATOR_IS_MULTI_CONFIG|GHS_INTEGRITY_APP|GHS_NO_SOURCE_GROUP_FILE|GLOBAL_DEPENDS_DEBUG_MODE|GLOBAL_DEPENDS_NO_CYCLES|GNUtoMS|HAS_CXX|HEADER_FILE_ONLY|HELPSTRING|IMPLICIT_DEPENDS_INCLUDE_TRANSFORM|IMPORTED|IMPORTED_(?:COMMON_LANGUAGE_RUNTIME|CONFIGURATIONS|GLOBAL|IMPLIB|LIBNAME|LINK_DEPENDENT_LIBRARIES|LINK_INTERFACE_(?:LANGUAGES|LIBRARIES|MULTIPLICITY)|LOCATION|NO_SONAME|OBJECTS|SONAME)|IMPORT_PREFIX|IMPORT_SUFFIX|INCLUDE_DIRECTORIES|INCLUDE_REGULAR_EXPRESSION|INSTALL_NAME_DIR|INSTALL_RPATH|INSTALL_RPATH_USE_LINK_PATH|INTERFACE_(?:AUTOUIC_OPTIONS|COMPILE_DEFINITIONS|COMPILE_FEATURES|COMPILE_OPTIONS|INCLUDE_DIRECTORIES|LINK_DEPENDS|LINK_DIRECTORIES|LINK_LIBRARIES|LINK_OPTIONS|POSITION_INDEPENDENT_CODE|SOURCES|SYSTEM_INCLUDE_DIRECTORIES)|INTERPROCEDURAL_OPTIMIZATION|IN_TRY_COMPILE|IOS_INSTALL_COMBINED|JOB_POOLS|JOB_POOL_COMPILE|JOB_POOL_LINK|KEEP_EXTENSION|LABELS|LANGUAGE|LIBRARY_OUTPUT_DIRECTORY|LINKER_LANGUAGE|LINK_(?:DEPENDS|DEPENDS_NO_SHARED|DIRECTORIES|FLAGS|INTERFACE_LIBRARIES|INTERFACE_MULTIPLICITY|LIBRARIES|OPTIONS|SEARCH_END_STATIC|SEARCH_START_STATIC|WHAT_YOU_USE)|LISTFILE_STACK|LOCATION|MACOSX_BUNDLE|MACOSX_BUNDLE_INFO_PLIST|MACOSX_FRAMEWORK_INFO_PLIST|MACOSX_PACKAGE_LOCATION|MACOSX_RPATH|MACROS|MANUALLY_ADDED_DEPENDENCIES|MEASUREMENT|MODIFIED|NAME|NO_SONAME|NO_SYSTEM_FROM_IMPORTED|OBJECT_DEPENDS|OBJECT_OUTPUTS|OSX_ARCHITECTURES|OUTPUT_NAME|PACKAGES_FOUND|PACKAGES_NOT_FOUND|PARENT_DIRECTORY|PASS_REGULAR_EXPRESSION|PDB_NAME|PDB_OUTPUT_DIRECTORY|POSITION_INDEPENDENT_CODE|POST_INSTALL_SCRIPT|PREDEFINED_TARGETS_FOLDER|PREFIX|PRE_INSTALL_SCRIPT|PRIVATE_HEADER|PROCESSORS|PROCESSOR_AFFINITY|PROJECT_LABEL|PUBLIC_HEADER|REPORT_UNDEFINED_PROPERTIES|REQUIRED_FILES|RESOURCE|RESOURCE_LOCK|RULE_LAUNCH_COMPILE|RULE_LAUNCH_CUSTOM|RULE_LAUNCH_LINK|RULE_MESSAGES|RUNTIME_OUTPUT_DIRECTORY|RUN_SERIAL|SKIP_AUTOGEN|SKIP_AUTOMOC|SKIP_AUTORCC|SKIP_AUTOUIC|SKIP_BUILD_RPATH|SKIP_RETURN_CODE|SOURCES|SOURCE_DIR|SOVERSION|STATIC_LIBRARY_FLAGS|STATIC_LIBRARY_OPTIONS|STRINGS|SUBDIRECTORIES|SUFFIX|SYMBOLIC|TARGET_ARCHIVES_MAY_BE_SHARED_LIBS|TARGET_MESSAGES|TARGET_SUPPORTS_SHARED_LIBS|TESTS|TEST_INCLUDE_FILE|TEST_INCLUDE_FILES|TIMEOUT|TIMEOUT_AFTER_MATCH|TYPE|USE_FOLDERS|VALUE|VARIABLES|VERSION|VISIBILITY_INLINES_HIDDEN|VS_(?:CONFIGURATION_TYPE|COPY_TO_OUT_DIR|DEBUGGER_(?:COMMAND|COMMAND_ARGUMENTS|ENVIRONMENT|WORKING_DIRECTORY)|DEPLOYMENT_CONTENT|DEPLOYMENT_LOCATION|DOTNET_REFERENCES|DOTNET_REFERENCES_COPY_LOCAL|GLOBAL_KEYWORD|GLOBAL_PROJECT_TYPES|GLOBAL_ROOTNAMESPACE|INCLUDE_IN_VSIX|IOT_STARTUP_TASK|KEYWORD|RESOURCE_GENERATOR|SCC_AUXPATH|SCC_LOCALPATH|SCC_PROJECTNAME|SCC_PROVIDER|SDK_REFERENCES|SHADER_(?:DISABLE_OPTIMIZATIONS|ENABLE_DEBUG|ENTRYPOINT|FLAGS|MODEL|OBJECT_FILE_NAME|OUTPUT_HEADER_FILE|TYPE|VARIABLE_NAME)|STARTUP_PROJECT|TOOL_OVERRIDE|USER_PROPS|WINRT_COMPONENT|WINRT_EXTENSIONS|WINRT_REFERENCES|XAML_TYPE)|WILL_FAIL|WIN32_EXECUTABLE|WINDOWS_EXPORT_ALL_SYMBOLS|WORKING_DIRECTORY|WRAP_EXCLUDE|XCODE_(?:EMIT_EFFECTIVE_PLATFORM_NAME|EXPLICIT_FILE_TYPE|FILE_ATTRIBUTES|LAST_KNOWN_FILE_TYPE|PRODUCT_TYPE|SCHEME_(?:ADDRESS_SANITIZER|ADDRESS_SANITIZER_USE_AFTER_RETURN|ARGUMENTS|DISABLE_MAIN_THREAD_CHECKER|DYNAMIC_LIBRARY_LOADS|DYNAMIC_LINKER_API_USAGE|ENVIRONMENT|EXECUTABLE|GUARD_MALLOC|MAIN_THREAD_CHECKER_STOP|MALLOC_GUARD_EDGES|MALLOC_SCRIBBLE|MALLOC_STACK|THREAD_SANITIZER(?:_STOP)?|UNDEFINED_BEHAVIOUR_SANITIZER(?:_STOP)?|ZOMBIE_OBJECTS))|XCTEST)\b/,
      keyword: /\b(?:add_compile_definitions|add_compile_options|add_custom_command|add_custom_target|add_definitions|add_dependencies|add_executable|add_library|add_link_options|add_subdirectory|add_test|aux_source_directory|break|build_command|build_name|cmake_host_system_information|cmake_minimum_required|cmake_parse_arguments|cmake_policy|configure_file|continue|create_test_sourcelist|ctest_build|ctest_configure|ctest_coverage|ctest_empty_binary_directory|ctest_memcheck|ctest_read_custom_files|ctest_run_script|ctest_sleep|ctest_start|ctest_submit|ctest_test|ctest_update|ctest_upload|define_property|else|elseif|enable_language|enable_testing|endforeach|endfunction|endif|endmacro|endwhile|exec_program|execute_process|export|export_library_dependencies|file|find_file|find_library|find_package|find_path|find_program|fltk_wrap_ui|foreach|function|get_cmake_property|get_directory_property|get_filename_component|get_property|get_source_file_property|get_target_property|get_test_property|if|include|include_directories|include_external_msproject|include_guard|include_regular_expression|install|install_files|install_programs|install_targets|link_directories|link_libraries|list|load_cache|load_command|macro|make_directory|mark_as_advanced|math|message|option|output_required_files|project|qt_wrap_cpp|qt_wrap_ui|remove|remove_definitions|return|separate_arguments|set|set_directory_properties|set_property|set_source_files_properties|set_target_properties|set_tests_properties|site_name|source_group|string|subdir_depends|subdirs|target_compile_definitions|target_compile_features|target_compile_options|target_include_directories|target_link_directories|target_link_libraries|target_link_options|target_sources|try_compile|try_run|unset|use_mangled_mesa|utility_source|variable_requires|variable_watch|while|write_file)(?=\s*\()\b/,
      boolean: /\b(?:FALSE|OFF|ON|TRUE)\b/,
      namespace: /\b(?:INTERFACE|PRIVATE|PROPERTIES|PUBLIC|SHARED|STATIC|TARGET_OBJECTS)\b/,
      operator: /\b(?:AND|DEFINED|EQUAL|GREATER|LESS|MATCHES|NOT|OR|STREQUAL|STRGREATER|STRLESS|VERSION_EQUAL|VERSION_GREATER|VERSION_LESS)\b/,
      inserted: {
        pattern: /\b\w+::\w+\b/,
        alias: "class-name"
      },
      number: /\b\d+(?:\.\d+)*\b/,
      function: /\b[a-z_]\w*(?=\s*\()\b/i,
      punctuation: /[()>}]|\$[<{]/
    };
  }
  return vf;
}
var Ef, WA;
function eY() {
  if (WA) return Ef;
  WA = 1, Ef = e, e.displayName = "cobol", e.aliases = [];
  function e(t) {
    t.languages.cobol = {
      comment: {
        pattern: /\*>.*|(^[ \t]*)\*.*/m,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /[xzgn]?(?:"(?:[^\r\n"]|"")*"(?!")|'(?:[^\r\n']|'')*'(?!'))/i,
        greedy: !0
      },
      level: {
        pattern: /(^[ \t]*)\d+\b/m,
        lookbehind: !0,
        greedy: !0,
        alias: "number"
      },
      "class-name": {
        // https://github.com/antlr/grammars-v4/blob/42edd5b687d183b5fa679e858a82297bd27141e7/cobol85/Cobol85.g4#L1015
        pattern: /(\bpic(?:ture)?\s+)(?:(?:[-\w$/,:*+<>]|\.(?!\s|$))(?:\(\d+\))?)+/i,
        lookbehind: !0,
        inside: {
          number: {
            pattern: /(\()\d+/,
            lookbehind: !0
          },
          punctuation: /[()]/
        }
      },
      keyword: {
        pattern: /(^|[^\w-])(?:ABORT|ACCEPT|ACCESS|ADD|ADDRESS|ADVANCING|AFTER|ALIGNED|ALL|ALPHABET|ALPHABETIC|ALPHABETIC-LOWER|ALPHABETIC-UPPER|ALPHANUMERIC|ALPHANUMERIC-EDITED|ALSO|ALTER|ALTERNATE|ANY|ARE|AREA|AREAS|AS|ASCENDING|ASCII|ASSIGN|ASSOCIATED-DATA|ASSOCIATED-DATA-LENGTH|AT|ATTRIBUTE|AUTHOR|AUTO|AUTO-SKIP|BACKGROUND-COLOR|BACKGROUND-COLOUR|BASIS|BEEP|BEFORE|BEGINNING|BELL|BINARY|BIT|BLANK|BLINK|BLOCK|BOTTOM|BOUNDS|BY|BYFUNCTION|BYTITLE|CALL|CANCEL|CAPABLE|CCSVERSION|CD|CF|CH|CHAINING|CHANGED|CHANNEL|CHARACTER|CHARACTERS|CLASS|CLASS-ID|CLOCK-UNITS|CLOSE|CLOSE-DISPOSITION|COBOL|CODE|CODE-SET|COL|COLLATING|COLUMN|COM-REG|COMMA|COMMITMENT|COMMON|COMMUNICATION|COMP|COMP-1|COMP-2|COMP-3|COMP-4|COMP-5|COMPUTATIONAL|COMPUTATIONAL-1|COMPUTATIONAL-2|COMPUTATIONAL-3|COMPUTATIONAL-4|COMPUTATIONAL-5|COMPUTE|CONFIGURATION|CONTAINS|CONTENT|CONTINUE|CONTROL|CONTROL-POINT|CONTROLS|CONVENTION|CONVERTING|COPY|CORR|CORRESPONDING|COUNT|CRUNCH|CURRENCY|CURSOR|DATA|DATA-BASE|DATE|DATE-COMPILED|DATE-WRITTEN|DAY|DAY-OF-WEEK|DBCS|DE|DEBUG-CONTENTS|DEBUG-ITEM|DEBUG-LINE|DEBUG-NAME|DEBUG-SUB-1|DEBUG-SUB-2|DEBUG-SUB-3|DEBUGGING|DECIMAL-POINT|DECLARATIVES|DEFAULT|DEFAULT-DISPLAY|DEFINITION|DELETE|DELIMITED|DELIMITER|DEPENDING|DESCENDING|DESTINATION|DETAIL|DFHRESP|DFHVALUE|DISABLE|DISK|DISPLAY|DISPLAY-1|DIVIDE|DIVISION|DONTCARE|DOUBLE|DOWN|DUPLICATES|DYNAMIC|EBCDIC|EGCS|EGI|ELSE|EMI|EMPTY-CHECK|ENABLE|END|END-ACCEPT|END-ADD|END-CALL|END-COMPUTE|END-DELETE|END-DIVIDE|END-EVALUATE|END-IF|END-MULTIPLY|END-OF-PAGE|END-PERFORM|END-READ|END-RECEIVE|END-RETURN|END-REWRITE|END-SEARCH|END-START|END-STRING|END-SUBTRACT|END-UNSTRING|END-WRITE|ENDING|ENTER|ENTRY|ENTRY-PROCEDURE|ENVIRONMENT|EOL|EOP|EOS|ERASE|ERROR|ESCAPE|ESI|EVALUATE|EVENT|EVERY|EXCEPTION|EXCLUSIVE|EXHIBIT|EXIT|EXPORT|EXTEND|EXTENDED|EXTERNAL|FD|FILE|FILE-CONTROL|FILLER|FINAL|FIRST|FOOTING|FOR|FOREGROUND-COLOR|FOREGROUND-COLOUR|FROM|FULL|FUNCTION|FUNCTION-POINTER|FUNCTIONNAME|GENERATE|GIVING|GLOBAL|GO|GOBACK|GRID|GROUP|HEADING|HIGH-VALUE|HIGH-VALUES|HIGHLIGHT|I-O|I-O-CONTROL|ID|IDENTIFICATION|IF|IMPLICIT|IMPORT|IN|INDEX|INDEXED|INDICATE|INITIAL|INITIALIZE|INITIATE|INPUT|INPUT-OUTPUT|INSPECT|INSTALLATION|INTEGER|INTO|INVALID|INVOKE|IS|JUST|JUSTIFIED|KANJI|KEPT|KEY|KEYBOARD|LABEL|LANGUAGE|LAST|LB|LD|LEADING|LEFT|LEFTLINE|LENGTH|LENGTH-CHECK|LIBACCESS|LIBPARAMETER|LIBRARY|LIMIT|LIMITS|LINAGE|LINAGE-COUNTER|LINE|LINE-COUNTER|LINES|LINKAGE|LIST|LOCAL|LOCAL-STORAGE|LOCK|LONG-DATE|LONG-TIME|LOW-VALUE|LOW-VALUES|LOWER|LOWLIGHT|MEMORY|MERGE|MESSAGE|MMDDYYYY|MODE|MODULES|MORE-LABELS|MOVE|MULTIPLE|MULTIPLY|NAMED|NATIONAL|NATIONAL-EDITED|NATIVE|NEGATIVE|NETWORK|NEXT|NO|NO-ECHO|NULL|NULLS|NUMBER|NUMERIC|NUMERIC-DATE|NUMERIC-EDITED|NUMERIC-TIME|OBJECT-COMPUTER|OCCURS|ODT|OF|OFF|OMITTED|ON|OPEN|OPTIONAL|ORDER|ORDERLY|ORGANIZATION|OTHER|OUTPUT|OVERFLOW|OVERLINE|OWN|PACKED-DECIMAL|PADDING|PAGE|PAGE-COUNTER|PASSWORD|PERFORM|PF|PH|PIC|PICTURE|PLUS|POINTER|PORT|POSITION|POSITIVE|PRINTER|PRINTING|PRIVATE|PROCEDURE|PROCEDURE-POINTER|PROCEDURES|PROCEED|PROCESS|PROGRAM|PROGRAM-ID|PROGRAM-LIBRARY|PROMPT|PURGE|QUEUE|QUOTE|QUOTES|RANDOM|RD|READ|READER|REAL|RECEIVE|RECEIVED|RECORD|RECORDING|RECORDS|RECURSIVE|REDEFINES|REEL|REF|REFERENCE|REFERENCES|RELATIVE|RELEASE|REMAINDER|REMARKS|REMOTE|REMOVAL|REMOVE|RENAMES|REPLACE|REPLACING|REPORT|REPORTING|REPORTS|REQUIRED|RERUN|RESERVE|RESET|RETURN|RETURN-CODE|RETURNING|REVERSE-VIDEO|REVERSED|REWIND|REWRITE|RF|RH|RIGHT|ROUNDED|RUN|SAME|SAVE|SCREEN|SD|SEARCH|SECTION|SECURE|SECURITY|SEGMENT|SEGMENT-LIMIT|SELECT|SEND|SENTENCE|SEPARATE|SEQUENCE|SEQUENTIAL|SET|SHARED|SHAREDBYALL|SHAREDBYRUNUNIT|SHARING|SHIFT-IN|SHIFT-OUT|SHORT-DATE|SIGN|SIZE|SORT|SORT-CONTROL|SORT-CORE-SIZE|SORT-FILE-SIZE|SORT-MERGE|SORT-MESSAGE|SORT-MODE-SIZE|SORT-RETURN|SOURCE|SOURCE-COMPUTER|SPACE|SPACES|SPECIAL-NAMES|STANDARD|STANDARD-1|STANDARD-2|START|STATUS|STOP|STRING|SUB-QUEUE-1|SUB-QUEUE-2|SUB-QUEUE-3|SUBTRACT|SUM|SUPPRESS|SYMBOL|SYMBOLIC|SYNC|SYNCHRONIZED|TABLE|TALLY|TALLYING|TAPE|TASK|TERMINAL|TERMINATE|TEST|TEXT|THEN|THREAD|THREAD-LOCAL|THROUGH|THRU|TIME|TIMER|TIMES|TITLE|TO|TODAYS-DATE|TODAYS-NAME|TOP|TRAILING|TRUNCATED|TYPE|TYPEDEF|UNDERLINE|UNIT|UNSTRING|UNTIL|UP|UPON|USAGE|USE|USING|VALUE|VALUES|VARYING|VIRTUAL|WAIT|WHEN|WHEN-COMPILED|WITH|WORDS|WORKING-STORAGE|WRITE|YEAR|YYYYDDD|YYYYMMDD|ZERO-FILL|ZEROES|ZEROS)(?![\w-])/i,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[^\w-])(?:false|true)(?![\w-])/i,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^\w-])(?:[+-]?(?:(?:\d+(?:[.,]\d+)?|[.,]\d+)(?:e[+-]?\d+)?|zero))(?![\w-])/i,
        lookbehind: !0
      },
      operator: [
        /<>|[<>]=?|[=+*/&]/,
        {
          pattern: /(^|[^\w-])(?:-|and|equal|greater|less|not|or|than)(?![\w-])/i,
          lookbehind: !0
        }
      ],
      punctuation: /[.:,()]/
    };
  }
  return Ef;
}
var Sf, KA;
function tY() {
  if (KA) return Sf;
  KA = 1, Sf = e, e.displayName = "coffeescript", e.aliases = ["coffee"];
  function e(t) {
    (function(n) {
      var r = /#(?!\{).+/, a = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
      };
      n.languages.coffeescript = n.languages.extend("javascript", {
        comment: r,
        string: [
          // Strings are multiline
          {
            pattern: /'(?:\\[\s\S]|[^\\'])*'/,
            greedy: !0
          },
          {
            // Strings are multiline
            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
            greedy: !0,
            inside: {
              interpolation: a
            }
          }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
          pattern: /@(?!\d)\w+/,
          alias: "variable"
        }
      }), n.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
          pattern: /###[\s\S]+?###/,
          alias: "comment"
        },
        // Block regexp can contain comments and interpolation
        "block-regex": {
          pattern: /\/{3}[\s\S]*?\/{3}/,
          alias: "regex",
          inside: {
            comment: r,
            interpolation: a
          }
        }
      }), n.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          inside: {
            delimiter: {
              pattern: /^`|`$/,
              alias: "punctuation"
            },
            script: {
              pattern: /[\s\S]+/,
              alias: "language-javascript",
              inside: n.languages.javascript
            }
          }
        },
        // Block strings
        "multiline-string": [
          {
            pattern: /'''[\s\S]*?'''/,
            greedy: !0,
            alias: "string"
          },
          {
            pattern: /"""[\s\S]*?"""/,
            greedy: !0,
            alias: "string",
            inside: {
              interpolation: a
            }
          }
        ]
      }), n.languages.insertBefore("coffeescript", "keyword", {
        // Object property
        property: /(?!\d)\w+(?=\s*:(?!:))/
      }), delete n.languages.coffeescript["template-string"], n.languages.coffee = n.languages.coffeescript;
    })(t);
  }
  return Sf;
}
var xf, YA;
function nY() {
  if (YA) return xf;
  YA = 1, xf = e, e.displayName = "concurnas", e.aliases = ["conc"];
  function e(t) {
    t.languages.concurnas = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      langext: {
        pattern: /\b\w+\s*\|\|[\s\S]+?\|\|/,
        greedy: !0,
        inside: {
          "class-name": /^\w+/,
          string: {
            pattern: /(^\s*\|\|)[\s\S]+(?=\|\|$)/,
            lookbehind: !0
          },
          punctuation: /\|\|/
        }
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|also|annotation|assert|async|await|bool|boolean|break|byte|case|catch|changed|char|class|closed|constant|continue|def|default|del|double|elif|else|enum|every|extends|false|finally|float|for|from|global|gpudef|gpukernel|if|import|in|init|inject|int|lambda|local|long|loop|match|new|nodefault|null|of|onchange|open|out|override|package|parfor|parforsync|post|pre|private|protected|provide|provider|public|return|shared|short|single|size_t|sizeof|super|sync|this|throw|trait|trans|transient|true|try|typedef|unchecked|using|val|var|void|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b0b[01][01_]*L?\b|\b0x(?:[\da-f_]*\.)?[\da-f_p+-]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfls]?/i,
      punctuation: /[{}[\];(),.:]/,
      operator: /<==|>==|=>|->|<-|<>|&==|&<>|\?:?|\.\?|\+\+|--|[-+*/=<>]=?|[!^~]|\b(?:and|as|band|bor|bxor|comp|is|isnot|mod|or)\b=?/,
      annotation: {
        pattern: /@(?:\w+:)?(?:\w+|\[[^\]]+\])?/,
        alias: "builtin"
      }
    }, t.languages.insertBefore("concurnas", "langext", {
      "regex-literal": {
        pattern: /\br("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          regex: /[\s\S]+/
        }
      },
      "string-literal": {
        pattern: /(?:\B|\bs)("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: t.languages.concurnas
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.conc = t.languages.concurnas;
  }
  return xf;
}
var Tf, XA;
function rY() {
  if (XA) return Tf;
  XA = 1, Tf = e, e.displayName = "coq", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /\(\*(?:[^(*]|\((?!\*)|\*(?!\))|<self>)*\*\)/.source, a = 0; a < 2; a++)
        r = r.replace(/<self>/g, function() {
          return r;
        });
      r = r.replace(/<self>/g, "[]"), n.languages.coq = {
        comment: RegExp(r),
        string: {
          pattern: /"(?:[^"]|"")*"(?!")/,
          greedy: !0
        },
        attribute: [
          {
            pattern: RegExp(
              /#\[(?:[^\[\]("]|"(?:[^"]|"")*"(?!")|\((?!\*)|<comment>)*\]/.source.replace(
                /<comment>/g,
                function() {
                  return r;
                }
              )
            ),
            greedy: !0,
            alias: "attr-name",
            inside: {
              comment: RegExp(r),
              string: {
                pattern: /"(?:[^"]|"")*"(?!")/,
                greedy: !0
              },
              operator: /=/,
              punctuation: /^#\[|\]$|[,()]/
            }
          },
          {
            pattern: /\b(?:Cumulative|Global|Local|Monomorphic|NonCumulative|Polymorphic|Private|Program)\b/,
            alias: "attr-name"
          }
        ],
        keyword: /\b(?:Abort|About|Add|Admit|Admitted|All|Arguments|As|Assumptions|Axiom|Axioms|Back|BackTo|Backtrace|BinOp|BinOpSpec|BinRel|Bind|Blacklist|Canonical|Case|Cd|Check|Class|Classes|Close|CoFixpoint|CoInductive|Coercion|Coercions|Collection|Combined|Compute|Conjecture|Conjectures|Constant|Constants|Constraint|Constructors|Context|Corollary|Create|CstOp|Custom|Cut|Debug|Declare|Defined|Definition|Delimit|Dependencies|Dependent|Derive|Diffs|Drop|Elimination|End|Entry|Equality|Eval|Example|Existential|Existentials|Existing|Export|Extern|Extraction|Fact|Fail|Field|File|Firstorder|Fixpoint|Flags|Focus|From|Funclass|Function|Functional|GC|Generalizable|Goal|Grab|Grammar|Graph|Guarded|Haskell|Heap|Hide|Hint|HintDb|Hints|Hypotheses|Hypothesis|IF|Identity|Immediate|Implicit|Implicits|Import|Include|Induction|Inductive|Infix|Info|Initial|InjTyp|Inline|Inspect|Instance|Instances|Intro|Intros|Inversion|Inversion_clear|JSON|Language|Left|Lemma|Let|Lia|Libraries|Library|Load|LoadPath|Locate|Ltac|Ltac2|ML|Match|Method|Minimality|Module|Modules|Morphism|Next|NoInline|Notation|Number|OCaml|Obligation|Obligations|Opaque|Open|Optimize|Parameter|Parameters|Parametric|Path|Paths|Prenex|Preterm|Primitive|Print|Profile|Projections|Proof|Prop|PropBinOp|PropOp|PropUOp|Property|Proposition|Pwd|Qed|Quit|Rec|Record|Recursive|Redirect|Reduction|Register|Relation|Remark|Remove|Require|Reserved|Reset|Resolve|Restart|Rewrite|Right|Ring|Rings|SProp|Saturate|Save|Scheme|Scope|Scopes|Search|SearchHead|SearchPattern|SearchRewrite|Section|Separate|Set|Setoid|Show|Signatures|Solve|Solver|Sort|Sortclass|Sorted|Spec|Step|Strategies|Strategy|String|Structure|SubClass|Subgraph|SuchThat|Tactic|Term|TestCompile|Theorem|Time|Timeout|To|Transparent|Type|Typeclasses|Types|Typing|UnOp|UnOpSpec|Undelimit|Undo|Unfocus|Unfocused|Unfold|Universe|Universes|Unshelve|Variable|Variables|Variant|Verbose|View|Visibility|Zify|_|apply|as|at|by|cofix|else|end|exists|exists2|fix|for|forall|fun|if|in|let|match|measure|move|removed|return|struct|then|using|wf|where|with)\b/,
        number: /\b(?:0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]+)?(?:p[+-]?\d[\d_]*)?|\d[\d_]*(?:\.[\d_]+)?(?:e[+-]?\d[\d_]*)?)\b/i,
        punct: {
          pattern: /@\{|\{\||\[=|:>/,
          alias: "punctuation"
        },
        operator: /\/\\|\\\/|\.{2,3}|:{1,2}=|\*\*|[-=]>|<(?:->?|[+:=>]|<:)|>(?:=|->)|\|[-|]?|[-!%&*+/<=>?@^~']/,
        punctuation: /\.\(|`\(|@\{|`\{|\{\||\[=|:>|[:.,;(){}\[\]]/
      };
    })(t);
  }
  return Tf;
}
var wf, ZA;
function dc() {
  if (ZA) return wf;
  ZA = 1, wf = e, e.displayName = "ruby", e.aliases = ["rb"];
  function e(t) {
    (function(n) {
      n.languages.ruby = n.languages.extend("clike", {
        comment: {
          pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
          greedy: !0
        },
        "class-name": {
          pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
          lookbehind: !0,
          inside: {
            punctuation: /[.\\]/
          }
        },
        keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
        operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
        punctuation: /[(){}[\].,;]/
      }), n.languages.insertBefore("ruby", "operator", {
        "double-colon": {
          pattern: /::/,
          alias: "punctuation"
        }
      });
      var r = {
        pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
        lookbehind: !0,
        inside: {
          content: {
            pattern: /^(#\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: n.languages.ruby
          },
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: "punctuation"
          }
        }
      };
      delete n.languages.ruby.function;
      var a = "(?:" + [
        /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
        /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
        /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
        /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
        /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
      ].join("|") + ")", i = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
      n.languages.insertBefore("ruby", "keyword", {
        "regex-literal": [
          {
            pattern: RegExp(
              /%r/.source + a + /[egimnosux]{0,6}/.source
            ),
            greedy: !0,
            inside: {
              interpolation: r,
              regex: /[\s\S]+/
            }
          },
          {
            pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              interpolation: r,
              regex: /[\s\S]+/
            }
          }
        ],
        variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
        symbol: [
          {
            pattern: RegExp(/(^|[^:]):/.source + i),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: RegExp(
              /([\r\n{(,][ \t]*)/.source + i + /(?=:(?!:))/.source
            ),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "method-definition": {
          pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
          lookbehind: !0,
          inside: {
            function: /\b\w+$/,
            keyword: /^self\b/,
            "class-name": /^\w+/,
            punctuation: /\./
          }
        }
      }), n.languages.insertBefore("ruby", "string", {
        "string-literal": [
          {
            pattern: RegExp(/%[qQiIwWs]?/.source + a),
            greedy: !0,
            inside: {
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
            greedy: !0,
            inside: {
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?/
                }
              },
              interpolation: r,
              string: /[\s\S]+/
            }
          },
          {
            pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                inside: {
                  symbol: /\b\w+/,
                  punctuation: /^<<[-~]?'|'$/
                }
              },
              string: /[\s\S]+/
            }
          }
        ],
        "command-literal": [
          {
            pattern: RegExp(/%x/.source + a),
            greedy: !0,
            inside: {
              interpolation: r,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          },
          {
            pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
            greedy: !0,
            inside: {
              interpolation: r,
              command: {
                pattern: /[\s\S]+/,
                alias: "string"
              }
            }
          }
        ]
      }), delete n.languages.ruby.string, n.languages.insertBefore("ruby", "number", {
        builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
        constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
      }), n.languages.rb = n.languages.ruby;
    })(t);
  }
  return wf;
}
var Af, JA;
function aY() {
  if (JA) return Af;
  JA = 1;
  var e = dc();
  Af = t, t.displayName = "crystal", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.crystal = r.languages.extend("ruby", {
        keyword: [
          /\b(?:__DIR__|__END_LINE__|__FILE__|__LINE__|abstract|alias|annotation|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|ifdef|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|ptr|require|rescue|return|select|self|sizeof|struct|super|then|type|typeof|undef|uninitialized|union|unless|until|when|while|with|yield)\b/,
          {
            pattern: /(\.\s*)(?:is_a|responds_to)\?/,
            lookbehind: !0
          }
        ],
        number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/,
        operator: [/->/, r.languages.ruby.operator],
        punctuation: /[(){}[\].,;\\]/
      }), r.languages.insertBefore("crystal", "string-literal", {
        attribute: {
          pattern: /@\[.*?\]/,
          inside: {
            delimiter: {
              pattern: /^@\[|\]$/,
              alias: "punctuation"
            },
            attribute: {
              pattern: /^(\s*)\w+/,
              lookbehind: !0,
              alias: "class-name"
            },
            args: {
              pattern: /\S(?:[\s\S]*\S)?/,
              inside: r.languages.crystal
            }
          }
        },
        expansion: {
          pattern: /\{(?:\{.*?\}|%.*?%)\}/,
          inside: {
            content: {
              pattern: /^(\{.)[\s\S]+(?=.\}$)/,
              lookbehind: !0,
              inside: r.languages.crystal
            },
            delimiter: {
              pattern: /^\{[\{%]|[\}%]\}$/,
              alias: "operator"
            }
          }
        },
        char: {
          pattern: /'(?:[^\\\r\n]{1,2}|\\(?:.|u(?:[A-Fa-f0-9]{1,4}|\{[A-Fa-f0-9]{1,6}\})))'/,
          greedy: !0
        }
      });
    }(n);
  }
  return Af;
}
var If, QA;
function iY() {
  if (QA) return If;
  QA = 1;
  var e = cc();
  If = t, t.displayName = "cshtml", t.aliases = ["razor"];
  function t(n) {
    n.register(e), function(r) {
      var a = /\/(?![/*])|\/\/.*[\r\n]|\/\*[^*]*(?:\*(?!\/)[^*]*)*\*\//.source, i = /@(?!")|"(?:[^\r\n\\"]|\\.)*"|@"(?:[^\\"]|""|\\[\s\S])*"(?!")/.source + "|" + /'(?:(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'|(?=[^\\](?!')))/.source;
      function s(w, x) {
        for (var I = 0; I < x; I++)
          w = w.replace(/<self>/g, function() {
            return "(?:" + w + ")";
          });
        return w.replace(/<self>/g, "[^\\s\\S]").replace(/<str>/g, "(?:" + i + ")").replace(/<comment>/g, "(?:" + a + ")");
      }
      var u = s(/\((?:[^()'"@/]|<str>|<comment>|<self>)*\)/.source, 2), c = s(/\[(?:[^\[\]'"@/]|<str>|<comment>|<self>)*\]/.source, 2), d = s(/\{(?:[^{}'"@/]|<str>|<comment>|<self>)*\}/.source, 2), p = s(/<(?:[^<>'"@/]|<str>|<comment>|<self>)*>/.source, 2), f = /(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?/.source, m = /(?!\d)[^\s>\/=$<%]+/.source + f + /\s*\/?>/.source, h = /\B@?/.source + "(?:" + /<([a-zA-Z][\w:]*)/.source + f + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
      // eslint-disable-next-line regexp/strict
      /<\/?(?!\1\b)/.source + m + "|" + // nested start tag
      s(
        // eslint-disable-next-line regexp/strict
        /<\1/.source + f + /\s*>/.source + "(?:" + (/[^<]/.source + "|" + // all tags that are not the start tag
        // eslint-disable-next-line regexp/strict
        /<\/?(?!\1\b)/.source + m + "|<self>") + ")*" + // eslint-disable-next-line regexp/strict
        /<\/\1\s*>/.source,
        2
      )) + ")*" + // eslint-disable-next-line regexp/strict
      /<\/\1\s*>/.source + "|" + /</.source + m + ")";
      r.languages.cshtml = r.languages.extend("markup", {});
      var E = r.languages.insertBefore(
        "csharp",
        "string",
        {
          html: {
            pattern: RegExp(h),
            greedy: !0,
            inside: r.languages.cshtml
          }
        },
        {
          csharp: r.languages.extend("csharp", {})
        }
      ), y = {
        pattern: /\S[\s\S]*/,
        alias: "language-csharp",
        inside: E
      };
      r.languages.insertBefore("cshtml", "prolog", {
        "razor-comment": {
          pattern: /@\*[\s\S]*?\*@/,
          greedy: !0,
          alias: "comment"
        },
        block: {
          pattern: RegExp(
            /(^|[^@])@/.source + "(?:" + [
              // @{ ... }
              d,
              // @code{ ... }
              /(?:code|functions)\s*/.source + d,
              // @for (...) { ... }
              /(?:for|foreach|lock|switch|using|while)\s*/.source + u + /\s*/.source + d,
              // @do { ... } while (...);
              /do\s*/.source + d + /\s*while\s*/.source + u + /(?:\s*;)?/.source,
              // @try { ... } catch (...) { ... } finally { ... }
              /try\s*/.source + d + /\s*catch\s*/.source + u + /\s*/.source + d + /\s*finally\s*/.source + d,
              // @if (...) {...} else if (...) {...} else {...}
              /if\s*/.source + u + /\s*/.source + d + "(?:" + /\s*else/.source + "(?:" + /\s+if\s*/.source + u + ")?" + /\s*/.source + d + ")*"
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w*/,
            csharp: y
          }
        },
        directive: {
          pattern: /^([ \t]*)@(?:addTagHelper|attribute|implements|inherits|inject|layout|model|namespace|page|preservewhitespace|removeTagHelper|section|tagHelperPrefix|using)(?=\s).*/m,
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^@\w+/,
            csharp: y
          }
        },
        value: {
          pattern: RegExp(
            /(^|[^@])@/.source + /(?:await\b\s*)?/.source + "(?:" + /\w+\b/.source + "|" + u + ")(?:" + /[?!]?\.\w+\b/.source + "|" + u + "|" + c + "|" + p + u + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "variable",
          inside: {
            keyword: /^@/,
            csharp: y
          }
        },
        "delegate-operator": {
          pattern: /(^|[^@])@(?=<)/,
          lookbehind: !0,
          alias: "operator"
        }
      }), r.languages.razor = r.languages.cshtml;
    }(n);
  }
  return If;
}
var Rf, eI;
function oY() {
  if (eI) return Rf;
  eI = 1, Rf = e, e.displayName = "csp", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(a) {
        return RegExp(
          /([ \t])/.source + "(?:" + a + ")" + /(?=[\s;]|$)/.source,
          "i"
        );
      }
      n.languages.csp = {
        directive: {
          pattern: /(^|[\s;])(?:base-uri|block-all-mixed-content|(?:child|connect|default|font|frame|img|manifest|media|object|prefetch|script|style|worker)-src|disown-opener|form-action|frame-(?:ancestors|options)|input-protection(?:-(?:clip|selectors))?|navigate-to|plugin-types|policy-uri|referrer|reflected-xss|report-(?:to|uri)|require-sri-for|sandbox|(?:script|style)-src-(?:attr|elem)|upgrade-insecure-requests)(?=[\s;]|$)/i,
          lookbehind: !0,
          alias: "property"
        },
        scheme: {
          pattern: r(/[a-z][a-z0-9.+-]*:/.source),
          lookbehind: !0
        },
        none: {
          pattern: r(/'none'/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        nonce: {
          pattern: r(/'nonce-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        hash: {
          pattern: r(/'sha(?:256|384|512)-[-+/\w=]+'/.source),
          lookbehind: !0,
          alias: "number"
        },
        host: {
          pattern: r(
            /[a-z][a-z0-9.+-]*:\/\/[^\s;,']*/.source + "|" + /\*[^\s;,']*/.source + "|" + /[a-z0-9-]+(?:\.[a-z0-9-]+)+(?::[\d*]+)?(?:\/[^\s;,']*)?/.source
          ),
          lookbehind: !0,
          alias: "url",
          inside: {
            important: /\*/
          }
        },
        keyword: [
          {
            pattern: r(/'unsafe-[a-z-]+'/.source),
            lookbehind: !0,
            alias: "unsafe"
          },
          {
            pattern: r(/'[a-z-]+'/.source),
            lookbehind: !0,
            alias: "safe"
          }
        ],
        punctuation: /;/
      };
    })(t);
  }
  return Rf;
}
var _f, tI;
function sY() {
  if (tI) return _f;
  tI = 1, _f = e, e.displayName = "cssExtras", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, a;
      n.languages.css.selector = {
        pattern: n.languages.css.selector.pattern,
        lookbehind: !0,
        inside: a = {
          "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
          "pseudo-class": /:[-\w]+/,
          class: /\.[-\w]+/,
          id: /#[-\w]+/,
          attribute: {
            pattern: RegExp(`\\[(?:[^[\\]"']|` + r.source + ")*\\]"),
            greedy: !0,
            inside: {
              punctuation: /^\[|\]$/,
              "case-sensitivity": {
                pattern: /(\s)[si]$/i,
                lookbehind: !0,
                alias: "keyword"
              },
              namespace: {
                pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                lookbehind: !0,
                inside: {
                  punctuation: /\|$/
                }
              },
              "attr-name": {
                pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                lookbehind: !0
              },
              "attr-value": [
                r,
                {
                  pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                  lookbehind: !0
                }
              ],
              operator: /[|~*^$]?=/
            }
          },
          "n-th": [
            {
              pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
              lookbehind: !0,
              inside: {
                number: /[\dn]+/,
                operator: /[+-]/
              }
            },
            {
              pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
              lookbehind: !0
            }
          ],
          combinator: />|\+|~|\|\|/,
          // the `tag` token has been existed and removed.
          // because we can't find a perfect tokenize to match it.
          // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
          punctuation: /[(),]/
        }
      }, n.languages.css.atrule.inside["selector-function-argument"].inside = a, n.languages.insertBefore("css", "property", {
        variable: {
          pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
          lookbehind: !0
        }
      });
      var i = {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: !0
      }, s = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      };
      n.languages.insertBefore("css", "function", {
        operator: {
          pattern: /(\s)[+\-*\/](?=\s)/,
          lookbehind: !0
        },
        // CAREFUL!
        // Previewers and Inline color use hexcode and color.
        hexcode: {
          pattern: /\B#[\da-f]{3,8}\b/i,
          alias: "color"
        },
        color: [
          {
            pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
            lookbehind: !0
          },
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: i,
              number: s,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        // it's important that there is no boundary assertion after the hex digits
        entity: /\\[\da-f]{1,8}/i,
        unit: i,
        number: s
      });
    })(t);
  }
  return _f;
}
var Cf, nI;
function lY() {
  if (nI) return Cf;
  nI = 1, Cf = e, e.displayName = "csv", e.aliases = [];
  function e(t) {
    t.languages.csv = {
      value: /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
      punctuation: /,/
    };
  }
  return Cf;
}
var kf, rI;
function uY() {
  if (rI) return kf;
  rI = 1, kf = e, e.displayName = "cypher", e.aliases = [];
  function e(t) {
    t.languages.cypher = {
      // https://neo4j.com/docs/cypher-manual/current/syntax/comments/
      comment: /\/\/.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(:\s*)(?:\w+|`(?:[^`\\\r\n])*`)(?=\s*[{):])/,
        lookbehind: !0,
        greedy: !0
      },
      relationship: {
        pattern: /(-\[\s*(?:\w+\s*|`(?:[^`\\\r\n])*`\s*)?:\s*|\|\s*:\s*)(?:\w+|`(?:[^`\\\r\n])*`)/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      identifier: {
        pattern: /`(?:[^`\\\r\n])*`/,
        greedy: !0
      },
      variable: /\$\w+/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/reserved/
      keyword: /\b(?:ADD|ALL|AND|AS|ASC|ASCENDING|ASSERT|BY|CALL|CASE|COMMIT|CONSTRAINT|CONTAINS|CREATE|CSV|DELETE|DESC|DESCENDING|DETACH|DISTINCT|DO|DROP|ELSE|END|ENDS|EXISTS|FOR|FOREACH|IN|INDEX|IS|JOIN|KEY|LIMIT|LOAD|MANDATORY|MATCH|MERGE|NODE|NOT|OF|ON|OPTIONAL|OR|ORDER(?=\s+BY)|PERIODIC|REMOVE|REQUIRE|RETURN|SCALAR|SCAN|SET|SKIP|START|STARTS|THEN|UNION|UNIQUE|UNWIND|USING|WHEN|WHERE|WITH|XOR|YIELD)\b/i,
      function: /\b\w+\b(?=\s*\()/,
      boolean: /\b(?:false|null|true)\b/i,
      number: /\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)\b/,
      // https://neo4j.com/docs/cypher-manual/current/syntax/operators/
      operator: /:|<--?|--?>?|<>|=~?|[<>]=?|[+*/%^|]|\.\.\.?/,
      punctuation: /[()[\]{},;.]/
    };
  }
  return kf;
}
var Nf, aI;
function cY() {
  if (aI) return Nf;
  aI = 1, Nf = e, e.displayName = "d", e.aliases = [];
  function e(t) {
    t.languages.d = t.languages.extend("clike", {
      comment: [
        {
          // Shebang
          pattern: /^\s*#!.+/,
          greedy: !0
        },
        {
          pattern: RegExp(
            /(^|[^\\])/.source + "(?:" + [
              // /+ comment +/
              // Allow one level of nesting
              /\/\+(?:\/\+(?:[^+]|\+(?!\/))*\+\/|(?!\/\+)[\s\S])*?\+\//.source,
              // // comment
              /\/\/.*/.source,
              // /* comment */
              /\/\*[\s\S]*?\*\//.source
            ].join("|") + ")"
          ),
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: [
        {
          pattern: RegExp(
            [
              // r"", x""
              /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/.source,
              // q"[]", q"()", q"<>", q"{}"
              /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/.source,
              // q"IDENT
              // ...
              // IDENT"
              /\bq"((?!\d)\w+)$[\s\S]*?^\1"/.source,
              // q"//", q"||", etc.
              // eslint-disable-next-line regexp/strict
              /\bq"(.)[\s\S]*?\2"/.source,
              // eslint-disable-next-line regexp/strict
              /(["`])(?:\\[\s\S]|(?!\3)[^\\])*\3[cwd]?/.source
            ].join("|"),
            "m"
          ),
          greedy: !0
        },
        {
          pattern: /\bq\{(?:\{[^{}]*\}|[^{}])*\}/,
          greedy: !0,
          alias: "token-string"
        }
      ],
      // In order: $, keywords and special tokens, globally defined symbols
      keyword: /\$|\b(?:__(?:(?:DATE|EOF|FILE|FUNCTION|LINE|MODULE|PRETTY_FUNCTION|TIMESTAMP|TIME|VENDOR|VERSION)__|gshared|parameters|traits|vector)|abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|dstring|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|ptrdiff_t|public|pure|real|ref|return|scope|shared|short|size_t|static|string|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|wstring)\b/,
      number: [
        // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
        // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
        /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]{0,4}/i,
        {
          pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]{0,4}/i,
          lookbehind: !0
        }
      ],
      operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
    }), t.languages.insertBefore("d", "string", {
      // Characters
      // 'a', '\\', '\n', '\xFF', '\377', '\uFFFF', '\U0010FFFF', '\quot'
      char: /'(?:\\(?:\W|\w+)|[^\\])'/
    }), t.languages.insertBefore("d", "keyword", {
      property: /\B@\w*/
    }), t.languages.insertBefore("d", "function", {
      register: {
        // Iasm registers
        pattern: /\b(?:[ABCD][LHX]|E?(?:BP|DI|SI|SP)|[BS]PL|[ECSDGF]S|CR[0234]|[DS]IL|DR[012367]|E[ABCD]X|X?MM[0-7]|R(?:1[0-5]|[89])[BWD]?|R[ABCD]X|R[BS]P|R[DS]I|TR[3-7]|XMM(?:1[0-5]|[89])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
        alias: "variable"
      }
    });
  }
  return Nf;
}
var Of, iI;
function dY() {
  if (iI) return Of;
  iI = 1, Of = e, e.displayName = "dart", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        /\b(?:async|sync|yield)\*/,
        /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|covariant|default|deferred|do|dynamic|else|enum|export|extends|extension|external|factory|final|finally|for|get|hide|if|implements|import|in|interface|library|mixin|new|null|on|operator|part|rethrow|return|set|show|static|super|switch|sync|this|throw|try|typedef|var|void|while|with|yield)\b/
      ], a = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, i = {
        pattern: RegExp(a + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          }
        }
      };
      n.languages.dart = n.languages.extend("clike", {
        "class-name": [
          i,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              a + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: i.inside
          }
        ],
        keyword: r,
        operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
      }), n.languages.insertBefore("dart", "string", {
        "string-literal": {
          pattern: /r?(?:("""|''')[\s\S]*?\1|(["'])(?:\\.|(?!\2)[^\\\r\n])*\2(?!\2))/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
              lookbehind: !0,
              inside: {
                punctuation: /^\$\{?|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  inside: n.languages.dart
                }
              }
            },
            string: /[\s\S]+/
          }
        },
        string: void 0
      }), n.languages.insertBefore("dart", "class-name", {
        metadata: {
          pattern: /@\w+/,
          alias: "function"
        }
      }), n.languages.insertBefore("dart", "class-name", {
        generics: {
          pattern: /<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<(?:[\w\s,.&?]|<[\w\s,.&?]*>)*>)*>)*>/,
          inside: {
            "class-name": i,
            keyword: r,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        }
      });
    })(t);
  }
  return Of;
}
var Lf, oI;
function pY() {
  if (oI) return Lf;
  oI = 1, Lf = e, e.displayName = "dataweave", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.dataweave = {
        url: /\b[A-Za-z]+:\/\/[\w/:.?=&-]+|\burn:[\w:.?=&-]+/,
        property: {
          pattern: /(?:\b\w+#)?(?:"(?:\\.|[^\\"\r\n])*"|\b\w+)(?=\s*[:@])/,
          greedy: !0
        },
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        "mime-type": /\b(?:application|audio|image|multipart|text|video)\/[\w+-]+/,
        date: {
          pattern: /\|[\w:+-]+\|/,
          greedy: !0
        },
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        regex: {
          pattern: /\/(?:[^\\\/\r\n]|\\[^\r\n])+\//,
          greedy: !0
        },
        keyword: /\b(?:and|as|at|case|do|else|fun|if|input|is|match|not|ns|null|or|output|type|unless|update|using|var)\b/,
        function: /\b[A-Z_]\w*(?=\s*\()/i,
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\];(),.:@]/,
        operator: /<<|>>|->|[<>~=]=?|!=|--?-?|\+\+?|!|\?/,
        boolean: /\b(?:false|true)\b/
      };
    })(t);
  }
  return Lf;
}
var Df, sI;
function fY() {
  if (sI) return Df;
  sI = 1, Df = e, e.displayName = "dax", e.aliases = [];
  function e(t) {
    t.languages.dax = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/).*)/,
        lookbehind: !0
      },
      "data-field": {
        pattern: /'(?:[^']|'')*'(?!')(?:\[[ \w\xA0-\uFFFF]+\])?|\w+\[[ \w\xA0-\uFFFF]+\]/,
        alias: "symbol"
      },
      measure: {
        pattern: /\[[ \w\xA0-\uFFFF]+\]/,
        alias: "constant"
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      function: /\b(?:ABS|ACOS|ACOSH|ACOT|ACOTH|ADDCOLUMNS|ADDMISSINGITEMS|ALL|ALLCROSSFILTERED|ALLEXCEPT|ALLNOBLANKROW|ALLSELECTED|AND|APPROXIMATEDISTINCTCOUNT|ASIN|ASINH|ATAN|ATANH|AVERAGE|AVERAGEA|AVERAGEX|BETA\.DIST|BETA\.INV|BLANK|CALCULATE|CALCULATETABLE|CALENDAR|CALENDARAUTO|CEILING|CHISQ\.DIST|CHISQ\.DIST\.RT|CHISQ\.INV|CHISQ\.INV\.RT|CLOSINGBALANCEMONTH|CLOSINGBALANCEQUARTER|CLOSINGBALANCEYEAR|COALESCE|COMBIN|COMBINA|COMBINEVALUES|CONCATENATE|CONCATENATEX|CONFIDENCE\.NORM|CONFIDENCE\.T|CONTAINS|CONTAINSROW|CONTAINSSTRING|CONTAINSSTRINGEXACT|CONVERT|COS|COSH|COT|COTH|COUNT|COUNTA|COUNTAX|COUNTBLANK|COUNTROWS|COUNTX|CROSSFILTER|CROSSJOIN|CURRENCY|CURRENTGROUP|CUSTOMDATA|DATATABLE|DATE|DATEADD|DATEDIFF|DATESBETWEEN|DATESINPERIOD|DATESMTD|DATESQTD|DATESYTD|DATEVALUE|DAY|DEGREES|DETAILROWS|DISTINCT|DISTINCTCOUNT|DISTINCTCOUNTNOBLANK|DIVIDE|EARLIER|EARLIEST|EDATE|ENDOFMONTH|ENDOFQUARTER|ENDOFYEAR|EOMONTH|ERROR|EVEN|EXACT|EXCEPT|EXP|EXPON\.DIST|FACT|FALSE|FILTER|FILTERS|FIND|FIRSTDATE|FIRSTNONBLANK|FIRSTNONBLANKVALUE|FIXED|FLOOR|FORMAT|GCD|GENERATE|GENERATEALL|GENERATESERIES|GEOMEAN|GEOMEANX|GROUPBY|HASONEFILTER|HASONEVALUE|HOUR|IF|IF\.EAGER|IFERROR|IGNORE|INT|INTERSECT|ISBLANK|ISCROSSFILTERED|ISEMPTY|ISERROR|ISEVEN|ISFILTERED|ISINSCOPE|ISLOGICAL|ISNONTEXT|ISNUMBER|ISO\.CEILING|ISODD|ISONORAFTER|ISSELECTEDMEASURE|ISSUBTOTAL|ISTEXT|KEEPFILTERS|KEYWORDMATCH|LASTDATE|LASTNONBLANK|LASTNONBLANKVALUE|LCM|LEFT|LEN|LN|LOG|LOG10|LOOKUPVALUE|LOWER|MAX|MAXA|MAXX|MEDIAN|MEDIANX|MID|MIN|MINA|MINUTE|MINX|MOD|MONTH|MROUND|NATURALINNERJOIN|NATURALLEFTOUTERJOIN|NEXTDAY|NEXTMONTH|NEXTQUARTER|NEXTYEAR|NONVISUAL|NORM\.DIST|NORM\.INV|NORM\.S\.DIST|NORM\.S\.INV|NOT|NOW|ODD|OPENINGBALANCEMONTH|OPENINGBALANCEQUARTER|OPENINGBALANCEYEAR|OR|PARALLELPERIOD|PATH|PATHCONTAINS|PATHITEM|PATHITEMREVERSE|PATHLENGTH|PERCENTILE\.EXC|PERCENTILE\.INC|PERCENTILEX\.EXC|PERCENTILEX\.INC|PERMUT|PI|POISSON\.DIST|POWER|PREVIOUSDAY|PREVIOUSMONTH|PREVIOUSQUARTER|PREVIOUSYEAR|PRODUCT|PRODUCTX|QUARTER|QUOTIENT|RADIANS|RAND|RANDBETWEEN|RANK\.EQ|RANKX|RELATED|RELATEDTABLE|REMOVEFILTERS|REPLACE|REPT|RIGHT|ROLLUP|ROLLUPADDISSUBTOTAL|ROLLUPGROUP|ROLLUPISSUBTOTAL|ROUND|ROUNDDOWN|ROUNDUP|ROW|SAMEPERIODLASTYEAR|SAMPLE|SEARCH|SECOND|SELECTCOLUMNS|SELECTEDMEASURE|SELECTEDMEASUREFORMATSTRING|SELECTEDMEASURENAME|SELECTEDVALUE|SIGN|SIN|SINH|SQRT|SQRTPI|STARTOFMONTH|STARTOFQUARTER|STARTOFYEAR|STDEV\.P|STDEV\.S|STDEVX\.P|STDEVX\.S|SUBSTITUTE|SUBSTITUTEWITHINDEX|SUM|SUMMARIZE|SUMMARIZECOLUMNS|SUMX|SWITCH|T\.DIST|T\.DIST\.2T|T\.DIST\.RT|T\.INV|T\.INV\.2T|TAN|TANH|TIME|TIMEVALUE|TODAY|TOPN|TOPNPERLEVEL|TOPNSKIP|TOTALMTD|TOTALQTD|TOTALYTD|TREATAS|TRIM|TRUE|TRUNC|UNICHAR|UNICODE|UNION|UPPER|USERELATIONSHIP|USERNAME|USEROBJECTID|USERPRINCIPALNAME|UTCNOW|UTCTODAY|VALUE|VALUES|VAR\.P|VAR\.S|VARX\.P|VARX\.S|WEEKDAY|WEEKNUM|XIRR|XNPV|YEAR|YEARFRAC)(?=\s*\()/i,
      keyword: /\b(?:DEFINE|EVALUATE|MEASURE|ORDER\s+BY|RETURN|VAR|START\s+AT|ASC|DESC)\b/i,
      boolean: {
        pattern: /\b(?:FALSE|NULL|TRUE)\b/i,
        alias: "constant"
      },
      number: /\b\d+(?:\.\d*)?|\B\.\d+\b/,
      operator: /:=|[-+*\/=^]|&&?|\|\||<(?:=>?|<|>)?|>[>=]?|\b(?:IN|NOT)\b/i,
      punctuation: /[;\[\](){}`,.]/
    };
  }
  return Df;
}
var Mf, lI;
function gY() {
  if (lI) return Mf;
  lI = 1, Mf = e, e.displayName = "dhall", e.aliases = [];
  function e(t) {
    t.languages.dhall = {
      // Multi-line comments can be nested. E.g. {- foo {- bar -} -}
      // The multi-line pattern is essentially this:
      //   \{-(?:[^-{]|-(?!\})|\{(?!-)|<SELF>)*-\}
      comment: /--.*|\{-(?:[^-{]|-(?!\})|\{(?!-)|\{-(?:[^-{]|-(?!\})|\{(?!-))*-\})*-\}/,
      string: {
        pattern: /"(?:[^"\\]|\\.)*"|''(?:[^']|'(?!')|'''|''\$\{)*''(?!'|\$)/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$\{[^{}]*\}/,
            inside: {
              expression: {
                pattern: /(^\$\{)[\s\S]+(?=\}$)/,
                lookbehind: !0,
                alias: "language-dhall",
                inside: null
                // see blow
              },
              punctuation: /\$\{|\}/
            }
          }
        }
      },
      label: {
        pattern: /`[^`]*`/,
        greedy: !0
      },
      url: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L596
        pattern: /\bhttps?:\/\/[\w.:%!$&'*+;=@~-]+(?:\/[\w.:%!$&'*+;=@~-]*)*(?:\?[/?\w.:%!$&'*+;=@~-]*)?/,
        greedy: !0
      },
      env: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L661
        pattern: /\benv:(?:(?!\d)\w+|"(?:[^"\\=]|\\.)*")/,
        greedy: !0,
        inside: {
          function: /^env/,
          operator: /^:/,
          variable: /[\s\S]+/
        }
      },
      hash: {
        // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L725
        pattern: /\bsha256:[\da-fA-F]{64}\b/,
        inside: {
          function: /sha256/,
          operator: /:/,
          number: /[\da-fA-F]{64}/
        }
      },
      // https://github.com/dhall-lang/dhall-lang/blob/5fde8ef1bead6fb4e999d3c1ffe7044cd019d63a/standard/dhall.abnf#L359
      keyword: /\b(?:as|assert|else|forall|if|in|let|merge|missing|then|toMap|using|with)\b|\u2200/,
      builtin: /\b(?:None|Some)\b/,
      boolean: /\b(?:False|True)\b/,
      number: /\bNaN\b|-?\bInfinity\b|[+-]?\b(?:0x[\da-fA-F]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/,
      operator: /\/\\|\/\/\\\\|&&|\|\||===|[!=]=|\/\/|->|\+\+|::|[+*#@=:?<>|\\\u2227\u2a53\u2261\u2afd\u03bb\u2192]/,
      punctuation: /\.\.|[{}\[\](),./]/,
      // we'll just assume that every capital word left is a type name
      "class-name": /\b[A-Z]\w*\b/
    }, t.languages.dhall.string.inside.interpolation.inside.expression.inside = t.languages.dhall;
  }
  return Mf;
}
var Ff, uI;
function mY() {
  if (uI) return Ff;
  uI = 1, Ff = e, e.displayName = "diff", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.diff = {
        coord: [
          // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
          /^(?:\*{3}|-{3}|\+{3}).*$/m,
          // Match "@@ ... @@" coord lines in unified diff.
          /^@@.*@@$/m,
          // Match coord lines in normal diff (starts with a number).
          /^\d.*$/m
        ]
        // deleted, inserted, unchanged, diff
      };
      var r = {
        "deleted-sign": "-",
        "deleted-arrow": "<",
        "inserted-sign": "+",
        "inserted-arrow": ">",
        unchanged: " ",
        diff: "!"
      };
      Object.keys(r).forEach(function(a) {
        var i = r[a], s = [];
        /^\w+$/.test(a) || s.push(/\w+/.exec(a)[0]), a === "diff" && s.push("bold"), n.languages.diff[a] = {
          pattern: RegExp(
            "^(?:[" + i + `].*(?:\r
?|
|(?![\\s\\S])))+`,
            "m"
          ),
          alias: s,
          inside: {
            line: {
              pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
              lookbehind: !0
            },
            prefix: {
              pattern: /[\s\S]/,
              alias: /\w+/.exec(a)[0]
            }
          }
        };
      }), Object.defineProperty(n.languages.diff, "PREFIXES", {
        value: r
      });
    })(t);
  }
  return Ff;
}
var Pf, cI;
function Mn() {
  if (cI) return Pf;
  cI = 1, Pf = e, e.displayName = "markupTemplating", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(a, i) {
        return "___" + a.toUpperCase() + i + "___";
      }
      Object.defineProperties(n.languages["markup-templating"] = {}, {
        buildPlaceholders: {
          /**
           * Tokenize all inline templating expressions matching `placeholderPattern`.
           *
           * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
           * `true` will be replaced.
           *
           * @param {object} env The environment of the `before-tokenize` hook.
           * @param {string} language The language id.
           * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
           * @param {(match: string) => boolean} [replaceFilter]
           */
          value: function(a, i, s, u) {
            if (a.language === i) {
              var c = a.tokenStack = [];
              a.code = a.code.replace(s, function(d) {
                if (typeof u == "function" && !u(d))
                  return d;
                for (var p = c.length, f; a.code.indexOf(f = r(i, p)) !== -1; )
                  ++p;
                return c[p] = d, f;
              }), a.grammar = n.languages.markup;
            }
          }
        },
        tokenizePlaceholders: {
          /**
           * Replace placeholders with proper tokens after tokenizing.
           *
           * @param {object} env The environment of the `after-tokenize` hook.
           * @param {string} language The language id.
           */
          value: function(a, i) {
            if (a.language !== i || !a.tokenStack)
              return;
            a.grammar = n.languages[i];
            var s = 0, u = Object.keys(a.tokenStack);
            function c(d) {
              for (var p = 0; p < d.length && !(s >= u.length); p++) {
                var f = d[p];
                if (typeof f == "string" || f.content && typeof f.content == "string") {
                  var m = u[s], h = a.tokenStack[m], E = typeof f == "string" ? f : f.content, y = r(i, m), w = E.indexOf(y);
                  if (w > -1) {
                    ++s;
                    var x = E.substring(0, w), I = new n.Token(
                      i,
                      n.tokenize(h, a.grammar),
                      "language-" + i,
                      h
                    ), S = E.substring(w + y.length), C = [];
                    x && C.push.apply(C, c([x])), C.push(I), S && C.push.apply(C, c([S])), typeof f == "string" ? d.splice.apply(d, [p, 1].concat(C)) : f.content = C;
                  }
                } else f.content && c(f.content);
              }
              return d;
            }
            c(a.tokens);
          }
        }
      });
    })(t);
  }
  return Pf;
}
var Bf, dI;
function hY() {
  if (dI) return Bf;
  dI = 1;
  var e = Mn();
  Bf = t, t.displayName = "django", t.aliases = ["jinja2"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.django = {
        comment: /^\{#[\s\S]*?#\}$/,
        tag: {
          pattern: /(^\{%[+-]?\s*)\w+/,
          lookbehind: !0,
          alias: "keyword"
        },
        delimiter: {
          pattern: /^\{[{%][+-]?|[+-]?[}%]\}$/,
          alias: "punctuation"
        },
        string: {
          pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        filter: {
          pattern: /(\|)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        test: {
          pattern: /(\bis\s+(?:not\s+)?)(?!not\b)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b[a-z_]\w+(?=\s*\()/i,
        keyword: /\b(?:and|as|by|else|for|if|import|in|is|loop|not|or|recursive|with|without)\b/,
        operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        number: /\b\d+(?:\.\d+)?\b/,
        boolean: /[Ff]alse|[Nn]one|[Tt]rue/,
        variable: /\b\w+\b/,
        punctuation: /[{}[\](),.:;]/
      };
      var a = /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g, i = r.languages["markup-templating"];
      r.hooks.add("before-tokenize", function(s) {
        i.buildPlaceholders(s, "django", a);
      }), r.hooks.add("after-tokenize", function(s) {
        i.tokenizePlaceholders(s, "django");
      }), r.languages.jinja2 = r.languages.django, r.hooks.add("before-tokenize", function(s) {
        i.buildPlaceholders(s, "jinja2", a);
      }), r.hooks.add("after-tokenize", function(s) {
        i.tokenizePlaceholders(s, "jinja2");
      });
    }(n);
  }
  return Bf;
}
var $f, pI;
function bY() {
  if (pI) return $f;
  pI = 1, $f = e, e.displayName = "dnsZoneFile", e.aliases = [];
  function e(t) {
    t.languages["dns-zone-file"] = {
      comment: /;.*/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(^\$ORIGIN[ \t]+)\S+/m,
          lookbehind: !0
        },
        {
          pattern: /(^|\s)@(?=\s|$)/,
          lookbehind: !0
        }
      ],
      keyword: /^\$(?:INCLUDE|ORIGIN|TTL)(?=\s|$)/m,
      class: {
        // https://tools.ietf.org/html/rfc1035#page-13
        pattern: /(^|\s)(?:CH|CS|HS|IN)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        // https://en.wikipedia.org/wiki/List_of_DNS_record_types
        pattern: /(^|\s)(?:A|A6|AAAA|AFSDB|APL|ATMA|CAA|CDNSKEY|CDS|CERT|CNAME|DHCID|DLV|DNAME|DNSKEY|DS|EID|GID|GPOS|HINFO|HIP|IPSECKEY|ISDN|KEY|KX|LOC|MAILA|MAILB|MB|MD|MF|MG|MINFO|MR|MX|NAPTR|NB|NBSTAT|NIMLOC|NINFO|NS|NSAP|NSAP-PTR|NSEC|NSEC3|NSEC3PARAM|NULL|NXT|OPENPGPKEY|PTR|PX|RKEY|RP|RRSIG|RT|SIG|SINK|SMIMEA|SOA|SPF|SRV|SSHFP|TA|TKEY|TLSA|TSIG|TXT|UID|UINFO|UNSPEC|URI|WKS|X25)(?=\s|$)/,
        lookbehind: !0,
        alias: "keyword"
      },
      punctuation: /[()]/
    }, t.languages["dns-zone"] = t.languages["dns-zone-file"];
  }
  return $f;
}
var Uf, fI;
function yY() {
  if (fI) return Uf;
  fI = 1, Uf = e, e.displayName = "docker", e.aliases = ["dockerfile"];
  function e(t) {
    (function(n) {
      var r = /\\[\r\n](?:\s|\\[\r\n]|#.*(?!.))*(?![\s#]|\\[\r\n])/.source, a = /(?:[ \t]+(?![ \t])(?:<SP_BS>)?|<SP_BS>)/.source.replace(
        /<SP_BS>/g,
        function() {
          return r;
        }
      ), i = /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"|'(?:[^'\\\r\n]|\\(?:\r\n|[\s\S]))*'/.source, s = /--[\w-]+=(?:<STR>|(?!["'])(?:[^\s\\]|\\.)+)/.source.replace(
        /<STR>/g,
        function() {
          return i;
        }
      ), u = {
        pattern: RegExp(i),
        greedy: !0
      }, c = {
        pattern: /(^[ \t]*)#.*/m,
        lookbehind: !0,
        greedy: !0
      };
      function d(p, f) {
        return p = p.replace(/<OPT>/g, function() {
          return s;
        }).replace(/<SP>/g, function() {
          return a;
        }), RegExp(p, f);
      }
      n.languages.docker = {
        instruction: {
          pattern: /(^[ \t]*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)(?:\\.|[^\r\n\\])*(?:\\$(?:\s|#.*$)*(?![\s#])(?:\\.|[^\r\n\\])*)*/im,
          lookbehind: !0,
          greedy: !0,
          inside: {
            options: {
              pattern: d(
                /(^(?:ONBUILD<SP>)?\w+<SP>)<OPT>(?:<SP><OPT>)*/.source,
                "i"
              ),
              lookbehind: !0,
              greedy: !0,
              inside: {
                property: {
                  pattern: /(^|\s)--[\w-]+/,
                  lookbehind: !0
                },
                string: [
                  u,
                  {
                    pattern: /(=)(?!["'])(?:[^\s\\]|\\.)+/,
                    lookbehind: !0
                  }
                ],
                operator: /\\$/m,
                punctuation: /=/
              }
            },
            keyword: [
              {
                // https://docs.docker.com/engine/reference/builder/#healthcheck
                pattern: d(
                  /(^(?:ONBUILD<SP>)?HEALTHCHECK<SP>(?:<OPT><SP>)*)(?:CMD|NONE)\b/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#from
                pattern: d(
                  /(^(?:ONBUILD<SP>)?FROM<SP>(?:<OPT><SP>)*(?!--)[^ \t\\]+<SP>)AS/.source,
                  "i"
                ),
                lookbehind: !0,
                greedy: !0
              },
              {
                // https://docs.docker.com/engine/reference/builder/#onbuild
                pattern: d(/(^ONBUILD<SP>)\w+/.source, "i"),
                lookbehind: !0,
                greedy: !0
              },
              {
                pattern: /^\w+/,
                greedy: !0
              }
            ],
            comment: c,
            string: u,
            variable: /\$(?:\w+|\{[^{}"'\\]*\})/,
            operator: /\\$/m
          }
        },
        comment: c
      }, n.languages.dockerfile = n.languages.docker;
    })(t);
  }
  return Uf;
}
var jf, gI;
function vY() {
  if (gI) return jf;
  gI = 1, jf = e, e.displayName = "dot", e.aliases = ["gv"];
  function e(t) {
    (function(n) {
      var r = "(?:" + [
        // an identifier
        /[a-zA-Z_\x80-\uFFFF][\w\x80-\uFFFF]*/.source,
        // a number
        /-?(?:\.\d+|\d+(?:\.\d*)?)/.source,
        // a double-quoted string
        /"[^"\\]*(?:\\[\s\S][^"\\]*)*"/.source,
        // HTML-like string
        /<(?:[^<>]|(?!<!--)<(?:[^<>"']|"[^"]*"|'[^']*')+>|<!--(?:[^-]|-(?!->))*-->)*>/.source
      ].join("|") + ")", a = {
        markup: {
          pattern: /(^<)[\s\S]+(?=>$)/,
          lookbehind: !0,
          alias: ["language-markup", "language-html", "language-xml"],
          inside: n.languages.markup
        }
      };
      function i(s, u) {
        return RegExp(
          s.replace(/<ID>/g, function() {
            return r;
          }),
          u
        );
      }
      n.languages.dot = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\/|^#.*/m,
          greedy: !0
        },
        "graph-name": {
          pattern: i(
            /(\b(?:digraph|graph|subgraph)[ \t\r\n]+)<ID>/.source,
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name",
          inside: a
        },
        "attr-value": {
          pattern: i(/(=[ \t\r\n]*)<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        "attr-name": {
          pattern: i(/([\[;, \t\r\n])<ID>(?=[ \t\r\n]*=)/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        keyword: /\b(?:digraph|edge|graph|node|strict|subgraph)\b/i,
        "compass-point": {
          pattern: /(:[ \t\r\n]*)(?:[ewc_]|[ns][ew]?)(?![\w\x80-\uFFFF])/,
          lookbehind: !0,
          alias: "builtin"
        },
        node: {
          pattern: i(/(^|[^-.\w\x80-\uFFFF\\])<ID>/.source),
          lookbehind: !0,
          greedy: !0,
          inside: a
        },
        operator: /[=:]|-[->]/,
        punctuation: /[\[\]{};,]/
      }, n.languages.gv = n.languages.dot;
    })(t);
  }
  return jf;
}
var qf, mI;
function EY() {
  if (mI) return qf;
  mI = 1, qf = e, e.displayName = "ebnf", e.aliases = [];
  function e(t) {
    t.languages.ebnf = {
      comment: /\(\*[\s\S]*?\*\)/,
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      special: {
        pattern: /\?[^?\r\n]*\?/,
        greedy: !0,
        alias: "class-name"
      },
      definition: {
        pattern: /^([\t ]*)[a-z]\w*(?:[ \t]+[a-z]\w*)*(?=\s*=)/im,
        lookbehind: !0,
        alias: ["rule", "keyword"]
      },
      rule: /\b[a-z]\w*(?:[ \t]+[a-z]\w*)*\b/i,
      punctuation: /\([:/]|[:/]\)|[.,;()[\]{}]/,
      operator: /[-=|*/!]/
    };
  }
  return qf;
}
var zf, hI;
function SY() {
  if (hI) return zf;
  hI = 1, zf = e, e.displayName = "editorconfig", e.aliases = [];
  function e(t) {
    t.languages.editorconfig = {
      // https://editorconfig-specification.readthedocs.io
      comment: /[;#].*/,
      section: {
        pattern: /(^[ \t]*)\[.+\]/m,
        lookbehind: !0,
        alias: "selector",
        inside: {
          regex: /\\\\[\[\]{},!?.*]/,
          // Escape special characters with '\\'
          operator: /[!?]|\.\.|\*{1,2}/,
          punctuation: /[\[\]{},]/
        }
      },
      key: {
        pattern: /(^[ \t]*)[^\s=]+(?=[ \t]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /=.*/,
        alias: "attr-value",
        inside: {
          punctuation: /^=/
        }
      }
    };
  }
  return zf;
}
var Gf, bI;
function xY() {
  if (bI) return Gf;
  bI = 1, Gf = e, e.displayName = "eiffel", e.aliases = [];
  function e(t) {
    t.languages.eiffel = {
      comment: /--.*/,
      string: [
        // Aligned-verbatim-strings
        {
          pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
          greedy: !0
        },
        // Non-aligned-verbatim-strings
        {
          pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
          greedy: !0
        },
        // Single-line string
        {
          pattern: /"(?:%(?:(?!\n)\s)*\n\s*%|%\S|[^%"\r\n])*"/,
          greedy: !0
        }
      ],
      // normal char | special char | char code
      char: /'(?:%.|[^%'\r\n])+'/,
      keyword: /\b(?:across|agent|alias|all|and|as|assign|attached|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
      boolean: /\b(?:False|True)\b/i,
      // Convention: class-names are always all upper-case characters
      "class-name": /\b[A-Z][\dA-Z_]*\b/,
      number: [
        // hexa | octal | bin
        /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
        // Decimal
        /(?:\b\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*\b|\b\d(?:_*\d)*\b\.?/i
      ],
      punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
      operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
    };
  }
  return Gf;
}
var Hf, yI;
function TY() {
  if (yI) return Hf;
  yI = 1;
  var e = Mn();
  Hf = t, t.displayName = "ejs", t.aliases = ["eta"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.ejs = {
        delimiter: {
          pattern: /^<%[-_=]?|[-_]?%>$/,
          alias: "punctuation"
        },
        comment: /^#[\s\S]*/,
        "language-javascript": {
          pattern: /[\s\S]+/,
          inside: r.languages.javascript
        }
      }, r.hooks.add("before-tokenize", function(a) {
        var i = /<%(?!%)[\s\S]+?%>/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "ejs",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(a, "ejs");
      }), r.languages.eta = r.languages.ejs;
    }(n);
  }
  return Hf;
}
var Vf, vI;
function wY() {
  if (vI) return Vf;
  vI = 1, Vf = e, e.displayName = "elixir", e.aliases = [];
  function e(t) {
    t.languages.elixir = {
      doc: {
        pattern: /@(?:doc|moduledoc)\s+(?:("""|''')[\s\S]*?\1|("|')(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2)/,
        inside: {
          attribute: /^@\w+/,
          string: /['"][\s\S]+/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
      regex: {
        pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
        greedy: !0
      },
      string: [
        {
          // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
          pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|#(?!\{)|[^#\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          pattern: /("""|''')[\s\S]*?\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        },
        {
          // Multi-line strings are allowed
          pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0,
          inside: {
            // See interpolation below
          }
        }
      ],
      atom: {
        // Look-behind prevents bad highlighting of the :: operator
        pattern: /(^|[^:]):\w+/,
        lookbehind: !0,
        alias: "symbol"
      },
      module: {
        pattern: /\b[A-Z]\w*\b/,
        alias: "class-name"
      },
      // Look-ahead prevents bad highlighting of the :: operator
      "attr-name": /\b\w+\??:(?!:)/,
      argument: {
        // Look-behind prevents bad highlighting of the && operator
        pattern: /(^|[^&])&\d+/,
        lookbehind: !0,
        alias: "variable"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "variable"
      },
      function: /\b[_a-zA-Z]\w*[?!]?(?:(?=\s*(?:\.\s*)?\()|(?=\/\d))/,
      number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
      keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|delegate|exception|impl|macro|module|n|np|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|quote|raise|require|rescue|try|unless|unquote|use|when)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      operator: [
        /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
        {
          // We don't want to match <<
          pattern: /([^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /([^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,%\[\]{}()]/
    }, t.languages.elixir.string.forEach(function(n) {
      n.inside = {
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            rest: t.languages.elixir
          }
        }
      };
    });
  }
  return Vf;
}
var Wf, EI;
function AY() {
  if (EI) return Wf;
  EI = 1, Wf = e, e.displayName = "elm", e.aliases = [];
  function e(t) {
    t.languages.elm = {
      comment: /--.*|\{-[\s\S]*?-\}/,
      char: {
        pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+|u\{[0-9a-fA-F]+\}))'/,
        greedy: !0
      },
      string: [
        {
          // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
          pattern: /"""[\s\S]*?"""/,
          greedy: !0
        },
        {
          pattern: /"(?:[^\\"\r\n]|\\.)*"/,
          greedy: !0
        }
      ],
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+(?:[A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|exposing|import)\b/
        }
      },
      keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
      // decimal integers and floating point numbers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
      // Most of this is needed because of the meaning of a single '.'.
      // If it stands alone freely, it is the function composition.
      // It may also be a separator between a module name and an identifier => no
      // operator. If it comes together with other special characters it is an
      // operator too.
      // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
      // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
      operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
      // In Elm, nearly everything is a variable, do not highlight these.
      hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
      constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
      punctuation: /[{}[\]|(),.:]/
    };
  }
  return Wf;
}
var Kf, SI;
function IY() {
  if (SI) return Kf;
  SI = 1;
  var e = dc(), t = Mn();
  Kf = n, n.displayName = "erb", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.erb = {
        delimiter: {
          pattern: /^(\s*)<%=?|%>(?=\s*$)/,
          lookbehind: !0,
          alias: "punctuation"
        },
        ruby: {
          pattern: /\s*\S[\s\S]*/,
          alias: "language-ruby",
          inside: a.languages.ruby
        }
      }, a.hooks.add("before-tokenize", function(i) {
        var s = /<%=?(?:[^\r\n]|[\r\n](?!=begin)|[\r\n]=begin\s(?:[^\r\n]|[\r\n](?!=end))*[\r\n]=end)+?%>/g;
        a.languages["markup-templating"].buildPlaceholders(
          i,
          "erb",
          s
        );
      }), a.hooks.add("after-tokenize", function(i) {
        a.languages["markup-templating"].tokenizePlaceholders(i, "erb");
      });
    }(r);
  }
  return Kf;
}
var Yf, xI;
function RY() {
  if (xI) return Yf;
  xI = 1, Yf = e, e.displayName = "erlang", e.aliases = [];
  function e(t) {
    t.languages.erlang = {
      comment: /%.+/,
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      "quoted-function": {
        pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
        alias: "function"
      },
      "quoted-atom": {
        pattern: /'(?:\\.|[^\\'\r\n])+'/,
        alias: "atom"
      },
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:after|case|catch|end|fun|if|of|receive|try|when)\b/,
      number: [
        /\$\\?./,
        /\b\d+#[a-z0-9]+/i,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i
      ],
      function: /\b[a-z][\w@]*(?=\()/,
      variable: {
        // Look-behind is used to prevent wrong highlighting of atoms containing "@"
        pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
        lookbehind: !0
      },
      operator: [
        /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:and|andalso|band|bnot|bor|bsl|bsr|bxor|div|not|or|orelse|rem|xor)\b/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      atom: /\b[a-z][\w@]*/,
      punctuation: /[()[\]{}:;,.#|]|<<|>>/
    };
  }
  return Yf;
}
var Xf, TI;
function l1() {
  if (TI) return Xf;
  TI = 1, Xf = e, e.displayName = "lua", e.aliases = [];
  function e(t) {
    t.languages.lua = {
      comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
      // \z may be used to skip the following space
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
        greedy: !0
      },
      number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
      keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
      function: /(?!\d)\w+(?=\s*(?:[({]))/,
      operator: [
        /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
        {
          // Match ".." but don't break "..."
          pattern: /(^|[^.])\.\.(?!\.)/,
          lookbehind: !0
        }
      ],
      punctuation: /[\[\](){},;]|\.+|:+/
    };
  }
  return Xf;
}
var Zf, wI;
function _Y() {
  if (wI) return Zf;
  wI = 1;
  var e = l1(), t = Mn();
  Zf = n, n.displayName = "etlua", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.etlua = {
        delimiter: {
          pattern: /^<%[-=]?|-?%>$/,
          alias: "punctuation"
        },
        "language-lua": {
          pattern: /[\s\S]+/,
          inside: a.languages.lua
        }
      }, a.hooks.add("before-tokenize", function(i) {
        var s = /<%[\s\S]+?%>/g;
        a.languages["markup-templating"].buildPlaceholders(
          i,
          "etlua",
          s
        );
      }), a.hooks.add("after-tokenize", function(i) {
        a.languages["markup-templating"].tokenizePlaceholders(i, "etlua");
      });
    }(r);
  }
  return Zf;
}
var Jf, AI;
function CY() {
  if (AI) return Jf;
  AI = 1, Jf = e, e.displayName = "excelFormula", e.aliases = [];
  function e(t) {
    t.languages["excel-formula"] = {
      comment: {
        pattern: /(\bN\(\s*)"(?:[^"]|"")*"(?=\s*\))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"]|"")*"(?!")/,
        greedy: !0
      },
      reference: {
        // https://www.ablebits.com/office-addins-blog/2015/12/08/excel-reference-another-sheet-workbook/
        // Sales!B2
        // 'Winter sales'!B2
        // [Sales.xlsx]Jan!B2:B5
        // D:\Reports\[Sales.xlsx]Jan!B2:B5
        // '[Sales.xlsx]Jan sales'!B2:B5
        // 'D:\Reports\[Sales.xlsx]Jan sales'!B2:B5
        pattern: /(?:'[^']*'|(?:[^\s()[\]{}<>*?"';,$&]*\[[^^\s()[\]{}<>*?"']+\])?\w+)!/,
        greedy: !0,
        alias: "string",
        inside: {
          operator: /!$/,
          punctuation: /'/,
          sheet: {
            pattern: /[^[\]]+$/,
            alias: "function"
          },
          file: {
            pattern: /\[[^[\]]+\]$/,
            inside: {
              punctuation: /[[\]]/
            }
          },
          path: /[\s\S]+/
        }
      },
      "function-name": {
        pattern: /\b[A-Z]\w*(?=\()/i,
        alias: "keyword"
      },
      range: {
        pattern: /\$?\b(?:[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+|[A-Z]+:\$?[A-Z]+|\d+:\$?\d+)\b/i,
        alias: "property",
        inside: {
          operator: /:/,
          cell: /\$?[A-Z]+\$?\d+/i,
          column: /\$?[A-Z]+/i,
          row: /\$?\d+/
        }
      },
      cell: {
        // Excel is case insensitive, so the string "foo1" could be either a variable or a cell.
        // To combat this, we match cells case insensitive, if the contain at least one "$", and case sensitive otherwise.
        pattern: /\b[A-Z]+\d+\b|\$[A-Za-z]+\$?\d+\b|\b[A-Za-z]+\$\d+\b/,
        alias: "property"
      },
      number: /(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      operator: /[-+*/^%=&,]|<[=>]?|>=?/,
      punctuation: /[[\]();{}|]/
    }, t.languages.xlsx = t.languages.xls = t.languages["excel-formula"];
  }
  return Jf;
}
var Qf, II;
function kY() {
  if (II) return Qf;
  II = 1, Qf = e, e.displayName = "factor", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        function: /\b(?:BUGS?|FIX(?:MES?)?|NOTES?|TODOS?|XX+|HACKS?|WARN(?:ING)?|\?{2,}|!{2,})\b/
      }, a = {
        number: /\\[^\s']|%\w/
      }, i = {
        comment: [
          {
            // ! single-line exclamation point comments with whitespace after/around the !
            pattern: /(^|\s)(?:! .*|!$)/,
            lookbehind: !0,
            inside: r
          },
          /* from basis/multiline: */
          {
            // /* comment */, /* comment*/
            pattern: /(^|\s)\/\*\s[\s\S]*?\*\/(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: r
          },
          {
            // ![[ comment ]] , ![===[ comment]===]
            pattern: /(^|\s)!\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            inside: r
          }
        ],
        number: [
          {
            // basic base 10 integers 9, -9
            pattern: /(^|\s)[+-]?\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // base prefix integers 0b010 0o70 0xad 0d10 0XAD -0xa9
            pattern: /(^|\s)[+-]?0(?:b[01]+|o[0-7]+|d\d+|x[\dA-F]+)(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // fractional ratios 1/5 -1/5 and the literal float approximations 1/5. -1/5.
            pattern: /(^|\s)[+-]?\d+\/\d+\.?(?=\s|$)/,
            lookbehind: !0
          },
          {
            // positive mixed numbers 23+1/5 +23+1/5
            pattern: /(^|\s)\+?\d+\+\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // negative mixed numbers -23-1/5
            pattern: /(^|\s)-\d+-\d+\/\d+(?=\s|$)/,
            lookbehind: !0
          },
          {
            // basic decimal floats -0.01 0. .0 .1 -.1 -1. -12.13 +12.13
            // and scientific notation with base 10 exponents 3e4 3e-4 .3e-4
            pattern: /(^|\s)[+-]?(?:\d*\.\d+|\d+\.\d*|\d+)(?:e[+-]?\d+)?(?=\s|$)/i,
            lookbehind: !0
          },
          {
            // NAN literal syntax NAN: 80000deadbeef, NAN: a
            pattern: /(^|\s)NAN:\s+[\da-fA-F]+(?=\s|$)/,
            lookbehind: !0
          },
          {
            /*
            base prefix floats 0x1.0p3 (8.0) 0b1.010p2 (5.0) 0x1.p1 0b1.11111111p11111...
            "The normalized hex form ±0x1.MMMMMMMMMMMMM[pP]±EEEE allows any floating-point number to be specified precisely.
            The values of MMMMMMMMMMMMM and EEEE map directly to the mantissa and exponent fields of the binary IEEE 754 representation."
            <https://docs.factorcode.org/content/article-syntax-floats.html>
            */
            pattern: /(^|\s)[+-]?0(?:b1\.[01]*|o1\.[0-7]*|d1\.\d*|x1\.[\dA-F]*)p\d+(?=\s|$)/i,
            lookbehind: !0
          }
        ],
        // R/ regexp?\/\\/
        regexp: {
          pattern: /(^|\s)R\/\s(?:\\\S|[^\\/])*\/(?:[idmsr]*|[idmsr]+-[idmsr]+)(?=\s|$)/,
          lookbehind: !0,
          alias: "number",
          inside: {
            variable: /\\\S/,
            keyword: /[+?*\[\]^$(){}.|]/,
            operator: {
              pattern: /(\/)[idmsr]+(?:-[idmsr]+)?/,
              lookbehind: !0
            }
          }
        },
        boolean: {
          pattern: /(^|\s)[tf](?=\s|$)/,
          lookbehind: !0
        },
        // SBUF" asd", URL" ://...", P" /etc/"
        "custom-string": {
          pattern: /(^|\s)[A-Z0-9\-]+"\s(?:\\\S|[^"\\])*"/,
          lookbehind: !0,
          greedy: !0,
          alias: "string",
          inside: {
            number: /\\\S|%\w|\//
          }
        },
        "multiline-string": [
          {
            // STRING: name \n content \n ; -> CONSTANT: name "content" (symbol)
            pattern: /(^|\s)STRING:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*;(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              number: a.number,
              // trailing semicolon on its own line
              "semicolon-or-setlocal": {
                pattern: /([\r\n][ \t]*);(?=\s|$)/,
                lookbehind: !0,
                alias: "function"
              }
            }
          },
          {
            // HEREDOC: marker \n content \n marker ; -> "content" (immediate)
            pattern: /(^|\s)HEREDOC:\s+\S+(?:\n|\r\n).*(?:\n|\r\n)\s*\S+(?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: a
          },
          {
            // [[ string ]], [==[ string]==]
            pattern: /(^|\s)\[(={0,6})\[\s[\s\S]*?\]\2\](?=\s|$)/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: a
          }
        ],
        "special-using": {
          pattern: /(^|\s)USING:(?:\s\S+)*(?=\s+;(?:\s|$))/,
          lookbehind: !0,
          alias: "function",
          inside: {
            // this is essentially a regex for vocab names, which i don't want to specify
            // but the USING: gets picked up as a vocab name
            string: {
              pattern: /(\s)[^:\s]+/,
              lookbehind: !0
            }
          }
        },
        /* this description of stack effect literal syntax is not complete and not as specific as theoretically possible
        trying to do better is more work and regex-computation-time than it's worth though.
        - we'd like to have the "delimiter" parts of the stack effect [ (, --, and ) ] be a different (less-important or comment-like) colour to the stack effect contents
        - we'd like if nested stack effects were treated as such rather than just appearing flat (with `inside`)
        - we'd like if the following variable name conventions were recognised specifically:
        special row variables = ..a b..
        type and stack effect annotations end with a colon = ( quot: ( a: ( -- ) -- b ) -- x ), ( x: number -- )
        word throws unconditional error = *
        any other word-like variable name = a ? q' etc
        https://docs.factorcode.org/content/article-effects.html
        these are pretty complicated to highlight properly without a real parser, and therefore out of scope
        the old pattern, which may be later useful, was: (^|\s)(?:call|execute|eval)?\((?:\s+[^"\r\n\t ]\S*)*?\s+--(?:\s+[^"\n\t ]\S*)*?\s+\)(?=\s|$)
        */
        // current solution is not great
        "stack-effect-delimiter": [
          {
            // opening parenthesis
            pattern: /(^|\s)(?:call|eval|execute)?\((?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // middle --
            pattern: /(\s)--(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing parenthesis
            pattern: /(\s)\)(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        combinators: {
          pattern: null,
          lookbehind: !0,
          alias: "keyword"
        },
        "kernel-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "sequences-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "math-builtin": {
          pattern: null,
          lookbehind: !0,
          alias: "variable"
        },
        "constructor-word": {
          // <array> but not <=>
          pattern: /(^|\s)<(?!=+>|-+>)\S+>(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "other-builtin-syntax": {
          pattern: null,
          lookbehind: !0,
          alias: "operator"
        },
        /*
        full list of supported word naming conventions: (the convention appears outside of the [brackets])
        set-[x]
        change-[x]
        with-[x]
        new-[x]
        >[string]
        [base]>
        [string]>[number]
        +[symbol]+
        [boolean-word]?
        ?[of]
        [slot-reader]>>
        >>[slot-setter]
        [slot-writer]<<
        ([implementation-detail])
        [mutater]!
        [variant]*
        [prettyprint].
        $[help-markup]
        <constructors>, SYNTAX:, etc are supported by their own patterns.
        `with` and `new` from `kernel` are their own builtins.
        see <https://docs.factorcode.org/content/article-conventions.html>
        */
        "conventionally-named-word": {
          pattern: /(^|\s)(?!")(?:(?:change|new|set|with)-\S+|\$\S+|>[^>\s]+|[^:>\s]+>|[^>\s]+>[^>\s]+|\+[^+\s]+\+|[^?\s]+\?|\?[^?\s]+|[^>\s]+>>|>>[^>\s]+|[^<\s]+<<|\([^()\s]+\)|[^!\s]+!|[^*\s]\S*\*|[^.\s]\S*\.)(?=\s|$)/,
          lookbehind: !0,
          alias: "keyword"
        },
        "colon-syntax": {
          pattern: /(^|\s)(?:[A-Z0-9\-]+#?)?:{1,2}\s+(?:;\S+|(?!;)\S+)(?=\s|$)/,
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "semicolon-or-setlocal": {
          pattern: /(\s)(?:;|:>)(?=\s|$)/,
          lookbehind: !0,
          alias: "function"
        },
        // do not highlight leading } or trailing X{ at the begin/end of the file as it's invalid syntax
        "curly-brace-literal-delimiter": [
          {
            // opening
            pattern: /(^|\s)[a-z]*\{(?=\s)/i,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\}(?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        // do not highlight leading ] or trailing [ at the begin/end of the file as it's invalid syntax
        "quotation-delimiter": [
          {
            // opening
            pattern: /(^|\s)\[(?=\s)/,
            lookbehind: !0,
            alias: "operator"
          },
          {
            // closing
            pattern: /(\s)\](?=\s|$)/,
            lookbehind: !0,
            alias: "operator"
          }
        ],
        "normal-word": {
          pattern: /(^|\s)[^"\s]\S*(?=\s|$)/,
          lookbehind: !0
        },
        /*
        basic first-class string "a"
        with escaped double-quote "a\""
        escaped backslash "\\"
        and general escapes since Factor has so many "\N"
        syntax that works in the reference implementation that isn't fully
        supported because it's an implementation detail:
        "string 1""string 2" -> 2 strings (works anyway)
        "string"5 -> string, 5
        "string"[ ] -> string, quotation
        { "a"} -> array<string>
        the rest of those examples all properly recognise the string, but not
        the other object (number, quotation, etc)
        this is fine for a regex-only implementation.
        */
        string: {
          pattern: /"(?:\\\S|[^"\\])*"/,
          greedy: !0,
          inside: a
        }
      }, s = function(p) {
        return (p + "").replace(/([.?*+\^$\[\]\\(){}|\-])/g, "\\$1");
      }, u = function(p) {
        return new RegExp("(^|\\s)(?:" + p.map(s).join("|") + ")(?=\\s|$)");
      }, c = {
        "kernel-builtin": [
          "or",
          "2nipd",
          "4drop",
          "tuck",
          "wrapper",
          "nip",
          "wrapper?",
          "callstack>array",
          "die",
          "dupd",
          "callstack",
          "callstack?",
          "3dup",
          "hashcode",
          "pick",
          "4nip",
          "build",
          ">boolean",
          "nipd",
          "clone",
          "5nip",
          "eq?",
          "?",
          "=",
          "swapd",
          "2over",
          "clear",
          "2dup",
          "get-retainstack",
          "not",
          "tuple?",
          "dup",
          "3nipd",
          "call",
          "-rotd",
          "object",
          "drop",
          "assert=",
          "assert?",
          "-rot",
          "execute",
          "boa",
          "get-callstack",
          "curried?",
          "3drop",
          "pickd",
          "overd",
          "over",
          "roll",
          "3nip",
          "swap",
          "and",
          "2nip",
          "rotd",
          "throw",
          "(clone)",
          "hashcode*",
          "spin",
          "reach",
          "4dup",
          "equal?",
          "get-datastack",
          "assert",
          "2drop",
          "<wrapper>",
          "boolean?",
          "identity-hashcode",
          "identity-tuple?",
          "null",
          "composed?",
          "new",
          "5drop",
          "rot",
          "-roll",
          "xor",
          "identity-tuple",
          "boolean"
        ],
        "other-builtin-syntax": [
          // syntax
          "=======",
          "recursive",
          "flushable",
          ">>",
          "<<<<<<",
          "M\\",
          "B",
          "PRIVATE>",
          "\\",
          "======",
          "final",
          "inline",
          "delimiter",
          "deprecated",
          "<PRIVATE",
          ">>>>>>",
          "<<<<<<<",
          "parse-complex",
          "malformed-complex",
          "read-only",
          ">>>>>>>",
          "call-next-method",
          "<<",
          "foldable",
          // literals
          "$",
          "$[",
          "${"
        ],
        "sequences-builtin": [
          "member-eq?",
          "mismatch",
          "append",
          "assert-sequence=",
          "longer",
          "repetition",
          "clone-like",
          "3sequence",
          "assert-sequence?",
          "last-index-from",
          "reversed",
          "index-from",
          "cut*",
          "pad-tail",
          "join-as",
          "remove-eq!",
          "concat-as",
          "but-last",
          "snip",
          "nths",
          "nth",
          "sequence",
          "longest",
          "slice?",
          "<slice>",
          "remove-nth",
          "tail-slice",
          "empty?",
          "tail*",
          "member?",
          "virtual-sequence?",
          "set-length",
          "drop-prefix",
          "iota",
          "unclip",
          "bounds-error?",
          "unclip-last-slice",
          "non-negative-integer-expected",
          "non-negative-integer-expected?",
          "midpoint@",
          "longer?",
          "?set-nth",
          "?first",
          "rest-slice",
          "prepend-as",
          "prepend",
          "fourth",
          "sift",
          "subseq-start",
          "new-sequence",
          "?last",
          "like",
          "first4",
          "1sequence",
          "reverse",
          "slice",
          "virtual@",
          "repetition?",
          "set-last",
          "index",
          "4sequence",
          "max-length",
          "set-second",
          "immutable-sequence",
          "first2",
          "first3",
          "supremum",
          "unclip-slice",
          "suffix!",
          "insert-nth",
          "tail",
          "3append",
          "short",
          "suffix",
          "concat",
          "flip",
          "immutable?",
          "reverse!",
          "2sequence",
          "sum",
          "delete-all",
          "indices",
          "snip-slice",
          "<iota>",
          "check-slice",
          "sequence?",
          "head",
          "append-as",
          "halves",
          "sequence=",
          "collapse-slice",
          "?second",
          "slice-error?",
          "product",
          "bounds-check?",
          "bounds-check",
          "immutable",
          "virtual-exemplar",
          "harvest",
          "remove",
          "pad-head",
          "last",
          "set-fourth",
          "cartesian-product",
          "remove-eq",
          "shorten",
          "shorter",
          "reversed?",
          "shorter?",
          "shortest",
          "head-slice",
          "pop*",
          "tail-slice*",
          "but-last-slice",
          "iota?",
          "append!",
          "cut-slice",
          "new-resizable",
          "head-slice*",
          "sequence-hashcode",
          "pop",
          "set-nth",
          "?nth",
          "second",
          "join",
          "immutable-sequence?",
          "<reversed>",
          "3append-as",
          "virtual-sequence",
          "subseq?",
          "remove-nth!",
          "length",
          "last-index",
          "lengthen",
          "assert-sequence",
          "copy",
          "move",
          "third",
          "first",
          "tail?",
          "set-first",
          "prefix",
          "bounds-error",
          "<repetition>",
          "exchange",
          "surround",
          "cut",
          "min-length",
          "set-third",
          "push-all",
          "head?",
          "subseq-start-from",
          "delete-slice",
          "rest",
          "sum-lengths",
          "head*",
          "infimum",
          "remove!",
          "glue",
          "slice-error",
          "subseq",
          "push",
          "replace-slice",
          "subseq-as",
          "unclip-last"
        ],
        "math-builtin": [
          "number=",
          "next-power-of-2",
          "?1+",
          "fp-special?",
          "imaginary-part",
          "float>bits",
          "number?",
          "fp-infinity?",
          "bignum?",
          "fp-snan?",
          "denominator",
          "gcd",
          "*",
          "+",
          "fp-bitwise=",
          "-",
          "u>=",
          "/",
          ">=",
          "bitand",
          "power-of-2?",
          "log2-expects-positive",
          "neg?",
          "<",
          "log2",
          ">",
          "integer?",
          "number",
          "bits>double",
          "2/",
          "zero?",
          "bits>float",
          "float?",
          "shift",
          "ratio?",
          "rect>",
          "even?",
          "ratio",
          "fp-sign",
          "bitnot",
          ">fixnum",
          "complex?",
          "/i",
          "integer>fixnum",
          "/f",
          "sgn",
          ">bignum",
          "next-float",
          "u<",
          "u>",
          "mod",
          "recip",
          "rational",
          ">float",
          "2^",
          "integer",
          "fixnum?",
          "neg",
          "fixnum",
          "sq",
          "bignum",
          ">rect",
          "bit?",
          "fp-qnan?",
          "simple-gcd",
          "complex",
          "<fp-nan>",
          "real",
          ">fraction",
          "double>bits",
          "bitor",
          "rem",
          "fp-nan-payload",
          "real-part",
          "log2-expects-positive?",
          "prev-float",
          "align",
          "unordered?",
          "float",
          "fp-nan?",
          "abs",
          "bitxor",
          "integer>fixnum-strict",
          "u<=",
          "odd?",
          "<=",
          "/mod",
          ">integer",
          "real?",
          "rational?",
          "numerator"
        ]
        // that's all for now
      };
      Object.keys(c).forEach(function(p) {
        i[p].pattern = u(c[p]);
      });
      var d = [
        // kernel
        "2bi",
        "while",
        "2tri",
        "bi*",
        "4dip",
        "both?",
        "same?",
        "tri@",
        "curry",
        "prepose",
        "3bi",
        "?if",
        "tri*",
        "2keep",
        "3keep",
        "curried",
        "2keepd",
        "when",
        "2bi*",
        "2tri*",
        "4keep",
        "bi@",
        "keepdd",
        "do",
        "unless*",
        "tri-curry",
        "if*",
        "loop",
        "bi-curry*",
        "when*",
        "2bi@",
        "2tri@",
        "with",
        "2with",
        "either?",
        "bi",
        "until",
        "3dip",
        "3curry",
        "tri-curry*",
        "tri-curry@",
        "bi-curry",
        "keepd",
        "compose",
        "2dip",
        "if",
        "3tri",
        "unless",
        "tuple",
        "keep",
        "2curry",
        "tri",
        "most",
        "while*",
        "dip",
        "composed",
        "bi-curry@",
        // sequences
        "find-last-from",
        "trim-head-slice",
        "map-as",
        "each-from",
        "none?",
        "trim-tail",
        "partition",
        "if-empty",
        "accumulate*",
        "reject!",
        "find-from",
        "accumulate-as",
        "collector-for-as",
        "reject",
        "map",
        "map-sum",
        "accumulate!",
        "2each-from",
        "follow",
        "supremum-by",
        "map!",
        "unless-empty",
        "collector",
        "padding",
        "reduce-index",
        "replicate-as",
        "infimum-by",
        "trim-tail-slice",
        "count",
        "find-index",
        "filter",
        "accumulate*!",
        "reject-as",
        "map-integers",
        "map-find",
        "reduce",
        "selector",
        "interleave",
        "2map",
        "filter-as",
        "binary-reduce",
        "map-index-as",
        "find",
        "produce",
        "filter!",
        "replicate",
        "cartesian-map",
        "cartesian-each",
        "find-index-from",
        "map-find-last",
        "3map-as",
        "3map",
        "find-last",
        "selector-as",
        "2map-as",
        "2map-reduce",
        "accumulate",
        "each",
        "each-index",
        "accumulate*-as",
        "when-empty",
        "all?",
        "collector-as",
        "push-either",
        "new-like",
        "collector-for",
        "2selector",
        "push-if",
        "2all?",
        "map-reduce",
        "3each",
        "any?",
        "trim-slice",
        "2reduce",
        "change-nth",
        "produce-as",
        "2each",
        "trim",
        "trim-head",
        "cartesian-find",
        "map-index",
        // math
        "if-zero",
        "each-integer",
        "unless-zero",
        "(find-integer)",
        "when-zero",
        "find-last-integer",
        "(all-integers?)",
        "times",
        "(each-integer)",
        "find-integer",
        "all-integers?",
        // math.combinators
        "unless-negative",
        "if-positive",
        "when-positive",
        "when-negative",
        "unless-positive",
        "if-negative",
        // combinators
        "case",
        "2cleave",
        "cond>quot",
        "case>quot",
        "3cleave",
        "wrong-values",
        "to-fixed-point",
        "alist>quot",
        "cond",
        "cleave",
        "call-effect",
        "recursive-hashcode",
        "spread",
        "deep-spread>quot",
        // combinators.short-circuit
        "2||",
        "0||",
        "n||",
        "0&&",
        "2&&",
        "3||",
        "1||",
        "1&&",
        "n&&",
        "3&&",
        // combinators.smart
        "smart-unless*",
        "keep-inputs",
        "reduce-outputs",
        "smart-when*",
        "cleave>array",
        "smart-with",
        "smart-apply",
        "smart-if",
        "inputs/outputs",
        "output>sequence-n",
        "map-outputs",
        "map-reduce-outputs",
        "dropping",
        "output>array",
        "smart-map-reduce",
        "smart-2map-reduce",
        "output>array-n",
        "nullary",
        "input<sequence",
        "append-outputs",
        "drop-inputs",
        "inputs",
        "smart-2reduce",
        "drop-outputs",
        "smart-reduce",
        "preserving",
        "smart-when",
        "outputs",
        "append-outputs-as",
        "smart-unless",
        "smart-if*",
        "sum-outputs",
        "input<sequence-unsafe",
        "output>sequence"
        // tafn
      ];
      i.combinators.pattern = u(d), n.languages.factor = i;
    })(t);
  }
  return Qf;
}
var eg, RI;
function NY() {
  if (RI) return eg;
  RI = 1, eg = e, e.displayName = "$false", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.false = {
        comment: {
          pattern: /\{[^}]*\}/
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        "character-code": {
          pattern: /'(?:[^\r]|\r\n?)/,
          alias: "number"
        },
        "assembler-code": {
          pattern: /\d+`/,
          alias: "important"
        },
        number: /\d+/,
        operator: /[-!#$%&'*+,./:;=>?@\\^_`|~ßø]/,
        punctuation: /\[|\]/,
        variable: /[a-z]/,
        "non-standard": {
          pattern: /[()<BDO®]/,
          alias: "bold"
        }
      };
    })(t);
  }
  return eg;
}
var tg, _I;
function OY() {
  if (_I) return tg;
  _I = 1, tg = e, e.displayName = "firestoreSecurityRules", e.aliases = [];
  function e(t) {
    t.languages["firestore-security-rules"] = t.languages.extend(
      "clike",
      {
        comment: /\/\/.*/,
        keyword: /\b(?:allow|function|if|match|null|return|rules_version|service)\b/,
        operator: /&&|\|\||[<>!=]=?|[-+*/%]|\b(?:in|is)\b/
      }
    ), delete t.languages["firestore-security-rules"]["class-name"], t.languages.insertBefore("firestore-security-rules", "keyword", {
      path: {
        pattern: /(^|[\s(),])(?:\/(?:[\w\xA0-\uFFFF]+|\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)))+/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /\{[\w\xA0-\uFFFF]+(?:=\*\*)?\}|\$\([\w\xA0-\uFFFF.]+\)/,
            inside: {
              operator: /=/,
              keyword: /\*\*/,
              punctuation: /[.$(){}]/
            }
          },
          punctuation: /\//
        }
      },
      method: {
        // to make the pattern shorter, the actual method names are omitted
        pattern: /(\ballow\s+)[a-z]+(?:\s*,\s*[a-z]+)*(?=\s*[:;])/,
        lookbehind: !0,
        alias: "builtin",
        inside: {
          punctuation: /,/
        }
      }
    });
  }
  return tg;
}
var ng, CI;
function LY() {
  if (CI) return ng;
  CI = 1, ng = e, e.displayName = "flow", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.flow = n.languages.extend("javascript", {}), n.languages.insertBefore("flow", "keyword", {
        type: [
          {
            pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|any|mixed|null|void)\b/,
            alias: "tag"
          }
        ]
      }), n.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete n.languages.flow.parameter, n.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
          pattern: /\{\||\|\}/,
          alias: "punctuation"
        }
      }), Array.isArray(n.languages.flow.keyword) || (n.languages.flow.keyword = [n.languages.flow.keyword]), n.languages.flow.keyword.unshift(
        {
          pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
          lookbehind: !0
        }
      );
    })(t);
  }
  return ng;
}
var rg, kI;
function DY() {
  if (kI) return rg;
  kI = 1, rg = e, e.displayName = "fortran", e.aliases = [];
  function e(t) {
    t.languages.fortran = {
      "quoted-number": {
        pattern: /[BOZ](['"])[A-F0-9]+\1/i,
        alias: "number"
      },
      string: {
        pattern: /(?:\b\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:[ \t]*!.*(?:\r\n?|\n)|(?![ \t]*!))|(?!\1).)*(?:\1|&)/,
        inside: {
          comment: {
            pattern: /(&(?:\r\n?|\n)\s*)!.*/,
            lookbehind: !0
          }
        }
      },
      comment: {
        pattern: /!.*/,
        greedy: !0
      },
      boolean: /\.(?:FALSE|TRUE)\.(?:_\w+)?/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
      keyword: [
        // Types
        /\b(?:CHARACTER|COMPLEX|DOUBLE ?PRECISION|INTEGER|LOGICAL|REAL)\b/i,
        // END statements
        /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
        // Statements
        /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
        // Others
        /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEIF|ELSEWHERE|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
      ],
      operator: [
        /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.[A-Z]+\./i,
        {
          // Use lookbehind to prevent confusion with (/ /)
          pattern: /(^|(?!\().)\/(?!\))/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\/|\/\)|[(),;:&]/
    };
  }
  return rg;
}
var ag, NI;
function MY() {
  if (NI) return ag;
  NI = 1, ag = e, e.displayName = "fsharp", e.aliases = [];
  function e(t) {
    t.languages.fsharp = t.languages.extend("clike", {
      comment: [
        {
          pattern: /(^|[^\\])\(\*(?!\))[\s\S]*?\*\)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|"(?:\\[\s\S]|[^\\"])*")B?/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:exception|inherit|interface|new|of|type)\s+|\w\s*:\s*|\s:\??>\s*)[.\w]+\b(?:\s*(?:->|\*)\s*[.\w]+\b)*(?!\s*[:.])/,
        lookbehind: !0,
        inside: {
          operator: /->|\*/,
          punctuation: /\./
        }
      },
      keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(?:abstract|and|as|asr|assert|atomic|base|begin|break|checked|class|component|const|constraint|constructor|continue|default|delegate|do|done|downcast|downto|eager|elif|else|end|event|exception|extern|external|false|finally|fixed|for|fun|function|functor|global|if|in|include|inherit|inline|interface|internal|land|lazy|lor|lsl|lsr|lxor|match|member|method|mixin|mod|module|mutable|namespace|new|not|null|object|of|open|or|override|parallel|private|process|protected|public|pure|rec|sealed|select|sig|static|struct|tailcall|then|to|trait|true|try|type|upcast|val|virtual|void|volatile|when|while|with)\b/,
      number: [
        /\b0x[\da-fA-F]+(?:LF|lf|un)?\b/,
        /\b0b[01]+(?:uy|y)?\b/,
        /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
        /\b\d+(?:[IlLsy]|UL|u[lsy]?)?\b/
      ],
      operator: /([<>~&^])\1\1|([*.:<>&])\2|<-|->|[!=:]=|<?\|{1,3}>?|\??(?:<=|>=|<>|[-+*/%=<>])\??|[!?^&]|~[+~-]|:>|:\?>?/
    }), t.languages.insertBefore("fsharp", "keyword", {
      preprocessor: {
        pattern: /(^[\t ]*)#.*/m,
        lookbehind: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /(^#)\b(?:else|endif|if|light|line|nowarn)\b/,
            lookbehind: !0,
            alias: "keyword"
          }
        }
      }
    }), t.languages.insertBefore("fsharp", "punctuation", {
      "computation-expression": {
        pattern: /\b[_a-z]\w*(?=\s*\{)/i,
        alias: "keyword"
      }
    }), t.languages.insertBefore("fsharp", "string", {
      annotation: {
        pattern: /\[<.+?>\]/,
        greedy: !0,
        inside: {
          punctuation: /^\[<|>\]$/,
          "class-name": {
            pattern: /^\w+$|(^|;\s*)[A-Z]\w*(?=\()/,
            lookbehind: !0
          },
          "annotation-content": {
            pattern: /[\s\S]+/,
            inside: t.languages.fsharp
          }
        }
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8}))'B?/,
        greedy: !0
      }
    });
  }
  return ag;
}
var ig, OI;
function FY() {
  if (OI) return ig;
  OI = 1;
  var e = Mn();
  ig = t, t.displayName = "ftl", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      for (var a = /[^<()"']|\((?:<expr>)*\)|<(?!#--)|<#--(?:[^-]|-(?!->))*-->|"(?:[^\\"]|\\.)*"|'(?:[^\\']|\\.)*'/.source, i = 0; i < 2; i++)
        a = a.replace(/<expr>/g, function() {
          return a;
        });
      a = a.replace(/<expr>/g, /[^\s\S]/.source);
      var s = {
        comment: /<#--[\s\S]*?-->/,
        string: [
          {
            // raw string
            pattern: /\br("|')(?:(?!\1)[^\\]|\\.)*\1/,
            greedy: !0
          },
          {
            pattern: RegExp(
              /("|')(?:(?!\1|\$\{)[^\\]|\\.|\$\{(?:(?!\})(?:<expr>))*\})*\1/.source.replace(
                /<expr>/g,
                function() {
                  return a;
                }
              )
            ),
            greedy: !0,
            inside: {
              interpolation: {
                pattern: RegExp(
                  /((?:^|[^\\])(?:\\\\)*)\$\{(?:(?!\})(?:<expr>))*\}/.source.replace(
                    /<expr>/g,
                    function() {
                      return a;
                    }
                  )
                ),
                lookbehind: !0,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^\$\{|\}$/,
                    alias: "punctuation"
                  },
                  rest: null
                }
              }
            }
          }
        ],
        keyword: /\b(?:as)\b/,
        boolean: /\b(?:false|true)\b/,
        "builtin-function": {
          pattern: /((?:^|[^?])\?\s*)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        function: /\b\w+(?=\s*\()/,
        number: /\b\d+(?:\.\d+)?\b/,
        operator: /\.\.[<*!]?|->|--|\+\+|&&|\|\||\?{1,2}|[-+*/%!=<>]=?|\b(?:gt|gte|lt|lte)\b/,
        punctuation: /[,;.:()[\]{}]/
      };
      s.string[1].inside.interpolation.inside.rest = s, r.languages.ftl = {
        "ftl-comment": {
          // the pattern is shortened to be more efficient
          pattern: /^<#--[\s\S]*/,
          alias: "comment"
        },
        "ftl-directive": {
          pattern: /^<[\s\S]+>$/,
          inside: {
            directive: {
              pattern: /(^<\/?)[#@][a-z]\w*/i,
              lookbehind: !0,
              alias: "keyword"
            },
            punctuation: /^<\/?|\/?>$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: s
            }
          }
        },
        "ftl-interpolation": {
          pattern: /^\$\{[\s\S]*\}$/,
          inside: {
            punctuation: /^\$\{|\}$/,
            content: {
              pattern: /\s*\S[\s\S]*/,
              alias: "ftl",
              inside: s
            }
          }
        }
      }, r.hooks.add("before-tokenize", function(u) {
        var c = RegExp(
          /<#--[\s\S]*?-->|<\/?[#@][a-zA-Z](?:<expr>)*?>|\$\{(?:<expr>)*?\}/.source.replace(
            /<expr>/g,
            function() {
              return a;
            }
          ),
          "gi"
        );
        r.languages["markup-templating"].buildPlaceholders(
          u,
          "ftl",
          c
        );
      }), r.hooks.add("after-tokenize", function(u) {
        r.languages["markup-templating"].tokenizePlaceholders(u, "ftl");
      });
    }(n);
  }
  return ig;
}
var og, LI;
function PY() {
  if (LI) return og;
  LI = 1, og = e, e.displayName = "gap", e.aliases = [];
  function e(t) {
    t.languages.gap = {
      shell: {
        pattern: /^gap>[\s\S]*?(?=^gap>|$(?![\s\S]))/m,
        greedy: !0,
        inside: {
          gap: {
            pattern: /^(gap>).+(?:(?:\r(?:\n|(?!\n))|\n)>.*)*/,
            lookbehind: !0,
            inside: null
            // see below
          },
          punctuation: /^gap>/
        }
      },
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\'"])(?:'(?:[^\r\n\\']|\\.){1,10}'|"(?:[^\r\n\\"]|\\.)*"(?!")|"""[\s\S]*?""")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          continuation: {
            pattern: /([\r\n])>/,
            lookbehind: !0,
            alias: "punctuation"
          }
        }
      },
      keyword: /\b(?:Assert|Info|IsBound|QUIT|TryNextMethod|Unbind|and|atomic|break|continue|do|elif|else|end|fi|for|function|if|in|local|mod|not|od|or|quit|readonly|readwrite|rec|repeat|return|then|until|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      continuation: {
        pattern: /([\r\n])>/,
        lookbehind: !0,
        alias: "punctuation"
      },
      operator: /->|[-+*/^~=!]|<>|[<>]=?|:=|\.\./,
      punctuation: /[()[\]{},;.:]/
    }, t.languages.gap.shell.inside.gap.inside = t.languages.gap;
  }
  return og;
}
var sg, DI;
function BY() {
  if (DI) return sg;
  DI = 1, sg = e, e.displayName = "gcode", e.aliases = [];
  function e(t) {
    t.languages.gcode = {
      comment: /;.*|\B\(.*?\)\B/,
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      keyword: /\b[GM]\d+(?:\.\d+)?\b/,
      property: /\b[A-Z]/,
      checksum: {
        pattern: /(\*)\d+/,
        lookbehind: !0,
        alias: "number"
      },
      // T0:0:0
      punctuation: /[:*]/
    };
  }
  return sg;
}
var lg, MI;
function $Y() {
  if (MI) return lg;
  MI = 1, lg = e, e.displayName = "gdscript", e.aliases = [];
  function e(t) {
    t.languages.gdscript = {
      comment: /#.*/,
      string: {
        pattern: /@?(?:("|')(?:(?!\1)[^\n\\]|\\[\s\S])*\1(?!"|')|"""(?:[^\\]|\\[\s\S])*?""")/,
        greedy: !0
      },
      "class-name": {
        // class_name Foo, extends Bar, class InnerClass
        // export(int) var baz, export(int, 0) var i
        // as Node
        // const FOO: int = 9, var bar: bool = true
        // func add(reference: Item, amount: int) -> Item:
        pattern: /(^(?:class|class_name|extends)[ \t]+|^export\([ \t]*|\bas[ \t]+|(?:\b(?:const|var)[ \t]|[,(])[ \t]*\w+[ \t]*:[ \t]*|->[ \t]*)[a-zA-Z_]\w*/m,
        lookbehind: !0
      },
      keyword: /\b(?:and|as|assert|break|breakpoint|class|class_name|const|continue|elif|else|enum|export|extends|for|func|if|in|is|master|mastersync|match|not|null|onready|or|pass|preload|puppet|puppetsync|remote|remotesync|return|self|setget|signal|static|tool|var|while|yield)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*\()/i,
      variable: /\$\w+/,
      number: [
        /\b0b[01_]+\b|\b0x[\da-fA-F_]+\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.[\d_]+)(?:e[+-]?[\d_]+)?\b/,
        /\b(?:INF|NAN|PI|TAU)\b/
      ],
      constant: /\b[A-Z][A-Z_\d]*\b/,
      boolean: /\b(?:false|true)\b/,
      operator: /->|:=|&&|\|\||<<|>>|[-+*/%&|!<>=]=?|[~^]/,
      punctuation: /[.:,;()[\]{}]/
    };
  }
  return lg;
}
var ug, FI;
function UY() {
  if (FI) return ug;
  FI = 1, ug = e, e.displayName = "gedcom", e.aliases = [];
  function e(t) {
    t.languages.gedcom = {
      "line-value": {
        // Preceded by level, optional pointer, and tag
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ ).+/m,
        lookbehind: !0,
        inside: {
          pointer: {
            pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
            alias: "variable"
          }
        }
      },
      tag: {
        // Preceded by level and optional pointer
        pattern: /(^[\t ]*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
        lookbehind: !0,
        alias: "string"
      },
      level: {
        pattern: /(^[\t ]*)\d+/m,
        lookbehind: !0,
        alias: "number"
      },
      pointer: {
        pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
        alias: "variable"
      }
    };
  }
  return ug;
}
var cg, PI;
function jY() {
  if (PI) return cg;
  PI = 1, cg = e, e.displayName = "gherkin", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\r?\n|\r)[ \t]*\|.+\|(?:(?!\|).)*/.source;
      n.languages.gherkin = {
        pystring: {
          pattern: /("""|''')[\s\S]+?\1/,
          alias: "string"
        },
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[ \t]*)@\S*/m,
          lookbehind: !0
        },
        feature: {
          pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|Lastnost|Mak|Mogucnost|laH|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|Potrzeba biznesowa|perbogh|poQbogh malja'|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:\r\n]+(?:\r?\n|\r|$))*/,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]+/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        scenario: {
          pattern: /(^[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram Senaryo|Dyagram senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|EXAMPLZ|Examples|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|Grundlage|Hannergrond|ghantoH|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut chovnatlh|lut|lutmey|Lýsing Atburðarásar|Lýsing Dæma|MISHUN SRSLY|MISHUN|Menggariskan Senario|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan Senaryo|Plan senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo Deskripsyon|Senaryo deskripsyon|Senaryo|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie Uiteensetting|Situasie|Skenario konsep|Skenario|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa hwaer swa|Swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo-ho-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/m,
          lookbehind: !0,
          inside: {
            important: {
              pattern: /(:)[^\r\n]*/,
              lookbehind: !0
            },
            keyword: /[^:\r\n]+:/
          }
        },
        "table-body": {
          // Look-behind is used to skip the table head, which has the same format as any table row
          pattern: RegExp("(" + r + ")(?:" + r + ")+"),
          lookbehind: !0,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            },
            td: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "string"
            },
            punctuation: /\|/
          }
        },
        "table-head": {
          pattern: RegExp(r),
          inside: {
            th: {
              pattern: /\s*[^\s|][^|]*/,
              alias: "variable"
            },
            punctuation: /\|/
          }
        },
        atrule: {
          pattern: /(^[ \t]+)(?:'a|'ach|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cand|Cando|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|DEN|Dato|De|Den youse gotta|Dengan|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|E|En|Entonces|Epi|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kad|Kada|Kadar|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Ma|Majd|Maka|Manawa|Mas|Men|Menawa|Mutta|Nalika|Nalikaning|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Och|Og|Oletetaan|Ond|Onda|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|Quan|Quand|Quando|qaSDI'|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|Un|Und|ugeholl|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadan|Zadani|Zadano|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t])/m,
          lookbehind: !0
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
          inside: {
            outline: {
              pattern: /<[^>]+>/,
              alias: "variable"
            }
          }
        },
        outline: {
          pattern: /<[^>]+>/,
          alias: "variable"
        }
      };
    })(t);
  }
  return cg;
}
var dg, BI;
function qY() {
  if (BI) return dg;
  BI = 1, dg = e, e.displayName = "git", e.aliases = [];
  function e(t) {
    t.languages.git = {
      /*
       * A simple one line comment like in a git status command
       * For instance:
       * $ git status
       * # On branch infinite-scroll
       * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
       * # and have 1 and 2 different commits each, respectively.
       * nothing to commit (working directory clean)
       */
      comment: /^#.*/m,
      /*
       * Regexp to match the changed lines in a git diff output. Check the example below.
       */
      deleted: /^[-–].*/m,
      inserted: /^\+.*/m,
      /*
       * a string (double and simple quote)
       */
      string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      /*
       * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
       * For instance:
       * $ git add file.txt
       */
      command: {
        pattern: /^.*\$ git .*$/m,
        inside: {
          /*
           * A git command can contain a parameter starting by a single or a double dash followed by a string
           * For instance:
           * $ git diff --cached
           * $ git log -p
           */
          parameter: /\s--?\w+/
        }
      },
      /*
       * Coordinates displayed in a git diff command
       * For instance:
       * $ git diff
       * diff --git file.txt file.txt
       * index 6214953..1d54a52 100644
       * --- file.txt
       * +++ file.txt
       * @@ -1 +1,2 @@
       * -Here's my tetx file
       * +Here's my text file
       * +And this is the second line
       */
      coord: /^@@.*@@$/m,
      /*
       * Match a "commit [SHA1]" line in a git log output.
       * For instance:
       * $ git log
       * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
       * Author: lgiraudel
       * Date:   Mon Feb 17 11:18:34 2014 +0100
       *
       *     Add of a new line
       */
      "commit-sha1": /^commit \w{40}$/m
    };
  }
  return dg;
}
var pg, $I;
function zY() {
  if ($I) return pg;
  $I = 1;
  var e = Ri();
  pg = t, t.displayName = "glsl", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.glsl = n.languages.extend("c", {
      keyword: /\b(?:active|asm|atomic_uint|attribute|[ibdu]?vec[234]|bool|break|buffer|case|cast|centroid|class|coherent|common|const|continue|d?mat[234](?:x[234])?|default|discard|do|double|else|enum|extern|external|false|filter|fixed|flat|float|for|fvec[234]|goto|half|highp|hvec[234]|[iu]?sampler2DMS(?:Array)?|[iu]?sampler2DRect|[iu]?samplerBuffer|[iu]?samplerCube|[iu]?samplerCubeArray|[iu]?sampler[123]D|[iu]?sampler[12]DArray|[iu]?image2DMS(?:Array)?|[iu]?image2DRect|[iu]?imageBuffer|[iu]?imageCube|[iu]?imageCubeArray|[iu]?image[123]D|[iu]?image[12]DArray|if|in|inline|inout|input|int|interface|invariant|layout|long|lowp|mediump|namespace|noinline|noperspective|out|output|partition|patch|precise|precision|public|readonly|resource|restrict|return|sample|sampler[12]DArrayShadow|sampler[12]DShadow|sampler2DRectShadow|sampler3DRect|samplerCubeArrayShadow|samplerCubeShadow|shared|short|sizeof|smooth|static|struct|subroutine|superp|switch|template|this|true|typedef|uint|uniform|union|unsigned|using|varying|void|volatile|while|writeonly)\b/
    });
  }
  return pg;
}
var fg, UI;
function GY() {
  if (UI) return fg;
  UI = 1, fg = e, e.displayName = "gml", e.aliases = [];
  function e(t) {
    t.languages.gamemakerlanguage = t.languages.gml = t.languages.extend("clike", {
      keyword: /\b(?:break|case|continue|default|do|else|enum|exit|for|globalvar|if|repeat|return|switch|until|var|while)\b/,
      number: /(?:\b0x[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ulf]{0,4}/i,
      operator: /--|\+\+|[-+%/=]=?|!=|\*\*?=?|<[<=>]?|>[=>]?|&&?|\^\^?|\|\|?|~|\b(?:and|at|not|or|with|xor)\b/,
      constant: /\b(?:GM_build_date|GM_version|action_(?:continue|restart|reverse|stop)|all|gamespeed_(?:fps|microseconds)|global|local|noone|other|pi|pointer_(?:invalid|null)|self|timezone_(?:local|utc)|undefined|ev_(?:create|destroy|step|alarm|keyboard|mouse|collision|other|draw|draw_(?:begin|end|post|pre)|keypress|keyrelease|trigger|(?:left|middle|no|right)_button|(?:left|middle|right)_press|(?:left|middle|right)_release|mouse_(?:enter|leave|wheel_down|wheel_up)|global_(?:left|middle|right)_button|global_(?:left|middle|right)_press|global_(?:left|middle|right)_release|joystick(?:1|2)_(?:button1|button2|button3|button4|button5|button6|button7|button8|down|left|right|up)|outside|boundary|game_start|game_end|room_start|room_end|no_more_lives|animation_end|end_of_path|no_more_health|user\d|gui|gui_begin|gui_end|step_(?:begin|end|normal))|vk_(?:alt|anykey|backspace|control|delete|down|end|enter|escape|home|insert|left|nokey|pagedown|pageup|pause|printscreen|return|right|shift|space|tab|up|f\d|numpad\d|add|decimal|divide|lalt|lcontrol|lshift|multiply|ralt|rcontrol|rshift|subtract)|achievement_(?:filter_(?:all_players|favorites_only|friends_only)|friends_info|info|leaderboard_info|our_info|pic_loaded|show_(?:achievement|bank|friend_picker|leaderboard|profile|purchase_prompt|ui)|type_challenge|type_score_challenge)|asset_(?:font|object|path|room|script|shader|sound|sprite|tiles|timeline|unknown)|audio_(?:3d|falloff_(?:exponent_distance|exponent_distance_clamped|inverse_distance|inverse_distance_clamped|linear_distance|linear_distance_clamped|none)|mono|new_system|old_system|stereo)|bm_(?:add|complex|dest_alpha|dest_color|dest_colour|inv_dest_alpha|inv_dest_color|inv_dest_colour|inv_src_alpha|inv_src_color|inv_src_colour|max|normal|one|src_alpha|src_alpha_sat|src_color|src_colour|subtract|zero)|browser_(?:chrome|firefox|ie|ie_mobile|not_a_browser|opera|safari|safari_mobile|tizen|unknown|windows_store)|buffer_(?:bool|f16|f32|f64|fast|fixed|generalerror|grow|invalidtype|network|outofbounds|outofspace|s16|s32|s8|seek_end|seek_relative|seek_start|string|text|u16|u32|u64|u8|vbuffer|wrap)|c_(?:aqua|black|blue|dkgray|fuchsia|gray|green|lime|ltgray|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)|cmpfunc_(?:always|equal|greater|greaterequal|less|lessequal|never|notequal)|cr_(?:appstart|arrow|beam|cross|default|drag|handpoint|hourglass|none|size_all|size_nesw|size_ns|size_nwse|size_we|uparrow)|cull_(?:clockwise|counterclockwise|noculling)|device_(?:emulator|tablet)|device_ios_(?:ipad|ipad_retina|iphone|iphone5|iphone6|iphone6plus|iphone_retina|unknown)|display_(?:landscape|landscape_flipped|portrait|portrait_flipped)|dll_(?:cdecl|cdel|stdcall)|ds_type_(?:grid|list|map|priority|queue|stack)|ef_(?:cloud|ellipse|explosion|firework|flare|rain|ring|smoke|smokeup|snow|spark|star)|fa_(?:archive|bottom|center|directory|hidden|left|middle|readonly|right|sysfile|top|volumeid)|fb_login_(?:default|fallback_to_webview|forcing_safari|forcing_webview|no_fallback_to_webview|use_system_account)|iap_(?:available|canceled|ev_consume|ev_product|ev_purchase|ev_restore|ev_storeload|failed|purchased|refunded|status_available|status_loading|status_processing|status_restoring|status_unavailable|status_uninitialised|storeload_failed|storeload_ok|unavailable)|leaderboard_type_(?:number|time_mins_secs)|lighttype_(?:dir|point)|matrix_(?:projection|view|world)|mb_(?:any|left|middle|none|right)|network_(?:config_(?:connect_timeout|disable_reliable_udp|enable_reliable_udp|use_non_blocking_socket)|socket_(?:bluetooth|tcp|udp)|type_(?:connect|data|disconnect|non_blocking_connect))|of_challenge_(?:lose|tie|win)|os_(?:android|ios|linux|macosx|ps3|ps4|psvita|unknown|uwp|win32|win8native|windows|winphone|xboxone)|phy_debug_render_(?:aabb|collision_pairs|coms|core_shapes|joints|obb|shapes)|phy_joint_(?:anchor_1_x|anchor_1_y|anchor_2_x|anchor_2_y|angle|angle_limits|damping_ratio|frequency|length_1|length_2|lower_angle_limit|max_force|max_length|max_motor_force|max_motor_torque|max_torque|motor_force|motor_speed|motor_torque|reaction_force_x|reaction_force_y|reaction_torque|speed|translation|upper_angle_limit)|phy_particle_data_flag_(?:category|color|colour|position|typeflags|velocity)|phy_particle_flag_(?:colormixing|colourmixing|elastic|powder|spring|tensile|viscous|wall|water|zombie)|phy_particle_group_flag_(?:rigid|solid)|pr_(?:linelist|linestrip|pointlist|trianglefan|trianglelist|trianglestrip)|ps_(?:distr|shape)_(?:diamond|ellipse|gaussian|invgaussian|line|linear|rectangle)|pt_shape_(?:circle|cloud|disk|explosion|flare|line|pixel|ring|smoke|snow|spark|sphere|square|star)|ty_(?:real|string)|gp_(?:face\d|axislh|axislv|axisrh|axisrv|padd|padl|padr|padu|select|shoulderl|shoulderlb|shoulderr|shoulderrb|start|stickl|stickr)|lb_disp_(?:none|numeric|time_ms|time_sec)|lb_sort_(?:ascending|descending|none)|ov_(?:achievements|community|friends|gamegroup|players|settings)|ugc_(?:filetype_(?:community|microtrans)|list_(?:Favorited|Followed|Published|Subscribed|UsedOrPlayed|VotedDown|VotedOn|VotedUp|WillVoteLater)|match_(?:AllGuides|Artwork|Collections|ControllerBindings|IntegratedGuides|Items|Items_Mtx|Items_ReadyToUse|Screenshots|UsableInGame|Videos|WebGuides)|query_(?:AcceptedForGameRankedByAcceptanceDate|CreatedByFriendsRankedByPublicationDate|FavoritedByFriendsRankedByPublicationDate|NotYetRated)|query_RankedBy(?:NumTimesReported|PublicationDate|TextSearch|TotalVotesAsc|Trend|Vote|VotesUp)|result_success|sortorder_CreationOrder(?:Asc|Desc)|sortorder_(?:ForModeration|LastUpdatedDesc|SubscriptionDateDesc|TitleAsc|VoteScoreDesc)|visibility_(?:friends_only|private|public))|vertex_usage_(?:binormal|blendindices|blendweight|color|colour|depth|fog|normal|position|psize|sample|tangent|texcoord|textcoord)|vertex_type_(?:float\d|color|colour|ubyte4)|input_type|layerelementtype_(?:background|instance|oldtilemap|particlesystem|sprite|tile|tilemap|undefined)|se_(?:chorus|compressor|echo|equalizer|flanger|gargle|none|reverb)|text_type|tile_(?:flip|index_mask|mirror|rotate)|(?:obj|rm|scr|spr)\w+)\b/,
      variable: /\b(?:alarm|application_surface|async_load|background_(?:alpha|blend|color|colour|foreground|height|hspeed|htiled|index|showcolor|showcolour|visible|vspeed|vtiled|width|x|xscale|y|yscale)|bbox_(?:bottom|left|right|top)|browser_(?:height|width)|caption_(?:health|lives|score)|current_(?:day|hour|minute|month|second|time|weekday|year)|cursor_sprite|debug_mode|delta_time|direction|display_aa|error_(?:last|occurred)|event_(?:action|number|object|type)|fps|fps_real|friction|game_(?:display|project|save)_(?:id|name)|gamemaker_(?:pro|registered|version)|gravity|gravity_direction|(?:h|v)speed|health|iap_data|id|image_(?:alpha|angle|blend|depth|index|number|speed|xscale|yscale)|instance_(?:count|id)|keyboard_(?:key|lastchar|lastkey|string)|layer|lives|mask_index|mouse_(?:button|lastbutton|x|y)|object_index|os_(?:browser|device|type|version)|path_(?:endaction|index|orientation|position|positionprevious|scale|speed)|persistent|phy_(?:rotation|(?:col_normal|collision|com|linear_velocity|position|speed)_(?:x|y)|angular_(?:damping|velocity)|position_(?:x|y)previous|speed|linear_damping|bullet|fixed_rotation|active|mass|inertia|dynamic|kinematic|sleeping|collision_points)|pointer_(?:invalid|null)|room|room_(?:caption|first|height|last|persistent|speed|width)|score|secure_mode|show_(?:health|lives|score)|solid|speed|sprite_(?:height|index|width|xoffset|yoffset)|temp_directory|timeline_(?:index|loop|position|running|speed)|transition_(?:color|kind|steps)|undefined|view_(?:angle|current|enabled|(?:h|v)(?:border|speed)|(?:h|w|x|y)port|(?:h|w|x|y)view|object|surface_id|visible)|visible|webgl_enabled|working_directory|(?:x|y)(?:previous|start)|x|y|argument(?:_relitive|_count|\d)|argument|global|local|other|self)\b/
    });
  }
  return fg;
}
var gg, jI;
function HY() {
  if (jI) return gg;
  jI = 1, gg = e, e.displayName = "gn", e.aliases = ["gni"];
  function e(t) {
    t.languages.gn = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "string-literal": {
        pattern: /(^|[^\\"])"(?:[^\r\n"\\]|\\.)*"/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[\s\S]*?\}|[a-zA-Z_]\w*|0x[a-fA-F0-9]{2})/,
            lookbehind: !0,
            inside: {
              number: /^\$0x[\s\S]{2}$/,
              variable: /^\$\w+$/,
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: null
                // see below
              }
            }
          },
          string: /[\s\S]+/
        }
      },
      keyword: /\b(?:else|if)\b/,
      boolean: /\b(?:false|true)\b/,
      "builtin-function": {
        // a few functions get special highlighting to improve readability
        pattern: /\b(?:assert|defined|foreach|import|pool|print|template|tool|toolchain)(?=\s*\()/i,
        alias: "keyword"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:current_cpu|current_os|current_toolchain|default_toolchain|host_cpu|host_os|root_build_dir|root_gen_dir|root_out_dir|target_cpu|target_gen_dir|target_os|target_out_dir)\b/,
      number: /-?\b\d+\b/,
      operator: /[-+!=<>]=?|&&|\|\|/,
      punctuation: /[(){}[\],.]/
    }, t.languages.gn["string-literal"].inside.interpolation.inside.expression.inside = t.languages.gn, t.languages.gni = t.languages.gn;
  }
  return gg;
}
var mg, qI;
function VY() {
  if (qI) return mg;
  qI = 1, mg = e, e.displayName = "goModule", e.aliases = [];
  function e(t) {
    t.languages["go-mod"] = t.languages["go-module"] = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      version: {
        pattern: /(^|[\s()[\],])v\d+\.\d+\.\d+(?:[+-][-+.\w]*)?(?![^\s()[\],])/,
        lookbehind: !0,
        alias: "number"
      },
      "go-version": {
        pattern: /((?:^|\s)go\s+)\d+(?:\.\d+){1,2}/,
        lookbehind: !0,
        alias: "number"
      },
      keyword: {
        pattern: /^([ \t]*)(?:exclude|go|module|replace|require|retract)\b/m,
        lookbehind: !0
      },
      operator: /=>/,
      punctuation: /[()[\],]/
    };
  }
  return mg;
}
var hg, zI;
function WY() {
  if (zI) return hg;
  zI = 1, hg = e, e.displayName = "go", e.aliases = [];
  function e(t) {
    t.languages.go = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
      boolean: /\b(?:_|false|iota|nil|true)\b/,
      number: [
        // binary and octal integers
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        // hexadecimal integers and floats
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        // decimal integers and floats
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
      ],
      operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
      builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
    }), t.languages.insertBefore("go", "string", {
      char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: !0
      }
    }), delete t.languages.go["class-name"];
  }
  return hg;
}
var bg, GI;
function KY() {
  if (GI) return bg;
  GI = 1, bg = e, e.displayName = "graphql", e.aliases = [];
  function e(t) {
    t.languages.graphql = {
      comment: /#.*/,
      description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: !0,
        alias: "string",
        inside: {
          "language-markdown": {
            pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: t.languages.markdown
          }
        }
      },
      string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:false|true)\b/,
      variable: /\$[a-z_]\w*/i,
      directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
      },
      "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: !0
      },
      "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
      },
      scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
      constant: /\b[A-Z][A-Z_\d]*\b/,
      "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: !0
      },
      fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
      operator: /[!=|&]|\.{3}/,
      "property-query": /\w+(?=\s*\()/,
      object: /\w+(?=\s*\{)/,
      punctuation: /[!(){}\[\]:=,]/,
      property: /\w+/
    }, t.hooks.add("after-tokenize", function(r) {
      if (r.language !== "graphql")
        return;
      var a = r.tokens.filter(function(x) {
        return typeof x != "string" && x.type !== "comment" && x.type !== "scalar";
      }), i = 0;
      function s(x) {
        return a[i + x];
      }
      function u(x, I) {
        I = I || 0;
        for (var S = 0; S < x.length; S++) {
          var C = s(S + I);
          if (!C || C.type !== x[S])
            return !1;
        }
        return !0;
      }
      function c(x, I) {
        for (var S = 1, C = i; C < a.length; C++) {
          var T = a[C], A = T.content;
          if (T.type === "punctuation" && typeof A == "string") {
            if (x.test(A))
              S++;
            else if (I.test(A) && (S--, S === 0))
              return C;
          }
        }
        return -1;
      }
      function d(x, I) {
        var S = x.alias;
        S ? Array.isArray(S) || (x.alias = S = [S]) : x.alias = S = [], S.push(I);
      }
      for (; i < a.length; ) {
        var p = a[i++];
        if (p.type === "keyword" && p.content === "mutation") {
          var f = [];
          if (u(["definition-mutation", "punctuation"]) && s(1).content === "(") {
            i += 2;
            var m = c(/^\($/, /^\)$/);
            if (m === -1)
              continue;
            for (; i < m; i++) {
              var h = s(0);
              h.type === "variable" && (d(h, "variable-input"), f.push(h.content));
            }
            i = m + 1;
          }
          if (u(["punctuation", "property-query"]) && s(0).content === "{" && (i++, d(s(0), "property-mutation"), f.length > 0)) {
            var E = c(/^\{$/, /^\}$/);
            if (E === -1)
              continue;
            for (var y = i; y < E; y++) {
              var w = a[y];
              w.type === "variable" && f.indexOf(w.content) >= 0 && d(w, "variable-input");
            }
          }
        }
      }
    });
  }
  return bg;
}
var yg, HI;
function YY() {
  if (HI) return yg;
  HI = 1, yg = e, e.displayName = "groovy", e.aliases = [];
  function e(t) {
    t.languages.groovy = t.languages.extend("clike", {
      string: [
        {
          // https://groovy-lang.org/syntax.html#_dollar_slashy_string
          pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/,
          greedy: !0
        },
        {
          // TODO: Slash strings (e.g. /foo/) can contain line breaks but this will cause a lot of trouble with
          // simple division (see JS regex), so find a fix maybe?
          pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        }
      ],
      keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
      number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
        lookbehind: !0
      },
      punctuation: /\.+|[{}[\];(),:$]/
    }), t.languages.insertBefore("groovy", "string", {
      shebang: {
        pattern: /#!.+/,
        alias: "comment"
      }
    }), t.languages.insertBefore("groovy", "punctuation", {
      "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/
    }), t.languages.insertBefore("groovy", "function", {
      annotation: {
        pattern: /(^|[^.])@\w+/,
        lookbehind: !0,
        alias: "punctuation"
      }
    }), t.hooks.add("wrap", function(n) {
      if (n.language === "groovy" && n.type === "string") {
        var r = n.content.value[0];
        if (r != "'") {
          var a = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
          r === "$" && (a = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/), n.content.value = n.content.value.replace(/&lt;/g, "<").replace(/&amp;/g, "&"), n.content = t.highlight(n.content.value, {
            expression: {
              pattern: a,
              lookbehind: !0,
              inside: t.languages.groovy
            }
          }), n.classes.push(r === "/" ? "regex" : "gstring");
        }
      }
    });
  }
  return yg;
}
var vg, VI;
function XY() {
  if (VI) return vg;
  VI = 1;
  var e = dc();
  vg = t, t.displayName = "haml", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.haml = {
        // Multiline stuff should appear before the rest
        "multiline-comment": {
          pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ].+)*/,
          lookbehind: !0,
          alias: "comment"
        },
        "multiline-code": [
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ].*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ].+)/,
            lookbehind: !0,
            inside: r.languages.ruby
          },
          {
            pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ].*\|[\t ]*)*/,
            lookbehind: !0,
            inside: r.languages.ruby
          }
        ],
        // See at the end of the file for known filters
        filter: {
          pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            }
          }
        },
        markup: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
          lookbehind: !0,
          inside: r.languages.markup
        },
        doctype: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
          lookbehind: !0
        },
        tag: {
          // Allows for one nested group of braces
          pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^{}])+\}|\[[^\]]+\])*[\/<>]*/,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                // Lookbehind tries to prevent interpolations from breaking it all
                // Allows for one nested group of braces
                pattern: /(^|[^#])\{(?:\{[^}]+\}|[^{}])+\}/,
                lookbehind: !0,
                inside: r.languages.ruby
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                    lookbehind: !0
                  },
                  "attr-name": /[\w:-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[=(),]/
                }
              },
              {
                pattern: /\[[^\]]+\]/,
                inside: r.languages.ruby
              }
            ],
            punctuation: /[<>]/
          }
        },
        code: {
          pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
          lookbehind: !0,
          inside: r.languages.ruby
        },
        // Interpolations in plain text
        interpolation: {
          pattern: /#\{[^}]+\}/,
          inside: {
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            },
            ruby: {
              pattern: /[\s\S]+/,
              inside: r.languages.ruby
            }
          }
        },
        punctuation: {
          pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
          lookbehind: !0
        }
      };
      for (var a = "((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ].+|\\s*?(?=\\r?\\n|\\r)))+", i = [
        "css",
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "erb",
        "javascript",
        "less",
        "markdown",
        "ruby",
        "scss",
        "textile"
      ], s = {}, u = 0, c = i.length; u < c; u++) {
        var d = i[u];
        d = typeof d == "string" ? {
          filter: d,
          language: d
        } : d, r.languages[d.language] && (s["filter-" + d.filter] = {
          pattern: RegExp(
            a.replace("{{filter_name}}", function() {
              return d.filter;
            })
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "symbol"
            },
            text: {
              pattern: /[\s\S]+/,
              alias: [d.language, "language-" + d.language],
              inside: r.languages[d.language]
            }
          }
        });
      }
      r.languages.insertBefore("haml", "filter", s);
    }(n);
  }
  return vg;
}
var Eg, WI;
function ZY() {
  if (WI) return Eg;
  WI = 1;
  var e = Mn();
  Eg = t, t.displayName = "handlebars", t.aliases = ["hbs"];
  function t(n) {
    n.register(e), function(r) {
      r.languages.handlebars = {
        comment: /\{\{![\s\S]*?\}\}/,
        delimiter: {
          pattern: /^\{\{\{?|\}\}\}?$/,
          alias: "punctuation"
        },
        string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
        boolean: /\b(?:false|true)\b/,
        block: {
          pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
          lookbehind: !0,
          alias: "keyword"
        },
        brackets: {
          pattern: /\[[^\]]+\]/,
          inside: {
            punctuation: /\[|\]/,
            variable: /[\s\S]+/
          }
        },
        punctuation: /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
        variable: /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
      }, r.hooks.add("before-tokenize", function(a) {
        var i = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "handlebars",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(
          a,
          "handlebars"
        );
      }), r.languages.hbs = r.languages.handlebars;
    }(n);
  }
  return Eg;
}
var Sg, KI;
function Bv() {
  if (KI) return Sg;
  KI = 1, Sg = e, e.displayName = "haskell", e.aliases = ["hs"];
  function e(t) {
    t.languages.haskell = {
      comment: {
        pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--(?:(?=.)[^-!#$%*+=?&@|~.:<>^\\\/].*|$)|\{-[\s\S]*?-\})/m,
        lookbehind: !0
      },
      char: {
        pattern: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|ACK|BEL|BS|CAN|CR|DC1|DC2|DC3|DC4|DEL|DLE|EM|ENQ|EOT|ESC|ETB|ETX|FF|FS|GS|HT|LF|NAK|NUL|RS|SI|SO|SOH|SP|STX|SUB|SYN|US|VT|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
        alias: "string"
      },
      string: {
        pattern: /"(?:[^\\"]|\\(?:\S|\s+\\))*"/,
        greedy: !0
      },
      keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import|qualified)\b/,
          punctuation: /\./
        }
      },
      // These are builtin variables only. Constructors are highlighted later as a constant.
      builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
      // decimal integers and floating point numbers | octal integers | hexadecimal integers
      number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
      operator: [
        {
          // infix operator
          pattern: /`(?:[A-Z][\w']*\.)*[_a-z][\w']*`/,
          greedy: !0
        },
        {
          // function composition
          pattern: /(\s)\.(?=\s)/,
          lookbehind: !0
        },
        // Most of this is needed because of the meaning of a single '.'.
        // If it stands alone freely, it is the function composition.
        // It may also be a separator between a module name and an identifier => no
        // operator. If it comes together with other special characters it is an
        // operator too.
        //
        // This regex means: /[-!#$%*+=?&@|~.:<>^\\\/]+/ without /\./.
        /[-!#$%*+=?&@|~:<>^\\\/][-!#$%*+=?&@|~.:<>^\\\/]*|\.[-!#$%*+=?&@|~.:<>^\\\/]+/
      ],
      // In Haskell, nearly everything is a variable, do not highlight these.
      hvariable: {
        pattern: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      constant: {
        pattern: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /[{}[\];(),.:]/
    }, t.languages.hs = t.languages.haskell;
  }
  return Sg;
}
var xg, YI;
function JY() {
  if (YI) return xg;
  YI = 1, xg = e, e.displayName = "haxe", e.aliases = [];
  function e(t) {
    t.languages.haxe = t.languages.extend("clike", {
      string: {
        // Strings can be multi-line
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      "class-name": [
        {
          pattern: /(\b(?:abstract|class|enum|extends|implements|interface|new|typedef)\s+)[A-Z_]\w*/,
          lookbehind: !0
        },
        // based on naming convention
        /\b[A-Z]\w*/
      ],
      // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
      keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|final|for|from|function|if|implements|import|in|inline|interface|macro|new|null|operator|overload|override|package|private|public|return|static|super|switch|throw|to|try|typedef|untyped|using|var|while)(?!\.)\b/,
      function: {
        pattern: /\b[a-z_]\w*(?=\s*(?:<[^<>]*>\s*)?\()/i,
        greedy: !0
      },
      operator: /\.{3}|\+\+|--|&&|\|\||->|=>|(?:<<?|>{1,3}|[-+*/%!=&|^])=?|[?:~]/
    }), t.languages.insertBefore("haxe", "string", {
      "string-interpolation": {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^\\])\$(?:\w+|\{[^{}]+\})/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{?|\}$/,
                alias: "punctuation"
              },
              expression: {
                pattern: /[\s\S]+/,
                inside: t.languages.haxe
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("haxe", "class-name", {
      regex: {
        pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[a-z]*/,
        greedy: !0,
        inside: {
          "regex-flags": /\b[a-z]+$/,
          "regex-source": {
            pattern: /^(~\/)[\s\S]+(?=\/$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^~\/|\/$/
        }
      }
    }), t.languages.insertBefore("haxe", "keyword", {
      preprocessor: {
        pattern: /#(?:else|elseif|end|if)\b.*/,
        alias: "property"
      },
      metadata: {
        pattern: /@:?[\w.]+/,
        alias: "symbol"
      },
      reification: {
        pattern: /\$(?:\w+|(?=\{))/,
        alias: "important"
      }
    });
  }
  return xg;
}
var Tg, XI;
function QY() {
  if (XI) return Tg;
  XI = 1, Tg = e, e.displayName = "hcl", e.aliases = [];
  function e(t) {
    t.languages.hcl = {
      comment: /(?:\/\/|#).*|\/\*[\s\S]*?(?:\*\/|$)/,
      heredoc: {
        pattern: /<<-?(\w+\b)[\s\S]*?^[ \t]*\1/m,
        greedy: !0,
        alias: "string"
      },
      keyword: [
        {
          pattern: /(?:data|resource)\s+(?:"(?:\\[\s\S]|[^\\"])*")(?=\s+"[\w-]+"\s+\{)/i,
          inside: {
            type: {
              pattern: /(resource|data|\s+)(?:"(?:\\[\s\S]|[^\\"])*")/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        {
          pattern: /(?:backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+(?=\{)/i,
          inside: {
            type: {
              pattern: /(backend|module|output|provider|provisioner|variable)\s+(?:[\w-]+|"(?:\\[\s\S]|[^\\"])*")\s+/i,
              lookbehind: !0,
              alias: "variable"
            }
          }
        },
        /[\w-]+(?=\s+\{)/
      ],
      property: [/[-\w\.]+(?=\s*=(?!=))/, /"(?:\\[\s\S]|[^\\"])+"(?=\s*[:=])/],
      string: {
        pattern: /"(?:[^\\$"]|\\[\s\S]|\$(?:(?=")|\$+(?!\$)|[^"${])|\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\})*"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /(^|[^$])\$\{(?:[^{}"]|"(?:[^\\"]|\\[\s\S])*")*\}/,
            lookbehind: !0,
            inside: {
              type: {
                pattern: /(\b(?:count|data|local|module|path|self|terraform|var)\b\.)[\w\*]+/i,
                lookbehind: !0,
                alias: "variable"
              },
              keyword: /\b(?:count|data|local|module|path|self|terraform|var)\b/i,
              function: /\w+(?=\()/,
              string: {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: !0
              },
              number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
              punctuation: /[!\$#%&'()*+,.\/;<=>@\[\\\]^`{|}~?:]/
            }
          }
        }
      },
      number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      boolean: /\b(?:false|true)\b/i,
      punctuation: /[=\[\]{}]/
    };
  }
  return Tg;
}
var wg, ZI;
function e8() {
  if (ZI) return wg;
  ZI = 1;
  var e = Ri();
  wg = t, t.displayName = "hlsl", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.hlsl = n.languages.extend("c", {
      // Regarding keywords and class names:
      // The list of all keywords was split into 'keyword' and 'class-name' tokens based on whether they are capitalized.
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-keywords
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-reserved-words
      "class-name": [
        n.languages.c["class-name"],
        /\b(?:AppendStructuredBuffer|BlendState|Buffer|ByteAddressBuffer|CompileShader|ComputeShader|ConsumeStructuredBuffer|DepthStencilState|DepthStencilView|DomainShader|GeometryShader|Hullshader|InputPatch|LineStream|OutputPatch|PixelShader|PointStream|RWBuffer|RWByteAddressBuffer|RWStructuredBuffer|RWTexture(?:1D|1DArray|2D|2DArray|3D)|RasterizerState|RenderTargetView|SamplerComparisonState|SamplerState|StructuredBuffer|Texture(?:1D|1DArray|2D|2DArray|2DMS|2DMSArray|3D|Cube|CubeArray)|TriangleStream|VertexShader)\b/
      ],
      keyword: [
        // HLSL keyword
        /\b(?:asm|asm_fragment|auto|break|case|catch|cbuffer|centroid|char|class|column_major|compile|compile_fragment|const|const_cast|continue|default|delete|discard|do|dynamic_cast|else|enum|explicit|export|extern|for|friend|fxgroup|goto|groupshared|if|in|inline|inout|interface|line|lineadj|linear|long|matrix|mutable|namespace|new|nointerpolation|noperspective|operator|out|packoffset|pass|pixelfragment|point|precise|private|protected|public|register|reinterpret_cast|return|row_major|sample|sampler|shared|short|signed|sizeof|snorm|stateblock|stateblock_state|static|static_cast|string|struct|switch|tbuffer|technique|technique10|technique11|template|texture|this|throw|triangle|triangleadj|try|typedef|typename|uniform|union|unorm|unsigned|using|vector|vertexfragment|virtual|void|volatile|while)\b/,
        // scalar, vector, and matrix types
        /\b(?:bool|double|dword|float|half|int|min(?:10float|12int|16(?:float|int|uint))|uint)(?:[1-4](?:x[1-4])?)?\b/
      ],
      // https://docs.microsoft.com/en-us/windows/win32/direct3dhlsl/dx-graphics-hlsl-appendix-grammar#floating-point-numbers
      number: /(?:(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?|\b0x[\da-fA-F]+)[fFhHlLuU]?\b/,
      boolean: /\b(?:false|true)\b/
    });
  }
  return wg;
}
var Ag, JI;
function t8() {
  if (JI) return Ag;
  JI = 1, Ag = e, e.displayName = "hoon", e.aliases = [];
  function e(t) {
    t.languages.hoon = {
      comment: {
        pattern: /::.*/,
        greedy: !0
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      constant: /%(?:\.[ny]|[\w-]+)/,
      "class-name": /@(?:[a-z0-9-]*[a-z0-9])?|\*/i,
      function: /(?:\+[-+] {2})?(?:[a-z](?:[a-z0-9-]*[a-z0-9])?)/,
      keyword: /\.[\^\+\*=\?]|![><:\.=\?!]|=[>|:,\.\-\^<+;/~\*\?]|\?[>|:\.\-\^<\+&~=@!]|\|[\$_%:\.\-\^~\*=@\?]|\+[|\$\+\*]|:[_\-\^\+~\*]|%[_:\.\-\^\+~\*=]|\^[|:\.\-\+&~\*=\?]|\$[|_%:<>\-\^&~@=\?]|;[:<\+;\/~\*=]|~[>|\$_%<\+\/&=\?!]|--|==/
    };
  }
  return Ag;
}
var Ig, QI;
function n8() {
  if (QI) return Ig;
  QI = 1, Ig = e, e.displayName = "hpkp", e.aliases = [];
  function e(t) {
    t.languages.hpkp = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|pin-sha256|preload|report-to|report-uri|strict)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return Ig;
}
var Rg, eR;
function r8() {
  if (eR) return Rg;
  eR = 1, Rg = e, e.displayName = "hsts", e.aliases = [];
  function e(t) {
    t.languages.hsts = {
      directive: {
        pattern: /\b(?:includeSubDomains|max-age|preload)(?=[\s;=]|$)/i,
        alias: "property"
      },
      operator: /=/,
      punctuation: /;/
    };
  }
  return Rg;
}
var _g, tR;
function a8() {
  if (tR) return _g;
  tR = 1, _g = e, e.displayName = "http", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(f) {
        return RegExp("(^(?:" + f + "):[ 	]*(?![ 	]))[^]+", "i");
      }
      n.languages.http = {
        "request-line": {
          pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
          inside: {
            // HTTP Method
            method: {
              pattern: /^[A-Z]+\b/,
              alias: "property"
            },
            // Request Target e.g. http://example.com, /path/to/file
            "request-target": {
              pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
              lookbehind: !0,
              alias: "url",
              inside: n.languages.uri
            },
            // HTTP Version
            "http-version": {
              pattern: /^(\s)HTTP\/[\d.]+/,
              lookbehind: !0,
              alias: "property"
            }
          }
        },
        "response-status": {
          pattern: /^HTTP\/[\d.]+ \d+ .+/m,
          inside: {
            // HTTP Version
            "http-version": {
              pattern: /^HTTP\/[\d.]+/,
              alias: "property"
            },
            // Status Code
            "status-code": {
              pattern: /^(\s)\d+(?=\s)/,
              lookbehind: !0,
              alias: "number"
            },
            // Reason Phrase
            "reason-phrase": {
              pattern: /^(\s).+/,
              lookbehind: !0,
              alias: "string"
            }
          }
        },
        header: {
          pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
          inside: {
            "header-value": [
              {
                pattern: r(/Content-Security-Policy/.source),
                lookbehind: !0,
                alias: ["csp", "languages-csp"],
                inside: n.languages.csp
              },
              {
                pattern: r(/Public-Key-Pins(?:-Report-Only)?/.source),
                lookbehind: !0,
                alias: ["hpkp", "languages-hpkp"],
                inside: n.languages.hpkp
              },
              {
                pattern: r(/Strict-Transport-Security/.source),
                lookbehind: !0,
                alias: ["hsts", "languages-hsts"],
                inside: n.languages.hsts
              },
              {
                pattern: r(/[^:]+/.source),
                lookbehind: !0
              }
            ],
            "header-name": {
              pattern: /^[^:]+/,
              alias: "keyword"
            },
            punctuation: /^:/
          }
        }
      };
      var a = n.languages, i = {
        "application/javascript": a.javascript,
        "application/json": a.json || a.javascript,
        "application/xml": a.xml,
        "text/xml": a.xml,
        "text/html": a.html,
        "text/css": a.css,
        "text/plain": a.plain
      }, s = {
        "application/json": !0,
        "application/xml": !0
      };
      function u(f) {
        var m = f.replace(/^[a-z]+\//, ""), h = "\\w+/(?:[\\w.-]+\\+)+" + m + "(?![+\\w.-])";
        return "(?:" + f + "|" + h + ")";
      }
      var c;
      for (var d in i)
        if (i[d]) {
          c = c || {};
          var p = s[d] ? u(d) : d;
          c[d.replace(/\//g, "-")] = {
            pattern: RegExp(
              "(" + /content-type:\s*/.source + p + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ")" + // This is a little interesting:
              // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
              // However, when writing code by hand (e.g. to display on a website) people can forget about this,
              // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
              // the body does not start with a [\w-] character (as headers do).
              /[^ \t\w-][\s\S]*/.source,
              "i"
            ),
            lookbehind: !0,
            inside: i[d]
          };
        }
      c && n.languages.insertBefore("http", "header", c);
    })(t);
  }
  return _g;
}
var Cg, nR;
function i8() {
  if (nR) return Cg;
  nR = 1, Cg = e, e.displayName = "ichigojam", e.aliases = [];
  function e(t) {
    t.languages.ichigojam = {
      comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
      string: {
        pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^\w +\-.])*"/,
        greedy: !0
      },
      number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i,
      keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GOTO|GSB|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RIGHT|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
      function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
      label: /(?:\B@\S+)/,
      operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
      punctuation: /[\[,;:()\]]/
    };
  }
  return Cg;
}
var kg, rR;
function o8() {
  if (rR) return kg;
  rR = 1, kg = e, e.displayName = "icon", e.aliases = [];
  function e(t) {
    t.languages.icon = {
      comment: /#.*/,
      string: {
        pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
        greedy: !0
      },
      number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
      "builtin-keyword": {
        pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
        alias: "variable"
      },
      directive: {
        pattern: /\$\w+/,
        alias: "builtin"
      },
      keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
      function: /\b(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
      operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
      punctuation: /[\[\](){},;]/
    };
  }
  return kg;
}
var Ng, aR;
function s8() {
  if (aR) return Ng;
  aR = 1, Ng = e, e.displayName = "icuMessageFormat", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(d, p) {
        return p <= 0 ? /[]/.source : d.replace(/<SELF>/g, function() {
          return r(d, p - 1);
        });
      }
      var a = /'[{}:=,](?:[^']|'')*'(?!')/, i = {
        pattern: /''/,
        greedy: !0,
        alias: "operator"
      }, s = {
        pattern: a,
        greedy: !0,
        inside: {
          escape: i
        }
      }, u = r(
        /\{(?:[^{}']|'(?![{},'])|''|<STR>|<SELF>)*\}/.source.replace(
          /<STR>/g,
          function() {
            return a.source;
          }
        ),
        8
      ), c = {
        pattern: RegExp(u),
        inside: {
          message: {
            pattern: /^(\{)[\s\S]+(?=\}$)/,
            lookbehind: !0,
            inside: null
            // see below
          },
          "message-delimiter": {
            pattern: /./,
            alias: "punctuation"
          }
        }
      };
      n.languages["icu-message-format"] = {
        argument: {
          pattern: RegExp(u),
          greedy: !0,
          inside: {
            content: {
              pattern: /^(\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: {
                "argument-name": {
                  pattern: /^(\s*)[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "choice-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4c/classicu_1_1ChoiceFormat.html#details
                  pattern: /^(\s*,\s*choice\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    punctuation: /\|/,
                    range: {
                      pattern: /^(\s*)[+-]?(?:\d+(?:\.\d*)?|\u221e)\s*[<#\u2264]/,
                      lookbehind: !0,
                      inside: {
                        operator: /[<#\u2264]/,
                        number: /\S+/
                      }
                    },
                    rest: null
                    // see below
                  }
                },
                "plural-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/PluralFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*(?:plural|selectordinal)\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    offset: /^offset:\s*\d+/,
                    "nested-message": c,
                    selector: {
                      pattern: /=\d+|[^{}:=,\s]+/,
                      inside: {
                        keyword: /^(?:few|many|one|other|two|zero)$/
                      }
                    }
                  }
                },
                "select-style": {
                  // https://unicode-org.github.io/icu-docs/apidoc/released/icu4j/com/ibm/icu/text/SelectFormat.html#:~:text=Patterns%20and%20Their%20Interpretation
                  pattern: /^(\s*,\s*select\s*,\s*)\S(?:[\s\S]*\S)?/,
                  lookbehind: !0,
                  inside: {
                    "nested-message": c,
                    selector: {
                      pattern: /[^{}:=,\s]+/,
                      inside: {
                        keyword: /^other$/
                      }
                    }
                  }
                },
                keyword: /\b(?:choice|plural|select|selectordinal)\b/,
                "arg-type": {
                  pattern: /\b(?:date|duration|number|ordinal|spellout|time)\b/,
                  alias: "keyword"
                },
                "arg-skeleton": {
                  pattern: /(,\s*)::[^{}:=,\s]+/,
                  lookbehind: !0
                },
                "arg-style": {
                  pattern: /(,\s*)(?:currency|full|integer|long|medium|percent|short)(?=\s*$)/,
                  lookbehind: !0
                },
                "arg-style-text": {
                  pattern: RegExp(
                    /(^\s*,\s*(?=\S))/.source + r(/(?:[^{}']|'[^']*'|\{(?:<SELF>)?\})+/.source, 8) + "$"
                  ),
                  lookbehind: !0,
                  alias: "string"
                },
                punctuation: /,/
              }
            },
            "argument-delimiter": {
              pattern: /./,
              alias: "operator"
            }
          }
        },
        escape: i,
        string: s
      }, c.inside.message.inside = n.languages["icu-message-format"], n.languages["icu-message-format"].argument.inside.content.inside["choice-style"].inside.rest = n.languages["icu-message-format"];
    })(t);
  }
  return Ng;
}
var Og, iR;
function l8() {
  if (iR) return Og;
  iR = 1;
  var e = Bv();
  Og = t, t.displayName = "idris", t.aliases = ["idr"];
  function t(n) {
    n.register(e), n.languages.idris = n.languages.extend("haskell", {
      comment: {
        pattern: /(?:(?:--|\|\|\|).*$|\{-[\s\S]*?-\})/m
      },
      keyword: /\b(?:Type|case|class|codata|constructor|corecord|data|do|dsl|else|export|if|implementation|implicit|import|impossible|in|infix|infixl|infixr|instance|interface|let|module|mutual|namespace|of|parameters|partial|postulate|private|proof|public|quoteGoal|record|rewrite|syntax|then|total|using|where|with)\b/,
      builtin: void 0
    }), n.languages.insertBefore("idris", "keyword", {
      "import-statement": {
        pattern: /(^\s*import\s+)(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      }
    }), n.languages.idr = n.languages.idris;
  }
  return Og;
}
var Lg, oR;
function u8() {
  if (oR) return Lg;
  oR = 1, Lg = e, e.displayName = "iecst", e.aliases = [];
  function e(t) {
    t.languages.iecst = {
      comment: [
        {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\(\*[\s\S]*?(?:\*\)|$)|\{[\s\S]*?(?:\}|$))/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: [
        /\b(?:END_)?(?:PROGRAM|CONFIGURATION|INTERFACE|FUNCTION_BLOCK|FUNCTION|ACTION|TRANSITION|TYPE|STRUCT|(?:INITIAL_)?STEP|NAMESPACE|LIBRARY|CHANNEL|FOLDER|RESOURCE|VAR_(?:ACCESS|CONFIG|EXTERNAL|GLOBAL|INPUT|IN_OUT|OUTPUT|TEMP)|VAR|METHOD|PROPERTY)\b/i,
        /\b(?:AT|BY|(?:END_)?(?:CASE|FOR|IF|REPEAT|WHILE)|CONSTANT|CONTINUE|DO|ELSE|ELSIF|EXIT|EXTENDS|FROM|GET|GOTO|IMPLEMENTS|JMP|NON_RETAIN|OF|PRIVATE|PROTECTED|PUBLIC|RETAIN|RETURN|SET|TASK|THEN|TO|UNTIL|USING|WITH|__CATCH|__ENDTRY|__FINALLY|__TRY)\b/
      ],
      "class-name": /\b(?:ANY|ARRAY|BOOL|BYTE|U?(?:D|L|S)?INT|(?:D|L)?WORD|DATE(?:_AND_TIME)?|DT|L?REAL|POINTER|STRING|TIME(?:_OF_DAY)?|TOD)\b/,
      address: {
        pattern: /%[IQM][XBWDL][\d.]*|%[IQ][\d.]*/,
        alias: "symbol"
      },
      number: /\b(?:16#[\da-f]+|2#[01_]+|0x[\da-f]+)\b|\b(?:D|DT|T|TOD)#[\d_shmd:]*|\b[A-Z]*#[\d.,_]*|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      boolean: /\b(?:FALSE|NULL|TRUE)\b/,
      operator: /S?R?:?=>?|&&?|\*\*?|<[=>]?|>=?|[-:^/+#]|\b(?:AND|EQ|EXPT|GE|GT|LE|LT|MOD|NE|NOT|OR|XOR)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      punctuation: /[()[\].,;]/
    };
  }
  return Lg;
}
var Dg, sR;
function c8() {
  if (sR) return Dg;
  sR = 1, Dg = e, e.displayName = "ignore", e.aliases = ["gitignore", "hgignore", "npmignore"];
  function e(t) {
    (function(n) {
      n.languages.ignore = {
        // https://git-scm.com/docs/gitignore
        comment: /^#.*/m,
        entry: {
          pattern: /\S(?:.*(?:(?:\\ )|\S))?/,
          alias: "string",
          inside: {
            operator: /^!|\*\*?|\?/,
            regex: {
              pattern: /(^|[^\\])\[[^\[\]]*\]/,
              lookbehind: !0
            },
            punctuation: /\//
          }
        }
      }, n.languages.gitignore = n.languages.ignore, n.languages.hgignore = n.languages.ignore, n.languages.npmignore = n.languages.ignore;
    })(t);
  }
  return Dg;
}
var Mg, lR;
function d8() {
  if (lR) return Mg;
  lR = 1, Mg = e, e.displayName = "inform7", e.aliases = [];
  function e(t) {
    t.languages.inform7 = {
      string: {
        pattern: /"[^"]*"/,
        inside: {
          substitution: {
            pattern: /\[[^\[\]]+\]/,
            inside: {
              delimiter: {
                pattern: /\[|\]/,
                alias: "punctuation"
              }
              // See rest below
            }
          }
        }
      },
      comment: {
        pattern: /\[[^\[\]]+\]/,
        greedy: !0
      },
      title: {
        pattern: /^[ \t]*(?:book|chapter|part(?! of)|section|table|volume)\b.+/im,
        alias: "important"
      },
      number: {
        pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?(?:(?!\d)\w+)?|\b(?:eight|eleven|five|four|nine|one|seven|six|ten|three|twelve|two))\b(?!-)/i,
        lookbehind: !0
      },
      verb: {
        pattern: /(^|[^-])\b(?:answering|applying to|are|asking|attacking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:ing|s)?|consulting|contain(?:ing|s)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:s|ve|ving)|hold(?:ing|s)?|impl(?:ies|y)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:ing|s)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:ing|s)?|setting|showing|singing|sleeping|smelling|squeezing|support(?:ing|s)?|swearing|switching|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:ing|s)?|var(?:ies|y|ying)|waiting|waking|waving|wear(?:ing|s)?)\b(?!-)/i,
        lookbehind: !0,
        alias: "operator"
      },
      keyword: {
        pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|the story|unless)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
        lookbehind: !0
      },
      property: {
        pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: off| on)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
        lookbehind: !0,
        alias: "symbol"
      },
      position: {
        pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
        lookbehind: !0,
        alias: "keyword"
      },
      type: {
        pattern: /(^|[^-])\b(?:actions?|activit(?:ies|y)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
        lookbehind: !0,
        alias: "variable"
      },
      punctuation: /[.,:;(){}]/
    }, t.languages.inform7.string.inside.substitution.inside.rest = t.languages.inform7, t.languages.inform7.string.inside.substitution.inside.rest.text = {
      pattern: /\S(?:\s*\S)*/,
      alias: "comment"
    };
  }
  return Mg;
}
var Fg, uR;
function p8() {
  if (uR) return Fg;
  uR = 1, Fg = e, e.displayName = "ini", e.aliases = [];
  function e(t) {
    t.languages.ini = {
      /**
       * The component mimics the behavior of the Win32 API parser.
       *
       * @see {@link https://github.com/PrismJS/prism/issues/2775#issuecomment-787477723}
       */
      comment: {
        pattern: /(^[ \f\t\v]*)[#;][^\n\r]*/m,
        lookbehind: !0
      },
      section: {
        pattern: /(^[ \f\t\v]*)\[[^\n\r\]]*\]?/m,
        lookbehind: !0,
        inside: {
          "section-name": {
            pattern: /(^\[[ \f\t\v]*)[^ \f\t\v\]]+(?:[ \f\t\v]+[^ \f\t\v\]]+)*/,
            lookbehind: !0,
            alias: "selector"
          },
          punctuation: /\[|\]/
        }
      },
      key: {
        pattern: /(^[ \f\t\v]*)[^ \f\n\r\t\v=]+(?:[ \f\t\v]+[^ \f\n\r\t\v=]+)*(?=[ \f\t\v]*=)/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      value: {
        pattern: /(=[ \f\t\v]*)[^ \f\n\r\t\v]+(?:[ \f\t\v]+[^ \f\n\r\t\v]+)*/,
        lookbehind: !0,
        alias: "attr-value",
        inside: {
          "inner-value": {
            pattern: /^("|').+(?=\1$)/,
            lookbehind: !0
          }
        }
      },
      punctuation: /=/
    };
  }
  return Fg;
}
var Pg, cR;
function f8() {
  if (cR) return Pg;
  cR = 1, Pg = e, e.displayName = "io", e.aliases = [];
  function e(t) {
    t.languages.io = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?(?:\*\/|$)|\/\/.*|#.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "triple-quoted-string": {
        pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /"(?:\\.|[^\\\r\n"])*"/,
        greedy: !0
      },
      keyword: /\b(?:activate|activeCoroCount|asString|block|break|call|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getEnvironmentVariable|getSlot|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
      builtin: /\b(?:Array|AudioDevice|AudioMixer|BigNum|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Random|Regex|SGML|SGMLElement|SGMLParser|SQLite|Sequence|Server|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink)\b/,
      boolean: /\b(?:false|nil|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e-?\d+)?/i,
      operator: /[=!*/%+\-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|\b(?:and|not|or|return)\b|@@?|\?\??|\.\./,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return Pg;
}
var Bg, dR;
function g8() {
  if (dR) return Bg;
  dR = 1, Bg = e, e.displayName = "j", e.aliases = [];
  function e(t) {
    t.languages.j = {
      comment: {
        pattern: /\bNB\..*/,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      keyword: /\b(?:(?:CR|LF|adverb|conjunction|def|define|dyad|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
      verb: {
        // Negative look-ahead prevents bad highlighting
        // of ^: ;. =. =: !. !:
        pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
        alias: "keyword"
      },
      number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:ad|ar|[ejpx])_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_\b(?!\.))/,
      adverb: {
        pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
        alias: "builtin"
      },
      operator: /[=a][.:]|_\./,
      conjunction: {
        pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
        alias: "variable"
      },
      punctuation: /[()]/
    };
  }
  return Bg;
}
var $g, pR;
function $v() {
  if (pR) return $g;
  pR = 1, $g = e, e.displayName = "java", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, a = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, i = {
        pattern: RegExp(a + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: !0,
        inside: {
          namespace: {
            pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /\./
        }
      };
      n.languages.java = n.languages.extend("clike", {
        string: {
          pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
          lookbehind: !0,
          greedy: !0
        },
        "class-name": [
          i,
          {
            // variables and parameters
            // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
            pattern: RegExp(
              a + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source
            ),
            lookbehind: !0,
            inside: i.inside
          }
        ],
        keyword: r,
        function: [
          n.languages.clike.function,
          {
            pattern: /(::\s*)[a-z_]\w*/,
            lookbehind: !0
          }
        ],
        number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        operator: {
          pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
          lookbehind: !0
        }
      }), n.languages.insertBefore("java", "string", {
        "triple-quoted-string": {
          // http://openjdk.java.net/jeps/355#Description
          pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
          greedy: !0,
          alias: "string"
        },
        char: {
          pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
          greedy: !0
        }
      }), n.languages.insertBefore("java", "class-name", {
        annotation: {
          pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
          lookbehind: !0,
          alias: "punctuation"
        },
        generics: {
          pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
          inside: {
            "class-name": i,
            keyword: r,
            punctuation: /[<>(),.:]/,
            operator: /[?&|]/
          }
        },
        namespace: {
          pattern: RegExp(
            /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(
              /<keyword>/g,
              function() {
                return r.source;
              }
            )
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      });
    })(t);
  }
  return $g;
}
var Ug, fR;
function pc() {
  if (fR) return Ug;
  fR = 1, Ug = e, e.displayName = "javadoclike", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.javadoclike = {
        parameter: {
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
          lookbehind: !0
        },
        keyword: {
          // keywords are the first word in a line preceded be an `@` or surrounded by curly braces.
          // @word, {@word}
          pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
          lookbehind: !0
        },
        punctuation: /[{}]/
      };
      function a(s, u) {
        var c = "doc-comment", d = n.languages[s];
        if (d) {
          var p = d[c];
          if (!p) {
            var f = {};
            f[c] = {
              pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
              lookbehind: !0,
              alias: "comment"
            }, d = n.languages.insertBefore(s, "comment", f), p = d[c];
          }
          if (p instanceof RegExp && (p = d[c] = {
            pattern: p
          }), Array.isArray(p))
            for (var m = 0, h = p.length; m < h; m++)
              p[m] instanceof RegExp && (p[m] = {
                pattern: p[m]
              }), u(p[m]);
          else
            u(p);
        }
      }
      function i(s, u) {
        typeof s == "string" && (s = [s]), s.forEach(function(c) {
          a(c, function(d) {
            d.inside || (d.inside = {}), d.inside.rest = u;
          });
        });
      }
      Object.defineProperty(r, "addSupport", {
        value: i
      }), r.addSupport(["java", "javascript", "php"], r);
    })(t);
  }
  return Ug;
}
var jg, gR;
function m8() {
  if (gR) return jg;
  gR = 1;
  var e = $v(), t = pc();
  jg = n, n.displayName = "javadoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = /(^(?:[\t ]*(?:\*\s*)*))[^*\s].*$/m, s = /#\s*\w+(?:\s*\([^()]*\))?/.source, u = /(?:\b[a-zA-Z]\w+\s*\.\s*)*\b[A-Z]\w*(?:\s*<mem>)?|<mem>/.source.replace(
        /<mem>/g,
        function() {
          return s;
        }
      );
      a.languages.javadoc = a.languages.extend("javadoclike", {}), a.languages.insertBefore("javadoc", "keyword", {
        reference: {
          pattern: RegExp(
            /(@(?:exception|link|linkplain|see|throws|value)\s+(?:\*\s*)?)/.source + "(?:" + u + ")"
          ),
          lookbehind: !0,
          inside: {
            function: {
              pattern: /(#\s*)\w+(?=\s*\()/,
              lookbehind: !0
            },
            field: {
              pattern: /(#\s*)\w+/,
              lookbehind: !0
            },
            namespace: {
              pattern: /\b(?:[a-z]\w*\s*\.\s*)+/,
              inside: {
                punctuation: /\./
              }
            },
            "class-name": /\b[A-Z]\w*/,
            keyword: a.languages.java.keyword,
            punctuation: /[#()[\],.]/
          }
        },
        "class-name": {
          // @param <T> the first generic type parameter
          pattern: /(@param\s+)<[A-Z]\w*>/,
          lookbehind: !0,
          inside: {
            punctuation: /[.<>]/
          }
        },
        "code-section": [
          {
            pattern: /(\{@code\s+(?!\s))(?:[^\s{}]|\s+(?![\s}])|\{(?:[^{}]|\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\})*\})+(?=\s*\})/,
            lookbehind: !0,
            inside: {
              code: {
                // there can't be any HTML inside of {@code} tags
                pattern: i,
                lookbehind: !0,
                inside: a.languages.java,
                alias: "language-java"
              }
            }
          },
          {
            pattern: /(<(code|pre|tt)>(?!<code>)\s*)\S(?:\S|\s+\S)*?(?=\s*<\/\2>)/,
            lookbehind: !0,
            inside: {
              line: {
                pattern: i,
                lookbehind: !0,
                inside: {
                  // highlight HTML tags and entities
                  tag: a.languages.markup.tag,
                  entity: a.languages.markup.entity,
                  code: {
                    // everything else is Java code
                    pattern: /.+/,
                    inside: a.languages.java,
                    alias: "language-java"
                  }
                }
              }
            }
          }
        ],
        tag: a.languages.markup.tag,
        entity: a.languages.markup.entity
      }), a.languages.javadoclike.addSupport("java", a.languages.javadoc);
    }(r);
  }
  return jg;
}
var qg, mR;
function h8() {
  if (mR) return qg;
  mR = 1, qg = e, e.displayName = "javastacktrace", e.aliases = [];
  function e(t) {
    t.languages.javastacktrace = {
      // java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: java.sql.SQLException: Violation of unique constraint MY_ENTITY_UK_1: duplicate value(s) for column(s) MY_COLUMN in statement [...]
      // Caused by: com.example.myproject.MyProjectServletException
      // Caused by: MidLevelException: LowLevelException
      // Suppressed: Resource$CloseFailException: Resource ID = 0
      summary: {
        pattern: /^([\t ]*)(?:(?:Caused by:|Suppressed:|Exception in thread "[^"]*")[\t ]+)?[\w$.]+(?::.*)?$/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^([\t ]*)(?:(?:Caused by|Suppressed)(?=:)|Exception in thread)/m,
            lookbehind: !0
          },
          // the current thread if the summary starts with 'Exception in thread'
          string: {
            pattern: /^(\s*)"[^"]*"/,
            lookbehind: !0
          },
          exceptions: {
            pattern: /^(:?\s*)[\w$.]+(?=:|$)/,
            lookbehind: !0,
            inside: {
              "class-name": /[\w$]+$/,
              namespace: /\b[a-z]\w*\b/,
              punctuation: /\./
            }
          },
          message: {
            pattern: /(:\s*)\S.*/,
            lookbehind: !0,
            alias: "string"
          },
          punctuation: /:/
        }
      },
      // at org.mortbay.jetty.servlet.ServletHandler$CachedChain.doFilter(ServletHandler.java:1166)
      // at org.hsqldb.jdbc.Util.throwError(Unknown Source) here could be some notes
      // at java.base/java.lang.Class.forName0(Native Method)
      // at Util.<init>(Unknown Source)
      // at com.foo.loader/foo@9.0/com.foo.Main.run(Main.java:101)
      // at com.foo.loader//com.foo.bar.App.run(App.java:12)
      // at acme@2.1/org.acme.Lib.test(Lib.java:80)
      // at MyClass.mash(MyClass.java:9)
      //
      // More information:
      // https://docs.oracle.com/en/java/javase/13/docs/api/java.base/java/lang/StackTraceElement.html#toString()
      //
      // A valid Java module name is defined as:
      //   "A module name consists of one or more Java identifiers (§3.8) separated by "." tokens."
      // https://docs.oracle.com/javase/specs/jls/se9/html/jls-6.html#jls-ModuleName
      //
      // A Java module version is defined by this class:
      // https://docs.oracle.com/javase/9/docs/api/java/lang/module/ModuleDescriptor.Version.html
      // This is the implementation of the `parse` method in JDK13:
      // https://github.com/matcdac/jdk/blob/2305df71d1b7710266ae0956d73927a225132c0f/src/java.base/share/classes/java/lang/module/ModuleDescriptor.java#L1108
      // However, to keep this simple, a version will be matched by the pattern /@[\w$.+-]*/.
      "stack-frame": {
        pattern: /^([\t ]*)at (?:[\w$./]|@[\w$.+-]*\/)+(?:<init>)?\([^()]*\)/m,
        lookbehind: !0,
        inside: {
          keyword: {
            pattern: /^(\s*)at(?= )/,
            lookbehind: !0
          },
          source: [
            // (Main.java:15)
            // (Main.scala:15)
            {
              pattern: /(\()\w+\.\w+:\d+(?=\))/,
              lookbehind: !0,
              inside: {
                file: /^\w+\.\w+/,
                punctuation: /:/,
                "line-number": {
                  pattern: /\b\d+\b/,
                  alias: "number"
                }
              }
            },
            // (Unknown Source)
            // (Native Method)
            // (...something...)
            {
              pattern: /(\()[^()]*(?=\))/,
              lookbehind: !0,
              inside: {
                keyword: /^(?:Native Method|Unknown Source)$/
              }
            }
          ],
          "class-name": /[\w$]+(?=\.(?:<init>|[\w$]+)\()/,
          function: /(?:<init>|[\w$]+)(?=\()/,
          "class-loader": {
            pattern: /(\s)[a-z]\w*(?:\.[a-z]\w*)*(?=\/[\w@$.]*\/)/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /\./
            }
          },
          module: {
            pattern: /([\s/])[a-z]\w*(?:\.[a-z]\w*)*(?:@[\w$.+-]*)?(?=\/)/,
            lookbehind: !0,
            inside: {
              version: {
                pattern: /(@)[\s\S]+/,
                lookbehind: !0,
                alias: "number"
              },
              punctuation: /[@.]/
            }
          },
          namespace: {
            pattern: /(?:\b[a-z]\w*\.)+/,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()/.]/
        }
      },
      // ... 32 more
      // ... 32 common frames omitted
      more: {
        pattern: /^([\t ]*)\.{3} \d+ [a-z]+(?: [a-z]+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /\.{3}/,
          number: /\d+/,
          keyword: /\b[a-z]+(?: [a-z]+)*\b/
        }
      }
    };
  }
  return qg;
}
var zg, hR;
function b8() {
  if (hR) return zg;
  hR = 1, zg = e, e.displayName = "jexl", e.aliases = [];
  function e(t) {
    t.languages.jexl = {
      string: /(["'])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
      transform: {
        pattern: /(\|\s*)[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*/,
        alias: "function",
        lookbehind: !0
      },
      function: /[a-zA-Zа-яА-Я_\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$][\wа-яА-Я\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF$]*\s*(?=\()/,
      number: /\b\d+(?:\.\d+)?\b|\B\.\d+\b/,
      operator: /[<>!]=?|-|\+|&&|==|\|\|?|\/\/?|[?:*^%]/,
      boolean: /\b(?:false|true)\b/,
      keyword: /\bin\b/,
      punctuation: /[{}[\](),.]/
    };
  }
  return zg;
}
var Gg, bR;
function y8() {
  if (bR) return Gg;
  bR = 1, Gg = e, e.displayName = "jolie", e.aliases = [];
  function e(t) {
    t.languages.jolie = t.languages.extend("clike", {
      string: {
        pattern: /(^|[^\\])"(?:\\[\s\S]|[^"\\])*"/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /((?:\b(?:as|courier|embed|in|inputPort|outputPort|service)\b|@)[ \t]*)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:as|cH|comp|concurrent|constants|courier|cset|csets|default|define|else|embed|embedded|execution|exit|extender|for|foreach|forward|from|global|if|import|in|include|init|inputPort|install|instanceof|interface|is_defined|linkIn|linkOut|main|new|nullProcess|outputPort|over|private|provide|public|scope|sequential|service|single|spawn|synchronized|this|throw|throws|type|undef|until|while|with)\b/,
      function: /\b[a-z_]\w*(?=[ \t]*[@(])/i,
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?l?/i,
      operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[?\/%^@|]/,
      punctuation: /[()[\]{},;.:]/,
      builtin: /\b(?:Byte|any|bool|char|double|enum|float|int|length|long|ranges|regex|string|undefined|void)\b/
    }), t.languages.insertBefore("jolie", "keyword", {
      aggregates: {
        pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
        lookbehind: !0,
        inside: {
          keyword: /\bwith\b/,
          "class-name": /\w+/,
          punctuation: /,/
        }
      },
      redirects: {
        pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
        lookbehind: !0,
        inside: {
          punctuation: /,/,
          "class-name": /\w+/,
          operator: /=>/
        }
      },
      property: {
        pattern: /\b(?:Aggregates|[Ii]nterfaces|Java|Javascript|Jolie|[Ll]ocation|OneWay|[Pp]rotocol|Redirects|RequestResponse)\b(?=[ \t]*:)/
      }
    });
  }
  return Gg;
}
var Hg, yR;
function v8() {
  if (yR) return Hg;
  yR = 1, Hg = e, e.displayName = "jq", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\\\((?:[^()]|\([^()]*\))*\)/.source, a = RegExp(
        /(^|[^\\])"(?:[^"\r\n\\]|\\[^\r\n(]|__)*"/.source.replace(
          /__/g,
          function() {
            return r;
          }
        )
      ), i = {
        interpolation: {
          pattern: RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + r),
          lookbehind: !0,
          inside: {
            content: {
              pattern: /^(\\\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: null
              // see below
            },
            punctuation: /^\\\(|\)$/
          }
        }
      }, s = n.languages.jq = {
        comment: /#.*/,
        property: {
          pattern: RegExp(a.source + /(?=\s*:(?!:))/.source),
          lookbehind: !0,
          greedy: !0,
          inside: i
        },
        string: {
          pattern: a,
          lookbehind: !0,
          greedy: !0,
          inside: i
        },
        function: {
          pattern: /(\bdef\s+)[a-z_]\w+/i,
          lookbehind: !0
        },
        variable: /\B\$\w+/,
        "property-literal": {
          pattern: /\b[a-z_]\w*(?=\s*:(?!:))/i,
          alias: "property"
        },
        keyword: /\b(?:as|break|catch|def|elif|else|end|foreach|if|import|include|label|module|modulemeta|null|reduce|then|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        number: /(?:\b\d+\.|\B\.)?\b\d+(?:[eE][+-]?\d+)?\b/,
        operator: [
          {
            pattern: /\|=?/,
            alias: "pipe"
          },
          /\.\.|[!=<>]?=|\?\/\/|\/\/=?|[-+*/%]=?|[<>?]|\b(?:and|not|or)\b/
        ],
        "c-style-function": {
          pattern: /\b[a-z_]\w*(?=\s*\()/i,
          alias: "function"
        },
        punctuation: /::|[()\[\]{},:;]|\.(?=\s*[\[\w$])/,
        dot: {
          pattern: /\./,
          alias: "important"
        }
      };
      i.interpolation.inside.content.inside = s;
    })(t);
  }
  return Hg;
}
var Vg, vR;
function E8() {
  if (vR) return Vg;
  vR = 1, Vg = e, e.displayName = "jsExtras", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
          pattern: RegExp(
            "(\\.\\s*)" + n.languages.javascript["function-variable"].pattern.source
          ),
          lookbehind: !0,
          alias: ["function-variable", "method", "function", "property-access"]
        }
      }), n.languages.insertBefore("javascript", "function", {
        method: {
          pattern: RegExp(
            "(\\.\\s*)" + n.languages.javascript.function.source
          ),
          lookbehind: !0,
          alias: ["function", "property-access"]
        }
      }), n.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
          {
            // standard built-ins
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
            pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
            alias: "class-name"
          },
          {
            // errors
            pattern: /\b(?:[A-Z]\w*)Error\b/,
            alias: "class-name"
          }
        ]
      });
      function r(d, p) {
        return RegExp(
          d.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
          }),
          p
        );
      }
      n.languages.insertBefore("javascript", "keyword", {
        imports: {
          // https://tc39.es/ecma262/#sec-imports
          pattern: r(
            /(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source
          ),
          lookbehind: !0,
          inside: n.languages.javascript
        },
        exports: {
          // https://tc39.es/ecma262/#sec-exports
          pattern: r(
            /(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source
          ),
          lookbehind: !0,
          inside: n.languages.javascript
        }
      }), n.languages.javascript.keyword.unshift(
        {
          pattern: /\b(?:as|default|export|from|import)\b/,
          alias: "module"
        },
        {
          pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
          alias: "control-flow"
        },
        {
          pattern: /\bnull\b/,
          alias: ["null", "nil"]
        },
        {
          pattern: /\bundefined\b/,
          alias: "nil"
        }
      ), n.languages.insertBefore("javascript", "operator", {
        spread: {
          pattern: /\.{3}/,
          alias: "operator"
        },
        arrow: {
          pattern: /=>/,
          alias: "operator"
        }
      }), n.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
          pattern: r(/(\.\s*)#?<ID>/.source),
          lookbehind: !0
        },
        "maybe-class-name": {
          pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
          lookbehind: !0
        },
        dom: {
          // this contains only a few commonly used DOM variables
          pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
          alias: "variable"
        },
        console: {
          pattern: /\bconsole(?=\s*\.)/,
          alias: "class-name"
        }
      });
      for (var a = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
      ], i = 0; i < a.length; i++) {
        var s = a[i], u = n.languages.javascript[s];
        n.util.type(u) === "RegExp" && (u = n.languages.javascript[s] = {
          pattern: u
        });
        var c = u.inside || {};
        u.inside = c, c["maybe-class-name"] = /^[A-Z][\s\S]*/;
      }
    })(t);
  }
  return Vg;
}
var Wg, ER;
function S8() {
  if (ER) return Wg;
  ER = 1, Wg = e, e.displayName = "jsTemplates", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.javascript["template-string"], a = r.pattern.source, i = r.inside.interpolation, s = i.inside["interpolation-punctuation"], u = i.pattern.source;
      function c(y, w) {
        if (n.languages[y])
          return {
            pattern: RegExp("((?:" + w + ")\\s*)" + a),
            lookbehind: !0,
            greedy: !0,
            inside: {
              "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
              },
              "embedded-code": {
                pattern: /[\s\S]+/,
                alias: y
              }
            }
          };
      }
      n.languages.javascript["template-string"] = [
        // styled-jsx:
        //   css`a { color: #25F; }`
        // styled-components:
        //   styled.h1`color: red;`
        c(
          "css",
          /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source
        ),
        // html`<p></p>`
        // div.innerHTML = `<p></p>`
        c("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        // svg`<path fill="#fff" d="M55.37 ..."/>`
        c("svg", /\bsvg/.source),
        // md`# h1`, markdown`## h2`
        c("markdown", /\b(?:markdown|md)/.source),
        // gql`...`, graphql`...`, graphql.experimental`...`
        c(
          "graphql",
          /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source
        ),
        // sql`...`
        c("sql", /\bsql/.source),
        // vanilla template string
        r
      ].filter(Boolean);
      function d(y, w) {
        return "___" + w.toUpperCase() + "_" + y + "___";
      }
      function p(y, w, x) {
        var I = {
          code: y,
          grammar: w,
          language: x
        };
        return n.hooks.run("before-tokenize", I), I.tokens = n.tokenize(I.code, I.grammar), n.hooks.run("after-tokenize", I), I.tokens;
      }
      function f(y) {
        var w = {};
        w["interpolation-punctuation"] = s;
        var x = n.tokenize(y, w);
        if (x.length === 3) {
          var I = [1, 1];
          I.push.apply(
            I,
            p(x[1], n.languages.javascript, "javascript")
          ), x.splice.apply(x, I);
        }
        return new n.Token(
          "interpolation",
          x,
          i.alias,
          y
        );
      }
      function m(y, w, x) {
        var I = n.tokenize(y, {
          interpolation: {
            pattern: RegExp(u),
            lookbehind: !0
          }
        }), S = 0, C = {}, T = I.map(function(P) {
          if (typeof P == "string")
            return P;
          for (var b = P.content, L; y.indexOf(
            L = d(S++, x)
          ) !== -1; )
            ;
          return C[L] = b, L;
        }).join(""), A = p(T, w, x), O = Object.keys(C);
        S = 0;
        function U(P) {
          for (var b = 0; b < P.length; b++) {
            if (S >= O.length)
              return;
            var L = P[b];
            if (typeof L == "string" || typeof L.content == "string") {
              var j = O[S], G = typeof L == "string" ? L : (
                /** @type {string} */
                L.content
              ), H = G.indexOf(j);
              if (H !== -1) {
                ++S;
                var ne = G.substring(0, H), ue = f(
                  C[j]
                ), ce = G.substring(H + j.length), Q = [];
                if (ne && Q.push(ne), Q.push(ue), ce) {
                  var de = [ce];
                  U(de), Q.push.apply(Q, de);
                }
                typeof L == "string" ? (P.splice.apply(P, [b, 1].concat(Q)), b += Q.length - 1) : L.content = Q;
              }
            } else {
              var D = L.content;
              Array.isArray(D) ? U(D) : U([D]);
            }
          }
        }
        return U(A), new n.Token(
          x,
          A,
          "language-" + x,
          y
        );
      }
      var h = {
        javascript: !0,
        js: !0,
        typescript: !0,
        ts: !0,
        jsx: !0,
        tsx: !0
      };
      n.hooks.add("after-tokenize", function(y) {
        if (!(y.language in h))
          return;
        function w(x) {
          for (var I = 0, S = x.length; I < S; I++) {
            var C = x[I];
            if (typeof C != "string") {
              var T = C.content;
              if (!Array.isArray(T)) {
                typeof T != "string" && w([T]);
                continue;
              }
              if (C.type === "template-string") {
                var A = T[1];
                if (T.length === 3 && typeof A != "string" && A.type === "embedded-code") {
                  var O = E(A), U = A.alias, P = Array.isArray(U) ? U[0] : U, b = n.languages[P];
                  if (!b)
                    continue;
                  T[1] = m(O, b, P);
                }
              } else
                w(T);
            }
          }
        }
        w(y.tokens);
      });
      function E(y) {
        return typeof y == "string" ? y : Array.isArray(y) ? y.map(E).join("") : E(y.content);
      }
    })(t);
  }
  return Wg;
}
var Kg, SR;
function Uv() {
  if (SR) return Kg;
  SR = 1, Kg = e, e.displayName = "typescript", e.aliases = ["ts"];
  function e(t) {
    (function(n) {
      n.languages.typescript = n.languages.extend("javascript", {
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
      }), n.languages.typescript.keyword.push(
        /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
        // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
        // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/
      ), delete n.languages.typescript.parameter, delete n.languages.typescript["literal-property"];
      var r = n.languages.extend("typescript", {});
      delete r["class-name"], n.languages.typescript["class-name"].inside = r, n.languages.insertBefore("typescript", "function", {
        decorator: {
          pattern: /@[$\w\xA0-\uFFFF]+/,
          inside: {
            at: {
              pattern: /^@/,
              alias: "operator"
            },
            function: /^[\s\S]+/
          }
        },
        "generic-function": {
          // e.g. foo<T extends "bar" | "baz">( ...
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
          greedy: !0,
          inside: {
            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
            generic: {
              pattern: /<[\s\S]+/,
              // everything after the first <
              alias: "class-name",
              inside: r
            }
          }
        }
      }), n.languages.ts = n.languages.typescript;
    })(t);
  }
  return Kg;
}
var Yg, xR;
function x8() {
  if (xR) return Yg;
  xR = 1;
  var e = pc(), t = Uv();
  Yg = n, n.displayName = "jsdoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = a.languages.javascript, s = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, u = "(@(?:arg|argument|param|property)\\s+(?:" + s + "\\s+)?)";
      a.languages.jsdoc = a.languages.extend("javadoclike", {
        parameter: {
          // @param {string} foo - foo bar
          pattern: RegExp(
            u + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      }), a.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
          // @param {string} [baz.foo="bar"] foo bar
          pattern: RegExp(
            u + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source
          ),
          lookbehind: !0,
          inside: {
            parameter: {
              pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
              lookbehind: !0,
              inside: {
                punctuation: /\./
              }
            },
            code: {
              pattern: /(=)[\s\S]*(?=\]$)/,
              lookbehind: !0,
              inside: i,
              alias: "language-javascript"
            },
            punctuation: /[=[\]]/
          }
        },
        "class-name": [
          {
            pattern: RegExp(
              /(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(
                /<TYPE>/g,
                function() {
                  return s;
                }
              )
            ),
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          {
            pattern: RegExp("(@[a-z]+\\s+)" + s),
            lookbehind: !0,
            inside: {
              string: i.string,
              number: i.number,
              boolean: i.boolean,
              keyword: a.languages.typescript.keyword,
              operator: /=>|\.\.\.|[&|?:*]/,
              punctuation: /[.,;=<>{}()[\]]/
            }
          }
        ],
        example: {
          pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
          lookbehind: !0,
          inside: {
            code: {
              pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
              lookbehind: !0,
              inside: i,
              alias: "language-javascript"
            }
          }
        }
      }), a.languages.javadoclike.addSupport("javascript", a.languages.jsdoc);
    }(r);
  }
  return Yg;
}
var Xg, TR;
function jv() {
  if (TR) return Xg;
  TR = 1, Xg = e, e.displayName = "json", e.aliases = ["webmanifest"];
  function e(t) {
    t.languages.json = {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      }
    }, t.languages.webmanifest = t.languages.json;
  }
  return Xg;
}
var Zg, wR;
function T8() {
  if (wR) return Zg;
  wR = 1;
  var e = jv();
  Zg = t, t.displayName = "json5", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /("|')(?:\\(?:\r\n?|\n|.)|(?!\1)[^\\\r\n])*\1/;
      r.languages.json5 = r.languages.extend("json", {
        property: [
          {
            pattern: RegExp(a.source + "(?=\\s*:)"),
            greedy: !0
          },
          {
            pattern: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/,
            alias: "unquoted"
          }
        ],
        string: {
          pattern: a,
          greedy: !0
        },
        number: /[+-]?\b(?:NaN|Infinity|0x[a-fA-F\d]+)\b|[+-]?(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+\b)?/
      });
    }(n);
  }
  return Zg;
}
var Jg, AR;
function w8() {
  if (AR) return Jg;
  AR = 1;
  var e = jv();
  Jg = t, t.displayName = "jsonp", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.jsonp = n.languages.extend("json", {
      punctuation: /[{}[\]();,.]/
    }), n.languages.insertBefore("jsonp", "punctuation", {
      function: /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*\()/
    });
  }
  return Jg;
}
var Qg, IR;
function A8() {
  if (IR) return Qg;
  IR = 1, Qg = e, e.displayName = "jsstacktrace", e.aliases = [];
  function e(t) {
    t.languages.jsstacktrace = {
      "error-message": {
        pattern: /^\S.*/m,
        alias: "string"
      },
      "stack-frame": {
        pattern: /(^[ \t]+)at[ \t].*/m,
        lookbehind: !0,
        inside: {
          "not-my-code": {
            pattern: /^at[ \t]+(?!\s)(?:node\.js|<unknown>|.*(?:node_modules|\(<anonymous>\)|\(<unknown>|<anonymous>$|\(internal\/|\(node\.js)).*/m,
            alias: "comment"
          },
          filename: {
            pattern: /(\bat\s+(?!\s)|\()(?:[a-zA-Z]:)?[^():]+(?=:)/,
            lookbehind: !0,
            alias: "url"
          },
          function: {
            pattern: /(\bat\s+(?:new\s+)?)(?!\s)[_$a-zA-Z\xA0-\uFFFF<][.$\w\xA0-\uFFFF<>]*/,
            lookbehind: !0,
            inside: {
              punctuation: /\./
            }
          },
          punctuation: /[()]/,
          keyword: /\b(?:at|new)\b/,
          alias: {
            pattern: /\[(?:as\s+)?(?!\s)[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\]/,
            alias: "variable"
          },
          "line-number": {
            pattern: /:\d+(?::\d+)?\b/,
            alias: "number",
            inside: {
              punctuation: /:/
            }
          }
        }
      }
    };
  }
  return Qg;
}
var em, RR;
function u1() {
  if (RR) return em;
  RR = 1, em = e, e.displayName = "jsx", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.util.clone(n.languages.javascript), a = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, i = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, s = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function u(p, f) {
        return p = p.replace(/<S>/g, function() {
          return a;
        }).replace(/<BRACES>/g, function() {
          return i;
        }).replace(/<SPREAD>/g, function() {
          return s;
        }), RegExp(p, f);
      }
      s = u(s).source, n.languages.jsx = n.languages.extend("markup", r), n.languages.jsx.tag.pattern = u(
        /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source
      ), n.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, n.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, n.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, n.languages.jsx.tag.inside.comment = r.comment, n.languages.insertBefore(
        "inside",
        "attr-name",
        {
          spread: {
            pattern: u(/<SPREAD>/.source),
            inside: n.languages.jsx
          }
        },
        n.languages.jsx.tag
      ), n.languages.insertBefore(
        "inside",
        "special-attr",
        {
          script: {
            // Allow for two levels of nesting
            pattern: u(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
              "script-punctuation": {
                pattern: /^=(?=\{)/,
                alias: "punctuation"
              },
              rest: n.languages.jsx
            }
          }
        },
        n.languages.jsx.tag
      );
      var c = function(p) {
        return p ? typeof p == "string" ? p : typeof p.content == "string" ? p.content : p.content.map(c).join("") : "";
      }, d = function(p) {
        for (var f = [], m = 0; m < p.length; m++) {
          var h = p[m], E = !1;
          if (typeof h != "string" && (h.type === "tag" && h.content[0] && h.content[0].type === "tag" ? h.content[0].content[0].content === "</" ? f.length > 0 && f[f.length - 1].tagName === c(h.content[0].content[1]) && f.pop() : h.content[h.content.length - 1].content === "/>" || f.push({
            tagName: c(h.content[0].content[1]),
            openedBraces: 0
          }) : f.length > 0 && h.type === "punctuation" && h.content === "{" ? f[f.length - 1].openedBraces++ : f.length > 0 && f[f.length - 1].openedBraces > 0 && h.type === "punctuation" && h.content === "}" ? f[f.length - 1].openedBraces-- : E = !0), (E || typeof h == "string") && f.length > 0 && f[f.length - 1].openedBraces === 0) {
            var y = c(h);
            m < p.length - 1 && (typeof p[m + 1] == "string" || p[m + 1].type === "plain-text") && (y += c(p[m + 1]), p.splice(m + 1, 1)), m > 0 && (typeof p[m - 1] == "string" || p[m - 1].type === "plain-text") && (y = c(p[m - 1]) + y, p.splice(m - 1, 1), m--), p[m] = new n.Token(
              "plain-text",
              y,
              null,
              y
            );
          }
          h.content && typeof h.content != "string" && d(h.content);
        }
      };
      n.hooks.add("after-tokenize", function(p) {
        p.language !== "jsx" && p.language !== "tsx" || d(p.tokens);
      });
    })(t);
  }
  return em;
}
var tm, _R;
function I8() {
  if (_R) return tm;
  _R = 1, tm = e, e.displayName = "julia", e.aliases = [];
  function e(t) {
    t.languages.julia = {
      comment: {
        // support one level of nested comments
        // https://github.com/JuliaLang/julia/pull/6128
        pattern: /(^|[^\\])(?:#=(?:[^#=]|=(?!#)|#(?!=)|#=(?:[^#=]|=(?!#)|#(?!=))*=#)*=#|#.*)/,
        lookbehind: !0
      },
      regex: {
        // https://docs.julialang.org/en/v1/manual/strings/#Regular-Expressions-1
        pattern: /r"(?:\\.|[^"\\\r\n])*"[imsx]{0,4}/,
        greedy: !0
      },
      string: {
        // https://docs.julialang.org/en/v1/manual/strings/#String-Basics-1
        // https://docs.julialang.org/en/v1/manual/strings/#non-standard-string-literals-1
        // https://docs.julialang.org/en/v1/manual/running-external-programs/#Running-External-Programs-1
        pattern: /"""[\s\S]+?"""|(?:\b\w+)?"(?:\\.|[^"\\\r\n])*"|`(?:[^\\`\r\n]|\\.)*`/,
        greedy: !0
      },
      char: {
        // https://docs.julialang.org/en/v1/manual/strings/#man-characters-1
        pattern: /(^|[^\w'])'(?:\\[^\r\n][^'\r\n]*|[^\\\r\n])'/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|in|let|local|macro|module|print|println|quote|return|struct|try|type|typealias|using|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+(?:_[\da-f]+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[efp][+-]?\d+(?:_\d+)*)?j?/i,
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/
      // https://docs.julialang.org/en/v1/manual/mathematical-operations/#Operator-Precedence-and-Associativity-1
      operator: /&&|\|\||[-+*^%÷⊻&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:|])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥'√∛]/,
      punctuation: /::?|[{}[\]();,.?]/,
      // https://docs.julialang.org/en/v1/base/numbers/#Base.im
      constant: /\b(?:(?:Inf|NaN)(?:16|32|64)?|im|pi)\b|[πℯ]/
    };
  }
  return tm;
}
var nm, CR;
function R8() {
  if (CR) return nm;
  CR = 1, nm = e, e.displayName = "keepalived", e.aliases = [];
  function e(t) {
    t.languages.keepalived = {
      comment: {
        pattern: /[#!].*/,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/,
        lookbehind: !0,
        greedy: !0
      },
      // support IPv4, IPv6, subnet mask
      ip: {
        pattern: RegExp(
          /\b(?:(?:(?:[\da-f]{1,4}:){7}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}:[\da-f]{1,4}|(?:[\da-f]{1,4}:){5}:(?:[\da-f]{1,4}:)?[\da-f]{1,4}|(?:[\da-f]{1,4}:){4}:(?:[\da-f]{1,4}:){0,2}[\da-f]{1,4}|(?:[\da-f]{1,4}:){3}:(?:[\da-f]{1,4}:){0,3}[\da-f]{1,4}|(?:[\da-f]{1,4}:){2}:(?:[\da-f]{1,4}:){0,4}[\da-f]{1,4}|(?:[\da-f]{1,4}:){6}<ipv4>|(?:[\da-f]{1,4}:){0,5}:<ipv4>|::(?:[\da-f]{1,4}:){0,5}<ipv4>|[\da-f]{1,4}::(?:[\da-f]{1,4}:){0,5}[\da-f]{1,4}|::(?:[\da-f]{1,4}:){0,6}[\da-f]{1,4}|(?:[\da-f]{1,4}:){1,7}:)(?:\/\d{1,3})?|<ipv4>(?:\/\d{1,2})?)\b/.source.replace(
            /<ipv4>/g,
            function() {
              return /(?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d))/.source;
            }
          ),
          "i"
        ),
        alias: "number"
      },
      // support *nix / Windows, directory / file
      path: {
        pattern: /(\s)\/(?:[^\/\s]+\/)*[^\/\s]*|\b[a-zA-Z]:\\(?:[^\\\s]+\\)*[^\\\s]*/,
        lookbehind: !0,
        alias: "string"
      },
      variable: /\$\{?\w+\}?/,
      email: {
        pattern: /[\w-]+@[\w-]+(?:\.[\w-]{2,3}){1,2}/,
        alias: "string"
      },
      "conditional-configuration": {
        pattern: /@\^?[\w-]+/,
        alias: "variable"
      },
      operator: /=/,
      property: /\b(?:BFD_CHECK|DNS_CHECK|FILE_CHECK|HTTP_GET|MISC_CHECK|NAME|PING_CHECK|SCRIPTS|SMTP_CHECK|SSL|SSL_GET|TCP_CHECK|UDP_CHECK|accept|advert_int|alpha|auth_pass|auth_type|authentication|bfd_cpu_affinity|bfd_instance|bfd_no_swap|bfd_priority|bfd_process_name|bfd_rlimit_rttime|bfd_rt_priority|bind_if|bind_port|bindto|ca|certificate|check_unicast_src|checker|checker_cpu_affinity|checker_log_all_failures|checker_no_swap|checker_priority|checker_rlimit_rttime|checker_rt_priority|child_wait_time|connect_ip|connect_port|connect_timeout|dbus_service_name|debug|default_interface|delay|delay_before_retry|delay_loop|digest|dont_track_primary|dynamic|dynamic_interfaces|enable_(?:dbus|script_security|sni|snmp_checker|snmp_rfc|snmp_rfcv2|snmp_rfcv3|snmp_vrrp|traps)|end|fall|fast_recovery|file|flag-[123]|fork_delay|full_command|fwmark|garp_group|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|global_defs|global_tracking|gna_interval|group|ha_suspend|hashed|helo_name|higher_prio_send_advert|hoplimit|http_protocol|hysteresis|idle_tx|include|inhibit_on_failure|init_fail|init_file|instance|interface|interfaces|interval|ip_family|ipvs_process_name|keepalived.conf|kernel_rx_buf_size|key|linkbeat_interfaces|linkbeat_use_polling|log_all_failures|log_unknown_vrids|lower_prio_no_advert|lthreshold|lvs_flush|lvs_flush_onstop|lvs_method|lvs_netlink_cmd_rcv_bufs|lvs_netlink_cmd_rcv_bufs_force|lvs_netlink_monitor_rcv_bufs|lvs_netlink_monitor_rcv_bufs_force|lvs_notify_fifo|lvs_notify_fifo_script|lvs_sched|lvs_sync_daemon|max_auto_priority|max_hops|mcast_src_ip|mh-fallback|mh-port|min_auto_priority_delay|min_rx|min_tx|misc_dynamic|misc_path|misc_timeout|multiplier|name|namespace_with_ipsets|native_ipv6|neighbor_ip|net_namespace|net_namespace_ipvs|nftables|nftables_counters|nftables_ifindex|nftables_priority|no_accept|no_checker_emails|no_email_faults|nopreempt|notification_email|notification_email_from|notify|notify_backup|notify_deleted|notify_down|notify_fault|notify_fifo|notify_fifo_script|notify_master|notify_master_rx_lower_pri|notify_priority_changes|notify_stop|notify_up|old_unicast_checksum|omega|ops|param_match|passive|password|path|persistence_engine|persistence_granularity|persistence_timeout|preempt|preempt_delay|priority|process|process_monitor_rcv_bufs|process_monitor_rcv_bufs_force|process_name|process_names|promote_secondaries|protocol|proxy_arp|proxy_arp_pvlan|quorum|quorum_down|quorum_max|quorum_up|random_seed|real_server|regex|regex_max_offset|regex_min_offset|regex_no_match|regex_options|regex_stack|reload_repeat|reload_time_file|require_reply|retry|rise|router_id|rs_init_notifies|script|script_user|sh-fallback|sh-port|shutdown_script|shutdown_script_timeout|skip_check_adv_addr|smtp_alert|smtp_alert_checker|smtp_alert_vrrp|smtp_connect_timeout|smtp_helo_name|smtp_server|snmp_socket|sorry_server|sorry_server_inhibit|sorry_server_lvs_method|source_ip|start|startup_script|startup_script_timeout|state|static_ipaddress|static_routes|static_rules|status_code|step|strict_mode|sync_group_tracking_weight|terminate_delay|timeout|track_bfd|track_file|track_group|track_interface|track_process|track_script|track_src_ip|ttl|type|umask|unicast_peer|unicast_src_ip|unicast_ttl|url|use_ipvlan|use_pid_dir|use_vmac|user|uthreshold|val[123]|version|virtual_ipaddress|virtual_ipaddress_excluded|virtual_router_id|virtual_routes|virtual_rules|virtual_server|virtual_server_group|virtualhost|vmac_xmit_base|vrrp|vrrp_(?:check_unicast_src|cpu_affinity|garp_interval|garp_lower_prio_delay|garp_lower_prio_repeat|garp_master_delay|garp_master_refresh|garp_master_refresh_repeat|garp_master_repeat|gna_interval|higher_prio_send_advert|instance|ipsets|iptables|lower_prio_no_advert|mcast_group4|mcast_group6|min_garp|netlink_cmd_rcv_bufs|netlink_cmd_rcv_bufs_force|netlink_monitor_rcv_bufs|netlink_monitor_rcv_bufs_force|no_swap|notify_fifo|notify_fifo_script|notify_priority_changes|priority|process_name|rlimit_rttime|rt_priority|rx_bufs_multiplier|rx_bufs_policy|script|skip_check_adv_addr|startup_delay|strict|sync_group|track_process|version)|warmup|weight)\b/,
      constant: /\b(?:A|AAAA|AH|BACKUP|CNAME|DR|MASTER|MX|NAT|NS|PASS|SCTP|SOA|TCP|TUN|TXT|UDP|dh|fo|lblc|lblcr|lc|mh|nq|ovf|rr|sed|sh|wlc|wrr)\b/,
      number: {
        pattern: /(^|[^\w.-])-?\d+(?:\.\d+)?/,
        lookbehind: !0
      },
      boolean: /\b(?:false|no|off|on|true|yes)\b/,
      punctuation: /[\{\}]/
    };
  }
  return nm;
}
var rm, kR;
function _8() {
  if (kR) return rm;
  kR = 1, rm = e, e.displayName = "keyman", e.aliases = [];
  function e(t) {
    t.languages.keyman = {
      comment: {
        pattern: /\bc .*/i,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
        greedy: !0
      },
      "virtual-key": {
        pattern: /\[\s*(?:(?:ALT|CAPS|CTRL|LALT|LCTRL|NCAPS|RALT|RCTRL|SHIFT)\s+)*(?:[TKU]_[\w?]+|[A-E]\d\d?|"[^"\r\n]*"|'[^'\r\n]*')\s*\]/i,
        greedy: !0,
        alias: "function"
        // alias for styles
      },
      // https://help.keyman.com/developer/language/guide/headers
      "header-keyword": {
        pattern: /&\w+/,
        alias: "bold"
        // alias for styles
      },
      "header-statement": {
        pattern: /\b(?:bitmap|bitmaps|caps always off|caps on only|copyright|hotkey|language|layout|message|name|shift frees caps|version)\b/i,
        alias: "bold"
        // alias for styles
      },
      "rule-keyword": {
        pattern: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|reset|return|save|set|store|use)\b/i,
        alias: "keyword"
      },
      "structural-keyword": {
        pattern: /\b(?:ansi|begin|group|match|nomatch|unicode|using keys)\b/i,
        alias: "keyword"
      },
      "compile-target": {
        pattern: /\$(?:keyman|keymanonly|keymanweb|kmfl|weaver):/i,
        alias: "property"
      },
      // U+####, x###, d### characters and numbers
      number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i,
      operator: /[+>\\$]|\.\./,
      punctuation: /[()=,]/
    };
  }
  return rm;
}
var am, NR;
function C8() {
  if (NR) return am;
  NR = 1, am = e, e.displayName = "kotlin", e.aliases = ["kt", "kts"];
  function e(t) {
    (function(n) {
      n.languages.kotlin = n.languages.extend("clike", {
        keyword: {
          // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
          pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
          lookbehind: !0
        },
        function: [
          {
            pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
            greedy: !0
          },
          {
            pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
      }), delete n.languages.kotlin["class-name"];
      var r = {
        "interpolation-punctuation": {
          pattern: /^\$\{?|\}$/,
          alias: "punctuation"
        },
        expression: {
          pattern: /[\s\S]+/,
          inside: n.languages.kotlin
        }
      };
      n.languages.insertBefore("kotlin", "string", {
        // https://kotlinlang.org/spec/expressions.html#string-interpolation-expressions
        "string-literal": [
          {
            pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
            alias: "multiline",
            inside: {
              interpolation: {
                pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                inside: r
              },
              string: /[\s\S]+/
            }
          },
          {
            pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
            alias: "singleline",
            inside: {
              interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                lookbehind: !0,
                inside: r
              },
              string: /[\s\S]+/
            }
          }
        ],
        char: {
          // https://kotlinlang.org/spec/expressions.html#character-literals
          pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
          greedy: !0
        }
      }), delete n.languages.kotlin.string, n.languages.insertBefore("kotlin", "keyword", {
        annotation: {
          pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
          alias: "builtin"
        }
      }), n.languages.insertBefore("kotlin", "function", {
        label: {
          pattern: /\b\w+@|@\w+\b/,
          alias: "symbol"
        }
      }), n.languages.kt = n.languages.kotlin, n.languages.kts = n.languages.kotlin;
    })(t);
  }
  return am;
}
var im, OR;
function k8() {
  if (OR) return im;
  OR = 1, im = e, e.displayName = "kumir", e.aliases = ["kum"];
  function e(t) {
    (function(n) {
      var r = /\s\x00-\x1f\x22-\x2f\x3a-\x3f\x5b-\x5e\x60\x7b-\x7e/.source;
      function a(i, s) {
        return RegExp(i.replace(/<nonId>/g, r), s);
      }
      n.languages.kumir = {
        comment: {
          pattern: /\|.*/
        },
        prolog: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^\n\r"]*"|'[^\n\r']*'/,
          greedy: !0
        },
        boolean: {
          pattern: a(/(^|[<nonId>])(?:да|нет)(?=[<nonId>]|$)/.source),
          lookbehind: !0
        },
        "operator-word": {
          pattern: a(/(^|[<nonId>])(?:и|или|не)(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        "system-variable": {
          pattern: a(/(^|[<nonId>])знач(?=[<nonId>]|$)/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        type: [
          {
            pattern: a(
              /(^|[<nonId>])(?:вещ|лит|лог|сим|цел)(?:\x20*таб)?(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "builtin"
          },
          {
            pattern: a(
              /(^|[<nonId>])(?:компл|сканкод|файл|цвет)(?=[<nonId>]|$)/.source
            ),
            lookbehind: !0,
            alias: "important"
          }
        ],
        /**
         * Should be performed after searching for type names because of "таб".
         * "таб" is a reserved word, but never used without a preceding type name.
         * "НАЗНАЧИТЬ", "Фввод", and "Фвывод" are not reserved words.
         */
        keyword: {
          pattern: a(
            /(^|[<nonId>])(?:алг|арг(?:\x20*рез)?|ввод|ВКЛЮЧИТЬ|вс[её]|выбор|вывод|выход|дано|для|до|дс|если|иначе|исп|использовать|кон(?:(?:\x20+|_)исп)?|кц(?:(?:\x20+|_)при)?|надо|нач|нс|нц|от|пауза|пока|при|раза?|рез|стоп|таб|то|утв|шаг)(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for reserved words. */
        name: {
          // eslint-disable-next-line regexp/no-super-linear-backtracking
          pattern: a(
            /(^|[<nonId>])[^\d<nonId>][^<nonId>]*(?:\x20+[^<nonId>]+)*(?=[<nonId>]|$)/.source
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for names. */
        number: {
          pattern: a(
            /(^|[<nonId>])(?:\B\$[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?=[<nonId>]|$)/.source,
            "i"
          ),
          lookbehind: !0
        },
        /** Should be performed after searching for words. */
        punctuation: /:=|[(),:;\[\]]/,
        /**
         * Should be performed after searching for
         * - numeric constants (because of "+" and "-");
         * - punctuation marks (because of ":=" and "=").
         */
        "operator-char": {
          pattern: /\*\*?|<[=>]?|>=?|[-+/=]/,
          alias: "operator"
        }
      }, n.languages.kum = n.languages.kumir;
    })(t);
  }
  return im;
}
var om, LR;
function N8() {
  if (LR) return om;
  LR = 1, om = e, e.displayName = "kusto", e.aliases = [];
  function e(t) {
    t.languages.kusto = {
      comment: {
        pattern: /\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /```[\s\S]*?```|[hH]?(?:"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\.)*'|@(?:"[^\r\n"]*"|'[^\r\n']*'))/,
        greedy: !0
      },
      verb: {
        pattern: /(\|\s*)[a-z][\w-]*/i,
        lookbehind: !0,
        alias: "keyword"
      },
      command: {
        pattern: /\.[a-z][a-z\d-]*\b/,
        alias: "keyword"
      },
      "class-name": /\b(?:bool|datetime|decimal|dynamic|guid|int|long|real|string|timespan)\b/,
      keyword: /\b(?:access|alias|and|anti|as|asc|auto|between|by|(?:contains|(?:ends|starts)with|has(?:perfix|suffix)?)(?:_cs)?|database|declare|desc|external|from|fullouter|has_all|in|ingestion|inline|inner|innerunique|into|(?:left|right)(?:anti(?:semi)?|inner|outer|semi)?|let|like|local|not|of|on|or|pattern|print|query_parameters|range|restrict|schema|set|step|table|tables|to|view|where|with|matches\s+regex|nulls\s+(?:first|last))(?![\w-])/,
      boolean: /\b(?:false|null|true)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/,
      datetime: [
        {
          // RFC 822 + RFC 850
          pattern: /\b(?:(?:Fri|Friday|Mon|Monday|Sat|Saturday|Sun|Sunday|Thu|Thursday|Tue|Tuesday|Wed|Wednesday)\s*,\s*)?\d{1,2}(?:\s+|-)(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)(?:\s+|-)\d{2}\s+\d{2}:\d{2}(?::\d{2})?(?:\s*(?:\b(?:[A-Z]|(?:[ECMT][DS]|GM|U)T)|[+-]\d{4}))?\b/,
          alias: "number"
        },
        {
          // ISO 8601
          pattern: /[+-]?\b(?:\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?|\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)Z?/,
          alias: "number"
        }
      ],
      number: /\b(?:0x[0-9A-Fa-f]+|\d+(?:\.\d+)?(?:[Ee][+-]?\d+)?)(?:(?:min|sec|[mnµ]s|[dhms]|microsecond|tick)\b)?|[+-]?\binf\b/,
      operator: /=>|[!=]~|[!=<>]=?|[-+*/%|]|\.\./,
      punctuation: /[()\[\]{},;.:]/
    };
  }
  return om;
}
var sm, DR;
function O8() {
  if (DR) return sm;
  DR = 1, sm = e, e.displayName = "latex", e.aliases = ["tex", "context"];
  function e(t) {
    (function(n) {
      var r = /\\(?:[^a-z()[\]]|[a-z*]+)/i, a = {
        "equation-command": {
          pattern: r,
          alias: "regex"
        }
      };
      n.languages.latex = {
        comment: /%.*/,
        // the verbatim environment prints whitespace to the document
        cdata: {
          pattern: /(\\begin\{((?:lstlisting|verbatim)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: !0
        },
        /*
         * equations can be between $$ $$ or $ $ or \( \) or \[ \]
         * (all are multiline)
         */
        equation: [
          {
            pattern: /\$\$(?:\\[\s\S]|[^\\$])+\$\$|\$(?:\\[\s\S]|[^\\$])+\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
            inside: a,
            alias: "string"
          },
          {
            pattern: /(\\begin\{((?:align|eqnarray|equation|gather|math|multline)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
            lookbehind: !0,
            inside: a,
            alias: "string"
          }
        ],
        /*
         * arguments which are keywords or references are highlighted
         * as keywords
         */
        keyword: {
          pattern: /(\\(?:begin|cite|documentclass|end|label|ref|usepackage)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        url: {
          pattern: /(\\url\{)[^}]+(?=\})/,
          lookbehind: !0
        },
        /*
         * section or chapter headlines are highlighted as bold so that
         * they stand out more
         */
        headline: {
          pattern: /(\\(?:chapter|frametitle|paragraph|part|section|subparagraph|subsection|subsubparagraph|subsubsection|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
          lookbehind: !0,
          alias: "class-name"
        },
        function: {
          pattern: r,
          alias: "selector"
        },
        punctuation: /[[\]{}&]/
      }, n.languages.tex = n.languages.latex, n.languages.context = n.languages.latex;
    })(t);
  }
  return sm;
}
var lm, MR;
function fc() {
  if (MR) return lm;
  MR = 1;
  var e = Mn();
  lm = t, t.displayName = "php", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, i = [
        {
          pattern: /\b(?:false|true)\b/i,
          alias: "boolean"
        },
        {
          pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
          greedy: !0,
          lookbehind: !0
        },
        {
          pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
          greedy: !0,
          lookbehind: !0
        },
        /\b(?:null)\b/i,
        /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
      ], s = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, u = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, c = /[{}\[\](),:;]/;
      r.languages.php = {
        delimiter: {
          pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
          alias: "important"
        },
        comment: a,
        variable: /\$+(?:\w+\b|(?=\{))/,
        package: {
          pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        "class-name-definition": {
          pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
          lookbehind: !0,
          alias: "class-name"
        },
        "function-definition": {
          pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
          lookbehind: !0,
          alias: "function"
        },
        keyword: [
          {
            pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
            alias: "type-casting",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
            alias: "type-declaration",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b(?:parent|self|static)(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            // yield from
            pattern: /(\byield\s+)from\b/i,
            lookbehind: !0
          },
          // `class` is always a keyword unlike other keywords
          /\bclass\b/i,
          {
            // https://www.php.net/manual/en/reserved.keywords.php
            //
            // keywords cannot be preceded by "->"
            // the complex lookbehind means `(?<!(?:->|::)\s*)`
            pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
            lookbehind: !0
          }
        ],
        "argument-name": {
          pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
            greedy: !0
          },
          {
            pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: "class-name-fully-qualified",
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*\$)/i,
            alias: "type-declaration",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-declaration"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /\b[a-z_]\w*(?=\s*::)/i,
            alias: "static-context",
            greedy: !0
          },
          {
            pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
            alias: ["class-name-fully-qualified", "static-context"],
            greedy: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
            alias: "type-hint",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
            alias: ["class-name-fully-qualified", "type-hint"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
            alias: "return-type",
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            alias: ["class-name-fully-qualified", "return-type"],
            greedy: !0,
            lookbehind: !0,
            inside: {
              punctuation: /\\/
            }
          }
        ],
        constant: i,
        function: {
          pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
          lookbehind: !0,
          inside: {
            punctuation: /\\/
          }
        },
        property: {
          pattern: /(->\s*)\w+/,
          lookbehind: !0
        },
        number: s,
        operator: u,
        punctuation: c
      };
      var d = {
        pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
        lookbehind: !0,
        inside: r.languages.php
      }, p = [
        {
          pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
          alias: "nowdoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<'?|[';]$/
              }
            }
          }
        },
        {
          pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
          alias: "heredoc-string",
          greedy: !0,
          inside: {
            delimiter: {
              pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
              alias: "symbol",
              inside: {
                punctuation: /^<<<"?|[";]$/
              }
            },
            interpolation: d
          }
        },
        {
          pattern: /`(?:\\[\s\S]|[^\\`])*`/,
          alias: "backtick-quoted-string",
          greedy: !0
        },
        {
          pattern: /'(?:\\[\s\S]|[^\\'])*'/,
          alias: "single-quoted-string",
          greedy: !0
        },
        {
          pattern: /"(?:\\[\s\S]|[^\\"])*"/,
          alias: "double-quoted-string",
          greedy: !0,
          inside: {
            interpolation: d
          }
        }
      ];
      r.languages.insertBefore("php", "variable", {
        string: p,
        attribute: {
          pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
          greedy: !0,
          inside: {
            "attribute-content": {
              pattern: /^(#\[)[\s\S]+(?=\]$)/,
              lookbehind: !0,
              // inside can appear subset of php
              inside: {
                comment: a,
                string: p,
                "attribute-class-name": [
                  {
                    pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                    alias: "class-name",
                    greedy: !0,
                    lookbehind: !0
                  },
                  {
                    pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                    alias: ["class-name", "class-name-fully-qualified"],
                    greedy: !0,
                    lookbehind: !0,
                    inside: {
                      punctuation: /\\/
                    }
                  }
                ],
                constant: i,
                number: s,
                operator: u,
                punctuation: c
              }
            },
            delimiter: {
              pattern: /^#\[|\]$/,
              alias: "punctuation"
            }
          }
        }
      }), r.hooks.add("before-tokenize", function(f) {
        if (/<\?/.test(f.code)) {
          var m = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
          r.languages["markup-templating"].buildPlaceholders(
            f,
            "php",
            m
          );
        }
      }), r.hooks.add("after-tokenize", function(f) {
        r.languages["markup-templating"].tokenizePlaceholders(f, "php");
      });
    }(n);
  }
  return lm;
}
var um, FR;
function L8() {
  if (FR) return um;
  FR = 1;
  var e = Mn(), t = fc();
  um = n, n.displayName = "latte", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      a.languages.latte = {
        comment: /^\{\*[\s\S]*/,
        "latte-tag": {
          // https://latte.nette.org/en/tags
          pattern: /(^\{(?:\/(?=[a-z]))?)(?:[=_]|[a-z]\w*\b(?!\())/i,
          lookbehind: !0,
          alias: "important"
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          alias: "punctuation"
        },
        php: {
          pattern: /\S(?:[\s\S]*\S)?/,
          alias: "language-php",
          inside: a.languages.php
        }
      };
      var i = a.languages.extend("markup", {});
      a.languages.insertBefore(
        "inside",
        "attr-value",
        {
          "n-attr": {
            pattern: /n:[\w-]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+))?/,
            inside: {
              "attr-name": {
                pattern: /^[^\s=]+/,
                alias: "important"
              },
              "attr-value": {
                pattern: /=[\s\S]+/,
                inside: {
                  punctuation: [
                    /^=/,
                    {
                      pattern: /^(\s*)["']|["']$/,
                      lookbehind: !0
                    }
                  ],
                  php: {
                    pattern: /\S(?:[\s\S]*\S)?/,
                    inside: a.languages.php
                  }
                }
              }
            }
          }
        },
        i.tag
      ), a.hooks.add("before-tokenize", function(s) {
        if (s.language === "latte") {
          var u = /\{\*[\s\S]*?\*\}|\{[^'"\s{}*](?:[^"'/{}]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|\/\*(?:[^*]|\*(?!\/))*\*\/)*\}/g;
          a.languages["markup-templating"].buildPlaceholders(
            s,
            "latte",
            u
          ), s.grammar = i;
        }
      }), a.hooks.add("after-tokenize", function(s) {
        a.languages["markup-templating"].tokenizePlaceholders(s, "latte");
      });
    }(r);
  }
  return um;
}
var cm, PR;
function D8() {
  if (PR) return cm;
  PR = 1, cm = e, e.displayName = "less", e.aliases = [];
  function e(t) {
    t.languages.less = t.languages.extend("css", {
      comment: [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^|[^\\])\/\/.*/,
          lookbehind: !0
        }
      ],
      atrule: {
        pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          punctuation: /[:()]/
        }
      },
      // selectors and mixins are considered the same
      selector: {
        pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
          // mixin parameters
          variable: /@+[\w-]+/
        }
      },
      property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
      operator: /[+\-*\/]/
    }), t.languages.insertBefore("less", "property", {
      variable: [
        // Variable declaration (the colon must be consumed!)
        {
          pattern: /@[\w-]+\s*:/,
          inside: {
            punctuation: /:/
          }
        },
        // Variable usage
        /@@?[\w-]+/
      ],
      "mixin-usage": {
        pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
        lookbehind: !0,
        alias: "function"
      }
    });
  }
  return cm;
}
var dm, BR;
function qv() {
  if (BR) return dm;
  BR = 1, dm = e, e.displayName = "scheme", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.scheme = {
        // this supports "normal" single-line comments:
        //   ; comment
        // and (potentially nested) multiline comments:
        //   #| comment #| nested |# still comment |#
        // (only 1 level of nesting is supported)
        comment: /;.*|#;\s*(?:\((?:[^()]|\([^()]*\))*\)|\[(?:[^\[\]]|\[[^\[\]]*\])*\])|#\|(?:[^#|]|#(?!\|)|\|(?!#)|#\|(?:[^#|]|#(?!\|)|\|(?!#))*\|#)*\|#/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        symbol: {
          pattern: /'[^()\[\]#'\s]+/,
          greedy: !0
        },
        char: {
          pattern: /#\\(?:[ux][a-fA-F\d]+\b|[-a-zA-Z]+\b|[\uD800-\uDBFF][\uDC00-\uDFFF]|\S)/,
          greedy: !0
        },
        "lambda-parameter": [
          // https://www.cs.cmu.edu/Groups/AI/html/r4rs/r4rs_6.html#SEC30
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+)(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)/,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[^'`#])[(\[]lambda\s+[(\[])[^()\[\]']+/,
            lookbehind: !0
          }
        ],
        keyword: {
          pattern: /((?:^|[^'`#])[(\[])(?:begin|case(?:-lambda)?|cond(?:-expand)?|define(?:-library|-macro|-record-type|-syntax|-values)?|defmacro|delay(?:-force)?|do|else|except|export|guard|if|import|include(?:-ci|-library-declarations)?|lambda|let(?:rec)?(?:-syntax|-values|\*)?|let\*-values|only|parameterize|prefix|(?:quasi-?)?quote|rename|set!|syntax-(?:case|rules)|unless|unquote(?:-splicing)?|when)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        builtin: {
          // all functions of the base library of R7RS plus some of built-ins of R5Rs
          pattern: /((?:^|[^'`#])[(\[])(?:abs|and|append|apply|assoc|ass[qv]|binary-port\?|boolean=?\?|bytevector(?:-append|-copy|-copy!|-length|-u8-ref|-u8-set!|\?)?|caar|cadr|call-with-(?:current-continuation|port|values)|call\/cc|car|cdar|cddr|cdr|ceiling|char(?:->integer|-ready\?|\?|<\?|<=\?|=\?|>\?|>=\?)|close-(?:input-port|output-port|port)|complex\?|cons|current-(?:error|input|output)-port|denominator|dynamic-wind|eof-object\??|eq\?|equal\?|eqv\?|error|error-object(?:-irritants|-message|\?)|eval|even\?|exact(?:-integer-sqrt|-integer\?|\?)?|expt|features|file-error\?|floor(?:-quotient|-remainder|\/)?|flush-output-port|for-each|gcd|get-output-(?:bytevector|string)|inexact\??|input-port(?:-open\?|\?)|integer(?:->char|\?)|lcm|length|list(?:->string|->vector|-copy|-ref|-set!|-tail|\?)?|make-(?:bytevector|list|parameter|string|vector)|map|max|member|memq|memv|min|modulo|negative\?|newline|not|null\?|number(?:->string|\?)|numerator|odd\?|open-(?:input|output)-(?:bytevector|string)|or|output-port(?:-open\?|\?)|pair\?|peek-char|peek-u8|port\?|positive\?|procedure\?|quotient|raise|raise-continuable|rational\?|rationalize|read-(?:bytevector|bytevector!|char|error\?|line|string|u8)|real\?|remainder|reverse|round|set-c[ad]r!|square|string(?:->list|->number|->symbol|->utf8|->vector|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?|<\?|<=\?|=\?|>\?|>=\?)?|substring|symbol(?:->string|\?|=\?)|syntax-error|textual-port\?|truncate(?:-quotient|-remainder|\/)?|u8-ready\?|utf8->string|values|vector(?:->list|->string|-append|-copy|-copy!|-fill!|-for-each|-length|-map|-ref|-set!|\?)?|with-exception-handler|write-(?:bytevector|char|string|u8)|zero\?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        operator: {
          pattern: /((?:^|[^'`#])[(\[])(?:[-+*%/]|[<>]=?|=>?)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        number: {
          // The number pattern from [the R7RS spec](https://small.r7rs.org/attachment/r7rs.pdf).
          //
          // <number>      := <num 2>|<num 8>|<num 10>|<num 16>
          // <num R>       := <prefix R><complex R>
          // <complex R>   := <real R>(?:@<real R>|<imaginary R>)?|<imaginary R>
          // <imaginary R> := [+-](?:<ureal R>|(?:inf|nan)\.0)?i
          // <real R>      := [+-]?<ureal R>|[+-](?:inf|nan)\.0
          // <ureal R>     := <uint R>(?:\/<uint R>)?
          //                | <decimal R>
          //
          // <decimal 10>  := (?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?
          // <uint R>      := <digit R>+
          // <prefix R>    := <radix R>(?:#[ei])?|(?:#[ei])?<radix R>
          // <radix 2>     := #b
          // <radix 8>     := #o
          // <radix 10>    := (?:#d)?
          // <radix 16>    := #x
          // <digit 2>     := [01]
          // <digit 8>     := [0-7]
          // <digit 10>    := \d
          // <digit 16>    := [0-9a-f]
          //
          // The problem with this grammar is that the resulting regex is way to complex, so we simplify by grouping all
          // non-decimal bases together. This results in a decimal (dec) and combined binary, octal, and hexadecimal (box)
          // pattern:
          pattern: RegExp(
            r({
              "<ureal dec>": /\d+(?:\/\d+)|(?:\d+(?:\.\d*)?|\.\d+)(?:[esfdl][+-]?\d+)?/.source,
              "<real dec>": /[+-]?<ureal dec>|[+-](?:inf|nan)\.0/.source,
              "<imaginary dec>": /[+-](?:<ureal dec>|(?:inf|nan)\.0)?i/.source,
              "<complex dec>": /<real dec>(?:@<real dec>|<imaginary dec>)?|<imaginary dec>/.source,
              "<num dec>": /(?:#d(?:#[ei])?|#[ei](?:#d)?)?<complex dec>/.source,
              "<ureal box>": /[0-9a-f]+(?:\/[0-9a-f]+)?/.source,
              "<real box>": /[+-]?<ureal box>|[+-](?:inf|nan)\.0/.source,
              "<imaginary box>": /[+-](?:<ureal box>|(?:inf|nan)\.0)?i/.source,
              "<complex box>": /<real box>(?:@<real box>|<imaginary box>)?|<imaginary box>/.source,
              "<num box>": /#[box](?:#[ei])?|(?:#[ei])?#[box]<complex box>/.source,
              "<number>": /(^|[()\[\]\s])(?:<num dec>|<num box>)(?=[()\[\]\s]|$)/.source
            }),
            "i"
          ),
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[()\[\]\s])#(?:[ft]|false|true)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        function: {
          pattern: /((?:^|[^'`#])[(\[])(?:[^|()\[\]'\s]+|\|(?:[^\\|]|\\.)*\|)(?=[()\[\]\s]|$)/,
          lookbehind: !0
        },
        identifier: {
          pattern: /(^|[()\[\]\s])\|(?:[^\\|]|\\.)*\|(?=[()\[\]\s]|$)/,
          lookbehind: !0,
          greedy: !0
        },
        punctuation: /[()\[\]']/
      };
      function r(a) {
        for (var i in a)
          a[i] = a[i].replace(/<[\w\s]+>/g, function(s) {
            return "(?:" + a[s].trim() + ")";
          });
        return a[i];
      }
    })(t);
  }
  return dm;
}
var pm, $R;
function M8() {
  if ($R) return pm;
  $R = 1;
  var e = qv();
  pm = t, t.displayName = "lilypond", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      for (var a = /\((?:[^();"#\\]|\\[\s\S]|;.*(?!.)|"(?:[^"\\]|\\.)*"|#(?:\{(?:(?!#\})[\s\S])*#\}|[^{])|<expr>)*\)/.source, i = 5, s = 0; s < i; s++)
        a = a.replace(/<expr>/g, function() {
          return a;
        });
      a = a.replace(/<expr>/g, /[^\s\S]/.source);
      var u = r.languages.lilypond = {
        comment: /%(?:(?!\{).*|\{[\s\S]*?%\})/,
        "embedded-scheme": {
          pattern: RegExp(
            /(^|[=\s])#(?:"(?:[^"\\]|\\.)*"|[^\s()"]*(?:[^\s()]|<expr>))/.source.replace(
              /<expr>/g,
              function() {
                return a;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            scheme: {
              pattern: /^(#)[\s\S]+$/,
              lookbehind: !0,
              alias: "language-scheme",
              inside: {
                "embedded-lilypond": {
                  pattern: /#\{[\s\S]*?#\}/,
                  greedy: !0,
                  inside: {
                    punctuation: /^#\{|#\}$/,
                    lilypond: {
                      pattern: /[\s\S]+/,
                      alias: "language-lilypond",
                      inside: null
                      // see below
                    }
                  }
                },
                rest: r.languages.scheme
              }
            },
            punctuation: /#/
          }
        },
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": {
          pattern: /(\\new\s+)[\w-]+/,
          lookbehind: !0
        },
        keyword: {
          pattern: /\\[a-z][-\w]*/i,
          inside: {
            punctuation: /^\\/
          }
        },
        operator: /[=|]|<<|>>/,
        punctuation: {
          pattern: /(^|[a-z\d])(?:'+|,+|[_^]?-[_^]?(?:[-+^!>._]|(?=\d))|[_^]\.?|[.!])|[{}()[\]<>^~]|\\[()[\]<>\\!]|--|__/,
          lookbehind: !0
        },
        number: /\b\d+(?:\/\d+)?\b/
      };
      u["embedded-scheme"].inside.scheme.inside["embedded-lilypond"].inside.lilypond.inside = u, r.languages.ly = u;
    }(n);
  }
  return pm;
}
var fm, UR;
function F8() {
  if (UR) return fm;
  UR = 1;
  var e = Mn();
  fm = t, t.displayName = "liquid", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.liquid = {
      comment: {
        pattern: /(^\{%\s*comment\s*%\})[\s\S]+(?=\{%\s*endcomment\s*%\}$)/,
        lookbehind: !0
      },
      delimiter: {
        pattern: /^\{(?:\{\{|[%\{])-?|-?(?:\}\}|[%\}])\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      keyword: /\b(?:as|assign|break|(?:end)?(?:capture|case|comment|for|form|if|paginate|raw|style|tablerow|unless)|continue|cycle|decrement|echo|else|elsif|in|include|increment|limit|liquid|offset|range|render|reversed|section|when|with)\b/,
      object: /\b(?:address|all_country_option_tags|article|block|blog|cart|checkout|collection|color|country|country_option_tags|currency|current_page|current_tags|customer|customer_address|date|discount_allocation|discount_application|external_video|filter|filter_value|font|forloop|fulfillment|generic_file|gift_card|group|handle|image|line_item|link|linklist|localization|location|measurement|media|metafield|model|model_source|order|page|page_description|page_image|page_title|part|policy|product|product_option|recommendations|request|robots|routes|rule|script|search|selling_plan|selling_plan_allocation|selling_plan_group|shipping_method|shop|shop_locale|sitemap|store_availability|tax_line|template|theme|transaction|unit_price_measurement|user_agent|variant|video|video_source)\b/,
      function: [
        {
          pattern: /(\|\s*)\w+/,
          lookbehind: !0,
          alias: "filter"
        },
        {
          // array functions
          pattern: /(\.\s*)(?:first|last|size)/,
          lookbehind: !0
        }
      ],
      boolean: /\b(?:false|nil|true)\b/,
      range: {
        pattern: /\.\./,
        alias: "operator"
      },
      // https://github.com/Shopify/liquid/blob/698f5e0d967423e013f6169d9111bd969bd78337/lib/liquid/lexer.rb#L21
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /[!=]=|<>|[<>]=?|[|?:=-]|\b(?:and|contains(?=\s)|or)\b/,
      punctuation: /[.,\[\]()]/,
      empty: {
        pattern: /\bempty\b/,
        alias: "keyword"
      }
    }, n.hooks.add("before-tokenize", function(r) {
      var a = /\{%\s*comment\s*%\}[\s\S]*?\{%\s*endcomment\s*%\}|\{(?:%[\s\S]*?%|\{\{[\s\S]*?\}\}|\{[\s\S]*?\})\}/g, i = !1;
      n.languages["markup-templating"].buildPlaceholders(
        r,
        "liquid",
        a,
        function(s) {
          var u = /^\{%-?\s*(\w+)/.exec(s);
          if (u) {
            var c = u[1];
            if (c === "raw" && !i)
              return i = !0, !0;
            if (c === "endraw")
              return i = !1, !0;
          }
          return !i;
        }
      );
    }), n.hooks.add("after-tokenize", function(r) {
      n.languages["markup-templating"].tokenizePlaceholders(r, "liquid");
    });
  }
  return fm;
}
var gm, jR;
function P8() {
  if (jR) return gm;
  jR = 1, gm = e, e.displayName = "lisp", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(y) {
        return RegExp(/(\()/.source + "(?:" + y + ")" + /(?=[\s\)])/.source);
      }
      function a(y) {
        return RegExp(
          /([\s([])/.source + "(?:" + y + ")" + /(?=[\s)])/.source
        );
      }
      var i = /(?!\d)[-+*/~!@$%^=<>{}\w]+/.source, s = "&" + i, u = "(\\()", c = "(?=\\))", d = "(?=\\s)", p = /(?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\))*\))*\))*/.source, f = {
        // Three or four semicolons are considered a heading.
        // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
        heading: {
          pattern: /;;;.*/,
          alias: ["comment", "title"]
        },
        comment: /;.*/,
        string: {
          pattern: /"(?:[^"\\]|\\.)*"/,
          greedy: !0,
          inside: {
            argument: /[-A-Z]+(?=[.,\s])/,
            symbol: RegExp("`" + i + "'")
          }
        },
        "quoted-symbol": {
          pattern: RegExp("#?'" + i),
          alias: ["variable", "symbol"]
        },
        "lisp-property": {
          pattern: RegExp(":" + i),
          alias: "property"
        },
        splice: {
          pattern: RegExp(",@?" + i),
          alias: ["symbol", "variable"]
        },
        keyword: [
          {
            pattern: RegExp(
              u + "(?:and|(?:cl-)?letf|cl-loop|cond|cons|error|if|(?:lexical-)?let\\*?|message|not|null|or|provide|require|setq|unless|use-package|when|while)" + d
            ),
            lookbehind: !0
          },
          {
            pattern: RegExp(
              u + "(?:append|by|collect|concat|do|finally|for|in|return)" + d
            ),
            lookbehind: !0
          }
        ],
        declare: {
          pattern: r(/declare/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        interactive: {
          pattern: r(/interactive/.source),
          lookbehind: !0,
          alias: "keyword"
        },
        boolean: {
          pattern: a(/nil|t/.source),
          lookbehind: !0
        },
        number: {
          pattern: a(/[-+]?\d+(?:\.\d*)?/.source),
          lookbehind: !0
        },
        defvar: {
          pattern: RegExp(u + "def(?:const|custom|group|var)\\s+" + i),
          lookbehind: !0,
          inside: {
            keyword: /^def[a-z]+/,
            variable: RegExp(i)
          }
        },
        defun: {
          pattern: RegExp(
            u + /(?:cl-)?(?:defmacro|defun\*?)\s+/.source + i + /\s+\(/.source + p + /\)/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^(?:cl-)?def\S+/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            function: {
              pattern: RegExp("(^\\s)" + i),
              lookbehind: !0
            },
            punctuation: /[()]/
          }
        },
        lambda: {
          pattern: RegExp(
            u + "lambda\\s+\\(\\s*(?:&?" + i + "(?:\\s+&?" + i + ")*\\s*)?\\)"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            keyword: /^lambda/,
            // See below, this property needs to be defined later so that it can
            // reference the language object.
            arguments: null,
            punctuation: /[()]/
          }
        },
        car: {
          pattern: RegExp(u + i),
          lookbehind: !0
        },
        punctuation: [
          // open paren, brackets, and close paren
          /(?:['`,]?\(|[)\[\]])/,
          // cons
          {
            pattern: /(\s)\.(?=\s)/,
            lookbehind: !0
          }
        ]
      }, m = {
        "lisp-marker": RegExp(s),
        varform: {
          pattern: RegExp(
            /\(/.source + i + /\s+(?=\S)/.source + p + /\)/.source
          ),
          inside: f
        },
        argument: {
          pattern: RegExp(/(^|[\s(])/.source + i),
          lookbehind: !0,
          alias: "variable"
        },
        rest: f
      }, h = "\\S+(?:\\s+\\S+)*", E = {
        pattern: RegExp(u + p + c),
        lookbehind: !0,
        inside: {
          "rest-vars": {
            pattern: RegExp("&(?:body|rest)\\s+" + h),
            inside: m
          },
          "other-marker-vars": {
            pattern: RegExp("&(?:aux|optional)\\s+" + h),
            inside: m
          },
          keys: {
            pattern: RegExp("&key\\s+" + h + "(?:\\s+&allow-other-keys)?"),
            inside: m
          },
          argument: {
            pattern: RegExp(i),
            alias: "variable"
          },
          punctuation: /[()]/
        }
      };
      f.lambda.inside.arguments = E, f.defun.inside.arguments = n.util.clone(E), f.defun.inside.arguments.inside.sublist = E, n.languages.lisp = f, n.languages.elisp = f, n.languages.emacs = f, n.languages["emacs-lisp"] = f;
    })(t);
  }
  return gm;
}
var mm, qR;
function B8() {
  if (qR) return mm;
  qR = 1, mm = e, e.displayName = "livescript", e.aliases = [];
  function e(t) {
    t.languages.livescript = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0
        }
      ],
      "interpolated-string": {
        /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
         * forcing it to match """-quoted string when it would otherwise match "-quoted first. */
        pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          variable: {
            pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
            lookbehind: !0
          },
          interpolation: {
            pattern: /(^|[^\\])#\{[^}]+\}/m,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^#\{|\}$/,
                alias: "variable"
              }
              // See rest below
            }
          },
          string: /[\s\S]+/
        }
      },
      string: [
        {
          pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
          greedy: !0
        },
        {
          pattern: /<\[[\s\S]*?\]>/,
          greedy: !0
        },
        /\\[^\s,;\])}]+/
      ],
      regex: [
        {
          pattern: /\/\/(?:\[[^\r\n\]]*\]|\\.|(?!\/\/)[^\\\[])+\/\/[gimyu]{0,5}/,
          greedy: !0,
          inside: {
            comment: {
              pattern: /(^|[^\\])#.*/,
              lookbehind: !0
            }
          }
        },
        {
          pattern: /\/(?:\[[^\r\n\]]*\]|\\.|[^/\\\r\n\[])+\/[gimyu]{0,5}/,
          greedy: !0
        }
      ],
      keyword: {
        pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
        lookbehind: !0
      },
      "keyword-operator": {
        pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?: not|nt)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
        lookbehind: !0,
        alias: "operator"
      },
      boolean: {
        pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
        lookbehind: !0
      },
      argument: {
        // Don't match .&. nor &&
        pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
        lookbehind: !0,
        alias: "variable"
      },
      number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
      identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
      operator: [
        // Spaced .
        {
          pattern: /( )\.(?= )/,
          lookbehind: !0
        },
        // Full list, in order:
        // .= .~ .. ...
        // .&. .^. .<<. .>>. .>>>.
        // := :: ::=
        // &&
        // || |>
        // < << <<< <<<<
        // <- <-- <-! <--!
        // <~ <~~ <~! <~~!
        // <| <= <?
        // > >> >= >?
        // - -- -> -->
        // + ++
        // @ @@
        // % %%
        // * **
        // ! != !~=
        // !~> !~~>
        // !-> !-->
        // ~ ~> ~~> ~=
        // = ==
        // ^ ^^
        // / ?
        /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
      ],
      punctuation: /[(){}\[\]|.,:;`]/
    }, t.languages.livescript["interpolated-string"].inside.interpolation.inside.rest = t.languages.livescript;
  }
  return mm;
}
var hm, zR;
function $8() {
  if (zR) return hm;
  zR = 1, hm = e, e.displayName = "llvm", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.llvm = {
        comment: /;.*/,
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        boolean: /\b(?:false|true)\b/,
        variable: /[%@!#](?:(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+|\d+)/i,
        label: /(?!\d)(?:[-$.\w]|\\[a-f\d]{2})+:/i,
        type: {
          pattern: /\b(?:double|float|fp128|half|i[1-9]\d*|label|metadata|ppc_fp128|token|void|x86_fp80|x86_mmx)\b/,
          alias: "class-name"
        },
        keyword: /\b[a-z_][a-z_0-9]*\b/,
        number: /[+-]?\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-Fa-f]+\b|\b0xK[\dA-Fa-f]{20}\b|\b0x[ML][\dA-Fa-f]{32}\b|\b0xH[\dA-Fa-f]{4}\b/,
        punctuation: /[{}[\];(),.!*=<>]/
      };
    })(t);
  }
  return hm;
}
var bm, GR;
function U8() {
  if (GR) return bm;
  GR = 1, bm = e, e.displayName = "log", e.aliases = [];
  function e(t) {
    t.languages.log = {
      string: {
        // Single-quoted strings must not be confused with plain text. E.g. Can't isn't Susan's Chris' toy
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?![st] | \w)(?:[^'\\\r\n]|\\.)*'/,
        greedy: !0
      },
      exception: {
        pattern: /(^|[^\w.])[a-z][\w.]*(?:Error|Exception):.*(?:(?:\r\n?|\n)[ \t]*(?:at[ \t].+|\.{3}.*|Caused by:.*))+(?:(?:\r\n?|\n)[ \t]*\.\.\. .*)?/,
        lookbehind: !0,
        greedy: !0,
        alias: ["javastacktrace", "language-javastacktrace"],
        inside: t.languages.javastacktrace || {
          keyword: /\bat\b/,
          function: /[a-z_][\w$]*(?=\()/,
          punctuation: /[.:()]/
        }
      },
      level: [
        {
          pattern: /\b(?:ALERT|CRIT|CRITICAL|EMERG|EMERGENCY|ERR|ERROR|FAILURE|FATAL|SEVERE)\b/,
          alias: ["error", "important"]
        },
        {
          pattern: /\b(?:WARN|WARNING|WRN)\b/,
          alias: ["warning", "important"]
        },
        {
          pattern: /\b(?:DISPLAY|INF|INFO|NOTICE|STATUS)\b/,
          alias: ["info", "keyword"]
        },
        {
          pattern: /\b(?:DBG|DEBUG|FINE)\b/,
          alias: ["debug", "keyword"]
        },
        {
          pattern: /\b(?:FINER|FINEST|TRACE|TRC|VERBOSE|VRB)\b/,
          alias: ["trace", "comment"]
        }
      ],
      property: {
        pattern: /((?:^|[\]|])[ \t]*)[a-z_](?:[\w-]|\b\/\b)*(?:[. ]\(?\w(?:[\w-]|\b\/\b)*\)?)*:(?=\s)/im,
        lookbehind: !0
      },
      separator: {
        pattern: /(^|[^-+])-{3,}|={3,}|\*{3,}|- - /m,
        lookbehind: !0,
        alias: "comment"
      },
      url: /\b(?:file|ftp|https?):\/\/[^\s|,;'"]*[^\s|,;'">.]/,
      email: {
        pattern: /(^|\s)[-\w+.]+@[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)+(?=\s)/,
        lookbehind: !0,
        alias: "url"
      },
      "ip-address": {
        pattern: /\b(?:\d{1,3}(?:\.\d{1,3}){3})\b/,
        alias: "constant"
      },
      "mac-address": {
        pattern: /\b[a-f0-9]{2}(?::[a-f0-9]{2}){5}\b/i,
        alias: "constant"
      },
      domain: {
        pattern: /(^|\s)[a-z][a-z0-9-]*(?:\.[a-z][a-z0-9-]*)*\.[a-z][a-z0-9-]+(?=\s)/,
        lookbehind: !0,
        alias: "constant"
      },
      uuid: {
        pattern: /\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
        alias: "constant"
      },
      hash: {
        pattern: /\b(?:[a-f0-9]{32}){1,2}\b/i,
        alias: "constant"
      },
      "file-path": {
        pattern: /\b[a-z]:[\\/][^\s|,;:(){}\[\]"']+|(^|[\s:\[\](>|])\.{0,2}\/\w[^\s|,;:(){}\[\]"']*/i,
        lookbehind: !0,
        greedy: !0,
        alias: "string"
      },
      date: {
        pattern: RegExp(
          /\b\d{4}[-/]\d{2}[-/]\d{2}(?:T(?=\d{1,2}:)|(?=\s\d{1,2}:))/.source + "|" + /\b\d{1,4}[-/ ](?:\d{1,2}|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)[-/ ]\d{2,4}T?\b/.source + "|" + /\b(?:(?:Fri|Mon|Sat|Sun|Thu|Tue|Wed)(?:\s{1,2}(?:Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep))?|Apr|Aug|Dec|Feb|Jan|Jul|Jun|Mar|May|Nov|Oct|Sep)\s{1,2}\d{1,2}\b/.source,
          "i"
        ),
        alias: "number"
      },
      time: {
        pattern: /\b\d{1,2}:\d{1,2}:\d{1,2}(?:[.,:]\d+)?(?:\s?[+-]\d{2}:?\d{2}|Z)?\b/,
        alias: "number"
      },
      boolean: /\b(?:false|null|true)\b/i,
      number: {
        pattern: /(^|[^.\w])(?:0x[a-f0-9]+|0o[0-7]+|0b[01]+|v?\d[\da-f]*(?:\.\d+)*(?:e[+-]?\d+)?[a-z]{0,3}\b)\b(?!\.\w)/i,
        lookbehind: !0
      },
      operator: /[;:?<=>~/@!$%&+\-|^(){}*#]/,
      punctuation: /[\[\].,]/
    };
  }
  return bm;
}
var ym, HR;
function j8() {
  if (HR) return ym;
  HR = 1, ym = e, e.displayName = "lolcode", e.aliases = [];
  function e(t) {
    t.languages.lolcode = {
      comment: [/\bOBTW\s[\s\S]*?\sTLDR\b/, /\bBTW.+/],
      string: {
        pattern: /"(?::.|[^":])*"/,
        inside: {
          variable: /:\{[^}]+\}/,
          symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
        },
        greedy: !0
      },
      number: /(?:\B-)?(?:\b\d+(?:\.\d*)?|\B\.\d+)/,
      symbol: {
        pattern: /(^|\s)(?:A )?(?:BUKKIT|NOOB|NUMBAR|NUMBR|TROOF|YARN)(?=\s|,|$)/,
        lookbehind: !0,
        inside: {
          keyword: /A(?=\s)/
        }
      },
      label: {
        pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
        lookbehind: !0,
        alias: "string"
      },
      function: {
        pattern: /((?:^|\s)(?:HOW IZ I|I IZ|IZ) )[a-zA-Z]\w*/,
        lookbehind: !0
      },
      keyword: [
        {
          pattern: /(^|\s)(?:AN|FOUND YR|GIMMEH|GTFO|HAI|HAS A|HOW IZ I|I HAS A|I IZ|IF U SAY SO|IM IN YR|IM OUTTA YR|IS NOW(?: A)?|ITZ(?: A)?|IZ|KTHX|KTHXBYE|LIEK(?: A)?|MAEK|MEBBE|MKAY|NERFIN|NO WAI|O HAI IM|O RLY\?|OIC|OMG|OMGWTF|R|SMOOSH|SRS|TIL|UPPIN|VISIBLE|WILE|WTF\?|YA RLY|YR)(?=\s|,|$)/,
          lookbehind: !0
        },
        /'Z(?=\s|,|$)/
      ],
      boolean: {
        pattern: /(^|\s)(?:FAIL|WIN)(?=\s|,|$)/,
        lookbehind: !0
      },
      variable: {
        pattern: /(^|\s)IT(?=\s|,|$)/,
        lookbehind: !0
      },
      operator: {
        pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:ALL|ANY|BIGGR|BOTH|DIFF|EITHER|MOD|PRODUKT|QUOSHUNT|SMALLR|SUM|WON) OF)(?=\s|,|$)/,
        lookbehind: !0
      },
      punctuation: /\.{3}|…|,|!/
    };
  }
  return ym;
}
var vm, VR;
function q8() {
  if (VR) return vm;
  VR = 1, vm = e, e.displayName = "magma", e.aliases = [];
  function e(t) {
    t.languages.magma = {
      output: {
        pattern: /^(>.*(?:\r(?:\n|(?!\n))|\n))(?!>)(?:.+|(?:\r(?:\n|(?!\n))|\n)(?!>).*)(?:(?:\r(?:\n|(?!\n))|\n)(?!>).*)*/m,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\"])"(?:[^\r\n\\"]|\\.)*"/,
        lookbehind: !0,
        greedy: !0
      },
      // http://magma.maths.usyd.edu.au/magma/handbook/text/82
      keyword: /\b(?:_|adj|and|assert|assert2|assert3|assigned|break|by|case|cat|catch|clear|cmpeq|cmpne|continue|declare|default|delete|diff|div|do|elif|else|end|eq|error|eval|exists|exit|for|forall|forward|fprintf|freeze|function|ge|gt|if|iload|import|in|intrinsic|is|join|le|load|local|lt|meet|mod|ne|not|notadj|notin|notsubset|or|print|printf|procedure|quit|random|read|readi|repeat|require|requirege|requirerange|restore|return|save|sdiff|select|subset|then|time|to|try|until|vprint|vprintf|vtime|when|where|while|xor)\b/,
      boolean: /\b(?:false|true)\b/,
      generator: {
        pattern: /\b[a-z_]\w*(?=\s*<)/i,
        alias: "class-name"
      },
      function: /\b[a-z_]\w*(?=\s*\()/i,
      number: {
        pattern: /(^|[^\w.]|\.\.)(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?:_[a-z]?)?(?=$|[^\w.]|\.\.)/,
        lookbehind: !0
      },
      operator: /->|[-+*/^~!|#=]|:=|\.\./,
      punctuation: /[()[\]{}<>,;.:]/
    };
  }
  return vm;
}
var Em, WR;
function z8() {
  if (WR) return Em;
  WR = 1, Em = e, e.displayName = "makefile", e.aliases = [];
  function e(t) {
    t.languages.makefile = {
      comment: {
        pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
        lookbehind: !0
      },
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "builtin-target": {
        pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
        alias: "builtin"
      },
      target: {
        pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
        alias: "symbol",
        inside: {
          variable: /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
        }
      },
      variable: /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
      // Directives
      keyword: /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
      function: {
        pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
        lookbehind: !0
      },
      operator: /(?:::|[?:+!])?=|[|@]/,
      punctuation: /[:;(){}]/
    };
  }
  return Em;
}
var Sm, KR;
function G8() {
  if (KR) return Sm;
  KR = 1, Sm = e, e.displayName = "markdown", e.aliases = ["md"];
  function e(t) {
    (function(n) {
      var r = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function a(m) {
        return m = m.replace(/<inner>/g, function() {
          return r;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + m + ")");
      }
      var i = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, s = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
        /__/g,
        function() {
          return i;
        }
      ), u = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      n.languages.markdown = n.languages.extend("markup", {}), n.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
          pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^---|---$/,
            "front-matter": {
              pattern: /\S+(?:\s+\S+)*/,
              alias: ["yaml", "language-yaml"],
              inside: n.languages.yaml
            }
          }
        },
        blockquote: {
          // > ...
          pattern: /^>(?:[\t ]*>)*/m,
          alias: "punctuation"
        },
        table: {
          pattern: RegExp(
            "^" + s + u + "(?:" + s + ")*",
            "m"
          ),
          inside: {
            "table-data-rows": {
              pattern: RegExp(
                "^(" + s + u + ")(?:" + s + ")*$"
              ),
              lookbehind: !0,
              inside: {
                "table-data": {
                  pattern: RegExp(i),
                  inside: n.languages.markdown
                },
                punctuation: /\|/
              }
            },
            "table-line": {
              pattern: RegExp("^(" + s + ")" + u + "$"),
              lookbehind: !0,
              inside: {
                punctuation: /\||:?-{3,}:?/
              }
            },
            "table-header-row": {
              pattern: RegExp("^" + s + "$"),
              inside: {
                "table-header": {
                  pattern: RegExp(i),
                  alias: "important",
                  inside: n.languages.markdown
                },
                punctuation: /\|/
              }
            }
          }
        },
        code: [
          {
            // Prefixed by 4 spaces or 1 tab and preceded by an empty line
            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
            lookbehind: !0,
            alias: "keyword"
          },
          {
            // ```optional language
            // code block
            // ```
            pattern: /^```[\s\S]*?^```$/m,
            greedy: !0,
            inside: {
              "code-block": {
                pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                lookbehind: !0
              },
              "code-language": {
                pattern: /^(```).+/,
                lookbehind: !0
              },
              punctuation: /```/
            }
          }
        ],
        title: [
          {
            // title 1
            // =======
            // title 2
            // -------
            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
            alias: "important",
            inside: {
              punctuation: /==+$|--+$/
            }
          },
          {
            // # title 1
            // ###### title 6
            pattern: /(^\s*)#.+/m,
            lookbehind: !0,
            alias: "important",
            inside: {
              punctuation: /^#+|#+$/
            }
          }
        ],
        hr: {
          // ***
          // ---
          // * * *
          // -----------
          pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        list: {
          // * item
          // + item
          // - item
          // 1. item
          pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        "url-reference": {
          // [id]: http://example.com "Optional title"
          // [id]: http://example.com 'Optional title'
          // [id]: http://example.com (Optional title)
          // [id]: <http://example.com> "Optional title"
          pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
          inside: {
            variable: {
              pattern: /^(!?\[)[^\]]+/,
              lookbehind: !0
            },
            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            punctuation: /^[\[\]!:]|[<>]/
          },
          alias: "url"
        },
        bold: {
          // **strong**
          // __strong__
          // allow one nested instance of italic text using the same delimiter
          pattern: a(
            /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^..)[\s\S]+(?=..$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /\*\*|__/
          }
        },
        italic: {
          // *em*
          // _em_
          // allow one nested instance of bold text using the same delimiter
          pattern: a(
            /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^.)[\s\S]+(?=.$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /[*_]/
          }
        },
        strike: {
          // ~~strike through~~
          // ~strike~
          // eslint-disable-next-line regexp/strict
          pattern: a(/(~~?)(?:(?!~)<inner>)+\2/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^~~?)[\s\S]+(?=\1$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /~~?/
          }
        },
        "code-snippet": {
          // `code`
          // ``code``
          pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
          lookbehind: !0,
          greedy: !0,
          alias: ["code", "keyword"]
        },
        url: {
          // [example](http://example.com "Optional title")
          // [example][id]
          // [example] [id]
          pattern: a(
            /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            operator: /^!/,
            content: {
              pattern: /(^\[)[^\]]+(?=\])/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            variable: {
              pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
              lookbehind: !0
            },
            url: {
              pattern: /(^\]\()[^\s)]+/,
              lookbehind: !0
            },
            string: {
              pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
              lookbehind: !0
            }
          }
        }
      }), ["url", "bold", "italic", "strike"].forEach(function(m) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(h) {
          m !== h && (n.languages.markdown[m].inside.content.inside[h] = n.languages.markdown[h]);
        });
      }), n.hooks.add("after-tokenize", function(m) {
        if (m.language !== "markdown" && m.language !== "md")
          return;
        function h(E) {
          if (!(!E || typeof E == "string"))
            for (var y = 0, w = E.length; y < w; y++) {
              var x = E[y];
              if (x.type !== "code") {
                h(x.content);
                continue;
              }
              var I = x.content[1], S = x.content[3];
              if (I && S && I.type === "code-language" && S.type === "code-block" && typeof I.content == "string") {
                var C = I.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                C = (/[a-z][\w-]*/i.exec(C) || [""])[0].toLowerCase();
                var T = "language-" + C;
                S.alias ? typeof S.alias == "string" ? S.alias = [S.alias, T] : S.alias.push(T) : S.alias = [T];
              }
            }
        }
        h(m.tokens);
      }), n.hooks.add("wrap", function(m) {
        if (m.type === "code-block") {
          for (var h = "", E = 0, y = m.classes.length; E < y; E++) {
            var w = m.classes[E], x = /language-(.+)/.exec(w);
            if (x) {
              h = x[1];
              break;
            }
          }
          var I = n.languages[h];
          if (I)
            m.content = n.highlight(
              f(m.content.value),
              I,
              h
            );
          else if (h && h !== "none" && n.plugins.autoloader) {
            var S = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            m.attributes.id = S, n.plugins.autoloader.loadLanguages(h, function() {
              var C = document.getElementById(S);
              C && (C.innerHTML = n.highlight(
                C.textContent,
                n.languages[h],
                h
              ));
            });
          }
        }
      });
      var c = RegExp(n.languages.markup.tag.pattern.source, "gi"), d = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
      }, p = String.fromCodePoint || String.fromCharCode;
      function f(m) {
        var h = m.replace(c, "");
        return h = h.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(E, y) {
          if (y = y.toLowerCase(), y[0] === "#") {
            var w;
            return y[1] === "x" ? w = parseInt(y.slice(2), 16) : w = Number(y.slice(1)), p(w);
          } else {
            var x = d[y];
            return x || E;
          }
        }), h;
      }
      n.languages.md = n.languages.markdown;
    })(t);
  }
  return Sm;
}
var xm, YR;
function H8() {
  if (YR) return xm;
  YR = 1, xm = e, e.displayName = "matlab", e.aliases = [];
  function e(t) {
    t.languages.matlab = {
      comment: [/%\{[\s\S]*?\}%/, /%.+/],
      string: {
        pattern: /\B'(?:''|[^'\r\n])*'/,
        greedy: !0
      },
      // FIXME We could handle imaginary numbers as a whole
      number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
      keyword: /\b(?:NaN|break|case|catch|continue|else|elseif|end|for|function|if|inf|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
      function: /\b(?!\d)\w+(?=\s*\()/,
      operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
      punctuation: /\.{3}|[.,;\[\](){}!]/
    };
  }
  return xm;
}
var Tm, XR;
function V8() {
  if (XR) return Tm;
  XR = 1, Tm = e, e.displayName = "maxscript", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:about|and|animate|as|at|attributes|by|case|catch|collect|continue|coordsys|do|else|exit|fn|for|from|function|global|if|in|local|macroscript|mapped|max|not|of|off|on|or|parameters|persistent|plugin|rcmenu|return|rollout|set|struct|then|throw|to|tool|try|undo|utility|when|where|while|with)\b/i;
      n.languages.maxscript = {
        comment: {
          pattern: /\/\*[\s\S]*?(?:\*\/|$)|--.*/,
          greedy: !0
        },
        string: {
          pattern: /(^|[^"\\@])(?:"(?:[^"\\]|\\[\s\S])*"|@"[^"]*")/,
          lookbehind: !0,
          greedy: !0
        },
        path: {
          pattern: /\$(?:[\w/\\.*?]|'[^']*')*/,
          greedy: !0,
          alias: "string"
        },
        "function-call": {
          pattern: RegExp(
            "((?:" + // start of line
            (/^/.source + "|" + // operators and other language constructs
            /[;=<>+\-*/^({\[]/.source + "|" + // keywords as part of statements
            /\b(?:and|by|case|catch|collect|do|else|if|in|not|or|return|then|to|try|where|while|with)\b/.source) + ")[ 	]*)(?!" + r.source + ")" + /[a-z_]\w*\b/.source + "(?=[ 	]*(?:" + // variable
            ("(?!" + r.source + ")" + /[a-z_]/.source + "|" + // number
            /\d|-\.?\d/.source + "|" + // other expressions or literals
            /[({'"$@#?]/.source) + "))",
            "im"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "function"
        },
        "function-definition": {
          pattern: /(\b(?:fn|function)\s+)\w+\b/i,
          lookbehind: !0,
          alias: "function"
        },
        argument: {
          pattern: /\b[a-z_]\w*(?=:)/i,
          alias: "attr-name"
        },
        keyword: r,
        boolean: /\b(?:false|true)\b/,
        time: {
          pattern: /(^|[^\w.])(?:(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?[msft])+|\d+:\d+(?:\.\d*)?)(?![\w.:])/,
          lookbehind: !0,
          alias: "number"
        },
        number: [
          {
            pattern: /(^|[^\w.])(?:(?:\d+(?:\.\d*)?|\.\d+)(?:[eEdD][+-]\d+|[LP])?|0x[a-fA-F0-9]+)(?![\w.:])/,
            lookbehind: !0
          },
          /\b(?:e|pi)\b/
        ],
        constant: /\b(?:dontcollect|ok|silentValue|undefined|unsupplied)\b/,
        color: {
          pattern: /\b(?:black|blue|brown|gray|green|orange|red|white|yellow)\b/i,
          alias: "constant"
        },
        operator: /[-+*/<>=!]=?|[&^?]|#(?!\()/,
        punctuation: /[()\[\]{}.:,;]|#(?=\()|\\$/m
      };
    })(t);
  }
  return Tm;
}
var wm, ZR;
function W8() {
  if (ZR) return wm;
  ZR = 1, wm = e, e.displayName = "mel", e.aliases = [];
  function e(t) {
    t.languages.mel = {
      comment: /\/\/.*/,
      code: {
        pattern: /`(?:\\.|[^\\`\r\n])*`/,
        greedy: !0,
        alias: "italic",
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: "punctuation"
          }
          // See rest below
        }
      },
      string: {
        pattern: /"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      variable: /\$\w+/,
      number: /\b0x[\da-fA-F]+\b|\b\d+(?:\.\d*)?|\B\.\d+/,
      flag: {
        pattern: /-[^\d\W]\w*/,
        alias: "operator"
      },
      keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
      function: /\b\w+(?=\()|\b(?:CBG|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|Mayatomr|about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
      operator: [
        /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
        {
          // We don't want to match <<
          pattern: /(^|[^<])<(?!<)/,
          lookbehind: !0
        },
        {
          // We don't want to match >>
          pattern: /(^|[^>])>(?!>)/,
          lookbehind: !0
        }
      ],
      punctuation: /<<|>>|[.,:;?\[\](){}]/
    }, t.languages.mel.code.inside.rest = t.languages.mel;
  }
  return wm;
}
var Am, JR;
function K8() {
  if (JR) return Am;
  JR = 1, Am = e, e.displayName = "mermaid", e.aliases = [];
  function e(t) {
    t.languages.mermaid = {
      comment: {
        pattern: /%%.*/,
        greedy: !0
      },
      style: {
        pattern: /^([ \t]*(?:classDef|linkStyle|style)[ \t]+[\w$-]+[ \t]+)\w.*[^\s;]/m,
        lookbehind: !0,
        inside: {
          property: /\b\w[\w-]*(?=[ \t]*:)/,
          operator: /:/,
          punctuation: /,/
        }
      },
      "inter-arrow-label": {
        pattern: /([^<>ox.=-])(?:-[-.]|==)(?![<>ox.=-])[ \t]*(?:"[^"\r\n]*"|[^\s".=-](?:[^\r\n.=-]*[^\s.=-])?)[ \t]*(?:\.+->?|--+[->]|==+[=>])(?![<>ox.=-])/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          arrow: {
            pattern: /(?:\.+->?|--+[->]|==+[=>])$/,
            alias: "operator"
          },
          label: {
            pattern: /^([\s\S]{2}[ \t]*)\S(?:[\s\S]*\S)?/,
            lookbehind: !0,
            alias: "property"
          },
          "arrow-head": {
            pattern: /^\S+/,
            alias: ["arrow", "operator"]
          }
        }
      },
      arrow: [
        // This might look complex but it really isn't.
        // There are many possible arrows (see tests) and it's impossible to fit all of them into one pattern. The
        // problem is that we only have one lookbehind per pattern. However, we cannot disallow too many arrow
        // characters in the one lookbehind because that would create too many false negatives. So we have to split the
        // arrows into different patterns.
        {
          // ER diagram
          pattern: /(^|[^{}|o.-])[|}][|o](?:--|\.\.)[|o][|{](?![{}|o.-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // flow chart
          // (?:==+|--+|-\.*-)
          pattern: /(^|[^<>ox.=-])(?:[<ox](?:==+|--+|-\.*-)[>ox]?|(?:==+|--+|-\.*-)[>ox]|===+|---+|-\.+-)(?![<>ox.=-])/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // sequence diagram
          pattern: /(^|[^<>()x-])(?:--?(?:>>|[x>)])(?![<>()x])|(?:<<|[x<(])--?(?!-))/,
          lookbehind: !0,
          alias: "operator"
        },
        {
          // class diagram
          pattern: /(^|[^<>|*o.-])(?:[*o]--|--[*o]|<\|?(?:--|\.\.)|(?:--|\.\.)\|?>|--|\.\.)(?![<>|*o.-])/,
          lookbehind: !0,
          alias: "operator"
        }
      ],
      label: {
        pattern: /(^|[^|<])\|(?:[^\r\n"|]|"[^"\r\n]*")+\|/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      text: {
        pattern: /(?:[(\[{]+|\b>)(?:[^\r\n"()\[\]{}]|"[^"\r\n]*")+(?:[)\]}]+|>)/,
        alias: "string"
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      annotation: {
        pattern: /<<(?:abstract|choice|enumeration|fork|interface|join|service)>>|\[\[(?:choice|fork|join)\]\]/i,
        alias: "important"
      },
      keyword: [
        // This language has both case-sensitive and case-insensitive keywords
        {
          pattern: /(^[ \t]*)(?:action|callback|class|classDef|classDiagram|click|direction|erDiagram|flowchart|gantt|gitGraph|graph|journey|link|linkStyle|pie|requirementDiagram|sequenceDiagram|stateDiagram|stateDiagram-v2|style|subgraph)(?![\w$-])/m,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^[ \t]*)(?:activate|alt|and|as|autonumber|deactivate|else|end(?:[ \t]+note)?|loop|opt|par|participant|rect|state|note[ \t]+(?:over|(?:left|right)[ \t]+of))(?![\w$-])/im,
          lookbehind: !0,
          greedy: !0
        }
      ],
      entity: /#[a-z0-9]+;/,
      operator: {
        pattern: /(\w[ \t]*)&(?=[ \t]*\w)|:::|:/,
        lookbehind: !0
      },
      punctuation: /[(){};]/
    };
  }
  return Am;
}
var Im, QR;
function Y8() {
  if (QR) return Im;
  QR = 1, Im = e, e.displayName = "mizar", e.aliases = [];
  function e(t) {
    t.languages.mizar = {
      comment: /::.+/,
      keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|end|environ|equals|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:ies|y)|when|where|with|wrt)\b/,
      parameter: {
        pattern: /\$(?:10|\d)/,
        alias: "variable"
      },
      variable: /\b\w+(?=:)/,
      number: /(?:\b|-)\d+\b/,
      operator: /\.\.\.|->|&|\.?=/,
      punctuation: /\(#|#\)|[,:;\[\](){}]/
    };
  }
  return Im;
}
var Rm, e_;
function X8() {
  if (e_) return Rm;
  e_ = 1, Rm = e, e.displayName = "mongodb", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        // query and projection
        "$eq",
        "$gt",
        "$gte",
        "$in",
        "$lt",
        "$lte",
        "$ne",
        "$nin",
        "$and",
        "$not",
        "$nor",
        "$or",
        "$exists",
        "$type",
        "$expr",
        "$jsonSchema",
        "$mod",
        "$regex",
        "$text",
        "$where",
        "$geoIntersects",
        "$geoWithin",
        "$near",
        "$nearSphere",
        "$all",
        "$elemMatch",
        "$size",
        "$bitsAllClear",
        "$bitsAllSet",
        "$bitsAnyClear",
        "$bitsAnySet",
        "$comment",
        "$elemMatch",
        "$meta",
        "$slice",
        // update
        "$currentDate",
        "$inc",
        "$min",
        "$max",
        "$mul",
        "$rename",
        "$set",
        "$setOnInsert",
        "$unset",
        "$addToSet",
        "$pop",
        "$pull",
        "$push",
        "$pullAll",
        "$each",
        "$position",
        "$slice",
        "$sort",
        "$bit",
        // aggregation pipeline stages
        "$addFields",
        "$bucket",
        "$bucketAuto",
        "$collStats",
        "$count",
        "$currentOp",
        "$facet",
        "$geoNear",
        "$graphLookup",
        "$group",
        "$indexStats",
        "$limit",
        "$listLocalSessions",
        "$listSessions",
        "$lookup",
        "$match",
        "$merge",
        "$out",
        "$planCacheStats",
        "$project",
        "$redact",
        "$replaceRoot",
        "$replaceWith",
        "$sample",
        "$set",
        "$skip",
        "$sort",
        "$sortByCount",
        "$unionWith",
        "$unset",
        "$unwind",
        "$setWindowFields",
        // aggregation pipeline operators
        "$abs",
        "$accumulator",
        "$acos",
        "$acosh",
        "$add",
        "$addToSet",
        "$allElementsTrue",
        "$and",
        "$anyElementTrue",
        "$arrayElemAt",
        "$arrayToObject",
        "$asin",
        "$asinh",
        "$atan",
        "$atan2",
        "$atanh",
        "$avg",
        "$binarySize",
        "$bsonSize",
        "$ceil",
        "$cmp",
        "$concat",
        "$concatArrays",
        "$cond",
        "$convert",
        "$cos",
        "$dateFromParts",
        "$dateToParts",
        "$dateFromString",
        "$dateToString",
        "$dayOfMonth",
        "$dayOfWeek",
        "$dayOfYear",
        "$degreesToRadians",
        "$divide",
        "$eq",
        "$exp",
        "$filter",
        "$first",
        "$floor",
        "$function",
        "$gt",
        "$gte",
        "$hour",
        "$ifNull",
        "$in",
        "$indexOfArray",
        "$indexOfBytes",
        "$indexOfCP",
        "$isArray",
        "$isNumber",
        "$isoDayOfWeek",
        "$isoWeek",
        "$isoWeekYear",
        "$last",
        "$last",
        "$let",
        "$literal",
        "$ln",
        "$log",
        "$log10",
        "$lt",
        "$lte",
        "$ltrim",
        "$map",
        "$max",
        "$mergeObjects",
        "$meta",
        "$min",
        "$millisecond",
        "$minute",
        "$mod",
        "$month",
        "$multiply",
        "$ne",
        "$not",
        "$objectToArray",
        "$or",
        "$pow",
        "$push",
        "$radiansToDegrees",
        "$range",
        "$reduce",
        "$regexFind",
        "$regexFindAll",
        "$regexMatch",
        "$replaceOne",
        "$replaceAll",
        "$reverseArray",
        "$round",
        "$rtrim",
        "$second",
        "$setDifference",
        "$setEquals",
        "$setIntersection",
        "$setIsSubset",
        "$setUnion",
        "$size",
        "$sin",
        "$slice",
        "$split",
        "$sqrt",
        "$stdDevPop",
        "$stdDevSamp",
        "$strcasecmp",
        "$strLenBytes",
        "$strLenCP",
        "$substr",
        "$substrBytes",
        "$substrCP",
        "$subtract",
        "$sum",
        "$switch",
        "$tan",
        "$toBool",
        "$toDate",
        "$toDecimal",
        "$toDouble",
        "$toInt",
        "$toLong",
        "$toObjectId",
        "$toString",
        "$toLower",
        "$toUpper",
        "$trim",
        "$trunc",
        "$type",
        "$week",
        "$year",
        "$zip",
        "$count",
        "$dateAdd",
        "$dateDiff",
        "$dateSubtract",
        "$dateTrunc",
        "$getField",
        "$rand",
        "$sampleRate",
        "$setField",
        "$unsetField",
        // aggregation pipeline query modifiers
        "$comment",
        "$explain",
        "$hint",
        "$max",
        "$maxTimeMS",
        "$min",
        "$orderby",
        "$query",
        "$returnKey",
        "$showDiskLoc",
        "$natural"
      ], a = [
        "ObjectId",
        "Code",
        "BinData",
        "DBRef",
        "Timestamp",
        "NumberLong",
        "NumberDecimal",
        "MaxKey",
        "MinKey",
        "RegExp",
        "ISODate",
        "UUID"
      ];
      r = r.map(function(s) {
        return s.replace("$", "\\$");
      });
      var i = "(?:" + r.join("|") + ")\\b";
      n.languages.mongodb = n.languages.extend("javascript", {}), n.languages.insertBefore("mongodb", "string", {
        property: {
          pattern: /(?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)(?=\s*:)/,
          greedy: !0,
          inside: {
            keyword: RegExp(`^(['"])?` + i + "(?:\\1)?$")
          }
        }
      }), n.languages.mongodb.string.inside = {
        url: {
          // url pattern
          pattern: /https?:\/\/[-\w@:%.+~#=]{1,256}\.[a-z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*/i,
          greedy: !0
        },
        entity: {
          // ipv4
          pattern: /\b(?:(?:[01]?\d\d?|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d\d?|2[0-4]\d|25[0-5])\b/,
          greedy: !0
        }
      }, n.languages.insertBefore("mongodb", "constant", {
        builtin: {
          pattern: RegExp("\\b(?:" + a.join("|") + ")\\b"),
          alias: "keyword"
        }
      });
    })(t);
  }
  return Rm;
}
var _m, t_;
function Z8() {
  if (t_) return _m;
  t_ = 1, _m = e, e.displayName = "monkey", e.aliases = [];
  function e(t) {
    t.languages.monkey = {
      comment: {
        pattern: /^#Rem\s[\s\S]*?^#End|'.+/im,
        greedy: !0
      },
      string: {
        pattern: /"[^"\r\n]*"/,
        greedy: !0
      },
      preprocessor: {
        pattern: /(^[ \t]*)#.+/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      function: /\b\w+(?=\()/,
      "type-char": {
        pattern: /\b[?%#$]/,
        alias: "class-name"
      },
      number: {
        pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
        lookbehind: !0
      },
      keyword: /\b(?:Abstract|Array|Bool|Case|Catch|Class|Const|Continue|Default|Eachin|Else|ElseIf|End|EndIf|Exit|Extends|Extern|False|Field|Final|Float|For|Forever|Function|Global|If|Implements|Import|Inline|Int|Interface|Local|Method|Module|New|Next|Null|Object|Private|Property|Public|Repeat|Return|Select|Self|Step|Strict|String|Super|Then|Throw|To|True|Try|Until|Void|Wend|While)\b/i,
      operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
      punctuation: /[.,:;()\[\]]/
    };
  }
  return _m;
}
var Cm, n_;
function J8() {
  if (n_) return Cm;
  n_ = 1, Cm = e, e.displayName = "moonscript", e.aliases = ["moon"];
  function e(t) {
    t.languages.moonscript = {
      comment: /--.*/,
      string: [
        {
          pattern: /'[^']*'|\[(=*)\[[\s\S]*?\]\1\]/,
          greedy: !0
        },
        {
          pattern: /"[^"]*"/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /#\{[^{}]*\}/,
              inside: {
                moonscript: {
                  pattern: /(^#\{)[\s\S]+(?=\})/,
                  lookbehind: !0,
                  inside: null
                  // see beow
                },
                "interpolation-punctuation": {
                  pattern: /#\{|\}/,
                  alias: "punctuation"
                }
              }
            }
          }
        }
      ],
      "class-name": [
        {
          pattern: /(\b(?:class|extends)[ \t]+)\w+/,
          lookbehind: !0
        },
        // class-like names start with a capital letter
        /\b[A-Z]\w*/
      ],
      keyword: /\b(?:class|continue|do|else|elseif|export|extends|for|from|if|import|in|local|nil|return|self|super|switch|then|unless|using|when|while|with)\b/,
      variable: /@@?\w*/,
      property: {
        pattern: /\b(?!\d)\w+(?=:)|(:)(?!\d)\w+/,
        lookbehind: !0
      },
      function: {
        pattern: /\b(?:_G|_VERSION|assert|collectgarbage|coroutine\.(?:create|resume|running|status|wrap|yield)|debug\.(?:debug|getfenv|gethook|getinfo|getlocal|getmetatable|getregistry|getupvalue|setfenv|sethook|setlocal|setmetatable|setupvalue|traceback)|dofile|error|getfenv|getmetatable|io\.(?:close|flush|input|lines|open|output|popen|read|stderr|stdin|stdout|tmpfile|type|write)|ipairs|load|loadfile|loadstring|math\.(?:abs|acos|asin|atan|atan2|ceil|cos|cosh|deg|exp|floor|fmod|frexp|ldexp|log|log10|max|min|modf|pi|pow|rad|random|randomseed|sin|sinh|sqrt|tan|tanh)|module|next|os\.(?:clock|date|difftime|execute|exit|getenv|remove|rename|setlocale|time|tmpname)|package\.(?:cpath|loaded|loadlib|path|preload|seeall)|pairs|pcall|print|rawequal|rawget|rawset|require|select|setfenv|setmetatable|string\.(?:byte|char|dump|find|format|gmatch|gsub|len|lower|match|rep|reverse|sub|upper)|table\.(?:concat|insert|maxn|remove|sort)|tonumber|tostring|type|unpack|xpcall)\b/,
        inside: {
          punctuation: /\./
        }
      },
      boolean: /\b(?:false|true)\b/,
      number: /(?:\B\.\d+|\b\d+\.\d+|\b\d+(?=[eE]))(?:[eE][-+]?\d+)?\b|\b(?:0x[a-fA-F\d]+|\d+)(?:U?LL)?\b/,
      operator: /\.{3}|[-=]>|~=|(?:[-+*/%<>!=]|\.\.)=?|[:#^]|\b(?:and|or)\b=?|\b(?:not)\b/,
      punctuation: /[.,()[\]{}\\]/
    }, t.languages.moonscript.string[1].inside.interpolation.inside.moonscript.inside = t.languages.moonscript, t.languages.moon = t.languages.moonscript;
  }
  return Cm;
}
var km, r_;
function Q8() {
  if (r_) return km;
  r_ = 1, km = e, e.displayName = "n1ql", e.aliases = [];
  function e(t) {
    t.languages.n1ql = {
      comment: {
        pattern: /\/\*[\s\S]*?(?:$|\*\/)|--.*/,
        greedy: !0
      },
      string: {
        pattern: /(["'])(?:\\[\s\S]|(?!\1)[^\\]|\1\1)*\1/,
        greedy: !0
      },
      identifier: {
        pattern: /`(?:\\[\s\S]|[^\\`]|``)*`/,
        greedy: !0
      },
      parameter: /\$[\w.]+/,
      // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html#n1ql-reserved-words
      keyword: /\b(?:ADVISE|ALL|ALTER|ANALYZE|AS|ASC|AT|BEGIN|BINARY|BOOLEAN|BREAK|BUCKET|BUILD|BY|CALL|CAST|CLUSTER|COLLATE|COLLECTION|COMMIT|COMMITTED|CONNECT|CONTINUE|CORRELATE|CORRELATED|COVER|CREATE|CURRENT|DATABASE|DATASET|DATASTORE|DECLARE|DECREMENT|DELETE|DERIVED|DESC|DESCRIBE|DISTINCT|DO|DROP|EACH|ELEMENT|EXCEPT|EXCLUDE|EXECUTE|EXPLAIN|FETCH|FILTER|FLATTEN|FLUSH|FOLLOWING|FOR|FORCE|FROM|FTS|FUNCTION|GOLANG|GRANT|GROUP|GROUPS|GSI|HASH|HAVING|IF|IGNORE|ILIKE|INCLUDE|INCREMENT|INDEX|INFER|INLINE|INNER|INSERT|INTERSECT|INTO|IS|ISOLATION|JAVASCRIPT|JOIN|KEY|KEYS|KEYSPACE|KNOWN|LANGUAGE|LAST|LEFT|LET|LETTING|LEVEL|LIMIT|LSM|MAP|MAPPING|MATCHED|MATERIALIZED|MERGE|MINUS|MISSING|NAMESPACE|NEST|NL|NO|NTH_VALUE|NULL|NULLS|NUMBER|OBJECT|OFFSET|ON|OPTION|OPTIONS|ORDER|OTHERS|OUTER|OVER|PARSE|PARTITION|PASSWORD|PATH|POOL|PRECEDING|PREPARE|PRIMARY|PRIVATE|PRIVILEGE|PROBE|PROCEDURE|PUBLIC|RANGE|RAW|REALM|REDUCE|RENAME|RESPECT|RETURN|RETURNING|REVOKE|RIGHT|ROLE|ROLLBACK|ROW|ROWS|SATISFIES|SAVEPOINT|SCHEMA|SCOPE|SELECT|SELF|SEMI|SET|SHOW|SOME|START|STATISTICS|STRING|SYSTEM|TIES|TO|TRAN|TRANSACTION|TRIGGER|TRUNCATE|UNBOUNDED|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNSET|UPDATE|UPSERT|USE|USER|USING|VALIDATE|VALUE|VALUES|VIA|VIEW|WHERE|WHILE|WINDOW|WITH|WORK|XOR)\b/i,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:FALSE|TRUE)\b/i,
      number: /(?:\b\d+\.|\B\.)\d+e[+\-]?\d+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
      operator: /[-+*\/%]|!=|==?|\|\||<[>=]?|>=?|\b(?:AND|ANY|ARRAY|BETWEEN|CASE|ELSE|END|EVERY|EXISTS|FIRST|IN|LIKE|NOT|OR|THEN|VALUED|WHEN|WITHIN)\b/i,
      punctuation: /[;[\](),.{}:]/
    };
  }
  return km;
}
var Nm, a_;
function e7() {
  if (a_) return Nm;
  a_ = 1, Nm = e, e.displayName = "n4js", e.aliases = ["n4jsd"];
  function e(t) {
    t.languages.n4js = t.languages.extend("javascript", {
      // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
      keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
    }), t.languages.insertBefore("n4js", "constant", {
      // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
      annotation: {
        pattern: /@+\w+/,
        alias: "operator"
      }
    }), t.languages.n4jsd = t.languages.n4js;
  }
  return Nm;
}
var Om, i_;
function t7() {
  if (i_) return Om;
  i_ = 1, Om = e, e.displayName = "nand2tetrisHdl", e.aliases = [];
  function e(t) {
    t.languages["nand2tetris-hdl"] = {
      comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      keyword: /\b(?:BUILTIN|CHIP|CLOCKED|IN|OUT|PARTS)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b[A-Za-z][A-Za-z0-9]*(?=\()/,
      number: /\b\d+\b/,
      operator: /=|\.\./,
      punctuation: /[{}[\];(),:]/
    };
  }
  return Om;
}
var Lm, o_;
function n7() {
  if (o_) return Lm;
  o_ = 1, Lm = e, e.displayName = "naniscript", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\{[^\r\n\[\]{}]*\}/, a = {
        "quoted-string": {
          pattern: /"(?:[^"\\]|\\.)*"/,
          alias: "operator"
        },
        "command-param-id": {
          pattern: /(\s)\w+:/,
          lookbehind: !0,
          alias: "property"
        },
        "command-param-value": [
          {
            pattern: r,
            alias: "selector"
          },
          {
            pattern: /([\t ])\S+/,
            lookbehind: !0,
            greedy: !0,
            alias: "operator"
          },
          {
            pattern: /\S(?:.*\S)?/,
            alias: "operator"
          }
        ]
      };
      n.languages.naniscript = {
        // ; ...
        comment: {
          pattern: /^([\t ]*);.*/m,
          lookbehind: !0
        },
        // > ...
        // Define is a control line starting with '>' followed by a word, a space and a text.
        define: {
          pattern: /^>.+/m,
          alias: "tag",
          inside: {
            value: {
              pattern: /(^>\w+[\t ]+)(?!\s)[^{}\r\n]+/,
              lookbehind: !0,
              alias: "operator"
            },
            key: {
              pattern: /(^>)\w+/,
              lookbehind: !0
            }
          }
        },
        // # ...
        label: {
          pattern: /^([\t ]*)#[\t ]*\w+[\t ]*$/m,
          lookbehind: !0,
          alias: "regex"
        },
        command: {
          pattern: /^([\t ]*)@\w+(?=[\t ]|$).*/m,
          lookbehind: !0,
          alias: "function",
          inside: {
            "command-name": /^@\w+/,
            expression: {
              pattern: r,
              greedy: !0,
              alias: "selector"
            },
            "command-params": {
              pattern: /\s*\S[\s\S]*/,
              inside: a
            }
          }
        },
        // Generic is any line that doesn't start with operators: ;>#@
        "generic-text": {
          pattern: /(^[ \t]*)[^#@>;\s].*/m,
          lookbehind: !0,
          alias: "punctuation",
          inside: {
            // \{ ... \} ... \[ ... \] ... \"
            "escaped-char": /\\[{}\[\]"]/,
            expression: {
              pattern: r,
              greedy: !0,
              alias: "selector"
            },
            "inline-command": {
              pattern: /\[[\t ]*\w[^\r\n\[\]]*\]/,
              greedy: !0,
              alias: "function",
              inside: {
                "command-params": {
                  pattern: /(^\[[\t ]*\w+\b)[\s\S]+(?=\]$)/,
                  lookbehind: !0,
                  inside: a
                },
                "command-param-name": {
                  pattern: /^(\[[\t ]*)\w+/,
                  lookbehind: !0,
                  alias: "name"
                },
                "start-stop-char": /[\[\]]/
              }
            }
          }
        }
      }, n.languages.nani = n.languages.naniscript, n.hooks.add("after-tokenize", function(u) {
        var c = u.tokens;
        c.forEach(function(d) {
          if (typeof d != "string" && d.type === "generic-text") {
            var p = s(d);
            i(p) || (d.type = "bad-line", d.content = p);
          }
        });
      });
      function i(u) {
        for (var c = "[]{}", d = [], p = 0; p < u.length; p++) {
          var f = u[p], m = c.indexOf(f);
          if (m !== -1) {
            if (m % 2 === 0)
              d.push(m + 1);
            else if (d.pop() !== m)
              return !1;
          }
        }
        return d.length === 0;
      }
      function s(u) {
        return typeof u == "string" ? u : Array.isArray(u) ? u.map(s).join("") : s(u.content);
      }
    })(t);
  }
  return Lm;
}
var Dm, s_;
function r7() {
  if (s_) return Dm;
  s_ = 1, Dm = e, e.displayName = "nasm", e.aliases = [];
  function e(t) {
    t.languages.nasm = {
      comment: /;.*$/m,
      string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      label: {
        pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
        lookbehind: !0,
        alias: "function"
      },
      keyword: [
        /\[?BITS (?:16|32|64)\]?/,
        {
          pattern: /(^\s*)section\s*[a-z.]+:?/im,
          lookbehind: !0
        },
        /(?:extern|global)[^;\r\n]*/i,
        /(?:CPU|DEFAULT|FLOAT).*$/m
      ],
      register: {
        pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s)\b/i,
        alias: "variable"
      },
      number: /(?:\b|(?=\$))(?:0[hx](?:\.[\da-f]+|[\da-f]+(?:\.[\da-f]+)?)(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
      operator: /[\[\]*+\-\/%<>=&|$!]/
    };
  }
  return Dm;
}
var Mm, l_;
function a7() {
  if (l_) return Mm;
  l_ = 1, Mm = e, e.displayName = "neon", e.aliases = [];
  function e(t) {
    t.languages.neon = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      datetime: {
        pattern: /(^|[[{(=:,\s])\d\d\d\d-\d\d?-\d\d?(?:(?:[Tt]| +)\d\d?:\d\d:\d\d(?:\.\d*)? *(?:Z|[-+]\d\d?(?::?\d\d)?)?)?(?=$|[\]}),\s])/,
        lookbehind: !0,
        alias: "number"
      },
      key: {
        pattern: /(^|[[{(,\s])[^,:=[\]{}()'"\s]+(?=\s*:(?:$|[\]}),\s])|\s*=)/,
        lookbehind: !0,
        alias: "atrule"
      },
      number: {
        pattern: /(^|[[{(=:,\s])[+-]?(?:0x[\da-fA-F]+|0o[0-7]+|0b[01]+|(?:\d+(?:\.\d*)?|\.?\d+)(?:[eE][+-]?\d+)?)(?=$|[\]}),:=\s])/,
        lookbehind: !0
      },
      boolean: {
        pattern: /(^|[[{(=:,\s])(?:false|no|true|yes)(?=$|[\]}),:=\s])/i,
        lookbehind: !0
      },
      null: {
        pattern: /(^|[[{(=:,\s])(?:null)(?=$|[\]}),:=\s])/i,
        lookbehind: !0,
        alias: "keyword"
      },
      string: {
        pattern: /(^|[[{(=:,\s])(?:('''|""")\r?\n(?:(?:[^\r\n]|\r?\n(?![\t ]*\2))*\r?\n)?[\t ]*\2|'[^'\r\n]*'|"(?:\\.|[^\\"\r\n])*")/,
        lookbehind: !0,
        greedy: !0
      },
      literal: {
        pattern: /(^|[[{(=:,\s])(?:[^#"',:=[\]{}()\s`-]|[:-][^"',=[\]{}()\s])(?:[^,:=\]})(\s]|:(?![\s,\]})]|$)|[ \t]+[^#,:=\]})(\s])*/,
        lookbehind: !0,
        alias: "string"
      },
      punctuation: /[,:=[\]{}()-]/
    };
  }
  return Mm;
}
var Fm, u_;
function i7() {
  if (u_) return Fm;
  u_ = 1, Fm = e, e.displayName = "nevod", e.aliases = [];
  function e(t) {
    t.languages.nevod = {
      comment: /\/\/.*|(?:\/\*[\s\S]*?(?:\*\/|$))/,
      string: {
        pattern: /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))!?\*?/,
        greedy: !0,
        inside: {
          "string-attrs": /!$|!\*$|\*$/
        }
      },
      namespace: {
        pattern: /(@namespace\s+)[a-zA-Z0-9\-.]+(?=\s*\{)/,
        lookbehind: !0
      },
      pattern: {
        pattern: /(@pattern\s+)?#?[a-zA-Z0-9\-.]+(?:\s*\(\s*(?:~\s*)?[a-zA-Z0-9\-.]+\s*(?:,\s*(?:~\s*)?[a-zA-Z0-9\-.]*)*\))?(?=\s*=)/,
        lookbehind: !0,
        inside: {
          "pattern-name": {
            pattern: /^#?[a-zA-Z0-9\-.]+/,
            alias: "class-name"
          },
          fields: {
            pattern: /\(.*\)/,
            inside: {
              "field-name": {
                pattern: /[a-zA-Z0-9\-.]+/,
                alias: "variable"
              },
              punctuation: /[,()]/,
              operator: {
                pattern: /~/,
                alias: "field-hidden-mark"
              }
            }
          }
        }
      },
      search: {
        pattern: /(@search\s+|#)[a-zA-Z0-9\-.]+(?:\.\*)?(?=\s*;)/,
        alias: "function",
        lookbehind: !0
      },
      keyword: /@(?:having|inside|namespace|outside|pattern|require|search|where)\b/,
      "standard-pattern": {
        pattern: /\b(?:Alpha|AlphaNum|Any|Blank|End|LineBreak|Num|NumAlpha|Punct|Space|Start|Symbol|Word|WordBreak)\b(?:\([a-zA-Z0-9\-.,\s+]*\))?/,
        inside: {
          "standard-pattern-name": {
            pattern: /^[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          quantifier: {
            pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
            alias: "number"
          },
          "standard-pattern-attr": {
            pattern: /[a-zA-Z0-9\-.]+/,
            alias: "builtin"
          },
          punctuation: /[,()]/
        }
      },
      quantifier: {
        pattern: /\b\d+(?:\s*\+|\s*-\s*\d+)?(?!\w)/,
        alias: "number"
      },
      operator: [
        {
          pattern: /=/,
          alias: "pattern-def"
        },
        {
          pattern: /&/,
          alias: "conjunction"
        },
        {
          pattern: /~/,
          alias: "exception"
        },
        {
          pattern: /\?/,
          alias: "optionality"
        },
        {
          pattern: /[[\]]/,
          alias: "repetition"
        },
        {
          pattern: /[{}]/,
          alias: "variation"
        },
        {
          pattern: /[+_]/,
          alias: "sequence"
        },
        {
          pattern: /\.{2,3}/,
          alias: "span"
        }
      ],
      "field-capture": [
        {
          pattern: /([a-zA-Z0-9\-.]+\s*\()\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+(?:\s*,\s*[a-zA-Z0-9\-.]+\s*:\s*[a-zA-Z0-9\-.]+)*(?=\s*\))/,
          lookbehind: !0,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        },
        {
          pattern: /[a-zA-Z0-9\-.]+\s*:/,
          inside: {
            "field-name": {
              pattern: /[a-zA-Z0-9\-.]+/,
              alias: "variable"
            },
            colon: /:/
          }
        }
      ],
      punctuation: /[:;,()]/,
      name: /[a-zA-Z0-9\-.]+/
    };
  }
  return Fm;
}
var Pm, c_;
function o7() {
  if (c_) return Pm;
  c_ = 1, Pm = e, e.displayName = "nginx", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\$(?:\w[a-z\d]*(?:_[^\x00-\x1F\s"'\\()$]*)?|\{[^}\s"'\\]+\})/i;
      n.languages.nginx = {
        comment: {
          pattern: /(^|[\s{};])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        directive: {
          pattern: /(^|\s)\w(?:[^;{}"'\\\s]|\\.|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|\s+(?:#.*(?!.)|(?![#\s])))*?(?=\s*[;{])/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            string: {
              pattern: /((?:^|[^\\])(?:\\\\)*)(?:"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')/,
              lookbehind: !0,
              greedy: !0,
              inside: {
                escape: {
                  pattern: /\\["'\\nrt]/,
                  alias: "entity"
                },
                variable: r
              }
            },
            comment: {
              pattern: /(\s)#.*/,
              lookbehind: !0,
              greedy: !0
            },
            keyword: {
              pattern: /^\S+/,
              greedy: !0
            },
            // other patterns
            boolean: {
              pattern: /(\s)(?:off|on)(?!\S)/,
              lookbehind: !0
            },
            number: {
              pattern: /(\s)\d+[a-z]*(?!\S)/i,
              lookbehind: !0
            },
            variable: r
          }
        },
        punctuation: /[{};]/
      };
    })(t);
  }
  return Pm;
}
var Bm, d_;
function s7() {
  if (d_) return Bm;
  d_ = 1, Bm = e, e.displayName = "nim", e.aliases = [];
  function e(t) {
    t.languages.nim = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
        pattern: /(?:\b(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")/,
        greedy: !0
      },
      char: {
        // Character literals are handled specifically to prevent issues with numeric type suffixes
        pattern: /'(?:\\(?:\d+|x[\da-fA-F]{0,2}|.)|[^'])'/,
        greedy: !0
      },
      function: {
        pattern: /(?:(?!\d)(?:\w|\\x[89a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
        greedy: !0,
        inside: {
          operator: /\*$/
        }
      },
      // We don't want to highlight operators (and anything really) inside backticks
      identifier: {
        pattern: /`[^`\r\n]+`/,
        greedy: !0,
        inside: {
          punctuation: /`/
        }
      },
      // The negative look ahead prevents wrong highlighting of the .. operator
      number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
      keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
      operator: {
        // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
        // but allow the slice operator .. to take precedence over them
        // One can define his own operators in Nim so all combination of operators might be an operator.
        pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|in|is|isnot|mod|not|notin|of|or|shl|shr|xor)\b)/m,
        lookbehind: !0
      },
      punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
    };
  }
  return Bm;
}
var $m, p_;
function l7() {
  if (p_) return $m;
  p_ = 1, $m = e, e.displayName = "nix", e.aliases = [];
  function e(t) {
    t.languages.nix = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
        greedy: !0,
        inside: {
          interpolation: {
            // The lookbehind ensures the ${} is not preceded by \ or ''
            pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^{}]|\{[^}]*\})*\}/,
            lookbehind: !0,
            inside: null
            // see below
          }
        }
      },
      url: [
        /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
        {
          pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
          lookbehind: !0
        }
      ],
      antiquotation: {
        pattern: /\$(?=\{)/,
        alias: "important"
      },
      number: /\b\d+\b/,
      keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
      function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
      boolean: /\b(?:false|true)\b/,
      operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
      punctuation: /[{}()[\].,:;]/
    }, t.languages.nix.string.inside.interpolation.inside = t.languages.nix;
  }
  return $m;
}
var Um, f_;
function u7() {
  if (f_) return Um;
  f_ = 1, Um = e, e.displayName = "nsis", e.aliases = [];
  function e(t) {
    t.languages.nsis = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|[#;].*)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: {
        pattern: /(^[\t ]*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|BG(?:Font|Gradient|Image)|Banner|BrandingText|BringToFront|CRCCheck|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|Seek|Write|WriteByte|WriteUTF16LE|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DLLVersion(?:Local)?|DlgItem|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|NSISdl|Name|Nop|OutFile|PE(?:DllCharacteristics|SubsysVer)|Page(?:Callbacks)?|Pop|Push|Quit|RMDir|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|UnRegDLL|Unicode|UninstPage|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UserInfo|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|Var|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle|ns(?:Dialogs|Exec))\b/m,
        lookbehind: !0
      },
      property: /\b(?:ARCHIVE|FILE_(?:ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK(?:(?:CR|CU|LM)(?:32|64)?|DD|PD|U)|HKEY_(?:CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(?:ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(?:ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY|admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user)\b/,
      constant: /\$\{[!\w\.:\^-]+\}|\$\([!\w\.:\^-]+\)/,
      variable: /\$\w[\w\.]*/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
      operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
      punctuation: /[{}[\];(),.:]/,
      important: {
        pattern: /(^[\t ]*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
        lookbehind: !0
      }
    };
  }
  return Um;
}
var jm, g_;
function c7() {
  if (g_) return jm;
  g_ = 1;
  var e = Ri();
  jm = t, t.displayName = "objectivec", t.aliases = ["objc"];
  function t(n) {
    n.register(e), n.languages.objectivec = n.languages.extend("c", {
      string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
      operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
    }), delete n.languages.objectivec["class-name"], n.languages.objc = n.languages.objectivec;
  }
  return jm;
}
var qm, m_;
function d7() {
  if (m_) return qm;
  m_ = 1, qm = e, e.displayName = "ocaml", e.aliases = [];
  function e(t) {
    t.languages.ocaml = {
      comment: {
        pattern: /\(\*[\s\S]*?\*\)/,
        greedy: !0
      },
      char: {
        pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
        greedy: !0
      },
      string: [
        {
          pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
          greedy: !0
        },
        {
          pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
          greedy: !0
        }
      ],
      number: [
        // binary and octal
        /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
        // hexadecimal
        /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
        // decimal
        /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
      ],
      directive: {
        pattern: /\B#\w+/,
        alias: "property"
      },
      label: {
        pattern: /\B~\w+/,
        alias: "property"
      },
      "type-variable": {
        pattern: /\B'\w+/,
        alias: "function"
      },
      variant: {
        pattern: /`\w+/,
        alias: "symbol"
      },
      // For the list of keywords and operators,
      // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
      keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
      boolean: /\b(?:false|true)\b/,
      "operator-like-punctuation": {
        pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
        alias: "punctuation"
      },
      // Custom operators are allowed
      operator: /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
      punctuation: /;;|::|[(){}\[\].,:;#]|\b_\b/
    };
  }
  return qm;
}
var zm, h_;
function p7() {
  if (h_) return zm;
  h_ = 1;
  var e = Ri();
  zm = t, t.displayName = "opencl", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.opencl = r.languages.extend("c", {
        // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
        keyword: /\b(?:(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|__attribute__|auto|(?:bool|u?(?:char|int|long|short)|half|quad)(?:2|3|4|8|16)?|break|case|complex|const|continue|(?:double|float)(?:16(?:x(?:1|2|4|8|16))?|1x(?:1|2|4|8|16)|2(?:x(?:1|2|4|8|16))?|3|4(?:x(?:1|2|4|8|16))?|8(?:x(?:1|2|4|8|16))?)?|default|do|else|enum|extern|for|goto|if|imaginary|inline|packed|pipe|register|restrict|return|signed|sizeof|static|struct|switch|typedef|uniform|union|unsigned|void|volatile|while)\b/,
        // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
        // Math Constants: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/mathConstants.html
        // Macros and Limits: https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/macroLimits.html
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[fuhl]{0,4}/i,
        boolean: /\b(?:false|true)\b/,
        "constant-opencl-kernel": {
          pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:GLOBAL|LOCAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT|HALF)_(?:DIG|EPSILON|(?:MAX|MIN)(?:(?:_10)?_EXP)?|MANT_DIG)|FLT_RADIX|HUGE_VALF?|(?:INT|LONG|SCHAR|SHRT)_(?:MAX|MIN)|INFINITY|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:2|10)E?|PI(?:_[24])?|SQRT(?:1_2|2))(?:_F|_H)?|NAN|(?:UCHAR|UINT|ULONG|USHRT)_MAX)\b/,
          alias: "constant"
        }
      }), r.languages.insertBefore("opencl", "class-name", {
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/scalarDataTypes.html
        // https://www.khronos.org/registry/OpenCL/sdk/2.1/docs/man/xhtml/otherDataTypes.html
        "builtin-type": {
          pattern: /\b(?:_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|cl_(?:image_format|mem_fence_flags)|clk_event_t|event_t|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|intptr_t|ndrange_t|ptrdiff_t|queue_t|reserve_id_t|sampler_t|size_t|uintptr_t)\b/,
          alias: "keyword"
        }
      });
      var a = {
        // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
        "type-opencl-host": {
          pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|int|long|short)|double|float)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
          alias: "keyword"
        },
        "boolean-opencl-host": {
          pattern: /\bCL_(?:FALSE|TRUE)\b/,
          alias: "boolean"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
        "constant-opencl-host": {
          pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:8|16|24|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
          alias: "constant"
        },
        // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
        "function-opencl-host": {
          pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
          alias: "function"
        }
      };
      r.languages.insertBefore("c", "keyword", a), r.languages.cpp && (a["type-opencl-host-cpp"] = {
        pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|Sampler|UserEvent)\b/,
        alias: "keyword"
      }, r.languages.insertBefore("cpp", "keyword", a));
    }(n);
  }
  return zm;
}
var Gm, b_;
function f7() {
  if (b_) return Gm;
  b_ = 1, Gm = e, e.displayName = "openqasm", e.aliases = ["qasm"];
  function e(t) {
    t.languages.openqasm = {
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"[^"\r\n\t]*"|'[^'\r\n\t]*'/,
        greedy: !0
      },
      keyword: /\b(?:CX|OPENQASM|U|barrier|boxas|boxto|break|const|continue|ctrl|def|defcal|defcalgrammar|delay|else|end|for|gate|gphase|if|in|include|inv|kernel|lengthof|let|measure|pow|reset|return|rotary|stretchinf|while)\b|#pragma\b/,
      "class-name": /\b(?:angle|bit|bool|creg|fixed|float|int|length|qreg|qubit|stretch|uint)\b/,
      function: /\b(?:cos|exp|ln|popcount|rotl|rotr|sin|sqrt|tan)\b(?=\s*\()/,
      constant: /\b(?:euler|pi|tau)\b|π|𝜏|ℇ/,
      number: {
        pattern: /(^|[^.\w$])(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?(?:dt|ns|us|µs|ms|s)?/i,
        lookbehind: !0
      },
      operator: /->|>>=?|<<=?|&&|\|\||\+\+|--|[!=<>&|~^+\-*/%]=?|@/,
      punctuation: /[(){}\[\];,:.]/
    }, t.languages.qasm = t.languages.openqasm;
  }
  return Gm;
}
var Hm, y_;
function g7() {
  if (y_) return Hm;
  y_ = 1, Hm = e, e.displayName = "oz", e.aliases = [];
  function e(t) {
    t.languages.oz = {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:[^"\\]|\\[\s\S])*"/,
        greedy: !0
      },
      atom: {
        pattern: /'(?:[^'\\]|\\[\s\S])*'/,
        greedy: !0,
        alias: "builtin"
      },
      keyword: /\$|\[\]|\b(?:_|at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
      function: [
        /\b[a-z][A-Za-z\d]*(?=\()/,
        {
          pattern: /(\{)[A-Z][A-Za-z\d]*\b/,
          lookbehind: !0
        }
      ],
      number: /\b(?:0[bx][\da-f]+|\d+(?:\.\d*)?(?:e~?\d+)?)\b|&(?:[^\\]|\\(?:\d{3}|.))/i,
      variable: /`(?:[^`\\]|\\.)+`/,
      "attr-name": /\b\w+(?=[ \t]*:(?![:=]))/,
      operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
      punctuation: /[\[\](){}.:;?]/
    };
  }
  return Hm;
}
var Vm, v_;
function m7() {
  if (v_) return Vm;
  v_ = 1, Vm = e, e.displayName = "parigp", e.aliases = [];
  function e(t) {
    t.languages.parigp = {
      comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"/,
        greedy: !0
      },
      // PARI/GP does not care about white spaces at all
      // so let's process the keywords to build an appropriate regexp
      // (e.g. "b *r *e *a *k", etc.)
      keyword: function() {
        var n = [
          "breakpoint",
          "break",
          "dbg_down",
          "dbg_err",
          "dbg_up",
          "dbg_x",
          "forcomposite",
          "fordiv",
          "forell",
          "forpart",
          "forprime",
          "forstep",
          "forsubgroup",
          "forvec",
          "for",
          "iferr",
          "if",
          "local",
          "my",
          "next",
          "return",
          "until",
          "while"
        ];
        return n = n.map(function(r) {
          return r.split("").join(" *");
        }).join("|"), RegExp("\\b(?:" + n + ")\\b");
      }(),
      function: /\b\w(?:[\w ]*\w)?(?= *\()/,
      number: {
        // The lookbehind and the negative lookahead prevent from breaking the .. operator
        pattern: /((?:\. *\. *)?)(?:\b\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *(?:[+-] *)?\d(?: *\d)*)?/i,
        lookbehind: !0
      },
      operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?: *>|(?: *<)?(?: *=)?)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
      punctuation: /[\[\]{}().,:;|]/
    };
  }
  return Vm;
}
var Wm, E_;
function h7() {
  if (E_) return Wm;
  E_ = 1, Wm = e, e.displayName = "parser", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.parser = n.languages.extend("markup", {
        keyword: {
          pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
          lookbehind: !0
        },
        variable: {
          pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            punctuation: /\.|:+/
          }
        },
        function: {
          pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /(^@)(?:GET_|SET_)/,
              lookbehind: !0
            },
            punctuation: /\.|:+/
          }
        },
        escape: {
          pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
          alias: "builtin"
        },
        punctuation: /[\[\](){};]/
      });
      r = n.languages.insertBefore("parser", "keyword", {
        "parser-comment": {
          pattern: /(\s)#.*/,
          lookbehind: !0,
          alias: "comment"
        },
        expression: {
          // Allow for 3 levels of depth
          pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
          greedy: !0,
          lookbehind: !0,
          inside: {
            string: {
              pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
              lookbehind: !0
            },
            keyword: r.keyword,
            variable: r.variable,
            function: r.function,
            boolean: /\b(?:false|true)\b/,
            number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
            escape: r.escape,
            operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
            punctuation: r.punctuation
          }
        }
      }), n.languages.insertBefore(
        "inside",
        "punctuation",
        {
          expression: r.expression,
          keyword: r.keyword,
          variable: r.variable,
          function: r.function,
          escape: r.escape,
          "parser-punctuation": {
            pattern: r.punctuation,
            alias: "punctuation"
          }
        },
        r.tag.inside["attr-value"]
      );
    })(t);
  }
  return Wm;
}
var Km, S_;
function b7() {
  if (S_) return Km;
  S_ = 1, Km = e, e.displayName = "pascal", e.aliases = ["objectpascal"];
  function e(t) {
    t.languages.pascal = {
      directive: {
        pattern: /\{\$[\s\S]*?\}/,
        greedy: !0,
        alias: ["marco", "property"]
      },
      comment: {
        pattern: /\(\*[\s\S]*?\*\)|\{[\s\S]*?\}|\/\/.*/,
        greedy: !0
      },
      string: {
        pattern: /(?:'(?:''|[^'\r\n])*'(?!')|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
        greedy: !0
      },
      asm: {
        pattern: /(\basm\b)[\s\S]+?(?=\bend\s*[;[])/i,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      keyword: [
        {
          // Turbo Pascal
          pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
          lookbehind: !0
        },
        {
          // Free Pascal
          pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
          lookbehind: !0
        },
        {
          // Object Pascal
          pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
          lookbehind: !0
        },
        {
          // Modifiers
          pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
          lookbehind: !0
        }
      ],
      number: [
        // Hexadecimal, octal and binary
        /(?:[&%]\d+|\$[a-f\d]+)/i,
        // Decimal
        /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
      ],
      operator: [
        /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/,
        {
          pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
          lookbehind: !0
        }
      ],
      punctuation: /\(\.|\.\)|[()\[\]:;,.]/
    }, t.languages.pascal.asm.inside = t.languages.extend("pascal", {
      asm: void 0,
      keyword: void 0,
      operator: void 0
    }), t.languages.objectpascal = t.languages.pascal;
  }
  return Km;
}
var Ym, x_;
function y7() {
  if (x_) return Ym;
  x_ = 1, Ym = e, e.displayName = "pascaligo", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\((?:[^()]|\((?:[^()]|\([^()]*\))*\))*\)/.source, a = /(?:\b\w+(?:<braces>)?|<braces>)/.source.replace(
        /<braces>/g,
        function() {
          return r;
        }
      ), i = n.languages.pascaligo = {
        comment: /\(\*[\s\S]+?\*\)|\/\/.*/,
        string: {
          pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1|\^[a-z]/i,
          greedy: !0
        },
        "class-name": [
          {
            pattern: RegExp(
              /(\btype\s+\w+\s+is\s+)<type>/.source.replace(
                /<type>/g,
                function() {
                  return a;
                }
              ),
              "i"
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /<type>(?=\s+is\b)/.source.replace(/<type>/g, function() {
                return a;
              }),
              "i"
            ),
            inside: null
            // see below
          },
          {
            pattern: RegExp(
              /(:\s*)<type>/.source.replace(/<type>/g, function() {
                return a;
              })
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        keyword: {
          pattern: /(^|[^&])\b(?:begin|block|case|const|else|end|fail|for|from|function|if|is|nil|of|remove|return|skip|then|type|var|while|with)\b/i,
          lookbehind: !0
        },
        boolean: {
          pattern: /(^|[^&])\b(?:False|True)\b/i,
          lookbehind: !0
        },
        builtin: {
          pattern: /(^|[^&])\b(?:bool|int|list|map|nat|record|string|unit)\b/i,
          lookbehind: !0
        },
        function: /\b\w+(?=\s*\()/,
        number: [
          // Hexadecimal, octal and binary
          /%[01]+|&[0-7]+|\$[a-f\d]+/i,
          // Decimal
          /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?(?:mtz|n)?/i
        ],
        operator: /->|=\/=|\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=|]|\b(?:and|mod|or)\b/,
        punctuation: /\(\.|\.\)|[()\[\]:;,.{}]/
      }, s = [
        "comment",
        "keyword",
        "builtin",
        "operator",
        "punctuation"
      ].reduce(function(u, c) {
        return u[c] = i[c], u;
      }, {});
      i["class-name"].forEach(function(u) {
        u.inside = s;
      });
    })(t);
  }
  return Ym;
}
var Xm, T_;
function v7() {
  if (T_) return Xm;
  T_ = 1, Xm = e, e.displayName = "pcaxis", e.aliases = ["px"];
  function e(t) {
    t.languages.pcaxis = {
      string: /"[^"]*"/,
      keyword: {
        pattern: /((?:^|;)\s*)[-A-Z\d]+(?:\s*\[[-\w]+\])?(?:\s*\("[^"]*"(?:,\s*"[^"]*")*\))?(?=\s*=)/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          keyword: /^[-A-Z\d]+/,
          language: {
            pattern: /^(\s*)\[[-\w]+\]/,
            lookbehind: !0,
            inside: {
              punctuation: /^\[|\]$/,
              property: /[-\w]+/
            }
          },
          "sub-key": {
            pattern: /^(\s*)\S[\s\S]*/,
            lookbehind: !0,
            inside: {
              parameter: {
                pattern: /"[^"]*"/,
                alias: "property"
              },
              punctuation: /^\(|\)$|,/
            }
          }
        }
      },
      operator: /=/,
      tlist: {
        pattern: /TLIST\s*\(\s*\w+(?:(?:\s*,\s*"[^"]*")+|\s*,\s*"[^"]*"-"[^"]*")?\s*\)/,
        greedy: !0,
        inside: {
          function: /^TLIST/,
          property: {
            pattern: /^(\s*\(\s*)\w+/,
            lookbehind: !0
          },
          string: /"[^"]*"/,
          punctuation: /[(),]/,
          operator: /-/
        }
      },
      punctuation: /[;,]/,
      number: {
        pattern: /(^|\s)\d+(?:\.\d+)?(?!\S)/,
        lookbehind: !0
      },
      boolean: /NO|YES/
    }, t.languages.px = t.languages.pcaxis;
  }
  return Xm;
}
var Zm, w_;
function E7() {
  if (w_) return Zm;
  w_ = 1, Zm = e, e.displayName = "peoplecode", e.aliases = ["pcode"];
  function e(t) {
    t.languages.peoplecode = {
      comment: RegExp(
        [
          // C-style multiline comments
          /\/\*[\s\S]*?\*\//.source,
          // REM comments
          /\bREM[^;]*;/.source,
          // Nested <* *> comments
          /<\*(?:[^<*]|\*(?!>)|<(?!\*)|<\*(?:(?!\*>)[\s\S])*\*>)*\*>/.source,
          // /+ +/ comments
          /\/\+[\s\S]*?\+\//.source
        ].join("|")
      ),
      string: {
        pattern: /'(?:''|[^'\r\n])*'(?!')|"(?:""|[^"\r\n])*"(?!")/,
        greedy: !0
      },
      variable: /%\w+/,
      "function-definition": {
        pattern: /((?:^|[^\w-])(?:function|method)\s+)\w+/i,
        lookbehind: !0,
        alias: "function"
      },
      "class-name": {
        pattern: /((?:^|[^-\w])(?:as|catch|class|component|create|extends|global|implements|instance|local|of|property|returns)\s+)\w+(?::\w+)*/i,
        lookbehind: !0,
        inside: {
          punctuation: /:/
        }
      },
      keyword: /\b(?:abstract|alias|as|catch|class|component|constant|create|declare|else|end-(?:class|evaluate|for|function|get|if|method|set|try|while)|evaluate|extends|for|function|get|global|if|implements|import|instance|library|local|method|null|of|out|peopleCode|private|program|property|protected|readonly|ref|repeat|returns?|set|step|then|throw|to|try|until|value|when(?:-other)?|while)\b/i,
      "operator-keyword": {
        pattern: /\b(?:and|not|or)\b/i,
        alias: "operator"
      },
      function: /[_a-z]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/i,
      number: /\b\d+(?:\.\d+)?\b/,
      operator: /<>|[<>]=?|!=|\*\*|[-+*/|=@]/,
      punctuation: /[:.;,()[\]]/
    }, t.languages.pcode = t.languages.peoplecode;
  }
  return Zm;
}
var Jm, A_;
function S7() {
  if (A_) return Jm;
  A_ = 1, Jm = e, e.displayName = "perl", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
      n.languages.perl = {
        comment: [
          {
            // POD
            pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\$])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        // TODO Could be nice to handle Heredoc too.
        string: [
          {
            pattern: RegExp(
              /\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // q/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // q a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // q(...)
                // q{...}
                // q[...]
                // q<...>
                r
              ].join("|") + ")"
            ),
            greedy: !0
          },
          // "...", `...`
          {
            pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
            greedy: !0
          },
          // '...'
          // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
          {
            pattern: /'(?:[^'\\\r\n]|\\.)*'/,
            greedy: !0
          }
        ],
        regex: [
          {
            pattern: RegExp(
              /\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // m/.../
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                // m a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // m(...)
                // m{...}
                // m[...]
                // m<...>
                r
              ].join("|") + ")" + /[msixpodualngc]*/.source
            ),
            greedy: !0
          },
          // The lookbehinds prevent -s from breaking
          {
            pattern: RegExp(
              /(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + "(?:" + [
                // s/.../.../
                // eslint-disable-next-line regexp/strict
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                // s a...a...a
                // eslint-disable-next-line regexp/strict
                /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                // s(...)(...)
                // s{...}{...}
                // s[...][...]
                // s<...><...>
                // s(...)[...]
                r + /\s*/.source + r
              ].join("|") + ")" + /[msixpodualngcer]*/.source
            ),
            lookbehind: !0,
            greedy: !0
          },
          // /.../
          // The look-ahead tries to prevent two divisions on
          // the same line from being highlighted as regex.
          // This does not support multi-line regex.
          {
            pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
            greedy: !0
          }
        ],
        // FIXME Not sure about the handling of ::, ', and #
        variable: [
          // ${^POSTMATCH}
          /[&*$@%]\{\^[A-Z]+\}/,
          // $^V
          /[&*$@%]\^[A-Z_]/,
          // ${...}
          /[&*$@%]#?(?=\{)/,
          // $foo
          /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
          // $1
          /[&*$@%]\d+/,
          // $_, @_, %!
          // The negative lookahead prevents from breaking the %= operator
          /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
        ],
        filehandle: {
          // <>, <FOO>, _
          pattern: /<(?![<=])\S*?>|\b_\b/,
          alias: "symbol"
        },
        "v-string": {
          // v1.2, 1.2.3
          pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
          alias: "string"
        },
        function: {
          pattern: /(\bsub[ \t]+)\w+/,
          lookbehind: !0
        },
        keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
        operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
        punctuation: /[{}[\];(),:]/
      };
    })(t);
  }
  return Jm;
}
var Qm, I_;
function x7() {
  if (I_) return Qm;
  I_ = 1;
  var e = fc();
  Qm = t, t.displayName = "phpExtras", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.insertBefore("php", "variable", {
      this: {
        pattern: /\$this\b/,
        alias: "keyword"
      },
      global: /\$(?:GLOBALS|HTTP_RAW_POST_DATA|_(?:COOKIE|ENV|FILES|GET|POST|REQUEST|SERVER|SESSION)|argc|argv|http_response_header|php_errormsg)\b/,
      scope: {
        pattern: /\b[\w\\]+::/,
        inside: {
          keyword: /\b(?:parent|self|static)\b/,
          punctuation: /::|\\/
        }
      }
    });
  }
  return Qm;
}
var eh, R_;
function T7() {
  if (R_) return eh;
  R_ = 1;
  var e = fc(), t = pc();
  eh = n, n.displayName = "phpdoc", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = /(?:\b[a-zA-Z]\w*|[|\\[\]])+/.source;
      a.languages.phpdoc = a.languages.extend("javadoclike", {
        parameter: {
          pattern: RegExp(
            "(@(?:global|param|property(?:-read|-write)?|var)\\s+(?:" + i + "\\s+)?)\\$\\w+"
          ),
          lookbehind: !0
        }
      }), a.languages.insertBefore("phpdoc", "keyword", {
        "class-name": [
          {
            pattern: RegExp(
              "(@(?:global|package|param|property(?:-read|-write)?|return|subpackage|throws|var)\\s+)" + i
            ),
            lookbehind: !0,
            inside: {
              keyword: /\b(?:array|bool|boolean|callback|double|false|float|int|integer|mixed|null|object|resource|self|string|true|void)\b/,
              punctuation: /[|\\[\]()]/
            }
          }
        ]
      }), a.languages.javadoclike.addSupport("php", a.languages.phpdoc);
    }(r);
  }
  return eh;
}
var th, __;
function w7() {
  if (__) return th;
  __ = 1;
  var e = Fv();
  th = t, t.displayName = "plsql", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.plsql = n.languages.extend("sql", {
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|--.*/,
        greedy: !0
      },
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-reserved-words-keywords.html
      keyword: /\b(?:A|ACCESSIBLE|ADD|AGENT|AGGREGATE|ALL|ALTER|AND|ANY|ARRAY|AS|ASC|AT|ATTRIBUTE|AUTHID|AVG|BEGIN|BETWEEN|BFILE_BASE|BINARY|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BULK|BY|BYTE|C|CALL|CALLING|CASCADE|CASE|CHAR|CHARACTER|CHARSET|CHARSETFORM|CHARSETID|CHAR_BASE|CHECK|CLOB_BASE|CLONE|CLOSE|CLUSTER|CLUSTERS|COLAUTH|COLLECT|COLUMNS|COMMENT|COMMIT|COMMITTED|COMPILED|COMPRESS|CONNECT|CONSTANT|CONSTRUCTOR|CONTEXT|CONTINUE|CONVERT|COUNT|CRASH|CREATE|CREDENTIAL|CURRENT|CURSOR|CUSTOMDATUM|DANGLING|DATA|DATE|DATE_BASE|DAY|DECLARE|DEFAULT|DEFINE|DELETE|DESC|DETERMINISTIC|DIRECTORY|DISTINCT|DOUBLE|DROP|DURATION|ELEMENT|ELSE|ELSIF|EMPTY|END|ESCAPE|EXCEPT|EXCEPTION|EXCEPTIONS|EXCLUSIVE|EXECUTE|EXISTS|EXIT|EXTERNAL|FETCH|FINAL|FIRST|FIXED|FLOAT|FOR|FORALL|FORCE|FROM|FUNCTION|GENERAL|GOTO|GRANT|GROUP|HASH|HAVING|HEAP|HIDDEN|HOUR|IDENTIFIED|IF|IMMEDIATE|IMMUTABLE|IN|INCLUDING|INDEX|INDEXES|INDICATOR|INDICES|INFINITE|INSERT|INSTANTIABLE|INT|INTERFACE|INTERSECT|INTERVAL|INTO|INVALIDATE|IS|ISOLATION|JAVA|LANGUAGE|LARGE|LEADING|LENGTH|LEVEL|LIBRARY|LIKE|LIKE2|LIKE4|LIKEC|LIMIT|LIMITED|LOCAL|LOCK|LONG|LOOP|MAP|MAX|MAXLEN|MEMBER|MERGE|MIN|MINUS|MINUTE|MOD|MODE|MODIFY|MONTH|MULTISET|MUTABLE|NAME|NAN|NATIONAL|NATIVE|NCHAR|NEW|NOCOMPRESS|NOCOPY|NOT|NOWAIT|NULL|NUMBER_BASE|OBJECT|OCICOLL|OCIDATE|OCIDATETIME|OCIDURATION|OCIINTERVAL|OCILOBLOCATOR|OCINUMBER|OCIRAW|OCIREF|OCIREFCURSOR|OCIROWID|OCISTRING|OCITYPE|OF|OLD|ON|ONLY|OPAQUE|OPEN|OPERATOR|OPTION|OR|ORACLE|ORADATA|ORDER|ORGANIZATION|ORLANY|ORLVARY|OTHERS|OUT|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETER|PARAMETERS|PARENT|PARTITION|PASCAL|PERSISTABLE|PIPE|PIPELINED|PLUGGABLE|POLYMORPHIC|PRAGMA|PRECISION|PRIOR|PRIVATE|PROCEDURE|PUBLIC|RAISE|RANGE|RAW|READ|RECORD|REF|REFERENCE|RELIES_ON|REM|REMAINDER|RENAME|RESOURCE|RESULT|RESULT_CACHE|RETURN|RETURNING|REVERSE|REVOKE|ROLLBACK|ROW|SAMPLE|SAVE|SAVEPOINT|SB1|SB2|SB4|SECOND|SEGMENT|SELECT|SELF|SEPARATE|SEQUENCE|SERIALIZABLE|SET|SHARE|SHORT|SIZE|SIZE_T|SOME|SPARSE|SQL|SQLCODE|SQLDATA|SQLNAME|SQLSTATE|STANDARD|START|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUM|SYNONYM|TABAUTH|TABLE|TDO|THE|THEN|TIME|TIMESTAMP|TIMEZONE_ABBR|TIMEZONE_HOUR|TIMEZONE_MINUTE|TIMEZONE_REGION|TO|TRAILING|TRANSACTION|TRANSACTIONAL|TRUSTED|TYPE|UB1|UB2|UB4|UNDER|UNION|UNIQUE|UNPLUG|UNSIGNED|UNTRUSTED|UPDATE|USE|USING|VALIST|VALUE|VALUES|VARIABLE|VARIANCE|VARRAY|VARYING|VIEW|VIEWS|VOID|WHEN|WHERE|WHILE|WITH|WORK|WRAPPED|WRITE|YEAR|ZONE)\b/i,
      // https://docs.oracle.com/en/database/oracle/oracle-database/21/lnpls/plsql-language-fundamentals.html#GUID-96A42F7C-7A71-4B90-8255-CA9C8BD9722E
      operator: /:=?|=>|[<>^~!]=|\.\.|\|\||\*\*|[-+*/%<>=@]/
    }), n.languages.insertBefore("plsql", "operator", {
      label: {
        pattern: /<<\s*\w+\s*>>/,
        alias: "symbol"
      }
    });
  }
  return th;
}
var nh, C_;
function A7() {
  if (C_) return nh;
  C_ = 1, nh = e, e.displayName = "powerquery", e.aliases = [];
  function e(t) {
    t.languages.powerquery = {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0,
        greedy: !0
      },
      "quoted-identifier": {
        pattern: /#"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      string: {
        pattern: /(?:#!)?"(?:[^"\r\n]|"")*"(?!")/,
        greedy: !0
      },
      constant: [
        /\bDay\.(?:Friday|Monday|Saturday|Sunday|Thursday|Tuesday|Wednesday)\b/,
        /\bTraceLevel\.(?:Critical|Error|Information|Verbose|Warning)\b/,
        /\bOccurrence\.(?:All|First|Last)\b/,
        /\bOrder\.(?:Ascending|Descending)\b/,
        /\bRoundingMode\.(?:AwayFromZero|Down|ToEven|TowardZero|Up)\b/,
        /\bMissingField\.(?:Error|Ignore|UseNull)\b/,
        /\bQuoteStyle\.(?:Csv|None)\b/,
        /\bJoinKind\.(?:FullOuter|Inner|LeftAnti|LeftOuter|RightAnti|RightOuter)\b/,
        /\bGroupKind\.(?:Global|Local)\b/,
        /\bExtraValues\.(?:Error|Ignore|List)\b/,
        /\bJoinAlgorithm\.(?:Dynamic|LeftHash|LeftIndex|PairwiseHash|RightHash|RightIndex|SortMerge)\b/,
        /\bJoinSide\.(?:Left|Right)\b/,
        /\bPrecision\.(?:Decimal|Double)\b/,
        /\bRelativePosition\.From(?:End|Start)\b/,
        /\bTextEncoding\.(?:Ascii|BigEndianUnicode|Unicode|Utf16|Utf8|Windows)\b/,
        /\b(?:Any|Binary|Date|DateTime|DateTimeZone|Duration|Function|Int16|Int32|Int64|Int8|List|Logical|None|Number|Record|Table|Text|Time)\.Type\b/,
        /\bnull\b/
      ],
      boolean: /\b(?:false|true)\b/,
      keyword: /\b(?:and|as|each|else|error|if|in|is|let|meta|not|nullable|optional|or|otherwise|section|shared|then|try|type)\b|#(?:binary|date|datetime|datetimezone|duration|infinity|nan|sections|shared|table|time)\b/,
      function: {
        pattern: /(^|[^#\w.])[a-z_][\w.]*(?=\s*\()/i,
        lookbehind: !0
      },
      "data-type": {
        pattern: /\b(?:any|anynonnull|binary|date|datetime|datetimezone|duration|function|list|logical|none|number|record|table|text|time)\b/,
        alias: "class-name"
      },
      number: {
        pattern: /\b0x[\da-f]+\b|(?:[+-]?(?:\b\d+\.)?\b\d+|[+-]\.\d+|(^|[^.])\B\.\d+)(?:e[+-]?\d+)?\b/i,
        lookbehind: !0
      },
      operator: /[-+*\/&?@^]|<(?:=>?|>)?|>=?|=>?|\.\.\.?/,
      punctuation: /[,;\[\](){}]/
    }, t.languages.pq = t.languages.powerquery, t.languages.mscript = t.languages.powerquery;
  }
  return nh;
}
var rh, k_;
function I7() {
  if (k_) return rh;
  k_ = 1, rh = e, e.displayName = "powershell", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = n.languages.powershell = {
        comment: [
          {
            pattern: /(^|[^`])<#[\s\S]*?#>/,
            lookbehind: !0
          },
          {
            pattern: /(^|[^`])#.*/,
            lookbehind: !0
          }
        ],
        string: [
          {
            pattern: /"(?:`[\s\S]|[^`"])*"/,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /'(?:[^']|'')*'/,
            greedy: !0
          }
        ],
        // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
        // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
        namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
        boolean: /\$(?:false|true)\b/i,
        variable: /\$\w+\b/,
        // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
        // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
        // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
        function: [
          /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
          /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
        ],
        // per http://technet.microsoft.com/en-us/library/hh847744.aspx
        keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
        operator: {
          pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
          lookbehind: !0
        },
        punctuation: /[|{}[\];(),.]/
      };
      r.string[0].inside = {
        function: {
          // Allow for one level of nesting
          pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
          lookbehind: !0,
          inside: r
        },
        boolean: r.boolean,
        variable: r.variable
      };
    })(t);
  }
  return rh;
}
var ah, N_;
function R7() {
  if (N_) return ah;
  N_ = 1, ah = e, e.displayName = "processing", e.aliases = [];
  function e(t) {
    t.languages.processing = t.languages.extend("clike", {
      keyword: /\b(?:break|case|catch|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
      // Spaces are allowed between function name and parenthesis
      function: /\b\w+(?=\s*\()/,
      operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
    }), t.languages.insertBefore("processing", "number", {
      // Special case: XML is a type
      constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
      type: {
        pattern: /\b(?:boolean|byte|char|color|double|float|int|[A-Z]\w*)\b/,
        alias: "class-name"
      }
    });
  }
  return ah;
}
var ih, O_;
function _7() {
  if (O_) return ih;
  O_ = 1, ih = e, e.displayName = "prolog", e.aliases = [];
  function e(t) {
    t.languages.prolog = {
      // Syntax depends on the implementation
      comment: {
        pattern: /\/\*[\s\S]*?\*\/|%.*/,
        greedy: !0
      },
      // Depending on the implementation, strings may allow escaped newlines and quote-escape
      string: {
        pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1(?!\1)/,
        greedy: !0
      },
      builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
      // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
      function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
      number: /\b\d+(?:\.\d*)?/,
      // Custom operators are allowed
      operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
      punctuation: /[(){}\[\],]/
    };
  }
  return ih;
}
var oh, L_;
function C7() {
  if (L_) return oh;
  L_ = 1, oh = e, e.displayName = "promql", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = [
        "sum",
        "min",
        "max",
        "avg",
        "group",
        "stddev",
        "stdvar",
        "count",
        "count_values",
        "bottomk",
        "topk",
        "quantile"
      ], a = [
        "on",
        "ignoring",
        "group_right",
        "group_left",
        "by",
        "without"
      ], i = ["offset"], s = r.concat(a, i);
      n.languages.promql = {
        comment: {
          pattern: /(^[ \t]*)#.*/m,
          lookbehind: !0
        },
        "vector-match": {
          // Match the comma-separated label lists inside vector matching:
          pattern: new RegExp(
            "((?:" + a.join("|") + ")\\s*)\\([^)]*\\)"
          ),
          lookbehind: !0,
          inside: {
            "label-key": {
              pattern: /\b[^,]+\b/,
              alias: "attr-name"
            },
            punctuation: /[(),]/
          }
        },
        "context-labels": {
          pattern: /\{[^{}]*\}/,
          inside: {
            "label-key": {
              pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
              alias: "attr-name"
            },
            "label-value": {
              pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
              greedy: !0,
              alias: "attr-value"
            },
            punctuation: /\{|\}|=~?|![=~]|,/
          }
        },
        "context-range": [
          {
            pattern: /\[[\w\s:]+\]/,
            // [1m]
            inside: {
              punctuation: /\[|\]|:/,
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          },
          {
            pattern: /(\boffset\s+)\w+/,
            // offset 1m
            lookbehind: !0,
            inside: {
              "range-duration": {
                pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                alias: "number"
              }
            }
          }
        ],
        keyword: new RegExp("\\b(?:" + s.join("|") + ")\\b", "i"),
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
        operator: /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
        punctuation: /[{};()`,.[\]]/
      };
    })(t);
  }
  return oh;
}
var sh, D_;
function k7() {
  if (D_) return sh;
  D_ = 1, sh = e, e.displayName = "properties", e.aliases = [];
  function e(t) {
    t.languages.properties = {
      comment: /^[ \t]*[#!].*$/m,
      "attr-value": {
        pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?: *[=:] *(?! )| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
        lookbehind: !0
      },
      "attr-name": /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+(?= *[=:]| )/m,
      punctuation: /[=:]/
    };
  }
  return sh;
}
var lh, M_;
function N7() {
  if (M_) return lh;
  M_ = 1, lh = e, e.displayName = "protobuf", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:bool|bytes|double|s?fixed(?:32|64)|float|[su]?int(?:32|64)|string)\b/;
      n.languages.protobuf = n.languages.extend("clike", {
        "class-name": [
          {
            pattern: /(\b(?:enum|extend|message|service)\s+)[A-Za-z_]\w*(?=\s*\{)/,
            lookbehind: !0
          },
          {
            pattern: /(\b(?:rpc\s+\w+|returns)\s*\(\s*(?:stream\s+)?)\.?[A-Za-z_]\w*(?:\.[A-Za-z_]\w*)*(?=\s*\))/,
            lookbehind: !0
          }
        ],
        keyword: /\b(?:enum|extend|extensions|import|message|oneof|option|optional|package|public|repeated|required|reserved|returns|rpc(?=\s+\w)|service|stream|syntax|to)\b(?!\s*=\s*\d)/,
        function: /\b[a-z_]\w*(?=\s*\()/i
      }), n.languages.insertBefore("protobuf", "operator", {
        map: {
          pattern: /\bmap<\s*[\w.]+\s*,\s*[\w.]+\s*>(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /[<>.,]/,
            builtin: r
          }
        },
        builtin: r,
        "positional-class-name": {
          pattern: /(?:\b|\B\.)[a-z_]\w*(?:\.[a-z_]\w*)*(?=\s+[a-z_]\w*\s*[=;])/i,
          alias: "class-name",
          inside: {
            punctuation: /\./
          }
        },
        annotation: {
          pattern: /(\[\s*)[a-z_]\w*(?=\s*=)/i,
          lookbehind: !0
        }
      });
    })(t);
  }
  return lh;
}
var uh, F_;
function O7() {
  if (F_) return uh;
  F_ = 1, uh = e, e.displayName = "psl", e.aliases = [];
  function e(t) {
    t.languages.psl = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0,
        inside: {
          symbol: /\\[ntrbA-Z"\\]/
        }
      },
      "heredoc-string": {
        pattern: /<<<([a-zA-Z_]\w*)[\r\n](?:.*[\r\n])*?\1\b/,
        alias: "string",
        greedy: !0
      },
      keyword: /\b(?:__multi|__single|case|default|do|else|elsif|exit|export|for|foreach|function|if|last|line|local|next|requires|return|switch|until|while|word)\b/,
      constant: /\b(?:ALARM|CHART_ADD_GRAPH|CHART_DELETE_GRAPH|CHART_DESTROY|CHART_LOAD|CHART_PRINT|EOF|OFFLINE|OK|PSL_PROF_LOG|R_CHECK_HORIZ|R_CHECK_VERT|R_CLICKER|R_COLUMN|R_FRAME|R_ICON|R_LABEL|R_LABEL_CENTER|R_LIST_MULTIPLE|R_LIST_MULTIPLE_ND|R_LIST_SINGLE|R_LIST_SINGLE_ND|R_MENU|R_POPUP|R_POPUP_SCROLLED|R_RADIO_HORIZ|R_RADIO_VERT|R_ROW|R_SCALE_HORIZ|R_SCALE_VERT|R_SEP_HORIZ|R_SEP_VERT|R_SPINNER|R_TEXT_FIELD|R_TEXT_FIELD_LABEL|R_TOGGLE|TRIM_LEADING|TRIM_LEADING_AND_TRAILING|TRIM_REDUNDANT|TRIM_TRAILING|VOID|WARN)\b/,
      boolean: /\b(?:FALSE|False|NO|No|TRUE|True|YES|Yes|false|no|true|yes)\b/,
      variable: /\b(?:PslDebug|errno|exit_status)\b/,
      builtin: {
        pattern: /\b(?:PslExecute|PslFunctionCall|PslFunctionExists|PslSetOptions|_snmp_debug|acos|add_diary|annotate|annotate_get|ascii_to_ebcdic|asctime|asin|atan|atexit|batch_set|blackout|cat|ceil|chan_exists|change_state|close|code_cvt|cond_signal|cond_wait|console_type|convert_base|convert_date|convert_locale_date|cos|cosh|create|date|dcget_text|destroy|destroy_lock|dget_text|difference|dump_hist|ebcdic_to_ascii|encrypt|event_archive|event_catalog_get|event_check|event_query|event_range_manage|event_range_query|event_report|event_schedule|event_trigger|event_trigger2|execute|exists|exp|fabs|file|floor|fmod|fopen|fseek|ftell|full_discovery|get|get_chan_info|get_ranges|get_text|get_vars|getenv|gethostinfo|getpid|getpname|grep|history|history_get_retention|in_transition|index|int|internal|intersection|is_var|isnumber|join|kill|length|lines|lock|lock_info|log|log10|loge|matchline|msg_check|msg_get_format|msg_get_severity|msg_printf|msg_sprintf|ntharg|nthargf|nthline|nthlinef|num_bytes|num_consoles|pconfig|popen|poplines|pow|print|printf|proc_exists|process|random|read|readln|refresh_parameters|remote_check|remote_close|remote_event_query|remote_event_trigger|remote_file_send|remote_open|remove|replace|rindex|sec_check_priv|sec_store_get|sec_store_set|set|set_alarm_ranges|set_locale|share|sin|sinh|sleep|snmp_agent_config|snmp_agent_start|snmp_agent_stop|snmp_close|snmp_config|snmp_get|snmp_get_next|snmp_h_get|snmp_h_get_next|snmp_h_set|snmp_open|snmp_set|snmp_trap_ignore|snmp_trap_listen|snmp_trap_raise_std_trap|snmp_trap_receive|snmp_trap_register_im|snmp_trap_send|snmp_walk|sopen|sort|splitline|sprintf|sqrt|srandom|str_repeat|strcasecmp|subset|substr|system|tail|tan|tanh|text_domain|time|tmpnam|tolower|toupper|trace_psl_process|trim|union|unique|unlock|unset|va_arg|va_start|write)\b/,
        alias: "builtin-function"
      },
      "foreach-variable": {
        pattern: /(\bforeach\s+(?:(?:\w+\b|"(?:\\.|[^\\"])*")\s+){0,2})[_a-zA-Z]\w*(?=\s*\()/,
        lookbehind: !0,
        greedy: !0
      },
      function: /\b[_a-z]\w*\b(?=\s*\()/i,
      number: /\b(?:0x[0-9a-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /--|\+\+|&&=?|\|\|=?|<<=?|>>=?|[=!]~|[-+*/%&|^!=<>]=?|\.|[:?]/,
      punctuation: /[(){}\[\];,]/
    };
  }
  return uh;
}
var ch, P_;
function L7() {
  if (P_) return ch;
  P_ = 1, ch = e, e.displayName = "pug", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.pug = {
        // Multiline stuff should appear before the rest
        // This handles both single-line and multi-line comments
        comment: {
          pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ].+)*/m,
          lookbehind: !0
        },
        // All the tag-related part is in lookbehind
        // so that it can be highlighted by the "tag" pattern
        "multiline-script": {
          pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        // See at the end of the file for known filters
        filter: {
          pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: /\S[\s\S]*/
          }
        },
        "multiline-plain-text": {
          pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/m,
          lookbehind: !0
        },
        markup: {
          pattern: /(^[\t ]*)<.+/m,
          lookbehind: !0,
          inside: n.languages.markup
        },
        doctype: {
          pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
          lookbehind: !0
        },
        // This handle all conditional and loop keywords
        "flow-control": {
          pattern: /(^[\t ]*)(?:case|default|each|else|if|unless|when|while)\b(?: .+)?/m,
          lookbehind: !0,
          inside: {
            each: {
              pattern: /^each .+? in\b/,
              inside: {
                keyword: /\b(?:each|in)\b/,
                punctuation: /,/
              }
            },
            branch: {
              pattern: /^(?:case|default|else|if|unless|when|while)\b/,
              alias: "keyword"
            },
            rest: n.languages.javascript
          }
        },
        keyword: {
          pattern: /(^[\t ]*)(?:append|block|extends|include|prepend)\b.+/m,
          lookbehind: !0
        },
        mixin: [
          // Declaration
          {
            pattern: /(^[\t ]*)mixin .+/m,
            lookbehind: !0,
            inside: {
              keyword: /^mixin/,
              function: /\w+(?=\s*\(|\s*$)/,
              punctuation: /[(),.]/
            }
          },
          // Usage
          {
            pattern: /(^[\t ]*)\+.+/m,
            lookbehind: !0,
            inside: {
              name: {
                pattern: /^\+\w+/,
                alias: "function"
              },
              rest: n.languages.javascript
            }
          }
        ],
        script: {
          pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]).+/m,
          lookbehind: !0,
          inside: n.languages.javascript
        },
        "plain-text": {
          pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]).+/m,
          lookbehind: !0
        },
        tag: {
          pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
          lookbehind: !0,
          inside: {
            attributes: [
              {
                pattern: /&[^(]+\([^)]+\)/,
                inside: n.languages.javascript
              },
              {
                pattern: /\([^)]+\)/,
                inside: {
                  "attr-value": {
                    pattern: /(=\s*(?!\s))(?:\{[^}]*\}|[^,)\r\n]+)/,
                    lookbehind: !0,
                    inside: n.languages.javascript
                  },
                  "attr-name": /[\w-]+(?=\s*!?=|\s*[,)])/,
                  punctuation: /[!=(),]+/
                }
              }
            ],
            punctuation: /:/,
            "attr-id": /#[\w\-]+/,
            "attr-class": /\.[\w\-]+/
          }
        },
        code: [
          {
            pattern: /(^[\t ]*(?:-|!?=)).+/m,
            lookbehind: !0,
            inside: n.languages.javascript
          }
        ],
        punctuation: /[.\-!=|]+/
      };
      for (var r = /(^([\t ]*)):<filter_name>(?:(?:\r?\n|\r(?!\n))(?:\2[\t ].+|\s*?(?=\r?\n|\r)))+/.source, a = [
        {
          filter: "atpl",
          language: "twig"
        },
        {
          filter: "coffee",
          language: "coffeescript"
        },
        "ejs",
        "handlebars",
        "less",
        "livescript",
        "markdown",
        {
          filter: "sass",
          language: "scss"
        },
        "stylus"
      ], i = {}, s = 0, u = a.length; s < u; s++) {
        var c = a[s];
        c = typeof c == "string" ? {
          filter: c,
          language: c
        } : c, n.languages[c.language] && (i["filter-" + c.filter] = {
          pattern: RegExp(
            r.replace("<filter_name>", function() {
              return c.filter;
            }),
            "m"
          ),
          lookbehind: !0,
          inside: {
            "filter-name": {
              pattern: /^:[\w-]+/,
              alias: "variable"
            },
            text: {
              pattern: /\S[\s\S]*/,
              alias: [c.language, "language-" + c.language],
              inside: n.languages[c.language]
            }
          }
        });
      }
      n.languages.insertBefore("pug", "filter", i);
    })(t);
  }
  return ch;
}
var dh, B_;
function D7() {
  if (B_) return dh;
  B_ = 1, dh = e, e.displayName = "puppet", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.puppet = {
        heredoc: [
          // Matches the content of a quoted heredoc string (subject to interpolation)
          {
            pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
              // See interpolation below
            }
          },
          // Matches the content of an unquoted heredoc string (no interpolation)
          {
            pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r(?!\n)))*?[ \t]*(?:\|[ \t]*)?(?:-[ \t]*)?\2/,
            lookbehind: !0,
            greedy: !0,
            alias: "string",
            inside: {
              // Matches the end tag
              punctuation: /(?=\S).*\S(?= *$)/
            }
          },
          // Matches the start tag of heredoc strings
          {
            pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
            alias: "string",
            inside: {
              punctuation: {
                pattern: /(\().+?(?=\))/,
                lookbehind: !0
              }
            }
          }
        ],
        "multiline-comment": {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: !0,
          greedy: !0,
          alias: "comment"
        },
        regex: {
          // Must be prefixed with the keyword "node" or a non-word char
          pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            // Extended regexes must have the x flag. They can contain single-line comments.
            "extended-regex": {
              pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
              inside: {
                comment: /#.*/
              }
            }
          }
        },
        comment: {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        string: {
          // Allow for one nested level of double quotes inside interpolation
          pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|\$(?!\{)|(?!\1)[^\\$]|\\[\s\S])*\1/,
          greedy: !0,
          inside: {
            "double-quoted": {
              pattern: /^"[\s\S]*"$/,
              inside: {
                // See interpolation below
              }
            }
          }
        },
        variable: {
          pattern: /\$(?:::)?\w+(?:::\w+)*/,
          inside: {
            punctuation: /::/
          }
        },
        "attr-name": /(?:\b\w+|\*)(?=\s*=>)/,
        function: [
          {
            pattern: /(\.)(?!\d)\w+/,
            lookbehind: !0
          },
          /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
        ],
        number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
        boolean: /\b(?:false|true)\b/,
        // Includes words reserved for future use
        keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
        datatype: {
          pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
          alias: "symbol"
        },
        operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
        punctuation: /[\[\]{}().,;]|:+/
      };
      var r = [
        {
          // Allow for one nested level of braces inside interpolation
          pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
          lookbehind: !0,
          inside: {
            "short-variable": {
              // Negative look-ahead prevent wrong highlighting of functions
              pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
              lookbehind: !0,
              alias: "variable",
              inside: {
                punctuation: /::/
              }
            },
            delimiter: {
              pattern: /^\$/,
              alias: "variable"
            },
            rest: n.languages.puppet
          }
        },
        {
          pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
          lookbehind: !0,
          alias: "variable",
          inside: {
            punctuation: /::/
          }
        }
      ];
      n.languages.puppet.heredoc[0].inside.interpolation = r, n.languages.puppet.string.inside["double-quoted"].inside.interpolation = r;
    })(t);
  }
  return dh;
}
var ph, $_;
function M7() {
  if ($_) return ph;
  $_ = 1, ph = e, e.displayName = "pure", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.pure = {
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
            lookbehind: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0
          },
          /#!.+/
        ],
        "inline-lang": {
          pattern: /%<[\s\S]+?%>/,
          greedy: !0,
          inside: {
            lang: {
              pattern: /(^%< *)-\*-.+?-\*-/,
              lookbehind: !0,
              alias: "comment"
            },
            delimiter: {
              pattern: /^%<.*|%>$/,
              alias: "punctuation"
            }
          }
        },
        string: {
          pattern: /"(?:\\.|[^"\\\r\n])*"/,
          greedy: !0
        },
        number: {
          // The look-behind prevents wrong highlighting of the .. operator
          pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d+)?|\B\.\d+)(?:e[+-]?\d+)?L?)/i,
          lookbehind: !0
        },
        keyword: /\b(?:NULL|ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
        function: /\b(?:abs|add_(?:addr|constdef|(?:fundef|interface|macdef|typedef)(?:_at)?|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_c?string(?:_pointer)?|byte_(?:matrix|pointer)|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|sentry|short|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
        special: {
          pattern: /\b__[a-z]+__\b/i,
          alias: "builtin"
        },
        // Any combination of operator chars can be an operator
        // eslint-disable-next-line no-misleading-character-class
        operator: /(?:[!"#$%&'*+,\-.\/:<=>?@\\^`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]|\b_+\b)+|\b(?:and|div|mod|not|or)\b/,
        // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
        punctuation: /[(){}\[\];,|]/
      };
      var r = [
        "c",
        {
          lang: "c++",
          alias: "cpp"
        },
        "fortran"
      ], a = /%< *-\*- *<lang>\d* *-\*-[\s\S]+?%>/.source;
      r.forEach(function(i) {
        var s = i;
        if (typeof i != "string" && (s = i.alias, i = i.lang), n.languages[s]) {
          var u = {};
          u["inline-lang-" + s] = {
            pattern: RegExp(
              a.replace(
                "<lang>",
                i.replace(/([.+*?\/\\(){}\[\]])/g, "\\$1")
              ),
              "i"
            ),
            inside: n.util.clone(n.languages.pure["inline-lang"].inside)
          }, u["inline-lang-" + s].inside.rest = n.util.clone(
            n.languages[s]
          ), n.languages.insertBefore("pure", "inline-lang", u);
        }
      }), n.languages.c && (n.languages.pure["inline-lang"].inside.rest = n.util.clone(
        n.languages.c
      ));
    })(t);
  }
  return ph;
}
var fh, U_;
function F7() {
  if (U_) return fh;
  U_ = 1, fh = e, e.displayName = "purebasic", e.aliases = [];
  function e(t) {
    t.languages.purebasic = t.languages.extend("clike", {
      comment: /;.*/,
      keyword: /\b(?:align|and|as|break|calldebugger|case|compilercase|compilerdefault|compilerelse|compilerelseif|compilerendif|compilerendselect|compilererror|compilerif|compilerselect|continue|data|datasection|debug|debuglevel|declare|declarec|declarecdll|declaredll|declaremodule|default|define|dim|disableasm|disabledebugger|disableexplicit|else|elseif|enableasm|enabledebugger|enableexplicit|end|enddatasection|enddeclaremodule|endenumeration|endif|endimport|endinterface|endmacro|endmodule|endprocedure|endselect|endstructure|endstructureunion|endwith|enumeration|extends|fakereturn|for|foreach|forever|global|gosub|goto|if|import|importc|includebinary|includefile|includepath|interface|macro|module|newlist|newmap|next|not|or|procedure|procedurec|procedurecdll|proceduredll|procedurereturn|protected|prototype|prototypec|read|redim|repeat|restore|return|runtime|select|shared|static|step|structure|structureunion|swap|threaded|to|until|wend|while|with|xincludefile|xor)\b/i,
      function: /\b\w+(?:\.\w+)?\s*(?=\()/,
      number: /(?:\$[\da-f]+|\b-?(?:\d+(?:\.\d+)?|\.\d+)(?:e[+-]?\d+)?)\b/i,
      operator: /(?:@\*?|\?|\*)\w+|-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*/@]/
    }), t.languages.insertBefore("purebasic", "keyword", {
      tag: /#\w+\$?/,
      asm: {
        pattern: /(^[\t ]*)!.*/m,
        lookbehind: !0,
        alias: "tag",
        inside: {
          comment: /;.*/,
          string: {
            pattern: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
            greedy: !0
          },
          // Anonymous label references, i.e.: jmp @b
          "label-reference-anonymous": {
            pattern: /(!\s*j[a-z]+\s+)@[fb]/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          // Named label reference, i.e.: jne label1
          "label-reference-addressed": {
            pattern: /(!\s*j[a-z]+\s+)[A-Z._?$@][\w.?$@~#]*/i,
            lookbehind: !0,
            alias: "fasm-label"
          },
          keyword: [
            /\b(?:extern|global)\b[^;\r\n]*/i,
            /\b(?:CPU|DEFAULT|FLOAT)\b.*/
          ],
          function: {
            pattern: /^([\t ]*!\s*)[\da-z]+(?=\s|$)/im,
            lookbehind: !0
          },
          "function-inline": {
            pattern: /(:\s*)[\da-z]+(?=\s)/i,
            lookbehind: !0,
            alias: "function"
          },
          label: {
            pattern: /^([\t ]*!\s*)[A-Za-z._?$@][\w.?$@~#]*(?=:)/m,
            lookbehind: !0,
            alias: "fasm-label"
          },
          register: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|di|si|sp)|[cdefgs]s|mm\d+)\b/i,
          number: /(?:\b|-|(?=\$))(?:0[hx](?:[\da-f]*\.)?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|(?:\d+(?:\.\d+)?|\.\d+)(?:\.?e[+-]?\d+)?[dt]?)\b/i,
          operator: /[\[\]*+\-/%<>=&|$!,.:]/
        }
      }
    }), delete t.languages.purebasic["class-name"], delete t.languages.purebasic.boolean, t.languages.pbfasm = t.languages.purebasic;
  }
  return fh;
}
var gh, j_;
function P7() {
  if (j_) return gh;
  j_ = 1;
  var e = Bv();
  gh = t, t.displayName = "purescript", t.aliases = ["purs"];
  function t(n) {
    n.register(e), n.languages.purescript = n.languages.extend("haskell", {
      keyword: /\b(?:ado|case|class|data|derive|do|else|forall|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b|∀/,
      "import-statement": {
        // The imported or hidden names are not included in this import
        // statement. This is because we want to highlight those exactly like
        // we do for the names in the program.
        pattern: /(^[\t ]*)import\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*(?:\s+as\s+[A-Z][\w']*(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
        lookbehind: !0,
        inside: {
          keyword: /\b(?:as|hiding|import)\b/,
          punctuation: /\./
        }
      },
      // These are builtin functions only. Constructors are highlighted later as a constant.
      builtin: /\b(?:absurd|add|ap|append|apply|between|bind|bottom|clamp|compare|comparing|compose|conj|const|degree|discard|disj|div|eq|flap|flip|gcd|identity|ifM|join|lcm|liftA1|liftM1|map|max|mempty|min|mod|mul|negate|not|notEq|one|otherwise|recip|show|sub|top|unit|unless|unlessM|void|when|whenM|zero)\b/,
      operator: [
        // Infix operators
        n.languages.haskell.operator[0],
        // ASCII operators
        n.languages.haskell.operator[2],
        // All UTF16 Unicode operator symbols
        // This regex is equivalent to /(?=[\x80-\uFFFF])[\p{gc=Math_Symbol}\p{gc=Currency_Symbol}\p{Modifier_Symbol}\p{Other_Symbol}]/u
        // See https://github.com/PrismJS/prism/issues/3006 for more details.
        /[\xa2-\xa6\xa8\xa9\xac\xae-\xb1\xb4\xb8\xd7\xf7\u02c2-\u02c5\u02d2-\u02df\u02e5-\u02eb\u02ed\u02ef-\u02ff\u0375\u0384\u0385\u03f6\u0482\u058d-\u058f\u0606-\u0608\u060b\u060e\u060f\u06de\u06e9\u06fd\u06fe\u07f6\u07fe\u07ff\u09f2\u09f3\u09fa\u09fb\u0af1\u0b70\u0bf3-\u0bfa\u0c7f\u0d4f\u0d79\u0e3f\u0f01-\u0f03\u0f13\u0f15-\u0f17\u0f1a-\u0f1f\u0f34\u0f36\u0f38\u0fbe-\u0fc5\u0fc7-\u0fcc\u0fce\u0fcf\u0fd5-\u0fd8\u109e\u109f\u1390-\u1399\u166d\u17db\u1940\u19de-\u19ff\u1b61-\u1b6a\u1b74-\u1b7c\u1fbd\u1fbf-\u1fc1\u1fcd-\u1fcf\u1fdd-\u1fdf\u1fed-\u1fef\u1ffd\u1ffe\u2044\u2052\u207a-\u207c\u208a-\u208c\u20a0-\u20bf\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211e-\u2123\u2125\u2127\u2129\u212e\u213a\u213b\u2140-\u2144\u214a-\u214d\u214f\u218a\u218b\u2190-\u2307\u230c-\u2328\u232b-\u2426\u2440-\u244a\u249c-\u24e9\u2500-\u2767\u2794-\u27c4\u27c7-\u27e5\u27f0-\u2982\u2999-\u29d7\u29dc-\u29fb\u29fe-\u2b73\u2b76-\u2b95\u2b97-\u2bff\u2ce5-\u2cea\u2e50\u2e51\u2e80-\u2e99\u2e9b-\u2ef3\u2f00-\u2fd5\u2ff0-\u2ffb\u3004\u3012\u3013\u3020\u3036\u3037\u303e\u303f\u309b\u309c\u3190\u3191\u3196-\u319f\u31c0-\u31e3\u3200-\u321e\u322a-\u3247\u3250\u3260-\u327f\u328a-\u32b0\u32c0-\u33ff\u4dc0-\u4dff\ua490-\ua4c6\ua700-\ua716\ua720\ua721\ua789\ua78a\ua828-\ua82b\ua836-\ua839\uaa77-\uaa79\uab5b\uab6a\uab6b\ufb29\ufbb2-\ufbc1\ufdfc\ufdfd\ufe62\ufe64-\ufe66\ufe69\uff04\uff0b\uff1c-\uff1e\uff3e\uff40\uff5c\uff5e\uffe0-\uffe6\uffe8-\uffee\ufffc\ufffd]/
      ]
    }), n.languages.purs = n.languages.purescript;
  }
  return gh;
}
var mh, q_;
function B7() {
  if (q_) return mh;
  q_ = 1, mh = e, e.displayName = "python", e.aliases = ["py"];
  function e(t) {
    t.languages.python = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0,
        greedy: !0
      },
      "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: !0,
        inside: {
          interpolation: {
            // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
            pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
            lookbehind: !0,
            inside: {
              "format-spec": {
                pattern: /(:)[^:(){}]+(?=\}$)/,
                lookbehind: !0
              },
              "conversion-option": {
                pattern: /![sra](?=[:}]$)/,
                alias: "punctuation"
              },
              rest: null
            }
          },
          string: /[\s\S]+/
        }
      },
      "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: !0
      },
      function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: !0
      },
      "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: !0
      },
      decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: !0,
        alias: ["annotation", "punctuation"],
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
      builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
      boolean: /\b(?:False|None|True)\b/,
      number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
      operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.python["string-interpolation"].inside.interpolation.inside.rest = t.languages.python, t.languages.py = t.languages.python;
  }
  return mh;
}
var hh, z_;
function $7() {
  if (z_) return hh;
  z_ = 1, hh = e, e.displayName = "q", e.aliases = [];
  function e(t) {
    t.languages.q = {
      string: /"(?:\\.|[^"\\\r\n])*"/,
      comment: [
        // From http://code.kx.com/wiki/Reference/Slash:
        // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
        {
          pattern: /([\t )\]}])\/.*/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
        // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
        // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
        // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
        {
          pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
          lookbehind: !0,
          greedy: !0
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A \ on a line by itself with no preceding matching / will comment to end of file.
        {
          pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
          greedy: !0
        },
        {
          pattern: /^#!.+/m,
          greedy: !0
        }
      ],
      symbol: /`(?::\S+|[\w.]*)/,
      datetime: {
        pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
        alias: "number"
      },
      // The negative look-ahead prevents bad highlighting
      // of verbs 0: and 1:
      number: /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
      keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
      adverb: {
        pattern: /['\/\\]:?|\beach\b/,
        alias: "function"
      },
      verb: {
        pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
        alias: "operator"
      },
      punctuation: /[(){}\[\];.]/
    };
  }
  return hh;
}
var bh, G_;
function U7() {
  if (G_) return bh;
  G_ = 1, bh = e, e.displayName = "qml", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /"(?:\\.|[^\\"\r\n])*"|'(?:\\.|[^\\'\r\n])*'/.source, a = /\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))*\*\//.source, i = /(?:[^\\()[\]{}"'/]|<string>|\/(?![*/])|<comment>|\(<expr>*\)|\[<expr>*\]|\{<expr>*\}|\\[\s\S])/.source.replace(/<string>/g, function() {
        return r;
      }).replace(/<comment>/g, function() {
        return a;
      }), s = 0; s < 2; s++)
        i = i.replace(/<expr>/g, function() {
          return i;
        });
      i = i.replace(/<expr>/g, "[^\\s\\S]"), n.languages.qml = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        "javascript-function": {
          pattern: RegExp(
            /((?:^|;)[ \t]*)function\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*\(<js>*\)\s*\{<js>*\}/.source.replace(
              /<js>/g,
              function() {
                return i;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: n.languages.javascript
        },
        "class-name": {
          pattern: /((?:^|[:;])[ \t]*)(?!\d)\w+(?=[ \t]*\{|[ \t]+on\b)/m,
          lookbehind: !0
        },
        property: [
          {
            pattern: /((?:^|[;{])[ \t]*)(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0
          },
          {
            pattern: /((?:^|[;{])[ \t]*)property[ \t]+(?!\d)\w+(?:\.\w+)*[ \t]+(?!\d)\w+(?:\.\w+)*(?=[ \t]*:)/m,
            lookbehind: !0,
            inside: {
              keyword: /^property/,
              property: /\w+(?:\.\w+)*/
            }
          }
        ],
        "javascript-expression": {
          pattern: RegExp(
            /(:[ \t]*)(?![\s;}[])(?:(?!$|[;}])<js>)+/.source.replace(
              /<js>/g,
              function() {
                return i;
              }
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "language-javascript",
          inside: n.languages.javascript
        },
        string: {
          pattern: /"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        keyword: /\b(?:as|import|on)\b/,
        punctuation: /[{}[\]:;,]/
      };
    })(t);
  }
  return bh;
}
var yh, H_;
function j7() {
  if (H_) return yh;
  H_ = 1, yh = e, e.displayName = "qore", e.aliases = [];
  function e(t) {
    t.languages.qore = t.languages.extend("clike", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
        lookbehind: !0
      },
      // Overridden to allow unescaped multi-line strings
      string: {
        pattern: /("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: !0
      },
      keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:bool|date|float|int|list|number|string)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
      boolean: /\b(?:false|true)\b/i,
      function: /\$?\b(?!\d)\w+(?=\()/,
      number: /\b(?:0b[01]+|0x(?:[\da-f]*\.)?[\da-fp\-]+|(?:\d+(?:\.\d+)?|\.\d+)(?:e\d+)?[df]|(?:\d+(?:\.\d+)?|\.\d+))\b/i,
      operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
        lookbehind: !0
      },
      variable: /\$(?!\d)\w+\b/
    });
  }
  return yh;
}
var vh, V_;
function q7() {
  if (V_) return vh;
  V_ = 1, vh = e, e.displayName = "qsharp", e.aliases = ["qs"];
  function e(t) {
    (function(n) {
      function r(E, y) {
        return E.replace(/<<(\d+)>>/g, function(w, x) {
          return "(?:" + y[+x] + ")";
        });
      }
      function a(E, y, w) {
        return RegExp(r(E, y), "");
      }
      function i(E, y) {
        for (var w = 0; w < y; w++)
          E = E.replace(/<<self>>/g, function() {
            return "(?:" + E + ")";
          });
        return E.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var s = {
        // keywords which represent a return or variable type
        type: "Adj BigInt Bool Ctl Double false Int One Pauli PauliI PauliX PauliY PauliZ Qubit Range Result String true Unit Zero",
        // all other keywords
        other: "Adjoint adjoint apply as auto body borrow borrowing Controlled controlled distribute elif else fail fixup for function if in internal intrinsic invert is let mutable namespace new newtype open operation repeat return self set until use using while within"
      };
      function u(E) {
        return "\\b(?:" + E.trim().replace(/ /g, "|") + ")\\b";
      }
      var c = RegExp(
        u(s.type + " " + s.other)
      ), d = /\b[A-Za-z_]\w*\b/.source, p = r(/<<0>>(?:\s*\.\s*<<0>>)*/.source, [d]), f = {
        keyword: c,
        punctuation: /[<>()?,.:[\]]/
      }, m = /"(?:\\.|[^\\"])*"/.source;
      n.languages.qsharp = n.languages.extend("clike", {
        comment: /\/\/.*/,
        string: [
          {
            pattern: a(/(^|[^$\\])<<0>>/.source, [m]),
            lookbehind: !0,
            greedy: !0
          }
        ],
        "class-name": [
          {
            // open Microsoft.Quantum.Canon;
            // open Microsoft.Quantum.Canon as CN;
            pattern: a(/(\b(?:as|open)\s+)<<0>>(?=\s*(?:;|as\b))/.source, [
              p
            ]),
            lookbehind: !0,
            inside: f
          },
          {
            // namespace Quantum.App1;
            pattern: a(/(\bnamespace\s+)<<0>>(?=\s*\{)/.source, [p]),
            lookbehind: !0,
            inside: f
          }
        ],
        keyword: c,
        number: /(?:\b0(?:x[\da-f]+|b[01]+|o[0-7]+)|(?:\B\.\d+|\b\d+(?:\.\d*)?)(?:e[-+]?\d+)?)l?\b/i,
        operator: /\band=|\bor=|\band\b|\bnot\b|\bor\b|<[-=]|[-=]>|>>>=?|<<<=?|\^\^\^=?|\|\|\|=?|&&&=?|w\/=?|~~~|[*\/+\-^=!%]=?/,
        punctuation: /::|[{}[\];(),.:]/
      }), n.languages.insertBefore("qsharp", "number", {
        range: {
          pattern: /\.\./,
          alias: "operator"
        }
      });
      var h = i(
        r(/\{(?:[^"{}]|<<0>>|<<self>>)*\}/.source, [m]),
        2
      );
      n.languages.insertBefore("qsharp", "string", {
        "interpolation-string": {
          pattern: a(/\$"(?:\\.|<<0>>|[^\\"{])*"/.source, [h]),
          greedy: !0,
          inside: {
            interpolation: {
              pattern: a(/((?:^|[^\\])(?:\\\\)*)<<0>>/.source, [
                h
              ]),
              lookbehind: !0,
              inside: {
                punctuation: /^\{|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  alias: "language-qsharp",
                  inside: n.languages.qsharp
                }
              }
            },
            string: /[\s\S]+/
          }
        }
      });
    })(t), t.languages.qs = t.languages.qsharp;
  }
  return vh;
}
var Eh, W_;
function z7() {
  if (W_) return Eh;
  W_ = 1, Eh = e, e.displayName = "r", e.aliases = [];
  function e(t) {
    t.languages.r = {
      comment: /#.*/,
      string: {
        pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "percent-operator": {
        // Includes user-defined operators
        // and %%, %*%, %/%, %in%, %o%, %x%
        pattern: /%[^%\s]*%/,
        alias: "operator"
      },
      boolean: /\b(?:FALSE|TRUE)\b/,
      ellipsis: /\.\.(?:\.|\d+)/,
      number: [
        /\b(?:Inf|NaN)\b/,
        /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+(?:\.\d*)?|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
      ],
      keyword: /\b(?:NA|NA_character_|NA_complex_|NA_integer_|NA_real_|NULL|break|else|for|function|if|in|next|repeat|while)\b/,
      operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
      punctuation: /[(){}\[\],;]/
    };
  }
  return Eh;
}
var Sh, K_;
function G7() {
  if (K_) return Sh;
  K_ = 1;
  var e = qv();
  Sh = t, t.displayName = "racket", t.aliases = ["rkt"];
  function t(n) {
    n.register(e), n.languages.racket = n.languages.extend("scheme", {
      "lambda-parameter": {
        // the racket lambda syntax is a lot more complex, so we won't even attempt to capture it.
        // this will just prevent false positives of the `function` pattern
        pattern: /([(\[]lambda\s+[(\[])[^()\[\]'\s]+/,
        lookbehind: !0
      }
    }), n.languages.insertBefore("racket", "string", {
      lang: {
        pattern: /^#lang.+/m,
        greedy: !0,
        alias: "keyword"
      }
    }), n.languages.rkt = n.languages.racket;
  }
  return Sh;
}
var xh, Y_;
function H7() {
  if (Y_) return xh;
  Y_ = 1, xh = e, e.displayName = "reason", e.aliases = [];
  function e(t) {
    t.languages.reason = t.languages.extend("clike", {
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: !0
      },
      // 'class-name' must be matched *after* 'constructor' defined below
      "class-name": /\b[A-Z]\w*/,
      keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
      operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
    }), t.languages.insertBefore("reason", "class-name", {
      char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: !0
      },
      // Negative look-ahead prevents from matching things like String.capitalize
      constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
      label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
      }
    }), delete t.languages.reason.function;
  }
  return xh;
}
var Th, X_;
function V7() {
  if (X_) return Th;
  X_ = 1, Th = e, e.displayName = "regex", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
      }, a = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, i = {
        pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, s = {
        pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
        alias: "class-name"
      }, u = "(?:[^\\\\-]|" + a.source + ")", c = RegExp(u + "-" + u), d = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: !0,
        alias: "variable"
      };
      n.languages.regex = {
        "char-class": {
          pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
          lookbehind: !0,
          inside: {
            "char-class-negation": {
              pattern: /(^\[)\^/,
              lookbehind: !0,
              alias: "operator"
            },
            "char-class-punctuation": {
              pattern: /^\[|\]$/,
              alias: "punctuation"
            },
            range: {
              pattern: c,
              inside: {
                escape: a,
                "range-punctuation": {
                  pattern: /-/,
                  alias: "operator"
                }
              }
            },
            "special-escape": r,
            "char-set": s,
            escape: a
          }
        },
        "special-escape": r,
        "char-set": i,
        backreference: [
          {
            // a backreference which is not an octal escape
            pattern: /\\(?![123][0-7]{2})[1-9]/,
            alias: "keyword"
          },
          {
            pattern: /\\k<[^<>']+>/,
            alias: "keyword",
            inside: {
              "group-name": d
            }
          }
        ],
        anchor: {
          pattern: /[$^]|\\[ABbGZz]/,
          alias: "function"
        },
        escape: a,
        group: [
          {
            // https://docs.oracle.com/javase/10/docs/api/java/util/regex/Pattern.html
            // https://docs.microsoft.com/en-us/dotnet/standard/base-types/regular-expression-language-quick-reference?view=netframework-4.7.2#grouping-constructs
            // (), (?<name>), (?'name'), (?>), (?:), (?=), (?!), (?<=), (?<!), (?is-m), (?i-m:)
            pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
            alias: "punctuation",
            inside: {
              "group-name": d
            }
          },
          {
            pattern: /\)/,
            alias: "punctuation"
          }
        ],
        quantifier: {
          pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
          alias: "number"
        },
        alternation: {
          pattern: /\|/,
          alias: "keyword"
        }
      };
    })(t);
  }
  return Th;
}
var wh, Z_;
function W7() {
  if (Z_) return wh;
  Z_ = 1, wh = e, e.displayName = "rego", e.aliases = [];
  function e(t) {
    t.languages.rego = {
      comment: /#.*/,
      property: {
        pattern: /(^|[^\\.])(?:"(?:\\.|[^\\"\r\n])*"|`[^`]*`|\b[a-z_]\w*\b)(?=\s*:(?!=))/i,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"|`[^`]*`/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /\b(?:as|default|else|import|not|null|package|set(?=\s*\()|some|with)\b/,
      boolean: /\b(?:false|true)\b/,
      function: {
        pattern: /\b[a-z_]\w*\b(?:\s*\.\s*\b[a-z_]\w*\b)*(?=\s*\()/i,
        inside: {
          namespace: /\b\w+\b(?=\s*\.)/,
          punctuation: /\./
        }
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      operator: /[-+*/%|&]|[<>:=]=?|!=|\b_\b/,
      punctuation: /[,;.\[\]{}()]/
    };
  }
  return wh;
}
var Ah, J_;
function K7() {
  if (J_) return Ah;
  J_ = 1, Ah = e, e.displayName = "renpy", e.aliases = ["rpy"];
  function e(t) {
    t.languages.renpy = {
      comment: {
        pattern: /(^|[^\\])#.+/,
        lookbehind: !0
      },
      string: {
        pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\])*\2|(?:^#?(?:(?:[0-9a-fA-F]){3}|[0-9a-fA-F]{6})$)/m,
        greedy: !0
      },
      function: /\b[a-z_]\w*(?=\()/i,
      property: /\b(?:Update|UpdateVersion|action|activate_sound|adv_nvl_transition|after_load_transition|align|alpha|alt|anchor|antialias|area|auto|background|bar_invert|bar_resizing|bar_vertical|black_color|bold|bottom_bar|bottom_gutter|bottom_margin|bottom_padding|box_reverse|box_wrap|can_update|caret|child|color|crop|default_afm_enable|default_afm_time|default_fullscreen|default_text_cps|developer|directory_name|drag_handle|drag_joined|drag_name|drag_raise|draggable|dragged|drop_shadow|drop_shadow_color|droppable|dropped|easein|easeout|edgescroll|end_game_transition|end_splash_transition|enter_replay_transition|enter_sound|enter_transition|enter_yesno_transition|executable_name|exit_replay_transition|exit_sound|exit_transition|exit_yesno_transition|fadein|fadeout|first_indent|first_spacing|fit_first|focus|focus_mask|font|foreground|game_main_transition|get_installed_packages|google_play_key|google_play_salt|ground|has_music|has_sound|has_voice|height|help|hinting|hover|hover_background|hover_color|hover_sound|hovered|hyperlink_functions|idle|idle_color|image_style|include_update|insensitive|insensitive_background|insensitive_color|inside|intra_transition|italic|justify|kerning|keyboard_focus|language|layer_clipping|layers|layout|left_bar|left_gutter|left_margin|left_padding|length|line_leading|line_overlap_split|line_spacing|linear|main_game_transition|main_menu_music|maximum|min_width|minimum|minwidth|modal|mouse|mousewheel|name|narrator_menu|newline_indent|nvl_adv_transition|offset|order_reverse|outlines|overlay_functions|pos|position|prefix|radius|range|rest_indent|right_bar|right_gutter|right_margin|right_padding|rotate|rotate_pad|ruby_style|sample_sound|save_directory|say_attribute_transition|screen_height|screen_width|scrollbars|selected_hover|selected_hover_color|selected_idle|selected_idle_color|selected_insensitive|show_side_image|show_two_window|side_spacing|side_xpos|side_ypos|size|size_group|slow_cps|slow_cps_multiplier|spacing|strikethrough|subpixel|text_align|text_style|text_xpos|text_y_fudge|text_ypos|thumb|thumb_offset|thumb_shadow|thumbnail_height|thumbnail_width|time|top_bar|top_gutter|top_margin|top_padding|translations|underline|unscrollable|update|value|version|version_name|version_tuple|vertical|width|window_hide_transition|window_icon|window_left_padding|window_show_transition|window_title|windows_icon|xadjustment|xalign|xanchor|xanchoraround|xaround|xcenter|xfill|xinitial|xmargin|xmaximum|xminimum|xoffset|xofsset|xpadding|xpos|xsize|xzoom|yadjustment|yalign|yanchor|yanchoraround|yaround|ycenter|yfill|yinitial|ymargin|ymaximum|yminimum|yoffset|ypadding|ypos|ysize|ysizexysize|yzoom|zoom|zorder)\b/,
      tag: /\b(?:bar|block|button|buttoscreenn|drag|draggroup|fixed|frame|grid|[hv]box|hotbar|hotspot|image|imagebutton|imagemap|input|key|label|menu|mm_menu_frame|mousearea|nvl|parallel|screen|self|side|tag|text|textbutton|timer|vbar|viewport|window)\b|\$/,
      keyword: /\b(?:None|add|adjustment|alignaround|allow|angle|animation|around|as|assert|behind|box_layout|break|build|cache|call|center|changed|child_size|choice|circles|class|clear|clicked|clipping|clockwise|config|contains|continue|corner1|corner2|counterclockwise|def|default|define|del|delay|disabled|disabled_text|dissolve|elif|else|event|except|exclude|exec|expression|fade|finally|for|from|function|global|gm_root|has|hide|id|if|import|in|init|is|jump|knot|lambda|left|less_rounded|mm_root|movie|music|null|on|onlayer|pass|pause|persistent|play|print|python|queue|raise|random|renpy|repeat|return|right|rounded_window|scene|scope|set|show|slow|slow_abortable|slow_done|sound|stop|store|style|style_group|substitute|suffix|theme|transform|transform_anchor|transpose|try|ui|unhovered|updater|use|voice|while|widget|widget_hover|widget_selected|widget_text|yield)\b/,
      boolean: /\b(?:[Ff]alse|[Tt]rue)\b/,
      number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
      operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:and|at|not|or|with)\b/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.rpy = t.languages.renpy;
  }
  return Ah;
}
var Ih, Q_;
function Y7() {
  if (Q_) return Ih;
  Q_ = 1, Ih = e, e.displayName = "rest", e.aliases = [];
  function e(t) {
    t.languages.rest = {
      table: [
        {
          pattern: /(^[\t ]*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1[+|].+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/m,
          lookbehind: !0,
          inside: {
            punctuation: /\||(?:\+[=-]+)+\+/
          }
        },
        {
          pattern: /(^[\t ]*)=+ [ =]*=(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1=+ [ =]*=(?=(?:\r?\n|\r){2}|\s*$)/m,
          lookbehind: !0,
          inside: {
            punctuation: /[=-]+/
          }
        }
      ],
      // Directive-like patterns
      "substitution-def": {
        pattern: /(^[\t ]*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
        lookbehind: !0,
        inside: {
          substitution: {
            pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
            alias: "attr-value",
            inside: {
              punctuation: /^\||\|$/
            }
          },
          directive: {
            pattern: /( )(?! )[^:]+::/,
            lookbehind: !0,
            alias: "function",
            inside: {
              punctuation: /::$/
            }
          }
        }
      },
      "link-target": [
        {
          pattern: /(^[\t ]*\.\. )\[[^\]]+\]/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^\[|\]$/
          }
        },
        {
          pattern: /(^[\t ]*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /^_|:$/
          }
        }
      ],
      directive: {
        pattern: /(^[\t ]*\.\. )[^:]+::/m,
        lookbehind: !0,
        alias: "function",
        inside: {
          punctuation: /::$/
        }
      },
      comment: {
        // The two alternatives try to prevent highlighting of blank comments
        pattern: /(^[\t ]*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
        lookbehind: !0
      },
      title: [
        // Overlined and underlined
        {
          pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
          inside: {
            punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        },
        // Underlined only
        {
          pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
          lookbehind: !0,
          inside: {
            punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
            important: /.+/
          }
        }
      ],
      hr: {
        pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
        lookbehind: !0,
        alias: "punctuation"
      },
      field: {
        pattern: /(^[\t ]*):[^:\r\n]+:(?= )/m,
        lookbehind: !0,
        alias: "attr-name"
      },
      "command-line-option": {
        pattern: /(^[\t ]*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
        lookbehind: !0,
        alias: "symbol"
      },
      "literal-block": {
        pattern: /::(?:\r?\n|\r){2}([ \t]+)(?![ \t]).+(?:(?:\r?\n|\r)\1.+)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^::/,
            alias: "punctuation"
          }
        }
      },
      "quoted-literal-block": {
        pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
        inside: {
          "literal-block-punctuation": {
            pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
            alias: "punctuation"
          }
        }
      },
      "list-bullet": {
        pattern: /(^[\t ]*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
        lookbehind: !0,
        alias: "punctuation"
      },
      "doctest-block": {
        pattern: /(^[\t ]*)>>> .+(?:(?:\r?\n|\r).+)*/m,
        lookbehind: !0,
        inside: {
          punctuation: /^>>>/
        }
      },
      inline: [
        {
          pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s)(?:(?!\2).)*\S\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
          lookbehind: !0,
          inside: {
            bold: {
              pattern: /(^\*\*).+(?=\*\*$)/,
              lookbehind: !0
            },
            italic: {
              pattern: /(^\*).+(?=\*$)/,
              lookbehind: !0
            },
            "inline-literal": {
              pattern: /(^``).+(?=``$)/,
              lookbehind: !0,
              alias: "symbol"
            },
            role: {
              pattern: /^:[^:]+:|:[^:]+:$/,
              alias: "function",
              inside: {
                punctuation: /^:|:$/
              }
            },
            "interpreted-text": {
              pattern: /(^`).+(?=`$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            substitution: {
              pattern: /(^\|).+(?=\|$)/,
              lookbehind: !0,
              alias: "attr-value"
            },
            punctuation: /\*\*?|``?|\|/
          }
        }
      ],
      link: [
        {
          pattern: /\[[^\[\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
          alias: "string",
          inside: {
            punctuation: /^\[|\]_$/
          }
        },
        {
          pattern: /(?:\b[a-z\d]+(?:[_.:+][a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
          alias: "string",
          inside: {
            punctuation: /^_?`|`$|`?_?_$/
          }
        }
      ],
      // Line block start,
      // quote attribution,
      // explicit markup start,
      // and anonymous hyperlink target shortcut (__)
      punctuation: {
        pattern: /(^[\t ]*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
        lookbehind: !0
      }
    };
  }
  return Ih;
}
var Rh, eC;
function X7() {
  if (eC) return Rh;
  eC = 1, Rh = e, e.displayName = "rip", e.aliases = [];
  function e(t) {
    t.languages.rip = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      char: {
        pattern: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      regex: {
        pattern: /(^|[^/])\/(?!\/)(?:\[[^\n\r\]]*\]|\\.|[^/\\\r\n\[])+\/(?=\s*(?:$|[\r\n,.;})]))/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:=>|->)|\b(?:case|catch|class|else|exit|finally|if|raise|return|switch|try)\b/,
      builtin: /@|\bSystem\b/,
      boolean: /\b(?:false|true)\b/,
      date: /\b\d{4}-\d{2}-\d{2}\b/,
      time: /\b\d{2}:\d{2}:\d{2}\b/,
      datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
      symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
      number: /[+-]?\b(?:\d+\.\d+|\d+)\b/,
      punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
      reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
    };
  }
  return Rh;
}
var _h, tC;
function Z7() {
  if (tC) return _h;
  tC = 1, _h = e, e.displayName = "roboconf", e.aliases = [];
  function e(t) {
    t.languages.roboconf = {
      comment: /#.*/,
      keyword: {
        pattern: /(^|\s)(?:(?:external|import)\b|(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{))/,
        lookbehind: !0
      },
      component: {
        pattern: /[\w-]+(?=[ \t]*\{)/,
        alias: "variable"
      },
      property: /[\w.-]+(?=[ \t]*:)/,
      value: {
        pattern: /(=[ \t]*(?![ \t]))[^,;]+/,
        lookbehind: !0,
        alias: "attr-value"
      },
      optional: {
        pattern: /\(optional\)/,
        alias: "builtin"
      },
      wildcard: {
        pattern: /(\.)\*/,
        lookbehind: !0,
        alias: "operator"
      },
      punctuation: /[{},.;:=]/
    };
  }
  return _h;
}
var Ch, nC;
function J7() {
  if (nC) return Ch;
  nC = 1, Ch = e, e.displayName = "robotframework", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(^[ \t]*| {2}|\t)#.*/m,
        lookbehind: !0,
        greedy: !0
      }, a = {
        pattern: /((?:^|[^\\])(?:\\{2})*)[$@&%]\{(?:[^{}\r\n]|\{[^{}\r\n]*\})*\}/,
        lookbehind: !0,
        inside: {
          punctuation: /^[$@&%]\{|\}$/
        }
      };
      function i(d, p) {
        var f = {};
        f["section-header"] = {
          pattern: /^ ?\*{3}.+?\*{3}/,
          alias: "keyword"
        };
        for (var m in p)
          f[m] = p[m];
        return f.tag = {
          pattern: /([\r\n](?: {2}|\t)[ \t]*)\[[-\w]+\]/,
          lookbehind: !0,
          inside: {
            punctuation: /\[|\]/
          }
        }, f.variable = a, f.comment = r, {
          pattern: RegExp(
            /^ ?\*{3}[ \t]*<name>[ \t]*\*{3}(?:.|[\r\n](?!\*{3}))*/.source.replace(
              /<name>/g,
              function() {
                return d;
              }
            ),
            "im"
          ),
          alias: "section",
          inside: f
        };
      }
      var s = {
        pattern: /(\[Documentation\](?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
        lookbehind: !0,
        alias: "string"
      }, u = {
        pattern: /([\r\n] ?)(?!#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        alias: "function",
        inside: {
          variable: a
        }
      }, c = {
        pattern: /([\r\n](?: {2}|\t)[ \t]*)(?!\[|\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
        lookbehind: !0,
        inside: {
          variable: a
        }
      };
      n.languages.robotframework = {
        settings: i("Settings", {
          documentation: {
            pattern: /([\r\n] ?Documentation(?: {2}|\t)[ \t]*)(?![ \t]|#)(?:.|(?:\r\n?|\n)[ \t]*\.{3})+/,
            lookbehind: !0,
            alias: "string"
          },
          property: {
            pattern: /([\r\n] ?)(?!\.{3}|#)(?:\S(?:[ \t]\S)*)+/,
            lookbehind: !0
          }
        }),
        variables: i("Variables"),
        "test-cases": i("Test Cases", {
          "test-name": u,
          documentation: s,
          property: c
        }),
        keywords: i("Keywords", {
          "keyword-name": u,
          documentation: s,
          property: c
        }),
        tasks: i("Tasks", {
          "task-name": u,
          documentation: s,
          property: c
        }),
        comment: r
      }, n.languages.robot = n.languages.robotframework;
    })(t);
  }
  return Ch;
}
var kh, rC;
function Q7() {
  if (rC) return kh;
  rC = 1, kh = e, e.displayName = "rust", e.aliases = [];
  function e(t) {
    (function(n) {
      for (var r = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, a = 0; a < 2; a++)
        r = r.replace(/<self>/g, function() {
          return r;
        });
      r = r.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
      }), n.languages.rust = {
        comment: [
          {
            pattern: RegExp(/(^|[^\\])/.source + r),
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        string: {
          pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
          greedy: !0
        },
        char: {
          pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
          greedy: !0
        },
        attribute: {
          pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
          greedy: !0,
          alias: "attr-name",
          inside: {
            string: null
            // see below
          }
        },
        // Closure params should not be confused with bitwise OR |
        "closure-params": {
          pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            "closure-punctuation": {
              pattern: /^\||\|$/,
              alias: "punctuation"
            },
            rest: null
            // see below
          }
        },
        "lifetime-annotation": {
          pattern: /'\w+/,
          alias: "symbol"
        },
        "fragment-specifier": {
          pattern: /(\$\w+:)[a-z]+/,
          lookbehind: !0,
          alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
          pattern: /(\bfn\s+)\w+/,
          lookbehind: !0,
          alias: "function"
        },
        "type-definition": {
          pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
          lookbehind: !0,
          alias: "class-name"
        },
        "module-declaration": [
          {
            pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
            lookbehind: !0,
            alias: "namespace"
          },
          {
            pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
            lookbehind: !0,
            alias: "namespace",
            inside: {
              punctuation: /::/
            }
          }
        ],
        keyword: [
          // https://github.com/rust-lang/reference/blob/master/src/keywords.md
          /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
          // primitives and str
          // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
          /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
          pattern: /\b\w+!/,
          alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
          pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
          inside: {
            punctuation: /::/
          }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
      }, n.languages.rust["closure-params"].inside.rest = n.languages.rust, n.languages.rust.attribute.inside.string = n.languages.rust.string;
    })(t);
  }
  return kh;
}
var Nh, aC;
function eX() {
  if (aC) return Nh;
  aC = 1, Nh = e, e.displayName = "sas", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:"(?:""|[^"])*"(?!")|'(?:''|[^'])*'(?!'))/.source, a = /\b(?:\d[\da-f]*x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i, i = {
        pattern: RegExp(r + "[bx]"),
        alias: "number"
      }, s = {
        pattern: /&[a-z_]\w*/i
      }, u = {
        pattern: /((?:^|\s|=|\())%(?:ABORT|BY|CMS|COPY|DISPLAY|DO|ELSE|END|EVAL|GLOBAL|GO|GOTO|IF|INC|INCLUDE|INDEX|INPUT|KTRIM|LENGTH|LET|LIST|LOCAL|PUT|QKTRIM|QSCAN|QSUBSTR|QSYSFUNC|QUPCASE|RETURN|RUN|SCAN|SUBSTR|SUPERQ|SYMDEL|SYMEXIST|SYMGLOBL|SYMLOCAL|SYSCALL|SYSEVALF|SYSEXEC|SYSFUNC|SYSGET|SYSRPUT|THEN|TO|TSO|UNQUOTE|UNTIL|UPCASE|WHILE|WINDOW)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, c = {
        pattern: /(^|\s)(?:proc\s+\w+|data(?!=)|quit|run)\b/i,
        alias: "keyword",
        lookbehind: !0
      }, d = [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(^[ \t]*|;\s*)\*[^;]*;/m,
          lookbehind: !0
        }
      ], p = {
        pattern: RegExp(r),
        greedy: !0
      }, f = /[$%@.(){}\[\];,\\]/, m = {
        pattern: /%?\b\w+(?=\()/,
        alias: "keyword"
      }, h = {
        function: m,
        "arg-value": {
          pattern: /(=\s*)[A-Z\.]+/i,
          lookbehind: !0
        },
        operator: /=/,
        "macro-variable": s,
        arg: {
          pattern: /[A-Z]+/i,
          alias: "keyword"
        },
        number: a,
        "numeric-constant": i,
        punctuation: f,
        string: p
      }, E = {
        pattern: /\b(?:format|put)\b=?[\w'$.]+/i,
        inside: {
          keyword: /^(?:format|put)(?==)/i,
          equals: /=/,
          format: {
            pattern: /(?:\w|\$\d)+\.\d?/,
            alias: "number"
          }
        }
      }, y = {
        pattern: /\b(?:format|put)\s+[\w']+(?:\s+[$.\w]+)+(?=;)/i,
        inside: {
          keyword: /^(?:format|put)/i,
          format: {
            pattern: /[\w$]+\.\d?/,
            alias: "number"
          }
        }
      }, w = {
        pattern: /((?:^|\s)=?)(?:catname|checkpoint execute_always|dm|endsas|filename|footnote|%include|libname|%list|lock|missing|options|page|resetline|%run|sasfile|skip|sysecho|title\d?)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, x = {
        pattern: /(^|\s)(?:submit(?:\s+(?:load|norun|parseonly))?|endsubmit)\b/i,
        lookbehind: !0,
        alias: "keyword"
      }, I = /aStore|accessControl|aggregation|audio|autotune|bayesianNetClassifier|bioMedImage|boolRule|builtins|cardinality|cdm|clustering|conditionalRandomFields|configuration|copula|countreg|dataDiscovery|dataPreprocess|dataSciencePilot|dataStep|decisionTree|deduplication|deepLearn|deepNeural|deepRnn|ds2|ecm|entityRes|espCluster|explainModel|factmac|fastKnn|fcmpact|fedSql|freqTab|gVarCluster|gam|gleam|graphSemiSupLearn|hiddenMarkovModel|hyperGroup|ica|image|iml|kernalPca|langModel|ldaTopic|loadStreams|mbc|mixed|mlTools|modelPublishing|network|neuralNet|nmf|nonParametricBayes|nonlinear|optNetwork|optimization|panel|pca|percentile|phreg|pls|qkb|qlim|quantreg|recommend|regression|reinforcementLearn|robustPca|ruleMining|sampling|sandwich|sccasl|search(?:Analytics)?|sentimentAnalysis|sequence|session(?:Prop)?|severity|simSystem|simple|smartData|sparkEmbeddedProcess|sparseML|spatialreg|spc|stabilityMonitoring|svDataDescription|svm|table|text(?:Filters|Frequency|Mining|Parse|Rule(?:Develop|Score)|Topic|Util)|timeData|transpose|tsInfo|tsReconcile|uniTimeSeries|varReduce/.source, S = {
        pattern: RegExp(
          /(^|\s)(?:action\s+)?(?:<act>)\.[a-z]+\b[^;]+/.source.replace(
            /<act>/g,
            function() {
              return I;
            }
          ),
          "i"
        ),
        lookbehind: !0,
        inside: {
          keyword: RegExp(
            /(?:<act>)\.[a-z]+\b/.source.replace(/<act>/g, function() {
              return I;
            }),
            "i"
          ),
          action: {
            pattern: /(?:action)/i,
            alias: "keyword"
          },
          comment: d,
          function: m,
          "arg-value": h["arg-value"],
          operator: h.operator,
          argument: h.arg,
          number: a,
          "numeric-constant": i,
          punctuation: f,
          string: p
        }
      }, C = {
        pattern: /((?:^|\s)=?)(?:after|analysis|and|array|barchart|barwidth|begingraph|by|call|cas|cbarline|cfill|class(?:lev)?|close|column|computed?|contains|continue|data(?==)|define|delete|describe|document|do\s+over|do|dol|drop|dul|else|end(?:comp|source)?|entryTitle|eval(?:uate)?|exec(?:ute)?|exit|file(?:name)?|fill(?:attrs)?|flist|fnc|function(?:list)?|global|goto|group(?:by)?|headline|headskip|histogram|if|infile|keep|keylabel|keyword|label|layout|leave|legendlabel|length|libname|loadactionset|merge|midpoints|_?null_|name|noobs|nowd|ods|options|or|otherwise|out(?:put)?|over(?:lay)?|plot|print|put|raise|ranexp|rannor|rbreak|retain|return|select|session|sessref|set|source|statgraph|sum|summarize|table|temp|terminate|then\s+do|then|title\d?|to|var|when|where|xaxisopts|y2axisopts|yaxisopts)\b/i,
        lookbehind: !0
      };
      n.languages.sas = {
        datalines: {
          pattern: /^([ \t]*)(?:cards|(?:data)?lines);[\s\S]+?^[ \t]*;/im,
          lookbehind: !0,
          alias: "string",
          inside: {
            keyword: {
              pattern: /^(?:cards|(?:data)?lines)/i
            },
            punctuation: /;/
          }
        },
        "proc-sql": {
          pattern: /(^proc\s+(?:fed)?sql(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            sql: {
              pattern: RegExp(
                /^[ \t]*(?:select|alter\s+table|(?:create|describe|drop)\s+(?:index|table(?:\s+constraints)?|view)|create\s+unique\s+index|insert\s+into|update)(?:<str>|[^;"'])+;/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              alias: "language-sql",
              inside: n.languages.sql
            },
            "global-statements": w,
            "sql-statements": {
              pattern: /(^|\s)(?:disconnect\s+from|begin|commit|exec(?:ute)?|reset|rollback|validate)\b/i,
              lookbehind: !0,
              alias: "keyword"
            },
            number: a,
            "numeric-constant": i,
            punctuation: f,
            string: p
          }
        },
        "proc-groovy": {
          pattern: /(^proc\s+groovy(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: d,
            groovy: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-groovy",
              inside: n.languages.groovy
            },
            keyword: C,
            "submit-statement": x,
            "global-statements": w,
            number: a,
            "numeric-constant": i,
            punctuation: f,
            string: p
          }
        },
        "proc-lua": {
          pattern: /(^proc\s+lua(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|data|quit|run);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: d,
            lua: {
              pattern: RegExp(
                /(^[ \t]*submit(?:\s+(?:load|norun|parseonly))?)(?:<str>|[^"'])+?(?=endsubmit;)/.source.replace(
                  /<str>/g,
                  function() {
                    return r;
                  }
                ),
                "im"
              ),
              lookbehind: !0,
              alias: "language-lua",
              inside: n.languages.lua
            },
            keyword: C,
            "submit-statement": x,
            "global-statements": w,
            number: a,
            "numeric-constant": i,
            punctuation: f,
            string: p
          }
        },
        "proc-cas": {
          pattern: /(^proc\s+cas(?:\s+[\w|=]+)?;)[\s\S]+?(?=^(?:proc\s+\w+|quit|data);|(?![\s\S]))/im,
          lookbehind: !0,
          inside: {
            comment: d,
            "statement-var": {
              pattern: /((?:^|\s)=?)saveresult\s[^;]+/im,
              lookbehind: !0,
              inside: {
                statement: {
                  pattern: /^saveresult\s+\S+/i,
                  inside: {
                    keyword: /^(?:saveresult)/i
                  }
                },
                rest: h
              }
            },
            "cas-actions": S,
            statement: {
              pattern: /((?:^|\s)=?)(?:default|(?:un)?set|on|output|upload)[^;]+/im,
              lookbehind: !0,
              inside: h
            },
            step: c,
            keyword: C,
            function: m,
            format: E,
            altformat: y,
            "global-statements": w,
            number: a,
            "numeric-constant": i,
            punctuation: f,
            string: p
          }
        },
        "proc-args": {
          pattern: RegExp(
            /(^proc\s+\w+\s+)(?!\s)(?:[^;"']|<str>)+;/.source.replace(
              /<str>/g,
              function() {
                return r;
              }
            ),
            "im"
          ),
          lookbehind: !0,
          inside: h
        },
        /*Special keywords within macros*/
        "macro-keyword": u,
        "macro-variable": s,
        "macro-string-functions": {
          pattern: /((?:^|\s|=))%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)\(.*?(?:[^%]\))/i,
          lookbehind: !0,
          inside: {
            function: {
              pattern: /%(?:BQUOTE|NRBQUOTE|NRQUOTE|NRSTR|QUOTE|STR)/i,
              alias: "keyword"
            },
            "macro-keyword": u,
            "macro-variable": s,
            "escaped-char": {
              pattern: /%['"()<>=¬^~;,#]/
            },
            punctuation: f
          }
        },
        "macro-declaration": {
          pattern: /^%macro[^;]+(?=;)/im,
          inside: {
            keyword: /%macro/i
          }
        },
        "macro-end": {
          pattern: /^%mend[^;]+(?=;)/im,
          inside: {
            keyword: /%mend/i
          }
        },
        /*%_zscore(headcir, _lhc, _mhc, _shc, headcz, headcpct, _Fheadcz); */
        macro: {
          pattern: /%_\w+(?=\()/,
          alias: "keyword"
        },
        input: {
          pattern: /\binput\s[-\w\s/*.$&]+;/i,
          inside: {
            input: {
              alias: "keyword",
              pattern: /^input/i
            },
            comment: d,
            number: a,
            "numeric-constant": i
          }
        },
        "options-args": {
          pattern: /(^options)[-'"|/\\<>*+=:()\w\s]*(?=;)/im,
          lookbehind: !0,
          inside: h
        },
        "cas-actions": S,
        comment: d,
        function: m,
        format: E,
        altformat: y,
        "numeric-constant": i,
        datetime: {
          // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
          pattern: RegExp(r + "(?:dt?|t)"),
          alias: "number"
        },
        string: p,
        step: c,
        keyword: C,
        // In SAS Studio syntax highlighting, these operators are styled like keywords
        "operator-keyword": {
          pattern: /\b(?:eq|ge|gt|in|le|lt|ne|not)\b/i,
          alias: "operator"
        },
        // Decimal (1.2e23), hexadecimal (0c1x)
        number: a,
        operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?/,
        punctuation: f
      };
    })(t);
  }
  return Nh;
}
var Oh, iC;
function tX() {
  if (iC) return Oh;
  iC = 1, Oh = e, e.displayName = "sass", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.sass = n.languages.extend("css", {
        // Sass comments don't need to be closed, only indented
        comment: {
          pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
          lookbehind: !0,
          greedy: !0
        }
      }), n.languages.insertBefore("sass", "atrule", {
        // We want to consume the whole line
        "atrule-line": {
          // Includes support for = and + shortcuts
          pattern: /^(?:[ \t]*)[@+=].+/m,
          greedy: !0,
          inside: {
            atrule: /(?:@[\w-]+|[+=])/
          }
        }
      }), delete n.languages.sass.atrule;
      var r = /\$[-\w]+|#\{\$[-\w]+\}/, a = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: !0
        }
      ];
      n.languages.insertBefore("sass", "property", {
        // We want to consume the whole line
        "variable-line": {
          pattern: /^[ \t]*\$.+/m,
          greedy: !0,
          inside: {
            punctuation: /:/,
            variable: r,
            operator: a
          }
        },
        // We want to consume the whole line
        "property-line": {
          pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
          greedy: !0,
          inside: {
            property: [
              /[^:\s]+(?=\s*:)/,
              {
                pattern: /(:)[^:\s]+/,
                lookbehind: !0
              }
            ],
            punctuation: /:/,
            variable: r,
            operator: a,
            important: n.languages.sass.important
          }
        }
      }), delete n.languages.sass.property, delete n.languages.sass.important, n.languages.insertBefore("sass", "punctuation", {
        selector: {
          pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
          lookbehind: !0,
          greedy: !0
        }
      });
    })(t);
  }
  return Oh;
}
var Lh, oC;
function nX() {
  if (oC) return Lh;
  oC = 1;
  var e = $v();
  Lh = t, t.displayName = "scala", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.scala = n.languages.extend("java", {
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
      number: /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
      builtin: /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
      symbol: /'[^\d\s\\]\w*/
    }), n.languages.insertBefore("scala", "triple-quoted-string", {
      "string-interpolation": {
        pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
        greedy: !0,
        inside: {
          id: {
            pattern: /^\w+/,
            greedy: !0,
            alias: "function"
          },
          escape: {
            pattern: /\\\$"|\$[$"]/,
            greedy: !0,
            alias: "symbol"
          },
          interpolation: {
            pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
            greedy: !0,
            inside: {
              punctuation: /^\$\{?|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: n.languages.scala
              }
            }
          },
          string: /[\s\S]+/
        }
      }
    }), delete n.languages.scala["class-name"], delete n.languages.scala.function;
  }
  return Lh;
}
var Dh, sC;
function rX() {
  if (sC) return Dh;
  sC = 1, Dh = e, e.displayName = "scss", e.aliases = [];
  function e(t) {
    t.languages.scss = t.languages.extend("css", {
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: !0
      },
      atrule: {
        pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
        inside: {
          rule: /@[\w-]+/
          // See rest below
        }
      },
      // url, compassified
      url: /(?:[-a-z]+-)?url(?=\()/i,
      // CSS selector regex is not appropriate for Sass
      // since there can be lot more things (var, @ directive, nesting..)
      // a selector must start at the end of a property or after a brace (end of other rules or nesting)
      // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
      // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
      // can "pass" as a selector- e.g: proper#{$erty})
      // this one was hard to do, so please be careful if you edit this one :)
      selector: {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
        inside: {
          parent: {
            pattern: /&/,
            alias: "important"
          },
          placeholder: /%[-\w]+/,
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      },
      property: {
        pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
        inside: {
          variable: /\$[-\w]+|#\{\$[-\w]+\}/
        }
      }
    }), t.languages.insertBefore("scss", "atrule", {
      keyword: [
        /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
        {
          pattern: /( )(?:from|through)(?= )/,
          lookbehind: !0
        }
      ]
    }), t.languages.insertBefore("scss", "important", {
      // var and interpolated vars
      variable: /\$[-\w]+|#\{\$[-\w]+\}/
    }), t.languages.insertBefore("scss", "function", {
      "module-modifier": {
        pattern: /\b(?:as|hide|show|with)\b/i,
        alias: "keyword"
      },
      placeholder: {
        pattern: /%[-\w]+/,
        alias: "selector"
      },
      statement: {
        pattern: /\B!(?:default|optional)\b/i,
        alias: "keyword"
      },
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      operator: {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
        lookbehind: !0
      }
    }), t.languages.scss.atrule.inside.rest = t.languages.scss;
  }
  return Dh;
}
var Mh, lC;
function aX() {
  if (lC) return Mh;
  lC = 1;
  var e = o1();
  Mh = t, t.displayName = "shellSession", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = [
        // normal string
        /"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source,
        /'[^']*'/.source,
        /\$'(?:[^'\\]|\\[\s\S])*'/.source,
        // here doc
        // 2 capturing groups
        /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source
      ].join("|");
      r.languages["shell-session"] = {
        command: {
          pattern: RegExp(
            // user info
            /^/.source + "(?:" + // <user> ":" ( <path> )?
            (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + // <path>
            // Since the path pattern is quite general, we will require it to start with a special character to
            // prevent false positives.
            /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ")?" + // shell symbol
            /[$#%](?=\s)/.source + // bash command
            /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(
              /<<str>>/g,
              function() {
                return a;
              }
            ),
            "m"
          ),
          greedy: !0,
          inside: {
            info: {
              // foo@bar:~/files$ exit
              // foo@bar$ exit
              // ~/files$ exit
              pattern: /^[^#$%]+/,
              alias: "punctuation",
              inside: {
                user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/,
                punctuation: /:/,
                path: /[\s\S]+/
              }
            },
            bash: {
              pattern: /(^[$#%]\s*)\S[\s\S]*/,
              lookbehind: !0,
              alias: "language-bash",
              inside: r.languages.bash
            },
            "shell-symbol": {
              pattern: /^[$#%]/,
              alias: "important"
            }
          }
        },
        output: /.(?:.*(?:[\r\n]|.$))*/
      }, r.languages["sh-session"] = r.languages.shellsession = r.languages["shell-session"];
    }(n);
  }
  return Mh;
}
var Fh, uC;
function iX() {
  if (uC) return Fh;
  uC = 1, Fh = e, e.displayName = "smali", e.aliases = [];
  function e(t) {
    t.languages.smali = {
      comment: /#.*/,
      string: {
        pattern: /"(?:[^\r\n\\"]|\\.)*"|'(?:[^\r\n\\']|\\(?:.|u[\da-fA-F]{4}))'/,
        greedy: !0
      },
      "class-name": {
        pattern: /(^|[^L])L(?:(?:\w+|`[^`\r\n]*`)\/)*(?:[\w$]+|`[^`\r\n]*`)(?=\s*;)/,
        lookbehind: !0,
        inside: {
          "class-name": {
            pattern: /(^L|\/)(?:[\w$]+|`[^`\r\n]*`)$/,
            lookbehind: !0
          },
          namespace: {
            pattern: /^(L)(?:(?:\w+|`[^`\r\n]*`)\/)+/,
            lookbehind: !0,
            inside: {
              punctuation: /\//
            }
          },
          builtin: /^L/
        }
      },
      builtin: [
        {
          // Reference: https://github.com/JesusFreke/smali/wiki/TypesMethodsAndFields#types
          pattern: /([();\[])[BCDFIJSVZ]+/,
          lookbehind: !0
        },
        {
          // e.g. .field mWifiOnUid:I
          pattern: /([\w$>]:)[BCDFIJSVZ]/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /(\.end\s+)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])\.(?!\d)[\w-]+/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^\w.-])(?:abstract|annotation|bridge|constructor|enum|final|interface|private|protected|public|runtime|static|synthetic|system|transient)(?![\w.-])/,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^|[^\w.-])(?:\w+|<[\w$-]+>)(?=\()/,
        lookbehind: !0
      },
      field: {
        pattern: /[\w$]+(?=:)/,
        alias: "variable"
      },
      register: {
        pattern: /(^|[^\w.-])[vp]\d(?![\w.-])/,
        lookbehind: !0,
        alias: "variable"
      },
      boolean: {
        pattern: /(^|[^\w.-])(?:false|true)(?![\w.-])/,
        lookbehind: !0
      },
      number: {
        pattern: /(^|[^/\w.-])-?(?:NAN|INFINITY|0x(?:[\dA-F]+(?:\.[\dA-F]*)?|\.[\dA-F]+)(?:p[+-]?[\dA-F]+)?|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?)[dflst]?(?![\w.-])/i,
        lookbehind: !0
      },
      label: {
        pattern: /(:)\w+/,
        lookbehind: !0,
        alias: "property"
      },
      operator: /->|\.\.|[\[=]/,
      punctuation: /[{}(),;:]/
    };
  }
  return Fh;
}
var Ph, cC;
function oX() {
  if (cC) return Ph;
  cC = 1, Ph = e, e.displayName = "smalltalk", e.aliases = [];
  function e(t) {
    t.languages.smalltalk = {
      comment: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      char: {
        pattern: /\$./,
        greedy: !0
      },
      string: {
        pattern: /'(?:''|[^'])*'/,
        greedy: !0
      },
      symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
      "block-arguments": {
        pattern: /(\[\s*):[^\[|]*\|/,
        lookbehind: !0,
        inside: {
          variable: /:[\da-z]+/i,
          punctuation: /\|/
        }
      },
      "temporary-variables": {
        pattern: /\|[^|]+\|/,
        inside: {
          variable: /[\da-z]+/i,
          punctuation: /\|/
        }
      },
      keyword: /\b(?:new|nil|self|super)\b/,
      boolean: /\b(?:false|true)\b/,
      number: [
        /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
        /\b\d+(?:\.\d+)?(?:e-?\d+)?/
      ],
      operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
      punctuation: /[.;:?\[\](){}]/
    };
  }
  return Ph;
}
var Bh, dC;
function sX() {
  if (dC) return Bh;
  dC = 1;
  var e = Mn();
  Bh = t, t.displayName = "smarty", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.smarty = {
        comment: {
          pattern: /^\{\*[\s\S]*?\*\}/,
          greedy: !0
        },
        "embedded-php": {
          pattern: /^\{php\}[\s\S]*?\{\/php\}/,
          greedy: !0,
          inside: {
            smarty: {
              pattern: /^\{php\}|\{\/php\}$/,
              inside: null
              // see below
            },
            php: {
              pattern: /[\s\S]+/,
              alias: "language-php",
              inside: r.languages.php
            }
          }
        },
        string: [
          {
            pattern: /"(?:\\.|[^"\\\r\n])*"/,
            greedy: !0,
            inside: {
              interpolation: {
                pattern: /\{[^{}]*\}|`[^`]*`/,
                inside: {
                  "interpolation-punctuation": {
                    pattern: /^[{`]|[`}]$/,
                    alias: "punctuation"
                  },
                  expression: {
                    pattern: /[\s\S]+/,
                    inside: null
                    // see below
                  }
                }
              },
              variable: /\$\w+/
            }
          },
          {
            pattern: /'(?:\\.|[^'\\\r\n])*'/,
            greedy: !0
          }
        ],
        keyword: {
          pattern: /(^\{\/?)[a-z_]\w*\b(?!\()/i,
          lookbehind: !0,
          greedy: !0
        },
        delimiter: {
          pattern: /^\{\/?|\}$/,
          greedy: !0,
          alias: "punctuation"
        },
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        variable: [
          /\$(?!\d)\w+/,
          /#(?!\d)\w+#/,
          {
            pattern: /(\.|->|\w\s*=)(?!\d)\w+\b(?!\()/,
            lookbehind: !0
          },
          {
            pattern: /(\[)(?!\d)\w+(?=\])/,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /(\|\s*)@?[a-z_]\w*|\b[a-z_]\w*(?=\()/i,
          lookbehind: !0
        },
        "attr-name": /\b[a-z_]\w*(?=\s*=)/i,
        boolean: /\b(?:false|no|off|on|true|yes)\b/,
        punctuation: /[\[\](){}.,:`]|->/,
        operator: [
          /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
          /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
          /\b(?:and|eq|gt?e|gt|lt?e|lt|mod|neq?|not|or)\b/
        ]
      }, r.languages.smarty["embedded-php"].inside.smarty.inside = r.languages.smarty, r.languages.smarty.string[0].inside.interpolation.inside.expression.inside = r.languages.smarty;
      var a = /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/, i = RegExp(
        // comments
        /\{\*[\s\S]*?\*\}/.source + "|" + // php tags
        /\{php\}[\s\S]*?\{\/php\}/.source + "|" + // smarty blocks
        /\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>|\{(?:[^{}"']|<str>)*\})*\})*\}/.source.replace(
          /<str>/g,
          function() {
            return a.source;
          }
        ),
        "g"
      );
      r.hooks.add("before-tokenize", function(s) {
        var u = "{literal}", c = "{/literal}", d = !1;
        r.languages["markup-templating"].buildPlaceholders(
          s,
          "smarty",
          i,
          function(p) {
            return p === c && (d = !1), d ? !1 : (p === u && (d = !0), !0);
          }
        );
      }), r.hooks.add("after-tokenize", function(s) {
        r.languages["markup-templating"].tokenizePlaceholders(s, "smarty");
      });
    }(n);
  }
  return Bh;
}
var $h, pC;
function lX() {
  if (pC) return $h;
  pC = 1, $h = e, e.displayName = "sml", e.aliases = ["smlnj"];
  function e(t) {
    (function(n) {
      var r = /\b(?:abstype|and|andalso|as|case|datatype|do|else|end|eqtype|exception|fn|fun|functor|handle|if|in|include|infix|infixr|let|local|nonfix|of|op|open|orelse|raise|rec|sharing|sig|signature|struct|structure|then|type|val|where|while|with|withtype)\b/i;
      n.languages.sml = {
        // allow one level of nesting
        comment: /\(\*(?:[^*(]|\*(?!\))|\((?!\*)|\(\*(?:[^*(]|\*(?!\))|\((?!\*))*\*\))*\*\)/,
        string: {
          pattern: /#?"(?:[^"\\]|\\.)*"/,
          greedy: !0
        },
        "class-name": [
          {
            // This is only an approximation since the real grammar is context-free
            //
            // Why the main loop so complex?
            // The main loop is approximately the same as /(?:\s*(?:[*,]|->)\s*<TERMINAL>)*/ which is, obviously, a lot
            // simpler. The difference is that if a comma is the last iteration of the loop, then the terminal must be
            // followed by a long identifier.
            pattern: RegExp(
              /((?:^|[^:]):\s*)<TERMINAL>(?:\s*(?:(?:\*|->)\s*<TERMINAL>|,\s*<TERMINAL>(?:(?=<NOT-LAST>)|(?!<NOT-LAST>)\s+<LONG-ID>)))*/.source.replace(/<NOT-LAST>/g, function() {
                return /\s*(?:[*,]|->)/.source;
              }).replace(/<TERMINAL>/g, function() {
                return /(?:'[\w']*|<LONG-ID>|\((?:[^()]|\([^()]*\))*\)|\{(?:[^{}]|\{[^{}]*\})*\})(?:\s+<LONG-ID>)*/.source;
              }).replace(/<LONG-ID>/g, function() {
                return /(?!<KEYWORD>)[a-z\d_][\w'.]*/.source;
              }).replace(/<KEYWORD>/g, function() {
                return r.source;
              }),
              "i"
            ),
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          {
            pattern: /((?:^|[^\w'])(?:datatype|exception|functor|signature|structure|type)\s+)[a-z_][\w'.]*/i,
            lookbehind: !0
          }
        ],
        function: {
          pattern: /((?:^|[^\w'])fun\s+)[a-z_][\w'.]*/i,
          lookbehind: !0
        },
        keyword: r,
        variable: {
          pattern: /(^|[^\w'])'[\w']*/,
          lookbehind: !0
        },
        number: /~?\b(?:\d+(?:\.\d+)?(?:e~?\d+)?|0x[\da-f]+)\b/i,
        word: {
          pattern: /\b0w(?:\d+|x[\da-f]+)\b/i,
          alias: "constant"
        },
        boolean: /\b(?:false|true)\b/i,
        operator: /\.\.\.|:[>=:]|=>?|->|[<>]=?|[!+\-*/^#|@~]/,
        punctuation: /[(){}\[\].:,;]/
      }, n.languages.sml["class-name"][0].inside = n.languages.sml, n.languages.smlnj = n.languages.sml;
    })(t);
  }
  return $h;
}
var Uh, fC;
function uX() {
  if (fC) return Uh;
  fC = 1, Uh = e, e.displayName = "solidity", e.aliases = ["sol"];
  function e(t) {
    t.languages.solidity = t.languages.extend("clike", {
      "class-name": {
        pattern: /(\b(?:contract|enum|interface|library|new|struct|using)\s+)(?!\d)[\w$]+/,
        lookbehind: !0
      },
      keyword: /\b(?:_|anonymous|as|assembly|assert|break|calldata|case|constant|constructor|continue|contract|default|delete|do|else|emit|enum|event|external|for|from|function|if|import|indexed|inherited|interface|internal|is|let|library|mapping|memory|modifier|new|payable|pragma|private|public|pure|require|returns?|revert|selfdestruct|solidity|storage|struct|suicide|switch|this|throw|using|var|view|while)\b/,
      operator: /=>|->|:=|=:|\*\*|\+\+|--|\|\||&&|<<=?|>>=?|[-+*/%^&|<>!=]=?|[~?]/
    }), t.languages.insertBefore("solidity", "keyword", {
      builtin: /\b(?:address|bool|byte|u?int(?:8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?|string|bytes(?:[1-9]|[12]\d|3[0-2])?)\b/
    }), t.languages.insertBefore("solidity", "number", {
      version: {
        pattern: /([<>]=?|\^)\d+\.\d+\.\d+\b/,
        lookbehind: !0,
        alias: "number"
      }
    }), t.languages.sol = t.languages.solidity;
  }
  return Uh;
}
var jh, gC;
function cX() {
  if (gC) return jh;
  gC = 1, jh = e, e.displayName = "solutionFile", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        // https://en.wikipedia.org/wiki/Universally_unique_identifier#Format
        pattern: /\{[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}\}/i,
        alias: "constant",
        inside: {
          punctuation: /[{}]/
        }
      };
      n.languages["solution-file"] = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        string: {
          pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
          greedy: !0,
          inside: {
            guid: r
          }
        },
        object: {
          // Foo
          //   Bar("abs") = 9
          //   EndBar
          //   Prop = TRUE
          // EndFoo
          pattern: /^([ \t]*)(?:([A-Z]\w*)\b(?=.*(?:\r\n?|\n)(?:\1[ \t].*(?:\r\n?|\n))*\1End\2(?=[ \t]*$))|End[A-Z]\w*(?=[ \t]*$))/m,
          lookbehind: !0,
          greedy: !0,
          alias: "keyword"
        },
        property: {
          pattern: /^([ \t]*)(?!\s)[^\r\n"#=()]*[^\s"#=()](?=\s*=)/m,
          lookbehind: !0,
          inside: {
            guid: r
          }
        },
        guid: r,
        number: /\b\d+(?:\.\d+)*\b/,
        boolean: /\b(?:FALSE|TRUE)\b/,
        operator: /=/,
        punctuation: /[(),]/
      }, n.languages.sln = n.languages["solution-file"];
    })(t);
  }
  return jh;
}
var qh, mC;
function dX() {
  if (mC) return qh;
  mC = 1;
  var e = Mn();
  qh = t, t.displayName = "soy", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      var a = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, i = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/;
      r.languages.soy = {
        comment: [
          /\/\*[\s\S]*?\*\//,
          {
            pattern: /(\s)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        "command-arg": {
          pattern: /(\{+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "string",
          inside: {
            punctuation: /\./
          }
        },
        parameter: {
          pattern: /(\{+\/?\s*@?param\??\s+)\.?[\w.]+/,
          lookbehind: !0,
          alias: "variable"
        },
        keyword: [
          {
            pattern: /(\{+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
            lookbehind: !0
          },
          /\b(?:any|as|attributes|bool|css|float|html|in|int|js|list|map|null|number|string|uri)\b/
        ],
        delimiter: {
          pattern: /^\{+\/?|\/?\}+$/,
          alias: "punctuation"
        },
        property: /\w+(?==)/,
        variable: {
          pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+\]))*/,
          inside: {
            string: {
              pattern: a,
              greedy: !0
            },
            number: i,
            punctuation: /[\[\].?]/
          }
        },
        string: {
          pattern: a,
          greedy: !0
        },
        function: [
          /\w+(?=\()/,
          {
            pattern: /(\|[^\S\r\n]*)\w+/,
            lookbehind: !0
          }
        ],
        boolean: /\b(?:false|true)\b/,
        number: i,
        operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
        punctuation: /[{}()\[\]|.,:]/
      }, r.hooks.add("before-tokenize", function(s) {
        var u = /\{\{.+?\}\}|\{.+?\}|\s\/\/.*|\/\*[\s\S]*?\*\//g, c = "{literal}", d = "{/literal}", p = !1;
        r.languages["markup-templating"].buildPlaceholders(
          s,
          "soy",
          u,
          function(f) {
            return f === d && (p = !1), p ? !1 : (f === c && (p = !0), !0);
          }
        );
      }), r.hooks.add("after-tokenize", function(s) {
        r.languages["markup-templating"].tokenizePlaceholders(s, "soy");
      });
    }(n);
  }
  return qh;
}
var zh, hC;
function c1() {
  if (hC) return zh;
  hC = 1, zh = e, e.displayName = "turtle", e.aliases = [];
  function e(t) {
    t.languages.turtle = {
      comment: {
        pattern: /#.*/,
        greedy: !0
      },
      "multiline-string": {
        pattern: /"""(?:(?:""?)?(?:[^"\\]|\\.))*"""|'''(?:(?:''?)?(?:[^'\\]|\\.))*'''/,
        greedy: !0,
        alias: "string",
        inside: {
          comment: /#.*/
        }
      },
      string: {
        pattern: /"(?:[^\\"\r\n]|\\.)*"|'(?:[^\\'\r\n]|\\.)*'/,
        greedy: !0
      },
      url: {
        pattern: /<(?:[^\x00-\x20<>"{}|^`\\]|\\(?:u[\da-fA-F]{4}|U[\da-fA-F]{8}))*>/,
        greedy: !0,
        inside: {
          punctuation: /[<>]/
        }
      },
      function: {
        pattern: /(?:(?![-.\d\xB7])[-.\w\xB7\xC0-\uFFFD]+)?:(?:(?![-.])(?:[-.:\w\xC0-\uFFFD]|%[\da-f]{2}|\\.)+)?/i,
        inside: {
          "local-name": {
            pattern: /([^:]*:)[\s\S]+/,
            lookbehind: !0
          },
          prefix: {
            pattern: /[\s\S]+/,
            inside: {
              punctuation: /:/
            }
          }
        }
      },
      number: /[+-]?\b\d+(?:\.\d*)?(?:e[+-]?\d+)?/i,
      punctuation: /[{}.,;()[\]]|\^\^/,
      boolean: /\b(?:false|true)\b/,
      keyword: [/(?:\ba|@prefix|@base)\b|=/, /\b(?:base|graph|prefix)\b/i],
      tag: {
        pattern: /@[a-z]+(?:-[a-z\d]+)*/i,
        inside: {
          punctuation: /@/
        }
      }
    }, t.languages.trig = t.languages.turtle;
  }
  return zh;
}
var Gh, bC;
function pX() {
  if (bC) return Gh;
  bC = 1;
  var e = c1();
  Gh = t, t.displayName = "sparql", t.aliases = ["rq"];
  function t(n) {
    n.register(e), n.languages.sparql = n.languages.extend("turtle", {
      boolean: /\b(?:false|true)\b/i,
      variable: {
        pattern: /[?$]\w+/,
        greedy: !0
      }
    }), n.languages.insertBefore("sparql", "punctuation", {
      keyword: [
        /\b(?:A|ADD|ALL|AS|ASC|ASK|BNODE|BY|CLEAR|CONSTRUCT|COPY|CREATE|DATA|DEFAULT|DELETE|DESC|DESCRIBE|DISTINCT|DROP|EXISTS|FILTER|FROM|GROUP|HAVING|INSERT|INTO|LIMIT|LOAD|MINUS|MOVE|NAMED|NOT|NOW|OFFSET|OPTIONAL|ORDER|RAND|REDUCED|SELECT|SEPARATOR|SERVICE|SILENT|STRUUID|UNION|USING|UUID|VALUES|WHERE)\b/i,
        /\b(?:ABS|AVG|BIND|BOUND|CEIL|COALESCE|CONCAT|CONTAINS|COUNT|DATATYPE|DAY|ENCODE_FOR_URI|FLOOR|GROUP_CONCAT|HOURS|IF|IRI|isBLANK|isIRI|isLITERAL|isNUMERIC|isURI|LANG|LANGMATCHES|LCASE|MAX|MD5|MIN|MINUTES|MONTH|REGEX|REPLACE|ROUND|sameTerm|SAMPLE|SECONDS|SHA1|SHA256|SHA384|SHA512|STR|STRAFTER|STRBEFORE|STRDT|STRENDS|STRLANG|STRLEN|STRSTARTS|SUBSTR|SUM|TIMEZONE|TZ|UCASE|URI|YEAR)\b(?=\s*\()/i,
        /\b(?:BASE|GRAPH|PREFIX)\b/i
      ]
    }), n.languages.rq = n.languages.sparql;
  }
  return Gh;
}
var Hh, yC;
function fX() {
  if (yC) return Hh;
  yC = 1, Hh = e, e.displayName = "splunkSpl", e.aliases = [];
  function e(t) {
    t.languages["splunk-spl"] = {
      comment: /`comment\("(?:\\.|[^\\"])*"\)`/,
      string: {
        pattern: /"(?:\\.|[^\\"])*"/,
        greedy: !0
      },
      // https://docs.splunk.com/Documentation/Splunk/7.3.0/SearchReference/ListOfSearchCommands
      keyword: /\b(?:abstract|accum|addcoltotals|addinfo|addtotals|analyzefields|anomalies|anomalousvalue|anomalydetection|append|appendcols|appendcsv|appendlookup|appendpipe|arules|associate|audit|autoregress|bin|bucket|bucketdir|chart|cluster|cofilter|collect|concurrency|contingency|convert|correlate|datamodel|dbinspect|dedup|delete|delta|diff|erex|eval|eventcount|eventstats|extract|fieldformat|fields|fieldsummary|filldown|fillnull|findtypes|folderize|foreach|format|from|gauge|gentimes|geom|geomfilter|geostats|head|highlight|history|iconify|input|inputcsv|inputlookup|iplocation|join|kmeans|kv|kvform|loadjob|localize|localop|lookup|makecontinuous|makemv|makeresults|map|mcollect|metadata|metasearch|meventcollect|mstats|multikv|multisearch|mvcombine|mvexpand|nomv|outlier|outputcsv|outputlookup|outputtext|overlap|pivot|predict|rangemap|rare|regex|relevancy|reltime|rename|replace|rest|return|reverse|rex|rtorder|run|savedsearch|script|scrub|search|searchtxn|selfjoin|sendemail|set|setfields|sichart|sirare|sistats|sitimechart|sitop|sort|spath|stats|strcat|streamstats|table|tags|tail|timechart|timewrap|top|transaction|transpose|trendline|tscollect|tstats|typeahead|typelearner|typer|union|uniq|untable|where|x11|xmlkv|xmlunescape|xpath|xyseries)\b/i,
      "operator-word": {
        pattern: /\b(?:and|as|by|not|or|xor)\b/i,
        alias: "operator"
      },
      function: /\b\w+(?=\s*\()/,
      property: /\b\w+(?=\s*=(?!=))/,
      date: {
        // MM/DD/YYYY(:HH:MM:SS)?
        pattern: /\b\d{1,2}\/\d{1,2}\/\d{1,4}(?:(?::\d{1,2}){3})?\b/,
        alias: "number"
      },
      number: /\b\d+(?:\.\d+)?\b/,
      boolean: /\b(?:f|false|t|true)\b/i,
      operator: /[<>=]=?|[-+*/%|]/,
      punctuation: /[()[\],]/
    };
  }
  return Hh;
}
var Vh, vC;
function gX() {
  if (vC) return Vh;
  vC = 1, Vh = e, e.displayName = "sqf", e.aliases = [];
  function e(t) {
    t.languages.sqf = t.languages.extend("clike", {
      string: {
        pattern: /"(?:(?:"")?[^"])*"(?!")|'(?:[^'])*'/,
        greedy: !0
      },
      keyword: /\b(?:breakOut|breakTo|call|case|catch|default|do|echo|else|execFSM|execVM|exitWith|for|forEach|forEachMember|forEachMemberAgent|forEachMemberTeam|from|goto|if|nil|preprocessFile|preprocessFileLineNumbers|private|scopeName|spawn|step|switch|then|throw|to|try|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\b(?:abs|accTime|acos|action|actionIDs|actionKeys|actionKeysImages|actionKeysNames|actionKeysNamesArray|actionName|actionParams|activateAddons|activatedAddons|activateKey|add3DENConnection|add3DENEventHandler|add3DENLayer|addAction|addBackpack|addBackpackCargo|addBackpackCargoGlobal|addBackpackGlobal|addCamShake|addCuratorAddons|addCuratorCameraArea|addCuratorEditableObjects|addCuratorEditingArea|addCuratorPoints|addEditorObject|addEventHandler|addForce|addForceGeneratorRTD|addGoggles|addGroupIcon|addHandgunItem|addHeadgear|addItem|addItemCargo|addItemCargoGlobal|addItemPool|addItemToBackpack|addItemToUniform|addItemToVest|addLiveStats|addMagazine|addMagazineAmmoCargo|addMagazineCargo|addMagazineCargoGlobal|addMagazineGlobal|addMagazinePool|addMagazines|addMagazineTurret|addMenu|addMenuItem|addMissionEventHandler|addMPEventHandler|addMusicEventHandler|addOwnedMine|addPlayerScores|addPrimaryWeaponItem|addPublicVariableEventHandler|addRating|addResources|addScore|addScoreSide|addSecondaryWeaponItem|addSwitchableUnit|addTeamMember|addToRemainsCollector|addTorque|addUniform|addVehicle|addVest|addWaypoint|addWeapon|addWeaponCargo|addWeaponCargoGlobal|addWeaponGlobal|addWeaponItem|addWeaponPool|addWeaponTurret|admin|agent|agents|AGLToASL|aimedAtTarget|aimPos|airDensityCurveRTD|airDensityRTD|airplaneThrottle|airportSide|AISFinishHeal|alive|all3DENEntities|allAirports|allControls|allCurators|allCutLayers|allDead|allDeadMen|allDisplays|allGroups|allMapMarkers|allMines|allMissionObjects|allow3DMode|allowCrewInImmobile|allowCuratorLogicIgnoreAreas|allowDamage|allowDammage|allowFileOperations|allowFleeing|allowGetIn|allowSprint|allPlayers|allSimpleObjects|allSites|allTurrets|allUnits|allUnitsUAV|allVariables|ammo|ammoOnPylon|animate|animateBay|animateDoor|animatePylon|animateSource|animationNames|animationPhase|animationSourcePhase|animationState|append|apply|armoryPoints|arrayIntersect|asin|ASLToAGL|ASLToATL|assert|assignAsCargo|assignAsCargoIndex|assignAsCommander|assignAsDriver|assignAsGunner|assignAsTurret|assignCurator|assignedCargo|assignedCommander|assignedDriver|assignedGunner|assignedItems|assignedTarget|assignedTeam|assignedVehicle|assignedVehicleRole|assignItem|assignTeam|assignToAirport|atan|atan2|atg|ATLToASL|attachedObject|attachedObjects|attachedTo|attachObject|attachTo|attackEnabled|backpack|backpackCargo|backpackContainer|backpackItems|backpackMagazines|backpackSpaceFor|behaviour|benchmark|binocular|blufor|boundingBox|boundingBoxReal|boundingCenter|briefingName|buildingExit|buildingPos|buldozer_EnableRoadDiag|buldozer_IsEnabledRoadDiag|buldozer_LoadNewRoads|buldozer_reloadOperMap|buttonAction|buttonSetAction|cadetMode|callExtension|camCommand|camCommit|camCommitPrepared|camCommitted|camConstuctionSetParams|camCreate|camDestroy|cameraEffect|cameraEffectEnableHUD|cameraInterest|cameraOn|cameraView|campaignConfigFile|camPreload|camPreloaded|camPrepareBank|camPrepareDir|camPrepareDive|camPrepareFocus|camPrepareFov|camPrepareFovRange|camPreparePos|camPrepareRelPos|camPrepareTarget|camSetBank|camSetDir|camSetDive|camSetFocus|camSetFov|camSetFovRange|camSetPos|camSetRelPos|camSetTarget|camTarget|camUseNVG|canAdd|canAddItemToBackpack|canAddItemToUniform|canAddItemToVest|cancelSimpleTaskDestination|canFire|canMove|canSlingLoad|canStand|canSuspend|canTriggerDynamicSimulation|canUnloadInCombat|canVehicleCargo|captive|captiveNum|cbChecked|cbSetChecked|ceil|channelEnabled|cheatsEnabled|checkAIFeature|checkVisibility|civilian|className|clear3DENAttribute|clear3DENInventory|clearAllItemsFromBackpack|clearBackpackCargo|clearBackpackCargoGlobal|clearForcesRTD|clearGroupIcons|clearItemCargo|clearItemCargoGlobal|clearItemPool|clearMagazineCargo|clearMagazineCargoGlobal|clearMagazinePool|clearOverlay|clearRadio|clearVehicleInit|clearWeaponCargo|clearWeaponCargoGlobal|clearWeaponPool|clientOwner|closeDialog|closeDisplay|closeOverlay|collapseObjectTree|collect3DENHistory|collectiveRTD|combatMode|commandArtilleryFire|commandChat|commander|commandFire|commandFollow|commandFSM|commandGetOut|commandingMenu|commandMove|commandRadio|commandStop|commandSuppressiveFire|commandTarget|commandWatch|comment|commitOverlay|compile|compileFinal|completedFSM|composeText|configClasses|configFile|configHierarchy|configName|configNull|configProperties|configSourceAddonList|configSourceMod|configSourceModList|confirmSensorTarget|connectTerminalToUAV|controlNull|controlsGroupCtrl|copyFromClipboard|copyToClipboard|copyWaypoints|cos|count|countEnemy|countFriendly|countSide|countType|countUnknown|create3DENComposition|create3DENEntity|createAgent|createCenter|createDialog|createDiaryLink|createDiaryRecord|createDiarySubject|createDisplay|createGearDialog|createGroup|createGuardedPoint|createLocation|createMarker|createMarkerLocal|createMenu|createMine|createMissionDisplay|createMPCampaignDisplay|createSimpleObject|createSimpleTask|createSite|createSoundSource|createTask|createTeam|createTrigger|createUnit|createVehicle|createVehicleCrew|createVehicleLocal|crew|ctAddHeader|ctAddRow|ctClear|ctCurSel|ctData|ctFindHeaderRows|ctFindRowHeader|ctHeaderControls|ctHeaderCount|ctRemoveHeaders|ctRemoveRows|ctrlActivate|ctrlAddEventHandler|ctrlAngle|ctrlAutoScrollDelay|ctrlAutoScrollRewind|ctrlAutoScrollSpeed|ctrlChecked|ctrlClassName|ctrlCommit|ctrlCommitted|ctrlCreate|ctrlDelete|ctrlEnable|ctrlEnabled|ctrlFade|ctrlHTMLLoaded|ctrlIDC|ctrlIDD|ctrlMapAnimAdd|ctrlMapAnimClear|ctrlMapAnimCommit|ctrlMapAnimDone|ctrlMapCursor|ctrlMapMouseOver|ctrlMapScale|ctrlMapScreenToWorld|ctrlMapWorldToScreen|ctrlModel|ctrlModelDirAndUp|ctrlModelScale|ctrlParent|ctrlParentControlsGroup|ctrlPosition|ctrlRemoveAllEventHandlers|ctrlRemoveEventHandler|ctrlScale|ctrlSetActiveColor|ctrlSetAngle|ctrlSetAutoScrollDelay|ctrlSetAutoScrollRewind|ctrlSetAutoScrollSpeed|ctrlSetBackgroundColor|ctrlSetChecked|ctrlSetDisabledColor|ctrlSetEventHandler|ctrlSetFade|ctrlSetFocus|ctrlSetFont|ctrlSetFontH1|ctrlSetFontH1B|ctrlSetFontH2|ctrlSetFontH2B|ctrlSetFontH3|ctrlSetFontH3B|ctrlSetFontH4|ctrlSetFontH4B|ctrlSetFontH5|ctrlSetFontH5B|ctrlSetFontH6|ctrlSetFontH6B|ctrlSetFontHeight|ctrlSetFontHeightH1|ctrlSetFontHeightH2|ctrlSetFontHeightH3|ctrlSetFontHeightH4|ctrlSetFontHeightH5|ctrlSetFontHeightH6|ctrlSetFontHeightSecondary|ctrlSetFontP|ctrlSetFontPB|ctrlSetFontSecondary|ctrlSetForegroundColor|ctrlSetModel|ctrlSetModelDirAndUp|ctrlSetModelScale|ctrlSetPixelPrecision|ctrlSetPosition|ctrlSetScale|ctrlSetStructuredText|ctrlSetText|ctrlSetTextColor|ctrlSetTextColorSecondary|ctrlSetTextSecondary|ctrlSetTooltip|ctrlSetTooltipColorBox|ctrlSetTooltipColorShade|ctrlSetTooltipColorText|ctrlShow|ctrlShown|ctrlText|ctrlTextHeight|ctrlTextSecondary|ctrlTextWidth|ctrlType|ctrlVisible|ctRowControls|ctRowCount|ctSetCurSel|ctSetData|ctSetHeaderTemplate|ctSetRowTemplate|ctSetValue|ctValue|curatorAddons|curatorCamera|curatorCameraArea|curatorCameraAreaCeiling|curatorCoef|curatorEditableObjects|curatorEditingArea|curatorEditingAreaType|curatorMouseOver|curatorPoints|curatorRegisteredObjects|curatorSelected|curatorWaypointCost|current3DENOperation|currentChannel|currentCommand|currentMagazine|currentMagazineDetail|currentMagazineDetailTurret|currentMagazineTurret|currentMuzzle|currentNamespace|currentTask|currentTasks|currentThrowable|currentVisionMode|currentWaypoint|currentWeapon|currentWeaponMode|currentWeaponTurret|currentZeroing|cursorObject|cursorTarget|customChat|customRadio|cutFadeOut|cutObj|cutRsc|cutText|damage|date|dateToNumber|daytime|deActivateKey|debriefingText|debugFSM|debugLog|deg|delete3DENEntities|deleteAt|deleteCenter|deleteCollection|deleteEditorObject|deleteGroup|deleteGroupWhenEmpty|deleteIdentity|deleteLocation|deleteMarker|deleteMarkerLocal|deleteRange|deleteResources|deleteSite|deleteStatus|deleteTeam|deleteVehicle|deleteVehicleCrew|deleteWaypoint|detach|detectedMines|diag_activeMissionFSMs|diag_activeScripts|diag_activeSQFScripts|diag_activeSQSScripts|diag_captureFrame|diag_captureFrameToFile|diag_captureSlowFrame|diag_codePerformance|diag_drawMode|diag_dynamicSimulationEnd|diag_enable|diag_enabled|diag_fps|diag_fpsMin|diag_frameNo|diag_lightNewLoad|diag_list|diag_log|diag_logSlowFrame|diag_mergeConfigFile|diag_recordTurretLimits|diag_setLightNew|diag_tickTime|diag_toggle|dialog|diarySubjectExists|didJIP|didJIPOwner|difficulty|difficultyEnabled|difficultyEnabledRTD|difficultyOption|direction|directSay|disableAI|disableCollisionWith|disableConversation|disableDebriefingStats|disableMapIndicators|disableNVGEquipment|disableRemoteSensors|disableSerialization|disableTIEquipment|disableUAVConnectability|disableUserInput|displayAddEventHandler|displayCtrl|displayNull|displayParent|displayRemoveAllEventHandlers|displayRemoveEventHandler|displaySetEventHandler|dissolveTeam|distance|distance2D|distanceSqr|distributionRegion|do3DENAction|doArtilleryFire|doFire|doFollow|doFSM|doGetOut|doMove|doorPhase|doStop|doSuppressiveFire|doTarget|doWatch|drawArrow|drawEllipse|drawIcon|drawIcon3D|drawLine|drawLine3D|drawLink|drawLocation|drawPolygon|drawRectangle|drawTriangle|driver|drop|dynamicSimulationDistance|dynamicSimulationDistanceCoef|dynamicSimulationEnabled|dynamicSimulationSystemEnabled|east|edit3DENMissionAttributes|editObject|editorSetEventHandler|effectiveCommander|emptyPositions|enableAI|enableAIFeature|enableAimPrecision|enableAttack|enableAudioFeature|enableAutoStartUpRTD|enableAutoTrimRTD|enableCamShake|enableCaustics|enableChannel|enableCollisionWith|enableCopilot|enableDebriefingStats|enableDiagLegend|enableDynamicSimulation|enableDynamicSimulationSystem|enableEndDialog|enableEngineArtillery|enableEnvironment|enableFatigue|enableGunLights|enableInfoPanelComponent|enableIRLasers|enableMimics|enablePersonTurret|enableRadio|enableReload|enableRopeAttach|enableSatNormalOnDetail|enableSaving|enableSentences|enableSimulation|enableSimulationGlobal|enableStamina|enableStressDamage|enableTeamSwitch|enableTraffic|enableUAVConnectability|enableUAVWaypoints|enableVehicleCargo|enableVehicleSensor|enableWeaponDisassembly|endl|endLoadingScreen|endMission|engineOn|enginesIsOnRTD|enginesPowerRTD|enginesRpmRTD|enginesTorqueRTD|entities|environmentEnabled|estimatedEndServerTime|estimatedTimeLeft|evalObjectArgument|everyBackpack|everyContainer|exec|execEditorScript|exp|expectedDestination|exportJIPMessages|eyeDirection|eyePos|face|faction|fadeMusic|fadeRadio|fadeSound|fadeSpeech|failMission|fillWeaponsFromPool|find|findCover|findDisplay|findEditorObject|findEmptyPosition|findEmptyPositionReady|findIf|findNearestEnemy|finishMissionInit|finite|fire|fireAtTarget|firstBackpack|flag|flagAnimationPhase|flagOwner|flagSide|flagTexture|fleeing|floor|flyInHeight|flyInHeightASL|fog|fogForecast|fogParams|forceAddUniform|forceAtPositionRTD|forcedMap|forceEnd|forceFlagTexture|forceFollowRoad|forceGeneratorRTD|forceMap|forceRespawn|forceSpeed|forceWalk|forceWeaponFire|forceWeatherChange|forgetTarget|format|formation|formationDirection|formationLeader|formationMembers|formationPosition|formationTask|formatText|formLeader|freeLook|fromEditor|fuel|fullCrew|gearIDCAmmoCount|gearSlotAmmoCount|gearSlotData|get3DENActionState|get3DENAttribute|get3DENCamera|get3DENConnections|get3DENEntity|get3DENEntityID|get3DENGrid|get3DENIconsVisible|get3DENLayerEntities|get3DENLinesVisible|get3DENMissionAttribute|get3DENMouseOver|get3DENSelected|getAimingCoef|getAllEnvSoundControllers|getAllHitPointsDamage|getAllOwnedMines|getAllSoundControllers|getAmmoCargo|getAnimAimPrecision|getAnimSpeedCoef|getArray|getArtilleryAmmo|getArtilleryComputerSettings|getArtilleryETA|getAssignedCuratorLogic|getAssignedCuratorUnit|getBackpackCargo|getBleedingRemaining|getBurningValue|getCameraViewDirection|getCargoIndex|getCenterOfMass|getClientState|getClientStateNumber|getCompatiblePylonMagazines|getConnectedUAV|getContainerMaxLoad|getCursorObjectParams|getCustomAimCoef|getDammage|getDescription|getDir|getDirVisual|getDLCAssetsUsage|getDLCAssetsUsageByName|getDLCs|getDLCUsageTime|getEditorCamera|getEditorMode|getEditorObjectScope|getElevationOffset|getEngineTargetRpmRTD|getEnvSoundController|getFatigue|getFieldManualStartPage|getForcedFlagTexture|getFriend|getFSMVariable|getFuelCargo|getGroupIcon|getGroupIconParams|getGroupIcons|getHideFrom|getHit|getHitIndex|getHitPointDamage|getItemCargo|getMagazineCargo|getMarkerColor|getMarkerPos|getMarkerSize|getMarkerType|getMass|getMissionConfig|getMissionConfigValue|getMissionDLCs|getMissionLayerEntities|getMissionLayers|getModelInfo|getMousePosition|getMusicPlayedTime|getNumber|getObjectArgument|getObjectChildren|getObjectDLC|getObjectMaterials|getObjectProxy|getObjectTextures|getObjectType|getObjectViewDistance|getOxygenRemaining|getPersonUsedDLCs|getPilotCameraDirection|getPilotCameraPosition|getPilotCameraRotation|getPilotCameraTarget|getPlateNumber|getPlayerChannel|getPlayerScores|getPlayerUID|getPlayerUIDOld|getPos|getPosASL|getPosASLVisual|getPosASLW|getPosATL|getPosATLVisual|getPosVisual|getPosWorld|getPylonMagazines|getRelDir|getRelPos|getRemoteSensorsDisabled|getRepairCargo|getResolution|getRotorBrakeRTD|getShadowDistance|getShotParents|getSlingLoad|getSoundController|getSoundControllerResult|getSpeed|getStamina|getStatValue|getSuppression|getTerrainGrid|getTerrainHeightASL|getText|getTotalDLCUsageTime|getTrimOffsetRTD|getUnitLoadout|getUnitTrait|getUserMFDText|getUserMFDValue|getVariable|getVehicleCargo|getWeaponCargo|getWeaponSway|getWingsOrientationRTD|getWingsPositionRTD|getWPPos|glanceAt|globalChat|globalRadio|goggles|group|groupChat|groupFromNetId|groupIconSelectable|groupIconsVisible|groupId|groupOwner|groupRadio|groupSelectedUnits|groupSelectUnit|grpNull|gunner|gusts|halt|handgunItems|handgunMagazine|handgunWeapon|handsHit|hasInterface|hasPilotCamera|hasWeapon|hcAllGroups|hcGroupParams|hcLeader|hcRemoveAllGroups|hcRemoveGroup|hcSelected|hcSelectGroup|hcSetGroup|hcShowBar|hcShownBar|headgear|hideBody|hideObject|hideObjectGlobal|hideSelection|hint|hintC|hintCadet|hintSilent|hmd|hostMission|htmlLoad|HUDMovementLevels|humidity|image|importAllGroups|importance|in|inArea|inAreaArray|incapacitatedState|independent|inflame|inflamed|infoPanel|infoPanelComponentEnabled|infoPanelComponents|infoPanels|inGameUISetEventHandler|inheritsFrom|initAmbientLife|inPolygon|inputAction|inRangeOfArtillery|insertEditorObject|intersect|is3DEN|is3DENMultiplayer|isAbleToBreathe|isAgent|isAimPrecisionEnabled|isArray|isAutoHoverOn|isAutonomous|isAutoStartUpEnabledRTD|isAutotest|isAutoTrimOnRTD|isBleeding|isBurning|isClass|isCollisionLightOn|isCopilotEnabled|isDamageAllowed|isDedicated|isDLCAvailable|isEngineOn|isEqualTo|isEqualType|isEqualTypeAll|isEqualTypeAny|isEqualTypeArray|isEqualTypeParams|isFilePatchingEnabled|isFlashlightOn|isFlatEmpty|isForcedWalk|isFormationLeader|isGroupDeletedWhenEmpty|isHidden|isInRemainsCollector|isInstructorFigureEnabled|isIRLaserOn|isKeyActive|isKindOf|isLaserOn|isLightOn|isLocalized|isManualFire|isMarkedForCollection|isMultiplayer|isMultiplayerSolo|isNil|isNull|isNumber|isObjectHidden|isObjectRTD|isOnRoad|isPipEnabled|isPlayer|isRealTime|isRemoteExecuted|isRemoteExecutedJIP|isServer|isShowing3DIcons|isSimpleObject|isSprintAllowed|isStaminaEnabled|isSteamMission|isStreamFriendlyUIEnabled|isStressDamageEnabled|isText|isTouchingGround|isTurnedOut|isTutHintsEnabled|isUAVConnectable|isUAVConnected|isUIContext|isUniformAllowed|isVehicleCargo|isVehicleRadarOn|isVehicleSensorEnabled|isWalking|isWeaponDeployed|isWeaponRested|itemCargo|items|itemsWithMagazines|join|joinAs|joinAsSilent|joinSilent|joinString|kbAddDatabase|kbAddDatabaseTargets|kbAddTopic|kbHasTopic|kbReact|kbRemoveTopic|kbTell|kbWasSaid|keyImage|keyName|knowsAbout|land|landAt|landResult|language|laserTarget|lbAdd|lbClear|lbColor|lbColorRight|lbCurSel|lbData|lbDelete|lbIsSelected|lbPicture|lbPictureRight|lbSelection|lbSetColor|lbSetColorRight|lbSetCurSel|lbSetData|lbSetPicture|lbSetPictureColor|lbSetPictureColorDisabled|lbSetPictureColorSelected|lbSetPictureRight|lbSetPictureRightColor|lbSetPictureRightColorDisabled|lbSetPictureRightColorSelected|lbSetSelectColor|lbSetSelectColorRight|lbSetSelected|lbSetText|lbSetTextRight|lbSetTooltip|lbSetValue|lbSize|lbSort|lbSortByValue|lbText|lbTextRight|lbValue|leader|leaderboardDeInit|leaderboardGetRows|leaderboardInit|leaderboardRequestRowsFriends|leaderboardRequestRowsGlobal|leaderboardRequestRowsGlobalAroundUser|leaderboardsRequestUploadScore|leaderboardsRequestUploadScoreKeepBest|leaderboardState|leaveVehicle|libraryCredits|libraryDisclaimers|lifeState|lightAttachObject|lightDetachObject|lightIsOn|lightnings|limitSpeed|linearConversion|lineBreak|lineIntersects|lineIntersectsObjs|lineIntersectsSurfaces|lineIntersectsWith|linkItem|list|listObjects|listRemoteTargets|listVehicleSensors|ln|lnbAddArray|lnbAddColumn|lnbAddRow|lnbClear|lnbColor|lnbColorRight|lnbCurSelRow|lnbData|lnbDeleteColumn|lnbDeleteRow|lnbGetColumnsPosition|lnbPicture|lnbPictureRight|lnbSetColor|lnbSetColorRight|lnbSetColumnsPos|lnbSetCurSelRow|lnbSetData|lnbSetPicture|lnbSetPictureColor|lnbSetPictureColorRight|lnbSetPictureColorSelected|lnbSetPictureColorSelectedRight|lnbSetPictureRight|lnbSetText|lnbSetTextRight|lnbSetValue|lnbSize|lnbSort|lnbSortByValue|lnbText|lnbTextRight|lnbValue|load|loadAbs|loadBackpack|loadFile|loadGame|loadIdentity|loadMagazine|loadOverlay|loadStatus|loadUniform|loadVest|local|localize|locationNull|locationPosition|lock|lockCameraTo|lockCargo|lockDriver|locked|lockedCargo|lockedDriver|lockedTurret|lockIdentity|lockTurret|lockWP|log|logEntities|logNetwork|logNetworkTerminate|lookAt|lookAtPos|magazineCargo|magazines|magazinesAllTurrets|magazinesAmmo|magazinesAmmoCargo|magazinesAmmoFull|magazinesDetail|magazinesDetailBackpack|magazinesDetailUniform|magazinesDetailVest|magazinesTurret|magazineTurretAmmo|mapAnimAdd|mapAnimClear|mapAnimCommit|mapAnimDone|mapCenterOnCamera|mapGridPosition|markAsFinishedOnSteam|markerAlpha|markerBrush|markerColor|markerDir|markerPos|markerShape|markerSize|markerText|markerType|max|members|menuAction|menuAdd|menuChecked|menuClear|menuCollapse|menuData|menuDelete|menuEnable|menuEnabled|menuExpand|menuHover|menuPicture|menuSetAction|menuSetCheck|menuSetData|menuSetPicture|menuSetValue|menuShortcut|menuShortcutText|menuSize|menuSort|menuText|menuURL|menuValue|min|mineActive|mineDetectedBy|missionConfigFile|missionDifficulty|missionName|missionNamespace|missionStart|missionVersion|modelToWorld|modelToWorldVisual|modelToWorldVisualWorld|modelToWorldWorld|modParams|moonIntensity|moonPhase|morale|move|move3DENCamera|moveInAny|moveInCargo|moveInCommander|moveInDriver|moveInGunner|moveInTurret|moveObjectToEnd|moveOut|moveTime|moveTo|moveToCompleted|moveToFailed|musicVolume|name|nameSound|nearEntities|nearestBuilding|nearestLocation|nearestLocations|nearestLocationWithDubbing|nearestObject|nearestObjects|nearestTerrainObjects|nearObjects|nearObjectsReady|nearRoads|nearSupplies|nearTargets|needReload|netId|netObjNull|newOverlay|nextMenuItemIndex|nextWeatherChange|nMenuItems|numberOfEnginesRTD|numberToDate|objectCurators|objectFromNetId|objectParent|objNull|objStatus|onBriefingGear|onBriefingGroup|onBriefingNotes|onBriefingPlan|onBriefingTeamSwitch|onCommandModeChanged|onDoubleClick|onEachFrame|onGroupIconClick|onGroupIconOverEnter|onGroupIconOverLeave|onHCGroupSelectionChanged|onMapSingleClick|onPlayerConnected|onPlayerDisconnected|onPreloadFinished|onPreloadStarted|onShowNewObject|onTeamSwitch|openCuratorInterface|openDLCPage|openDSInterface|openMap|openSteamApp|openYoutubeVideo|opfor|orderGetIn|overcast|overcastForecast|owner|param|params|parseNumber|parseSimpleArray|parseText|parsingNamespace|particlesQuality|pi|pickWeaponPool|pitch|pixelGrid|pixelGridBase|pixelGridNoUIScale|pixelH|pixelW|playableSlotsNumber|playableUnits|playAction|playActionNow|player|playerRespawnTime|playerSide|playersNumber|playGesture|playMission|playMove|playMoveNow|playMusic|playScriptedMission|playSound|playSound3D|position|positionCameraToWorld|posScreenToWorld|posWorldToScreen|ppEffectAdjust|ppEffectCommit|ppEffectCommitted|ppEffectCreate|ppEffectDestroy|ppEffectEnable|ppEffectEnabled|ppEffectForceInNVG|precision|preloadCamera|preloadObject|preloadSound|preloadTitleObj|preloadTitleRsc|primaryWeapon|primaryWeaponItems|primaryWeaponMagazine|priority|processDiaryLink|processInitCommands|productVersion|profileName|profileNamespace|profileNameSteam|progressLoadingScreen|progressPosition|progressSetPosition|publicVariable|publicVariableClient|publicVariableServer|pushBack|pushBackUnique|putWeaponPool|queryItemsPool|queryMagazinePool|queryWeaponPool|rad|radioChannelAdd|radioChannelCreate|radioChannelRemove|radioChannelSetCallSign|radioChannelSetLabel|radioVolume|rain|rainbow|random|rank|rankId|rating|rectangular|registeredTasks|registerTask|reload|reloadEnabled|remoteControl|remoteExec|remoteExecCall|remoteExecutedOwner|remove3DENConnection|remove3DENEventHandler|remove3DENLayer|removeAction|removeAll3DENEventHandlers|removeAllActions|removeAllAssignedItems|removeAllContainers|removeAllCuratorAddons|removeAllCuratorCameraAreas|removeAllCuratorEditingAreas|removeAllEventHandlers|removeAllHandgunItems|removeAllItems|removeAllItemsWithMagazines|removeAllMissionEventHandlers|removeAllMPEventHandlers|removeAllMusicEventHandlers|removeAllOwnedMines|removeAllPrimaryWeaponItems|removeAllWeapons|removeBackpack|removeBackpackGlobal|removeCuratorAddons|removeCuratorCameraArea|removeCuratorEditableObjects|removeCuratorEditingArea|removeDrawIcon|removeDrawLinks|removeEventHandler|removeFromRemainsCollector|removeGoggles|removeGroupIcon|removeHandgunItem|removeHeadgear|removeItem|removeItemFromBackpack|removeItemFromUniform|removeItemFromVest|removeItems|removeMagazine|removeMagazineGlobal|removeMagazines|removeMagazinesTurret|removeMagazineTurret|removeMenuItem|removeMissionEventHandler|removeMPEventHandler|removeMusicEventHandler|removeOwnedMine|removePrimaryWeaponItem|removeSecondaryWeaponItem|removeSimpleTask|removeSwitchableUnit|removeTeamMember|removeUniform|removeVest|removeWeapon|removeWeaponAttachmentCargo|removeWeaponCargo|removeWeaponGlobal|removeWeaponTurret|reportRemoteTarget|requiredVersion|resetCamShake|resetSubgroupDirection|resistance|resize|resources|respawnVehicle|restartEditorCamera|reveal|revealMine|reverse|reversedMouseY|roadAt|roadsConnectedTo|roleDescription|ropeAttachedObjects|ropeAttachedTo|ropeAttachEnabled|ropeAttachTo|ropeCreate|ropeCut|ropeDestroy|ropeDetach|ropeEndPosition|ropeLength|ropes|ropeUnwind|ropeUnwound|rotorsForcesRTD|rotorsRpmRTD|round|runInitScript|safeZoneH|safeZoneW|safeZoneWAbs|safeZoneX|safeZoneXAbs|safeZoneY|save3DENInventory|saveGame|saveIdentity|saveJoysticks|saveOverlay|saveProfileNamespace|saveStatus|saveVar|savingEnabled|say|say2D|say3D|score|scoreSide|screenshot|screenToWorld|scriptDone|scriptName|scriptNull|scudState|secondaryWeapon|secondaryWeaponItems|secondaryWeaponMagazine|select|selectBestPlaces|selectDiarySubject|selectedEditorObjects|selectEditorObject|selectionNames|selectionPosition|selectLeader|selectMax|selectMin|selectNoPlayer|selectPlayer|selectRandom|selectRandomWeighted|selectWeapon|selectWeaponTurret|sendAUMessage|sendSimpleCommand|sendTask|sendTaskResult|sendUDPMessage|serverCommand|serverCommandAvailable|serverCommandExecutable|serverName|serverTime|set|set3DENAttribute|set3DENAttributes|set3DENGrid|set3DENIconsVisible|set3DENLayer|set3DENLinesVisible|set3DENLogicType|set3DENMissionAttribute|set3DENMissionAttributes|set3DENModelsVisible|set3DENObjectType|set3DENSelected|setAccTime|setActualCollectiveRTD|setAirplaneThrottle|setAirportSide|setAmmo|setAmmoCargo|setAmmoOnPylon|setAnimSpeedCoef|setAperture|setApertureNew|setArmoryPoints|setAttributes|setAutonomous|setBehaviour|setBleedingRemaining|setBrakesRTD|setCameraInterest|setCamShakeDefParams|setCamShakeParams|setCamUseTI|setCaptive|setCenterOfMass|setCollisionLight|setCombatMode|setCompassOscillation|setConvoySeparation|setCuratorCameraAreaCeiling|setCuratorCoef|setCuratorEditingAreaType|setCuratorWaypointCost|setCurrentChannel|setCurrentTask|setCurrentWaypoint|setCustomAimCoef|setCustomWeightRTD|setDamage|setDammage|setDate|setDebriefingText|setDefaultCamera|setDestination|setDetailMapBlendPars|setDir|setDirection|setDrawIcon|setDriveOnPath|setDropInterval|setDynamicSimulationDistance|setDynamicSimulationDistanceCoef|setEditorMode|setEditorObjectScope|setEffectCondition|setEngineRpmRTD|setFace|setFaceAnimation|setFatigue|setFeatureType|setFlagAnimationPhase|setFlagOwner|setFlagSide|setFlagTexture|setFog|setForceGeneratorRTD|setFormation|setFormationTask|setFormDir|setFriend|setFromEditor|setFSMVariable|setFuel|setFuelCargo|setGroupIcon|setGroupIconParams|setGroupIconsSelectable|setGroupIconsVisible|setGroupId|setGroupIdGlobal|setGroupOwner|setGusts|setHideBehind|setHit|setHitIndex|setHitPointDamage|setHorizonParallaxCoef|setHUDMovementLevels|setIdentity|setImportance|setInfoPanel|setLeader|setLightAmbient|setLightAttenuation|setLightBrightness|setLightColor|setLightDayLight|setLightFlareMaxDistance|setLightFlareSize|setLightIntensity|setLightnings|setLightUseFlare|setLocalWindParams|setMagazineTurretAmmo|setMarkerAlpha|setMarkerAlphaLocal|setMarkerBrush|setMarkerBrushLocal|setMarkerColor|setMarkerColorLocal|setMarkerDir|setMarkerDirLocal|setMarkerPos|setMarkerPosLocal|setMarkerShape|setMarkerShapeLocal|setMarkerSize|setMarkerSizeLocal|setMarkerText|setMarkerTextLocal|setMarkerType|setMarkerTypeLocal|setMass|setMimic|setMousePosition|setMusicEffect|setMusicEventHandler|setName|setNameSound|setObjectArguments|setObjectMaterial|setObjectMaterialGlobal|setObjectProxy|setObjectTexture|setObjectTextureGlobal|setObjectViewDistance|setOvercast|setOwner|setOxygenRemaining|setParticleCircle|setParticleClass|setParticleFire|setParticleParams|setParticleRandom|setPilotCameraDirection|setPilotCameraRotation|setPilotCameraTarget|setPilotLight|setPiPEffect|setPitch|setPlateNumber|setPlayable|setPlayerRespawnTime|setPos|setPosASL|setPosASL2|setPosASLW|setPosATL|setPosition|setPosWorld|setPylonLoadOut|setPylonsPriority|setRadioMsg|setRain|setRainbow|setRandomLip|setRank|setRectangular|setRepairCargo|setRotorBrakeRTD|setShadowDistance|setShotParents|setSide|setSimpleTaskAlwaysVisible|setSimpleTaskCustomData|setSimpleTaskDescription|setSimpleTaskDestination|setSimpleTaskTarget|setSimpleTaskType|setSimulWeatherLayers|setSize|setSkill|setSlingLoad|setSoundEffect|setSpeaker|setSpeech|setSpeedMode|setStamina|setStaminaScheme|setStatValue|setSuppression|setSystemOfUnits|setTargetAge|setTaskMarkerOffset|setTaskResult|setTaskState|setTerrainGrid|setText|setTimeMultiplier|setTitleEffect|setToneMapping|setToneMappingParams|setTrafficDensity|setTrafficDistance|setTrafficGap|setTrafficSpeed|setTriggerActivation|setTriggerArea|setTriggerStatements|setTriggerText|setTriggerTimeout|setTriggerType|setType|setUnconscious|setUnitAbility|setUnitLoadout|setUnitPos|setUnitPosWeak|setUnitRank|setUnitRecoilCoefficient|setUnitTrait|setUnloadInCombat|setUserActionText|setUserMFDText|setUserMFDValue|setVariable|setVectorDir|setVectorDirAndUp|setVectorUp|setVehicleAmmo|setVehicleAmmoDef|setVehicleArmor|setVehicleCargo|setVehicleId|setVehicleInit|setVehicleLock|setVehiclePosition|setVehicleRadar|setVehicleReceiveRemoteTargets|setVehicleReportOwnPosition|setVehicleReportRemoteTargets|setVehicleTIPars|setVehicleVarName|setVelocity|setVelocityModelSpace|setVelocityTransformation|setViewDistance|setVisibleIfTreeCollapsed|setWantedRpmRTD|setWaves|setWaypointBehaviour|setWaypointCombatMode|setWaypointCompletionRadius|setWaypointDescription|setWaypointForceBehaviour|setWaypointFormation|setWaypointHousePosition|setWaypointLoiterRadius|setWaypointLoiterType|setWaypointName|setWaypointPosition|setWaypointScript|setWaypointSpeed|setWaypointStatements|setWaypointTimeout|setWaypointType|setWaypointVisible|setWeaponReloadingTime|setWind|setWindDir|setWindForce|setWindStr|setWingForceScaleRTD|setWPPos|show3DIcons|showChat|showCinemaBorder|showCommandingMenu|showCompass|showCuratorCompass|showGPS|showHUD|showLegend|showMap|shownArtilleryComputer|shownChat|shownCompass|shownCuratorCompass|showNewEditorObject|shownGPS|shownHUD|shownMap|shownPad|shownRadio|shownScoretable|shownUAVFeed|shownWarrant|shownWatch|showPad|showRadio|showScoretable|showSubtitles|showUAVFeed|showWarrant|showWatch|showWaypoint|showWaypoints|side|sideAmbientLife|sideChat|sideEmpty|sideEnemy|sideFriendly|sideLogic|sideRadio|sideUnknown|simpleTasks|simulationEnabled|simulCloudDensity|simulCloudOcclusion|simulInClouds|simulWeatherSync|sin|size|sizeOf|skill|skillFinal|skipTime|sleep|sliderPosition|sliderRange|sliderSetPosition|sliderSetRange|sliderSetSpeed|sliderSpeed|slingLoadAssistantShown|soldierMagazines|someAmmo|sort|soundVolume|speaker|speed|speedMode|splitString|sqrt|squadParams|stance|startLoadingScreen|stop|stopEngineRTD|stopped|str|sunOrMoon|supportInfo|suppressFor|surfaceIsWater|surfaceNormal|surfaceType|swimInDepth|switchableUnits|switchAction|switchCamera|switchGesture|switchLight|switchMove|synchronizedObjects|synchronizedTriggers|synchronizedWaypoints|synchronizeObjectsAdd|synchronizeObjectsRemove|synchronizeTrigger|synchronizeWaypoint|systemChat|systemOfUnits|tan|targetKnowledge|targets|targetsAggregate|targetsQuery|taskAlwaysVisible|taskChildren|taskCompleted|taskCustomData|taskDescription|taskDestination|taskHint|taskMarkerOffset|taskNull|taskParent|taskResult|taskState|taskType|teamMember|teamMemberNull|teamName|teams|teamSwitch|teamSwitchEnabled|teamType|terminate|terrainIntersect|terrainIntersectASL|terrainIntersectAtASL|text|textLog|textLogFormat|tg|time|timeMultiplier|titleCut|titleFadeOut|titleObj|titleRsc|titleText|toArray|toFixed|toLower|toString|toUpper|triggerActivated|triggerActivation|triggerArea|triggerAttachedVehicle|triggerAttachObject|triggerAttachVehicle|triggerDynamicSimulation|triggerStatements|triggerText|triggerTimeout|triggerTimeoutCurrent|triggerType|turretLocal|turretOwner|turretUnit|tvAdd|tvClear|tvCollapse|tvCollapseAll|tvCount|tvCurSel|tvData|tvDelete|tvExpand|tvExpandAll|tvPicture|tvPictureRight|tvSetColor|tvSetCurSel|tvSetData|tvSetPicture|tvSetPictureColor|tvSetPictureColorDisabled|tvSetPictureColorSelected|tvSetPictureRight|tvSetPictureRightColor|tvSetPictureRightColorDisabled|tvSetPictureRightColorSelected|tvSetSelectColor|tvSetText|tvSetTooltip|tvSetValue|tvSort|tvSortByValue|tvText|tvTooltip|tvValue|type|typeName|typeOf|UAVControl|uiNamespace|uiSleep|unassignCurator|unassignItem|unassignTeam|unassignVehicle|underwater|uniform|uniformContainer|uniformItems|uniformMagazines|unitAddons|unitAimPosition|unitAimPositionVisual|unitBackpack|unitIsUAV|unitPos|unitReady|unitRecoilCoefficient|units|unitsBelowHeight|unlinkItem|unlockAchievement|unregisterTask|updateDrawIcon|updateMenuItem|updateObjectTree|useAIOperMapObstructionTest|useAISteeringComponent|useAudioTimeForMoves|userInputDisabled|vectorAdd|vectorCos|vectorCrossProduct|vectorDiff|vectorDir|vectorDirVisual|vectorDistance|vectorDistanceSqr|vectorDotProduct|vectorFromTo|vectorMagnitude|vectorMagnitudeSqr|vectorModelToWorld|vectorModelToWorldVisual|vectorMultiply|vectorNormalized|vectorUp|vectorUpVisual|vectorWorldToModel|vectorWorldToModelVisual|vehicle|vehicleCargoEnabled|vehicleChat|vehicleRadio|vehicleReceiveRemoteTargets|vehicleReportOwnPosition|vehicleReportRemoteTargets|vehicles|vehicleVarName|velocity|velocityModelSpace|verifySignature|vest|vestContainer|vestItems|vestMagazines|viewDistance|visibleCompass|visibleGPS|visibleMap|visiblePosition|visiblePositionASL|visibleScoretable|visibleWatch|waitUntil|waves|waypointAttachedObject|waypointAttachedVehicle|waypointAttachObject|waypointAttachVehicle|waypointBehaviour|waypointCombatMode|waypointCompletionRadius|waypointDescription|waypointForceBehaviour|waypointFormation|waypointHousePosition|waypointLoiterRadius|waypointLoiterType|waypointName|waypointPosition|waypoints|waypointScript|waypointsEnabledUAV|waypointShow|waypointSpeed|waypointStatements|waypointTimeout|waypointTimeoutCurrent|waypointType|waypointVisible|weaponAccessories|weaponAccessoriesCargo|weaponCargo|weaponDirection|weaponInertia|weaponLowered|weapons|weaponsItems|weaponsItemsCargo|weaponState|weaponsTurret|weightRTD|west|WFSideText|wind|windDir|windRTD|windStr|wingsForcesRTD|worldName|worldSize|worldToModel|worldToModelVisual|worldToScreen)\b/i,
      number: /(?:\$|\b0x)[\da-f]+\b|(?:\B\.\d+|\b\d+(?:\.\d+)?)(?:e[+-]?\d+)?\b/i,
      operator: /##|>>|&&|\|\||[!=<>]=?|[-+*/%#^]|\b(?:and|mod|not|or)\b/i,
      "magic-variable": {
        pattern: /\b(?:this|thisList|thisTrigger|_exception|_fnc_scriptName|_fnc_scriptNameParent|_forEachIndex|_this|_thisEventHandler|_thisFSM|_thisScript|_x)\b/i,
        alias: "keyword"
      },
      constant: /\bDIK(?:_[a-z\d]+)+\b/i
    }), t.languages.insertBefore("sqf", "string", {
      macro: {
        pattern: /(^[ \t]*)#[a-z](?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: !0,
        greedy: !0,
        alias: "property",
        inside: {
          directive: {
            pattern: /#[a-z]+\b/i,
            alias: "keyword"
          },
          comment: t.languages.sqf.comment
        }
      }
    }), delete t.languages.sqf["class-name"];
  }
  return Vh;
}
var Wh, EC;
function mX() {
  if (EC) return Wh;
  EC = 1, Wh = e, e.displayName = "squirrel", e.aliases = [];
  function e(t) {
    t.languages.squirrel = t.languages.extend("clike", {
      comment: [
        t.languages.clike.comment[0],
        {
          pattern: /(^|[^\\:])(?:\/\/|#).*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^\\"'@])(?:@"(?:[^"]|"")*"(?!")|"(?:[^\\\r\n"]|\\.)*")/,
        lookbehind: !0,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|instanceof)\s+)\w+(?:\.\w+)*/,
        lookbehind: !0,
        inside: {
          punctuation: /\./
        }
      },
      keyword: /\b(?:__FILE__|__LINE__|base|break|case|catch|class|clone|const|constructor|continue|default|delete|else|enum|extends|for|foreach|function|if|in|instanceof|local|null|resume|return|static|switch|this|throw|try|typeof|while|yield)\b/,
      number: /\b(?:0x[0-9a-fA-F]+|\d+(?:\.(?:\d+|[eE][+-]?\d+))?)\b/,
      operator: /\+\+|--|<=>|<[-<]|>>>?|&&?|\|\|?|[-+*/%!=<>]=?|[~^]|::?/,
      punctuation: /[(){}\[\],;.]/
    }), t.languages.insertBefore("squirrel", "string", {
      char: {
        pattern: /(^|[^\\"'])'(?:[^\\']|\\(?:[xuU][0-9a-fA-F]{0,8}|[\s\S]))'/,
        lookbehind: !0,
        greedy: !0
      }
    }), t.languages.insertBefore("squirrel", "operator", {
      "attribute-punctuation": {
        pattern: /<\/|\/>/,
        alias: "important"
      },
      lambda: {
        pattern: /@(?=\()/,
        alias: "operator"
      }
    });
  }
  return Wh;
}
var Kh, SC;
function hX() {
  if (SC) return Kh;
  SC = 1, Kh = e, e.displayName = "stan", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\b(?:algebra_solver|algebra_solver_newton|integrate_1d|integrate_ode|integrate_ode_bdf|integrate_ode_rk45|map_rect|ode_(?:adams|bdf|ckrk|rk45)(?:_tol)?|ode_adjoint_tol_ctl|reduce_sum|reduce_sum_static)\b/;
      n.languages.stan = {
        comment: /\/\/.*|\/\*[\s\S]*?\*\/|#(?!include).*/,
        string: {
          // String literals can contain spaces and any printable ASCII characters except for " and \
          // https://mc-stan.org/docs/2_24/reference-manual/print-statements-section.html#string-literals
          pattern: /"[\x20\x21\x23-\x5B\x5D-\x7E]*"/,
          greedy: !0
        },
        directive: {
          pattern: /^([ \t]*)#include\b.*/m,
          lookbehind: !0,
          alias: "property"
        },
        "function-arg": {
          pattern: RegExp(
            "(" + r.source + /\s*\(\s*/.source + ")" + /[a-zA-Z]\w*/.source
          ),
          lookbehind: !0,
          alias: "function"
        },
        constraint: {
          pattern: /(\b(?:int|matrix|real|row_vector|vector)\s*)<[^<>]*>/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /(=\s*)\S(?:\S|\s+(?!\s))*?(?=\s*(?:>$|,\s*\w+\s*=))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            property: /\b[a-z]\w*(?=\s*=)/i,
            operator: /=/,
            punctuation: /^<|>$|,/
          }
        },
        keyword: [
          {
            pattern: /\bdata(?=\s*\{)|\b(?:functions|generated|model|parameters|quantities|transformed)\b/,
            alias: "program-block"
          },
          /\b(?:array|break|cholesky_factor_corr|cholesky_factor_cov|complex|continue|corr_matrix|cov_matrix|data|else|for|if|in|increment_log_prob|int|matrix|ordered|positive_ordered|print|real|reject|return|row_vector|simplex|target|unit_vector|vector|void|while)\b/,
          // these are functions that are known to take another function as their first argument.
          r
        ],
        function: /\b[a-z]\w*(?=\s*\()/i,
        number: /(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:E[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        boolean: /\b(?:false|true)\b/,
        operator: /<-|\.[*/]=?|\|\|?|&&|[!=<>+\-*/]=?|['^%~?:]/,
        punctuation: /[()\[\]{},;]/
      }, n.languages.stan.constraint.inside.expression.inside = n.languages.stan;
    })(t);
  }
  return Kh;
}
var Yh, xC;
function bX() {
  if (xC) return Yh;
  xC = 1, Yh = e, e.displayName = "stylus", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /(\b\d+)(?:%|[a-z]+)/,
        lookbehind: !0
      }, a = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: !0
      }, i = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0
        },
        url: {
          pattern: /\burl\((["']?).*?\1\)/i,
          greedy: !0
        },
        string: {
          pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
          greedy: !0
        },
        interpolation: null,
        // See below
        func: null,
        // See below
        important: /\B!(?:important|optional)\b/i,
        keyword: {
          pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
          lookbehind: !0
        },
        hexcode: /#[\da-f]{3,6}/i,
        color: [
          /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
          {
            pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
            inside: {
              unit: r,
              number: a,
              function: /[\w-]+(?=\()/,
              punctuation: /[(),]/
            }
          }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: r,
        boolean: /\b(?:false|true)\b/,
        operator: [
          // We want non-word chars around "-" because it is
          // accepted in property names.
          /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
        ],
        number: a,
        punctuation: /[{}()\[\];:,]/
      };
      i.interpolation = {
        pattern: /\{[^\r\n}:]+\}/,
        alias: "variable",
        inside: {
          delimiter: {
            pattern: /^\{|\}$/,
            alias: "punctuation"
          },
          rest: i
        }
      }, i.func = {
        pattern: /[\w-]+\([^)]*\).*/,
        inside: {
          function: /^[^(]+/,
          rest: i
        }
      }, n.languages.stylus = {
        "atrule-declaration": {
          pattern: /(^[ \t]*)@.+/m,
          lookbehind: !0,
          inside: {
            atrule: /^@[\w-]+/,
            rest: i
          }
        },
        "variable-declaration": {
          pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
          lookbehind: !0,
          inside: {
            variable: /^\S+/,
            rest: i
          }
        },
        statement: {
          pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
          lookbehind: !0,
          inside: {
            keyword: /^\S+/,
            rest: i
          }
        },
        // A property/value pair cannot end with a comma or a brace
        // It cannot have indented content unless it ended with a semicolon
        "property-declaration": {
          pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
          lookbehind: !0,
          inside: {
            property: {
              pattern: /^[^\s:]+/,
              inside: {
                interpolation: i.interpolation
              }
            },
            rest: i
          }
        },
        // A selector can contain parentheses only as part of a pseudo-element
        // It can span multiple lines.
        // It must end with a comma or an accolade or have indented content.
        selector: {
          pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
          lookbehind: !0,
          inside: {
            interpolation: i.interpolation,
            comment: i.comment,
            punctuation: /[{},]/
          }
        },
        func: i.func,
        string: i.string,
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
          lookbehind: !0,
          greedy: !0
        },
        interpolation: i.interpolation,
        punctuation: /[{}()\[\];:.]/
      };
    })(t);
  }
  return Yh;
}
var Xh, TC;
function yX() {
  if (TC) return Xh;
  TC = 1, Xh = e, e.displayName = "swift", e.aliases = [];
  function e(t) {
    t.languages.swift = {
      comment: {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: !0,
        greedy: !0
      },
      "string-literal": [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
          pattern: RegExp(
            /(^|[^"#])/.source + "(?:" + // single-line string
            /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + // multi-line string
            /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\\($/,
              alias: "punctuation"
            },
            punctuation: /\\(?=[\r\n])/,
            string: /[\s\S]+/
          }
        },
        {
          pattern: RegExp(
            /(^|[^"#])(#+)/.source + "(?:" + // single-line string
            /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + // multi-line string
            /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
              lookbehind: !0,
              inside: null
              // see below
            },
            "interpolation-punctuation": {
              pattern: /^\)|\\#+\($/,
              alias: "punctuation"
            },
            string: /[\s\S]+/
          }
        }
      ],
      directive: {
        // directives with conditions
        pattern: RegExp(
          /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + // This regex is a little complex. It's equivalent to this:
          //   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
          // where <round> is a general parentheses expression.
          /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
        ),
        alias: "property",
        inside: {
          "directive-name": /^#\w+/,
          boolean: /\b(?:false|true)\b/,
          number: /\b\d+(?:\.\d+)*\b/,
          operator: /!|&&|\|\||[<>]=?/,
          punctuation: /[(),]/
        }
      },
      literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
      },
      "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
      },
      attribute: {
        pattern: /@\w+/,
        alias: "atrule"
      },
      "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: !0,
        alias: "function"
      },
      label: {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: !0,
        alias: "important"
      },
      keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
      boolean: /\b(?:false|true)\b/,
      nil: {
        pattern: /\bnil\b/,
        alias: "constant"
      },
      "short-argument": /\$\d+\b/,
      omit: {
        pattern: /\b_\b/,
        alias: "keyword"
      },
      number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
      // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
      "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
      // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
      // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
      // This regex only supports ASCII operators.
      operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
      punctuation: /[{}[\]();,.:\\]/
    }, t.languages.swift["string-literal"].forEach(function(n) {
      n.inside.interpolation.inside = t.languages.swift;
    });
  }
  return Xh;
}
var Zh, wC;
function vX() {
  if (wC) return Zh;
  wC = 1, Zh = e, e.displayName = "systemd", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /^[;#].*/m,
        greedy: !0
      }, a = /"(?:[^\r\n"\\]|\\(?:[^\r]|\r\n?))*"(?!\S)/.source;
      n.languages.systemd = {
        comment: r,
        section: {
          pattern: /^\[[^\n\r\[\]]*\](?=[ \t]*$)/m,
          greedy: !0,
          inside: {
            punctuation: /^\[|\]$/,
            "section-name": {
              pattern: /[\s\S]+/,
              alias: "selector"
            }
          }
        },
        key: {
          pattern: /^[^\s=]+(?=[ \t]*=)/m,
          greedy: !0,
          alias: "attr-name"
        },
        value: {
          // This pattern is quite complex because of two properties:
          //  1) Quotes (strings) must be preceded by a space. Since we can't use lookbehinds, we have to "resolve"
          //     the lookbehind. You will see this in the main loop where spaces are handled separately.
          //  2) Line continuations.
          //     After line continuations, empty lines and comments are ignored so we have to consume them.
          pattern: RegExp(
            /(=[ \t]*(?!\s))/.source + // the value either starts with quotes or not
            "(?:" + a + `|(?=[^"\r
]))(?:` + (/[^\s\\]/.source + // handle spaces separately because of quotes
            '|[ 	]+(?:(?![ 	"])|' + a + ")|" + /\\[\r\n]+(?:[#;].*[\r\n]+)*(?![#;])/.source) + ")*"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "attr-value",
          inside: {
            comment: r,
            quoted: {
              pattern: RegExp(/(^|\s)/.source + a),
              lookbehind: !0,
              greedy: !0
            },
            punctuation: /\\$/m,
            boolean: {
              pattern: /^(?:false|no|off|on|true|yes)$/,
              greedy: !0
            }
          }
        },
        punctuation: /=/
      };
    })(t);
  }
  return Zh;
}
var Jh, AC;
function zv() {
  if (AC) return Jh;
  AC = 1, Jh = e, e.displayName = "t4Templating", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(i, s, u) {
        return {
          pattern: RegExp("<#" + i + "[\\s\\S]*?#>"),
          alias: "block",
          inside: {
            delimiter: {
              pattern: RegExp("^<#" + i + "|#>$"),
              alias: "important"
            },
            content: {
              pattern: /[\s\S]+/,
              inside: s,
              alias: u
            }
          }
        };
      }
      function a(i) {
        var s = n.languages[i], u = "language-" + i;
        return {
          block: {
            pattern: /<#[\s\S]+?#>/,
            inside: {
              directive: r("@", {
                "attr-value": {
                  pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/,
                  inside: {
                    punctuation: /^=|^["']|["']$/
                  }
                },
                keyword: /\b\w+(?=\s)/,
                "attr-name": /\b\w+/
              }),
              expression: r("=", s, u),
              "class-feature": r("\\+", s, u),
              standard: r("", s, u)
            }
          }
        };
      }
      n.languages["t4-templating"] = Object.defineProperty({}, "createT4", {
        value: a
      });
    })(t);
  }
  return Jh;
}
var Qh, IC;
function EX() {
  if (IC) return Qh;
  IC = 1;
  var e = zv(), t = cc();
  Qh = n, n.displayName = "t4Cs", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), r.languages.t4 = r.languages["t4-cs"] = r.languages["t4-templating"].createT4("csharp");
  }
  return Qh;
}
var eb, RC;
function d1() {
  if (RC) return eb;
  RC = 1;
  var e = s1();
  eb = t, t.displayName = "vbnet", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.vbnet = n.languages.extend("basic", {
      comment: [
        {
          pattern: /(?:!|REM\b).+/i,
          inside: {
            keyword: /^REM/i
          }
        },
        {
          pattern: /(^|[^\\:])'.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(^|[^"])"(?:""|[^"])*"(?!")/,
        lookbehind: !0,
        greedy: !0
      },
      keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDBL|CDEC|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DEFAULT|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LET|LIB|LIKE|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPERATOR|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHELL|SHORT|SINGLE|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SWAP|SYNCLOCK|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
      punctuation: /[,;:(){}]/
    });
  }
  return eb;
}
var tb, _C;
function SX() {
  if (_C) return tb;
  _C = 1;
  var e = zv(), t = d1();
  tb = n, n.displayName = "t4Vb", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), r.languages["t4-vb"] = r.languages["t4-templating"].createT4("vbnet");
  }
  return tb;
}
var nb, CC;
function p1() {
  if (CC) return nb;
  CC = 1, nb = e, e.displayName = "yaml", e.aliases = ["yml"];
  function e(t) {
    (function(n) {
      var r = /[*&][^\s[\]{},]+/, a = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, i = "(?:" + a.source + "(?:[ 	]+" + r.source + ")?|" + r.source + "(?:[ 	]+" + a.source + ")?)", s = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(
        /<PLAIN>/g,
        function() {
          return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        }
      ), u = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
      function c(d, p) {
        p = (p || "").replace(/m/g, "") + "m";
        var f = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
          return i;
        }).replace(/<<value>>/g, function() {
          return d;
        });
        return RegExp(f, p);
      }
      n.languages.yaml = {
        scalar: {
          pattern: RegExp(
            /([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(
              /<<prop>>/g,
              function() {
                return i;
              }
            )
          ),
          lookbehind: !0,
          alias: "string"
        },
        comment: /#.*/,
        key: {
          pattern: RegExp(
            /((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
              return i;
            }).replace(/<<key>>/g, function() {
              return "(?:" + s + "|" + u + ")";
            })
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "atrule"
        },
        directive: {
          pattern: /(^[ \t]*)%.+/m,
          lookbehind: !0,
          alias: "important"
        },
        datetime: {
          pattern: c(
            /\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source
          ),
          lookbehind: !0,
          alias: "number"
        },
        boolean: {
          pattern: c(/false|true/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        null: {
          pattern: c(/null|~/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        string: {
          pattern: c(u),
          lookbehind: !0,
          greedy: !0
        },
        number: {
          pattern: c(
            /[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source,
            "i"
          ),
          lookbehind: !0
        },
        tag: a,
        important: r,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
      }, n.languages.yml = n.languages.yaml;
    })(t);
  }
  return nb;
}
var rb, kC;
function xX() {
  if (kC) return rb;
  kC = 1;
  var e = p1();
  rb = t, t.displayName = "tap", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.tap = {
      fail: /not ok[^#{\n\r]*/,
      pass: /ok[^#{\n\r]*/,
      pragma: /pragma [+-][a-z]+/,
      bailout: /bail out!.*/i,
      version: /TAP version \d+/i,
      plan: /\b\d+\.\.\d+(?: +#.*)?/,
      subtest: {
        pattern: /# Subtest(?:: .*)?/,
        greedy: !0
      },
      punctuation: /[{}]/,
      directive: /#.*/,
      yamlish: {
        pattern: /(^[ \t]*)---[\s\S]*?[\r\n][ \t]*\.\.\.$/m,
        lookbehind: !0,
        inside: n.languages.yaml,
        alias: "language-yaml"
      }
    };
  }
  return rb;
}
var ab, NC;
function TX() {
  if (NC) return ab;
  NC = 1, ab = e, e.displayName = "tcl", e.aliases = [];
  function e(t) {
    t.languages.tcl = {
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: !0
      },
      string: {
        pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
        greedy: !0
      },
      variable: [
        {
          pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
          lookbehind: !0
        },
        {
          pattern: /(\$)\{[^}]+\}/,
          lookbehind: !0
        },
        {
          pattern: /(^[\t ]*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
          lookbehind: !0
        }
      ],
      function: {
        pattern: /(^[\t ]*proc[ \t]+)\S+/m,
        lookbehind: !0
      },
      builtin: [
        {
          pattern: /(^[\t ]*)(?:break|class|continue|error|eval|exit|for|foreach|if|proc|return|switch|while)\b/m,
          lookbehind: !0
        },
        /\b(?:else|elseif)\b/
      ],
      scope: {
        pattern: /(^[\t ]*)(?:global|upvar|variable)\b/m,
        lookbehind: !0,
        alias: "constant"
      },
      keyword: {
        pattern: /(^[\t ]*|\[)(?:Safe_Base|Tcl|after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|scan|seek|set|socket|source|split|string|subst|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|test|vars|wordBreak(?:After|Before))|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
        lookbehind: !0
      },
      operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|in|ne|ni)\b/,
      punctuation: /[{}()\[\]]/
    };
  }
  return ab;
}
var ib, OC;
function wX() {
  if (OC) return ib;
  OC = 1, ib = e, e.displayName = "textile", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /\([^|()\n]+\)|\[[^\]\n]+\]|\{[^}\n]+\}/.source, a = /\)|\((?![^|()\n]+\))/.source;
      function i(m, h) {
        return RegExp(
          m.replace(/<MOD>/g, function() {
            return "(?:" + r + ")";
          }).replace(/<PAR>/g, function() {
            return "(?:" + a + ")";
          }),
          h || ""
        );
      }
      var s = {
        css: {
          pattern: /\{[^{}]+\}/,
          inside: {
            rest: n.languages.css
          }
        },
        "class-id": {
          pattern: /(\()[^()]+(?=\))/,
          lookbehind: !0,
          alias: "attr-value"
        },
        lang: {
          pattern: /(\[)[^\[\]]+(?=\])/,
          lookbehind: !0,
          alias: "attr-value"
        },
        // Anything else is punctuation (the first pattern is for row/col spans inside tables)
        punctuation: /[\\\/]\d+|\S/
      }, u = n.languages.textile = n.languages.extend("markup", {
        phrase: {
          pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
          lookbehind: !0,
          inside: {
            // h1. Header 1
            "block-tag": {
              pattern: i(/^[a-z]\w*(?:<MOD>|<PAR>|[<>=])*\./.source),
              inside: {
                modifier: {
                  pattern: i(
                    /(^[a-z]\w*)(?:<MOD>|<PAR>|[<>=])+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: s
                },
                tag: /^[a-z]\w*/,
                punctuation: /\.$/
              }
            },
            // # List item
            // * List item
            list: {
              pattern: i(/^[*#]+<MOD>*\s+\S.*/.source, "m"),
              inside: {
                modifier: {
                  pattern: i(/(^[*#]+)<MOD>+/.source),
                  lookbehind: !0,
                  inside: s
                },
                punctuation: /^[*#]+/
              }
            },
            // | cell | cell | cell |
            table: {
              // Modifiers can be applied to the row: {color:red}.|1|2|3|
              // or the cell: |{color:red}.1|2|3|
              pattern: i(
                /^(?:(?:<MOD>|<PAR>|[<>=^~])+\.\s*)?(?:\|(?:(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.|(?!(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+\.))[^|]*)+\|/.source,
                "m"
              ),
              inside: {
                modifier: {
                  // Modifiers for rows after the first one are
                  // preceded by a pipe and a line feed
                  pattern: i(
                    /(^|\|(?:\r?\n|\r)?)(?:<MOD>|<PAR>|[<>=^~_]|[\\/]\d+)+(?=\.)/.source
                  ),
                  lookbehind: !0,
                  inside: s
                },
                punctuation: /\||^\./
              }
            },
            inline: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: i(
                /(^|[^a-zA-Z\d])(\*\*|__|\?\?|[*_%@+\-^~])<MOD>*.+?\2(?![a-zA-Z\d])/.source
              ),
              lookbehind: !0,
              inside: {
                // Note: superscripts and subscripts are not handled specifically
                // *bold*, **bold**
                bold: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^(\*\*?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // _italic_, __italic__
                italic: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^(__?)<MOD>*).+?(?=\2)/.source),
                  lookbehind: !0
                },
                // ??cite??
                cite: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^\?\?<MOD>*).+?(?=\?\?)/.source),
                  lookbehind: !0,
                  alias: "string"
                },
                // @code@
                code: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^@<MOD>*).+?(?=@)/.source),
                  lookbehind: !0,
                  alias: "keyword"
                },
                // +inserted+
                inserted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^\+<MOD>*).+?(?=\+)/.source),
                  lookbehind: !0
                },
                // -deleted-
                deleted: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^-<MOD>*).+?(?=-)/.source),
                  lookbehind: !0
                },
                // %span%
                span: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^%<MOD>*).+?(?=%)/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: i(
                    /(^\*\*|__|\?\?|[*_%@+\-^~])<MOD>+/.source
                  ),
                  lookbehind: !0,
                  inside: s
                },
                punctuation: /[*_%?@+\-^~]+/
              }
            },
            // [alias]http://example.com
            "link-ref": {
              pattern: /^\[[^\]]+\]\S+$/m,
              inside: {
                string: {
                  pattern: /(^\[)[^\]]+(?=\])/,
                  lookbehind: !0
                },
                url: {
                  pattern: /(^\])\S+$/,
                  lookbehind: !0
                },
                punctuation: /[\[\]]/
              }
            },
            // "text":http://example.com
            // "text":link-ref
            link: {
              // eslint-disable-next-line regexp/no-super-linear-backtracking
              pattern: i(
                /"<MOD>*[^"]+":.+?(?=[^\w/]?(?:\s|$))/.source
              ),
              inside: {
                text: {
                  // eslint-disable-next-line regexp/no-super-linear-backtracking
                  pattern: i(/(^"<MOD>*)[^"]+(?=")/.source),
                  lookbehind: !0
                },
                modifier: {
                  pattern: i(/(^")<MOD>+/.source),
                  lookbehind: !0,
                  inside: s
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[":]/
              }
            },
            // !image.jpg!
            // !image.jpg(Title)!:http://example.com
            image: {
              pattern: i(
                /!(?:<MOD>|<PAR>|[<>=])*(?![<>=])[^!\s()]+(?:\([^)]+\))?!(?::.+?(?=[^\w/]?(?:\s|$)))?/.source
              ),
              inside: {
                source: {
                  pattern: i(
                    /(^!(?:<MOD>|<PAR>|[<>=])*)(?![<>=])[^!\s()]+(?:\([^)]+\))?(?=!)/.source
                  ),
                  lookbehind: !0,
                  alias: "url"
                },
                modifier: {
                  pattern: i(/(^!)(?:<MOD>|<PAR>|[<>=])+/.source),
                  lookbehind: !0,
                  inside: s
                },
                url: {
                  pattern: /(:).+/,
                  lookbehind: !0
                },
                punctuation: /[!:]/
              }
            },
            // Footnote[1]
            footnote: {
              pattern: /\b\[\d+\]/,
              alias: "comment",
              inside: {
                punctuation: /\[|\]/
              }
            },
            // CSS(Cascading Style Sheet)
            acronym: {
              pattern: /\b[A-Z\d]+\([^)]+\)/,
              inside: {
                comment: {
                  pattern: /(\()[^()]+(?=\))/,
                  lookbehind: !0
                },
                punctuation: /[()]/
              }
            },
            // Prism(C)
            mark: {
              pattern: /\b\((?:C|R|TM)\)/,
              alias: "comment",
              inside: {
                punctuation: /[()]/
              }
            }
          }
        }
      }), c = u.phrase.inside, d = {
        inline: c.inline,
        link: c.link,
        image: c.image,
        footnote: c.footnote,
        acronym: c.acronym,
        mark: c.mark
      };
      u.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i;
      var p = c.inline.inside;
      p.bold.inside = d, p.italic.inside = d, p.inserted.inside = d, p.deleted.inside = d, p.span.inside = d;
      var f = c.table.inside;
      f.inline = d.inline, f.link = d.link, f.image = d.image, f.footnote = d.footnote, f.acronym = d.acronym, f.mark = d.mark;
    })(t);
  }
  return ib;
}
var ob, LC;
function AX() {
  if (LC) return ob;
  LC = 1, ob = e, e.displayName = "toml", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:[\w-]+|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*")/.source;
      function a(i) {
        return i.replace(/__/g, function() {
          return r;
        });
      }
      n.languages.toml = {
        comment: {
          pattern: /#.*/,
          greedy: !0
        },
        table: {
          pattern: RegExp(
            a(
              /(^[\t ]*\[\s*(?:\[\s*)?)__(?:\s*\.\s*__)*(?=\s*\])/.source
            ),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "class-name"
        },
        key: {
          pattern: RegExp(
            a(/(^[\t ]*|[{,]\s*)__(?:\s*\.\s*__)*(?=\s*=)/.source),
            "m"
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "property"
        },
        string: {
          pattern: /"""(?:\\[\s\S]|[^\\])*?"""|'''[\s\S]*?'''|'[^'\n\r]*'|"(?:\\.|[^\\"\r\n])*"/,
          greedy: !0
        },
        date: [
          {
            // Offset Date-Time, Local Date-Time, Local Date
            pattern: /\b\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/i,
            alias: "number"
          },
          {
            // Local Time
            pattern: /\b\d{2}:\d{2}:\d{2}(?:\.\d+)?\b/,
            alias: "number"
          }
        ],
        number: /(?:\b0(?:x[\da-zA-Z]+(?:_[\da-zA-Z]+)*|o[0-7]+(?:_[0-7]+)*|b[10]+(?:_[10]+)*))\b|[-+]?\b\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?\b|[-+]?\b(?:inf|nan)\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /[.,=[\]{}]/
      };
    })(t);
  }
  return ob;
}
var sb, DC;
function IX() {
  if (DC) return sb;
  DC = 1, sb = e, e.displayName = "tremor", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.tremor = {
        comment: {
          pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
          lookbehind: !0
        },
        "interpolated-string": null,
        // see below
        extractor: {
          pattern: /\b[a-z_]\w*\|(?:[^\r\n\\|]|\\(?:\r\n|[\s\S]))*\|/i,
          greedy: !0,
          inside: {
            regex: {
              pattern: /(^re)\|[\s\S]+/,
              lookbehind: !0
            },
            function: /^\w+/,
            value: /\|[\s\S]+/
          }
        },
        identifier: {
          pattern: /`[^`]*`/,
          greedy: !0
        },
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())\b/,
        keyword: /\b(?:args|as|by|case|config|connect|connector|const|copy|create|default|define|deploy|drop|each|emit|end|erase|event|flow|fn|for|from|group|having|insert|into|intrinsic|let|links|match|merge|mod|move|of|operator|patch|pipeline|recur|script|select|set|sliding|state|stream|to|tumbling|update|use|when|where|window|with)\b/,
        boolean: /\b(?:false|null|true)\b/i,
        number: /\b(?:0b[01_]*|0x[0-9a-fA-F_]*|\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee][+-]?[\d_]+)?)\b/,
        "pattern-punctuation": {
          pattern: /%(?=[({[])/,
          alias: "punctuation"
        },
        operator: /[-+*\/%~!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?>?=?|(?:absent|and|not|or|present|xor)\b/,
        punctuation: /::|[;\[\]()\{\},.:]/
      };
      var r = /#\{(?:[^"{}]|\{[^{}]*\}|"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*")*\}/.source;
      n.languages.tremor["interpolated-string"] = {
        pattern: RegExp(
          /(^|[^\\])/.source + '(?:"""(?:' + /[^"\\#]|\\[\s\S]|"(?!"")|#(?!\{)/.source + "|" + r + ')*"""|"(?:' + /[^"\\\r\n#]|\\(?:\r\n|[\s\S])|#(?!\{)/.source + "|" + r + ')*")'
        ),
        lookbehind: !0,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: RegExp(r),
            inside: {
              punctuation: /^#\{|\}$/,
              expression: {
                pattern: /[\s\S]+/,
                inside: n.languages.tremor
              }
            }
          },
          string: /[\s\S]+/
        }
      }, n.languages.troy = n.languages.tremor, n.languages.trickle = n.languages.tremor;
    })(t);
  }
  return sb;
}
var lb, MC;
function RX() {
  if (MC) return lb;
  MC = 1;
  var e = u1(), t = Uv();
  lb = n, n.displayName = "tsx", n.aliases = [];
  function n(r) {
    r.register(e), r.register(t), function(a) {
      var i = a.util.clone(a.languages.typescript);
      a.languages.tsx = a.languages.extend("jsx", i), delete a.languages.tsx.parameter, delete a.languages.tsx["literal-property"];
      var s = a.languages.tsx.tag;
      s.pattern = RegExp(
        /(^|[^\w$]|(?=<\/))/.source + "(?:" + s.pattern.source + ")",
        s.pattern.flags
      ), s.lookbehind = !0;
    }(r);
  }
  return lb;
}
var ub, FC;
function _X() {
  if (FC) return ub;
  FC = 1;
  var e = Mn();
  ub = t, t.displayName = "tt2", t.aliases = [];
  function t(n) {
    n.register(e), function(r) {
      r.languages.tt2 = r.languages.extend("clike", {
        comment: /#.*|\[%#[\s\S]*?%\]/,
        keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|SWITCH|TAGS|THROW|TRY|UNLESS|USE|WHILE|WRAPPER)\b/,
        punctuation: /[[\]{},()]/
      }), r.languages.insertBefore("tt2", "number", {
        operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|not|or)\b/,
        variable: {
          pattern: /\b[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*\b/i
        }
      }), r.languages.insertBefore("tt2", "keyword", {
        delimiter: {
          pattern: /^(?:\[%|%%)-?|-?%\]$/,
          alias: "punctuation"
        }
      }), r.languages.insertBefore("tt2", "string", {
        "single-quoted-string": {
          pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
          greedy: !0,
          alias: "string"
        },
        "double-quoted-string": {
          pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
          greedy: !0,
          alias: "string",
          inside: {
            variable: {
              pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
            }
          }
        }
      }), delete r.languages.tt2.string, r.hooks.add("before-tokenize", function(a) {
        var i = /\[%[\s\S]+?%\]/g;
        r.languages["markup-templating"].buildPlaceholders(
          a,
          "tt2",
          i
        );
      }), r.hooks.add("after-tokenize", function(a) {
        r.languages["markup-templating"].tokenizePlaceholders(a, "tt2");
      });
    }(n);
  }
  return ub;
}
var cb, PC;
function CX() {
  if (PC) return cb;
  PC = 1;
  var e = Mn();
  cb = t, t.displayName = "twig", t.aliases = [];
  function t(n) {
    n.register(e), n.languages.twig = {
      comment: /^\{#[\s\S]*?#\}$/,
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        }
      },
      keyword: /\b(?:even|if|odd)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    }, n.hooks.add("before-tokenize", function(r) {
      if (r.language === "twig") {
        var a = /\{(?:#[\s\S]*?#|%[\s\S]*?%|\{[\s\S]*?\})\}/g;
        n.languages["markup-templating"].buildPlaceholders(r, "twig", a);
      }
    }), n.hooks.add("after-tokenize", function(r) {
      n.languages["markup-templating"].tokenizePlaceholders(r, "twig");
    });
  }
  return cb;
}
var db, BC;
function kX() {
  if (BC) return db;
  BC = 1, db = e, e.displayName = "typoscript", e.aliases = ["tsconfig"];
  function e(t) {
    (function(n) {
      var r = /\b(?:ACT|ACTIFSUB|CARRAY|CASE|CLEARGIF|COA|COA_INT|CONSTANTS|CONTENT|CUR|EDITPANEL|EFFECT|EXT|FILE|FLUIDTEMPLATE|FORM|FRAME|FRAMESET|GIFBUILDER|GMENU|GMENU_FOLDOUT|GMENU_LAYERS|GP|HMENU|HRULER|HTML|IENV|IFSUB|IMAGE|IMGMENU|IMGMENUITEM|IMGTEXT|IMG_RESOURCE|INCLUDE_TYPOSCRIPT|JSMENU|JSMENUITEM|LLL|LOAD_REGISTER|NO|PAGE|RECORDS|RESTORE_REGISTER|TEMPLATE|TEXT|TMENU|TMENUITEM|TMENU_LAYERS|USER|USER_INT|_GIFBUILDER|global|globalString|globalVar)\b/;
      n.languages.typoscript = {
        comment: [
          {
            // multiline comments /* */
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0
          },
          {
            // double-slash comments - ignored when backslashes or colon is found in front
            // also ignored whenever directly after an equal-sign, because it would probably be an url without protocol
            pattern: /(^|[^\\:= \t]|(?:^|[^= \t])[ \t]+)\/\/.*/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // hash comments - ignored when leading quote is found for hex colors in strings
            pattern: /(^|[^"'])#.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        function: [
          {
            // old include style
            pattern: /<INCLUDE_TYPOSCRIPT:\s*source\s*=\s*(?:"[^"\r\n]*"|'[^'\r\n]*')\s*>/,
            inside: {
              string: {
                pattern: /"[^"\r\n]*"|'[^'\r\n]*'/,
                inside: {
                  keyword: r
                }
              },
              keyword: {
                pattern: /INCLUDE_TYPOSCRIPT/
              }
            }
          },
          {
            // new include style
            pattern: /@import\s*(?:"[^"\r\n]*"|'[^'\r\n]*')/,
            inside: {
              string: /"[^"\r\n]*"|'[^'\r\n]*'/
            }
          }
        ],
        string: {
          pattern: /^([^=]*=[< ]?)(?:(?!\]\n).)*/,
          lookbehind: !0,
          inside: {
            function: /\{\$.*\}/,
            // constants include
            keyword: r,
            number: /^\d+$/,
            punctuation: /[,|:]/
          }
        },
        keyword: r,
        number: {
          // special highlighting for indexes of arrays in tags
          pattern: /\b\d+\s*[.{=]/,
          inside: {
            operator: /[.{=]/
          }
        },
        tag: {
          pattern: /\.?[-\w\\]+\.?/,
          inside: {
            punctuation: /\./
          }
        },
        punctuation: /[{}[\];(),.:|]/,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/
      }, n.languages.tsconfig = n.languages.typoscript;
    })(t);
  }
  return db;
}
var pb, $C;
function NX() {
  if ($C) return pb;
  $C = 1, pb = e, e.displayName = "unrealscript", e.aliases = ["uc", "uscript"];
  function e(t) {
    t.languages.unrealscript = {
      comment: /\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      category: {
        pattern: /(\b(?:(?:autoexpand|hide|show)categories|var)\s*\()[^()]+(?=\))/,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      },
      metadata: {
        pattern: /(\w\s*)<\s*\w+\s*=[^<>|=\r\n]+(?:\|\s*\w+\s*=[^<>|=\r\n]+)*>/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          property: /\b\w+(?=\s*=)/,
          operator: /=/,
          punctuation: /[<>|]/
        }
      },
      macro: {
        pattern: /`\w+/,
        alias: "property"
      },
      "class-name": {
        pattern: /(\b(?:class|enum|extends|interface|state(?:\(\))?|struct|within)\s+)\w+/,
        lookbehind: !0
      },
      keyword: /\b(?:abstract|actor|array|auto|autoexpandcategories|bool|break|byte|case|class|classgroup|client|coerce|collapsecategories|config|const|continue|default|defaultproperties|delegate|dependson|deprecated|do|dontcollapsecategories|editconst|editinlinenew|else|enum|event|exec|export|extends|final|float|for|forcescriptorder|foreach|function|goto|guid|hidecategories|hidedropdown|if|ignores|implements|inherits|input|int|interface|iterator|latent|local|material|name|native|nativereplication|noexport|nontransient|noteditinlinenew|notplaceable|operator|optional|out|pawn|perobjectconfig|perobjectlocalized|placeable|postoperator|preoperator|private|protected|reliable|replication|return|server|showcategories|simulated|singular|state|static|string|struct|structdefault|structdefaultproperties|switch|texture|transient|travel|unreliable|until|var|vector|while|within)\b/,
      function: /\b[a-z_]\w*(?=\s*\()/i,
      boolean: /\b(?:false|true)\b/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      // https://docs.unrealengine.com/udk/Three/UnrealScriptExpressions.html
      operator: />>|<<|--|\+\+|\*\*|[-+*/~!=<>$@]=?|&&?|\|\|?|\^\^?|[?:%]|\b(?:ClockwiseFrom|Cross|Dot)\b/,
      punctuation: /[()[\]{};,.]/
    }, t.languages.uc = t.languages.uscript = t.languages.unrealscript;
  }
  return pb;
}
var fb, UC;
function OX() {
  if (UC) return fb;
  UC = 1, fb = e, e.displayName = "uorazor", e.aliases = [];
  function e(t) {
    t.languages.uorazor = {
      "comment-hash": {
        pattern: /#.*/,
        alias: "comment",
        greedy: !0
      },
      "comment-slash": {
        pattern: /\/\/.*/,
        alias: "comment",
        greedy: !0
      },
      string: {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        inside: {
          punctuation: /^['"]|['"]$/
        },
        greedy: !0
      },
      "source-layers": {
        pattern: /\b(?:arms|backpack|blue|bracelet|cancel|clear|cloak|criminal|earrings|enemy|facialhair|friend|friendly|gloves|gray|grey|ground|hair|head|innerlegs|innertorso|innocent|lefthand|middletorso|murderer|neck|nonfriendly|onehandedsecondary|outerlegs|outertorso|pants|red|righthand|ring|self|shirt|shoes|talisman|waist)\b/i,
        alias: "function"
      },
      "source-commands": {
        pattern: /\b(?:alliance|attack|cast|clearall|clearignore|clearjournal|clearlist|clearsysmsg|createlist|createtimer|dclick|dclicktype|dclickvar|dress|dressconfig|drop|droprelloc|emote|getlabel|guild|gumpclose|gumpresponse|hotkey|ignore|lasttarget|lift|lifttype|menu|menuresponse|msg|org|organize|organizer|overhead|pause|poplist|potion|promptresponse|pushlist|removelist|removetimer|rename|restock|say|scav|scavenger|script|setability|setlasttarget|setskill|settimer|setvar|sysmsg|target|targetloc|targetrelloc|targettype|undress|unignore|unsetvar|useobject|useonce|useskill|usetype|virtue|wait|waitforgump|waitformenu|waitforprompt|waitforstat|waitforsysmsg|waitfortarget|walk|wfsysmsg|wft|whisper|yell)\b/,
        alias: "function"
      },
      "tag-name": {
        pattern: /(^\{%-?\s*)\w+/,
        lookbehind: !0,
        alias: "keyword"
      },
      delimiter: {
        pattern: /^\{[{%]-?|-?[%}]\}$/,
        alias: "punctuation"
      },
      function: /\b(?:atlist|close|closest|count|counter|counttype|dead|dex|diffhits|diffmana|diffstam|diffweight|find|findbuff|finddebuff|findlayer|findtype|findtypelist|followers|gumpexists|hidden|hits|hp|hue|human|humanoid|ingump|inlist|insysmessage|insysmsg|int|invul|lhandempty|list|listexists|mana|maxhits|maxhp|maxmana|maxstam|maxweight|monster|mounted|name|next|noto|paralyzed|poisoned|position|prev|previous|queued|rand|random|rhandempty|skill|stam|str|targetexists|timer|timerexists|varexist|warmode|weight)\b/,
      keyword: /\b(?:and|as|break|continue|else|elseif|endfor|endif|endwhile|for|if|loop|not|or|replay|stop|while)\b/,
      boolean: /\b(?:false|null|true)\b/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      operator: [
        {
          pattern: /(\s)(?:and|b-and|b-or|b-xor|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
          lookbehind: !0
        },
        /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
      ],
      punctuation: /[()\[\]{}:.,]/
    };
  }
  return fb;
}
var gb, jC;
function LX() {
  if (jC) return gb;
  jC = 1, gb = e, e.displayName = "uri", e.aliases = ["url"];
  function e(t) {
    t.languages.uri = {
      scheme: {
        pattern: /^[a-z][a-z0-9+.-]*:/im,
        greedy: !0,
        inside: {
          "scheme-delimiter": /:$/
        }
      },
      fragment: {
        pattern: /#[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "fragment-delimiter": /^#/
        }
      },
      query: {
        pattern: /\?[\w\-.~!$&'()*+,;=%:@/?]*/,
        inside: {
          "query-delimiter": {
            pattern: /^\?/,
            greedy: !0
          },
          "pair-delimiter": /[&;]/,
          pair: {
            pattern: /^[^=][\s\S]*/,
            inside: {
              key: /^[^=]+/,
              value: {
                pattern: /(^=)[\s\S]+/,
                lookbehind: !0
              }
            }
          }
        }
      },
      authority: {
        pattern: RegExp(
          /^\/\//.source + // [ userinfo "@" ]
          /(?:[\w\-.~!$&'()*+,;=%:]*@)?/.source + // host
          ("(?:" + // IP-literal
          /\[(?:[0-9a-fA-F:.]{2,48}|v[0-9a-fA-F]+\.[\w\-.~!$&'()*+,;=]+)\]/.source + "|" + // IPv4address or registered name
          /[\w\-.~!$&'()*+,;=%]*/.source + ")") + // [ ":" port ]
          /(?::\d*)?/.source,
          "m"
        ),
        inside: {
          "authority-delimiter": /^\/\//,
          "user-info-segment": {
            pattern: /^[\w\-.~!$&'()*+,;=%:]*@/,
            inside: {
              "user-info-delimiter": /@$/,
              "user-info": /^[\w\-.~!$&'()*+,;=%:]+/
            }
          },
          "port-segment": {
            pattern: /:\d*$/,
            inside: {
              "port-delimiter": /^:/,
              port: /^\d+/
            }
          },
          host: {
            pattern: /[\s\S]+/,
            inside: {
              "ip-literal": {
                pattern: /^\[[\s\S]+\]$/,
                inside: {
                  "ip-literal-delimiter": /^\[|\]$/,
                  "ipv-future": /^v[\s\S]+/,
                  "ipv6-address": /^[\s\S]+/
                }
              },
              "ipv4-address": /^(?:(?:[03-9]\d?|[12]\d{0,2})\.){3}(?:[03-9]\d?|[12]\d{0,2})$/
            }
          }
        }
      },
      path: {
        pattern: /^[\w\-.~!$&'()*+,;=%:@/]+/m,
        inside: {
          "path-separator": /\//
        }
      }
    }, t.languages.url = t.languages.uri;
  }
  return gb;
}
var mb, qC;
function DX() {
  if (qC) return mb;
  qC = 1, mb = e, e.displayName = "v", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = {
        pattern: /[\s\S]+/,
        inside: null
      };
      n.languages.v = n.languages.extend("clike", {
        string: {
          pattern: /r?(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          alias: "quoted-string",
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:\{[^{}]*\}|\w+(?:\.\w+(?:\([^\(\)]*\))?|\[[^\[\]]+\])*)/,
              lookbehind: !0,
              inside: {
                "interpolation-variable": {
                  pattern: /^\$\w[\s\S]*$/,
                  alias: "variable"
                },
                "interpolation-punctuation": {
                  pattern: /^\$\{|\}$/,
                  alias: "punctuation"
                },
                "interpolation-expression": r
              }
            }
          }
        },
        "class-name": {
          pattern: /(\b(?:enum|interface|struct|type)\s+)(?:C\.)?\w+/,
          lookbehind: !0
        },
        keyword: /(?:\b(?:__global|as|asm|assert|atomic|break|chan|const|continue|defer|else|embed|enum|fn|for|go(?:to)?|if|import|in|interface|is|lock|match|module|mut|none|or|pub|return|rlock|select|shared|sizeof|static|struct|type(?:of)?|union|unsafe)|\$(?:else|for|if)|#(?:flag|include))\b/,
        number: /\b(?:0x[a-f\d]+(?:_[a-f\d]+)*|0b[01]+(?:_[01]+)*|0o[0-7]+(?:_[0-7]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?)\b/i,
        operator: /~|\?|[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\.?/,
        builtin: /\b(?:any(?:_float|_int)?|bool|byte(?:ptr)?|charptr|f(?:32|64)|i(?:8|16|64|128|nt)|rune|size_t|string|u(?:16|32|64|128)|voidptr)\b/
      }), r.inside = n.languages.v, n.languages.insertBefore("v", "string", {
        char: {
          pattern: /`(?:\\`|\\?[^`]{1,2})`/,
          // using {1,2} instead of `u` flag for compatibility
          alias: "rune"
        }
      }), n.languages.insertBefore("v", "operator", {
        attribute: {
          pattern: /(^[\t ]*)\[(?:deprecated|direct_array_access|flag|inline|live|ref_only|typedef|unsafe_fn|windows_stdcall)\]/m,
          lookbehind: !0,
          alias: "annotation",
          inside: {
            punctuation: /[\[\]]/,
            keyword: /\w+/
          }
        },
        generic: {
          pattern: /<\w+>(?=\s*[\)\{])/,
          inside: {
            punctuation: /[<>]/,
            "class-name": /\w+/
          }
        }
      }), n.languages.insertBefore("v", "function", {
        "generic-function": {
          // e.g. foo<T>( ...
          pattern: /\b\w+\s*<\w+>(?=\()/,
          inside: {
            function: /^\w+/,
            generic: {
              pattern: /<\w+>/,
              inside: n.languages.v.generic.inside
            }
          }
        }
      });
    })(t);
  }
  return mb;
}
var hb, zC;
function MX() {
  if (zC) return hb;
  zC = 1, hb = e, e.displayName = "vala", e.aliases = [];
  function e(t) {
    t.languages.vala = t.languages.extend("clike", {
      // Classes copied from prism-csharp
      "class-name": [
        {
          // (Foo bar, Bar baz)
          pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=(?:\?\s+|\*?\s+\*?)\w)/,
          inside: {
            punctuation: /\./
          }
        },
        {
          // [Foo]
          pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo : Bar
          pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        },
        {
          // class Foo
          pattern: /((?:\b(?:class|enum|interface|new|struct)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
          lookbehind: !0,
          inside: {
            punctuation: /\./
          }
        }
      ],
      keyword: /\b(?:abstract|as|assert|async|base|bool|break|case|catch|char|class|const|construct|continue|default|delegate|delete|do|double|dynamic|else|ensures|enum|errordomain|extern|finally|float|for|foreach|get|if|in|inline|int|int16|int32|int64|int8|interface|internal|is|lock|long|namespace|new|null|out|override|owned|params|private|protected|public|ref|requires|return|set|short|signal|sizeof|size_t|ssize_t|static|string|struct|switch|this|throw|throws|try|typeof|uchar|uint|uint16|uint32|uint64|uint8|ulong|unichar|unowned|ushort|using|value|var|virtual|void|volatile|weak|while|yield)\b/i,
      function: /\b\w+(?=\s*\()/,
      number: /(?:\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)(?:f|u?l?)?/i,
      operator: /\+\+|--|&&|\|\||<<=?|>>=?|=>|->|~|[+\-*\/%&^|=!<>]=?|\?\??|\.\.\./,
      punctuation: /[{}[\];(),.:]/,
      constant: /\b[A-Z0-9_]+\b/
    }), t.languages.insertBefore("vala", "string", {
      "raw-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      "template-string": {
        pattern: /@"[\s\S]*?"/,
        greedy: !0,
        inside: {
          interpolation: {
            pattern: /\$(?:\([^)]*\)|[a-zA-Z]\w*)/,
            inside: {
              delimiter: {
                pattern: /^\$\(?|\)$/,
                alias: "punctuation"
              },
              rest: t.languages.vala
            }
          },
          string: /[\s\S]+/
        }
      }
    }), t.languages.insertBefore("vala", "keyword", {
      regex: {
        pattern: /\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[imsx]{0,4}(?=\s*(?:$|[\r\n,.;})\]]))/,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: t.languages.regex
          },
          "regex-delimiter": /^\//,
          "regex-flags": /^[a-z]+$/
        }
      }
    });
  }
  return hb;
}
var bb, GC;
function FX() {
  if (GC) return bb;
  GC = 1, bb = e, e.displayName = "velocity", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.velocity = n.languages.extend("markup", {});
      var r = {
        variable: {
          pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+\])*|\{[^}]+\})/i,
          lookbehind: !0,
          inside: {}
          // See below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        number: /\b\d+\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
        punctuation: /[(){}[\]:,.]/
      };
      r.variable.inside = {
        string: r.string,
        function: {
          pattern: /([^\w-])[a-z][\w-]*(?=\()/,
          lookbehind: !0
        },
        number: r.number,
        boolean: r.boolean,
        punctuation: r.punctuation
      }, n.languages.insertBefore("velocity", "comment", {
        unparsed: {
          pattern: /(^|[^\\])#\[\[[\s\S]*?\]\]#/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^#\[\[|\]\]#$/
          }
        },
        "velocity-comment": [
          {
            pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          },
          {
            pattern: /(^|[^\\])##.*/,
            lookbehind: !0,
            greedy: !0,
            alias: "comment"
          }
        ],
        directive: {
          pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
          lookbehind: !0,
          inside: {
            keyword: {
              pattern: /^#@?(?:[a-z][\w-]*|\{[a-z][\w-]*\})|\bin\b/,
              inside: {
                punctuation: /[{}]/
              }
            },
            rest: r
          }
        },
        variable: r.variable
      }), n.languages.velocity.tag.inside["attr-value"].inside.rest = n.languages.velocity;
    })(t);
  }
  return bb;
}
var yb, HC;
function PX() {
  if (HC) return yb;
  HC = 1, yb = e, e.displayName = "verilog", e.aliases = [];
  function e(t) {
    t.languages.verilog = {
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
        greedy: !0
      },
      string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: !0
      },
      "kernel-function": {
        // support for any kernel function (ex: $display())
        pattern: /\B\$\w+\b/,
        alias: "property"
      },
      // support for user defined constants (ex: `define)
      constant: /\B`\w+\b/,
      function: /\b\w+(?=\()/,
      // support for verilog and system verilog keywords
      keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|case|casex|casez|cell|chandle|class|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endsequence|endspecify|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_ondetect|pulsestyle_onevent|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
      // bold highlighting for all verilog and system verilog logic blocks
      important: /\b(?:always|always_comb|always_ff|always_latch)\b(?: *@)?/,
      // support for time ticks, vectors, and real numbers
      number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b(?:\d*[._])?\d+(?:e[-+]?\d+)?/i,
      operator: /[-+{}^~%*\/?=!<>&|]+/,
      punctuation: /[[\];(),.:]/
    };
  }
  return yb;
}
var vb, VC;
function BX() {
  if (VC) return vb;
  VC = 1, vb = e, e.displayName = "vhdl", e.aliases = [];
  function e(t) {
    t.languages.vhdl = {
      comment: /--.+/,
      // support for all logic vectors
      "vhdl-vectors": {
        pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
        alias: "number"
      },
      // support for operator overloading included
      "quoted-function": {
        pattern: /"\S+?"(?=\()/,
        alias: "function"
      },
      string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
      constant: /\b(?:library|use)\b/i,
      // support for predefined attributes included
      keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
      boolean: /\b(?:false|true)\b/i,
      function: /\w+(?=\()/,
      // decimal, based, physical, and exponential numbers supported
      number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
      operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|and|mod|nand|nor|not|or|rem|rol|ror|sla|sll|sra|srl|xnor|xor)\b/i,
      punctuation: /[{}[\];(),.:]/
    };
  }
  return vb;
}
var Eb, WC;
function $X() {
  if (WC) return Eb;
  WC = 1, Eb = e, e.displayName = "vim", e.aliases = [];
  function e(t) {
    t.languages.vim = {
      string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
      comment: /".*/,
      function: /\b\w+(?=\()/,
      keyword: /\b(?:N|Next|P|Print|X|XMLent|XMLns|ab|abbreviate|abc|abclear|abo|aboveleft|al|all|ar|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|args|argu|argument|as|ascii|b|bN|bNext|ba|bad|badd|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bo|botright|bp|bprevious|br|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|brewind|bro|browse|bufdo|buffer|buffers|bun|bunload|bw|bwipeout|c|cN|cNext|cNfcNfile|ca|cabbrev|cabc|cabclear|cad|caddb|caddbuffer|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cg|cgetb|cgetbuffer|cgete|cgetexpr|cgetfile|change|changes|chd|chdir|che|checkpath|checkt|checktime|cl|cla|clast|clist|clo|close|cmapc|cmapclear|cn|cnew|cnewer|cnext|cnf|cnfile|cnorea|cnoreabbrev|co|col|colder|colo|colorscheme|comc|comclear|comp|compiler|con|conf|confirm|continue|cope|copen|copy|cp|cpf|cpfile|cprevious|cq|cquit|cr|crewind|cu|cuna|cunabbrev|cunmap|cw|cwindow|d|debugg|debuggreedy|delc|delcommand|delete|delf|delfunction|delm|delmarks|di|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|e|earlier|echoe|echoerr|echom|echomsg|echon|edit|el|else|elsei|elseif|em|emenu|en|endf|endfo|endfor|endfun|endfunction|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fin|fina|finally|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|foldd|folddoc|folddoclosed|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|h|ha|hardcopy|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iu|iuna|iunabbrev|iunmap|j|join|ju|jumps|k|kee|keepalt|keepj|keepjumps|keepmarks|l|lN|lNext|lNf|lNfile|la|lad|laddb|laddbuffer|laddexpr|laddf|laddfile|lan|language|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|left|lefta|leftabove|let|lex|lexpr|lf|lfile|lfir|lfirst|lg|lgetb|lgetbuffer|lgete|lgetexpr|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|list|ll|lla|llast|lli|llist|lm|lmak|lmake|lmap|lmapc|lmapclear|ln|lne|lnew|lnewer|lnext|lnf|lnfile|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lp|lpf|lpfile|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|m|ma|mak|make|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkv|mkvie|mkview|mkvimrc|mod|mode|move|mz|mzf|mzfile|mzscheme|n|nbkey|new|next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|o|omapc|omapclear|on|only|open|opt|options|ou|ounmap|p|pc|pclose|pe|ped|pedit|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|print|prof|profd|profdel|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|ptN|ptNext|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|py|pyf|pyfile|python|q|qa|qall|quit|quita|quitall|r|read|rec|recover|red|redi|redir|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|ru|rub|ruby|rubyd|rubydo|rubyf|rubyfile|runtime|rv|rviminfo|sN|sNext|sa|sal|sall|san|sandbox|sargument|sav|saveas|sb|sbN|sbNext|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbp|sbprevious|sbr|sbrewind|sbuffer|scrip|scripte|scriptencoding|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sl|sla|slast|sleep|sm|smagic|smap|smapc|smapclear|sme|smenu|sn|snext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|so|sor|sort|source|sp|spe|spelld|spelldump|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|split|spr|sprevious|sre|srewind|st|sta|stag|star|startg|startgreplace|startinsert|startr|startreplace|stj|stjump|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tN|tNext|ta|tab|tabN|tabNext|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabn|tabnew|tabnext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tmenu|tn|tnext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tunmenu|u|una|unabbreviate|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|ve|verb|verbose|version|vert|vertical|vi|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|w|wN|wNext|wa|wall|wh|while|win|winc|wincmd|windo|winp|winpos|winsize|wn|wnext|wp|wprevious|wq|wqa|wqall|write|ws|wsverb|wv|wviminfo|x|xa|xall|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
      builtin: /\b(?:acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autocmd|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|t_AB|t_AF|t_AL|t_CS|t_CV|t_Ce|t_Co|t_Cs|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_IE|t_IS|t_K1|t_K3|t_K4|t_K5|t_K6|t_K7|t_K8|t_K9|t_KA|t_KB|t_KC|t_KD|t_KE|t_KF|t_KG|t_KH|t_KI|t_KJ|t_KK|t_KL|t_RI|t_RV|t_SI|t_Sb|t_Sf|t_WP|t_WS|t_ZH|t_ZR|t_al|t_bc|t_cd|t_ce|t_cl|t_cm|t_cs|t_da|t_db|t_dl|t_fs|t_k1|t_k2|t_k3|t_k4|t_k5|t_k6|t_k7|t_k8|t_k9|t_kB|t_kD|t_kI|t_kN|t_kP|t_kb|t_kd|t_ke|t_kh|t_kl|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_se|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_xs|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
      operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
      punctuation: /[{}[\](),;:]/
    };
  }
  return Eb;
}
var Sb, KC;
function UX() {
  if (KC) return Sb;
  KC = 1, Sb = e, e.displayName = "visualBasic", e.aliases = [];
  function e(t) {
    t.languages["visual-basic"] = {
      comment: {
        pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i,
        inside: {
          keyword: /^REM/i
        }
      },
      directive: {
        pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i,
        alias: "property",
        greedy: !0
      },
      string: {
        pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
        greedy: !0
      },
      date: {
        pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i,
        alias: "number"
      },
      number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i,
      boolean: /\b(?:False|Nothing|True)\b/i,
      keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
      operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/,
      punctuation: /[{}().,:?]/
    }, t.languages.vb = t.languages["visual-basic"], t.languages.vba = t.languages["visual-basic"];
  }
  return Sb;
}
var xb, YC;
function jX() {
  if (YC) return xb;
  YC = 1, xb = e, e.displayName = "warpscript", e.aliases = [];
  function e(t) {
    t.languages.warpscript = {
      comment: /#.*|\/\/.*|\/\*[\s\S]*?\*\//,
      string: {
        pattern: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'|<'(?:[^\\']|'(?!>)|\\.)*'>/,
        greedy: !0
      },
      variable: /\$\S+/,
      macro: {
        pattern: /@\S+/,
        alias: "property"
      },
      // WarpScript doesn't have any keywords, these are all functions under the control category
      // https://www.warp10.io/tags/control
      keyword: /\b(?:BREAK|CHECKMACRO|CONTINUE|CUDF|DEFINED|DEFINEDMACRO|EVAL|FAIL|FOR|FOREACH|FORSTEP|IFT|IFTE|MSGFAIL|NRETURN|RETHROW|RETURN|SWITCH|TRY|UDF|UNTIL|WHILE)\b/,
      number: /[+-]?\b(?:NaN|Infinity|\d+(?:\.\d*)?(?:[Ee][+-]?\d+)?|0x[\da-fA-F]+|0b[01]+)\b/,
      boolean: /\b(?:F|T|false|true)\b/,
      punctuation: /<%|%>|[{}[\]()]/,
      // Some operators from the "operators" category
      // https://www.warp10.io/tags/operators
      operator: /==|&&?|\|\|?|\*\*?|>>>?|<<|[<>!~]=?|[-/%^]|\+!?|\b(?:AND|NOT|OR)\b/
    };
  }
  return xb;
}
var Tb, XC;
function qX() {
  if (XC) return Tb;
  XC = 1, Tb = e, e.displayName = "wasm", e.aliases = [];
  function e(t) {
    t.languages.wasm = {
      comment: [
        /\(;[\s\S]*?;\)/,
        {
          pattern: /;;.*/,
          greedy: !0
        }
      ],
      string: {
        pattern: /"(?:\\[\s\S]|[^"\\])*"/,
        greedy: !0
      },
      keyword: [
        {
          pattern: /\b(?:align|offset)=/,
          inside: {
            operator: /=/
          }
        },
        {
          pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
          inside: {
            punctuation: /\./
          }
        },
        /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
      ],
      variable: /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
      number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
      punctuation: /[()]/
    };
  }
  return Tb;
}
var wb, ZC;
function zX() {
  if (ZC) return wb;
  ZC = 1, wb = e, e.displayName = "webIdl", e.aliases = [];
  function e(t) {
    (function(n) {
      var r = /(?:\B-|\b_|\b)[A-Za-z][\w-]*(?![\w-])/.source, a = "(?:" + /\b(?:unsigned\s+)?long\s+long(?![\w-])/.source + "|" + /\b(?:unrestricted|unsigned)\s+[a-z]+(?![\w-])/.source + "|" + /(?!(?:unrestricted|unsigned)\b)/.source + r + /(?:\s*<(?:[^<>]|<[^<>]*>)*>)?/.source + ")" + /(?:\s*\?)?/.source, i = {};
      n.languages["web-idl"] = {
        comment: {
          pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
          greedy: !0
        },
        string: {
          pattern: /"[^"]*"/,
          greedy: !0
        },
        namespace: {
          pattern: RegExp(/(\bnamespace\s+)/.source + r),
          lookbehind: !0
        },
        "class-name": [
          {
            pattern: /(^|[^\w-])(?:iterable|maplike|setlike)\s*<(?:[^<>]|<[^<>]*>)*>/,
            lookbehind: !0,
            inside: i
          },
          {
            pattern: RegExp(
              /(\b(?:attribute|const|deleter|getter|optional|setter)\s+)/.source + a
            ),
            lookbehind: !0,
            inside: i
          },
          {
            // callback return type
            pattern: RegExp(
              "(" + /\bcallback\s+/.source + r + /\s*=\s*/.source + ")" + a
            ),
            lookbehind: !0,
            inside: i
          },
          {
            // typedef
            pattern: RegExp(/(\btypedef\b\s*)/.source + a),
            lookbehind: !0,
            inside: i
          },
          {
            pattern: RegExp(
              /(\b(?:callback|dictionary|enum|interface(?:\s+mixin)?)\s+)(?!(?:interface|mixin)\b)/.source + r
            ),
            lookbehind: !0
          },
          {
            // inheritance
            pattern: RegExp(/(:\s*)/.source + r),
            lookbehind: !0
          },
          // includes and implements
          RegExp(r + /(?=\s+(?:implements|includes)\b)/.source),
          {
            pattern: RegExp(/(\b(?:implements|includes)\s+)/.source + r),
            lookbehind: !0
          },
          {
            // function return type, parameter types, and dictionary members
            pattern: RegExp(
              a + "(?=" + /\s*(?:\.{3}\s*)?/.source + r + /\s*[(),;=]/.source + ")"
            ),
            inside: i
          }
        ],
        builtin: /\b(?:ArrayBuffer|BigInt64Array|BigUint64Array|ByteString|DOMString|DataView|Float32Array|Float64Array|FrozenArray|Int16Array|Int32Array|Int8Array|ObservableArray|Promise|USVString|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray)\b/,
        keyword: [
          /\b(?:async|attribute|callback|const|constructor|deleter|dictionary|enum|getter|implements|includes|inherit|interface|mixin|namespace|null|optional|or|partial|readonly|required|setter|static|stringifier|typedef|unrestricted)\b/,
          // type keywords
          /\b(?:any|bigint|boolean|byte|double|float|iterable|long|maplike|object|octet|record|sequence|setlike|short|symbol|undefined|unsigned|void)\b/
        ],
        boolean: /\b(?:false|true)\b/,
        number: {
          pattern: /(^|[^\w-])-?(?:0x[0-9a-f]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|NaN|Infinity)(?![\w-])/i,
          lookbehind: !0
        },
        operator: /\.{3}|[=:?<>-]/,
        punctuation: /[(){}[\].,;]/
      };
      for (var s in n.languages["web-idl"])
        s !== "class-name" && (i[s] = n.languages["web-idl"][s]);
      n.languages.webidl = n.languages["web-idl"];
    })(t);
  }
  return wb;
}
var Ab, JC;
function GX() {
  if (JC) return Ab;
  JC = 1, Ab = e, e.displayName = "wiki", e.aliases = [];
  function e(t) {
    t.languages.wiki = t.languages.extend("markup", {
      "block-comment": {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: !0,
        alias: "comment"
      },
      heading: {
        pattern: /^(=+)[^=\r\n].*?\1/m,
        inside: {
          punctuation: /^=+|=+$/,
          important: /.+/
        }
      },
      emphasis: {
        // TODO Multi-line
        pattern: /('{2,5}).+?\1/,
        inside: {
          "bold-italic": {
            pattern: /(''''').+?(?=\1)/,
            lookbehind: !0,
            alias: ["bold", "italic"]
          },
          bold: {
            pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          italic: {
            pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
            lookbehind: !0
          },
          punctuation: /^''+|''+$/
        }
      },
      hr: {
        pattern: /^-{4,}/m,
        alias: "punctuation"
      },
      url: [
        /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:PMID|RFC) +\d+/i,
        /\[\[.+?\]\]|\[.+?\]/
      ],
      variable: [
        /__[A-Z]+__/,
        // FIXME Nested structures should be handled
        // {{formatnum:{{#expr:{{{3}}}}}}}
        /\{{3}.+?\}{3}/,
        /\{\{.+?\}\}/
      ],
      symbol: [/^#redirect/im, /~{3,5}/],
      // Handle table attrs:
      // {|
      // ! style="text-align:left;"| Item
      // |}
      "table-tag": {
        pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
        lookbehind: !0,
        inside: {
          "table-bar": {
            pattern: /\|$/,
            alias: "punctuation"
          },
          rest: t.languages.markup.tag.inside
        }
      },
      punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
    }), t.languages.insertBefore("wiki", "tag", {
      // Prevent highlighting inside <nowiki>, <source> and <pre> tags
      nowiki: {
        pattern: /<(nowiki|pre|source)\b[^>]*>[\s\S]*?<\/\1>/i,
        inside: {
          tag: {
            pattern: /<(?:nowiki|pre|source)\b[^>]*>|<\/(?:nowiki|pre|source)>/i,
            inside: t.languages.markup.tag.inside
          }
        }
      }
    });
  }
  return Ab;
}
var Ib, QC;
function HX() {
  if (QC) return Ib;
  QC = 1, Ib = e, e.displayName = "wolfram", e.aliases = ["mathematica", "wl", "nb"];
  function e(t) {
    t.languages.wolfram = {
      // Allow one level of nesting - note: regex taken from applescipt
      comment: /\(\*(?:\(\*(?:[^*]|\*(?!\)))*\*\)|(?!\(\*)[\s\S])*?\*\)/,
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: !0
      },
      keyword: /\b(?:Abs|AbsArg|Accuracy|Block|Do|For|Function|If|Manipulate|Module|Nest|NestList|None|Return|Switch|Table|Which|While)\b/,
      context: {
        pattern: /\b\w+`+\w*/,
        alias: "class-name"
      },
      blank: {
        pattern: /\b\w+_\b/,
        alias: "regex"
      },
      "global-variable": {
        pattern: /\$\w+/,
        alias: "variable"
      },
      boolean: /\b(?:False|True)\b/,
      number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
      operator: /\/\.|;|=\.|\^=|\^:=|:=|<<|>>|<\||\|>|:>|\|->|->|<-|@@@|@@|@|\/@|=!=|===|==|=|\+|-|\^|\[\/-+%=\]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
      punctuation: /[{}[\];(),.:]/
    }, t.languages.mathematica = t.languages.wolfram, t.languages.wl = t.languages.wolfram, t.languages.nb = t.languages.wolfram;
  }
  return Ib;
}
var Rb, ek;
function VX() {
  if (ek) return Rb;
  ek = 1, Rb = e, e.displayName = "wren", e.aliases = [];
  function e(t) {
    t.languages.wren = {
      // Multiline comments in Wren can have nested multiline comments
      // Comments: // and /* */
      comment: [
        {
          // support 3 levels of nesting
          // regex: \/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\/
          pattern: /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|\/\*(?:[^*/]|\*(?!\/)|\/(?!\*))*\*\/)*\*\/)*\*\//,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      // Triple quoted strings are multiline but cannot have interpolation (raw strings)
      // Based on prism-python.js
      "triple-quoted-string": {
        pattern: /"""[\s\S]*?"""/,
        greedy: !0,
        alias: "string"
      },
      // see below
      "string-literal": null,
      // #!/usr/bin/env wren on the first line
      hashbang: {
        pattern: /^#!\/.+/,
        greedy: !0,
        alias: "comment"
      },
      // Attributes are special keywords to add meta data to classes
      attribute: {
        // #! attributes are stored in class properties
        // #!myvar = true
        // #attributes are not stored and dismissed at compilation
        pattern: /#!?[ \t\u3000]*\w+/,
        alias: "keyword"
      },
      "class-name": [
        {
          // class definition
          // class Meta {}
          pattern: /(\bclass\s+)\w+/,
          lookbehind: !0
        },
        // A class must always start with an uppercase.
        // File.read
        /\b[A-Z][a-z\d_]*\b/
      ],
      // A constant can be a variable, class, property or method. Just named in all uppercase letters
      constant: /\b[A-Z][A-Z\d_]*\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      },
      keyword: /\b(?:as|break|class|construct|continue|else|for|foreign|if|import|in|is|return|static|super|this|var|while)\b/,
      boolean: /\b(?:false|true)\b/,
      number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
      // Functions can be Class.method()
      function: /\b[a-z_]\w*(?=\s*[({])/i,
      operator: /<<|>>|[=!<>]=?|&&|\|\||[-+*/%~^&|?:]|\.{2,3}/,
      punctuation: /[\[\](){}.,;]/
    }, t.languages.wren["string-literal"] = {
      // A single quote string is multiline and can have interpolation (similar to JS backticks ``)
      pattern: /(^|[^\\"])"(?:[^\\"%]|\\[\s\S]|%(?!\()|%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\))*"/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          // "%(interpolation)"
          pattern: /((?:^|[^\\])(?:\\{2})*)%\((?:[^()]|\((?:[^()]|\([^)]*\))*\))*\)/,
          lookbehind: !0,
          inside: {
            expression: {
              pattern: /^(%\()[\s\S]+(?=\)$)/,
              lookbehind: !0,
              inside: t.languages.wren
            },
            "interpolation-punctuation": {
              pattern: /^%\(|\)$/,
              alias: "punctuation"
            }
          }
        },
        string: /[\s\S]+/
      }
    };
  }
  return Rb;
}
var _b, tk;
function WX() {
  if (tk) return _b;
  tk = 1, _b = e, e.displayName = "xeora", e.aliases = ["xeoracube"];
  function e(t) {
    (function(n) {
      n.languages.xeora = n.languages.extend("markup", {
        constant: {
          pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
          inside: {
            punctuation: {
              pattern: /\$/
            }
          }
        },
        variable: {
          pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[$.]/
            },
            operator: {
              pattern: /#+|[-+*~=^@]/
            }
          }
        },
        "function-inline": {
          pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\$/,
          inside: {
            variable: {
              pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
              inside: {
                punctuation: {
                  pattern: /[,.|]/
                },
                operator: {
                  pattern: /#+|[-+*~=^@]/
                }
              }
            },
            punctuation: {
              pattern: /\$\w:|[$:?.,|]/
            }
          },
          alias: "function"
        },
        "function-block": {
          pattern: /\$XF:\{[-\w.]+\?[-\w.]+(?:,(?:(?:@[-#]*\w+\.[\w+.]\.*)*\|)*(?:(?:[\w+]|[-#*.~^]+[\w+]|=\S)(?:[^$=]|=+[^=])*=*|(?:@[-#]*\w+\.[\w+.]\.*)+(?:(?:[\w+]|[-#*~^][-#*.~^]*[\w+]|=\S)(?:[^$=]|=+[^=])*=*)?)?)?\}:XF\$/,
          inside: {
            punctuation: {
              pattern: /[$:{}?.,|]/
            }
          },
          alias: "function"
        },
        "directive-inline": {
          pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\/\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            }
          },
          alias: "function"
        },
        "directive-block-open": {
          pattern: /\$\w+:\{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+\])?:[-\w.]+:\{(?:![A-Z]+)?/,
          inside: {
            punctuation: {
              pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
              inside: {
                tag: {
                  pattern: /#\d/
                }
              }
            },
            attribute: {
              pattern: /![A-Z]+$/,
              inside: {
                punctuation: {
                  pattern: /!/
                }
              },
              alias: "keyword"
            }
          },
          alias: "function"
        },
        "directive-block-separator": {
          pattern: /\}:[-\w.]+:\{/,
          inside: {
            punctuation: {
              pattern: /[:{}]/
            }
          },
          alias: "function"
        },
        "directive-block-close": {
          pattern: /\}:[-\w.]+\$/,
          inside: {
            punctuation: {
              pattern: /[:{}$]/
            }
          },
          alias: "function"
        }
      }), n.languages.insertBefore(
        "inside",
        "punctuation",
        {
          variable: n.languages.xeora["function-inline"].inside.variable
        },
        n.languages.xeora["function-block"]
      ), n.languages.xeoracube = n.languages.xeora;
    })(t);
  }
  return _b;
}
var Cb, nk;
function KX() {
  if (nk) return Cb;
  nk = 1, Cb = e, e.displayName = "xmlDoc", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(u, c) {
        n.languages[u] && n.languages.insertBefore(u, "comment", {
          "doc-comment": c
        });
      }
      var a = n.languages.markup.tag, i = {
        pattern: /\/\/\/.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: a
        }
      }, s = {
        pattern: /'''.*/,
        greedy: !0,
        alias: "comment",
        inside: {
          tag: a
        }
      };
      r("csharp", i), r("fsharp", i), r("vbnet", s);
    })(t);
  }
  return Cb;
}
var kb, rk;
function YX() {
  if (rk) return kb;
  rk = 1, kb = e, e.displayName = "xojo", e.aliases = [];
  function e(t) {
    t.languages.xojo = {
      comment: {
        pattern: /(?:'|\/\/|Rem\b).+/i,
        greedy: !0
      },
      string: {
        pattern: /"(?:""|[^"])*"/,
        greedy: !0
      },
      number: [/(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
      directive: {
        pattern: /#(?:Else|ElseIf|Endif|If|Pragma)\b/i,
        alias: "property"
      },
      keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|Auto|Boolean|Break|By(?:Ref|Val)|Byte|Call|Case|Catch|CFStringRef|CGFloat|Class|Color|Const|Continue|CString|Currency|CurrentMethodName|Declare|Delegate|Dim|Do(?:uble|wnTo)?|Each|Else(?:If)?|End|Enumeration|Event|Exception|Exit|Extends|False|Finally|For|Function|Get|GetTypeInfo|Global|GOTO|If|Implements|In|Inherits|Int(?:8|16|32|64|eger|erface)?|Lib|Loop|Me|Module|Next|Nil|Object|Optional|OSType|ParamArray|Private|Property|Protected|PString|Ptr|Raise(?:Event)?|ReDim|RemoveHandler|Return|Select(?:or)?|Self|Set|Shared|Short|Single|Soft|Static|Step|String|Sub|Super|Text|Then|To|True|Try|Ubound|UInt(?:8|16|32|64|eger)?|Until|Using|Var(?:iant)?|Wend|While|WindowPtr|WString)\b/i,
      operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|WeakAddressOf|Xor)\b/i,
      punctuation: /[.,;:()]/
    };
  }
  return kb;
}
var Nb, ak;
function XX() {
  if (ak) return Nb;
  ak = 1, Nb = e, e.displayName = "xquery", e.aliases = [];
  function e(t) {
    (function(n) {
      n.languages.xquery = n.languages.extend("markup", {
        "xquery-comment": {
          pattern: /\(:[\s\S]*?:\)/,
          greedy: !0,
          alias: "comment"
        },
        string: {
          pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
          greedy: !0
        },
        extension: {
          pattern: /\(#.+?#\)/,
          alias: "symbol"
        },
        variable: /\$[-\w:]+/,
        axis: {
          pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
          lookbehind: !0,
          alias: "operator"
        },
        "keyword-operator": {
          pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
          lookbehind: !0,
          alias: "operator"
        },
        keyword: {
          pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
          lookbehind: !0
        },
        function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
        "xquery-element": {
          pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "tag"
        },
        "xquery-attribute": {
          pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
          lookbehind: !0,
          alias: "attr-name"
        },
        builtin: {
          pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:ENTITIES|ENTITY|ID|IDREFS?|NCName|NMTOKENS?|NOTATION|Name|QName|anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|int|integer|language|long|negativeInteger|nonNegativeInteger|nonPositiveInteger|normalizedString|positiveInteger|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
          lookbehind: !0
        },
        number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
        operator: [
          /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
          {
            pattern: /(\s)-(?=\s)/,
            lookbehind: !0
          }
        ],
        punctuation: /[[\](){},;:/]/
      }), n.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/, n.languages.xquery.tag.inside["attr-value"].pattern = /=(?:("|')(?:\\[\s\S]|\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}|(?!\1)[^\\])*\1|[^\s'">=]+)/, n.languages.xquery.tag.inside["attr-value"].inside.punctuation = /^="|"$/, n.languages.xquery.tag.inside["attr-value"].inside.expression = {
        // Allow for two levels of nesting
        pattern: /\{(?!\{)(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])+\}/,
        inside: n.languages.xquery,
        alias: "language-xquery"
      };
      var r = function(i) {
        return typeof i == "string" ? i : typeof i.content == "string" ? i.content : i.content.map(r).join("");
      }, a = function(i) {
        for (var s = [], u = 0; u < i.length; u++) {
          var c = i[u], d = !1;
          if (typeof c != "string" && (c.type === "tag" && c.content[0] && c.content[0].type === "tag" ? c.content[0].content[0].content === "</" ? s.length > 0 && s[s.length - 1].tagName === r(c.content[0].content[1]) && s.pop() : c.content[c.content.length - 1].content === "/>" || s.push({
            tagName: r(c.content[0].content[1]),
            openedBraces: 0
          }) : s.length > 0 && c.type === "punctuation" && c.content === "{" && // Ignore `{{`
          (!i[u + 1] || i[u + 1].type !== "punctuation" || i[u + 1].content !== "{") && (!i[u - 1] || i[u - 1].type !== "plain-text" || i[u - 1].content !== "{") ? s[s.length - 1].openedBraces++ : s.length > 0 && s[s.length - 1].openedBraces > 0 && c.type === "punctuation" && c.content === "}" ? s[s.length - 1].openedBraces-- : c.type !== "comment" && (d = !0)), (d || typeof c == "string") && s.length > 0 && s[s.length - 1].openedBraces === 0) {
            var p = r(c);
            u < i.length - 1 && (typeof i[u + 1] == "string" || i[u + 1].type === "plain-text") && (p += r(i[u + 1]), i.splice(u + 1, 1)), u > 0 && (typeof i[u - 1] == "string" || i[u - 1].type === "plain-text") && (p = r(i[u - 1]) + p, i.splice(u - 1, 1), u--), /^\s+$/.test(p) ? i[u] = p : i[u] = new n.Token(
              "plain-text",
              p,
              null,
              p
            );
          }
          c.content && typeof c.content != "string" && a(c.content);
        }
      };
      n.hooks.add("after-tokenize", function(i) {
        i.language === "xquery" && a(i.tokens);
      });
    })(t);
  }
  return Nb;
}
var Ob, ik;
function ZX() {
  if (ik) return Ob;
  ik = 1, Ob = e, e.displayName = "yang", e.aliases = [];
  function e(t) {
    t.languages.yang = {
      // https://tools.ietf.org/html/rfc6020#page-34
      // http://www.yang-central.org/twiki/bin/view/Main/YangExamples
      comment: /\/\*[\s\S]*?\*\/|\/\/.*/,
      string: {
        pattern: /"(?:[^\\"]|\\.)*"|'[^']*'/,
        greedy: !0
      },
      keyword: {
        pattern: /(^|[{};\r\n][ \t]*)[a-z_][\w.-]*/i,
        lookbehind: !0
      },
      namespace: {
        pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
        lookbehind: !0
      },
      boolean: /\b(?:false|true)\b/,
      operator: /\+/,
      punctuation: /[{};:]/
    };
  }
  return Ob;
}
var Lb, ok;
function JX() {
  if (ok) return Lb;
  ok = 1, Lb = e, e.displayName = "zig", e.aliases = [];
  function e(t) {
    (function(n) {
      function r(p) {
        return function() {
          return p;
        };
      }
      var a = /\b(?:align|allowzero|and|anyframe|anytype|asm|async|await|break|cancel|catch|comptime|const|continue|defer|else|enum|errdefer|error|export|extern|fn|for|if|inline|linksection|nakedcc|noalias|nosuspend|null|or|orelse|packed|promise|pub|resume|return|stdcallcc|struct|suspend|switch|test|threadlocal|try|undefined|union|unreachable|usingnamespace|var|volatile|while)\b/, i = "\\b(?!" + a.source + ")(?!\\d)\\w+\\b", s = /align\s*\((?:[^()]|\([^()]*\))*\)/.source, u = /(?:\?|\bpromise->|(?:\[[^[\]]*\]|\*(?!\*)|\*\*)(?:\s*<ALIGN>|\s*const\b|\s*volatile\b|\s*allowzero\b)*)/.source.replace(
        /<ALIGN>/g,
        r(s)
      ), c = /(?:\bpromise\b|(?:\berror\.)?<ID>(?:\.<ID>)*(?!\s+<ID>))/.source.replace(
        /<ID>/g,
        r(i)
      ), d = "(?!\\s)(?:!?\\s*(?:" + u + "\\s*)*" + c + ")+";
      n.languages.zig = {
        comment: [
          {
            pattern: /\/\/[/!].*/,
            alias: "doc-comment"
          },
          /\/{2}.*/
        ],
        string: [
          {
            // "string" and c"string"
            pattern: /(^|[^\\@])c?"(?:[^"\\\r\n]|\\.)*"/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // multiline strings and c-strings
            pattern: /([\r\n])([ \t]+c?\\{2}).*(?:(?:\r\n?|\n)\2.*)*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        char: {
          // characters 'a', '\n', '\xFF', '\u{10FFFF}'
          pattern: /(^|[^\\])'(?:[^'\\\r\n]|[\uD800-\uDFFF]{2}|\\(?:.|x[a-fA-F\d]{2}|u\{[a-fA-F\d]{1,6}\}))'/,
          lookbehind: !0,
          greedy: !0
        },
        builtin: /\B@(?!\d)\w+(?=\s*\()/,
        label: {
          pattern: /(\b(?:break|continue)\s*:\s*)\w+\b|\b(?!\d)\w+\b(?=\s*:\s*(?:\{|while\b))/,
          lookbehind: !0
        },
        "class-name": [
          // const Foo = struct {};
          /\b(?!\d)\w+(?=\s*=\s*(?:(?:extern|packed)\s+)?(?:enum|struct|union)\s*[({])/,
          {
            // const x: i32 = 9;
            // var x: Bar;
            // fn foo(x: bool, y: f32) void {}
            pattern: RegExp(
              /(:\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?[=;,)])|<TYPE>(?=\s*(?:<ALIGN>\s*)?\{)/.source.replace(/<TYPE>/g, r(d)).replace(/<ALIGN>/g, r(s))
            ),
            lookbehind: !0,
            inside: null
            // see below
          },
          {
            // extern fn foo(x: f64) f64; (optional alignment)
            pattern: RegExp(
              /(\)\s*)<TYPE>(?=\s*(?:<ALIGN>\s*)?;)/.source.replace(/<TYPE>/g, r(d)).replace(/<ALIGN>/g, r(s))
            ),
            lookbehind: !0,
            inside: null
            // see below
          }
        ],
        "builtin-type": {
          pattern: /\b(?:anyerror|bool|c_u?(?:int|long|longlong|short)|c_longdouble|c_void|comptime_(?:float|int)|f(?:16|32|64|128)|[iu](?:8|16|32|64|128|size)|noreturn|type|void)\b/,
          alias: "keyword"
        },
        keyword: a,
        function: /\b(?!\d)\w+(?=\s*\()/,
        number: /\b(?:0b[01]+|0o[0-7]+|0x[a-fA-F\d]+(?:\.[a-fA-F\d]*)?(?:[pP][+-]?[a-fA-F\d]+)?|\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)\b/,
        boolean: /\b(?:false|true)\b/,
        operator: /\.[*?]|\.{2,3}|[-=]>|\*\*|\+\+|\|\||(?:<<|>>|[-+*]%|[-+*/%^&|<>!=])=?|[?~]/,
        punctuation: /[.:,;(){}[\]]/
      }, n.languages.zig["class-name"].forEach(function(p) {
        p.inside === null && (p.inside = n.languages.zig);
      });
    })(t);
  }
  return Lb;
}
var Db, sk;
function QX() {
  if (sk) return Db;
  sk = 1;
  var e = mK();
  return Db = e, e.register(bK()), e.register(yK()), e.register(vK()), e.register(EK()), e.register(SK()), e.register(xK()), e.register(TK()), e.register(wK()), e.register(AK()), e.register(IK()), e.register(RK()), e.register(_K()), e.register(CK()), e.register(kK()), e.register(NK()), e.register(OK()), e.register(LK()), e.register(DK()), e.register(MK()), e.register(FK()), e.register(PK()), e.register(BK()), e.register(o1()), e.register(s1()), e.register($K()), e.register(UK()), e.register(jK()), e.register(qK()), e.register(zK()), e.register(GK()), e.register(HK()), e.register(VK()), e.register(WK()), e.register(KK()), e.register(Ri()), e.register(YK()), e.register(XK()), e.register(ZK()), e.register(JK()), e.register(QK()), e.register(eY()), e.register(tY()), e.register(nY()), e.register(rY()), e.register(Pv()), e.register(aY()), e.register(cc()), e.register(iY()), e.register(oY()), e.register(sY()), e.register(lY()), e.register(uY()), e.register(cY()), e.register(dY()), e.register(pY()), e.register(fY()), e.register(gY()), e.register(mY()), e.register(hY()), e.register(bY()), e.register(yY()), e.register(vY()), e.register(EY()), e.register(SY()), e.register(xY()), e.register(TY()), e.register(wY()), e.register(AY()), e.register(IY()), e.register(RY()), e.register(_Y()), e.register(CY()), e.register(kY()), e.register(NY()), e.register(OY()), e.register(LY()), e.register(DY()), e.register(MY()), e.register(FY()), e.register(PY()), e.register(BY()), e.register($Y()), e.register(UY()), e.register(jY()), e.register(qY()), e.register(zY()), e.register(GY()), e.register(HY()), e.register(VY()), e.register(WY()), e.register(KY()), e.register(YY()), e.register(XY()), e.register(ZY()), e.register(Bv()), e.register(JY()), e.register(QY()), e.register(e8()), e.register(t8()), e.register(n8()), e.register(r8()), e.register(a8()), e.register(i8()), e.register(o8()), e.register(s8()), e.register(l8()), e.register(u8()), e.register(c8()), e.register(d8()), e.register(p8()), e.register(f8()), e.register(g8()), e.register($v()), e.register(m8()), e.register(pc()), e.register(h8()), e.register(b8()), e.register(y8()), e.register(v8()), e.register(E8()), e.register(S8()), e.register(x8()), e.register(jv()), e.register(T8()), e.register(w8()), e.register(A8()), e.register(u1()), e.register(I8()), e.register(R8()), e.register(_8()), e.register(C8()), e.register(k8()), e.register(N8()), e.register(O8()), e.register(L8()), e.register(D8()), e.register(M8()), e.register(F8()), e.register(P8()), e.register(B8()), e.register($8()), e.register(U8()), e.register(j8()), e.register(l1()), e.register(q8()), e.register(z8()), e.register(G8()), e.register(Mn()), e.register(H8()), e.register(V8()), e.register(W8()), e.register(K8()), e.register(Y8()), e.register(X8()), e.register(Z8()), e.register(J8()), e.register(Q8()), e.register(e7()), e.register(t7()), e.register(n7()), e.register(r7()), e.register(a7()), e.register(i7()), e.register(o7()), e.register(s7()), e.register(l7()), e.register(u7()), e.register(c7()), e.register(d7()), e.register(p7()), e.register(f7()), e.register(g7()), e.register(m7()), e.register(h7()), e.register(b7()), e.register(y7()), e.register(v7()), e.register(E7()), e.register(S7()), e.register(x7()), e.register(fc()), e.register(T7()), e.register(w7()), e.register(A7()), e.register(I7()), e.register(R7()), e.register(_7()), e.register(C7()), e.register(k7()), e.register(N7()), e.register(O7()), e.register(L7()), e.register(D7()), e.register(M7()), e.register(F7()), e.register(P7()), e.register(B7()), e.register($7()), e.register(U7()), e.register(j7()), e.register(q7()), e.register(z7()), e.register(G7()), e.register(H7()), e.register(V7()), e.register(W7()), e.register(K7()), e.register(Y7()), e.register(X7()), e.register(Z7()), e.register(J7()), e.register(dc()), e.register(Q7()), e.register(eX()), e.register(tX()), e.register(nX()), e.register(qv()), e.register(rX()), e.register(aX()), e.register(iX()), e.register(oX()), e.register(sX()), e.register(lX()), e.register(uX()), e.register(cX()), e.register(dX()), e.register(pX()), e.register(fX()), e.register(gX()), e.register(Fv()), e.register(mX()), e.register(hX()), e.register(bX()), e.register(yX()), e.register(vX()), e.register(EX()), e.register(zv()), e.register(SX()), e.register(xX()), e.register(TX()), e.register(wX()), e.register(AX()), e.register(IX()), e.register(RX()), e.register(_X()), e.register(c1()), e.register(CX()), e.register(Uv()), e.register(kX()), e.register(NX()), e.register(OX()), e.register(LX()), e.register(DX()), e.register(MX()), e.register(d1()), e.register(FX()), e.register(PX()), e.register(BX()), e.register($X()), e.register(UX()), e.register(jX()), e.register(qX()), e.register(zX()), e.register(GX()), e.register(HX()), e.register(VX()), e.register(WX()), e.register(KX()), e.register(YX()), e.register(XX()), e.register(p1()), e.register(ZX()), e.register(JX()), Db;
}
var eZ = QX();
const tZ = /* @__PURE__ */ Cu(eZ);
var f1 = jW(tZ, hK);
f1.supportedLanguages = qW;
const nZ = {
  'code[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#eee",
    background: "#2f2f2f",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#eee",
    background: "#2f2f2f",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    overflow: "auto",
    position: "relative",
    margin: "0.5em 0",
    padding: "1.25em 1em"
  },
  'code[class*="language-"]::-moz-selection': {
    background: "#363636"
  },
  'pre[class*="language-"]::-moz-selection': {
    background: "#363636"
  },
  'code[class*="language-"] ::-moz-selection': {
    background: "#363636"
  },
  'pre[class*="language-"] ::-moz-selection': {
    background: "#363636"
  },
  'code[class*="language-"]::selection': {
    background: "#363636"
  },
  'pre[class*="language-"]::selection': {
    background: "#363636"
  },
  'code[class*="language-"] ::selection': {
    background: "#363636"
  },
  'pre[class*="language-"] ::selection': {
    background: "#363636"
  },
  ':not(pre) > code[class*="language-"]': {
    whiteSpace: "normal",
    borderRadius: "0.2em",
    padding: "0.1em"
  },
  ".language-css > code": {
    color: "#fd9170"
  },
  ".language-sass > code": {
    color: "#fd9170"
  },
  ".language-scss > code": {
    color: "#fd9170"
  },
  '[class*="language-"] .namespace': {
    Opacity: "0.7"
  },
  atrule: {
    color: "#c792ea"
  },
  "attr-name": {
    color: "#ffcb6b"
  },
  "attr-value": {
    color: "#a5e844"
  },
  attribute: {
    color: "#a5e844"
  },
  boolean: {
    color: "#c792ea"
  },
  builtin: {
    color: "#ffcb6b"
  },
  cdata: {
    color: "#80cbc4"
  },
  char: {
    color: "#80cbc4"
  },
  class: {
    color: "#ffcb6b"
  },
  "class-name": {
    color: "#f2ff00"
  },
  comment: {
    color: "#616161"
  },
  constant: {
    color: "#c792ea"
  },
  deleted: {
    color: "#ff6666"
  },
  doctype: {
    color: "#616161"
  },
  entity: {
    color: "#ff6666"
  },
  function: {
    color: "#c792ea"
  },
  hexcode: {
    color: "#f2ff00"
  },
  id: {
    color: "#c792ea",
    fontWeight: "bold"
  },
  important: {
    color: "#c792ea",
    fontWeight: "bold"
  },
  inserted: {
    color: "#80cbc4"
  },
  keyword: {
    color: "#c792ea"
  },
  number: {
    color: "#fd9170"
  },
  operator: {
    color: "#89ddff"
  },
  prolog: {
    color: "#616161"
  },
  property: {
    color: "#80cbc4"
  },
  "pseudo-class": {
    color: "#a5e844"
  },
  "pseudo-element": {
    color: "#a5e844"
  },
  punctuation: {
    color: "#89ddff"
  },
  regex: {
    color: "#f2ff00"
  },
  selector: {
    color: "#ff6666"
  },
  string: {
    color: "#a5e844"
  },
  symbol: {
    color: "#c792ea"
  },
  tag: {
    color: "#ff6666"
  },
  unit: {
    color: "#fd9170"
  },
  url: {
    color: "#ff6666"
  },
  variable: {
    color: "#ff6666"
  }
}, rZ = {
  'code[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#90a4ae",
    background: "#fafafa",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    color: "#90a4ae",
    background: "#fafafa",
    fontFamily: "Roboto Mono, monospace",
    fontSize: "1em",
    lineHeight: "1.5em",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    overflow: "auto",
    position: "relative",
    margin: "0.5em 0",
    padding: "1.25em 1em"
  },
  'code[class*="language-"]::-moz-selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'pre[class*="language-"]::-moz-selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'code[class*="language-"] ::-moz-selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'pre[class*="language-"] ::-moz-selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'code[class*="language-"]::selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'pre[class*="language-"]::selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'code[class*="language-"] ::selection': {
    background: "#cceae7",
    color: "#263238"
  },
  'pre[class*="language-"] ::selection': {
    background: "#cceae7",
    color: "#263238"
  },
  ':not(pre) > code[class*="language-"]': {
    whiteSpace: "normal",
    borderRadius: "0.2em",
    padding: "0.1em"
  },
  ".language-css > code": {
    color: "#f76d47"
  },
  ".language-sass > code": {
    color: "#f76d47"
  },
  ".language-scss > code": {
    color: "#f76d47"
  },
  '[class*="language-"] .namespace': {
    Opacity: "0.7"
  },
  atrule: {
    color: "#7c4dff"
  },
  "attr-name": {
    color: "#39adb5"
  },
  "attr-value": {
    color: "#f6a434"
  },
  attribute: {
    color: "#f6a434"
  },
  boolean: {
    color: "#7c4dff"
  },
  builtin: {
    color: "#39adb5"
  },
  cdata: {
    color: "#39adb5"
  },
  char: {
    color: "#39adb5"
  },
  class: {
    color: "#39adb5"
  },
  "class-name": {
    color: "#6182b8"
  },
  comment: {
    color: "#aabfc9"
  },
  constant: {
    color: "#7c4dff"
  },
  deleted: {
    color: "#e53935"
  },
  doctype: {
    color: "#aabfc9"
  },
  entity: {
    color: "#e53935"
  },
  function: {
    color: "#7c4dff"
  },
  hexcode: {
    color: "#f76d47"
  },
  id: {
    color: "#7c4dff",
    fontWeight: "bold"
  },
  important: {
    color: "#7c4dff",
    fontWeight: "bold"
  },
  inserted: {
    color: "#39adb5"
  },
  keyword: {
    color: "#7c4dff"
  },
  number: {
    color: "#f76d47"
  },
  operator: {
    color: "#39adb5"
  },
  prolog: {
    color: "#aabfc9"
  },
  property: {
    color: "#39adb5"
  },
  "pseudo-class": {
    color: "#f6a434"
  },
  "pseudo-element": {
    color: "#f6a434"
  },
  punctuation: {
    color: "#39adb5"
  },
  regex: {
    color: "#6182b8"
  },
  selector: {
    color: "#e53935"
  },
  string: {
    color: "#f6a434"
  },
  symbol: {
    color: "#7c4dff"
  },
  tag: {
    color: "#e53935"
  },
  unit: {
    color: "#f76d47"
  },
  url: {
    color: "#e53935"
  },
  variable: {
    color: "#e53935"
  }
};
function aZ(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const iZ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, oZ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, sZ = {};
function lk(e, t) {
  return (sZ.jsx ? oZ : iZ).test(e);
}
const lZ = /[ \t\n\f\r]/g;
function uZ(e) {
  return typeof e == "object" ? e.type === "text" ? uk(e.value) : !1 : uk(e);
}
function uk(e) {
  return e.replace(lZ, "") === "";
}
class Fs {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Fs.prototype.normal = {};
Fs.prototype.property = {};
Fs.prototype.space = void 0;
function g1(e, t) {
  const n = {}, r = {};
  for (const a of e)
    Object.assign(n, a.property), Object.assign(r, a.normal);
  return new Fs(n, r, t);
}
function _y(e) {
  return e.toLowerCase();
}
let Fn = class {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
};
Fn.prototype.attribute = "";
Fn.prototype.booleanish = !1;
Fn.prototype.boolean = !1;
Fn.prototype.commaOrSpaceSeparated = !1;
Fn.prototype.commaSeparated = !1;
Fn.prototype.defined = !1;
Fn.prototype.mustUseProperty = !1;
Fn.prototype.number = !1;
Fn.prototype.overloadedBoolean = !1;
Fn.prototype.property = "";
Fn.prototype.spaceSeparated = !1;
Fn.prototype.space = void 0;
let cZ = 0;
const Oe = _i(), Vt = _i(), m1 = _i(), oe = _i(), gt = _i(), co = _i(), Vn = _i();
function _i() {
  return 2 ** ++cZ;
}
const Cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Oe,
  booleanish: Vt,
  commaOrSpaceSeparated: Vn,
  commaSeparated: co,
  number: oe,
  overloadedBoolean: m1,
  spaceSeparated: gt
}, Symbol.toStringTag, { value: "Module" })), Mb = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Cy)
);
class Gv extends Fn {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, a) {
    let i = -1;
    if (super(t, n), ck(this, "space", a), typeof r == "number")
      for (; ++i < Mb.length; ) {
        const s = Mb[i];
        ck(this, Mb[i], (r & Cy[s]) === Cy[s]);
      }
  }
}
Gv.prototype.defined = !0;
function ck(e, t, n) {
  n && (e[t] = n);
}
function To(e) {
  const t = {}, n = {};
  for (const [r, a] of Object.entries(e.properties)) {
    const i = new Gv(
      r,
      e.transform(e.attributes || {}, r),
      a,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[_y(r)] = r, n[_y(i.attribute)] = r;
  }
  return new Fs(t, n, e.space);
}
const h1 = To({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Vt,
    ariaAutoComplete: null,
    ariaBusy: Vt,
    ariaChecked: Vt,
    ariaColCount: oe,
    ariaColIndex: oe,
    ariaColSpan: oe,
    ariaControls: gt,
    ariaCurrent: null,
    ariaDescribedBy: gt,
    ariaDetails: null,
    ariaDisabled: Vt,
    ariaDropEffect: gt,
    ariaErrorMessage: null,
    ariaExpanded: Vt,
    ariaFlowTo: gt,
    ariaGrabbed: Vt,
    ariaHasPopup: null,
    ariaHidden: Vt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: gt,
    ariaLevel: oe,
    ariaLive: null,
    ariaModal: Vt,
    ariaMultiLine: Vt,
    ariaMultiSelectable: Vt,
    ariaOrientation: null,
    ariaOwns: gt,
    ariaPlaceholder: null,
    ariaPosInSet: oe,
    ariaPressed: Vt,
    ariaReadOnly: Vt,
    ariaRelevant: null,
    ariaRequired: Vt,
    ariaRoleDescription: gt,
    ariaRowCount: oe,
    ariaRowIndex: oe,
    ariaRowSpan: oe,
    ariaSelected: Vt,
    ariaSetSize: oe,
    ariaSort: null,
    ariaValueMax: oe,
    ariaValueMin: oe,
    ariaValueNow: oe,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function b1(e, t) {
  return t in e ? e[t] : t;
}
function y1(e, t) {
  return b1(e, t.toLowerCase());
}
const dZ = To({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: co,
    acceptCharset: gt,
    accessKey: gt,
    action: null,
    allow: null,
    allowFullScreen: Oe,
    allowPaymentRequest: Oe,
    allowUserMedia: Oe,
    alt: null,
    as: null,
    async: Oe,
    autoCapitalize: null,
    autoComplete: gt,
    autoFocus: Oe,
    autoPlay: Oe,
    blocking: gt,
    capture: null,
    charSet: null,
    checked: Oe,
    cite: null,
    className: gt,
    cols: oe,
    colSpan: null,
    content: null,
    contentEditable: Vt,
    controls: Oe,
    controlsList: gt,
    coords: oe | co,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Oe,
    defer: Oe,
    dir: null,
    dirName: null,
    disabled: Oe,
    download: m1,
    draggable: Vt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Oe,
    formTarget: null,
    headers: gt,
    height: oe,
    hidden: Oe,
    high: oe,
    href: null,
    hrefLang: null,
    htmlFor: gt,
    httpEquiv: gt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Oe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Oe,
    itemId: null,
    itemProp: gt,
    itemRef: gt,
    itemScope: Oe,
    itemType: gt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Oe,
    low: oe,
    manifest: null,
    max: null,
    maxLength: oe,
    media: null,
    method: null,
    min: null,
    minLength: oe,
    multiple: Oe,
    muted: Oe,
    name: null,
    nonce: null,
    noModule: Oe,
    noValidate: Oe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Oe,
    optimum: oe,
    pattern: null,
    ping: gt,
    placeholder: null,
    playsInline: Oe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Oe,
    referrerPolicy: null,
    rel: gt,
    required: Oe,
    reversed: Oe,
    rows: oe,
    rowSpan: oe,
    sandbox: gt,
    scope: null,
    scoped: Oe,
    seamless: Oe,
    selected: Oe,
    shadowRootClonable: Oe,
    shadowRootDelegatesFocus: Oe,
    shadowRootMode: null,
    shape: null,
    size: oe,
    sizes: null,
    slot: null,
    span: oe,
    spellCheck: Vt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: oe,
    step: null,
    style: null,
    tabIndex: oe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Oe,
    useMap: null,
    value: Vt,
    width: oe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: gt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: oe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: oe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Oe,
    // Lists. Use CSS to reduce space between items instead
    declare: Oe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: oe,
    // `<img>` and `<object>`
    leftMargin: oe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: oe,
    // `<body>`
    marginWidth: oe,
    // `<body>`
    noResize: Oe,
    // `<frame>`
    noHref: Oe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Oe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Oe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: oe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Vt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: oe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: oe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Oe,
    disableRemotePlayback: Oe,
    prefix: null,
    property: null,
    results: oe,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: y1
}), pZ = To({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Vn,
    accentHeight: oe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: oe,
    amplitude: oe,
    arabicForm: null,
    ascent: oe,
    attributeName: null,
    attributeType: null,
    azimuth: oe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: oe,
    by: null,
    calcMode: null,
    capHeight: oe,
    className: gt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: oe,
    diffuseConstant: oe,
    direction: null,
    display: null,
    dur: null,
    divisor: oe,
    dominantBaseline: null,
    download: Oe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: oe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: oe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: oe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: co,
    g2: co,
    glyphName: co,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: oe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: oe,
    horizOriginX: oe,
    horizOriginY: oe,
    id: null,
    ideographic: oe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: oe,
    k: oe,
    k1: oe,
    k2: oe,
    k3: oe,
    k4: oe,
    kernelMatrix: Vn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: oe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: oe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: oe,
    overlineThickness: oe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: oe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: gt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: oe,
    pointsAtY: oe,
    pointsAtZ: oe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Vn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Vn,
    rev: Vn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Vn,
    requiredFeatures: Vn,
    requiredFonts: Vn,
    requiredFormats: Vn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: oe,
    specularExponent: oe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: oe,
    strikethroughThickness: oe,
    string: null,
    stroke: null,
    strokeDashArray: Vn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: oe,
    strokeOpacity: oe,
    strokeWidth: null,
    style: null,
    surfaceScale: oe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Vn,
    tabIndex: oe,
    tableValues: null,
    target: null,
    targetX: oe,
    targetY: oe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Vn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: oe,
    underlineThickness: oe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: oe,
    values: null,
    vAlphabetic: oe,
    vMathematical: oe,
    vectorEffect: null,
    vHanging: oe,
    vIdeographic: oe,
    version: null,
    vertAdvY: oe,
    vertOriginX: oe,
    vertOriginY: oe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: oe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: b1
}), v1 = To({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), E1 = To({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: y1
}), S1 = To({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), fZ = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, gZ = /[A-Z]/g, dk = /-[a-z]/g, mZ = /^data[-\w.:]+$/i;
function hZ(e, t) {
  const n = _y(t);
  let r = t, a = Fn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && mZ.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(dk, yZ);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!dk.test(i)) {
        let s = i.replace(gZ, bZ);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    a = Gv;
  }
  return new a(r, t);
}
function bZ(e) {
  return "-" + e.toLowerCase();
}
function yZ(e) {
  return e.charAt(1).toUpperCase();
}
const vZ = g1([h1, dZ, v1, E1, S1], "html"), Hv = g1([h1, pZ, v1, E1, S1], "svg");
function EZ(e) {
  return e.join(" ").trim();
}
var Xi = {}, Fb, pk;
function SZ() {
  if (pk) return Fb;
  pk = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, i = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, u = /^\s+|\s+$/g, c = `
`, d = "/", p = "*", f = "", m = "comment", h = "declaration";
  Fb = function(y, w) {
    if (typeof y != "string")
      throw new TypeError("First argument must be a string");
    if (!y) return [];
    w = w || {};
    var x = 1, I = 1;
    function S(G) {
      var H = G.match(t);
      H && (x += H.length);
      var ne = G.lastIndexOf(c);
      I = ~ne ? G.length - ne : I + G.length;
    }
    function C() {
      var G = { line: x, column: I };
      return function(H) {
        return H.position = new T(G), U(), H;
      };
    }
    function T(G) {
      this.start = G, this.end = { line: x, column: I }, this.source = w.source;
    }
    T.prototype.content = y;
    function A(G) {
      var H = new Error(
        w.source + ":" + x + ":" + I + ": " + G
      );
      if (H.reason = G, H.filename = w.source, H.line = x, H.column = I, H.source = y, !w.silent) throw H;
    }
    function O(G) {
      var H = G.exec(y);
      if (H) {
        var ne = H[0];
        return S(ne), y = y.slice(ne.length), H;
      }
    }
    function U() {
      O(n);
    }
    function P(G) {
      var H;
      for (G = G || []; H = b(); )
        H !== !1 && G.push(H);
      return G;
    }
    function b() {
      var G = C();
      if (!(d != y.charAt(0) || p != y.charAt(1))) {
        for (var H = 2; f != y.charAt(H) && (p != y.charAt(H) || d != y.charAt(H + 1)); )
          ++H;
        if (H += 2, f === y.charAt(H - 1))
          return A("End of comment missing");
        var ne = y.slice(2, H - 2);
        return I += 2, S(ne), y = y.slice(H), I += 2, G({
          type: m,
          comment: ne
        });
      }
    }
    function L() {
      var G = C(), H = O(r);
      if (H) {
        if (b(), !O(a)) return A("property missing ':'");
        var ne = O(i), ue = G({
          type: h,
          property: E(H[0].replace(e, f)),
          value: ne ? E(ne[0].replace(e, f)) : f
        });
        return O(s), ue;
      }
    }
    function j() {
      var G = [];
      P(G);
      for (var H; H = L(); )
        H !== !1 && (G.push(H), P(G));
      return G;
    }
    return U(), j();
  };
  function E(y) {
    return y ? y.replace(u, f) : f;
  }
  return Fb;
}
var fk;
function xZ() {
  if (fk) return Xi;
  fk = 1;
  var e = Xi && Xi.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Xi, "__esModule", { value: !0 }), Xi.default = n;
  var t = e(SZ());
  function n(r, a) {
    var i = null;
    if (!r || typeof r != "string")
      return i;
    var s = (0, t.default)(r), u = typeof a == "function";
    return s.forEach(function(c) {
      if (c.type === "declaration") {
        var d = c.property, p = c.value;
        u ? a(d, p, c) : p && (i = i || {}, i[d] = p);
      }
    }), i;
  }
  return Xi;
}
var TZ = xZ();
const gk = /* @__PURE__ */ Cu(TZ), wZ = gk.default || gk, x1 = T1("end"), Vv = T1("start");
function T1(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function AZ(e) {
  const t = Vv(e), n = x1(e);
  if (t && n)
    return { start: t, end: n };
}
function ls(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? mk(e.position) : "start" in e || "end" in e ? mk(e) : "line" in e || "column" in e ? ky(e) : "";
}
function ky(e) {
  return hk(e && e.line) + ":" + hk(e && e.column);
}
function mk(e) {
  return ky(e && e.start) + "-" + ky(e && e.end);
}
function hk(e) {
  return e && typeof e == "number" ? e : 1;
}
class mn extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let a = "", i = {}, s = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? a = t : !i.cause && t && (s = !0, a = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? i.ruleId = r : (i.source = r.slice(0, c), i.ruleId = r.slice(c + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const c = i.ancestors[i.ancestors.length - 1];
      c && (i.place = c.position);
    }
    const u = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = u ? u.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = u ? u.line : void 0, this.name = ls(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = s && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
mn.prototype.file = "";
mn.prototype.name = "";
mn.prototype.reason = "";
mn.prototype.message = "";
mn.prototype.stack = "";
mn.prototype.column = void 0;
mn.prototype.line = void 0;
mn.prototype.ancestors = void 0;
mn.prototype.cause = void 0;
mn.prototype.fatal = void 0;
mn.prototype.place = void 0;
mn.prototype.ruleId = void 0;
mn.prototype.source = void 0;
const Wv = {}.hasOwnProperty, IZ = /* @__PURE__ */ new Map(), RZ = /[A-Z]/g, _Z = /-([a-z])/g, CZ = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), kZ = /* @__PURE__ */ new Set(["td", "th"]), w1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function NZ(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = $Z(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = BZ(n, t.jsx, t.jsxs);
  }
  const a = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Hv : vZ,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = A1(a, e, void 0);
  return i && typeof i != "string" ? i : a.create(
    e,
    a.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function A1(e, t, n) {
  if (t.type === "element")
    return OZ(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return LZ(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return MZ(e, t, n);
  if (t.type === "mdxjsEsm")
    return DZ(e, t);
  if (t.type === "root")
    return FZ(e, t, n);
  if (t.type === "text")
    return PZ(e, t);
}
function OZ(e, t, n) {
  const r = e.schema;
  let a = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (a = Hv, e.schema = a), e.ancestors.push(t);
  const i = R1(e, t.tagName, !1), s = UZ(e, t);
  let u = Yv(e, t);
  return CZ.has(t.tagName) && (u = u.filter(function(c) {
    return typeof c == "string" ? !uZ(c) : !0;
  })), I1(e, s, i, t), Kv(s, u), e.ancestors.pop(), e.schema = r, e.create(t, i, s, n);
}
function LZ(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  xs(e, t.position);
}
function DZ(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  xs(e, t.position);
}
function MZ(e, t, n) {
  const r = e.schema;
  let a = r;
  t.name === "svg" && r.space === "html" && (a = Hv, e.schema = a), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : R1(e, t.name, !0), s = jZ(e, t), u = Yv(e, t);
  return I1(e, s, i, t), Kv(s, u), e.ancestors.pop(), e.schema = r, e.create(t, i, s, n);
}
function FZ(e, t, n) {
  const r = {};
  return Kv(r, Yv(e, t)), e.create(t, e.Fragment, r, n);
}
function PZ(e, t) {
  return t.value;
}
function I1(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Kv(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function BZ(e, t, n) {
  return r;
  function r(a, i, s, u) {
    const d = Array.isArray(s.children) ? n : t;
    return u ? d(i, s, u) : d(i, s);
  }
}
function $Z(e, t) {
  return n;
  function n(r, a, i, s) {
    const u = Array.isArray(i.children), c = Vv(r);
    return t(
      a,
      i,
      s,
      u,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function UZ(e, t) {
  const n = {};
  let r, a;
  for (a in t.properties)
    if (a !== "children" && Wv.call(t.properties, a)) {
      const i = qZ(e, a, t.properties[a]);
      if (i) {
        const [s, u] = i;
        e.tableCellAlignToStyle && s === "align" && typeof u == "string" && kZ.has(t.tagName) ? r = u : n[s] = u;
      }
    }
  if (r) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function jZ(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const s = i.expression;
        s.type;
        const u = s.properties[0];
        u.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(u.argument)
        );
      } else
        xs(e, t.position);
    else {
      const a = r.name;
      let i;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const u = r.value.data.estree.body[0];
          u.type, i = e.evaluater.evaluateExpression(u.expression);
        } else
          xs(e, t.position);
      else
        i = r.value === null ? !0 : r.value;
      n[a] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function Yv(e, t) {
  const n = [];
  let r = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : IZ;
  for (; ++r < t.children.length; ) {
    const i = t.children[r];
    let s;
    if (e.passKeys) {
      const c = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (c) {
        const d = a.get(c) || 0;
        s = c + "-" + d, a.set(c, d + 1);
      }
    }
    const u = A1(e, i, s);
    u !== void 0 && n.push(u);
  }
  return n;
}
function qZ(e, t, n) {
  const r = hZ(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? aZ(n) : EZ(n)), r.property === "style") {
      let a = typeof n == "object" ? n : zZ(e, String(n));
      return e.stylePropertyNameCase === "css" && (a = GZ(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? fZ[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function zZ(e, t) {
  const n = {};
  try {
    wZ(t, r);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const i = (
        /** @type {Error} */
        a
      ), s = new mn("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: i,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = w1 + "#cannot-parse-style-attribute", s;
    }
  }
  return n;
  function r(a, i) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(_Z, VZ)), n[s] = i;
  }
}
function R1(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const a = t.split(".");
    let i = -1, s;
    for (; ++i < a.length; ) {
      const u = lk(a[i]) ? { type: "Identifier", name: a[i] } : { type: "Literal", value: a[i] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: u,
        computed: !!(i && u.type === "Literal"),
        optional: !1
      } : u;
    }
    r = s;
  } else
    r = lk(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const a = (
      /** @type {PropertyKey} */
      r.value
    );
    return Wv.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  xs(e);
}
function xs(e, t) {
  const n = new mn(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = w1 + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function GZ(e) {
  const t = {};
  let n;
  for (n in e)
    Wv.call(e, n) && (t[HZ(n)] = e[n]);
  return t;
}
function HZ(e) {
  let t = e.replace(RZ, WZ);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function VZ(e, t) {
  return t.toUpperCase();
}
function WZ(e) {
  return "-" + e.toLowerCase();
}
const Pb = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, KZ = {};
function YZ(e, t) {
  const n = KZ, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, a = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return _1(e, r, a);
}
function _1(e, t, n) {
  if (XZ(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return bk(e.children, t, n);
  }
  return Array.isArray(e) ? bk(e, t, n) : "";
}
function bk(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length; )
    r[a] = _1(e[a], t, n);
  return r.join("");
}
function XZ(e) {
  return !!(e && typeof e == "object");
}
const yk = document.createElement("i");
function Xv(e) {
  const t = "&" + e + ";";
  yk.innerHTML = t;
  const n = yk.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Qr(e, t, n, r) {
  const a = e.length;
  let i = 0, s;
  if (t < 0 ? t = -t > a ? 0 : a + t : t = t > a ? a : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); i < r.length; )
      s = r.slice(i, i + 1e4), s.unshift(t, 0), e.splice(...s), i += 1e4, t += 1e4;
}
function vr(e, t) {
  return e.length > 0 ? (Qr(e, e.length, 0, t), e) : t;
}
const vk = {}.hasOwnProperty;
function ZZ(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    JZ(t, e[n]);
  return t;
}
function JZ(e, t) {
  let n;
  for (n in t) {
    const a = (vk.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let s;
    if (i)
      for (s in i) {
        vk.call(a, s) || (a[s] = []);
        const u = i[s];
        QZ(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(u) ? u : u ? [u] : []
        );
      }
  }
}
function QZ(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Qr(e, 0, 0, r);
}
function C1(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function po(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Xr = Xa(/[A-Za-z]/), Yn = Xa(/[\dA-Za-z]/), eJ = Xa(/[#-'*+\--9=?A-Z^-~]/);
function Ny(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Oy = Xa(/\d/), tJ = Xa(/[\dA-Fa-f]/), nJ = Xa(/[!-/:-@[-`{-~]/);
function Ce(e) {
  return e !== null && e < -2;
}
function Nn(e) {
  return e !== null && (e < 0 || e === 32);
}
function Xe(e) {
  return e === -2 || e === -1 || e === 32;
}
const rJ = Xa(/\p{P}|\p{S}/u), aJ = Xa(/\s/);
function Xa(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function wo(e) {
  const t = [];
  let n = -1, r = 0, a = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let s = "";
    if (i === 37 && Yn(e.charCodeAt(n + 1)) && Yn(e.charCodeAt(n + 2)))
      a = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (s = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const u = e.charCodeAt(n + 1);
      i < 56320 && u > 56319 && u < 57344 ? (s = String.fromCharCode(i, u), a = 1) : s = "�";
    } else
      s = String.fromCharCode(i);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + a + 1, s = ""), a && (n += a, a = 0);
  }
  return t.join("") + e.slice(r);
}
function mt(e, t, n, r) {
  const a = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return s;
  function s(c) {
    return Xe(c) ? (e.enter(n), u(c)) : t(c);
  }
  function u(c) {
    return Xe(c) && i++ < a ? (e.consume(c), u) : (e.exit(n), t(c));
  }
}
const iJ = {
  tokenize: oJ
};
function oJ(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, a);
  let n;
  return t;
  function r(u) {
    if (u === null) {
      e.consume(u);
      return;
    }
    return e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), mt(e, t, "linePrefix");
  }
  function a(u) {
    return e.enter("paragraph"), i(u);
  }
  function i(u) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, s(u);
  }
  function s(u) {
    if (u === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(u);
      return;
    }
    return Ce(u) ? (e.consume(u), e.exit("chunkText"), i) : (e.consume(u), s);
  }
}
const sJ = {
  tokenize: lJ
}, Ek = {
  tokenize: uJ
};
function lJ(e) {
  const t = this, n = [];
  let r = 0, a, i, s;
  return u;
  function u(S) {
    if (r < n.length) {
      const C = n[r];
      return t.containerState = C[1], e.attempt(C[0].continuation, c, d)(S);
    }
    return d(S);
  }
  function c(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, a && I();
      const C = t.events.length;
      let T = C, A;
      for (; T--; )
        if (t.events[T][0] === "exit" && t.events[T][1].type === "chunkFlow") {
          A = t.events[T][1].end;
          break;
        }
      x(r);
      let O = C;
      for (; O < t.events.length; )
        t.events[O][1].end = {
          ...A
        }, O++;
      return Qr(t.events, T + 1, 0, t.events.slice(C)), t.events.length = O, d(S);
    }
    return u(S);
  }
  function d(S) {
    if (r === n.length) {
      if (!a)
        return m(S);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return E(S);
      t.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Ek, p, f)(S);
  }
  function p(S) {
    return a && I(), x(r), m(S);
  }
  function f(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, E(S);
  }
  function m(S) {
    return t.containerState = {}, e.attempt(Ek, h, E)(S);
  }
  function h(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(S);
  }
  function E(S) {
    if (S === null) {
      a && I(), x(0), e.consume(S);
      return;
    }
    return a = a || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: i
    }), y(S);
  }
  function y(S) {
    if (S === null) {
      w(e.exit("chunkFlow"), !0), x(0), e.consume(S);
      return;
    }
    return Ce(S) ? (e.consume(S), w(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, u) : (e.consume(S), y);
  }
  function w(S, C) {
    const T = t.sliceStream(S);
    if (C && T.push(null), S.previous = i, i && (i.next = S), i = S, a.defineSkip(S.start), a.write(T), t.parser.lazy[S.start.line]) {
      let A = a.events.length;
      for (; A--; )
        if (
          // The token starts before the line ending…
          a.events[A][1].start.offset < s && // …and either is not ended yet…
          (!a.events[A][1].end || // …or ends after it.
          a.events[A][1].end.offset > s)
        )
          return;
      const O = t.events.length;
      let U = O, P, b;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          if (P) {
            b = t.events[U][1].end;
            break;
          }
          P = !0;
        }
      for (x(r), A = O; A < t.events.length; )
        t.events[A][1].end = {
          ...b
        }, A++;
      Qr(t.events, U + 1, 0, t.events.slice(O)), t.events.length = A;
    }
  }
  function x(S) {
    let C = n.length;
    for (; C-- > S; ) {
      const T = n[C];
      t.containerState = T[1], T[0].exit.call(t, e);
    }
    n.length = S;
  }
  function I() {
    a.write([null]), i = void 0, a = void 0, t.containerState._closeFlow = void 0;
  }
}
function uJ(e, t, n) {
  return mt(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Sk(e) {
  if (e === null || Nn(e) || aJ(e))
    return 1;
  if (rJ(e))
    return 2;
}
function Zv(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const i = e[a].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const Ly = {
  name: "attention",
  resolveAll: cJ,
  tokenize: dJ
};
function cJ(e, t) {
  let n = -1, r, a, i, s, u, c, d, p;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, m = {
            ...e[n][1].start
          };
          xk(f, -c), xk(m, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, u = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, i = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, a = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...u.end
            }
          }, e[r][1].end = {
            ...s.start
          }, e[n][1].start = {
            ...u.end
          }, d = [], e[r][1].end.offset - e[r][1].start.offset && (d = vr(d, [["enter", e[r][1], t], ["exit", e[r][1], t]])), d = vr(d, [["enter", a, t], ["enter", s, t], ["exit", s, t], ["enter", i, t]]), d = vr(d, Zv(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), d = vr(d, [["exit", i, t], ["enter", u, t], ["exit", u, t], ["exit", a, t]]), e[n][1].end.offset - e[n][1].start.offset ? (p = 2, d = vr(d, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : p = 0, Qr(e, r - 1, n - r + 3, d), n = r + d.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function dJ(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, a = Sk(r);
  let i;
  return s;
  function s(c) {
    return i = c, e.enter("attentionSequence"), u(c);
  }
  function u(c) {
    if (c === i)
      return e.consume(c), u;
    const d = e.exit("attentionSequence"), p = Sk(c), f = !p || p === 2 && a || n.includes(c), m = !a || a === 2 && p || n.includes(r);
    return d._open = !!(i === 42 ? f : f && (a || !m)), d._close = !!(i === 42 ? m : m && (p || !f)), t(c);
  }
}
function xk(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const pJ = {
  name: "autolink",
  tokenize: fJ
};
function fJ(e, t, n) {
  let r = 0;
  return a;
  function a(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(h) {
    return Xr(h) ? (e.consume(h), s) : h === 64 ? n(h) : d(h);
  }
  function s(h) {
    return h === 43 || h === 45 || h === 46 || Yn(h) ? (r = 1, u(h)) : d(h);
  }
  function u(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Yn(h)) && r++ < 32 ? (e.consume(h), u) : (r = 0, d(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || Ny(h) ? n(h) : (e.consume(h), c);
  }
  function d(h) {
    return h === 64 ? (e.consume(h), p) : eJ(h) ? (e.consume(h), d) : n(h);
  }
  function p(h) {
    return Yn(h) ? f(h) : n(h);
  }
  function f(h) {
    return h === 46 ? (e.consume(h), r = 0, p) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(h);
  }
  function m(h) {
    if ((h === 45 || Yn(h)) && r++ < 63) {
      const E = h === 45 ? m : f;
      return e.consume(h), E;
    }
    return n(h);
  }
}
const gc = {
  partial: !0,
  tokenize: gJ
};
function gJ(e, t, n) {
  return r;
  function r(i) {
    return Xe(i) ? mt(e, a, "linePrefix")(i) : a(i);
  }
  function a(i) {
    return i === null || Ce(i) ? t(i) : n(i);
  }
}
const k1 = {
  continuation: {
    tokenize: hJ
  },
  exit: bJ,
  name: "blockQuote",
  tokenize: mJ
};
function mJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    if (s === 62) {
      const u = r.containerState;
      return u.open || (e.enter("blockQuote", {
        _container: !0
      }), u.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), i;
    }
    return n(s);
  }
  function i(s) {
    return Xe(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function hJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return Xe(s) ? mt(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : i(s);
  }
  function i(s) {
    return e.attempt(k1, t, n)(s);
  }
}
function bJ(e) {
  e.exit("blockQuote");
}
const N1 = {
  name: "characterEscape",
  tokenize: yJ
};
function yJ(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), a;
  }
  function a(i) {
    return nJ(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const O1 = {
  name: "characterReference",
  tokenize: vJ
};
function vJ(e, t, n) {
  const r = this;
  let a = 0, i, s;
  return u;
  function u(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), d) : (e.enter("characterReferenceValue"), i = 31, s = Yn, p(f));
  }
  function d(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, s = tJ, p) : (e.enter("characterReferenceValue"), i = 7, s = Oy, p(f));
  }
  function p(f) {
    if (f === 59 && a) {
      const m = e.exit("characterReferenceValue");
      return s === Yn && !Xv(r.sliceSerialize(m)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(f) && a++ < i ? (e.consume(f), p) : n(f);
  }
}
const Tk = {
  partial: !0,
  tokenize: SJ
}, wk = {
  concrete: !0,
  name: "codeFenced",
  tokenize: EJ
};
function EJ(e, t, n) {
  const r = this, a = {
    partial: !0,
    tokenize: T
  };
  let i = 0, s = 0, u;
  return c;
  function c(A) {
    return d(A);
  }
  function d(A) {
    const O = r.events[r.events.length - 1];
    return i = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, u = A, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(A);
  }
  function p(A) {
    return A === u ? (s++, e.consume(A), p) : s < 3 ? n(A) : (e.exit("codeFencedFenceSequence"), Xe(A) ? mt(e, f, "whitespace")(A) : f(A));
  }
  function f(A) {
    return A === null || Ce(A) ? (e.exit("codeFencedFence"), r.interrupt ? t(A) : e.check(Tk, y, C)(A)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(A));
  }
  function m(A) {
    return A === null || Ce(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(A)) : Xe(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), mt(e, h, "whitespace")(A)) : A === 96 && A === u ? n(A) : (e.consume(A), m);
  }
  function h(A) {
    return A === null || Ce(A) ? f(A) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), E(A));
  }
  function E(A) {
    return A === null || Ce(A) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(A)) : A === 96 && A === u ? n(A) : (e.consume(A), E);
  }
  function y(A) {
    return e.attempt(a, C, w)(A);
  }
  function w(A) {
    return e.enter("lineEnding"), e.consume(A), e.exit("lineEnding"), x;
  }
  function x(A) {
    return i > 0 && Xe(A) ? mt(e, I, "linePrefix", i + 1)(A) : I(A);
  }
  function I(A) {
    return A === null || Ce(A) ? e.check(Tk, y, C)(A) : (e.enter("codeFlowValue"), S(A));
  }
  function S(A) {
    return A === null || Ce(A) ? (e.exit("codeFlowValue"), I(A)) : (e.consume(A), S);
  }
  function C(A) {
    return e.exit("codeFenced"), t(A);
  }
  function T(A, O, U) {
    let P = 0;
    return b;
    function b(ne) {
      return A.enter("lineEnding"), A.consume(ne), A.exit("lineEnding"), L;
    }
    function L(ne) {
      return A.enter("codeFencedFence"), Xe(ne) ? mt(A, j, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : j(ne);
    }
    function j(ne) {
      return ne === u ? (A.enter("codeFencedFenceSequence"), G(ne)) : U(ne);
    }
    function G(ne) {
      return ne === u ? (P++, A.consume(ne), G) : P >= s ? (A.exit("codeFencedFenceSequence"), Xe(ne) ? mt(A, H, "whitespace")(ne) : H(ne)) : U(ne);
    }
    function H(ne) {
      return ne === null || Ce(ne) ? (A.exit("codeFencedFence"), O(ne)) : U(ne);
    }
  }
}
function SJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i);
  }
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Bb = {
  name: "codeIndented",
  tokenize: TJ
}, xJ = {
  partial: !0,
  tokenize: wJ
};
function TJ(e, t, n) {
  const r = this;
  return a;
  function a(d) {
    return e.enter("codeIndented"), mt(e, i, "linePrefix", 5)(d);
  }
  function i(d) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? s(d) : n(d);
  }
  function s(d) {
    return d === null ? c(d) : Ce(d) ? e.attempt(xJ, s, c)(d) : (e.enter("codeFlowValue"), u(d));
  }
  function u(d) {
    return d === null || Ce(d) ? (e.exit("codeFlowValue"), s(d)) : (e.consume(d), u);
  }
  function c(d) {
    return e.exit("codeIndented"), t(d);
  }
}
function wJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return r.parser.lazy[r.now().line] ? n(s) : Ce(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : mt(e, i, "linePrefix", 5)(s);
  }
  function i(s) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? t(s) : Ce(s) ? a(s) : n(s);
  }
}
const AJ = {
  name: "codeText",
  previous: RJ,
  resolve: IJ,
  tokenize: _J
};
function IJ(e) {
  let t = e.length - 4, n = 3, r, a;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    a === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (a = r) : (r === t || e[r][1].type === "lineEnding") && (e[a][1].type = "codeTextData", r !== a + 2 && (e[a][1].end = e[r - 1][1].end, e.splice(a + 2, r - a - 2), t -= r - a - 2, r = a + 2), a = void 0);
  return e;
}
function RJ(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function _J(e, t, n) {
  let r = 0, a, i;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), u(f);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), r++, u) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (i = e.enter("codeTextSequence"), a = 0, p(f)) : Ce(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), d(f));
  }
  function d(f) {
    return f === null || f === 32 || f === 96 || Ce(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), d);
  }
  function p(f) {
    return f === 96 ? (e.consume(f), a++, p) : a === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (i.type = "codeTextData", d(f));
  }
}
class CJ {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const a = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return r && Ko(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Ko(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Ko(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Ko(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Ko(this.left, n.reverse());
      }
  }
}
function Ko(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function L1(e) {
  const t = {};
  let n = -1, r, a, i, s, u, c, d;
  const p = new CJ(e);
  for (; ++n < p.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = p.get(n), n && r[1].type === "chunkFlow" && p.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, i = 0, i < c.length && c[i][1].type === "lineEndingBlank" && (i += 2), i < c.length && c[i][1].type === "content"))
      for (; ++i < c.length && c[i][1].type !== "content"; )
        c[i][1].type === "chunkText" && (c[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, kJ(p, n)), n = t[n], d = !0);
    else if (r[1]._container) {
      for (i = n, a = void 0; i--; )
        if (s = p.get(i), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank")
          s[0] === "enter" && (a && (p.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = i);
        else if (s[1].type !== "linePrefix") break;
      a && (r[1].end = {
        ...p.get(a)[1].start
      }, u = p.slice(a, n), u.unshift(r), p.splice(a, n - a + 1, u));
    }
  }
  return Qr(e, 0, Number.POSITIVE_INFINITY, p.slice(0)), !d;
}
function kJ(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let a = t - 1;
  const i = [], s = n._tokenizer || r.parser[n.contentType](n.start), u = s.events, c = [], d = {};
  let p, f, m = -1, h = n, E = 0, y = 0;
  const w = [y];
  for (; h; ) {
    for (; e.get(++a)[1] !== h; )
      ;
    i.push(a), h._tokenizer || (p = r.sliceStream(h), h.next || p.push(null), f && s.defineSkip(h.start), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(p), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = h, h = h.next;
  }
  for (h = n; ++m < u.length; )
    // Find a void token that includes a break.
    u[m][0] === "exit" && u[m - 1][0] === "enter" && u[m][1].type === u[m - 1][1].type && u[m][1].start.line !== u[m][1].end.line && (y = m + 1, w.push(y), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (s.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : w.pop(), m = w.length; m--; ) {
    const x = u.slice(w[m], w[m + 1]), I = i.pop();
    c.push([I, I + x.length - 1]), e.splice(I, 2, x);
  }
  for (c.reverse(), m = -1; ++m < c.length; )
    d[E + c[m][0]] = E + c[m][1], E += c[m][1] - c[m][0] - 1;
  return d;
}
const NJ = {
  resolve: LJ,
  tokenize: DJ
}, OJ = {
  partial: !0,
  tokenize: MJ
};
function LJ(e) {
  return L1(e), e;
}
function DJ(e, t) {
  let n;
  return r;
  function r(u) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), a(u);
  }
  function a(u) {
    return u === null ? i(u) : Ce(u) ? e.check(OJ, s, i)(u) : (e.consume(u), a);
  }
  function i(u) {
    return e.exit("chunkContent"), e.exit("content"), t(u);
  }
  function s(u) {
    return e.consume(u), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, a;
  }
}
function MJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), mt(e, i, "linePrefix");
  }
  function i(s) {
    if (s === null || Ce(s))
      return n(s);
    const u = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function D1(e, t, n, r, a, i, s, u, c) {
  const d = c || Number.POSITIVE_INFINITY;
  let p = 0;
  return f;
  function f(x) {
    return x === 60 ? (e.enter(r), e.enter(a), e.enter(i), e.consume(x), e.exit(i), m) : x === null || x === 32 || x === 41 || Ny(x) ? n(x) : (e.enter(r), e.enter(s), e.enter(u), e.enter("chunkString", {
      contentType: "string"
    }), y(x));
  }
  function m(x) {
    return x === 62 ? (e.enter(i), e.consume(x), e.exit(i), e.exit(a), e.exit(r), t) : (e.enter(u), e.enter("chunkString", {
      contentType: "string"
    }), h(x));
  }
  function h(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(u), m(x)) : x === null || x === 60 || Ce(x) ? n(x) : (e.consume(x), x === 92 ? E : h);
  }
  function E(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), h) : h(x);
  }
  function y(x) {
    return !p && (x === null || x === 41 || Nn(x)) ? (e.exit("chunkString"), e.exit(u), e.exit(s), e.exit(r), t(x)) : p < d && x === 40 ? (e.consume(x), p++, y) : x === 41 ? (e.consume(x), p--, y) : x === null || x === 32 || x === 40 || Ny(x) ? n(x) : (e.consume(x), x === 92 ? w : y);
  }
  function w(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), y) : y(x);
  }
}
function M1(e, t, n, r, a, i) {
  const s = this;
  let u = 0, c;
  return d;
  function d(h) {
    return e.enter(r), e.enter(a), e.consume(h), e.exit(a), e.enter(i), p;
  }
  function p(h) {
    return u > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !u && "_hiddenFootnoteSupport" in s.parser.constructs ? n(h) : h === 93 ? (e.exit(i), e.enter(a), e.consume(h), e.exit(a), e.exit(r), t) : Ce(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), f(h));
  }
  function f(h) {
    return h === null || h === 91 || h === 93 || Ce(h) || u++ > 999 ? (e.exit("chunkString"), p(h)) : (e.consume(h), c || (c = !Xe(h)), h === 92 ? m : f);
  }
  function m(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), u++, f) : f(h);
  }
}
function F1(e, t, n, r, a, i) {
  let s;
  return u;
  function u(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(a), e.consume(m), e.exit(a), s = m === 40 ? 41 : m, c) : n(m);
  }
  function c(m) {
    return m === s ? (e.enter(a), e.consume(m), e.exit(a), e.exit(r), t) : (e.enter(i), d(m));
  }
  function d(m) {
    return m === s ? (e.exit(i), c(s)) : m === null ? n(m) : Ce(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), mt(e, d, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(m));
  }
  function p(m) {
    return m === s || m === null || Ce(m) ? (e.exit("chunkString"), d(m)) : (e.consume(m), m === 92 ? f : p);
  }
  function f(m) {
    return m === s || m === 92 ? (e.consume(m), p) : p(m);
  }
}
function us(e, t) {
  let n;
  return r;
  function r(a) {
    return Ce(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n = !0, r) : Xe(a) ? mt(e, r, n ? "linePrefix" : "lineSuffix")(a) : t(a);
  }
}
const FJ = {
  name: "definition",
  tokenize: BJ
}, PJ = {
  partial: !0,
  tokenize: $J
};
function BJ(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(h) {
    return e.enter("definition"), s(h);
  }
  function s(h) {
    return M1.call(
      r,
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function u(h) {
    return a = po(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return Nn(h) ? us(e, d)(h) : d(h);
  }
  function d(h) {
    return D1(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function p(h) {
    return e.attempt(PJ, f, f)(h);
  }
  function f(h) {
    return Xe(h) ? mt(e, m, "whitespace")(h) : m(h);
  }
  function m(h) {
    return h === null || Ce(h) ? (e.exit("definition"), r.parser.defined.push(a), t(h)) : n(h);
  }
}
function $J(e, t, n) {
  return r;
  function r(u) {
    return Nn(u) ? us(e, a)(u) : n(u);
  }
  function a(u) {
    return F1(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(u);
  }
  function i(u) {
    return Xe(u) ? mt(e, s, "whitespace")(u) : s(u);
  }
  function s(u) {
    return u === null || Ce(u) ? t(u) : n(u);
  }
}
const UJ = {
  name: "hardBreakEscape",
  tokenize: jJ
};
function jJ(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), a;
  }
  function a(i) {
    return Ce(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const qJ = {
  name: "headingAtx",
  resolve: zJ,
  tokenize: GJ
};
function zJ(e, t) {
  let n = e.length - 2, r = 3, a, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (a = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Qr(e, r, n - r + 1, [["enter", a, t], ["enter", i, t], ["exit", i, t], ["exit", a, t]])), e;
}
function GJ(e, t, n) {
  let r = 0;
  return a;
  function a(p) {
    return e.enter("atxHeading"), i(p);
  }
  function i(p) {
    return e.enter("atxHeadingSequence"), s(p);
  }
  function s(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), s) : p === null || Nn(p) ? (e.exit("atxHeadingSequence"), u(p)) : n(p);
  }
  function u(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), c(p)) : p === null || Ce(p) ? (e.exit("atxHeading"), t(p)) : Xe(p) ? mt(e, u, "whitespace")(p) : (e.enter("atxHeadingText"), d(p));
  }
  function c(p) {
    return p === 35 ? (e.consume(p), c) : (e.exit("atxHeadingSequence"), u(p));
  }
  function d(p) {
    return p === null || p === 35 || Nn(p) ? (e.exit("atxHeadingText"), u(p)) : (e.consume(p), d);
  }
}
const HJ = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ak = ["pre", "script", "style", "textarea"], VJ = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: YJ,
  tokenize: XJ
}, WJ = {
  partial: !0,
  tokenize: JJ
}, KJ = {
  partial: !0,
  tokenize: ZJ
};
function YJ(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function XJ(e, t, n) {
  const r = this;
  let a, i, s, u, c;
  return d;
  function d(M) {
    return p(M);
  }
  function p(M) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(M), f;
  }
  function f(M) {
    return M === 33 ? (e.consume(M), m) : M === 47 ? (e.consume(M), i = !0, y) : M === 63 ? (e.consume(M), a = 3, r.interrupt ? t : D) : Xr(M) ? (e.consume(M), s = String.fromCharCode(M), w) : n(M);
  }
  function m(M) {
    return M === 45 ? (e.consume(M), a = 2, h) : M === 91 ? (e.consume(M), a = 5, u = 0, E) : Xr(M) ? (e.consume(M), a = 4, r.interrupt ? t : D) : n(M);
  }
  function h(M) {
    return M === 45 ? (e.consume(M), r.interrupt ? t : D) : n(M);
  }
  function E(M) {
    const he = "CDATA[";
    return M === he.charCodeAt(u++) ? (e.consume(M), u === he.length ? r.interrupt ? t : j : E) : n(M);
  }
  function y(M) {
    return Xr(M) ? (e.consume(M), s = String.fromCharCode(M), w) : n(M);
  }
  function w(M) {
    if (M === null || M === 47 || M === 62 || Nn(M)) {
      const he = M === 47, se = s.toLowerCase();
      return !he && !i && Ak.includes(se) ? (a = 1, r.interrupt ? t(M) : j(M)) : HJ.includes(s.toLowerCase()) ? (a = 6, he ? (e.consume(M), x) : r.interrupt ? t(M) : j(M)) : (a = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(M) : i ? I(M) : S(M));
    }
    return M === 45 || Yn(M) ? (e.consume(M), s += String.fromCharCode(M), w) : n(M);
  }
  function x(M) {
    return M === 62 ? (e.consume(M), r.interrupt ? t : j) : n(M);
  }
  function I(M) {
    return Xe(M) ? (e.consume(M), I) : b(M);
  }
  function S(M) {
    return M === 47 ? (e.consume(M), b) : M === 58 || M === 95 || Xr(M) ? (e.consume(M), C) : Xe(M) ? (e.consume(M), S) : b(M);
  }
  function C(M) {
    return M === 45 || M === 46 || M === 58 || M === 95 || Yn(M) ? (e.consume(M), C) : T(M);
  }
  function T(M) {
    return M === 61 ? (e.consume(M), A) : Xe(M) ? (e.consume(M), T) : S(M);
  }
  function A(M) {
    return M === null || M === 60 || M === 61 || M === 62 || M === 96 ? n(M) : M === 34 || M === 39 ? (e.consume(M), c = M, O) : Xe(M) ? (e.consume(M), A) : U(M);
  }
  function O(M) {
    return M === c ? (e.consume(M), c = null, P) : M === null || Ce(M) ? n(M) : (e.consume(M), O);
  }
  function U(M) {
    return M === null || M === 34 || M === 39 || M === 47 || M === 60 || M === 61 || M === 62 || M === 96 || Nn(M) ? T(M) : (e.consume(M), U);
  }
  function P(M) {
    return M === 47 || M === 62 || Xe(M) ? S(M) : n(M);
  }
  function b(M) {
    return M === 62 ? (e.consume(M), L) : n(M);
  }
  function L(M) {
    return M === null || Ce(M) ? j(M) : Xe(M) ? (e.consume(M), L) : n(M);
  }
  function j(M) {
    return M === 45 && a === 2 ? (e.consume(M), ue) : M === 60 && a === 1 ? (e.consume(M), ce) : M === 62 && a === 4 ? (e.consume(M), le) : M === 63 && a === 3 ? (e.consume(M), D) : M === 93 && a === 5 ? (e.consume(M), de) : Ce(M) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(WJ, Ae, G)(M)) : M === null || Ce(M) ? (e.exit("htmlFlowData"), G(M)) : (e.consume(M), j);
  }
  function G(M) {
    return e.check(KJ, H, Ae)(M);
  }
  function H(M) {
    return e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), ne;
  }
  function ne(M) {
    return M === null || Ce(M) ? G(M) : (e.enter("htmlFlowData"), j(M));
  }
  function ue(M) {
    return M === 45 ? (e.consume(M), D) : j(M);
  }
  function ce(M) {
    return M === 47 ? (e.consume(M), s = "", Q) : j(M);
  }
  function Q(M) {
    if (M === 62) {
      const he = s.toLowerCase();
      return Ak.includes(he) ? (e.consume(M), le) : j(M);
    }
    return Xr(M) && s.length < 8 ? (e.consume(M), s += String.fromCharCode(M), Q) : j(M);
  }
  function de(M) {
    return M === 93 ? (e.consume(M), D) : j(M);
  }
  function D(M) {
    return M === 62 ? (e.consume(M), le) : M === 45 && a === 2 ? (e.consume(M), D) : j(M);
  }
  function le(M) {
    return M === null || Ce(M) ? (e.exit("htmlFlowData"), Ae(M)) : (e.consume(M), le);
  }
  function Ae(M) {
    return e.exit("htmlFlow"), t(M);
  }
}
function ZJ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return Ce(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : n(s);
  }
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function JJ(e, t, n) {
  return r;
  function r(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(gc, t, n);
  }
}
const QJ = {
  name: "htmlText",
  tokenize: eQ
};
function eQ(e, t, n) {
  const r = this;
  let a, i, s;
  return u;
  function u(D) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(D), c;
  }
  function c(D) {
    return D === 33 ? (e.consume(D), d) : D === 47 ? (e.consume(D), T) : D === 63 ? (e.consume(D), S) : Xr(D) ? (e.consume(D), U) : n(D);
  }
  function d(D) {
    return D === 45 ? (e.consume(D), p) : D === 91 ? (e.consume(D), i = 0, E) : Xr(D) ? (e.consume(D), I) : n(D);
  }
  function p(D) {
    return D === 45 ? (e.consume(D), h) : n(D);
  }
  function f(D) {
    return D === null ? n(D) : D === 45 ? (e.consume(D), m) : Ce(D) ? (s = f, ce(D)) : (e.consume(D), f);
  }
  function m(D) {
    return D === 45 ? (e.consume(D), h) : f(D);
  }
  function h(D) {
    return D === 62 ? ue(D) : D === 45 ? m(D) : f(D);
  }
  function E(D) {
    const le = "CDATA[";
    return D === le.charCodeAt(i++) ? (e.consume(D), i === le.length ? y : E) : n(D);
  }
  function y(D) {
    return D === null ? n(D) : D === 93 ? (e.consume(D), w) : Ce(D) ? (s = y, ce(D)) : (e.consume(D), y);
  }
  function w(D) {
    return D === 93 ? (e.consume(D), x) : y(D);
  }
  function x(D) {
    return D === 62 ? ue(D) : D === 93 ? (e.consume(D), x) : y(D);
  }
  function I(D) {
    return D === null || D === 62 ? ue(D) : Ce(D) ? (s = I, ce(D)) : (e.consume(D), I);
  }
  function S(D) {
    return D === null ? n(D) : D === 63 ? (e.consume(D), C) : Ce(D) ? (s = S, ce(D)) : (e.consume(D), S);
  }
  function C(D) {
    return D === 62 ? ue(D) : S(D);
  }
  function T(D) {
    return Xr(D) ? (e.consume(D), A) : n(D);
  }
  function A(D) {
    return D === 45 || Yn(D) ? (e.consume(D), A) : O(D);
  }
  function O(D) {
    return Ce(D) ? (s = O, ce(D)) : Xe(D) ? (e.consume(D), O) : ue(D);
  }
  function U(D) {
    return D === 45 || Yn(D) ? (e.consume(D), U) : D === 47 || D === 62 || Nn(D) ? P(D) : n(D);
  }
  function P(D) {
    return D === 47 ? (e.consume(D), ue) : D === 58 || D === 95 || Xr(D) ? (e.consume(D), b) : Ce(D) ? (s = P, ce(D)) : Xe(D) ? (e.consume(D), P) : ue(D);
  }
  function b(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || Yn(D) ? (e.consume(D), b) : L(D);
  }
  function L(D) {
    return D === 61 ? (e.consume(D), j) : Ce(D) ? (s = L, ce(D)) : Xe(D) ? (e.consume(D), L) : P(D);
  }
  function j(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), a = D, G) : Ce(D) ? (s = j, ce(D)) : Xe(D) ? (e.consume(D), j) : (e.consume(D), H);
  }
  function G(D) {
    return D === a ? (e.consume(D), a = void 0, ne) : D === null ? n(D) : Ce(D) ? (s = G, ce(D)) : (e.consume(D), G);
  }
  function H(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 96 ? n(D) : D === 47 || D === 62 || Nn(D) ? P(D) : (e.consume(D), H);
  }
  function ne(D) {
    return D === 47 || D === 62 || Nn(D) ? P(D) : n(D);
  }
  function ue(D) {
    return D === 62 ? (e.consume(D), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(D);
  }
  function ce(D) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), Q;
  }
  function Q(D) {
    return Xe(D) ? mt(e, de, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : de(D);
  }
  function de(D) {
    return e.enter("htmlTextData"), s(D);
  }
}
const Jv = {
  name: "labelEnd",
  resolveAll: aQ,
  resolveTo: iQ,
  tokenize: oQ
}, tQ = {
  tokenize: sQ
}, nQ = {
  tokenize: lQ
}, rQ = {
  tokenize: uQ
};
function aQ(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const a = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += a;
    }
  }
  return e.length !== n.length && Qr(e, 0, e.length, n), e;
}
function iQ(e, t) {
  let n = e.length, r = 0, a, i, s, u;
  for (; n--; )
    if (a = e[n][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[n][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = n, a.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = n);
  const c = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, d = {
    type: "label",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, p = {
    type: "labelText",
    start: {
      ...e[i + r + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return u = [["enter", c, t], ["enter", d, t]], u = vr(u, e.slice(i + 1, i + r + 3)), u = vr(u, [["enter", p, t]]), u = vr(u, Zv(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, s - 3), t)), u = vr(u, [["exit", p, t], e[s - 2], e[s - 1], ["exit", d, t]]), u = vr(u, e.slice(s + 1)), u = vr(u, [["exit", c, t]]), Qr(e, i, e.length, u), e;
}
function oQ(e, t, n) {
  const r = this;
  let a = r.events.length, i, s;
  for (; a--; )
    if ((r.events[a][1].type === "labelImage" || r.events[a][1].type === "labelLink") && !r.events[a][1]._balanced) {
      i = r.events[a][1];
      break;
    }
  return u;
  function u(m) {
    return i ? i._inactive ? f(m) : (s = r.parser.defined.includes(po(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(m);
  }
  function c(m) {
    return m === 40 ? e.attempt(tQ, p, s ? p : f)(m) : m === 91 ? e.attempt(nQ, p, s ? d : f)(m) : s ? p(m) : f(m);
  }
  function d(m) {
    return e.attempt(rQ, p, f)(m);
  }
  function p(m) {
    return t(m);
  }
  function f(m) {
    return i._balanced = !0, n(m);
  }
}
function sQ(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Nn(f) ? us(e, i)(f) : i(f);
  }
  function i(f) {
    return f === 41 ? p(f) : D1(e, s, u, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Nn(f) ? us(e, c)(f) : p(f);
  }
  function u(f) {
    return n(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? F1(e, d, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : p(f);
  }
  function d(f) {
    return Nn(f) ? us(e, p)(f) : p(f);
  }
  function p(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function lQ(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return M1.call(r, e, i, s, "reference", "referenceMarker", "referenceString")(u);
  }
  function i(u) {
    return r.parser.defined.includes(po(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(u) : n(u);
  }
  function s(u) {
    return n(u);
  }
}
function uQ(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const cQ = {
  name: "labelStartImage",
  resolveAll: Jv.resolveAll,
  tokenize: dQ
};
function dQ(e, t, n) {
  const r = this;
  return a;
  function a(u) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(u), e.exit("labelImageMarker"), i;
  }
  function i(u) {
    return u === 91 ? (e.enter("labelMarker"), e.consume(u), e.exit("labelMarker"), e.exit("labelImage"), s) : n(u);
  }
  function s(u) {
    return u === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(u) : t(u);
  }
}
const pQ = {
  name: "labelStartLink",
  resolveAll: Jv.resolveAll,
  tokenize: fQ
};
function fQ(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const $b = {
  name: "lineEnding",
  tokenize: gQ
};
function gQ(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), mt(e, t, "linePrefix");
  }
}
const cu = {
  name: "thematicBreak",
  tokenize: mQ
};
function mQ(e, t, n) {
  let r = 0, a;
  return i;
  function i(d) {
    return e.enter("thematicBreak"), s(d);
  }
  function s(d) {
    return a = d, u(d);
  }
  function u(d) {
    return d === a ? (e.enter("thematicBreakSequence"), c(d)) : r >= 3 && (d === null || Ce(d)) ? (e.exit("thematicBreak"), t(d)) : n(d);
  }
  function c(d) {
    return d === a ? (e.consume(d), r++, c) : (e.exit("thematicBreakSequence"), Xe(d) ? mt(e, u, "whitespace")(d) : u(d));
  }
}
const kn = {
  continuation: {
    tokenize: vQ
  },
  exit: SQ,
  name: "list",
  tokenize: yQ
}, hQ = {
  partial: !0,
  tokenize: xQ
}, bQ = {
  partial: !0,
  tokenize: EQ
};
function yQ(e, t, n) {
  const r = this, a = r.events[r.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return u;
  function u(h) {
    const E = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (E === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Oy(h)) {
      if (r.containerState.type || (r.containerState.type = E, e.enter(E, {
        _container: !0
      })), E === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(cu, n, d)(h) : d(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return Oy(h) && ++s < 10 ? (e.consume(h), c) : (!r.interrupt || s < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), d(h)) : n(h);
  }
  function d(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      gc,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      e.attempt(hQ, m, f)
    );
  }
  function p(h) {
    return r.containerState.initialBlankLine = !0, i++, m(h);
  }
  function f(h) {
    return Xe(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), m) : n(h);
  }
  function m(h) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function vQ(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(gc, a, i);
  function a(u) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, mt(e, t, "listItemIndent", r.containerState.size + 1)(u);
  }
  function i(u) {
    return r.containerState.furtherBlankLines || !Xe(u) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(u)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(bQ, t, s)(u));
  }
  function s(u) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, mt(e, e.attempt(kn, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u);
  }
}
function EQ(e, t, n) {
  const r = this;
  return mt(e, a, "listItemIndent", r.containerState.size + 1);
  function a(i) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function SQ(e) {
  e.exit(this.containerState.type);
}
function xQ(e, t, n) {
  const r = this;
  return mt(e, a, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(i) {
    const s = r.events[r.events.length - 1];
    return !Xe(i) && s && s[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const Ik = {
  name: "setextUnderline",
  resolveTo: TQ,
  tokenize: wQ
};
function TQ(e, t) {
  let n = e.length, r, a, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (a = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", i ? (e.splice(a, 0, ["enter", s, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[i][1].end
  }) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function wQ(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(d) {
    let p = r.events.length, f;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        f = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), a = d, s(d)) : n(d);
  }
  function s(d) {
    return e.enter("setextHeadingLineSequence"), u(d);
  }
  function u(d) {
    return d === a ? (e.consume(d), u) : (e.exit("setextHeadingLineSequence"), Xe(d) ? mt(e, c, "lineSuffix")(d) : c(d));
  }
  function c(d) {
    return d === null || Ce(d) ? (e.exit("setextHeadingLine"), t(d)) : n(d);
  }
}
const AQ = {
  tokenize: IQ
};
function IQ(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    gc,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, mt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(NJ, a)), "linePrefix"))
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function a(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const RQ = {
  resolveAll: B1()
}, _Q = P1("string"), CQ = P1("text");
function P1(e) {
  return {
    resolveAll: B1(e === "text" ? kQ : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, a = this.parser.constructs[e], i = n.attempt(a, s, u);
    return s;
    function s(p) {
      return d(p) ? i(p) : u(p);
    }
    function u(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), c;
    }
    function c(p) {
      return d(p) ? (n.exit("data"), i(p)) : (n.consume(p), c);
    }
    function d(p) {
      if (p === null)
        return !0;
      const f = a[p];
      let m = -1;
      if (f)
        for (; ++m < f.length; ) {
          const h = f[m];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function B1(e) {
  return t;
  function t(n, r) {
    let a = -1, i;
    for (; ++a <= n.length; )
      i === void 0 ? n[a] && n[a][1].type === "data" && (i = a, a++) : (!n[a] || n[a][1].type !== "data") && (a !== i + 2 && (n[i][1].end = n[a - 1][1].end, n.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function kQ(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], a = t.sliceStream(r);
      let i = a.length, s = -1, u = 0, c;
      for (; i--; ) {
        const d = a[i];
        if (typeof d == "string") {
          for (s = d.length; d.charCodeAt(s - 1) === 32; )
            u++, s--;
          if (s) break;
          s = -1;
        } else if (d === -2)
          c = !0, u++;
        else if (d !== -1) {
          i++;
          break;
        }
      }
      if (u) {
        const d = {
          type: n === e.length || c || u < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? s : r.start._bufferIndex + s,
            _index: r.start._index + i,
            line: r.end.line,
            column: r.end.column - u,
            offset: r.end.offset - u
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...d.start
        }, r.start.offset === r.end.offset ? Object.assign(r, d) : (e.splice(n, 0, ["enter", d, t], ["exit", d, t]), n += 2);
      }
      n++;
    }
  return e;
}
const NQ = {
  42: kn,
  43: kn,
  45: kn,
  48: kn,
  49: kn,
  50: kn,
  51: kn,
  52: kn,
  53: kn,
  54: kn,
  55: kn,
  56: kn,
  57: kn,
  62: k1
}, OQ = {
  91: FJ
}, LQ = {
  [-2]: Bb,
  [-1]: Bb,
  32: Bb
}, DQ = {
  35: qJ,
  42: cu,
  45: [Ik, cu],
  60: VJ,
  61: Ik,
  95: cu,
  96: wk,
  126: wk
}, MQ = {
  38: O1,
  92: N1
}, FQ = {
  [-5]: $b,
  [-4]: $b,
  [-3]: $b,
  33: cQ,
  38: O1,
  42: Ly,
  60: [pJ, QJ],
  91: pQ,
  92: [UJ, N1],
  93: Jv,
  95: Ly,
  96: AJ
}, PQ = {
  null: [Ly, RQ]
}, BQ = {
  null: [42, 95]
}, $Q = {
  null: []
}, UQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: BQ,
  contentInitial: OQ,
  disable: $Q,
  document: NQ,
  flow: DQ,
  flowInitial: LQ,
  insideSpan: PQ,
  string: MQ,
  text: FQ
}, Symbol.toStringTag, { value: "Module" }));
function jQ(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const a = {}, i = [];
  let s = [], u = [];
  const c = {
    attempt: O(T),
    check: O(A),
    consume: I,
    enter: S,
    exit: C,
    interrupt: O(A, {
      interrupt: !0
    })
  }, d = {
    code: null,
    containerState: {},
    defineSkip: y,
    events: [],
    now: E,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: h,
    write: f
  };
  let p = t.tokenize.call(d, c);
  return t.resolveAll && i.push(t), d;
  function f(L) {
    return s = vr(s, L), w(), s[s.length - 1] !== null ? [] : (U(t, 0), d.events = Zv(i, d.events, d), d.events);
  }
  function m(L, j) {
    return zQ(h(L), j);
  }
  function h(L) {
    return qQ(s, L);
  }
  function E() {
    const {
      _bufferIndex: L,
      _index: j,
      line: G,
      column: H,
      offset: ne
    } = r;
    return {
      _bufferIndex: L,
      _index: j,
      line: G,
      column: H,
      offset: ne
    };
  }
  function y(L) {
    a[L.line] = L.column, b();
  }
  function w() {
    let L;
    for (; r._index < s.length; ) {
      const j = s[r._index];
      if (typeof j == "string")
        for (L = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === L && r._bufferIndex < j.length; )
          x(j.charCodeAt(r._bufferIndex));
      else
        x(j);
    }
  }
  function x(L) {
    p = p(L);
  }
  function I(L) {
    Ce(L) ? (r.line++, r.column = 1, r.offset += L === -3 ? 2 : 1, b()) : L !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[r._index].length && (r._bufferIndex = -1, r._index++)), d.previous = L;
  }
  function S(L, j) {
    const G = j || {};
    return G.type = L, G.start = E(), d.events.push(["enter", G, d]), u.push(G), G;
  }
  function C(L) {
    const j = u.pop();
    return j.end = E(), d.events.push(["exit", j, d]), j;
  }
  function T(L, j) {
    U(L, j.from);
  }
  function A(L, j) {
    j.restore();
  }
  function O(L, j) {
    return G;
    function G(H, ne, ue) {
      let ce, Q, de, D;
      return Array.isArray(H) ? (
        /* c8 ignore next 1 */
        Ae(H)
      ) : "tokenize" in H ? (
        // Looks like a construct.
        Ae([
          /** @type {Construct} */
          H
        ])
      ) : le(H);
      function le(ie) {
        return xe;
        function xe(_e) {
          const Le = _e !== null && ie[_e], tt = _e !== null && ie.null, at = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(tt) ? tt : tt ? [tt] : []
          ];
          return Ae(at)(_e);
        }
      }
      function Ae(ie) {
        return ce = ie, Q = 0, ie.length === 0 ? ue : M(ie[Q]);
      }
      function M(ie) {
        return xe;
        function xe(_e) {
          return D = P(), de = ie, ie.partial || (d.currentConstruct = ie), ie.name && d.parser.constructs.disable.null.includes(ie.name) ? se() : ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            j ? Object.assign(Object.create(d), j) : d,
            c,
            he,
            se
          )(_e);
        }
      }
      function he(ie) {
        return L(de, D), ne;
      }
      function se(ie) {
        return D.restore(), ++Q < ce.length ? M(ce[Q]) : ue;
      }
    }
  }
  function U(L, j) {
    L.resolveAll && !i.includes(L) && i.push(L), L.resolve && Qr(d.events, j, d.events.length - j, L.resolve(d.events.slice(j), d)), L.resolveTo && (d.events = L.resolveTo(d.events, d));
  }
  function P() {
    const L = E(), j = d.previous, G = d.currentConstruct, H = d.events.length, ne = Array.from(u);
    return {
      from: H,
      restore: ue
    };
    function ue() {
      r = L, d.previous = j, d.currentConstruct = G, d.events.length = H, u = ne, b();
    }
  }
  function b() {
    r.line in a && r.column < 2 && (r.column = a[r.line], r.offset += a[r.line] - 1);
  }
}
function qQ(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, a = t.end._index, i = t.end._bufferIndex;
  let s;
  if (n === a)
    s = [e[n].slice(r, i)];
  else {
    if (s = e.slice(n, a), r > -1) {
      const u = s[0];
      typeof u == "string" ? s[0] = u.slice(r) : s.shift();
    }
    i > 0 && s.push(e[a].slice(0, i));
  }
  return s;
}
function zQ(e, t) {
  let n = -1;
  const r = [];
  let a;
  for (; ++n < e.length; ) {
    const i = e[n];
    let s;
    if (typeof i == "string")
      s = i;
    else switch (i) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(i);
    }
    a = i === -2, r.push(s);
  }
  return r.join("");
}
function GQ(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      ZZ([UQ, ...(e || {}).extensions || []])
    ),
    content: a(iJ),
    defined: [],
    document: a(sJ),
    flow: a(AQ),
    lazy: {},
    string: a(_Q),
    text: a(CQ)
  };
  return r;
  function a(i) {
    return s;
    function s(u) {
      return jQ(r, i, u);
    }
  }
}
function HQ(e) {
  for (; !L1(e); )
    ;
  return e;
}
const Rk = /[\0\t\n\r]/g;
function VQ() {
  let e = 1, t = "", n = !0, r;
  return a;
  function a(i, s, u) {
    const c = [];
    let d, p, f, m, h;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(s || void 0).decode(i)), f = 0, t = "", n && (i.charCodeAt(0) === 65279 && f++, n = void 0); f < i.length; ) {
      if (Rk.lastIndex = f, d = Rk.exec(i), m = d && d.index !== void 0 ? d.index : i.length, h = i.charCodeAt(m), !d) {
        t = i.slice(f);
        break;
      }
      if (h === 10 && f === m && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), f < m && (c.push(i.slice(f, m)), e += m - f), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, c.push(-2); e++ < p; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = m + 1;
    }
    return u && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const WQ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function KQ(e) {
  return e.replace(WQ, YQ);
}
function YQ(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const a = n.charCodeAt(1), i = a === 120 || a === 88;
    return C1(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Xv(n) || e;
}
const $1 = {}.hasOwnProperty;
function XQ(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), ZQ(n)(HQ(GQ(n).document().write(VQ()(e, t, !0))));
}
function ZQ(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(wn),
      autolinkProtocol: P,
      autolinkEmail: P,
      atxHeading: i(nn),
      blockQuote: i(tt),
      characterEscape: P,
      characterReference: P,
      codeFenced: i(at),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: i(at, s),
      codeText: i(tn, s),
      codeTextData: P,
      data: P,
      codeFlowValue: P,
      definition: i(Ge),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: i(St),
      hardBreakEscape: i(kt),
      hardBreakTrailing: i(kt),
      htmlFlow: i(Ze, s),
      htmlFlowData: P,
      htmlText: i(Ze, s),
      htmlTextData: P,
      image: i(Nt),
      label: s,
      link: i(wn),
      listItem: i(me),
      listItemValue: m,
      listOrdered: i(Rt, f),
      listUnordered: i(Rt),
      paragraph: i(Ee),
      reference: M,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: i(nn),
      strong: i(ar),
      thematicBreak: i(bt)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: T,
      autolink: c(),
      autolinkEmail: Le,
      autolinkProtocol: _e,
      blockQuote: c(),
      characterEscapeValue: b,
      characterReferenceMarkerHexadecimal: se,
      characterReferenceMarkerNumeric: se,
      characterReferenceValue: ie,
      characterReference: xe,
      codeFenced: c(w),
      codeFencedFence: y,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: E,
      codeFlowValue: b,
      codeIndented: c(x),
      codeText: c(ne),
      codeTextData: b,
      data: b,
      definition: c(),
      definitionDestinationString: C,
      definitionLabelString: I,
      definitionTitleString: S,
      emphasis: c(),
      hardBreakEscape: c(j),
      hardBreakTrailing: c(j),
      htmlFlow: c(G),
      htmlFlowData: b,
      htmlText: c(H),
      htmlTextData: b,
      image: c(ce),
      label: de,
      labelText: Q,
      lineEnding: L,
      link: c(ue),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: he,
      resourceDestinationString: D,
      resourceTitleString: le,
      resource: Ae,
      setextHeading: c(U),
      setextHeadingLineSequence: O,
      setextHeadingText: A,
      strong: c(),
      thematicBreak: c()
    }
  };
  U1(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(Y) {
    let re = {
      type: "root",
      children: []
    };
    const fe = {
      stack: [re],
      tokenStack: [],
      config: t,
      enter: u,
      exit: d,
      buffer: s,
      resume: p,
      data: n
    }, Se = [];
    let Pe = -1;
    for (; ++Pe < Y.length; )
      if (Y[Pe][1].type === "listOrdered" || Y[Pe][1].type === "listUnordered")
        if (Y[Pe][0] === "enter")
          Se.push(Pe);
        else {
          const Bt = Se.pop();
          Pe = a(Y, Bt, Pe);
        }
    for (Pe = -1; ++Pe < Y.length; ) {
      const Bt = t[Y[Pe][0]];
      $1.call(Bt, Y[Pe][1].type) && Bt[Y[Pe][1].type].call(Object.assign({
        sliceSerialize: Y[Pe][2].sliceSerialize
      }, fe), Y[Pe][1]);
    }
    if (fe.tokenStack.length > 0) {
      const Bt = fe.tokenStack[fe.tokenStack.length - 1];
      (Bt[1] || _k).call(fe, void 0, Bt[0]);
    }
    for (re.position = {
      start: La(Y.length > 0 ? Y[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: La(Y.length > 0 ? Y[Y.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Pe = -1; ++Pe < t.transforms.length; )
      re = t.transforms[Pe](re) || re;
    return re;
  }
  function a(Y, re, fe) {
    let Se = re - 1, Pe = -1, Bt = !1, $t, Ut, Yt, xt;
    for (; ++Se <= fe; ) {
      const Ot = Y[Se];
      switch (Ot[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ot[0] === "enter" ? Pe++ : Pe--, xt = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ot[0] === "enter" && ($t && !xt && !Pe && !Yt && (Yt = Se), xt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          xt = void 0;
      }
      if (!Pe && Ot[0] === "enter" && Ot[1].type === "listItemPrefix" || Pe === -1 && Ot[0] === "exit" && (Ot[1].type === "listUnordered" || Ot[1].type === "listOrdered")) {
        if ($t) {
          let rn = Se;
          for (Ut = void 0; rn--; ) {
            const Xt = Y[rn];
            if (Xt[1].type === "lineEnding" || Xt[1].type === "lineEndingBlank") {
              if (Xt[0] === "exit") continue;
              Ut && (Y[Ut][1].type = "lineEndingBlank", Bt = !0), Xt[1].type = "lineEnding", Ut = rn;
            } else if (!(Xt[1].type === "linePrefix" || Xt[1].type === "blockQuotePrefix" || Xt[1].type === "blockQuotePrefixWhitespace" || Xt[1].type === "blockQuoteMarker" || Xt[1].type === "listItemIndent")) break;
          }
          Yt && (!Ut || Yt < Ut) && ($t._spread = !0), $t.end = Object.assign({}, Ut ? Y[Ut][1].start : Ot[1].end), Y.splice(Ut || Se, 0, ["exit", $t, Ot[2]]), Se++, fe++;
        }
        if (Ot[1].type === "listItemPrefix") {
          const rn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ot[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          $t = rn, Y.splice(Se, 0, ["enter", rn, Ot[2]]), Se++, fe++, Yt = void 0, xt = !0;
        }
      }
    }
    return Y[re][1]._spread = Bt, fe;
  }
  function i(Y, re) {
    return fe;
    function fe(Se) {
      u.call(this, Y(Se), Se), re && re.call(this, Se);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(Y, re, fe) {
    this.stack[this.stack.length - 1].children.push(Y), this.stack.push(Y), this.tokenStack.push([re, fe || void 0]), Y.position = {
      start: La(re.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(Y) {
    return re;
    function re(fe) {
      Y && Y.call(this, fe), d.call(this, fe);
    }
  }
  function d(Y, re) {
    const fe = this.stack.pop(), Se = this.tokenStack.pop();
    if (Se)
      Se[0].type !== Y.type && (re ? re.call(this, Y, Se[0]) : (Se[1] || _k).call(this, Y, Se[0]));
    else throw new Error("Cannot close `" + Y.type + "` (" + ls({
      start: Y.start,
      end: Y.end
    }) + "): it’s not open");
    fe.position.end = La(Y.end);
  }
  function p() {
    return YZ(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(Y) {
    if (this.data.expectingFirstListItemValue) {
      const re = this.stack[this.stack.length - 2];
      re.start = Number.parseInt(this.sliceSerialize(Y), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.lang = Y;
  }
  function E() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.meta = Y;
  }
  function y() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function w() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.value = Y.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.value = Y.replace(/(\r?\n|\r)$/g, "");
  }
  function I(Y) {
    const re = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = re, fe.identifier = po(this.sliceSerialize(Y)).toLowerCase();
  }
  function S() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.title = Y;
  }
  function C() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.url = Y;
  }
  function T(Y) {
    const re = this.stack[this.stack.length - 1];
    if (!re.depth) {
      const fe = this.sliceSerialize(Y).length;
      re.depth = fe;
    }
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(Y) {
    const re = this.stack[this.stack.length - 1];
    re.depth = this.sliceSerialize(Y).codePointAt(0) === 61 ? 1 : 2;
  }
  function U() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function P(Y) {
    const fe = this.stack[this.stack.length - 1].children;
    let Se = fe[fe.length - 1];
    (!Se || Se.type !== "text") && (Se = Bn(), Se.position = {
      start: La(Y.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, fe.push(Se)), this.stack.push(Se);
  }
  function b(Y) {
    const re = this.stack.pop();
    re.value += this.sliceSerialize(Y), re.position.end = La(Y.end);
  }
  function L(Y) {
    const re = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const fe = re.children[re.children.length - 1];
      fe.position.end = La(Y.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(re.type) && (P.call(this, Y), b.call(this, Y));
  }
  function j() {
    this.data.atHardBreak = !0;
  }
  function G() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.value = Y;
  }
  function H() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.value = Y;
  }
  function ne() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.value = Y;
  }
  function ue() {
    const Y = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const re = this.data.referenceType || "shortcut";
      Y.type += "Reference", Y.referenceType = re, delete Y.url, delete Y.title;
    } else
      delete Y.identifier, delete Y.label;
    this.data.referenceType = void 0;
  }
  function ce() {
    const Y = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const re = this.data.referenceType || "shortcut";
      Y.type += "Reference", Y.referenceType = re, delete Y.url, delete Y.title;
    } else
      delete Y.identifier, delete Y.label;
    this.data.referenceType = void 0;
  }
  function Q(Y) {
    const re = this.sliceSerialize(Y), fe = this.stack[this.stack.length - 2];
    fe.label = KQ(re), fe.identifier = po(re).toLowerCase();
  }
  function de() {
    const Y = this.stack[this.stack.length - 1], re = this.resume(), fe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, fe.type === "link") {
      const Se = Y.children;
      fe.children = Se;
    } else
      fe.alt = re;
  }
  function D() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.url = Y;
  }
  function le() {
    const Y = this.resume(), re = this.stack[this.stack.length - 1];
    re.title = Y;
  }
  function Ae() {
    this.data.inReference = void 0;
  }
  function M() {
    this.data.referenceType = "collapsed";
  }
  function he(Y) {
    const re = this.resume(), fe = this.stack[this.stack.length - 1];
    fe.label = re, fe.identifier = po(this.sliceSerialize(Y)).toLowerCase(), this.data.referenceType = "full";
  }
  function se(Y) {
    this.data.characterReferenceType = Y.type;
  }
  function ie(Y) {
    const re = this.sliceSerialize(Y), fe = this.data.characterReferenceType;
    let Se;
    fe ? (Se = C1(re, fe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Se = Xv(re);
    const Pe = this.stack[this.stack.length - 1];
    Pe.value += Se;
  }
  function xe(Y) {
    const re = this.stack.pop();
    re.position.end = La(Y.end);
  }
  function _e(Y) {
    b.call(this, Y);
    const re = this.stack[this.stack.length - 1];
    re.url = this.sliceSerialize(Y);
  }
  function Le(Y) {
    b.call(this, Y);
    const re = this.stack[this.stack.length - 1];
    re.url = "mailto:" + this.sliceSerialize(Y);
  }
  function tt() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function at() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function tn() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function St() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function nn() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function kt() {
    return {
      type: "break"
    };
  }
  function Ze() {
    return {
      type: "html",
      value: ""
    };
  }
  function Nt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function wn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Rt(Y) {
    return {
      type: "list",
      ordered: Y.type === "listOrdered",
      start: null,
      spread: Y._spread,
      children: []
    };
  }
  function me(Y) {
    return {
      type: "listItem",
      spread: Y._spread,
      checked: null,
      children: []
    };
  }
  function Ee() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ar() {
    return {
      type: "strong",
      children: []
    };
  }
  function Bn() {
    return {
      type: "text",
      value: ""
    };
  }
  function bt() {
    return {
      type: "thematicBreak"
    };
  }
}
function La(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function U1(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? U1(e, r) : JQ(e, r);
  }
}
function JQ(e, t) {
  let n;
  for (n in t)
    if ($1.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function _k(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + ls({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + ls({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + ls({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function QQ(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return XQ(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function eee(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function tee(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function nee(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let a = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (a.data = { meta: t.meta }), e.patch(t, a), a = e.applyData(t, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, e.patch(t, a), a;
}
function ree(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function aee(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function iee(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), a = wo(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let s, u = e.footnoteCounts.get(r);
  u === void 0 ? (u = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = i + 1, u += 1, e.footnoteCounts.set(r, u);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + a,
      id: n + "fnref-" + a + (u > 1 ? "-" + u : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, c);
  const d = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, d), e.applyData(t, d);
}
function oee(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function see(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function j1(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const a = e.all(t), i = a[0];
  i && i.type === "text" ? i.value = "[" + i.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += r : a.push({ type: "text", value: r }), a;
}
function lee(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return j1(e, t);
  const a = { src: wo(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function uee(e, t) {
  const n = { src: wo(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function cee(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function dee(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return j1(e, t);
  const a = { href: wo(r.url || "") };
  r.title !== null && r.title !== void 0 && (a.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function pee(e, t) {
  const n = { href: wo(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function fee(e, t, n) {
  const r = e.all(t), a = n ? gee(n) : q1(t), i = {}, s = [];
  if (typeof t.checked == "boolean") {
    const p = r[0];
    let f;
    p && p.type === "element" && p.tagName === "p" ? f = p : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let u = -1;
  for (; ++u < r.length; ) {
    const p = r[u];
    (a || u !== 0 || p.type !== "element" || p.tagName !== "p") && s.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !a ? s.push(...p.children) : s.push(p);
  }
  const c = r[r.length - 1];
  c && (a || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const d = { type: "element", tagName: "li", properties: i, children: s };
  return e.patch(t, d), e.applyData(t, d);
}
function gee(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = q1(n[r]);
  }
  return t;
}
function q1(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function mee(e, t) {
  const n = {}, r = e.all(t);
  let a = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++a < r.length; ) {
    const s = r[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function hee(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function bee(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function yee(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function vee(e, t) {
  const n = e.all(t), r = n.shift(), a = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), a.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, u = Vv(t.children[1]), c = x1(t.children[t.children.length - 1]);
    u && c && (s.position = { start: u, end: c }), a.push(s);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Eee(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, u = s ? s.length : t.children.length;
  let c = -1;
  const d = [];
  for (; ++c < u; ) {
    const f = t.children[c], m = {}, h = s ? s[c] : void 0;
    h && (m.align = h);
    let E = { type: "element", tagName: i, properties: m, children: [] };
    f && (E.children = e.all(f), e.patch(f, E), E = e.applyData(f, E)), d.push(E);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(d, !0)
  };
  return e.patch(t, p), e.applyData(t, p);
}
function See(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Ck = 9, kk = 32;
function xee(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), a = 0;
  const i = [];
  for (; r; )
    i.push(
      Nk(t.slice(a, r.index), a > 0, !0),
      r[0]
    ), a = r.index + r[0].length, r = n.exec(t);
  return i.push(Nk(t.slice(a), a > 0, !1)), i.join("");
}
function Nk(e, t, n) {
  let r = 0, a = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === Ck || i === kk; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(a - 1);
    for (; i === Ck || i === kk; )
      a--, i = e.codePointAt(a - 1);
  }
  return a > r ? e.slice(r, a) : "";
}
function Tee(e, t) {
  const n = { type: "text", value: xee(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function wee(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Aee = {
  blockquote: eee,
  break: tee,
  code: nee,
  delete: ree,
  emphasis: aee,
  footnoteReference: iee,
  heading: oee,
  html: see,
  imageReference: lee,
  image: uee,
  inlineCode: cee,
  linkReference: dee,
  link: pee,
  listItem: fee,
  list: mee,
  paragraph: hee,
  // @ts-expect-error: root is different, but hard to type.
  root: bee,
  strong: yee,
  table: vee,
  tableCell: See,
  tableRow: Eee,
  text: Tee,
  thematicBreak: wee,
  toml: Ul,
  yaml: Ul,
  definition: Ul,
  footnoteDefinition: Ul
};
function Ul() {
}
const z1 = -1, mc = 0, cs = 1, Au = 2, Qv = 3, eE = 4, tE = 5, nE = 6, G1 = 7, H1 = 8, Ok = typeof self == "object" ? self : globalThis, Iee = (e, t) => {
  const n = (a, i) => (e.set(i, a), a), r = (a) => {
    if (e.has(a))
      return e.get(a);
    const [i, s] = t[a];
    switch (i) {
      case mc:
      case z1:
        return n(s, a);
      case cs: {
        const u = n([], a);
        for (const c of s)
          u.push(r(c));
        return u;
      }
      case Au: {
        const u = n({}, a);
        for (const [c, d] of s)
          u[r(c)] = r(d);
        return u;
      }
      case Qv:
        return n(new Date(s), a);
      case eE: {
        const { source: u, flags: c } = s;
        return n(new RegExp(u, c), a);
      }
      case tE: {
        const u = n(/* @__PURE__ */ new Map(), a);
        for (const [c, d] of s)
          u.set(r(c), r(d));
        return u;
      }
      case nE: {
        const u = n(/* @__PURE__ */ new Set(), a);
        for (const c of s)
          u.add(r(c));
        return u;
      }
      case G1: {
        const { name: u, message: c } = s;
        return n(new Ok[u](c), a);
      }
      case H1:
        return n(BigInt(s), a);
      case "BigInt":
        return n(Object(BigInt(s)), a);
      case "ArrayBuffer":
        return n(new Uint8Array(s).buffer, s);
      case "DataView": {
        const { buffer: u } = new Uint8Array(s);
        return n(new DataView(u), s);
      }
    }
    return n(new Ok[i](s), a);
  };
  return r;
}, Lk = (e) => Iee(/* @__PURE__ */ new Map(), e)(0), Zi = "", { toString: Ree } = {}, { keys: _ee } = Object, Yo = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [mc, t];
  const n = Ree.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [cs, Zi];
    case "Object":
      return [Au, Zi];
    case "Date":
      return [Qv, Zi];
    case "RegExp":
      return [eE, Zi];
    case "Map":
      return [tE, Zi];
    case "Set":
      return [nE, Zi];
    case "DataView":
      return [cs, n];
  }
  return n.includes("Array") ? [cs, n] : n.includes("Error") ? [G1, n] : [Au, n];
}, jl = ([e, t]) => e === mc && (t === "function" || t === "symbol"), Cee = (e, t, n, r) => {
  const a = (s, u) => {
    const c = r.push(s) - 1;
    return n.set(u, c), c;
  }, i = (s) => {
    if (n.has(s))
      return n.get(s);
    let [u, c] = Yo(s);
    switch (u) {
      case mc: {
        let p = s;
        switch (c) {
          case "bigint":
            u = H1, p = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            p = null;
            break;
          case "undefined":
            return a([z1], s);
        }
        return a([u, p], s);
      }
      case cs: {
        if (c) {
          let m = s;
          return c === "DataView" ? m = new Uint8Array(s.buffer) : c === "ArrayBuffer" && (m = new Uint8Array(s)), a([c, [...m]], s);
        }
        const p = [], f = a([u, p], s);
        for (const m of s)
          p.push(i(m));
        return f;
      }
      case Au: {
        if (c)
          switch (c) {
            case "BigInt":
              return a([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([c, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return i(s.toJSON());
        const p = [], f = a([u, p], s);
        for (const m of _ee(s))
          (e || !jl(Yo(s[m]))) && p.push([i(m), i(s[m])]);
        return f;
      }
      case Qv:
        return a([u, s.toISOString()], s);
      case eE: {
        const { source: p, flags: f } = s;
        return a([u, { source: p, flags: f }], s);
      }
      case tE: {
        const p = [], f = a([u, p], s);
        for (const [m, h] of s)
          (e || !(jl(Yo(m)) || jl(Yo(h)))) && p.push([i(m), i(h)]);
        return f;
      }
      case nE: {
        const p = [], f = a([u, p], s);
        for (const m of s)
          (e || !jl(Yo(m))) && p.push(i(m));
        return f;
      }
    }
    const { message: d } = s;
    return a([u, { name: c, message: d }], s);
  };
  return i;
}, Dk = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return Cee(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Iu = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Lk(Dk(e, t)) : structuredClone(e)
) : (e, t) => Lk(Dk(e, t));
function kee(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function Nee(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Oee(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || kee, r = e.options.footnoteBackLabel || Nee, a = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, u = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const d = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!d)
      continue;
    const p = e.all(d), f = String(d.identifier).toUpperCase(), m = wo(f.toLowerCase());
    let h = 0;
    const E = [], y = e.footnoteCounts.get(f);
    for (; y !== void 0 && ++h <= y; ) {
      E.length > 0 && E.push({ type: "text", value: " " });
      let I = typeof n == "string" ? n : n(c, h);
      typeof I == "string" && (I = { type: "text", value: I }), E.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const w = p[p.length - 1];
    if (w && w.type === "element" && w.tagName === "p") {
      const I = w.children[w.children.length - 1];
      I && I.type === "text" ? I.value += " " : w.children.push({ type: "text", value: " " }), w.children.push(...E);
    } else
      p.push(...E);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(p, !0)
    };
    e.patch(d, x), u.push(x);
  }
  if (u.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...Iu(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(u, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const V1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return Fee;
    if (typeof e == "function")
      return hc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Lee(e) : Dee(e);
    if (typeof e == "string")
      return Mee(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Lee(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = V1(e[n]);
  return hc(r);
  function r(...a) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, a)) return !0;
    return !1;
  }
}
function Dee(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return hc(n);
  function n(r) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (a[i] !== t[i]) return !1;
    return !0;
  }
}
function Mee(e) {
  return hc(t);
  function t(n) {
    return n && n.type === e;
  }
}
function hc(e) {
  return t;
  function t(n, r, a) {
    return !!(Pee(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      a || void 0
    ));
  }
}
function Fee() {
  return !0;
}
function Pee(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const W1 = [], Bee = !0, Mk = !1, $ee = "skip";
function Uee(e, t, n, r) {
  let a;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : a = t;
  const i = V1(a), s = r ? -1 : 1;
  u(e, void 0, [])();
  function u(c, d, p) {
    const f = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof f.type == "string") {
      const h = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let h = W1, E, y, w;
      if ((!t || i(c, d, p[p.length - 1] || void 0)) && (h = jee(n(c, p)), h[0] === Mk))
        return h;
      if ("children" in c && c.children) {
        const x = (
          /** @type {UnistParent} */
          c
        );
        if (x.children && h[0] !== $ee)
          for (y = (r ? x.children.length : -1) + s, w = p.concat(x); y > -1 && y < x.children.length; ) {
            const I = x.children[y];
            if (E = u(I, y, w)(), E[0] === Mk)
              return E;
            y = typeof E[1] == "number" ? E[1] : y + s;
          }
      }
      return h;
    }
  }
}
function jee(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Bee, e] : e == null ? W1 : [e];
}
function K1(e, t, n, r) {
  let a, i, s;
  typeof t == "function" ? (i = void 0, s = t, a = n) : (i = t, s = n, a = r), Uee(e, i, u, a);
  function u(c, d) {
    const p = d[d.length - 1], f = p ? p.children.indexOf(c) : void 0;
    return s(c, f, p);
  }
}
const Dy = {}.hasOwnProperty, qee = {};
function zee(e, t) {
  const n = t || qee, r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = { ...Aee, ...n.handlers }, u = {
    all: d,
    applyData: Hee,
    definitionById: r,
    footnoteById: a,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: n,
    patch: Gee,
    wrap: Wee
  };
  return K1(e, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const f = p.type === "definition" ? r : a, m = String(p.identifier).toUpperCase();
      f.has(m) || f.set(m, p);
    }
  }), u;
  function c(p, f) {
    const m = p.type, h = u.handlers[m];
    if (Dy.call(u.handlers, m) && h)
      return h(u, p, f);
    if (u.options.passThrough && u.options.passThrough.includes(m)) {
      if ("children" in p) {
        const { children: y, ...w } = p, x = Iu(w);
        return x.children = u.all(p), x;
      }
      return Iu(p);
    }
    return (u.options.unknownHandler || Vee)(u, p, f);
  }
  function d(p) {
    const f = [];
    if ("children" in p) {
      const m = p.children;
      let h = -1;
      for (; ++h < m.length; ) {
        const E = u.one(m[h], p);
        if (E) {
          if (h && m[h - 1].type === "break" && (!Array.isArray(E) && E.type === "text" && (E.value = Fk(E.value)), !Array.isArray(E) && E.type === "element")) {
            const y = E.children[0];
            y && y.type === "text" && (y.value = Fk(y.value));
          }
          Array.isArray(E) ? f.push(...E) : f.push(E);
        }
      }
    }
    return f;
  }
}
function Gee(e, t) {
  e.position && (t.position = AZ(e));
}
function Hee(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, a = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && i && Object.assign(n.properties, Iu(i)), "children" in n && n.children && a !== null && a !== void 0 && (n.children = a);
  }
  return n;
}
function Vee(e, t) {
  const n = t.data || {}, r = "value" in t && !(Dy.call(n, "hProperties") || Dy.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Wee(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Fk(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Pk(e, t) {
  const n = zee(e, t), r = n.one(e, void 0), a = Oee(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return a && i.children.push({ type: "text", value: `
` }, a), i;
}
function Kee(e, t) {
  return e && "run" in e ? async function(n, r) {
    const a = (
      /** @type {HastRoot} */
      Pk(n, { file: r, ...t })
    );
    await e.run(a, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Pk(n, { file: r, ...e || t })
    );
  };
}
function Bk(e) {
  if (e)
    throw e;
}
var Ub, $k;
function Yee() {
  if ($k) return Ub;
  $k = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, a = function(d) {
    return typeof Array.isArray == "function" ? Array.isArray(d) : t.call(d) === "[object Array]";
  }, i = function(d) {
    if (!d || t.call(d) !== "[object Object]")
      return !1;
    var p = e.call(d, "constructor"), f = d.constructor && d.constructor.prototype && e.call(d.constructor.prototype, "isPrototypeOf");
    if (d.constructor && !p && !f)
      return !1;
    var m;
    for (m in d)
      ;
    return typeof m > "u" || e.call(d, m);
  }, s = function(d, p) {
    n && p.name === "__proto__" ? n(d, p.name, {
      enumerable: !0,
      configurable: !0,
      value: p.newValue,
      writable: !0
    }) : d[p.name] = p.newValue;
  }, u = function(d, p) {
    if (p === "__proto__")
      if (e.call(d, p)) {
        if (r)
          return r(d, p).value;
      } else return;
    return d[p];
  };
  return Ub = function c() {
    var d, p, f, m, h, E, y = arguments[0], w = 1, x = arguments.length, I = !1;
    for (typeof y == "boolean" && (I = y, y = arguments[1] || {}, w = 2), (y == null || typeof y != "object" && typeof y != "function") && (y = {}); w < x; ++w)
      if (d = arguments[w], d != null)
        for (p in d)
          f = u(y, p), m = u(d, p), y !== m && (I && m && (i(m) || (h = a(m))) ? (h ? (h = !1, E = f && a(f) ? f : []) : E = f && i(f) ? f : {}, s(y, { name: p, newValue: c(I, E, m) })) : typeof m < "u" && s(y, { name: p, newValue: m }));
    return y;
  }, Ub;
}
var Xee = Yee();
const jb = /* @__PURE__ */ Cu(Xee);
function My(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Zee() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...a) {
    let i = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    u(null, ...a);
    function u(c, ...d) {
      const p = e[++i];
      let f = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++f < a.length; )
        (d[f] === null || d[f] === void 0) && (d[f] = a[f]);
      a = d, p ? Jee(p, u)(...d) : s(null, ...d);
    }
  }
  function r(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), t;
  }
}
function Jee(e, t) {
  let n;
  return r;
  function r(...s) {
    const u = e.length > s.length;
    let c;
    u && s.push(a);
    try {
      c = e.apply(this, s);
    } catch (d) {
      const p = (
        /** @type {Error} */
        d
      );
      if (u && n)
        throw p;
      return a(p);
    }
    u || (c && c.then && typeof c.then == "function" ? c.then(i, a) : c instanceof Error ? a(c) : i(c));
  }
  function a(s, ...u) {
    n || (n = !0, t(s, ...u));
  }
  function i(s) {
    a(null, s);
  }
}
const qr = { basename: Qee, dirname: ete, extname: tte, join: nte, sep: "/" };
function Qee(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ps(e);
  let n = 0, r = -1, a = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (i) {
          n = a + 1;
          break;
        }
      } else r < 0 && (i = !0, r = a + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, u = t.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (i) {
        n = a + 1;
        break;
      }
    } else
      s < 0 && (i = !0, s = a + 1), u > -1 && (e.codePointAt(a) === t.codePointAt(u--) ? u < 0 && (r = a) : (u = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function ete(e) {
  if (Ps(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function tte(e) {
  Ps(e);
  let t = e.length, n = -1, r = 0, a = -1, i = 0, s;
  for (; t--; ) {
    const u = e.codePointAt(t);
    if (u === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), u === 46 ? a < 0 ? a = t : i !== 1 && (i = 1) : a > -1 && (i = -1);
  }
  return a < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && a === n - 1 && a === r + 1 ? "" : e.slice(a, n);
}
function nte(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ps(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : rte(n);
}
function rte(e) {
  Ps(e);
  const t = e.codePointAt(0) === 47;
  let n = ate(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function ate(e, t) {
  let n = "", r = 0, a = -1, i = 0, s = -1, u, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      u = e.codePointAt(s);
    else {
      if (u === 47)
        break;
      u = 47;
    }
    if (u === 47) {
      if (!(a === s - 1 || i === 1)) if (a !== s - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), a = s, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, a = s, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(a + 1, s) : n = e.slice(a + 1, s), r = s - a - 1;
      a = s, i = 0;
    } else u === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function Ps(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const ite = { cwd: ote };
function ote() {
  return "/";
}
function Fy(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function ste(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Fy(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return lte(e);
}
function lte(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(t);
}
const qb = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Y1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Fy(t) ? n = { path: t } : typeof t == "string" || ute(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : ite.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < qb.length; ) {
      const i = qb[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let a;
    for (a in n)
      qb.includes(a) || (this[a] = n[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? qr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Gb(t, "basename"), zb(t, "basename"), this.path = qr.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? qr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Uk(this.basename, "dirname"), this.path = qr.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? qr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (zb(t, "extname"), Uk(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = qr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Fy(t) && (t = ste(t)), Gb(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? qr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Gb(t, "stem"), zb(t, "stem"), this.path = qr.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const a = this.message(t, n, r);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const a = this.message(t, n, r);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const a = new mn(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function zb(e, t) {
  if (e && e.includes(qr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + qr.sep + "`"
    );
}
function Gb(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Uk(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function ute(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const cte = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = r[e], i = function() {
      return a.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, r), i;
  }
), dte = {}.hasOwnProperty;
class rE extends cte {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Zee();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new rE()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(jb(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (Wb("data", this.frozen), this.namespace[t] = n, this) : dte.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (Wb("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const a = n.call(t, ...r);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = ql(t), r = this.parser || this.Parser;
    return Hb("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), Hb("process", this.parser || this.Parser), Vb("process", this.compiler || this.Compiler), n ? a(void 0, n) : new Promise(a);
    function a(i, s) {
      const u = ql(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(u)
      );
      r.run(c, u, function(p, f, m) {
        if (p || !f || !m)
          return d(p);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), E = r.stringify(h, m);
        gte(E) ? m.value = E : m.result = E, d(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function d(p, f) {
        p || !f ? s(p) : i ? i(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), Hb("processSync", this.parser || this.Parser), Vb("processSync", this.compiler || this.Compiler), this.process(t, a), qk("processSync", "process", n), r;
    function a(i, s) {
      n = !0, Bk(i), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    jk(t), this.freeze();
    const a = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(s, u) {
      const c = ql(n);
      a.run(t, c, d);
      function d(p, f, m) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        p ? u(p) : s ? s(h) : r(void 0, h, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, a;
    return this.run(t, n, i), qk("runSync", "run", r), a;
    function i(s, u) {
      Bk(s), a = u, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = ql(n), a = this.compiler || this.Compiler;
    return Vb("stringify", a), jk(t), a(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, a = this.namespace;
    if (Wb("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? u(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(d) {
      if (typeof d == "function")
        c(d, []);
      else if (typeof d == "object")
        if (Array.isArray(d)) {
          const [p, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            d
          );
          c(p, f);
        } else
          s(d);
      else
        throw new TypeError("Expected usable value, not `" + d + "`");
    }
    function s(d) {
      if (!("plugins" in d) && !("settings" in d))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      u(d.plugins), d.settings && (a.settings = jb(!0, a.settings, d.settings));
    }
    function u(d) {
      let p = -1;
      if (d != null) if (Array.isArray(d))
        for (; ++p < d.length; ) {
          const f = d[p];
          i(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + d + "`");
    }
    function c(d, p) {
      let f = -1, m = -1;
      for (; ++f < r.length; )
        if (r[f][0] === d) {
          m = f;
          break;
        }
      if (m === -1)
        r.push([d, ...p]);
      else if (p.length > 0) {
        let [h, ...E] = p;
        const y = r[m][1];
        My(y) && My(h) && (h = jb(!0, y, h)), r[m] = [d, h, ...E];
      }
    }
  }
}
const pte = new rE().freeze();
function Hb(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Vb(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Wb(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function jk(e) {
  if (!My(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function qk(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function ql(e) {
  return fte(e) ? e : new Y1(e);
}
function fte(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function gte(e) {
  return typeof e == "string" || mte(e);
}
function mte(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const hte = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", zk = [], Gk = { allowDangerousHtml: !0 }, bte = /^(https?|ircs?|mailto|xmpp)$/i, yte = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function aE(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", a = e.className, i = e.components, s = e.disallowedElements, u = e.rehypePlugins || zk, c = e.remarkPlugins || zk, d = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Gk } : Gk, p = e.skipHtml, f = e.unwrapDisallowed, m = e.urlTransform || vte, h = pte().use(QQ).use(c).use(Kee, d).use(u), E = new Y1();
  typeof r == "string" && (E.value = r);
  for (const I of yte)
    Object.hasOwn(e, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + hte + I.id, void 0);
  const y = h.parse(E);
  let w = h.runSync(y, E);
  return a && (w = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      w.type === "root" ? w.children : [w]
    )
  }), K1(w, x), NZ(w, {
    Fragment: R.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: i,
    ignoreInvalidStyle: !0,
    jsx: R.jsx,
    jsxs: R.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function x(I, S, C) {
    if (I.type === "raw" && C && typeof S == "number")
      return p ? C.children.splice(S, 1) : C.children[S] = { type: "text", value: I.value }, S;
    if (I.type === "element") {
      let T;
      for (T in Pb)
        if (Object.hasOwn(Pb, T) && Object.hasOwn(I.properties, T)) {
          const A = I.properties[T], O = Pb[T];
          (O === null || O.includes(I.tagName)) && (I.properties[T] = m(String(A || ""), T, I));
        }
    }
    if (I.type === "element") {
      let T = t ? !t.includes(I.tagName) : s ? s.includes(I.tagName) : !1;
      if (!T && n && typeof S == "number" && (T = !n(I, S, C)), T && C && typeof S == "number")
        return f && I.children ? C.children.splice(S, 1, ...I.children) : C.children.splice(S, 1), S;
    }
  }
}
function vte(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a !== -1 && t > a || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    bte.test(e.slice(0, t)) ? e : ""
  );
}
const Bs = ({ source: e, className: t, uiSchema: n }) => /* @__PURE__ */ R.jsx(
  aE,
  {
    className: t,
    components: {
      code: ({ className: r, children: a }) => {
        const s = /language-(\w+)/.exec(r || "")?.[1] || "";
        return /* @__PURE__ */ R.jsx(
          f1,
          {
            style: n?.appBar?.["ui:darkMode"] ? nZ : rZ,
            language: s,
            PreTag: "div",
            source: e,
            children: String(a).trim()
          }
        );
      }
    },
    children: e || ""
  }
), Kb = "ContentDescriptor", ui = {
  description: `${Kb}-description`,
  heading: `${Kb}-heading`,
  secondaryHeading: `${Kb}-secondaryHeading`
}, Ete = cn(uv)({}), iE = ({
  contentDescriptor: e,
  hideIcon: t,
  hideRequired: n,
  uiSchema: r,
  disableTransitionProps: a
}) => {
  const i = Uy();
  return !e || Object.entries(e).length === 0 ? null : /* @__PURE__ */ R.jsxs(
    Ete,
    {
      style: { width: "100%" },
      TransitionProps: { unmountOnExit: !a },
      defaultExpanded: r && r.params["ui:defaultExpanded"],
      expanded: e.name ? void 0 : !0,
      sx: {
        [`& .${ui.description}`]: {
          color: i.palette.text.primary
        },
        [`& .${ui.heading}`]: {
          flexBasis: "33.33%",
          flexShrink: 0,
          fontSize: i.typography.pxToRem(15),
          color: i.palette.text.primary
        },
        [`& .${ui.secondaryHeading}`]: {
          alignSelf: "end",
          color: i.palette.text.secondary,
          fontSize: i.typography.pxToRem(15)
        },
        "& .MuiAccordionSummary-root": {
          backgroundColor: i.palette.background.paper,
          color: i.palette.text.primary
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
          color: `${i.palette.text.primary} !important`
        },
        "& .MuiAccordionSummary-expandIconWrapper svg": {
          color: `${i.palette.text.primary} !important`
        },
        "& .MuiAccordionDetails-root": {
          backgroundColor: i.palette.background.paper,
          color: i.palette.text.primary
        },
        "& .MuiTypography-root": {
          color: i.palette.text.primary
        },
        "& .MuiTypography-colorPrimary": {
          color: i.palette.primary.main
        }
      },
      children: [
        /* @__PURE__ */ R.jsx(
          cv,
          {
            style: { justifyContent: "space-between" },
            expandIcon: !e.name || t ? null : /* @__PURE__ */ R.jsx(_s, {}),
            sx: {
              "& .MuiAccordionSummary-expandIconWrapper": {
                order: -1,
                marginRight: 1,
                marginLeft: 0
              },
              "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                transform: "rotate(90deg)"
              }
            },
            children: /* @__PURE__ */ R.jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  height: "100%",
                  alignItems: "center"
                },
                children: [
                  /* @__PURE__ */ R.jsx(ye, { className: ui.heading, children: e.name }),
                  /* @__PURE__ */ R.jsx(ye, { className: ui.secondaryHeading, children: e.summary }),
                  n ? null : /* @__PURE__ */ R.jsx(ye, { className: ui.secondaryHeading, children: e.required ? "true" : "false" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ R.jsx(fr, { style: { display: "block", overflowX: "auto" }, children: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          e.description && /* @__PURE__ */ R.jsx(
            Bs,
            {
              uiSchema: r,
              source: e.description,
              className: ui.description
            }
          ),
          e.schema && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
            /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "schema" }),
            /* @__PURE__ */ R.jsx(KN, { schema: e.schema })
          ] })
        ] }) })
      ]
    }
  );
};
class Ste extends xr {
  render() {
    const { schema: t, disableTransitionProps: n } = this.props;
    if (!t || !t.components || !t.components.contentDescriptors)
      return null;
    const r = Object.entries(t.components.contentDescriptors);
    return r.length === 0 ? null : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(ye, { variant: "h3", gutterBottom: !0, children: "ContentDescriptors" }),
      r.map(([a, i]) => /* @__PURE__ */ R.jsx(
        iE,
        {
          contentDescriptor: i,
          disableTransitionProps: n,
          uiSchema: this.props.uiSchema,
          hideRequired: !0
        },
        a
      ))
    ] });
  }
}
var is = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var xte = is.exports, Hk;
function Tte() {
  return Hk || (Hk = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", u = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", d = 500, p = "__lodash_placeholder__", f = 1, m = 2, h = 4, E = 1, y = 2, w = 1, x = 2, I = 4, S = 8, C = 16, T = 32, A = 64, O = 128, U = 256, P = 512, b = 30, L = "...", j = 800, G = 16, H = 1, ne = 2, ue = 3, ce = 1 / 0, Q = 9007199254740991, de = 17976931348623157e292, D = NaN, le = 4294967295, Ae = le - 1, M = le >>> 1, he = [
        ["ary", O],
        ["bind", w],
        ["bindKey", x],
        ["curry", S],
        ["curryRight", C],
        ["flip", P],
        ["partial", T],
        ["partialRight", A],
        ["rearg", U]
      ], se = "[object Arguments]", ie = "[object Array]", xe = "[object AsyncFunction]", _e = "[object Boolean]", Le = "[object Date]", tt = "[object DOMException]", at = "[object Error]", tn = "[object Function]", Ge = "[object GeneratorFunction]", St = "[object Map]", nn = "[object Number]", kt = "[object Null]", Ze = "[object Object]", Nt = "[object Promise]", wn = "[object Proxy]", Rt = "[object RegExp]", me = "[object Set]", Ee = "[object String]", ar = "[object Symbol]", Bn = "[object Undefined]", bt = "[object WeakMap]", Y = "[object WeakSet]", re = "[object ArrayBuffer]", fe = "[object DataView]", Se = "[object Float32Array]", Pe = "[object Float64Array]", Bt = "[object Int8Array]", $t = "[object Int16Array]", Ut = "[object Int32Array]", Yt = "[object Uint8Array]", xt = "[object Uint8ClampedArray]", Ot = "[object Uint16Array]", rn = "[object Uint32Array]", Xt = /\b__p \+= '';/g, hn = /\b(__p \+=) '' \+/g, Te = /(__e\(.*?\)|\b__t\)) \+\n'';/g, An = /&(?:amp|lt|gt|quot|#39);/g, Dr = /[&<>"']/g, Ja = RegExp(An.source), Qa = RegExp(Dr.source), $s = /<%-([\s\S]+?)%>/g, Io = /<%([\s\S]+?)%>/g, hE = /<%=([\s\S]+?)%>/g, SL = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xL = /^\w*$/, TL = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, xc = /[\\^$.*+?()[\]{}|]/g, wL = RegExp(xc.source), Tc = /^\s+/, AL = /\s/, IL = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, RL = /\{\n\/\* \[wrapped with (.+)\] \*/, _L = /,? & /, CL = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, kL = /[()=,{}\[\]\/\s]/, NL = /\\(\\)?/g, OL = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, bE = /\w*$/, LL = /^[-+]0x[0-9a-f]+$/i, DL = /^0b[01]+$/i, ML = /^\[object .+?Constructor\]$/, FL = /^0o[0-7]+$/i, PL = /^(?:0|[1-9]\d*)$/, BL = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Us = /($^)/, $L = /['\n\r\u2028\u2029\\]/g, js = "\\ud800-\\udfff", UL = "\\u0300-\\u036f", jL = "\\ufe20-\\ufe2f", qL = "\\u20d0-\\u20ff", yE = UL + jL + qL, vE = "\\u2700-\\u27bf", EE = "a-z\\xdf-\\xf6\\xf8-\\xff", zL = "\\xac\\xb1\\xd7\\xf7", GL = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", HL = "\\u2000-\\u206f", VL = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", SE = "A-Z\\xc0-\\xd6\\xd8-\\xde", xE = "\\ufe0e\\ufe0f", TE = zL + GL + HL + VL, wc = "['’]", WL = "[" + js + "]", wE = "[" + TE + "]", qs = "[" + yE + "]", AE = "\\d+", KL = "[" + vE + "]", IE = "[" + EE + "]", RE = "[^" + js + TE + AE + vE + EE + SE + "]", Ac = "\\ud83c[\\udffb-\\udfff]", YL = "(?:" + qs + "|" + Ac + ")", _E = "[^" + js + "]", Ic = "(?:\\ud83c[\\udde6-\\uddff]){2}", Rc = "[\\ud800-\\udbff][\\udc00-\\udfff]", ki = "[" + SE + "]", CE = "\\u200d", kE = "(?:" + IE + "|" + RE + ")", XL = "(?:" + ki + "|" + RE + ")", NE = "(?:" + wc + "(?:d|ll|m|re|s|t|ve))?", OE = "(?:" + wc + "(?:D|LL|M|RE|S|T|VE))?", LE = YL + "?", DE = "[" + xE + "]?", ZL = "(?:" + CE + "(?:" + [_E, Ic, Rc].join("|") + ")" + DE + LE + ")*", JL = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", QL = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ME = DE + LE + ZL, eD = "(?:" + [KL, Ic, Rc].join("|") + ")" + ME, tD = "(?:" + [_E + qs + "?", qs, Ic, Rc, WL].join("|") + ")", nD = RegExp(wc, "g"), rD = RegExp(qs, "g"), _c = RegExp(Ac + "(?=" + Ac + ")|" + tD + ME, "g"), aD = RegExp([
        ki + "?" + IE + "+" + NE + "(?=" + [wE, ki, "$"].join("|") + ")",
        XL + "+" + OE + "(?=" + [wE, ki + kE, "$"].join("|") + ")",
        ki + "?" + kE + "+" + NE,
        ki + "+" + OE,
        QL,
        JL,
        AE,
        eD
      ].join("|"), "g"), iD = RegExp("[" + CE + js + yE + xE + "]"), oD = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, sD = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], lD = -1, yt = {};
      yt[Se] = yt[Pe] = yt[Bt] = yt[$t] = yt[Ut] = yt[Yt] = yt[xt] = yt[Ot] = yt[rn] = !0, yt[se] = yt[ie] = yt[re] = yt[_e] = yt[fe] = yt[Le] = yt[at] = yt[tn] = yt[St] = yt[nn] = yt[Ze] = yt[Rt] = yt[me] = yt[Ee] = yt[bt] = !1;
      var ft = {};
      ft[se] = ft[ie] = ft[re] = ft[fe] = ft[_e] = ft[Le] = ft[Se] = ft[Pe] = ft[Bt] = ft[$t] = ft[Ut] = ft[St] = ft[nn] = ft[Ze] = ft[Rt] = ft[me] = ft[Ee] = ft[ar] = ft[Yt] = ft[xt] = ft[Ot] = ft[rn] = !0, ft[at] = ft[tn] = ft[bt] = !1;
      var uD = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, cD = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, dD = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, pD = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, fD = parseFloat, gD = parseInt, FE = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, mD = typeof self == "object" && self && self.Object === Object && self, on = FE || mD || Function("return this")(), Cc = t && !t.nodeType && t, ei = Cc && !0 && e && !e.nodeType && e, PE = ei && ei.exports === Cc, kc = PE && FE.process, ir = function() {
        try {
          var q = ei && ei.require && ei.require("util").types;
          return q || kc && kc.binding && kc.binding("util");
        } catch {
        }
      }(), BE = ir && ir.isArrayBuffer, $E = ir && ir.isDate, UE = ir && ir.isMap, jE = ir && ir.isRegExp, qE = ir && ir.isSet, zE = ir && ir.isTypedArray;
      function $n(q, J, W) {
        switch (W.length) {
          case 0:
            return q.call(J);
          case 1:
            return q.call(J, W[0]);
          case 2:
            return q.call(J, W[0], W[1]);
          case 3:
            return q.call(J, W[0], W[1], W[2]);
        }
        return q.apply(J, W);
      }
      function hD(q, J, W, ge) {
        for (var ke = -1, He = q == null ? 0 : q.length; ++ke < He; ) {
          var Zt = q[ke];
          J(ge, Zt, W(Zt), q);
        }
        return ge;
      }
      function or(q, J) {
        for (var W = -1, ge = q == null ? 0 : q.length; ++W < ge && J(q[W], W, q) !== !1; )
          ;
        return q;
      }
      function bD(q, J) {
        for (var W = q == null ? 0 : q.length; W-- && J(q[W], W, q) !== !1; )
          ;
        return q;
      }
      function GE(q, J) {
        for (var W = -1, ge = q == null ? 0 : q.length; ++W < ge; )
          if (!J(q[W], W, q))
            return !1;
        return !0;
      }
      function Ta(q, J) {
        for (var W = -1, ge = q == null ? 0 : q.length, ke = 0, He = []; ++W < ge; ) {
          var Zt = q[W];
          J(Zt, W, q) && (He[ke++] = Zt);
        }
        return He;
      }
      function zs(q, J) {
        var W = q == null ? 0 : q.length;
        return !!W && Ni(q, J, 0) > -1;
      }
      function Nc(q, J, W) {
        for (var ge = -1, ke = q == null ? 0 : q.length; ++ge < ke; )
          if (W(J, q[ge]))
            return !0;
        return !1;
      }
      function Tt(q, J) {
        for (var W = -1, ge = q == null ? 0 : q.length, ke = Array(ge); ++W < ge; )
          ke[W] = J(q[W], W, q);
        return ke;
      }
      function wa(q, J) {
        for (var W = -1, ge = J.length, ke = q.length; ++W < ge; )
          q[ke + W] = J[W];
        return q;
      }
      function Oc(q, J, W, ge) {
        var ke = -1, He = q == null ? 0 : q.length;
        for (ge && He && (W = q[++ke]); ++ke < He; )
          W = J(W, q[ke], ke, q);
        return W;
      }
      function yD(q, J, W, ge) {
        var ke = q == null ? 0 : q.length;
        for (ge && ke && (W = q[--ke]); ke--; )
          W = J(W, q[ke], ke, q);
        return W;
      }
      function Lc(q, J) {
        for (var W = -1, ge = q == null ? 0 : q.length; ++W < ge; )
          if (J(q[W], W, q))
            return !0;
        return !1;
      }
      var vD = Dc("length");
      function ED(q) {
        return q.split("");
      }
      function SD(q) {
        return q.match(CL) || [];
      }
      function HE(q, J, W) {
        var ge;
        return W(q, function(ke, He, Zt) {
          if (J(ke, He, Zt))
            return ge = He, !1;
        }), ge;
      }
      function Gs(q, J, W, ge) {
        for (var ke = q.length, He = W + (ge ? 1 : -1); ge ? He-- : ++He < ke; )
          if (J(q[He], He, q))
            return He;
        return -1;
      }
      function Ni(q, J, W) {
        return J === J ? LD(q, J, W) : Gs(q, VE, W);
      }
      function xD(q, J, W, ge) {
        for (var ke = W - 1, He = q.length; ++ke < He; )
          if (ge(q[ke], J))
            return ke;
        return -1;
      }
      function VE(q) {
        return q !== q;
      }
      function WE(q, J) {
        var W = q == null ? 0 : q.length;
        return W ? Fc(q, J) / W : D;
      }
      function Dc(q) {
        return function(J) {
          return J == null ? n : J[q];
        };
      }
      function Mc(q) {
        return function(J) {
          return q == null ? n : q[J];
        };
      }
      function KE(q, J, W, ge, ke) {
        return ke(q, function(He, Zt, st) {
          W = ge ? (ge = !1, He) : J(W, He, Zt, st);
        }), W;
      }
      function TD(q, J) {
        var W = q.length;
        for (q.sort(J); W--; )
          q[W] = q[W].value;
        return q;
      }
      function Fc(q, J) {
        for (var W, ge = -1, ke = q.length; ++ge < ke; ) {
          var He = J(q[ge]);
          He !== n && (W = W === n ? He : W + He);
        }
        return W;
      }
      function Pc(q, J) {
        for (var W = -1, ge = Array(q); ++W < q; )
          ge[W] = J(W);
        return ge;
      }
      function wD(q, J) {
        return Tt(J, function(W) {
          return [W, q[W]];
        });
      }
      function YE(q) {
        return q && q.slice(0, QE(q) + 1).replace(Tc, "");
      }
      function Un(q) {
        return function(J) {
          return q(J);
        };
      }
      function Bc(q, J) {
        return Tt(J, function(W) {
          return q[W];
        });
      }
      function Ro(q, J) {
        return q.has(J);
      }
      function XE(q, J) {
        for (var W = -1, ge = q.length; ++W < ge && Ni(J, q[W], 0) > -1; )
          ;
        return W;
      }
      function ZE(q, J) {
        for (var W = q.length; W-- && Ni(J, q[W], 0) > -1; )
          ;
        return W;
      }
      function AD(q, J) {
        for (var W = q.length, ge = 0; W--; )
          q[W] === J && ++ge;
        return ge;
      }
      var ID = Mc(uD), RD = Mc(cD);
      function _D(q) {
        return "\\" + pD[q];
      }
      function CD(q, J) {
        return q == null ? n : q[J];
      }
      function Oi(q) {
        return iD.test(q);
      }
      function kD(q) {
        return oD.test(q);
      }
      function ND(q) {
        for (var J, W = []; !(J = q.next()).done; )
          W.push(J.value);
        return W;
      }
      function $c(q) {
        var J = -1, W = Array(q.size);
        return q.forEach(function(ge, ke) {
          W[++J] = [ke, ge];
        }), W;
      }
      function JE(q, J) {
        return function(W) {
          return q(J(W));
        };
      }
      function Aa(q, J) {
        for (var W = -1, ge = q.length, ke = 0, He = []; ++W < ge; ) {
          var Zt = q[W];
          (Zt === J || Zt === p) && (q[W] = p, He[ke++] = W);
        }
        return He;
      }
      function Hs(q) {
        var J = -1, W = Array(q.size);
        return q.forEach(function(ge) {
          W[++J] = ge;
        }), W;
      }
      function OD(q) {
        var J = -1, W = Array(q.size);
        return q.forEach(function(ge) {
          W[++J] = [ge, ge];
        }), W;
      }
      function LD(q, J, W) {
        for (var ge = W - 1, ke = q.length; ++ge < ke; )
          if (q[ge] === J)
            return ge;
        return -1;
      }
      function DD(q, J, W) {
        for (var ge = W + 1; ge--; )
          if (q[ge] === J)
            return ge;
        return ge;
      }
      function Li(q) {
        return Oi(q) ? FD(q) : vD(q);
      }
      function Rr(q) {
        return Oi(q) ? PD(q) : ED(q);
      }
      function QE(q) {
        for (var J = q.length; J-- && AL.test(q.charAt(J)); )
          ;
        return J;
      }
      var MD = Mc(dD);
      function FD(q) {
        for (var J = _c.lastIndex = 0; _c.test(q); )
          ++J;
        return J;
      }
      function PD(q) {
        return q.match(_c) || [];
      }
      function BD(q) {
        return q.match(aD) || [];
      }
      var $D = function q(J) {
        J = J == null ? on : Di.defaults(on.Object(), J, Di.pick(on, sD));
        var W = J.Array, ge = J.Date, ke = J.Error, He = J.Function, Zt = J.Math, st = J.Object, Uc = J.RegExp, UD = J.String, sr = J.TypeError, Vs = W.prototype, jD = He.prototype, Mi = st.prototype, Ws = J["__core-js_shared__"], Ks = jD.toString, nt = Mi.hasOwnProperty, qD = 0, eS = function() {
          var o = /[^.]+$/.exec(Ws && Ws.keys && Ws.keys.IE_PROTO || "");
          return o ? "Symbol(src)_1." + o : "";
        }(), Ys = Mi.toString, zD = Ks.call(st), GD = on._, HD = Uc(
          "^" + Ks.call(nt).replace(xc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Xs = PE ? J.Buffer : n, Ia = J.Symbol, Zs = J.Uint8Array, tS = Xs ? Xs.allocUnsafe : n, Js = JE(st.getPrototypeOf, st), nS = st.create, rS = Mi.propertyIsEnumerable, Qs = Vs.splice, aS = Ia ? Ia.isConcatSpreadable : n, _o = Ia ? Ia.iterator : n, ti = Ia ? Ia.toStringTag : n, el = function() {
          try {
            var o = oi(st, "defineProperty");
            return o({}, "", {}), o;
          } catch {
          }
        }(), VD = J.clearTimeout !== on.clearTimeout && J.clearTimeout, WD = ge && ge.now !== on.Date.now && ge.now, KD = J.setTimeout !== on.setTimeout && J.setTimeout, tl = Zt.ceil, nl = Zt.floor, jc = st.getOwnPropertySymbols, YD = Xs ? Xs.isBuffer : n, iS = J.isFinite, XD = Vs.join, ZD = JE(st.keys, st), Jt = Zt.max, dn = Zt.min, JD = ge.now, QD = J.parseInt, oS = Zt.random, eM = Vs.reverse, qc = oi(J, "DataView"), Co = oi(J, "Map"), zc = oi(J, "Promise"), Fi = oi(J, "Set"), ko = oi(J, "WeakMap"), No = oi(st, "create"), rl = ko && new ko(), Pi = {}, tM = si(qc), nM = si(Co), rM = si(zc), aM = si(Fi), iM = si(ko), al = Ia ? Ia.prototype : n, Oo = al ? al.valueOf : n, sS = al ? al.toString : n;
        function k(o) {
          if (Lt(o) && !Ne(o) && !(o instanceof Ue)) {
            if (o instanceof lr)
              return o;
            if (nt.call(o, "__wrapped__"))
              return lx(o);
          }
          return new lr(o);
        }
        var Bi = /* @__PURE__ */ function() {
          function o() {
          }
          return function(l) {
            if (!_t(l))
              return {};
            if (nS)
              return nS(l);
            o.prototype = l;
            var g = new o();
            return o.prototype = n, g;
          };
        }();
        function il() {
        }
        function lr(o, l) {
          this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!l, this.__index__ = 0, this.__values__ = n;
        }
        k.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: $s,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Io,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: hE,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: k
          }
        }, k.prototype = il.prototype, k.prototype.constructor = k, lr.prototype = Bi(il.prototype), lr.prototype.constructor = lr;
        function Ue(o) {
          this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = le, this.__views__ = [];
        }
        function oM() {
          var o = new Ue(this.__wrapped__);
          return o.__actions__ = In(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = In(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = In(this.__views__), o;
        }
        function sM() {
          if (this.__filtered__) {
            var o = new Ue(this);
            o.__dir__ = -1, o.__filtered__ = !0;
          } else
            o = this.clone(), o.__dir__ *= -1;
          return o;
        }
        function lM() {
          var o = this.__wrapped__.value(), l = this.__dir__, g = Ne(o), v = l < 0, _ = g ? o.length : 0, N = EF(0, _, this.__views__), F = N.start, $ = N.end, z = $ - F, ee = v ? $ : F - 1, te = this.__iteratees__, ae = te.length, pe = 0, be = dn(z, this.__takeCount__);
          if (!g || !v && _ == z && be == z)
            return NS(o, this.__actions__);
          var Ie = [];
          e:
            for (; z-- && pe < be; ) {
              ee += l;
              for (var Me = -1, Re = o[ee]; ++Me < ae; ) {
                var $e = te[Me], je = $e.iteratee, zn = $e.type, vn = je(Re);
                if (zn == ne)
                  Re = vn;
                else if (!vn) {
                  if (zn == H)
                    continue e;
                  break e;
                }
              }
              Ie[pe++] = Re;
            }
          return Ie;
        }
        Ue.prototype = Bi(il.prototype), Ue.prototype.constructor = Ue;
        function ni(o) {
          var l = -1, g = o == null ? 0 : o.length;
          for (this.clear(); ++l < g; ) {
            var v = o[l];
            this.set(v[0], v[1]);
          }
        }
        function uM() {
          this.__data__ = No ? No(null) : {}, this.size = 0;
        }
        function cM(o) {
          var l = this.has(o) && delete this.__data__[o];
          return this.size -= l ? 1 : 0, l;
        }
        function dM(o) {
          var l = this.__data__;
          if (No) {
            var g = l[o];
            return g === c ? n : g;
          }
          return nt.call(l, o) ? l[o] : n;
        }
        function pM(o) {
          var l = this.__data__;
          return No ? l[o] !== n : nt.call(l, o);
        }
        function fM(o, l) {
          var g = this.__data__;
          return this.size += this.has(o) ? 0 : 1, g[o] = No && l === n ? c : l, this;
        }
        ni.prototype.clear = uM, ni.prototype.delete = cM, ni.prototype.get = dM, ni.prototype.has = pM, ni.prototype.set = fM;
        function ea(o) {
          var l = -1, g = o == null ? 0 : o.length;
          for (this.clear(); ++l < g; ) {
            var v = o[l];
            this.set(v[0], v[1]);
          }
        }
        function gM() {
          this.__data__ = [], this.size = 0;
        }
        function mM(o) {
          var l = this.__data__, g = ol(l, o);
          if (g < 0)
            return !1;
          var v = l.length - 1;
          return g == v ? l.pop() : Qs.call(l, g, 1), --this.size, !0;
        }
        function hM(o) {
          var l = this.__data__, g = ol(l, o);
          return g < 0 ? n : l[g][1];
        }
        function bM(o) {
          return ol(this.__data__, o) > -1;
        }
        function yM(o, l) {
          var g = this.__data__, v = ol(g, o);
          return v < 0 ? (++this.size, g.push([o, l])) : g[v][1] = l, this;
        }
        ea.prototype.clear = gM, ea.prototype.delete = mM, ea.prototype.get = hM, ea.prototype.has = bM, ea.prototype.set = yM;
        function ta(o) {
          var l = -1, g = o == null ? 0 : o.length;
          for (this.clear(); ++l < g; ) {
            var v = o[l];
            this.set(v[0], v[1]);
          }
        }
        function vM() {
          this.size = 0, this.__data__ = {
            hash: new ni(),
            map: new (Co || ea)(),
            string: new ni()
          };
        }
        function EM(o) {
          var l = yl(this, o).delete(o);
          return this.size -= l ? 1 : 0, l;
        }
        function SM(o) {
          return yl(this, o).get(o);
        }
        function xM(o) {
          return yl(this, o).has(o);
        }
        function TM(o, l) {
          var g = yl(this, o), v = g.size;
          return g.set(o, l), this.size += g.size == v ? 0 : 1, this;
        }
        ta.prototype.clear = vM, ta.prototype.delete = EM, ta.prototype.get = SM, ta.prototype.has = xM, ta.prototype.set = TM;
        function ri(o) {
          var l = -1, g = o == null ? 0 : o.length;
          for (this.__data__ = new ta(); ++l < g; )
            this.add(o[l]);
        }
        function wM(o) {
          return this.__data__.set(o, c), this;
        }
        function AM(o) {
          return this.__data__.has(o);
        }
        ri.prototype.add = ri.prototype.push = wM, ri.prototype.has = AM;
        function _r(o) {
          var l = this.__data__ = new ea(o);
          this.size = l.size;
        }
        function IM() {
          this.__data__ = new ea(), this.size = 0;
        }
        function RM(o) {
          var l = this.__data__, g = l.delete(o);
          return this.size = l.size, g;
        }
        function _M(o) {
          return this.__data__.get(o);
        }
        function CM(o) {
          return this.__data__.has(o);
        }
        function kM(o, l) {
          var g = this.__data__;
          if (g instanceof ea) {
            var v = g.__data__;
            if (!Co || v.length < a - 1)
              return v.push([o, l]), this.size = ++g.size, this;
            g = this.__data__ = new ta(v);
          }
          return g.set(o, l), this.size = g.size, this;
        }
        _r.prototype.clear = IM, _r.prototype.delete = RM, _r.prototype.get = _M, _r.prototype.has = CM, _r.prototype.set = kM;
        function lS(o, l) {
          var g = Ne(o), v = !g && li(o), _ = !g && !v && Na(o), N = !g && !v && !_ && qi(o), F = g || v || _ || N, $ = F ? Pc(o.length, UD) : [], z = $.length;
          for (var ee in o)
            (l || nt.call(o, ee)) && !(F && // Safari 9 has enumerable `arguments.length` in strict mode.
            (ee == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            _ && (ee == "offset" || ee == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            N && (ee == "buffer" || ee == "byteLength" || ee == "byteOffset") || // Skip index properties.
            ia(ee, z))) && $.push(ee);
          return $;
        }
        function uS(o) {
          var l = o.length;
          return l ? o[ed(0, l - 1)] : n;
        }
        function NM(o, l) {
          return vl(In(o), ai(l, 0, o.length));
        }
        function OM(o) {
          return vl(In(o));
        }
        function Gc(o, l, g) {
          (g !== n && !Cr(o[l], g) || g === n && !(l in o)) && na(o, l, g);
        }
        function Lo(o, l, g) {
          var v = o[l];
          (!(nt.call(o, l) && Cr(v, g)) || g === n && !(l in o)) && na(o, l, g);
        }
        function ol(o, l) {
          for (var g = o.length; g--; )
            if (Cr(o[g][0], l))
              return g;
          return -1;
        }
        function LM(o, l, g, v) {
          return Ra(o, function(_, N, F) {
            l(v, _, g(_), F);
          }), v;
        }
        function cS(o, l) {
          return o && Fr(l, an(l), o);
        }
        function DM(o, l) {
          return o && Fr(l, _n(l), o);
        }
        function na(o, l, g) {
          l == "__proto__" && el ? el(o, l, {
            configurable: !0,
            enumerable: !0,
            value: g,
            writable: !0
          }) : o[l] = g;
        }
        function Hc(o, l) {
          for (var g = -1, v = l.length, _ = W(v), N = o == null; ++g < v; )
            _[g] = N ? n : Ad(o, l[g]);
          return _;
        }
        function ai(o, l, g) {
          return o === o && (g !== n && (o = o <= g ? o : g), l !== n && (o = o >= l ? o : l)), o;
        }
        function ur(o, l, g, v, _, N) {
          var F, $ = l & f, z = l & m, ee = l & h;
          if (g && (F = _ ? g(o, v, _, N) : g(o)), F !== n)
            return F;
          if (!_t(o))
            return o;
          var te = Ne(o);
          if (te) {
            if (F = xF(o), !$)
              return In(o, F);
          } else {
            var ae = pn(o), pe = ae == tn || ae == Ge;
            if (Na(o))
              return DS(o, $);
            if (ae == Ze || ae == se || pe && !_) {
              if (F = z || pe ? {} : QS(o), !$)
                return z ? dF(o, DM(F, o)) : cF(o, cS(F, o));
            } else {
              if (!ft[ae])
                return _ ? o : {};
              F = TF(o, ae, $);
            }
          }
          N || (N = new _r());
          var be = N.get(o);
          if (be)
            return be;
          N.set(o, F), _x(o) ? o.forEach(function(Re) {
            F.add(ur(Re, l, g, Re, o, N));
          }) : Ix(o) && o.forEach(function(Re, $e) {
            F.set($e, ur(Re, l, g, $e, o, N));
          });
          var Ie = ee ? z ? dd : cd : z ? _n : an, Me = te ? n : Ie(o);
          return or(Me || o, function(Re, $e) {
            Me && ($e = Re, Re = o[$e]), Lo(F, $e, ur(Re, l, g, $e, o, N));
          }), F;
        }
        function MM(o) {
          var l = an(o);
          return function(g) {
            return dS(g, o, l);
          };
        }
        function dS(o, l, g) {
          var v = g.length;
          if (o == null)
            return !v;
          for (o = st(o); v--; ) {
            var _ = g[v], N = l[_], F = o[_];
            if (F === n && !(_ in o) || !N(F))
              return !1;
          }
          return !0;
        }
        function pS(o, l, g) {
          if (typeof o != "function")
            throw new sr(s);
          return Uo(function() {
            o.apply(n, g);
          }, l);
        }
        function Do(o, l, g, v) {
          var _ = -1, N = zs, F = !0, $ = o.length, z = [], ee = l.length;
          if (!$)
            return z;
          g && (l = Tt(l, Un(g))), v ? (N = Nc, F = !1) : l.length >= a && (N = Ro, F = !1, l = new ri(l));
          e:
            for (; ++_ < $; ) {
              var te = o[_], ae = g == null ? te : g(te);
              if (te = v || te !== 0 ? te : 0, F && ae === ae) {
                for (var pe = ee; pe--; )
                  if (l[pe] === ae)
                    continue e;
                z.push(te);
              } else N(l, ae, v) || z.push(te);
            }
          return z;
        }
        var Ra = $S(Mr), fS = $S(Wc, !0);
        function FM(o, l) {
          var g = !0;
          return Ra(o, function(v, _, N) {
            return g = !!l(v, _, N), g;
          }), g;
        }
        function sl(o, l, g) {
          for (var v = -1, _ = o.length; ++v < _; ) {
            var N = o[v], F = l(N);
            if (F != null && ($ === n ? F === F && !qn(F) : g(F, $)))
              var $ = F, z = N;
          }
          return z;
        }
        function PM(o, l, g, v) {
          var _ = o.length;
          for (g = De(g), g < 0 && (g = -g > _ ? 0 : _ + g), v = v === n || v > _ ? _ : De(v), v < 0 && (v += _), v = g > v ? 0 : kx(v); g < v; )
            o[g++] = l;
          return o;
        }
        function gS(o, l) {
          var g = [];
          return Ra(o, function(v, _, N) {
            l(v, _, N) && g.push(v);
          }), g;
        }
        function sn(o, l, g, v, _) {
          var N = -1, F = o.length;
          for (g || (g = AF), _ || (_ = []); ++N < F; ) {
            var $ = o[N];
            l > 0 && g($) ? l > 1 ? sn($, l - 1, g, v, _) : wa(_, $) : v || (_[_.length] = $);
          }
          return _;
        }
        var Vc = US(), mS = US(!0);
        function Mr(o, l) {
          return o && Vc(o, l, an);
        }
        function Wc(o, l) {
          return o && mS(o, l, an);
        }
        function ll(o, l) {
          return Ta(l, function(g) {
            return oa(o[g]);
          });
        }
        function ii(o, l) {
          l = Ca(l, o);
          for (var g = 0, v = l.length; o != null && g < v; )
            o = o[Pr(l[g++])];
          return g && g == v ? o : n;
        }
        function hS(o, l, g) {
          var v = l(o);
          return Ne(o) ? v : wa(v, g(o));
        }
        function bn(o) {
          return o == null ? o === n ? Bn : kt : ti && ti in st(o) ? vF(o) : OF(o);
        }
        function Kc(o, l) {
          return o > l;
        }
        function BM(o, l) {
          return o != null && nt.call(o, l);
        }
        function $M(o, l) {
          return o != null && l in st(o);
        }
        function UM(o, l, g) {
          return o >= dn(l, g) && o < Jt(l, g);
        }
        function Yc(o, l, g) {
          for (var v = g ? Nc : zs, _ = o[0].length, N = o.length, F = N, $ = W(N), z = 1 / 0, ee = []; F--; ) {
            var te = o[F];
            F && l && (te = Tt(te, Un(l))), z = dn(te.length, z), $[F] = !g && (l || _ >= 120 && te.length >= 120) ? new ri(F && te) : n;
          }
          te = o[0];
          var ae = -1, pe = $[0];
          e:
            for (; ++ae < _ && ee.length < z; ) {
              var be = te[ae], Ie = l ? l(be) : be;
              if (be = g || be !== 0 ? be : 0, !(pe ? Ro(pe, Ie) : v(ee, Ie, g))) {
                for (F = N; --F; ) {
                  var Me = $[F];
                  if (!(Me ? Ro(Me, Ie) : v(o[F], Ie, g)))
                    continue e;
                }
                pe && pe.push(Ie), ee.push(be);
              }
            }
          return ee;
        }
        function jM(o, l, g, v) {
          return Mr(o, function(_, N, F) {
            l(v, g(_), N, F);
          }), v;
        }
        function Mo(o, l, g) {
          l = Ca(l, o), o = rx(o, l);
          var v = o == null ? o : o[Pr(dr(l))];
          return v == null ? n : $n(v, o, g);
        }
        function bS(o) {
          return Lt(o) && bn(o) == se;
        }
        function qM(o) {
          return Lt(o) && bn(o) == re;
        }
        function zM(o) {
          return Lt(o) && bn(o) == Le;
        }
        function Fo(o, l, g, v, _) {
          return o === l ? !0 : o == null || l == null || !Lt(o) && !Lt(l) ? o !== o && l !== l : GM(o, l, g, v, Fo, _);
        }
        function GM(o, l, g, v, _, N) {
          var F = Ne(o), $ = Ne(l), z = F ? ie : pn(o), ee = $ ? ie : pn(l);
          z = z == se ? Ze : z, ee = ee == se ? Ze : ee;
          var te = z == Ze, ae = ee == Ze, pe = z == ee;
          if (pe && Na(o)) {
            if (!Na(l))
              return !1;
            F = !0, te = !1;
          }
          if (pe && !te)
            return N || (N = new _r()), F || qi(o) ? XS(o, l, g, v, _, N) : bF(o, l, z, g, v, _, N);
          if (!(g & E)) {
            var be = te && nt.call(o, "__wrapped__"), Ie = ae && nt.call(l, "__wrapped__");
            if (be || Ie) {
              var Me = be ? o.value() : o, Re = Ie ? l.value() : l;
              return N || (N = new _r()), _(Me, Re, g, v, N);
            }
          }
          return pe ? (N || (N = new _r()), yF(o, l, g, v, _, N)) : !1;
        }
        function HM(o) {
          return Lt(o) && pn(o) == St;
        }
        function Xc(o, l, g, v) {
          var _ = g.length, N = _, F = !v;
          if (o == null)
            return !N;
          for (o = st(o); _--; ) {
            var $ = g[_];
            if (F && $[2] ? $[1] !== o[$[0]] : !($[0] in o))
              return !1;
          }
          for (; ++_ < N; ) {
            $ = g[_];
            var z = $[0], ee = o[z], te = $[1];
            if (F && $[2]) {
              if (ee === n && !(z in o))
                return !1;
            } else {
              var ae = new _r();
              if (v)
                var pe = v(ee, te, z, o, l, ae);
              if (!(pe === n ? Fo(te, ee, E | y, v, ae) : pe))
                return !1;
            }
          }
          return !0;
        }
        function yS(o) {
          if (!_t(o) || RF(o))
            return !1;
          var l = oa(o) ? HD : ML;
          return l.test(si(o));
        }
        function VM(o) {
          return Lt(o) && bn(o) == Rt;
        }
        function WM(o) {
          return Lt(o) && pn(o) == me;
        }
        function KM(o) {
          return Lt(o) && Al(o.length) && !!yt[bn(o)];
        }
        function vS(o) {
          return typeof o == "function" ? o : o == null ? Cn : typeof o == "object" ? Ne(o) ? xS(o[0], o[1]) : SS(o) : jx(o);
        }
        function Zc(o) {
          if (!$o(o))
            return ZD(o);
          var l = [];
          for (var g in st(o))
            nt.call(o, g) && g != "constructor" && l.push(g);
          return l;
        }
        function YM(o) {
          if (!_t(o))
            return NF(o);
          var l = $o(o), g = [];
          for (var v in o)
            v == "constructor" && (l || !nt.call(o, v)) || g.push(v);
          return g;
        }
        function Jc(o, l) {
          return o < l;
        }
        function ES(o, l) {
          var g = -1, v = Rn(o) ? W(o.length) : [];
          return Ra(o, function(_, N, F) {
            v[++g] = l(_, N, F);
          }), v;
        }
        function SS(o) {
          var l = fd(o);
          return l.length == 1 && l[0][2] ? tx(l[0][0], l[0][1]) : function(g) {
            return g === o || Xc(g, o, l);
          };
        }
        function xS(o, l) {
          return md(o) && ex(l) ? tx(Pr(o), l) : function(g) {
            var v = Ad(g, o);
            return v === n && v === l ? Id(g, o) : Fo(l, v, E | y);
          };
        }
        function ul(o, l, g, v, _) {
          o !== l && Vc(l, function(N, F) {
            if (_ || (_ = new _r()), _t(N))
              XM(o, l, F, g, ul, v, _);
            else {
              var $ = v ? v(bd(o, F), N, F + "", o, l, _) : n;
              $ === n && ($ = N), Gc(o, F, $);
            }
          }, _n);
        }
        function XM(o, l, g, v, _, N, F) {
          var $ = bd(o, g), z = bd(l, g), ee = F.get(z);
          if (ee) {
            Gc(o, g, ee);
            return;
          }
          var te = N ? N($, z, g + "", o, l, F) : n, ae = te === n;
          if (ae) {
            var pe = Ne(z), be = !pe && Na(z), Ie = !pe && !be && qi(z);
            te = z, pe || be || Ie ? Ne($) ? te = $ : jt($) ? te = In($) : be ? (ae = !1, te = DS(z, !0)) : Ie ? (ae = !1, te = MS(z, !0)) : te = [] : jo(z) || li(z) ? (te = $, li($) ? te = Nx($) : (!_t($) || oa($)) && (te = QS(z))) : ae = !1;
          }
          ae && (F.set(z, te), _(te, z, v, N, F), F.delete(z)), Gc(o, g, te);
        }
        function TS(o, l) {
          var g = o.length;
          if (g)
            return l += l < 0 ? g : 0, ia(l, g) ? o[l] : n;
        }
        function wS(o, l, g) {
          l.length ? l = Tt(l, function(N) {
            return Ne(N) ? function(F) {
              return ii(F, N.length === 1 ? N[0] : N);
            } : N;
          }) : l = [Cn];
          var v = -1;
          l = Tt(l, Un(we()));
          var _ = ES(o, function(N, F, $) {
            var z = Tt(l, function(ee) {
              return ee(N);
            });
            return { criteria: z, index: ++v, value: N };
          });
          return TD(_, function(N, F) {
            return uF(N, F, g);
          });
        }
        function ZM(o, l) {
          return AS(o, l, function(g, v) {
            return Id(o, v);
          });
        }
        function AS(o, l, g) {
          for (var v = -1, _ = l.length, N = {}; ++v < _; ) {
            var F = l[v], $ = ii(o, F);
            g($, F) && Po(N, Ca(F, o), $);
          }
          return N;
        }
        function JM(o) {
          return function(l) {
            return ii(l, o);
          };
        }
        function Qc(o, l, g, v) {
          var _ = v ? xD : Ni, N = -1, F = l.length, $ = o;
          for (o === l && (l = In(l)), g && ($ = Tt(o, Un(g))); ++N < F; )
            for (var z = 0, ee = l[N], te = g ? g(ee) : ee; (z = _($, te, z, v)) > -1; )
              $ !== o && Qs.call($, z, 1), Qs.call(o, z, 1);
          return o;
        }
        function IS(o, l) {
          for (var g = o ? l.length : 0, v = g - 1; g--; ) {
            var _ = l[g];
            if (g == v || _ !== N) {
              var N = _;
              ia(_) ? Qs.call(o, _, 1) : rd(o, _);
            }
          }
          return o;
        }
        function ed(o, l) {
          return o + nl(oS() * (l - o + 1));
        }
        function QM(o, l, g, v) {
          for (var _ = -1, N = Jt(tl((l - o) / (g || 1)), 0), F = W(N); N--; )
            F[v ? N : ++_] = o, o += g;
          return F;
        }
        function td(o, l) {
          var g = "";
          if (!o || l < 1 || l > Q)
            return g;
          do
            l % 2 && (g += o), l = nl(l / 2), l && (o += o);
          while (l);
          return g;
        }
        function Fe(o, l) {
          return yd(nx(o, l, Cn), o + "");
        }
        function eF(o) {
          return uS(zi(o));
        }
        function tF(o, l) {
          var g = zi(o);
          return vl(g, ai(l, 0, g.length));
        }
        function Po(o, l, g, v) {
          if (!_t(o))
            return o;
          l = Ca(l, o);
          for (var _ = -1, N = l.length, F = N - 1, $ = o; $ != null && ++_ < N; ) {
            var z = Pr(l[_]), ee = g;
            if (z === "__proto__" || z === "constructor" || z === "prototype")
              return o;
            if (_ != F) {
              var te = $[z];
              ee = v ? v(te, z, $) : n, ee === n && (ee = _t(te) ? te : ia(l[_ + 1]) ? [] : {});
            }
            Lo($, z, ee), $ = $[z];
          }
          return o;
        }
        var RS = rl ? function(o, l) {
          return rl.set(o, l), o;
        } : Cn, nF = el ? function(o, l) {
          return el(o, "toString", {
            configurable: !0,
            enumerable: !1,
            value: _d(l),
            writable: !0
          });
        } : Cn;
        function rF(o) {
          return vl(zi(o));
        }
        function cr(o, l, g) {
          var v = -1, _ = o.length;
          l < 0 && (l = -l > _ ? 0 : _ + l), g = g > _ ? _ : g, g < 0 && (g += _), _ = l > g ? 0 : g - l >>> 0, l >>>= 0;
          for (var N = W(_); ++v < _; )
            N[v] = o[v + l];
          return N;
        }
        function aF(o, l) {
          var g;
          return Ra(o, function(v, _, N) {
            return g = l(v, _, N), !g;
          }), !!g;
        }
        function cl(o, l, g) {
          var v = 0, _ = o == null ? v : o.length;
          if (typeof l == "number" && l === l && _ <= M) {
            for (; v < _; ) {
              var N = v + _ >>> 1, F = o[N];
              F !== null && !qn(F) && (g ? F <= l : F < l) ? v = N + 1 : _ = N;
            }
            return _;
          }
          return nd(o, l, Cn, g);
        }
        function nd(o, l, g, v) {
          var _ = 0, N = o == null ? 0 : o.length;
          if (N === 0)
            return 0;
          l = g(l);
          for (var F = l !== l, $ = l === null, z = qn(l), ee = l === n; _ < N; ) {
            var te = nl((_ + N) / 2), ae = g(o[te]), pe = ae !== n, be = ae === null, Ie = ae === ae, Me = qn(ae);
            if (F)
              var Re = v || Ie;
            else ee ? Re = Ie && (v || pe) : $ ? Re = Ie && pe && (v || !be) : z ? Re = Ie && pe && !be && (v || !Me) : be || Me ? Re = !1 : Re = v ? ae <= l : ae < l;
            Re ? _ = te + 1 : N = te;
          }
          return dn(N, Ae);
        }
        function _S(o, l) {
          for (var g = -1, v = o.length, _ = 0, N = []; ++g < v; ) {
            var F = o[g], $ = l ? l(F) : F;
            if (!g || !Cr($, z)) {
              var z = $;
              N[_++] = F === 0 ? 0 : F;
            }
          }
          return N;
        }
        function CS(o) {
          return typeof o == "number" ? o : qn(o) ? D : +o;
        }
        function jn(o) {
          if (typeof o == "string")
            return o;
          if (Ne(o))
            return Tt(o, jn) + "";
          if (qn(o))
            return sS ? sS.call(o) : "";
          var l = o + "";
          return l == "0" && 1 / o == -1 / 0 ? "-0" : l;
        }
        function _a(o, l, g) {
          var v = -1, _ = zs, N = o.length, F = !0, $ = [], z = $;
          if (g)
            F = !1, _ = Nc;
          else if (N >= a) {
            var ee = l ? null : mF(o);
            if (ee)
              return Hs(ee);
            F = !1, _ = Ro, z = new ri();
          } else
            z = l ? [] : $;
          e:
            for (; ++v < N; ) {
              var te = o[v], ae = l ? l(te) : te;
              if (te = g || te !== 0 ? te : 0, F && ae === ae) {
                for (var pe = z.length; pe--; )
                  if (z[pe] === ae)
                    continue e;
                l && z.push(ae), $.push(te);
              } else _(z, ae, g) || (z !== $ && z.push(ae), $.push(te));
            }
          return $;
        }
        function rd(o, l) {
          return l = Ca(l, o), o = rx(o, l), o == null || delete o[Pr(dr(l))];
        }
        function kS(o, l, g, v) {
          return Po(o, l, g(ii(o, l)), v);
        }
        function dl(o, l, g, v) {
          for (var _ = o.length, N = v ? _ : -1; (v ? N-- : ++N < _) && l(o[N], N, o); )
            ;
          return g ? cr(o, v ? 0 : N, v ? N + 1 : _) : cr(o, v ? N + 1 : 0, v ? _ : N);
        }
        function NS(o, l) {
          var g = o;
          return g instanceof Ue && (g = g.value()), Oc(l, function(v, _) {
            return _.func.apply(_.thisArg, wa([v], _.args));
          }, g);
        }
        function ad(o, l, g) {
          var v = o.length;
          if (v < 2)
            return v ? _a(o[0]) : [];
          for (var _ = -1, N = W(v); ++_ < v; )
            for (var F = o[_], $ = -1; ++$ < v; )
              $ != _ && (N[_] = Do(N[_] || F, o[$], l, g));
          return _a(sn(N, 1), l, g);
        }
        function OS(o, l, g) {
          for (var v = -1, _ = o.length, N = l.length, F = {}; ++v < _; ) {
            var $ = v < N ? l[v] : n;
            g(F, o[v], $);
          }
          return F;
        }
        function id(o) {
          return jt(o) ? o : [];
        }
        function od(o) {
          return typeof o == "function" ? o : Cn;
        }
        function Ca(o, l) {
          return Ne(o) ? o : md(o, l) ? [o] : sx(Je(o));
        }
        var iF = Fe;
        function ka(o, l, g) {
          var v = o.length;
          return g = g === n ? v : g, !l && g >= v ? o : cr(o, l, g);
        }
        var LS = VD || function(o) {
          return on.clearTimeout(o);
        };
        function DS(o, l) {
          if (l)
            return o.slice();
          var g = o.length, v = tS ? tS(g) : new o.constructor(g);
          return o.copy(v), v;
        }
        function sd(o) {
          var l = new o.constructor(o.byteLength);
          return new Zs(l).set(new Zs(o)), l;
        }
        function oF(o, l) {
          var g = l ? sd(o.buffer) : o.buffer;
          return new o.constructor(g, o.byteOffset, o.byteLength);
        }
        function sF(o) {
          var l = new o.constructor(o.source, bE.exec(o));
          return l.lastIndex = o.lastIndex, l;
        }
        function lF(o) {
          return Oo ? st(Oo.call(o)) : {};
        }
        function MS(o, l) {
          var g = l ? sd(o.buffer) : o.buffer;
          return new o.constructor(g, o.byteOffset, o.length);
        }
        function FS(o, l) {
          if (o !== l) {
            var g = o !== n, v = o === null, _ = o === o, N = qn(o), F = l !== n, $ = l === null, z = l === l, ee = qn(l);
            if (!$ && !ee && !N && o > l || N && F && z && !$ && !ee || v && F && z || !g && z || !_)
              return 1;
            if (!v && !N && !ee && o < l || ee && g && _ && !v && !N || $ && g && _ || !F && _ || !z)
              return -1;
          }
          return 0;
        }
        function uF(o, l, g) {
          for (var v = -1, _ = o.criteria, N = l.criteria, F = _.length, $ = g.length; ++v < F; ) {
            var z = FS(_[v], N[v]);
            if (z) {
              if (v >= $)
                return z;
              var ee = g[v];
              return z * (ee == "desc" ? -1 : 1);
            }
          }
          return o.index - l.index;
        }
        function PS(o, l, g, v) {
          for (var _ = -1, N = o.length, F = g.length, $ = -1, z = l.length, ee = Jt(N - F, 0), te = W(z + ee), ae = !v; ++$ < z; )
            te[$] = l[$];
          for (; ++_ < F; )
            (ae || _ < N) && (te[g[_]] = o[_]);
          for (; ee--; )
            te[$++] = o[_++];
          return te;
        }
        function BS(o, l, g, v) {
          for (var _ = -1, N = o.length, F = -1, $ = g.length, z = -1, ee = l.length, te = Jt(N - $, 0), ae = W(te + ee), pe = !v; ++_ < te; )
            ae[_] = o[_];
          for (var be = _; ++z < ee; )
            ae[be + z] = l[z];
          for (; ++F < $; )
            (pe || _ < N) && (ae[be + g[F]] = o[_++]);
          return ae;
        }
        function In(o, l) {
          var g = -1, v = o.length;
          for (l || (l = W(v)); ++g < v; )
            l[g] = o[g];
          return l;
        }
        function Fr(o, l, g, v) {
          var _ = !g;
          g || (g = {});
          for (var N = -1, F = l.length; ++N < F; ) {
            var $ = l[N], z = v ? v(g[$], o[$], $, g, o) : n;
            z === n && (z = o[$]), _ ? na(g, $, z) : Lo(g, $, z);
          }
          return g;
        }
        function cF(o, l) {
          return Fr(o, gd(o), l);
        }
        function dF(o, l) {
          return Fr(o, ZS(o), l);
        }
        function pl(o, l) {
          return function(g, v) {
            var _ = Ne(g) ? hD : LM, N = l ? l() : {};
            return _(g, o, we(v, 2), N);
          };
        }
        function $i(o) {
          return Fe(function(l, g) {
            var v = -1, _ = g.length, N = _ > 1 ? g[_ - 1] : n, F = _ > 2 ? g[2] : n;
            for (N = o.length > 3 && typeof N == "function" ? (_--, N) : n, F && yn(g[0], g[1], F) && (N = _ < 3 ? n : N, _ = 1), l = st(l); ++v < _; ) {
              var $ = g[v];
              $ && o(l, $, v, N);
            }
            return l;
          });
        }
        function $S(o, l) {
          return function(g, v) {
            if (g == null)
              return g;
            if (!Rn(g))
              return o(g, v);
            for (var _ = g.length, N = l ? _ : -1, F = st(g); (l ? N-- : ++N < _) && v(F[N], N, F) !== !1; )
              ;
            return g;
          };
        }
        function US(o) {
          return function(l, g, v) {
            for (var _ = -1, N = st(l), F = v(l), $ = F.length; $--; ) {
              var z = F[o ? $ : ++_];
              if (g(N[z], z, N) === !1)
                break;
            }
            return l;
          };
        }
        function pF(o, l, g) {
          var v = l & w, _ = Bo(o);
          function N() {
            var F = this && this !== on && this instanceof N ? _ : o;
            return F.apply(v ? g : this, arguments);
          }
          return N;
        }
        function jS(o) {
          return function(l) {
            l = Je(l);
            var g = Oi(l) ? Rr(l) : n, v = g ? g[0] : l.charAt(0), _ = g ? ka(g, 1).join("") : l.slice(1);
            return v[o]() + _;
          };
        }
        function Ui(o) {
          return function(l) {
            return Oc($x(Bx(l).replace(nD, "")), o, "");
          };
        }
        function Bo(o) {
          return function() {
            var l = arguments;
            switch (l.length) {
              case 0:
                return new o();
              case 1:
                return new o(l[0]);
              case 2:
                return new o(l[0], l[1]);
              case 3:
                return new o(l[0], l[1], l[2]);
              case 4:
                return new o(l[0], l[1], l[2], l[3]);
              case 5:
                return new o(l[0], l[1], l[2], l[3], l[4]);
              case 6:
                return new o(l[0], l[1], l[2], l[3], l[4], l[5]);
              case 7:
                return new o(l[0], l[1], l[2], l[3], l[4], l[5], l[6]);
            }
            var g = Bi(o.prototype), v = o.apply(g, l);
            return _t(v) ? v : g;
          };
        }
        function fF(o, l, g) {
          var v = Bo(o);
          function _() {
            for (var N = arguments.length, F = W(N), $ = N, z = ji(_); $--; )
              F[$] = arguments[$];
            var ee = N < 3 && F[0] !== z && F[N - 1] !== z ? [] : Aa(F, z);
            if (N -= ee.length, N < g)
              return VS(
                o,
                l,
                fl,
                _.placeholder,
                n,
                F,
                ee,
                n,
                n,
                g - N
              );
            var te = this && this !== on && this instanceof _ ? v : o;
            return $n(te, this, F);
          }
          return _;
        }
        function qS(o) {
          return function(l, g, v) {
            var _ = st(l);
            if (!Rn(l)) {
              var N = we(g, 3);
              l = an(l), g = function($) {
                return N(_[$], $, _);
              };
            }
            var F = o(l, g, v);
            return F > -1 ? _[N ? l[F] : F] : n;
          };
        }
        function zS(o) {
          return aa(function(l) {
            var g = l.length, v = g, _ = lr.prototype.thru;
            for (o && l.reverse(); v--; ) {
              var N = l[v];
              if (typeof N != "function")
                throw new sr(s);
              if (_ && !F && bl(N) == "wrapper")
                var F = new lr([], !0);
            }
            for (v = F ? v : g; ++v < g; ) {
              N = l[v];
              var $ = bl(N), z = $ == "wrapper" ? pd(N) : n;
              z && hd(z[0]) && z[1] == (O | S | T | U) && !z[4].length && z[9] == 1 ? F = F[bl(z[0])].apply(F, z[3]) : F = N.length == 1 && hd(N) ? F[$]() : F.thru(N);
            }
            return function() {
              var ee = arguments, te = ee[0];
              if (F && ee.length == 1 && Ne(te))
                return F.plant(te).value();
              for (var ae = 0, pe = g ? l[ae].apply(this, ee) : te; ++ae < g; )
                pe = l[ae].call(this, pe);
              return pe;
            };
          });
        }
        function fl(o, l, g, v, _, N, F, $, z, ee) {
          var te = l & O, ae = l & w, pe = l & x, be = l & (S | C), Ie = l & P, Me = pe ? n : Bo(o);
          function Re() {
            for (var $e = arguments.length, je = W($e), zn = $e; zn--; )
              je[zn] = arguments[zn];
            if (be)
              var vn = ji(Re), Gn = AD(je, vn);
            if (v && (je = PS(je, v, _, be)), N && (je = BS(je, N, F, be)), $e -= Gn, be && $e < ee) {
              var qt = Aa(je, vn);
              return VS(
                o,
                l,
                fl,
                Re.placeholder,
                g,
                je,
                qt,
                $,
                z,
                ee - $e
              );
            }
            var kr = ae ? g : this, la = pe ? kr[o] : o;
            return $e = je.length, $ ? je = LF(je, $) : Ie && $e > 1 && je.reverse(), te && z < $e && (je.length = z), this && this !== on && this instanceof Re && (la = Me || Bo(la)), la.apply(kr, je);
          }
          return Re;
        }
        function GS(o, l) {
          return function(g, v) {
            return jM(g, o, l(v), {});
          };
        }
        function gl(o, l) {
          return function(g, v) {
            var _;
            if (g === n && v === n)
              return l;
            if (g !== n && (_ = g), v !== n) {
              if (_ === n)
                return v;
              typeof g == "string" || typeof v == "string" ? (g = jn(g), v = jn(v)) : (g = CS(g), v = CS(v)), _ = o(g, v);
            }
            return _;
          };
        }
        function ld(o) {
          return aa(function(l) {
            return l = Tt(l, Un(we())), Fe(function(g) {
              var v = this;
              return o(l, function(_) {
                return $n(_, v, g);
              });
            });
          });
        }
        function ml(o, l) {
          l = l === n ? " " : jn(l);
          var g = l.length;
          if (g < 2)
            return g ? td(l, o) : l;
          var v = td(l, tl(o / Li(l)));
          return Oi(l) ? ka(Rr(v), 0, o).join("") : v.slice(0, o);
        }
        function gF(o, l, g, v) {
          var _ = l & w, N = Bo(o);
          function F() {
            for (var $ = -1, z = arguments.length, ee = -1, te = v.length, ae = W(te + z), pe = this && this !== on && this instanceof F ? N : o; ++ee < te; )
              ae[ee] = v[ee];
            for (; z--; )
              ae[ee++] = arguments[++$];
            return $n(pe, _ ? g : this, ae);
          }
          return F;
        }
        function HS(o) {
          return function(l, g, v) {
            return v && typeof v != "number" && yn(l, g, v) && (g = v = n), l = sa(l), g === n ? (g = l, l = 0) : g = sa(g), v = v === n ? l < g ? 1 : -1 : sa(v), QM(l, g, v, o);
          };
        }
        function hl(o) {
          return function(l, g) {
            return typeof l == "string" && typeof g == "string" || (l = pr(l), g = pr(g)), o(l, g);
          };
        }
        function VS(o, l, g, v, _, N, F, $, z, ee) {
          var te = l & S, ae = te ? F : n, pe = te ? n : F, be = te ? N : n, Ie = te ? n : N;
          l |= te ? T : A, l &= ~(te ? A : T), l & I || (l &= -4);
          var Me = [
            o,
            l,
            _,
            be,
            ae,
            Ie,
            pe,
            $,
            z,
            ee
          ], Re = g.apply(n, Me);
          return hd(o) && ax(Re, Me), Re.placeholder = v, ix(Re, o, l);
        }
        function ud(o) {
          var l = Zt[o];
          return function(g, v) {
            if (g = pr(g), v = v == null ? 0 : dn(De(v), 292), v && iS(g)) {
              var _ = (Je(g) + "e").split("e"), N = l(_[0] + "e" + (+_[1] + v));
              return _ = (Je(N) + "e").split("e"), +(_[0] + "e" + (+_[1] - v));
            }
            return l(g);
          };
        }
        var mF = Fi && 1 / Hs(new Fi([, -0]))[1] == ce ? function(o) {
          return new Fi(o);
        } : Nd;
        function WS(o) {
          return function(l) {
            var g = pn(l);
            return g == St ? $c(l) : g == me ? OD(l) : wD(l, o(l));
          };
        }
        function ra(o, l, g, v, _, N, F, $) {
          var z = l & x;
          if (!z && typeof o != "function")
            throw new sr(s);
          var ee = v ? v.length : 0;
          if (ee || (l &= -97, v = _ = n), F = F === n ? F : Jt(De(F), 0), $ = $ === n ? $ : De($), ee -= _ ? _.length : 0, l & A) {
            var te = v, ae = _;
            v = _ = n;
          }
          var pe = z ? n : pd(o), be = [
            o,
            l,
            g,
            v,
            _,
            te,
            ae,
            N,
            F,
            $
          ];
          if (pe && kF(be, pe), o = be[0], l = be[1], g = be[2], v = be[3], _ = be[4], $ = be[9] = be[9] === n ? z ? 0 : o.length : Jt(be[9] - ee, 0), !$ && l & (S | C) && (l &= -25), !l || l == w)
            var Ie = pF(o, l, g);
          else l == S || l == C ? Ie = fF(o, l, $) : (l == T || l == (w | T)) && !_.length ? Ie = gF(o, l, g, v) : Ie = fl.apply(n, be);
          var Me = pe ? RS : ax;
          return ix(Me(Ie, be), o, l);
        }
        function KS(o, l, g, v) {
          return o === n || Cr(o, Mi[g]) && !nt.call(v, g) ? l : o;
        }
        function YS(o, l, g, v, _, N) {
          return _t(o) && _t(l) && (N.set(l, o), ul(o, l, n, YS, N), N.delete(l)), o;
        }
        function hF(o) {
          return jo(o) ? n : o;
        }
        function XS(o, l, g, v, _, N) {
          var F = g & E, $ = o.length, z = l.length;
          if ($ != z && !(F && z > $))
            return !1;
          var ee = N.get(o), te = N.get(l);
          if (ee && te)
            return ee == l && te == o;
          var ae = -1, pe = !0, be = g & y ? new ri() : n;
          for (N.set(o, l), N.set(l, o); ++ae < $; ) {
            var Ie = o[ae], Me = l[ae];
            if (v)
              var Re = F ? v(Me, Ie, ae, l, o, N) : v(Ie, Me, ae, o, l, N);
            if (Re !== n) {
              if (Re)
                continue;
              pe = !1;
              break;
            }
            if (be) {
              if (!Lc(l, function($e, je) {
                if (!Ro(be, je) && (Ie === $e || _(Ie, $e, g, v, N)))
                  return be.push(je);
              })) {
                pe = !1;
                break;
              }
            } else if (!(Ie === Me || _(Ie, Me, g, v, N))) {
              pe = !1;
              break;
            }
          }
          return N.delete(o), N.delete(l), pe;
        }
        function bF(o, l, g, v, _, N, F) {
          switch (g) {
            case fe:
              if (o.byteLength != l.byteLength || o.byteOffset != l.byteOffset)
                return !1;
              o = o.buffer, l = l.buffer;
            case re:
              return !(o.byteLength != l.byteLength || !N(new Zs(o), new Zs(l)));
            case _e:
            case Le:
            case nn:
              return Cr(+o, +l);
            case at:
              return o.name == l.name && o.message == l.message;
            case Rt:
            case Ee:
              return o == l + "";
            case St:
              var $ = $c;
            case me:
              var z = v & E;
              if ($ || ($ = Hs), o.size != l.size && !z)
                return !1;
              var ee = F.get(o);
              if (ee)
                return ee == l;
              v |= y, F.set(o, l);
              var te = XS($(o), $(l), v, _, N, F);
              return F.delete(o), te;
            case ar:
              if (Oo)
                return Oo.call(o) == Oo.call(l);
          }
          return !1;
        }
        function yF(o, l, g, v, _, N) {
          var F = g & E, $ = cd(o), z = $.length, ee = cd(l), te = ee.length;
          if (z != te && !F)
            return !1;
          for (var ae = z; ae--; ) {
            var pe = $[ae];
            if (!(F ? pe in l : nt.call(l, pe)))
              return !1;
          }
          var be = N.get(o), Ie = N.get(l);
          if (be && Ie)
            return be == l && Ie == o;
          var Me = !0;
          N.set(o, l), N.set(l, o);
          for (var Re = F; ++ae < z; ) {
            pe = $[ae];
            var $e = o[pe], je = l[pe];
            if (v)
              var zn = F ? v(je, $e, pe, l, o, N) : v($e, je, pe, o, l, N);
            if (!(zn === n ? $e === je || _($e, je, g, v, N) : zn)) {
              Me = !1;
              break;
            }
            Re || (Re = pe == "constructor");
          }
          if (Me && !Re) {
            var vn = o.constructor, Gn = l.constructor;
            vn != Gn && "constructor" in o && "constructor" in l && !(typeof vn == "function" && vn instanceof vn && typeof Gn == "function" && Gn instanceof Gn) && (Me = !1);
          }
          return N.delete(o), N.delete(l), Me;
        }
        function aa(o) {
          return yd(nx(o, n, dx), o + "");
        }
        function cd(o) {
          return hS(o, an, gd);
        }
        function dd(o) {
          return hS(o, _n, ZS);
        }
        var pd = rl ? function(o) {
          return rl.get(o);
        } : Nd;
        function bl(o) {
          for (var l = o.name + "", g = Pi[l], v = nt.call(Pi, l) ? g.length : 0; v--; ) {
            var _ = g[v], N = _.func;
            if (N == null || N == o)
              return _.name;
          }
          return l;
        }
        function ji(o) {
          var l = nt.call(k, "placeholder") ? k : o;
          return l.placeholder;
        }
        function we() {
          var o = k.iteratee || Cd;
          return o = o === Cd ? vS : o, arguments.length ? o(arguments[0], arguments[1]) : o;
        }
        function yl(o, l) {
          var g = o.__data__;
          return IF(l) ? g[typeof l == "string" ? "string" : "hash"] : g.map;
        }
        function fd(o) {
          for (var l = an(o), g = l.length; g--; ) {
            var v = l[g], _ = o[v];
            l[g] = [v, _, ex(_)];
          }
          return l;
        }
        function oi(o, l) {
          var g = CD(o, l);
          return yS(g) ? g : n;
        }
        function vF(o) {
          var l = nt.call(o, ti), g = o[ti];
          try {
            o[ti] = n;
            var v = !0;
          } catch {
          }
          var _ = Ys.call(o);
          return v && (l ? o[ti] = g : delete o[ti]), _;
        }
        var gd = jc ? function(o) {
          return o == null ? [] : (o = st(o), Ta(jc(o), function(l) {
            return rS.call(o, l);
          }));
        } : Od, ZS = jc ? function(o) {
          for (var l = []; o; )
            wa(l, gd(o)), o = Js(o);
          return l;
        } : Od, pn = bn;
        (qc && pn(new qc(new ArrayBuffer(1))) != fe || Co && pn(new Co()) != St || zc && pn(zc.resolve()) != Nt || Fi && pn(new Fi()) != me || ko && pn(new ko()) != bt) && (pn = function(o) {
          var l = bn(o), g = l == Ze ? o.constructor : n, v = g ? si(g) : "";
          if (v)
            switch (v) {
              case tM:
                return fe;
              case nM:
                return St;
              case rM:
                return Nt;
              case aM:
                return me;
              case iM:
                return bt;
            }
          return l;
        });
        function EF(o, l, g) {
          for (var v = -1, _ = g.length; ++v < _; ) {
            var N = g[v], F = N.size;
            switch (N.type) {
              case "drop":
                o += F;
                break;
              case "dropRight":
                l -= F;
                break;
              case "take":
                l = dn(l, o + F);
                break;
              case "takeRight":
                o = Jt(o, l - F);
                break;
            }
          }
          return { start: o, end: l };
        }
        function SF(o) {
          var l = o.match(RL);
          return l ? l[1].split(_L) : [];
        }
        function JS(o, l, g) {
          l = Ca(l, o);
          for (var v = -1, _ = l.length, N = !1; ++v < _; ) {
            var F = Pr(l[v]);
            if (!(N = o != null && g(o, F)))
              break;
            o = o[F];
          }
          return N || ++v != _ ? N : (_ = o == null ? 0 : o.length, !!_ && Al(_) && ia(F, _) && (Ne(o) || li(o)));
        }
        function xF(o) {
          var l = o.length, g = new o.constructor(l);
          return l && typeof o[0] == "string" && nt.call(o, "index") && (g.index = o.index, g.input = o.input), g;
        }
        function QS(o) {
          return typeof o.constructor == "function" && !$o(o) ? Bi(Js(o)) : {};
        }
        function TF(o, l, g) {
          var v = o.constructor;
          switch (l) {
            case re:
              return sd(o);
            case _e:
            case Le:
              return new v(+o);
            case fe:
              return oF(o, g);
            case Se:
            case Pe:
            case Bt:
            case $t:
            case Ut:
            case Yt:
            case xt:
            case Ot:
            case rn:
              return MS(o, g);
            case St:
              return new v();
            case nn:
            case Ee:
              return new v(o);
            case Rt:
              return sF(o);
            case me:
              return new v();
            case ar:
              return lF(o);
          }
        }
        function wF(o, l) {
          var g = l.length;
          if (!g)
            return o;
          var v = g - 1;
          return l[v] = (g > 1 ? "& " : "") + l[v], l = l.join(g > 2 ? ", " : " "), o.replace(IL, `{
/* [wrapped with ` + l + `] */
`);
        }
        function AF(o) {
          return Ne(o) || li(o) || !!(aS && o && o[aS]);
        }
        function ia(o, l) {
          var g = typeof o;
          return l = l ?? Q, !!l && (g == "number" || g != "symbol" && PL.test(o)) && o > -1 && o % 1 == 0 && o < l;
        }
        function yn(o, l, g) {
          if (!_t(g))
            return !1;
          var v = typeof l;
          return (v == "number" ? Rn(g) && ia(l, g.length) : v == "string" && l in g) ? Cr(g[l], o) : !1;
        }
        function md(o, l) {
          if (Ne(o))
            return !1;
          var g = typeof o;
          return g == "number" || g == "symbol" || g == "boolean" || o == null || qn(o) ? !0 : xL.test(o) || !SL.test(o) || l != null && o in st(l);
        }
        function IF(o) {
          var l = typeof o;
          return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? o !== "__proto__" : o === null;
        }
        function hd(o) {
          var l = bl(o), g = k[l];
          if (typeof g != "function" || !(l in Ue.prototype))
            return !1;
          if (o === g)
            return !0;
          var v = pd(g);
          return !!v && o === v[0];
        }
        function RF(o) {
          return !!eS && eS in o;
        }
        var _F = Ws ? oa : Ld;
        function $o(o) {
          var l = o && o.constructor, g = typeof l == "function" && l.prototype || Mi;
          return o === g;
        }
        function ex(o) {
          return o === o && !_t(o);
        }
        function tx(o, l) {
          return function(g) {
            return g == null ? !1 : g[o] === l && (l !== n || o in st(g));
          };
        }
        function CF(o) {
          var l = Tl(o, function(v) {
            return g.size === d && g.clear(), v;
          }), g = l.cache;
          return l;
        }
        function kF(o, l) {
          var g = o[1], v = l[1], _ = g | v, N = _ < (w | x | O), F = v == O && g == S || v == O && g == U && o[7].length <= l[8] || v == (O | U) && l[7].length <= l[8] && g == S;
          if (!(N || F))
            return o;
          v & w && (o[2] = l[2], _ |= g & w ? 0 : I);
          var $ = l[3];
          if ($) {
            var z = o[3];
            o[3] = z ? PS(z, $, l[4]) : $, o[4] = z ? Aa(o[3], p) : l[4];
          }
          return $ = l[5], $ && (z = o[5], o[5] = z ? BS(z, $, l[6]) : $, o[6] = z ? Aa(o[5], p) : l[6]), $ = l[7], $ && (o[7] = $), v & O && (o[8] = o[8] == null ? l[8] : dn(o[8], l[8])), o[9] == null && (o[9] = l[9]), o[0] = l[0], o[1] = _, o;
        }
        function NF(o) {
          var l = [];
          if (o != null)
            for (var g in st(o))
              l.push(g);
          return l;
        }
        function OF(o) {
          return Ys.call(o);
        }
        function nx(o, l, g) {
          return l = Jt(l === n ? o.length - 1 : l, 0), function() {
            for (var v = arguments, _ = -1, N = Jt(v.length - l, 0), F = W(N); ++_ < N; )
              F[_] = v[l + _];
            _ = -1;
            for (var $ = W(l + 1); ++_ < l; )
              $[_] = v[_];
            return $[l] = g(F), $n(o, this, $);
          };
        }
        function rx(o, l) {
          return l.length < 2 ? o : ii(o, cr(l, 0, -1));
        }
        function LF(o, l) {
          for (var g = o.length, v = dn(l.length, g), _ = In(o); v--; ) {
            var N = l[v];
            o[v] = ia(N, g) ? _[N] : n;
          }
          return o;
        }
        function bd(o, l) {
          if (!(l === "constructor" && typeof o[l] == "function") && l != "__proto__")
            return o[l];
        }
        var ax = ox(RS), Uo = KD || function(o, l) {
          return on.setTimeout(o, l);
        }, yd = ox(nF);
        function ix(o, l, g) {
          var v = l + "";
          return yd(o, wF(v, DF(SF(v), g)));
        }
        function ox(o) {
          var l = 0, g = 0;
          return function() {
            var v = JD(), _ = G - (v - g);
            if (g = v, _ > 0) {
              if (++l >= j)
                return arguments[0];
            } else
              l = 0;
            return o.apply(n, arguments);
          };
        }
        function vl(o, l) {
          var g = -1, v = o.length, _ = v - 1;
          for (l = l === n ? v : l; ++g < l; ) {
            var N = ed(g, _), F = o[N];
            o[N] = o[g], o[g] = F;
          }
          return o.length = l, o;
        }
        var sx = CF(function(o) {
          var l = [];
          return o.charCodeAt(0) === 46 && l.push(""), o.replace(TL, function(g, v, _, N) {
            l.push(_ ? N.replace(NL, "$1") : v || g);
          }), l;
        });
        function Pr(o) {
          if (typeof o == "string" || qn(o))
            return o;
          var l = o + "";
          return l == "0" && 1 / o == -1 / 0 ? "-0" : l;
        }
        function si(o) {
          if (o != null) {
            try {
              return Ks.call(o);
            } catch {
            }
            try {
              return o + "";
            } catch {
            }
          }
          return "";
        }
        function DF(o, l) {
          return or(he, function(g) {
            var v = "_." + g[0];
            l & g[1] && !zs(o, v) && o.push(v);
          }), o.sort();
        }
        function lx(o) {
          if (o instanceof Ue)
            return o.clone();
          var l = new lr(o.__wrapped__, o.__chain__);
          return l.__actions__ = In(o.__actions__), l.__index__ = o.__index__, l.__values__ = o.__values__, l;
        }
        function MF(o, l, g) {
          (g ? yn(o, l, g) : l === n) ? l = 1 : l = Jt(De(l), 0);
          var v = o == null ? 0 : o.length;
          if (!v || l < 1)
            return [];
          for (var _ = 0, N = 0, F = W(tl(v / l)); _ < v; )
            F[N++] = cr(o, _, _ += l);
          return F;
        }
        function FF(o) {
          for (var l = -1, g = o == null ? 0 : o.length, v = 0, _ = []; ++l < g; ) {
            var N = o[l];
            N && (_[v++] = N);
          }
          return _;
        }
        function PF() {
          var o = arguments.length;
          if (!o)
            return [];
          for (var l = W(o - 1), g = arguments[0], v = o; v--; )
            l[v - 1] = arguments[v];
          return wa(Ne(g) ? In(g) : [g], sn(l, 1));
        }
        var BF = Fe(function(o, l) {
          return jt(o) ? Do(o, sn(l, 1, jt, !0)) : [];
        }), $F = Fe(function(o, l) {
          var g = dr(l);
          return jt(g) && (g = n), jt(o) ? Do(o, sn(l, 1, jt, !0), we(g, 2)) : [];
        }), UF = Fe(function(o, l) {
          var g = dr(l);
          return jt(g) && (g = n), jt(o) ? Do(o, sn(l, 1, jt, !0), n, g) : [];
        });
        function jF(o, l, g) {
          var v = o == null ? 0 : o.length;
          return v ? (l = g || l === n ? 1 : De(l), cr(o, l < 0 ? 0 : l, v)) : [];
        }
        function qF(o, l, g) {
          var v = o == null ? 0 : o.length;
          return v ? (l = g || l === n ? 1 : De(l), l = v - l, cr(o, 0, l < 0 ? 0 : l)) : [];
        }
        function zF(o, l) {
          return o && o.length ? dl(o, we(l, 3), !0, !0) : [];
        }
        function GF(o, l) {
          return o && o.length ? dl(o, we(l, 3), !0) : [];
        }
        function HF(o, l, g, v) {
          var _ = o == null ? 0 : o.length;
          return _ ? (g && typeof g != "number" && yn(o, l, g) && (g = 0, v = _), PM(o, l, g, v)) : [];
        }
        function ux(o, l, g) {
          var v = o == null ? 0 : o.length;
          if (!v)
            return -1;
          var _ = g == null ? 0 : De(g);
          return _ < 0 && (_ = Jt(v + _, 0)), Gs(o, we(l, 3), _);
        }
        function cx(o, l, g) {
          var v = o == null ? 0 : o.length;
          if (!v)
            return -1;
          var _ = v - 1;
          return g !== n && (_ = De(g), _ = g < 0 ? Jt(v + _, 0) : dn(_, v - 1)), Gs(o, we(l, 3), _, !0);
        }
        function dx(o) {
          var l = o == null ? 0 : o.length;
          return l ? sn(o, 1) : [];
        }
        function VF(o) {
          var l = o == null ? 0 : o.length;
          return l ? sn(o, ce) : [];
        }
        function WF(o, l) {
          var g = o == null ? 0 : o.length;
          return g ? (l = l === n ? 1 : De(l), sn(o, l)) : [];
        }
        function KF(o) {
          for (var l = -1, g = o == null ? 0 : o.length, v = {}; ++l < g; ) {
            var _ = o[l];
            v[_[0]] = _[1];
          }
          return v;
        }
        function px(o) {
          return o && o.length ? o[0] : n;
        }
        function YF(o, l, g) {
          var v = o == null ? 0 : o.length;
          if (!v)
            return -1;
          var _ = g == null ? 0 : De(g);
          return _ < 0 && (_ = Jt(v + _, 0)), Ni(o, l, _);
        }
        function XF(o) {
          var l = o == null ? 0 : o.length;
          return l ? cr(o, 0, -1) : [];
        }
        var ZF = Fe(function(o) {
          var l = Tt(o, id);
          return l.length && l[0] === o[0] ? Yc(l) : [];
        }), JF = Fe(function(o) {
          var l = dr(o), g = Tt(o, id);
          return l === dr(g) ? l = n : g.pop(), g.length && g[0] === o[0] ? Yc(g, we(l, 2)) : [];
        }), QF = Fe(function(o) {
          var l = dr(o), g = Tt(o, id);
          return l = typeof l == "function" ? l : n, l && g.pop(), g.length && g[0] === o[0] ? Yc(g, n, l) : [];
        });
        function eP(o, l) {
          return o == null ? "" : XD.call(o, l);
        }
        function dr(o) {
          var l = o == null ? 0 : o.length;
          return l ? o[l - 1] : n;
        }
        function tP(o, l, g) {
          var v = o == null ? 0 : o.length;
          if (!v)
            return -1;
          var _ = v;
          return g !== n && (_ = De(g), _ = _ < 0 ? Jt(v + _, 0) : dn(_, v - 1)), l === l ? DD(o, l, _) : Gs(o, VE, _, !0);
        }
        function nP(o, l) {
          return o && o.length ? TS(o, De(l)) : n;
        }
        var rP = Fe(fx);
        function fx(o, l) {
          return o && o.length && l && l.length ? Qc(o, l) : o;
        }
        function aP(o, l, g) {
          return o && o.length && l && l.length ? Qc(o, l, we(g, 2)) : o;
        }
        function iP(o, l, g) {
          return o && o.length && l && l.length ? Qc(o, l, n, g) : o;
        }
        var oP = aa(function(o, l) {
          var g = o == null ? 0 : o.length, v = Hc(o, l);
          return IS(o, Tt(l, function(_) {
            return ia(_, g) ? +_ : _;
          }).sort(FS)), v;
        });
        function sP(o, l) {
          var g = [];
          if (!(o && o.length))
            return g;
          var v = -1, _ = [], N = o.length;
          for (l = we(l, 3); ++v < N; ) {
            var F = o[v];
            l(F, v, o) && (g.push(F), _.push(v));
          }
          return IS(o, _), g;
        }
        function vd(o) {
          return o == null ? o : eM.call(o);
        }
        function lP(o, l, g) {
          var v = o == null ? 0 : o.length;
          return v ? (g && typeof g != "number" && yn(o, l, g) ? (l = 0, g = v) : (l = l == null ? 0 : De(l), g = g === n ? v : De(g)), cr(o, l, g)) : [];
        }
        function uP(o, l) {
          return cl(o, l);
        }
        function cP(o, l, g) {
          return nd(o, l, we(g, 2));
        }
        function dP(o, l) {
          var g = o == null ? 0 : o.length;
          if (g) {
            var v = cl(o, l);
            if (v < g && Cr(o[v], l))
              return v;
          }
          return -1;
        }
        function pP(o, l) {
          return cl(o, l, !0);
        }
        function fP(o, l, g) {
          return nd(o, l, we(g, 2), !0);
        }
        function gP(o, l) {
          var g = o == null ? 0 : o.length;
          if (g) {
            var v = cl(o, l, !0) - 1;
            if (Cr(o[v], l))
              return v;
          }
          return -1;
        }
        function mP(o) {
          return o && o.length ? _S(o) : [];
        }
        function hP(o, l) {
          return o && o.length ? _S(o, we(l, 2)) : [];
        }
        function bP(o) {
          var l = o == null ? 0 : o.length;
          return l ? cr(o, 1, l) : [];
        }
        function yP(o, l, g) {
          return o && o.length ? (l = g || l === n ? 1 : De(l), cr(o, 0, l < 0 ? 0 : l)) : [];
        }
        function vP(o, l, g) {
          var v = o == null ? 0 : o.length;
          return v ? (l = g || l === n ? 1 : De(l), l = v - l, cr(o, l < 0 ? 0 : l, v)) : [];
        }
        function EP(o, l) {
          return o && o.length ? dl(o, we(l, 3), !1, !0) : [];
        }
        function SP(o, l) {
          return o && o.length ? dl(o, we(l, 3)) : [];
        }
        var xP = Fe(function(o) {
          return _a(sn(o, 1, jt, !0));
        }), TP = Fe(function(o) {
          var l = dr(o);
          return jt(l) && (l = n), _a(sn(o, 1, jt, !0), we(l, 2));
        }), wP = Fe(function(o) {
          var l = dr(o);
          return l = typeof l == "function" ? l : n, _a(sn(o, 1, jt, !0), n, l);
        });
        function AP(o) {
          return o && o.length ? _a(o) : [];
        }
        function IP(o, l) {
          return o && o.length ? _a(o, we(l, 2)) : [];
        }
        function RP(o, l) {
          return l = typeof l == "function" ? l : n, o && o.length ? _a(o, n, l) : [];
        }
        function Ed(o) {
          if (!(o && o.length))
            return [];
          var l = 0;
          return o = Ta(o, function(g) {
            if (jt(g))
              return l = Jt(g.length, l), !0;
          }), Pc(l, function(g) {
            return Tt(o, Dc(g));
          });
        }
        function gx(o, l) {
          if (!(o && o.length))
            return [];
          var g = Ed(o);
          return l == null ? g : Tt(g, function(v) {
            return $n(l, n, v);
          });
        }
        var _P = Fe(function(o, l) {
          return jt(o) ? Do(o, l) : [];
        }), CP = Fe(function(o) {
          return ad(Ta(o, jt));
        }), kP = Fe(function(o) {
          var l = dr(o);
          return jt(l) && (l = n), ad(Ta(o, jt), we(l, 2));
        }), NP = Fe(function(o) {
          var l = dr(o);
          return l = typeof l == "function" ? l : n, ad(Ta(o, jt), n, l);
        }), OP = Fe(Ed);
        function LP(o, l) {
          return OS(o || [], l || [], Lo);
        }
        function DP(o, l) {
          return OS(o || [], l || [], Po);
        }
        var MP = Fe(function(o) {
          var l = o.length, g = l > 1 ? o[l - 1] : n;
          return g = typeof g == "function" ? (o.pop(), g) : n, gx(o, g);
        });
        function mx(o) {
          var l = k(o);
          return l.__chain__ = !0, l;
        }
        function FP(o, l) {
          return l(o), o;
        }
        function El(o, l) {
          return l(o);
        }
        var PP = aa(function(o) {
          var l = o.length, g = l ? o[0] : 0, v = this.__wrapped__, _ = function(N) {
            return Hc(N, o);
          };
          return l > 1 || this.__actions__.length || !(v instanceof Ue) || !ia(g) ? this.thru(_) : (v = v.slice(g, +g + (l ? 1 : 0)), v.__actions__.push({
            func: El,
            args: [_],
            thisArg: n
          }), new lr(v, this.__chain__).thru(function(N) {
            return l && !N.length && N.push(n), N;
          }));
        });
        function BP() {
          return mx(this);
        }
        function $P() {
          return new lr(this.value(), this.__chain__);
        }
        function UP() {
          this.__values__ === n && (this.__values__ = Cx(this.value()));
          var o = this.__index__ >= this.__values__.length, l = o ? n : this.__values__[this.__index__++];
          return { done: o, value: l };
        }
        function jP() {
          return this;
        }
        function qP(o) {
          for (var l, g = this; g instanceof il; ) {
            var v = lx(g);
            v.__index__ = 0, v.__values__ = n, l ? _.__wrapped__ = v : l = v;
            var _ = v;
            g = g.__wrapped__;
          }
          return _.__wrapped__ = o, l;
        }
        function zP() {
          var o = this.__wrapped__;
          if (o instanceof Ue) {
            var l = o;
            return this.__actions__.length && (l = new Ue(this)), l = l.reverse(), l.__actions__.push({
              func: El,
              args: [vd],
              thisArg: n
            }), new lr(l, this.__chain__);
          }
          return this.thru(vd);
        }
        function GP() {
          return NS(this.__wrapped__, this.__actions__);
        }
        var HP = pl(function(o, l, g) {
          nt.call(o, g) ? ++o[g] : na(o, g, 1);
        });
        function VP(o, l, g) {
          var v = Ne(o) ? GE : FM;
          return g && yn(o, l, g) && (l = n), v(o, we(l, 3));
        }
        function WP(o, l) {
          var g = Ne(o) ? Ta : gS;
          return g(o, we(l, 3));
        }
        var KP = qS(ux), YP = qS(cx);
        function XP(o, l) {
          return sn(Sl(o, l), 1);
        }
        function ZP(o, l) {
          return sn(Sl(o, l), ce);
        }
        function JP(o, l, g) {
          return g = g === n ? 1 : De(g), sn(Sl(o, l), g);
        }
        function hx(o, l) {
          var g = Ne(o) ? or : Ra;
          return g(o, we(l, 3));
        }
        function bx(o, l) {
          var g = Ne(o) ? bD : fS;
          return g(o, we(l, 3));
        }
        var QP = pl(function(o, l, g) {
          nt.call(o, g) ? o[g].push(l) : na(o, g, [l]);
        });
        function eB(o, l, g, v) {
          o = Rn(o) ? o : zi(o), g = g && !v ? De(g) : 0;
          var _ = o.length;
          return g < 0 && (g = Jt(_ + g, 0)), Il(o) ? g <= _ && o.indexOf(l, g) > -1 : !!_ && Ni(o, l, g) > -1;
        }
        var tB = Fe(function(o, l, g) {
          var v = -1, _ = typeof l == "function", N = Rn(o) ? W(o.length) : [];
          return Ra(o, function(F) {
            N[++v] = _ ? $n(l, F, g) : Mo(F, l, g);
          }), N;
        }), nB = pl(function(o, l, g) {
          na(o, g, l);
        });
        function Sl(o, l) {
          var g = Ne(o) ? Tt : ES;
          return g(o, we(l, 3));
        }
        function rB(o, l, g, v) {
          return o == null ? [] : (Ne(l) || (l = l == null ? [] : [l]), g = v ? n : g, Ne(g) || (g = g == null ? [] : [g]), wS(o, l, g));
        }
        var aB = pl(function(o, l, g) {
          o[g ? 0 : 1].push(l);
        }, function() {
          return [[], []];
        });
        function iB(o, l, g) {
          var v = Ne(o) ? Oc : KE, _ = arguments.length < 3;
          return v(o, we(l, 4), g, _, Ra);
        }
        function oB(o, l, g) {
          var v = Ne(o) ? yD : KE, _ = arguments.length < 3;
          return v(o, we(l, 4), g, _, fS);
        }
        function sB(o, l) {
          var g = Ne(o) ? Ta : gS;
          return g(o, wl(we(l, 3)));
        }
        function lB(o) {
          var l = Ne(o) ? uS : eF;
          return l(o);
        }
        function uB(o, l, g) {
          (g ? yn(o, l, g) : l === n) ? l = 1 : l = De(l);
          var v = Ne(o) ? NM : tF;
          return v(o, l);
        }
        function cB(o) {
          var l = Ne(o) ? OM : rF;
          return l(o);
        }
        function dB(o) {
          if (o == null)
            return 0;
          if (Rn(o))
            return Il(o) ? Li(o) : o.length;
          var l = pn(o);
          return l == St || l == me ? o.size : Zc(o).length;
        }
        function pB(o, l, g) {
          var v = Ne(o) ? Lc : aF;
          return g && yn(o, l, g) && (l = n), v(o, we(l, 3));
        }
        var fB = Fe(function(o, l) {
          if (o == null)
            return [];
          var g = l.length;
          return g > 1 && yn(o, l[0], l[1]) ? l = [] : g > 2 && yn(l[0], l[1], l[2]) && (l = [l[0]]), wS(o, sn(l, 1), []);
        }), xl = WD || function() {
          return on.Date.now();
        };
        function gB(o, l) {
          if (typeof l != "function")
            throw new sr(s);
          return o = De(o), function() {
            if (--o < 1)
              return l.apply(this, arguments);
          };
        }
        function yx(o, l, g) {
          return l = g ? n : l, l = o && l == null ? o.length : l, ra(o, O, n, n, n, n, l);
        }
        function vx(o, l) {
          var g;
          if (typeof l != "function")
            throw new sr(s);
          return o = De(o), function() {
            return --o > 0 && (g = l.apply(this, arguments)), o <= 1 && (l = n), g;
          };
        }
        var Sd = Fe(function(o, l, g) {
          var v = w;
          if (g.length) {
            var _ = Aa(g, ji(Sd));
            v |= T;
          }
          return ra(o, v, l, g, _);
        }), Ex = Fe(function(o, l, g) {
          var v = w | x;
          if (g.length) {
            var _ = Aa(g, ji(Ex));
            v |= T;
          }
          return ra(l, v, o, g, _);
        });
        function Sx(o, l, g) {
          l = g ? n : l;
          var v = ra(o, S, n, n, n, n, n, l);
          return v.placeholder = Sx.placeholder, v;
        }
        function xx(o, l, g) {
          l = g ? n : l;
          var v = ra(o, C, n, n, n, n, n, l);
          return v.placeholder = xx.placeholder, v;
        }
        function Tx(o, l, g) {
          var v, _, N, F, $, z, ee = 0, te = !1, ae = !1, pe = !0;
          if (typeof o != "function")
            throw new sr(s);
          l = pr(l) || 0, _t(g) && (te = !!g.leading, ae = "maxWait" in g, N = ae ? Jt(pr(g.maxWait) || 0, l) : N, pe = "trailing" in g ? !!g.trailing : pe);
          function be(qt) {
            var kr = v, la = _;
            return v = _ = n, ee = qt, F = o.apply(la, kr), F;
          }
          function Ie(qt) {
            return ee = qt, $ = Uo($e, l), te ? be(qt) : F;
          }
          function Me(qt) {
            var kr = qt - z, la = qt - ee, qx = l - kr;
            return ae ? dn(qx, N - la) : qx;
          }
          function Re(qt) {
            var kr = qt - z, la = qt - ee;
            return z === n || kr >= l || kr < 0 || ae && la >= N;
          }
          function $e() {
            var qt = xl();
            if (Re(qt))
              return je(qt);
            $ = Uo($e, Me(qt));
          }
          function je(qt) {
            return $ = n, pe && v ? be(qt) : (v = _ = n, F);
          }
          function zn() {
            $ !== n && LS($), ee = 0, v = z = _ = $ = n;
          }
          function vn() {
            return $ === n ? F : je(xl());
          }
          function Gn() {
            var qt = xl(), kr = Re(qt);
            if (v = arguments, _ = this, z = qt, kr) {
              if ($ === n)
                return Ie(z);
              if (ae)
                return LS($), $ = Uo($e, l), be(z);
            }
            return $ === n && ($ = Uo($e, l)), F;
          }
          return Gn.cancel = zn, Gn.flush = vn, Gn;
        }
        var mB = Fe(function(o, l) {
          return pS(o, 1, l);
        }), hB = Fe(function(o, l, g) {
          return pS(o, pr(l) || 0, g);
        });
        function bB(o) {
          return ra(o, P);
        }
        function Tl(o, l) {
          if (typeof o != "function" || l != null && typeof l != "function")
            throw new sr(s);
          var g = function() {
            var v = arguments, _ = l ? l.apply(this, v) : v[0], N = g.cache;
            if (N.has(_))
              return N.get(_);
            var F = o.apply(this, v);
            return g.cache = N.set(_, F) || N, F;
          };
          return g.cache = new (Tl.Cache || ta)(), g;
        }
        Tl.Cache = ta;
        function wl(o) {
          if (typeof o != "function")
            throw new sr(s);
          return function() {
            var l = arguments;
            switch (l.length) {
              case 0:
                return !o.call(this);
              case 1:
                return !o.call(this, l[0]);
              case 2:
                return !o.call(this, l[0], l[1]);
              case 3:
                return !o.call(this, l[0], l[1], l[2]);
            }
            return !o.apply(this, l);
          };
        }
        function yB(o) {
          return vx(2, o);
        }
        var vB = iF(function(o, l) {
          l = l.length == 1 && Ne(l[0]) ? Tt(l[0], Un(we())) : Tt(sn(l, 1), Un(we()));
          var g = l.length;
          return Fe(function(v) {
            for (var _ = -1, N = dn(v.length, g); ++_ < N; )
              v[_] = l[_].call(this, v[_]);
            return $n(o, this, v);
          });
        }), xd = Fe(function(o, l) {
          var g = Aa(l, ji(xd));
          return ra(o, T, n, l, g);
        }), wx = Fe(function(o, l) {
          var g = Aa(l, ji(wx));
          return ra(o, A, n, l, g);
        }), EB = aa(function(o, l) {
          return ra(o, U, n, n, n, l);
        });
        function SB(o, l) {
          if (typeof o != "function")
            throw new sr(s);
          return l = l === n ? l : De(l), Fe(o, l);
        }
        function xB(o, l) {
          if (typeof o != "function")
            throw new sr(s);
          return l = l == null ? 0 : Jt(De(l), 0), Fe(function(g) {
            var v = g[l], _ = ka(g, 0, l);
            return v && wa(_, v), $n(o, this, _);
          });
        }
        function TB(o, l, g) {
          var v = !0, _ = !0;
          if (typeof o != "function")
            throw new sr(s);
          return _t(g) && (v = "leading" in g ? !!g.leading : v, _ = "trailing" in g ? !!g.trailing : _), Tx(o, l, {
            leading: v,
            maxWait: l,
            trailing: _
          });
        }
        function wB(o) {
          return yx(o, 1);
        }
        function AB(o, l) {
          return xd(od(l), o);
        }
        function IB() {
          if (!arguments.length)
            return [];
          var o = arguments[0];
          return Ne(o) ? o : [o];
        }
        function RB(o) {
          return ur(o, h);
        }
        function _B(o, l) {
          return l = typeof l == "function" ? l : n, ur(o, h, l);
        }
        function CB(o) {
          return ur(o, f | h);
        }
        function kB(o, l) {
          return l = typeof l == "function" ? l : n, ur(o, f | h, l);
        }
        function NB(o, l) {
          return l == null || dS(o, l, an(l));
        }
        function Cr(o, l) {
          return o === l || o !== o && l !== l;
        }
        var OB = hl(Kc), LB = hl(function(o, l) {
          return o >= l;
        }), li = bS(/* @__PURE__ */ function() {
          return arguments;
        }()) ? bS : function(o) {
          return Lt(o) && nt.call(o, "callee") && !rS.call(o, "callee");
        }, Ne = W.isArray, DB = BE ? Un(BE) : qM;
        function Rn(o) {
          return o != null && Al(o.length) && !oa(o);
        }
        function jt(o) {
          return Lt(o) && Rn(o);
        }
        function MB(o) {
          return o === !0 || o === !1 || Lt(o) && bn(o) == _e;
        }
        var Na = YD || Ld, FB = $E ? Un($E) : zM;
        function PB(o) {
          return Lt(o) && o.nodeType === 1 && !jo(o);
        }
        function BB(o) {
          if (o == null)
            return !0;
          if (Rn(o) && (Ne(o) || typeof o == "string" || typeof o.splice == "function" || Na(o) || qi(o) || li(o)))
            return !o.length;
          var l = pn(o);
          if (l == St || l == me)
            return !o.size;
          if ($o(o))
            return !Zc(o).length;
          for (var g in o)
            if (nt.call(o, g))
              return !1;
          return !0;
        }
        function $B(o, l) {
          return Fo(o, l);
        }
        function UB(o, l, g) {
          g = typeof g == "function" ? g : n;
          var v = g ? g(o, l) : n;
          return v === n ? Fo(o, l, n, g) : !!v;
        }
        function Td(o) {
          if (!Lt(o))
            return !1;
          var l = bn(o);
          return l == at || l == tt || typeof o.message == "string" && typeof o.name == "string" && !jo(o);
        }
        function jB(o) {
          return typeof o == "number" && iS(o);
        }
        function oa(o) {
          if (!_t(o))
            return !1;
          var l = bn(o);
          return l == tn || l == Ge || l == xe || l == wn;
        }
        function Ax(o) {
          return typeof o == "number" && o == De(o);
        }
        function Al(o) {
          return typeof o == "number" && o > -1 && o % 1 == 0 && o <= Q;
        }
        function _t(o) {
          var l = typeof o;
          return o != null && (l == "object" || l == "function");
        }
        function Lt(o) {
          return o != null && typeof o == "object";
        }
        var Ix = UE ? Un(UE) : HM;
        function qB(o, l) {
          return o === l || Xc(o, l, fd(l));
        }
        function zB(o, l, g) {
          return g = typeof g == "function" ? g : n, Xc(o, l, fd(l), g);
        }
        function GB(o) {
          return Rx(o) && o != +o;
        }
        function HB(o) {
          if (_F(o))
            throw new ke(i);
          return yS(o);
        }
        function VB(o) {
          return o === null;
        }
        function WB(o) {
          return o == null;
        }
        function Rx(o) {
          return typeof o == "number" || Lt(o) && bn(o) == nn;
        }
        function jo(o) {
          if (!Lt(o) || bn(o) != Ze)
            return !1;
          var l = Js(o);
          if (l === null)
            return !0;
          var g = nt.call(l, "constructor") && l.constructor;
          return typeof g == "function" && g instanceof g && Ks.call(g) == zD;
        }
        var wd = jE ? Un(jE) : VM;
        function KB(o) {
          return Ax(o) && o >= -9007199254740991 && o <= Q;
        }
        var _x = qE ? Un(qE) : WM;
        function Il(o) {
          return typeof o == "string" || !Ne(o) && Lt(o) && bn(o) == Ee;
        }
        function qn(o) {
          return typeof o == "symbol" || Lt(o) && bn(o) == ar;
        }
        var qi = zE ? Un(zE) : KM;
        function YB(o) {
          return o === n;
        }
        function XB(o) {
          return Lt(o) && pn(o) == bt;
        }
        function ZB(o) {
          return Lt(o) && bn(o) == Y;
        }
        var JB = hl(Jc), QB = hl(function(o, l) {
          return o <= l;
        });
        function Cx(o) {
          if (!o)
            return [];
          if (Rn(o))
            return Il(o) ? Rr(o) : In(o);
          if (_o && o[_o])
            return ND(o[_o]());
          var l = pn(o), g = l == St ? $c : l == me ? Hs : zi;
          return g(o);
        }
        function sa(o) {
          if (!o)
            return o === 0 ? o : 0;
          if (o = pr(o), o === ce || o === -1 / 0) {
            var l = o < 0 ? -1 : 1;
            return l * de;
          }
          return o === o ? o : 0;
        }
        function De(o) {
          var l = sa(o), g = l % 1;
          return l === l ? g ? l - g : l : 0;
        }
        function kx(o) {
          return o ? ai(De(o), 0, le) : 0;
        }
        function pr(o) {
          if (typeof o == "number")
            return o;
          if (qn(o))
            return D;
          if (_t(o)) {
            var l = typeof o.valueOf == "function" ? o.valueOf() : o;
            o = _t(l) ? l + "" : l;
          }
          if (typeof o != "string")
            return o === 0 ? o : +o;
          o = YE(o);
          var g = DL.test(o);
          return g || FL.test(o) ? gD(o.slice(2), g ? 2 : 8) : LL.test(o) ? D : +o;
        }
        function Nx(o) {
          return Fr(o, _n(o));
        }
        function e$(o) {
          return o ? ai(De(o), -9007199254740991, Q) : o === 0 ? o : 0;
        }
        function Je(o) {
          return o == null ? "" : jn(o);
        }
        var t$ = $i(function(o, l) {
          if ($o(l) || Rn(l)) {
            Fr(l, an(l), o);
            return;
          }
          for (var g in l)
            nt.call(l, g) && Lo(o, g, l[g]);
        }), Ox = $i(function(o, l) {
          Fr(l, _n(l), o);
        }), Rl = $i(function(o, l, g, v) {
          Fr(l, _n(l), o, v);
        }), n$ = $i(function(o, l, g, v) {
          Fr(l, an(l), o, v);
        }), r$ = aa(Hc);
        function a$(o, l) {
          var g = Bi(o);
          return l == null ? g : cS(g, l);
        }
        var i$ = Fe(function(o, l) {
          o = st(o);
          var g = -1, v = l.length, _ = v > 2 ? l[2] : n;
          for (_ && yn(l[0], l[1], _) && (v = 1); ++g < v; )
            for (var N = l[g], F = _n(N), $ = -1, z = F.length; ++$ < z; ) {
              var ee = F[$], te = o[ee];
              (te === n || Cr(te, Mi[ee]) && !nt.call(o, ee)) && (o[ee] = N[ee]);
            }
          return o;
        }), o$ = Fe(function(o) {
          return o.push(n, YS), $n(Lx, n, o);
        });
        function s$(o, l) {
          return HE(o, we(l, 3), Mr);
        }
        function l$(o, l) {
          return HE(o, we(l, 3), Wc);
        }
        function u$(o, l) {
          return o == null ? o : Vc(o, we(l, 3), _n);
        }
        function c$(o, l) {
          return o == null ? o : mS(o, we(l, 3), _n);
        }
        function d$(o, l) {
          return o && Mr(o, we(l, 3));
        }
        function p$(o, l) {
          return o && Wc(o, we(l, 3));
        }
        function f$(o) {
          return o == null ? [] : ll(o, an(o));
        }
        function g$(o) {
          return o == null ? [] : ll(o, _n(o));
        }
        function Ad(o, l, g) {
          var v = o == null ? n : ii(o, l);
          return v === n ? g : v;
        }
        function m$(o, l) {
          return o != null && JS(o, l, BM);
        }
        function Id(o, l) {
          return o != null && JS(o, l, $M);
        }
        var h$ = GS(function(o, l, g) {
          l != null && typeof l.toString != "function" && (l = Ys.call(l)), o[l] = g;
        }, _d(Cn)), b$ = GS(function(o, l, g) {
          l != null && typeof l.toString != "function" && (l = Ys.call(l)), nt.call(o, l) ? o[l].push(g) : o[l] = [g];
        }, we), y$ = Fe(Mo);
        function an(o) {
          return Rn(o) ? lS(o) : Zc(o);
        }
        function _n(o) {
          return Rn(o) ? lS(o, !0) : YM(o);
        }
        function v$(o, l) {
          var g = {};
          return l = we(l, 3), Mr(o, function(v, _, N) {
            na(g, l(v, _, N), v);
          }), g;
        }
        function E$(o, l) {
          var g = {};
          return l = we(l, 3), Mr(o, function(v, _, N) {
            na(g, _, l(v, _, N));
          }), g;
        }
        var S$ = $i(function(o, l, g) {
          ul(o, l, g);
        }), Lx = $i(function(o, l, g, v) {
          ul(o, l, g, v);
        }), x$ = aa(function(o, l) {
          var g = {};
          if (o == null)
            return g;
          var v = !1;
          l = Tt(l, function(N) {
            return N = Ca(N, o), v || (v = N.length > 1), N;
          }), Fr(o, dd(o), g), v && (g = ur(g, f | m | h, hF));
          for (var _ = l.length; _--; )
            rd(g, l[_]);
          return g;
        });
        function T$(o, l) {
          return Dx(o, wl(we(l)));
        }
        var w$ = aa(function(o, l) {
          return o == null ? {} : ZM(o, l);
        });
        function Dx(o, l) {
          if (o == null)
            return {};
          var g = Tt(dd(o), function(v) {
            return [v];
          });
          return l = we(l), AS(o, g, function(v, _) {
            return l(v, _[0]);
          });
        }
        function A$(o, l, g) {
          l = Ca(l, o);
          var v = -1, _ = l.length;
          for (_ || (_ = 1, o = n); ++v < _; ) {
            var N = o == null ? n : o[Pr(l[v])];
            N === n && (v = _, N = g), o = oa(N) ? N.call(o) : N;
          }
          return o;
        }
        function I$(o, l, g) {
          return o == null ? o : Po(o, l, g);
        }
        function R$(o, l, g, v) {
          return v = typeof v == "function" ? v : n, o == null ? o : Po(o, l, g, v);
        }
        var Mx = WS(an), Fx = WS(_n);
        function _$(o, l, g) {
          var v = Ne(o), _ = v || Na(o) || qi(o);
          if (l = we(l, 4), g == null) {
            var N = o && o.constructor;
            _ ? g = v ? new N() : [] : _t(o) ? g = oa(N) ? Bi(Js(o)) : {} : g = {};
          }
          return (_ ? or : Mr)(o, function(F, $, z) {
            return l(g, F, $, z);
          }), g;
        }
        function C$(o, l) {
          return o == null ? !0 : rd(o, l);
        }
        function k$(o, l, g) {
          return o == null ? o : kS(o, l, od(g));
        }
        function N$(o, l, g, v) {
          return v = typeof v == "function" ? v : n, o == null ? o : kS(o, l, od(g), v);
        }
        function zi(o) {
          return o == null ? [] : Bc(o, an(o));
        }
        function O$(o) {
          return o == null ? [] : Bc(o, _n(o));
        }
        function L$(o, l, g) {
          return g === n && (g = l, l = n), g !== n && (g = pr(g), g = g === g ? g : 0), l !== n && (l = pr(l), l = l === l ? l : 0), ai(pr(o), l, g);
        }
        function D$(o, l, g) {
          return l = sa(l), g === n ? (g = l, l = 0) : g = sa(g), o = pr(o), UM(o, l, g);
        }
        function M$(o, l, g) {
          if (g && typeof g != "boolean" && yn(o, l, g) && (l = g = n), g === n && (typeof l == "boolean" ? (g = l, l = n) : typeof o == "boolean" && (g = o, o = n)), o === n && l === n ? (o = 0, l = 1) : (o = sa(o), l === n ? (l = o, o = 0) : l = sa(l)), o > l) {
            var v = o;
            o = l, l = v;
          }
          if (g || o % 1 || l % 1) {
            var _ = oS();
            return dn(o + _ * (l - o + fD("1e-" + ((_ + "").length - 1))), l);
          }
          return ed(o, l);
        }
        var F$ = Ui(function(o, l, g) {
          return l = l.toLowerCase(), o + (g ? Px(l) : l);
        });
        function Px(o) {
          return Rd(Je(o).toLowerCase());
        }
        function Bx(o) {
          return o = Je(o), o && o.replace(BL, ID).replace(rD, "");
        }
        function P$(o, l, g) {
          o = Je(o), l = jn(l);
          var v = o.length;
          g = g === n ? v : ai(De(g), 0, v);
          var _ = g;
          return g -= l.length, g >= 0 && o.slice(g, _) == l;
        }
        function B$(o) {
          return o = Je(o), o && Qa.test(o) ? o.replace(Dr, RD) : o;
        }
        function $$(o) {
          return o = Je(o), o && wL.test(o) ? o.replace(xc, "\\$&") : o;
        }
        var U$ = Ui(function(o, l, g) {
          return o + (g ? "-" : "") + l.toLowerCase();
        }), j$ = Ui(function(o, l, g) {
          return o + (g ? " " : "") + l.toLowerCase();
        }), q$ = jS("toLowerCase");
        function z$(o, l, g) {
          o = Je(o), l = De(l);
          var v = l ? Li(o) : 0;
          if (!l || v >= l)
            return o;
          var _ = (l - v) / 2;
          return ml(nl(_), g) + o + ml(tl(_), g);
        }
        function G$(o, l, g) {
          o = Je(o), l = De(l);
          var v = l ? Li(o) : 0;
          return l && v < l ? o + ml(l - v, g) : o;
        }
        function H$(o, l, g) {
          o = Je(o), l = De(l);
          var v = l ? Li(o) : 0;
          return l && v < l ? ml(l - v, g) + o : o;
        }
        function V$(o, l, g) {
          return g || l == null ? l = 0 : l && (l = +l), QD(Je(o).replace(Tc, ""), l || 0);
        }
        function W$(o, l, g) {
          return (g ? yn(o, l, g) : l === n) ? l = 1 : l = De(l), td(Je(o), l);
        }
        function K$() {
          var o = arguments, l = Je(o[0]);
          return o.length < 3 ? l : l.replace(o[1], o[2]);
        }
        var Y$ = Ui(function(o, l, g) {
          return o + (g ? "_" : "") + l.toLowerCase();
        });
        function X$(o, l, g) {
          return g && typeof g != "number" && yn(o, l, g) && (l = g = n), g = g === n ? le : g >>> 0, g ? (o = Je(o), o && (typeof l == "string" || l != null && !wd(l)) && (l = jn(l), !l && Oi(o)) ? ka(Rr(o), 0, g) : o.split(l, g)) : [];
        }
        var Z$ = Ui(function(o, l, g) {
          return o + (g ? " " : "") + Rd(l);
        });
        function J$(o, l, g) {
          return o = Je(o), g = g == null ? 0 : ai(De(g), 0, o.length), l = jn(l), o.slice(g, g + l.length) == l;
        }
        function Q$(o, l, g) {
          var v = k.templateSettings;
          g && yn(o, l, g) && (l = n), o = Je(o), l = Rl({}, l, v, KS);
          var _ = Rl({}, l.imports, v.imports, KS), N = an(_), F = Bc(_, N), $, z, ee = 0, te = l.interpolate || Us, ae = "__p += '", pe = Uc(
            (l.escape || Us).source + "|" + te.source + "|" + (te === hE ? OL : Us).source + "|" + (l.evaluate || Us).source + "|$",
            "g"
          ), be = "//# sourceURL=" + (nt.call(l, "sourceURL") ? (l.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++lD + "]") + `
`;
          o.replace(pe, function(Re, $e, je, zn, vn, Gn) {
            return je || (je = zn), ae += o.slice(ee, Gn).replace($L, _D), $e && ($ = !0, ae += `' +
__e(` + $e + `) +
'`), vn && (z = !0, ae += `';
` + vn + `;
__p += '`), je && (ae += `' +
((__t = (` + je + `)) == null ? '' : __t) +
'`), ee = Gn + Re.length, Re;
          }), ae += `';
`;
          var Ie = nt.call(l, "variable") && l.variable;
          if (!Ie)
            ae = `with (obj) {
` + ae + `
}
`;
          else if (kL.test(Ie))
            throw new ke(u);
          ae = (z ? ae.replace(Xt, "") : ae).replace(hn, "$1").replace(Te, "$1;"), ae = "function(" + (Ie || "obj") + `) {
` + (Ie ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + ($ ? ", __e = _.escape" : "") + (z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ae + `return __p
}`;
          var Me = Ux(function() {
            return He(N, be + "return " + ae).apply(n, F);
          });
          if (Me.source = ae, Td(Me))
            throw Me;
          return Me;
        }
        function eU(o) {
          return Je(o).toLowerCase();
        }
        function tU(o) {
          return Je(o).toUpperCase();
        }
        function nU(o, l, g) {
          if (o = Je(o), o && (g || l === n))
            return YE(o);
          if (!o || !(l = jn(l)))
            return o;
          var v = Rr(o), _ = Rr(l), N = XE(v, _), F = ZE(v, _) + 1;
          return ka(v, N, F).join("");
        }
        function rU(o, l, g) {
          if (o = Je(o), o && (g || l === n))
            return o.slice(0, QE(o) + 1);
          if (!o || !(l = jn(l)))
            return o;
          var v = Rr(o), _ = ZE(v, Rr(l)) + 1;
          return ka(v, 0, _).join("");
        }
        function aU(o, l, g) {
          if (o = Je(o), o && (g || l === n))
            return o.replace(Tc, "");
          if (!o || !(l = jn(l)))
            return o;
          var v = Rr(o), _ = XE(v, Rr(l));
          return ka(v, _).join("");
        }
        function iU(o, l) {
          var g = b, v = L;
          if (_t(l)) {
            var _ = "separator" in l ? l.separator : _;
            g = "length" in l ? De(l.length) : g, v = "omission" in l ? jn(l.omission) : v;
          }
          o = Je(o);
          var N = o.length;
          if (Oi(o)) {
            var F = Rr(o);
            N = F.length;
          }
          if (g >= N)
            return o;
          var $ = g - Li(v);
          if ($ < 1)
            return v;
          var z = F ? ka(F, 0, $).join("") : o.slice(0, $);
          if (_ === n)
            return z + v;
          if (F && ($ += z.length - $), wd(_)) {
            if (o.slice($).search(_)) {
              var ee, te = z;
              for (_.global || (_ = Uc(_.source, Je(bE.exec(_)) + "g")), _.lastIndex = 0; ee = _.exec(te); )
                var ae = ee.index;
              z = z.slice(0, ae === n ? $ : ae);
            }
          } else if (o.indexOf(jn(_), $) != $) {
            var pe = z.lastIndexOf(_);
            pe > -1 && (z = z.slice(0, pe));
          }
          return z + v;
        }
        function oU(o) {
          return o = Je(o), o && Ja.test(o) ? o.replace(An, MD) : o;
        }
        var sU = Ui(function(o, l, g) {
          return o + (g ? " " : "") + l.toUpperCase();
        }), Rd = jS("toUpperCase");
        function $x(o, l, g) {
          return o = Je(o), l = g ? n : l, l === n ? kD(o) ? BD(o) : SD(o) : o.match(l) || [];
        }
        var Ux = Fe(function(o, l) {
          try {
            return $n(o, n, l);
          } catch (g) {
            return Td(g) ? g : new ke(g);
          }
        }), lU = aa(function(o, l) {
          return or(l, function(g) {
            g = Pr(g), na(o, g, Sd(o[g], o));
          }), o;
        });
        function uU(o) {
          var l = o == null ? 0 : o.length, g = we();
          return o = l ? Tt(o, function(v) {
            if (typeof v[1] != "function")
              throw new sr(s);
            return [g(v[0]), v[1]];
          }) : [], Fe(function(v) {
            for (var _ = -1; ++_ < l; ) {
              var N = o[_];
              if ($n(N[0], this, v))
                return $n(N[1], this, v);
            }
          });
        }
        function cU(o) {
          return MM(ur(o, f));
        }
        function _d(o) {
          return function() {
            return o;
          };
        }
        function dU(o, l) {
          return o == null || o !== o ? l : o;
        }
        var pU = zS(), fU = zS(!0);
        function Cn(o) {
          return o;
        }
        function Cd(o) {
          return vS(typeof o == "function" ? o : ur(o, f));
        }
        function gU(o) {
          return SS(ur(o, f));
        }
        function mU(o, l) {
          return xS(o, ur(l, f));
        }
        var hU = Fe(function(o, l) {
          return function(g) {
            return Mo(g, o, l);
          };
        }), bU = Fe(function(o, l) {
          return function(g) {
            return Mo(o, g, l);
          };
        });
        function kd(o, l, g) {
          var v = an(l), _ = ll(l, v);
          g == null && !(_t(l) && (_.length || !v.length)) && (g = l, l = o, o = this, _ = ll(l, an(l)));
          var N = !(_t(g) && "chain" in g) || !!g.chain, F = oa(o);
          return or(_, function($) {
            var z = l[$];
            o[$] = z, F && (o.prototype[$] = function() {
              var ee = this.__chain__;
              if (N || ee) {
                var te = o(this.__wrapped__), ae = te.__actions__ = In(this.__actions__);
                return ae.push({ func: z, args: arguments, thisArg: o }), te.__chain__ = ee, te;
              }
              return z.apply(o, wa([this.value()], arguments));
            });
          }), o;
        }
        function yU() {
          return on._ === this && (on._ = GD), this;
        }
        function Nd() {
        }
        function vU(o) {
          return o = De(o), Fe(function(l) {
            return TS(l, o);
          });
        }
        var EU = ld(Tt), SU = ld(GE), xU = ld(Lc);
        function jx(o) {
          return md(o) ? Dc(Pr(o)) : JM(o);
        }
        function TU(o) {
          return function(l) {
            return o == null ? n : ii(o, l);
          };
        }
        var wU = HS(), AU = HS(!0);
        function Od() {
          return [];
        }
        function Ld() {
          return !1;
        }
        function IU() {
          return {};
        }
        function RU() {
          return "";
        }
        function _U() {
          return !0;
        }
        function CU(o, l) {
          if (o = De(o), o < 1 || o > Q)
            return [];
          var g = le, v = dn(o, le);
          l = we(l), o -= le;
          for (var _ = Pc(v, l); ++g < o; )
            l(g);
          return _;
        }
        function kU(o) {
          return Ne(o) ? Tt(o, Pr) : qn(o) ? [o] : In(sx(Je(o)));
        }
        function NU(o) {
          var l = ++qD;
          return Je(o) + l;
        }
        var OU = gl(function(o, l) {
          return o + l;
        }, 0), LU = ud("ceil"), DU = gl(function(o, l) {
          return o / l;
        }, 1), MU = ud("floor");
        function FU(o) {
          return o && o.length ? sl(o, Cn, Kc) : n;
        }
        function PU(o, l) {
          return o && o.length ? sl(o, we(l, 2), Kc) : n;
        }
        function BU(o) {
          return WE(o, Cn);
        }
        function $U(o, l) {
          return WE(o, we(l, 2));
        }
        function UU(o) {
          return o && o.length ? sl(o, Cn, Jc) : n;
        }
        function jU(o, l) {
          return o && o.length ? sl(o, we(l, 2), Jc) : n;
        }
        var qU = gl(function(o, l) {
          return o * l;
        }, 1), zU = ud("round"), GU = gl(function(o, l) {
          return o - l;
        }, 0);
        function HU(o) {
          return o && o.length ? Fc(o, Cn) : 0;
        }
        function VU(o, l) {
          return o && o.length ? Fc(o, we(l, 2)) : 0;
        }
        return k.after = gB, k.ary = yx, k.assign = t$, k.assignIn = Ox, k.assignInWith = Rl, k.assignWith = n$, k.at = r$, k.before = vx, k.bind = Sd, k.bindAll = lU, k.bindKey = Ex, k.castArray = IB, k.chain = mx, k.chunk = MF, k.compact = FF, k.concat = PF, k.cond = uU, k.conforms = cU, k.constant = _d, k.countBy = HP, k.create = a$, k.curry = Sx, k.curryRight = xx, k.debounce = Tx, k.defaults = i$, k.defaultsDeep = o$, k.defer = mB, k.delay = hB, k.difference = BF, k.differenceBy = $F, k.differenceWith = UF, k.drop = jF, k.dropRight = qF, k.dropRightWhile = zF, k.dropWhile = GF, k.fill = HF, k.filter = WP, k.flatMap = XP, k.flatMapDeep = ZP, k.flatMapDepth = JP, k.flatten = dx, k.flattenDeep = VF, k.flattenDepth = WF, k.flip = bB, k.flow = pU, k.flowRight = fU, k.fromPairs = KF, k.functions = f$, k.functionsIn = g$, k.groupBy = QP, k.initial = XF, k.intersection = ZF, k.intersectionBy = JF, k.intersectionWith = QF, k.invert = h$, k.invertBy = b$, k.invokeMap = tB, k.iteratee = Cd, k.keyBy = nB, k.keys = an, k.keysIn = _n, k.map = Sl, k.mapKeys = v$, k.mapValues = E$, k.matches = gU, k.matchesProperty = mU, k.memoize = Tl, k.merge = S$, k.mergeWith = Lx, k.method = hU, k.methodOf = bU, k.mixin = kd, k.negate = wl, k.nthArg = vU, k.omit = x$, k.omitBy = T$, k.once = yB, k.orderBy = rB, k.over = EU, k.overArgs = vB, k.overEvery = SU, k.overSome = xU, k.partial = xd, k.partialRight = wx, k.partition = aB, k.pick = w$, k.pickBy = Dx, k.property = jx, k.propertyOf = TU, k.pull = rP, k.pullAll = fx, k.pullAllBy = aP, k.pullAllWith = iP, k.pullAt = oP, k.range = wU, k.rangeRight = AU, k.rearg = EB, k.reject = sB, k.remove = sP, k.rest = SB, k.reverse = vd, k.sampleSize = uB, k.set = I$, k.setWith = R$, k.shuffle = cB, k.slice = lP, k.sortBy = fB, k.sortedUniq = mP, k.sortedUniqBy = hP, k.split = X$, k.spread = xB, k.tail = bP, k.take = yP, k.takeRight = vP, k.takeRightWhile = EP, k.takeWhile = SP, k.tap = FP, k.throttle = TB, k.thru = El, k.toArray = Cx, k.toPairs = Mx, k.toPairsIn = Fx, k.toPath = kU, k.toPlainObject = Nx, k.transform = _$, k.unary = wB, k.union = xP, k.unionBy = TP, k.unionWith = wP, k.uniq = AP, k.uniqBy = IP, k.uniqWith = RP, k.unset = C$, k.unzip = Ed, k.unzipWith = gx, k.update = k$, k.updateWith = N$, k.values = zi, k.valuesIn = O$, k.without = _P, k.words = $x, k.wrap = AB, k.xor = CP, k.xorBy = kP, k.xorWith = NP, k.zip = OP, k.zipObject = LP, k.zipObjectDeep = DP, k.zipWith = MP, k.entries = Mx, k.entriesIn = Fx, k.extend = Ox, k.extendWith = Rl, kd(k, k), k.add = OU, k.attempt = Ux, k.camelCase = F$, k.capitalize = Px, k.ceil = LU, k.clamp = L$, k.clone = RB, k.cloneDeep = CB, k.cloneDeepWith = kB, k.cloneWith = _B, k.conformsTo = NB, k.deburr = Bx, k.defaultTo = dU, k.divide = DU, k.endsWith = P$, k.eq = Cr, k.escape = B$, k.escapeRegExp = $$, k.every = VP, k.find = KP, k.findIndex = ux, k.findKey = s$, k.findLast = YP, k.findLastIndex = cx, k.findLastKey = l$, k.floor = MU, k.forEach = hx, k.forEachRight = bx, k.forIn = u$, k.forInRight = c$, k.forOwn = d$, k.forOwnRight = p$, k.get = Ad, k.gt = OB, k.gte = LB, k.has = m$, k.hasIn = Id, k.head = px, k.identity = Cn, k.includes = eB, k.indexOf = YF, k.inRange = D$, k.invoke = y$, k.isArguments = li, k.isArray = Ne, k.isArrayBuffer = DB, k.isArrayLike = Rn, k.isArrayLikeObject = jt, k.isBoolean = MB, k.isBuffer = Na, k.isDate = FB, k.isElement = PB, k.isEmpty = BB, k.isEqual = $B, k.isEqualWith = UB, k.isError = Td, k.isFinite = jB, k.isFunction = oa, k.isInteger = Ax, k.isLength = Al, k.isMap = Ix, k.isMatch = qB, k.isMatchWith = zB, k.isNaN = GB, k.isNative = HB, k.isNil = WB, k.isNull = VB, k.isNumber = Rx, k.isObject = _t, k.isObjectLike = Lt, k.isPlainObject = jo, k.isRegExp = wd, k.isSafeInteger = KB, k.isSet = _x, k.isString = Il, k.isSymbol = qn, k.isTypedArray = qi, k.isUndefined = YB, k.isWeakMap = XB, k.isWeakSet = ZB, k.join = eP, k.kebabCase = U$, k.last = dr, k.lastIndexOf = tP, k.lowerCase = j$, k.lowerFirst = q$, k.lt = JB, k.lte = QB, k.max = FU, k.maxBy = PU, k.mean = BU, k.meanBy = $U, k.min = UU, k.minBy = jU, k.stubArray = Od, k.stubFalse = Ld, k.stubObject = IU, k.stubString = RU, k.stubTrue = _U, k.multiply = qU, k.nth = nP, k.noConflict = yU, k.noop = Nd, k.now = xl, k.pad = z$, k.padEnd = G$, k.padStart = H$, k.parseInt = V$, k.random = M$, k.reduce = iB, k.reduceRight = oB, k.repeat = W$, k.replace = K$, k.result = A$, k.round = zU, k.runInContext = q, k.sample = lB, k.size = dB, k.snakeCase = Y$, k.some = pB, k.sortedIndex = uP, k.sortedIndexBy = cP, k.sortedIndexOf = dP, k.sortedLastIndex = pP, k.sortedLastIndexBy = fP, k.sortedLastIndexOf = gP, k.startCase = Z$, k.startsWith = J$, k.subtract = GU, k.sum = HU, k.sumBy = VU, k.template = Q$, k.times = CU, k.toFinite = sa, k.toInteger = De, k.toLength = kx, k.toLower = eU, k.toNumber = pr, k.toSafeInteger = e$, k.toString = Je, k.toUpper = tU, k.trim = nU, k.trimEnd = rU, k.trimStart = aU, k.truncate = iU, k.unescape = oU, k.uniqueId = NU, k.upperCase = sU, k.upperFirst = Rd, k.each = hx, k.eachRight = bx, k.first = px, kd(k, function() {
          var o = {};
          return Mr(k, function(l, g) {
            nt.call(k.prototype, g) || (o[g] = l);
          }), o;
        }(), { chain: !1 }), k.VERSION = r, or(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
          k[o].placeholder = k;
        }), or(["drop", "take"], function(o, l) {
          Ue.prototype[o] = function(g) {
            g = g === n ? 1 : Jt(De(g), 0);
            var v = this.__filtered__ && !l ? new Ue(this) : this.clone();
            return v.__filtered__ ? v.__takeCount__ = dn(g, v.__takeCount__) : v.__views__.push({
              size: dn(g, le),
              type: o + (v.__dir__ < 0 ? "Right" : "")
            }), v;
          }, Ue.prototype[o + "Right"] = function(g) {
            return this.reverse()[o](g).reverse();
          };
        }), or(["filter", "map", "takeWhile"], function(o, l) {
          var g = l + 1, v = g == H || g == ue;
          Ue.prototype[o] = function(_) {
            var N = this.clone();
            return N.__iteratees__.push({
              iteratee: we(_, 3),
              type: g
            }), N.__filtered__ = N.__filtered__ || v, N;
          };
        }), or(["head", "last"], function(o, l) {
          var g = "take" + (l ? "Right" : "");
          Ue.prototype[o] = function() {
            return this[g](1).value()[0];
          };
        }), or(["initial", "tail"], function(o, l) {
          var g = "drop" + (l ? "" : "Right");
          Ue.prototype[o] = function() {
            return this.__filtered__ ? new Ue(this) : this[g](1);
          };
        }), Ue.prototype.compact = function() {
          return this.filter(Cn);
        }, Ue.prototype.find = function(o) {
          return this.filter(o).head();
        }, Ue.prototype.findLast = function(o) {
          return this.reverse().find(o);
        }, Ue.prototype.invokeMap = Fe(function(o, l) {
          return typeof o == "function" ? new Ue(this) : this.map(function(g) {
            return Mo(g, o, l);
          });
        }), Ue.prototype.reject = function(o) {
          return this.filter(wl(we(o)));
        }, Ue.prototype.slice = function(o, l) {
          o = De(o);
          var g = this;
          return g.__filtered__ && (o > 0 || l < 0) ? new Ue(g) : (o < 0 ? g = g.takeRight(-o) : o && (g = g.drop(o)), l !== n && (l = De(l), g = l < 0 ? g.dropRight(-l) : g.take(l - o)), g);
        }, Ue.prototype.takeRightWhile = function(o) {
          return this.reverse().takeWhile(o).reverse();
        }, Ue.prototype.toArray = function() {
          return this.take(le);
        }, Mr(Ue.prototype, function(o, l) {
          var g = /^(?:filter|find|map|reject)|While$/.test(l), v = /^(?:head|last)$/.test(l), _ = k[v ? "take" + (l == "last" ? "Right" : "") : l], N = v || /^find/.test(l);
          _ && (k.prototype[l] = function() {
            var F = this.__wrapped__, $ = v ? [1] : arguments, z = F instanceof Ue, ee = $[0], te = z || Ne(F), ae = function($e) {
              var je = _.apply(k, wa([$e], $));
              return v && pe ? je[0] : je;
            };
            te && g && typeof ee == "function" && ee.length != 1 && (z = te = !1);
            var pe = this.__chain__, be = !!this.__actions__.length, Ie = N && !pe, Me = z && !be;
            if (!N && te) {
              F = Me ? F : new Ue(this);
              var Re = o.apply(F, $);
              return Re.__actions__.push({ func: El, args: [ae], thisArg: n }), new lr(Re, pe);
            }
            return Ie && Me ? o.apply(this, $) : (Re = this.thru(ae), Ie ? v ? Re.value()[0] : Re.value() : Re);
          });
        }), or(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
          var l = Vs[o], g = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", v = /^(?:pop|shift)$/.test(o);
          k.prototype[o] = function() {
            var _ = arguments;
            if (v && !this.__chain__) {
              var N = this.value();
              return l.apply(Ne(N) ? N : [], _);
            }
            return this[g](function(F) {
              return l.apply(Ne(F) ? F : [], _);
            });
          };
        }), Mr(Ue.prototype, function(o, l) {
          var g = k[l];
          if (g) {
            var v = g.name + "";
            nt.call(Pi, v) || (Pi[v] = []), Pi[v].push({ name: l, func: g });
          }
        }), Pi[fl(n, x).name] = [{
          name: "wrapper",
          func: n
        }], Ue.prototype.clone = oM, Ue.prototype.reverse = sM, Ue.prototype.value = lM, k.prototype.at = PP, k.prototype.chain = BP, k.prototype.commit = $P, k.prototype.next = UP, k.prototype.plant = qP, k.prototype.reverse = zP, k.prototype.toJSON = k.prototype.valueOf = k.prototype.value = GP, k.prototype.first = k.prototype.head, _o && (k.prototype[_o] = jP), k;
      }, Di = $D();
      ei ? ((ei.exports = Di)._ = Di, Cc._ = Di) : on._ = Di;
    }).call(xte);
  }(is, is.exports)), is.exports;
}
var X1 = Tte();
const Ru = /* @__PURE__ */ Cu(X1), Z1 = /* @__PURE__ */ B.createContext();
function wte(e) {
  return Sn("MuiTable", e);
}
xn("MuiTable", ["root", "stickyHeader"]);
const Ate = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return Dn({
    root: ["root", n && "stickyHeader"]
  }, wte, t);
}, Ite = Gt("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(tr(({
  theme: e
}) => ({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": {
    ...e.typography.body2,
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      borderCollapse: "separate"
    }
  }]
}))), Vk = "table", bc = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTable"
  }), {
    className: a,
    component: i = Vk,
    padding: s = "normal",
    size: u = "medium",
    stickyHeader: c = !1,
    ...d
  } = r, p = {
    ...r,
    component: i,
    padding: s,
    size: u,
    stickyHeader: c
  }, f = Ate(p), m = B.useMemo(() => ({
    padding: s,
    size: u,
    stickyHeader: c
  }), [s, u, c]);
  return /* @__PURE__ */ R.jsx(Z1.Provider, {
    value: m,
    children: /* @__PURE__ */ R.jsx(Ite, {
      as: i,
      role: i === Vk ? null : "table",
      ref: n,
      className: pt(f.root, a),
      ownerState: p,
      ...d
    })
  });
}), yc = /* @__PURE__ */ B.createContext();
function Rte(e) {
  return Sn("MuiTableBody", e);
}
xn("MuiTableBody", ["root"]);
const _te = (e) => {
  const {
    classes: t
  } = e;
  return Dn({
    root: ["root"]
  }, Rte, t);
}, Cte = Gt("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), kte = {
  variant: "body"
}, Wk = "tbody", vc = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTableBody"
  }), {
    className: a,
    component: i = Wk,
    ...s
  } = r, u = {
    ...r,
    component: i
  }, c = _te(u);
  return /* @__PURE__ */ R.jsx(yc.Provider, {
    value: kte,
    children: /* @__PURE__ */ R.jsx(Cte, {
      className: pt(c.root, a),
      as: i,
      ref: n,
      role: i === Wk ? null : "rowgroup",
      ownerState: u,
      ...s
    })
  });
});
function Nte(e) {
  return Sn("MuiTableCell", e);
}
const Ote = xn("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), Lte = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: a,
    size: i,
    stickyHeader: s
  } = e, u = {
    root: ["root", n, s && "stickyHeader", r !== "inherit" && `align${En(r)}`, a !== "normal" && `padding${En(a)}`, `size${En(i)}`]
  };
  return Dn(u, Nte, t);
}, Dte = Gt("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${En(n.size)}`], n.padding !== "normal" && t[`padding${En(n.padding)}`], n.align !== "inherit" && t[`align${En(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(tr(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? Hu(Ti(e.palette.divider, 1), 0.88) : Gu(Ti(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${Ote.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), en = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTableCell"
  }), {
    align: a = "inherit",
    className: i,
    component: s,
    padding: u,
    scope: c,
    size: d,
    sortDirection: p,
    variant: f,
    ...m
  } = r, h = B.useContext(Z1), E = B.useContext(yc), y = E && E.variant === "head";
  let w;
  s ? w = s : w = y ? "th" : "td";
  let x = c;
  w === "td" ? x = void 0 : !x && y && (x = "col");
  const I = f || E && E.variant, S = {
    ...r,
    align: a,
    component: w,
    padding: u || (h && h.padding ? h.padding : "normal"),
    size: d || (h && h.size ? h.size : "medium"),
    sortDirection: p,
    stickyHeader: I === "head" && h && h.stickyHeader,
    variant: I
  }, C = Lte(S);
  let T = null;
  return p && (T = p === "asc" ? "ascending" : "descending"), /* @__PURE__ */ R.jsx(Dte, {
    as: w,
    ref: n,
    className: pt(C.root, i),
    "aria-sort": T,
    scope: x,
    ownerState: S,
    ...m
  });
});
function Mte(e) {
  return Sn("MuiTableHead", e);
}
xn("MuiTableHead", ["root"]);
const Fte = (e) => {
  const {
    classes: t
  } = e;
  return Dn({
    root: ["root"]
  }, Mte, t);
}, Pte = Gt("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), Bte = {
  variant: "head"
}, Kk = "thead", Ec = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTableHead"
  }), {
    className: a,
    component: i = Kk,
    ...s
  } = r, u = {
    ...r,
    component: i
  }, c = Fte(u);
  return /* @__PURE__ */ R.jsx(yc.Provider, {
    value: Bte,
    children: /* @__PURE__ */ R.jsx(Pte, {
      as: i,
      className: pt(c.root, a),
      ref: n,
      role: i === Kk ? null : "rowgroup",
      ownerState: u,
      ...s
    })
  });
});
function $te(e) {
  return Sn("MuiTableRow", e);
}
const Yk = xn("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), Ute = (e) => {
  const {
    classes: t,
    selected: n,
    hover: r,
    head: a,
    footer: i
  } = e;
  return Dn({
    root: ["root", n && "selected", r && "hover", a && "head", i && "footer"]
  }, $te, t);
}, jte = Gt("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(tr(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Yk.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Yk.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Ti(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Ti(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
}))), Xk = "tr", Wa = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const r = Tn({
    props: t,
    name: "MuiTableRow"
  }), {
    className: a,
    component: i = Xk,
    hover: s = !1,
    selected: u = !1,
    ...c
  } = r, d = B.useContext(yc), p = {
    ...r,
    component: i,
    hover: s,
    selected: u,
    head: d && d.variant === "head",
    footer: d && d.variant === "footer"
  }, f = Ute(p);
  return /* @__PURE__ */ R.jsx(jte, {
    as: i,
    ref: n,
    className: pt(f.root, a),
    role: i === Xk ? null : "row",
    ownerState: p,
    ...c
  });
}), Er = aG({
  createStyledComponent: Gt("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => Tn({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: iv
});
var J1 = {}, Q1 = /* @__PURE__ */ Tr(J1), qte = (e, t) => K({}, e, t), zte = () => nr(Q1), oE = /* @__PURE__ */ Tr(() => {
});
oE.displayName = "JVR.DispatchShowTools";
function Gte() {
  return ho(qte, J1);
}
function eO() {
  return nr(oE);
}
var tO = (e) => {
  var {
    initial: t,
    dispatch: n,
    children: r
  } = e;
  return /* @__PURE__ */ R.jsx(Q1.Provider, {
    value: t,
    children: /* @__PURE__ */ R.jsx(oE.Provider, {
      value: n,
      children: r
    })
  });
};
tO.displayName = "JVR.ShowTools";
var nO = {}, rO = /* @__PURE__ */ Tr(nO), Hte = (e, t) => K({}, e, t), Sc = () => nr(rO), sE = /* @__PURE__ */ Tr(() => {
});
sE.displayName = "JVR.DispatchExpands";
function Vte() {
  return ho(Hte, nO);
}
function Wte() {
  return nr(sE);
}
var aO = (e) => {
  var {
    initial: t,
    dispatch: n,
    children: r
  } = e;
  return /* @__PURE__ */ R.jsx(rO.Provider, {
    value: t,
    children: /* @__PURE__ */ R.jsx(sE.Provider, {
      value: n,
      children: r
    })
  });
};
aO.displayName = "JVR.Expands";
var iO = {
  Str: {
    as: "span",
    "data-type": "string",
    style: {
      color: "var(--w-rjv-type-string-color, #cb4b16)"
    },
    className: "w-rjv-type",
    children: "string"
  },
  Url: {
    as: "a",
    style: {
      color: "var(--w-rjv-type-url-color, #0969da)"
    },
    "data-type": "url",
    className: "w-rjv-type",
    children: "url"
  },
  Undefined: {
    style: {
      color: "var(--w-rjv-type-undefined-color, #586e75)"
    },
    as: "span",
    "data-type": "undefined",
    className: "w-rjv-type",
    children: "undefined"
  },
  Null: {
    style: {
      color: "var(--w-rjv-type-null-color, #d33682)"
    },
    as: "span",
    "data-type": "null",
    className: "w-rjv-type",
    children: "null"
  },
  Map: {
    style: {
      color: "var(--w-rjv-type-map-color, #268bd2)",
      marginRight: 3
    },
    as: "span",
    "data-type": "map",
    className: "w-rjv-type",
    children: "Map"
  },
  Nan: {
    style: {
      color: "var(--w-rjv-type-nan-color, #859900)"
    },
    as: "span",
    "data-type": "nan",
    className: "w-rjv-type",
    children: "NaN"
  },
  Bigint: {
    style: {
      color: "var(--w-rjv-type-bigint-color, #268bd2)"
    },
    as: "span",
    "data-type": "bigint",
    className: "w-rjv-type",
    children: "bigint"
  },
  Int: {
    style: {
      color: "var(--w-rjv-type-int-color, #268bd2)"
    },
    as: "span",
    "data-type": "int",
    className: "w-rjv-type",
    children: "int"
  },
  Set: {
    style: {
      color: "var(--w-rjv-type-set-color, #268bd2)",
      marginRight: 3
    },
    as: "span",
    "data-type": "set",
    className: "w-rjv-type",
    children: "Set"
  },
  Float: {
    style: {
      color: "var(--w-rjv-type-float-color, #859900)"
    },
    as: "span",
    "data-type": "float",
    className: "w-rjv-type",
    children: "float"
  },
  True: {
    style: {
      color: "var(--w-rjv-type-boolean-color, #2aa198)"
    },
    as: "span",
    "data-type": "bool",
    className: "w-rjv-type",
    children: "bool"
  },
  False: {
    style: {
      color: "var(--w-rjv-type-boolean-color, #2aa198)"
    },
    as: "span",
    "data-type": "bool",
    className: "w-rjv-type",
    children: "bool"
  },
  Date: {
    style: {
      color: "var(--w-rjv-type-date-color, #268bd2)"
    },
    as: "span",
    "data-type": "date",
    className: "w-rjv-type",
    children: "date"
  }
}, oO = /* @__PURE__ */ Tr(iO), Kte = (e, t) => K({}, e, t), ht = () => nr(oO), lE = /* @__PURE__ */ Tr(() => {
});
lE.displayName = "JVR.DispatchTypes";
function Yte() {
  return ho(Kte, iO);
}
function Xte() {
  return nr(lE);
}
function sO(e) {
  var {
    initial: t,
    dispatch: n,
    children: r
  } = e;
  return /* @__PURE__ */ R.jsx(oO.Provider, {
    value: t,
    children: /* @__PURE__ */ R.jsx(lE.Provider, {
      value: n,
      children: r
    })
  });
}
sO.displayName = "JVR.Types";
var Zte = ["style"];
function lO(e) {
  var {
    style: t
  } = e, n = Be(e, Zte), r = K({
    cursor: "pointer",
    height: "1em",
    width: "1em",
    userSelect: "none",
    display: "inline-flex"
  }, t);
  return /* @__PURE__ */ R.jsx("svg", K({
    viewBox: "0 0 24 24",
    fill: "var(--w-rjv-arrow-color, currentColor)",
    style: r
  }, n, {
    children: /* @__PURE__ */ R.jsx("path", {
      d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
}
lO.displayName = "JVR.TriangleArrow";
var uO = {
  Arrow: {
    as: "span",
    className: "w-rjv-arrow",
    style: {
      transform: "rotate(0deg)",
      transition: "all 0.3s"
    },
    children: /* @__PURE__ */ R.jsx(lO, {})
  },
  Colon: {
    as: "span",
    style: {
      color: "var(--w-rjv-colon-color, var(--w-rjv-color))",
      marginLeft: 0,
      marginRight: 2
    },
    className: "w-rjv-colon",
    children: ":"
  },
  Quote: {
    as: "span",
    style: {
      color: "var(--w-rjv-quotes-color, #236a7c)"
    },
    className: "w-rjv-quotes",
    children: '"'
  },
  ValueQuote: {
    as: "span",
    style: {
      color: "var(--w-rjv-quotes-string-color, #cb4b16)"
    },
    className: "w-rjv-quotes",
    children: '"'
  },
  BracketsLeft: {
    as: "span",
    style: {
      color: "var(--w-rjv-brackets-color, #236a7c)"
    },
    className: "w-rjv-brackets-start",
    children: "["
  },
  BracketsRight: {
    as: "span",
    style: {
      color: "var(--w-rjv-brackets-color, #236a7c)"
    },
    className: "w-rjv-brackets-end",
    children: "]"
  },
  BraceLeft: {
    as: "span",
    style: {
      color: "var(--w-rjv-curlybraces-color, #236a7c)"
    },
    className: "w-rjv-curlybraces-start",
    children: "{"
  },
  BraceRight: {
    as: "span",
    style: {
      color: "var(--w-rjv-curlybraces-color, #236a7c)"
    },
    className: "w-rjv-curlybraces-end",
    children: "}"
  }
}, cO = /* @__PURE__ */ Tr(uO), Jte = (e, t) => K({}, e, t), Pn = () => nr(cO), uE = /* @__PURE__ */ Tr(() => {
});
uE.displayName = "JVR.DispatchSymbols";
function Qte() {
  return ho(Jte, uO);
}
function ene() {
  return nr(uE);
}
var dO = (e) => {
  var {
    initial: t,
    dispatch: n,
    children: r
  } = e;
  return /* @__PURE__ */ R.jsx(cO.Provider, {
    value: t,
    children: /* @__PURE__ */ R.jsx(uE.Provider, {
      value: n,
      children: r
    })
  });
};
dO.displayName = "JVR.Symbols";
var pO = {
  Copied: {
    className: "w-rjv-copied",
    style: {
      height: "1em",
      width: "1em",
      cursor: "pointer",
      verticalAlign: "middle",
      marginLeft: 5
    }
  },
  CountInfo: {
    as: "span",
    className: "w-rjv-object-size",
    style: {
      color: "var(--w-rjv-info-color, #0000004d)",
      paddingLeft: 8,
      fontStyle: "italic"
    }
  },
  CountInfoExtra: {
    as: "span",
    className: "w-rjv-object-extra",
    style: {
      paddingLeft: 8
    }
  },
  Ellipsis: {
    as: "span",
    style: {
      cursor: "pointer",
      color: "var(--w-rjv-ellipsis-color, #cb4b16)",
      userSelect: "none"
    },
    className: "w-rjv-ellipsis",
    children: "..."
  },
  Row: {
    as: "div",
    className: "w-rjv-line"
  },
  KeyName: {
    as: "span",
    className: "w-rjv-object-key"
  }
}, fO = /* @__PURE__ */ Tr(pO), tne = (e, t) => K({}, e, t), Ir = () => nr(fO), cE = /* @__PURE__ */ Tr(() => {
});
cE.displayName = "JVR.DispatchSection";
function nne() {
  return ho(tne, pO);
}
function rne() {
  return nr(cE);
}
var gO = (e) => {
  var {
    initial: t,
    dispatch: n,
    children: r
  } = e;
  return /* @__PURE__ */ R.jsx(fO.Provider, {
    value: t,
    children: /* @__PURE__ */ R.jsx(cE.Provider, {
      value: n,
      children: r
    })
  });
};
gO.displayName = "JVR.Section";
var mO = {
  objectSortKeys: !1,
  indentWidth: 15
}, dE = /* @__PURE__ */ Tr(mO);
dE.displayName = "JVR.Context";
var hO = /* @__PURE__ */ Tr(() => {
});
hO.displayName = "JVR.DispatchContext";
function ane(e, t) {
  return K({}, e, t);
}
var Ci = () => nr(dE), bO = (e) => {
  var {
    children: t,
    initialState: n,
    initialTypes: r
  } = e, [a, i] = ho(ane, Object.assign({}, mO, n)), [s, u] = Gte(), [c, d] = Vte(), [p, f] = Yte(), [m, h] = Qte(), [E, y] = nne();
  return Ai(() => i(K({}, n)), [n]), /* @__PURE__ */ R.jsx(dE.Provider, {
    value: a,
    children: /* @__PURE__ */ R.jsx(hO.Provider, {
      value: i,
      children: /* @__PURE__ */ R.jsx(tO, {
        initial: s,
        dispatch: u,
        children: /* @__PURE__ */ R.jsx(aO, {
          initial: c,
          dispatch: d,
          children: /* @__PURE__ */ R.jsx(sO, {
            initial: K({}, p, r),
            dispatch: f,
            children: /* @__PURE__ */ R.jsx(dO, {
              initial: m,
              dispatch: h,
              children: /* @__PURE__ */ R.jsx(gO, {
                initial: E,
                dispatch: y,
                children: t
              })
            })
          })
        })
      })
    })
  });
};
bO.displayName = "JVR.Provider";
function ine(e) {
  if (e == null) throw new TypeError("Cannot destructure " + e);
}
var one = ["isNumber", "value", "parentValue", "keyName", "keys"], sne = ["as", "render"], lne = ["as", "render"], une = ["as", "render"], cne = ["as", "style", "render"], dne = ["as", "render"], pne = ["as", "render"], fne = ["as", "render"], gne = ["as", "render"], Py = (e) => {
  var {
    Quote: t = {}
  } = Pn(), {
    isNumber: n,
    value: r,
    parentValue: a,
    keyName: i,
    keys: s
  } = e, u = Be(e, one);
  if (n) return null;
  var {
    as: c,
    render: d
  } = t, p = Be(t, sne), f = c || "span", m = K({}, u, p), h = {
    value: r,
    parentValue: a,
    keyName: i,
    keys: s || (i ? [i] : [])
  }, E = d && typeof d == "function" && d(m, h);
  return E || /* @__PURE__ */ R.jsx(f, K({}, m));
};
Py.displayName = "JVR.Quote";
var Ts = (e) => {
  var {
    ValueQuote: t = {}
  } = Pn(), n = K({}, (ine(e), e)), {
    as: r,
    render: a
  } = t, i = Be(t, lne), s = r || "span", u = K({}, n, i), c = a && typeof a == "function" && a(u, {});
  return c || /* @__PURE__ */ R.jsx(s, K({}, u));
};
Ts.displayName = "JVR.ValueQuote";
var yO = (e) => {
  var {
    value: t,
    parentValue: n,
    keyName: r,
    keys: a
  } = e, {
    Colon: i = {}
  } = Pn(), {
    as: s,
    render: u
  } = i, c = Be(i, une), d = s || "span", p = u && typeof u == "function" && u(c, {
    value: t,
    parentValue: n,
    keyName: r,
    keys: a || (r ? [r] : [])
  });
  return p || /* @__PURE__ */ R.jsx(d, K({}, c));
};
yO.displayName = "JVR.Colon";
var vO = (e) => {
  var {
    Arrow: t = {}
  } = Pn(), n = Sc(), {
    expandKey: r,
    style: a,
    value: i,
    parentValue: s,
    keyName: u,
    keys: c
  } = e, d = !!n[r], {
    as: p,
    style: f,
    render: m
  } = t, h = Be(t, cne), E = p || "span", y = m && typeof m == "function", w = K({}, h, {
    "data-expanded": d,
    style: K({}, f, a)
  }), x = {
    value: i,
    parentValue: s,
    keyName: u,
    keys: c || (u ? [u] : [])
  }, I = y && m(w, x);
  return I || /* @__PURE__ */ R.jsx(E, K({}, h, {
    style: K({}, f, a)
  }));
};
vO.displayName = "JVR.Arrow";
var EO = (e) => {
  var {
    isBrackets: t,
    value: n,
    parentValue: r,
    keyName: a,
    keys: i
  } = e, {
    BracketsLeft: s = {},
    BraceLeft: u = {}
  } = Pn(), c = {
    value: n,
    parentValue: r,
    keyName: a,
    keys: i || (a ? [a] : [])
  };
  if (t) {
    var {
      as: d,
      render: p
    } = s, f = Be(s, dne), m = d || "span", h = p && typeof p == "function" && p(f, c);
    return h || /* @__PURE__ */ R.jsx(m, K({}, f));
  }
  var {
    as: E,
    render: y
  } = u, w = Be(u, pne), x = E || "span", I = y && typeof y == "function" && y(w, c);
  return I || /* @__PURE__ */ R.jsx(x, K({}, w));
};
EO.displayName = "JVR.BracketsOpen";
var pE = (e) => {
  var {
    isBrackets: t,
    isVisiable: n,
    value: r,
    parentValue: a,
    keyName: i,
    keys: s
  } = e, u = {
    value: r,
    parentValue: a,
    keyName: i,
    keys: s || (i ? [i] : [])
  };
  if (!n) return null;
  var {
    BracketsRight: c = {},
    BraceRight: d = {}
  } = Pn();
  if (t) {
    var {
      as: p,
      render: f
    } = c, m = Be(c, fne), h = p || "span", E = f && typeof f == "function" && f(m, u);
    return E || /* @__PURE__ */ R.jsx(h, K({}, m));
  }
  var {
    as: y,
    render: w
  } = d, x = Be(d, gne), I = y || "span", S = w && typeof w == "function" && w(x, u);
  return S || /* @__PURE__ */ R.jsx(I, K({}, x));
};
pE.displayName = "JVR.BracketsClose";
var SO = (e) => {
  var t, {
    value: n,
    expandKey: r,
    level: a,
    keys: i = []
  } = e, s = Sc(), u = Array.isArray(n), {
    collapsed: c,
    shouldExpandNodeInitially: d
  } = Ci(), p = n instanceof Set, f = typeof c == "boolean" ? c : typeof c == "number" ? a > c : !1, m = (t = s[r]) != null ? t : f, h = Object.keys(n).length;
  if (s[r] === void 0 && d && d(m, {
    value: n,
    keys: i,
    level: a
  }) || m || h === 0)
    return null;
  var E = {
    paddingLeft: 4
  };
  return /* @__PURE__ */ R.jsx("div", {
    style: E,
    children: /* @__PURE__ */ R.jsx(pE, {
      isBrackets: u || p,
      isVisiable: !0
    })
  });
};
SO.displayName = "JVR.NestedClose";
var mne = ["as", "render"], hne = ["as", "render"], bne = ["as", "render"], yne = ["as", "render"], vne = ["as", "render"], Ene = ["as", "render"], Sne = ["as", "render"], xne = ["as", "render"], Tne = ["as", "render"], wne = ["as", "render"], Ane = ["as", "render"], Ine = ["as", "render"], Rne = ["as", "render"], By = (e) => {
  if (e === void 0)
    return "0n";
  if (typeof e == "string")
    try {
      e = BigInt(e);
    } catch {
      return "0n";
    }
  return e ? e.toString() + "n" : "0n";
}, xO = (e) => {
  var {
    value: t,
    keyName: n
  } = e, {
    Set: r = {},
    displayDataTypes: a
  } = ht(), i = t instanceof Set;
  if (!i || !a) return null;
  var {
    as: s,
    render: u
  } = r, c = Be(r, mne), d = u && typeof u == "function", p = d && u(c, {
    type: "type",
    value: t,
    keyName: n
  });
  if (p) return p;
  var f = s || "span";
  return /* @__PURE__ */ R.jsx(f, K({}, c));
};
xO.displayName = "JVR.SetComp";
var TO = (e) => {
  var {
    value: t,
    keyName: n
  } = e, {
    Map: r = {},
    displayDataTypes: a
  } = ht(), i = t instanceof Map;
  if (!i || !a) return null;
  var {
    as: s,
    render: u
  } = r, c = Be(r, hne), d = u && typeof u == "function", p = d && u(c, {
    type: "type",
    value: t,
    keyName: n
  });
  if (p) return p;
  var f = s || "span";
  return /* @__PURE__ */ R.jsx(f, K({}, c));
};
TO.displayName = "JVR.MapComp";
var Lr = {
  opacity: 0.75,
  paddingRight: 4
}, wO = (e) => {
  var {
    children: t = "",
    keyName: n
  } = e, {
    Str: r = {},
    displayDataTypes: a
  } = ht(), {
    shortenTextAfterLength: i = 30
  } = Ci(), {
    as: s,
    render: u
  } = r, c = Be(r, bne), d = t, [p, f] = a0(i && d.length > i);
  Ai(() => f(i && d.length > i), [i]);
  var m = s || "span", h = K({}, Lr, r.style || {});
  i > 0 && (c.style = K({}, c.style, {
    cursor: d.length <= i ? "initial" : "pointer"
  }), d.length > i && (c.onClick = () => {
    f(!p);
  }));
  var E = p ? d.slice(0, i) + "..." : d, y = u && typeof u == "function", w = y && u(K({}, c, {
    style: h
  }), {
    type: "type",
    value: t,
    keyName: n
  }), x = y && u(K({}, c, {
    children: E,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (w || /* @__PURE__ */ R.jsx(m, K({}, c, {
      style: h
    }))), x || /* @__PURE__ */ R.jsxs(er, {
      children: [/* @__PURE__ */ R.jsx(Ts, {}), /* @__PURE__ */ R.jsx(m, K({}, c, {
        className: "w-rjv-value",
        children: E
      })), /* @__PURE__ */ R.jsx(Ts, {})]
    })]
  });
};
wO.displayName = "JVR.TypeString";
var AO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    True: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, yne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: t?.toString()
    }))]
  });
};
AO.displayName = "JVR.TypeTrue";
var IO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    False: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, vne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: t?.toString()
    }))]
  });
};
IO.displayName = "JVR.TypeFalse";
var RO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Float: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Ene), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: t?.toString()
    }))]
  });
};
RO.displayName = "JVR.TypeFloat";
var _O = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Int: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Sne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: t?.toString()
    }))]
  });
};
_O.displayName = "JVR.TypeInt";
var CO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Bigint: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, xne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: By(t?.toString())
    }))]
  });
};
CO.displayName = "JVR.TypeFloat";
var kO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Url: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Tne), c = i || "span", d = K({}, Lr, r.style), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t?.href,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m || /* @__PURE__ */ R.jsxs("a", K({
      href: t?.href,
      target: "_blank"
    }, u, {
      className: "w-rjv-value",
      children: [/* @__PURE__ */ R.jsx(Ts, {}), t?.href, /* @__PURE__ */ R.jsx(Ts, {})]
    }))]
  });
};
kO.displayName = "JVR.TypeUrl";
var NO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Date: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, wne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = t instanceof Date ? t.toLocaleString() : t, h = p && s(K({}, u, {
    children: m,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), h || /* @__PURE__ */ R.jsx(c, K({}, u, {
      className: "w-rjv-value",
      children: m
    }))]
  });
};
NO.displayName = "JVR.TypeDate";
var OO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Undefined: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Ane), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m]
  });
};
OO.displayName = "JVR.TypeUndefined";
var LO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Null: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Ine), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t,
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m]
  });
};
LO.displayName = "JVR.TypeNull";
var DO = (e) => {
  var {
    children: t,
    keyName: n
  } = e, {
    Nan: r = {},
    displayDataTypes: a
  } = ht(), {
    as: i,
    render: s
  } = r, u = Be(r, Rne), c = i || "span", d = K({}, Lr, r.style || {}), p = s && typeof s == "function", f = p && s(K({}, u, {
    style: d
  }), {
    type: "type",
    value: t,
    keyName: n
  }), m = p && s(K({}, u, {
    children: t?.toString(),
    className: "w-rjv-value"
  }), {
    type: "value",
    value: t,
    keyName: n
  });
  return /* @__PURE__ */ R.jsxs(er, {
    children: [a && (f || /* @__PURE__ */ R.jsx(c, K({}, u, {
      style: d
    }))), m]
  });
};
DO.displayName = "JVR.TypeNan";
var _ne = (e) => Number(e) === e && e % 1 !== 0 || isNaN(e), MO = (e) => {
  var {
    value: t,
    keyName: n
  } = e, r = {
    keyName: n
  };
  return t instanceof URL ? /* @__PURE__ */ R.jsx(kO, K({}, r, {
    children: t
  })) : typeof t == "string" ? /* @__PURE__ */ R.jsx(wO, K({}, r, {
    children: t
  })) : t === !0 ? /* @__PURE__ */ R.jsx(AO, K({}, r, {
    children: t
  })) : t === !1 ? /* @__PURE__ */ R.jsx(IO, K({}, r, {
    children: t
  })) : t === null ? /* @__PURE__ */ R.jsx(LO, K({}, r, {
    children: t
  })) : t === void 0 ? /* @__PURE__ */ R.jsx(OO, K({}, r, {
    children: t
  })) : t instanceof Date ? /* @__PURE__ */ R.jsx(NO, K({}, r, {
    children: t
  })) : typeof t == "number" && isNaN(t) ? /* @__PURE__ */ R.jsx(DO, K({}, r, {
    children: t
  })) : typeof t == "number" && _ne(t) ? /* @__PURE__ */ R.jsx(RO, K({}, r, {
    children: t
  })) : typeof t == "bigint" ? /* @__PURE__ */ R.jsx(CO, K({}, r, {
    children: t
  })) : typeof t == "number" ? /* @__PURE__ */ R.jsx(_O, K({}, r, {
    children: t
  })) : null;
};
MO.displayName = "JVR.Value";
function Za(e, t, n) {
  var r = ene(), a = [e.className, t.className].filter(Boolean).join(" "), i = K({}, e, t, {
    className: a,
    style: K({}, e.style, t.style),
    children: t.children || e.children
  });
  Ai(() => r({
    [n]: i
  }), [t]);
}
function rr(e, t, n) {
  var r = Xte(), a = [e.className, t.className].filter(Boolean).join(" "), i = K({}, e, t, {
    className: a,
    style: K({}, e.style, t.style),
    children: t.children || e.children
  });
  Ai(() => r({
    [n]: i
  }), [t]);
}
function Ao(e, t, n) {
  var r = rne(), a = [e.className, t.className].filter(Boolean).join(" "), i = K({}, e, t, {
    className: a,
    style: K({}, e.style, t.style),
    children: t.children || e.children
  });
  Ai(() => r({
    [n]: i
  }), [t]);
}
var Cne = ["as", "render"], FO = (e) => {
  var {
    KeyName: t = {}
  } = Ir();
  return Ao(t, e, "KeyName"), null;
};
FO.displayName = "JVR.KeyName";
var PO = (e) => {
  var {
    children: t,
    value: n,
    parentValue: r,
    keyName: a,
    keys: i
  } = e, s = typeof t == "number", u = {
    color: s ? "var(--w-rjv-key-number, #268bd2)" : "var(--w-rjv-key-string, #002b36)"
  }, {
    KeyName: c = {}
  } = Ir(), {
    as: d,
    render: p
  } = c, f = Be(c, Cne);
  f.style = K({}, f.style, u);
  var m = d || "span", h = p && typeof p == "function" && p(K({}, f, {
    children: t
  }), {
    value: n,
    parentValue: r,
    keyName: a,
    keys: i || (a ? [a] : [])
  });
  return h || /* @__PURE__ */ R.jsx(m, K({}, f, {
    children: t
  }));
};
PO.displayName = "JVR.KeyNameComp";
var kne = ["children", "value", "parentValue", "keyName", "keys"], Nne = ["as", "render", "children"], BO = (e) => {
  var {
    Row: t = {}
  } = Ir();
  return Ao(t, e, "Row"), null;
};
BO.displayName = "JVR.Row";
var $O = (e) => {
  var {
    children: t,
    value: n,
    parentValue: r,
    keyName: a,
    keys: i
  } = e, s = Be(e, kne), {
    Row: u = {}
  } = Ir(), {
    as: c,
    render: d
  } = u, p = Be(u, Nne), f = c || "div", m = d && typeof d == "function" && d(K({}, s, p, {
    children: t
  }), {
    value: n,
    keyName: a,
    parentValue: r,
    keys: i
  });
  return m || /* @__PURE__ */ R.jsx(f, K({}, s, p, {
    children: t
  }));
};
$O.displayName = "JVR.RowComp";
function One(e) {
  var t = $y();
  return Ai(() => {
    t.current = e;
  }), t.current;
}
function Lne(e) {
  var {
    value: t,
    highlightUpdates: n,
    highlightContainer: r
  } = e, a = One(t), i = WU(() => {
    if (!n || a === void 0) return !1;
    if (typeof t != typeof a)
      return !0;
    if (typeof t == "number")
      return isNaN(t) && isNaN(a) ? !1 : t !== a;
    if (Array.isArray(t) !== Array.isArray(a))
      return !0;
    if (typeof t == "object" || typeof t == "function")
      return !1;
    if (t !== a)
      return !0;
  }, [n, t]);
  Ai(() => {
    r && r.current && i && "animate" in r.current && r.current.animate([{
      backgroundColor: "var(--w-rjv-update-color, #ebcb8b)"
    }, {
      backgroundColor: ""
    }], {
      duration: 1e3,
      easing: "ease-in"
    });
  }, [i, t, r]);
}
var Dne = ["keyName", "value", "parentValue", "expandKey", "keys"], Mne = ["as", "render"], fE = (e) => {
  var {
    keyName: t,
    value: n,
    parentValue: r,
    expandKey: a,
    keys: i
  } = e, s = Be(e, Dne), {
    onCopied: u,
    enableClipboard: c
  } = Ci(), d = zte(), p = d[a], [f, m] = a0(!1), {
    Copied: h = {}
  } = Ir();
  if (c === !1 || !p) return null;
  var E = (T) => {
    T.stopPropagation();
    var A = "";
    typeof n == "number" && n === 1 / 0 ? A = "Infinity" : typeof n == "number" && isNaN(n) ? A = "NaN" : typeof n == "bigint" ? A = By(n) : n instanceof Date ? A = n.toLocaleString() : A = JSON.stringify(n, (U, P) => typeof P == "bigint" ? By(P) : P, 2), u && u(A, n), m(!0);
    var O = navigator.clipboard || {
      writeText(U) {
        return new Promise((P, b) => {
          var L = document.createElement("textarea");
          L.style.position = "absolute", L.style.opacity = "0", L.style.left = "-99999999px", L.value = U, document.body.appendChild(L), L.select(), document.execCommand("copy") ? P() : b(), L.remove();
        });
      }
    };
    O.writeText(A).then(() => {
      var U = setTimeout(() => {
        m(!1), clearTimeout(U);
      }, 3e3);
    }).catch((U) => {
    });
  }, y = {
    style: {
      display: "inline-flex"
    },
    fill: f ? "var(--w-rjv-copied-success-color, #28a745)" : "var(--w-rjv-copied-color, currentColor)",
    onClick: E
  }, {
    render: w
  } = h, x = Be(h, Mne), I = K({}, x, s, y, {
    style: K({}, x.style, s.style, y.style)
  }), S = w && typeof w == "function", C = S && w(K({}, I, {
    "data-copied": f
  }), {
    value: n,
    keyName: t,
    keys: i,
    parentValue: r
  });
  return C || (f ? /* @__PURE__ */ R.jsx("svg", K({
    viewBox: "0 0 32 36"
  }, I, {
    children: /* @__PURE__ */ R.jsx("path", {
      d: "M27.5,33 L2.5,33 L2.5,12.5 L27.5,12.5 L27.5,15.2249049 C29.1403264,13.8627542 29.9736597,13.1778155 30,13.1700887 C30,11.9705278 30,10.0804982 30,7.5 C30,6.1 28.9,5 27.5,5 L20,5 C20,2.2 17.8,0 15,0 C12.2,0 10,2.2 10,5 L2.5,5 C1.1,5 0,6.1 0,7.5 L0,33 C0,34.4 1.1,36 2.5,36 L27.5,36 C28.9,36 30,34.4 30,33 L30,26.1114493 L27.5,28.4926435 L27.5,33 Z M7.5,7.5 L10,7.5 C10,7.5 12.5,6.4 12.5,5 C12.5,3.6 13.6,2.5 15,2.5 C16.4,2.5 17.5,3.6 17.5,5 C17.5,6.4 18.8,7.5 20,7.5 L22.5,7.5 C22.5,7.5 25,8.6 25,10 L5,10 C5,8.5 6.1,7.5 7.5,7.5 Z M5,27.5 L10,27.5 L10,25 L5,25 L5,27.5 Z M28.5589286,16 L32,19.6 L21.0160714,30.5382252 L13.5303571,24.2571429 L17.1303571,20.6571429 L21.0160714,24.5428571 L28.5589286,16 Z M17.5,15 L5,15 L5,17.5 L17.5,17.5 L17.5,15 Z M10,20 L5,20 L5,22.5 L10,22.5 L10,20 Z"
    })
  })) : /* @__PURE__ */ R.jsx("svg", K({
    viewBox: "0 0 32 36"
  }, I, {
    children: /* @__PURE__ */ R.jsx("path", {
      d: "M27.5,33 L2.5,33 L2.5,12.5 L27.5,12.5 L27.5,20 L30,20 L30,7.5 C30,6.1 28.9,5 27.5,5 L20,5 C20,2.2 17.8,0 15,0 C12.2,0 10,2.2 10,5 L2.5,5 C1.1,5 0,6.1 0,7.5 L0,33 C0,34.4 1.1,36 2.5,36 L27.5,36 C28.9,36 30,34.4 30,33 L30,29 L27.5,29 L27.5,33 Z M7.5,7.5 L10,7.5 C10,7.5 12.5,6.4 12.5,5 C12.5,3.6 13.6,2.5 15,2.5 C16.4,2.5 17.5,3.6 17.5,5 C17.5,6.4 18.8,7.5 20,7.5 L22.5,7.5 C22.5,7.5 25,8.6 25,10 L5,10 C5,8.5 6.1,7.5 7.5,7.5 Z M5,27.5 L10,27.5 L10,25 L5,25 L5,27.5 Z M22.5,21.5 L22.5,16.5 L12.5,24 L22.5,31.5 L22.5,26.5 L32,26.5 L32,21.5 L22.5,21.5 Z M17.5,15 L5,15 L5,17.5 L17.5,17.5 L17.5,15 Z M10,20 L5,20 L5,22.5 L10,22.5 L10,20 Z"
    })
  })));
};
fE.displayName = "JVR.Copied";
function UO() {
  var e = $y(null);
  return e.current === null && (e.current = "custom-id-" + Math.random().toString(36).substr(2, 9)), e.current;
}
var jO = (e) => {
  var t, {
    value: n,
    expandKey: r = "",
    level: a,
    keys: i = []
  } = e, s = Sc(), {
    objectSortKeys: u,
    indentWidth: c,
    collapsed: d,
    shouldExpandNodeInitially: p
  } = Ci(), f = Array.isArray(n), m = typeof d == "boolean" ? d : typeof d == "number" ? a > d : !1, h = (t = s[r]) != null ? t : m;
  if (s[r] === void 0 && p && p(h, {
    value: n,
    keys: i,
    level: a
  }) || h)
    return null;
  var E = f ? Object.entries(n).map((w) => [Number(w[0]), w[1]]) : Object.entries(n);
  u && (E = u === !0 ? E.sort((w, x) => {
    var [I] = w, [S] = x;
    return typeof I == "string" && typeof S == "string" ? I.localeCompare(S) : 0;
  }) : E.sort((w, x) => {
    var [I, S] = w, [C, T] = x;
    return typeof I == "string" && typeof C == "string" ? u(I, C, S, T) : 0;
  }));
  var y = {
    borderLeft: "var(--w-rjv-border-left-width, 1px) var(--w-rjv-line-style, solid) var(--w-rjv-line-color, #ebebeb)",
    paddingLeft: c,
    marginLeft: 6
  };
  return /* @__PURE__ */ R.jsx("div", {
    className: "w-rjv-wrap",
    style: y,
    children: E.map((w, x) => {
      var [I, S] = w;
      return /* @__PURE__ */ R.jsx(qO, {
        parentValue: n,
        keyName: I,
        keys: [...i, I],
        value: S,
        level: a
      }, x);
    })
  });
};
jO.displayName = "JVR.KeyValues";
var gE = (e) => {
  var {
    keyName: t,
    parentValue: n,
    keys: r,
    value: a
  } = e, {
    highlightUpdates: i
  } = Ci(), s = typeof t == "number", u = $y(null);
  Lne({
    value: a,
    highlightUpdates: i,
    highlightContainer: u
  });
  var c = {
    keyName: t,
    value: a,
    keys: r,
    parentValue: n
  };
  return /* @__PURE__ */ R.jsxs(er, {
    children: [/* @__PURE__ */ R.jsxs("span", {
      ref: u,
      children: [/* @__PURE__ */ R.jsx(Py, K({
        isNumber: s,
        "data-placement": "left"
      }, c)), /* @__PURE__ */ R.jsx(PO, K({}, c, {
        children: t
      })), /* @__PURE__ */ R.jsx(Py, K({
        isNumber: s,
        "data-placement": "right"
      }, c))]
    }), /* @__PURE__ */ R.jsx(yO, K({}, c))]
  });
};
gE.displayName = "JVR.KayName";
var qO = (e) => {
  var {
    keyName: t,
    value: n,
    parentValue: r,
    level: a = 0,
    keys: i = []
  } = e, s = eO(), u = UO(), c = Array.isArray(n), d = n instanceof Set, p = n instanceof Map, f = n instanceof Date, m = n instanceof URL, h = n && typeof n == "object" && !c && !d && !p && !f && !m, E = h || c || d || p;
  if (E) {
    var y = d ? Array.from(n) : p ? Object.fromEntries(n) : n;
    return /* @__PURE__ */ R.jsx(mE, {
      keyName: t,
      value: y,
      parentValue: r,
      initialValue: n,
      keys: i,
      level: a + 1
    });
  }
  var w = {
    onMouseEnter: () => s({
      [u]: !0
    }),
    onMouseLeave: () => s({
      [u]: !1
    })
  };
  return /* @__PURE__ */ R.jsxs($O, K({
    className: "w-rjv-line",
    value: n,
    keyName: t,
    keys: i,
    parentValue: r
  }, w, {
    children: [/* @__PURE__ */ R.jsx(gE, {
      keyName: t,
      value: n,
      keys: i,
      parentValue: r
    }), /* @__PURE__ */ R.jsx(MO, {
      keyName: t,
      value: n
    }), /* @__PURE__ */ R.jsx(fE, {
      keyName: t,
      value: n,
      keys: i,
      parentValue: r,
      expandKey: u
    })]
  }));
};
qO.displayName = "JVR.KeyValuesItem";
var Fne = ["value", "keyName"], Pne = ["as", "render"], zO = (e) => {
  var {
    CountInfoExtra: t = {}
  } = Ir();
  return Ao(t, e, "CountInfoExtra"), null;
};
zO.displayName = "JVR.CountInfoExtra";
var GO = (e) => {
  var {
    value: t = {},
    keyName: n
  } = e, r = Be(e, Fne), {
    CountInfoExtra: a = {}
  } = Ir(), {
    as: i,
    render: s
  } = a, u = Be(a, Pne);
  if (!s && !u.children) return null;
  var c = i || "span", d = s && typeof s == "function", p = K({}, u, r), f = d && s(p, {
    value: t,
    keyName: n
  });
  return f || /* @__PURE__ */ R.jsx(c, K({}, p));
};
GO.displayName = "JVR.CountInfoExtraComps";
var Bne = ["value", "keyName"], $ne = ["as", "render"], HO = (e) => {
  var {
    CountInfo: t = {}
  } = Ir();
  return Ao(t, e, "CountInfo"), null;
};
HO.displayName = "JVR.CountInfo";
var VO = (e) => {
  var {
    value: t = {},
    keyName: n
  } = e, r = Be(e, Bne), {
    displayObjectSize: a
  } = Ci(), {
    CountInfo: i = {}
  } = Ir();
  if (!a) return null;
  var {
    as: s,
    render: u
  } = i, c = Be(i, $ne), d = s || "span";
  c.style = K({}, c.style, e.style);
  var p = Object.keys(t).length;
  c.children || (c.children = p + " item" + (p === 1 ? "" : "s"));
  var f = K({}, c, r), m = u && typeof u == "function", h = m && u(K({}, f, {
    "data-length": p
  }), {
    value: t,
    keyName: n
  });
  return h || /* @__PURE__ */ R.jsx(d, K({}, f));
};
VO.displayName = "JVR.CountInfoComp";
var Une = ["as", "render"], WO = (e) => {
  var {
    Ellipsis: t = {}
  } = Ir();
  return Ao(t, e, "Ellipsis"), null;
};
WO.displayName = "JVR.Ellipsis";
var KO = (e) => {
  var {
    isExpanded: t,
    value: n,
    keyName: r
  } = e, {
    Ellipsis: a = {}
  } = Ir(), {
    as: i,
    render: s
  } = a, u = Be(a, Une), c = i || "span", d = s && typeof s == "function" && s(K({}, u, {
    "data-expanded": t
  }), {
    value: n,
    keyName: r
  });
  return d || (!t || typeof n == "object" && Object.keys(n).length == 0 ? null : /* @__PURE__ */ R.jsx(c, K({}, u)));
};
KO.displayName = "JVR.EllipsisComp";
var YO = (e) => {
  var t, {
    keyName: n,
    expandKey: r,
    keys: a = [],
    initialValue: i,
    value: s,
    parentValue: u,
    level: c
  } = e, d = Sc(), p = Wte(), {
    onExpand: f,
    collapsed: m,
    shouldExpandNodeInitially: h
  } = Ci(), E = Array.isArray(s), y = s instanceof Set, w = typeof m == "boolean" ? m : typeof m == "number" ? c > m : !1, x = typeof s == "object", I = (t = d[r]) != null ? t : w, S = h && h(I, {
    value: s,
    keys: a,
    level: c
  });
  d[r] === void 0 && S !== void 0 && (I = S);
  var C = () => {
    var L = {
      expand: !I,
      value: s,
      keyid: r,
      keyName: n
    };
    f && f(L), p({
      [r]: L.expand
    });
  }, T = {
    display: "inline-flex",
    alignItems: "center"
  }, A = {
    transform: "rotate(" + (I ? "-90" : "0") + "deg)",
    transition: "all 0.3s"
  }, O = Object.keys(s).length, U = O !== 0 && (E || y || x), P = {
    style: T
  };
  U && (P.onClick = C);
  var b = {
    keyName: n,
    value: s,
    keys: a,
    parentValue: u
  };
  return /* @__PURE__ */ R.jsxs("span", K({}, P, {
    children: [U && /* @__PURE__ */ R.jsx(vO, K({
      style: A,
      expandKey: r
    }, b)), (n || typeof n == "number") && /* @__PURE__ */ R.jsx(gE, K({}, b)), /* @__PURE__ */ R.jsx(xO, {
      value: i,
      keyName: n
    }), /* @__PURE__ */ R.jsx(TO, {
      value: i,
      keyName: n
    }), /* @__PURE__ */ R.jsx(EO, K({
      isBrackets: E || y
    }, b)), /* @__PURE__ */ R.jsx(KO, {
      keyName: n,
      value: s,
      isExpanded: I
    }), /* @__PURE__ */ R.jsx(pE, K({
      isVisiable: I || !U,
      isBrackets: E || y
    }, b)), /* @__PURE__ */ R.jsx(VO, {
      value: s,
      keyName: n
    }), /* @__PURE__ */ R.jsx(GO, {
      value: s,
      keyName: n
    }), /* @__PURE__ */ R.jsx(fE, {
      keyName: n,
      value: s,
      expandKey: r,
      parentValue: u,
      keys: a
    })]
  }));
};
YO.displayName = "JVR.NestedOpen";
var jne = ["className", "children", "parentValue", "keyid", "level", "value", "initialValue", "keys", "keyName"], mE = /* @__PURE__ */ _u((e, t) => {
  var {
    className: n = "",
    parentValue: r,
    level: a = 1,
    value: i,
    initialValue: s,
    keys: u,
    keyName: c
  } = e, d = Be(e, jne), p = eO(), f = UO(), m = [n, "w-rjv-inner"].filter(Boolean).join(" "), h = {
    onMouseEnter: () => p({
      [f]: !0
    }),
    onMouseLeave: () => p({
      [f]: !1
    })
  };
  return /* @__PURE__ */ R.jsxs("div", K({
    className: m,
    ref: t
  }, d, h, {
    children: [/* @__PURE__ */ R.jsx(YO, {
      expandKey: f,
      value: i,
      level: a,
      keys: u,
      parentValue: r,
      keyName: c,
      initialValue: s
    }), /* @__PURE__ */ R.jsx(jO, {
      expandKey: f,
      value: i,
      level: a,
      keys: u,
      parentValue: r,
      keyName: c
    }), /* @__PURE__ */ R.jsx(SO, {
      expandKey: f,
      value: i,
      level: a,
      keys: u
    })]
  }));
});
mE.displayName = "JVR.Container";
var XO = (e) => {
  var {
    BraceLeft: t = {}
  } = Pn();
  return Za(t, e, "BraceLeft"), null;
};
XO.displayName = "JVR.BraceLeft";
var ZO = (e) => {
  var {
    BraceRight: t = {}
  } = Pn();
  return Za(t, e, "BraceRight"), null;
};
ZO.displayName = "JVR.BraceRight";
var JO = (e) => {
  var {
    BracketsLeft: t = {}
  } = Pn();
  return Za(t, e, "BracketsLeft"), null;
};
JO.displayName = "JVR.BracketsLeft";
var QO = (e) => {
  var {
    BracketsRight: t = {}
  } = Pn();
  return Za(t, e, "BracketsRight"), null;
};
QO.displayName = "JVR.BracketsRight";
var eL = (e) => {
  var {
    Arrow: t = {}
  } = Pn();
  return Za(t, e, "Arrow"), null;
};
eL.displayName = "JVR.Arrow";
var tL = (e) => {
  var {
    Colon: t = {}
  } = Pn();
  return Za(t, e, "Colon"), null;
};
tL.displayName = "JVR.Colon";
var nL = (e) => {
  var {
    Quote: t = {}
  } = Pn();
  return Za(t, e, "Quote"), null;
};
nL.displayName = "JVR.Quote";
var rL = (e) => {
  var {
    ValueQuote: t = {}
  } = Pn();
  return Za(t, e, "ValueQuote"), null;
};
rL.displayName = "JVR.ValueQuote";
var aL = (e) => {
  var {
    Bigint: t = {}
  } = ht();
  return rr(t, e, "Bigint"), null;
};
aL.displayName = "JVR.Bigint";
var iL = (e) => {
  var {
    Date: t = {}
  } = ht();
  return rr(t, e, "Date"), null;
};
iL.displayName = "JVR.Date";
var oL = (e) => {
  var {
    False: t = {}
  } = ht();
  return rr(t, e, "False"), null;
};
oL.displayName = "JVR.False";
var sL = (e) => {
  var {
    Float: t = {}
  } = ht();
  return rr(t, e, "Float"), null;
};
sL.displayName = "JVR.Float";
var lL = (e) => {
  var {
    Int: t = {}
  } = ht();
  return rr(t, e, "Int"), null;
};
lL.displayName = "JVR.Int";
var uL = (e) => {
  var {
    Map: t = {}
  } = ht();
  return rr(t, e, "Map"), null;
};
uL.displayName = "JVR.Map";
var cL = (e) => {
  var {
    Nan: t = {}
  } = ht();
  return rr(t, e, "Nan"), null;
};
cL.displayName = "JVR.Nan";
var dL = (e) => {
  var {
    Null: t = {}
  } = ht();
  return rr(t, e, "Null"), null;
};
dL.displayName = "JVR.Null";
var pL = (e) => {
  var {
    Set: t = {}
  } = ht();
  return rr(t, e, "Set"), null;
};
pL.displayName = "JVR.Set";
var fL = (e) => {
  var {
    Str: t = {}
  } = ht();
  return rr(t, e, "Str"), null;
};
fL.displayName = "JVR.StringText";
var gL = (e) => {
  var {
    True: t = {}
  } = ht();
  return rr(t, e, "True"), null;
};
gL.displayName = "JVR.True";
var mL = (e) => {
  var {
    Undefined: t = {}
  } = ht();
  return rr(t, e, "Undefined"), null;
};
mL.displayName = "JVR.Undefined";
var hL = (e) => {
  var {
    Url: t = {}
  } = ht();
  return rr(t, e, "Url"), null;
};
hL.displayName = "JVR.Url";
var bL = (e) => {
  var {
    Copied: t = {}
  } = Ir();
  return Ao(t, e, "Copied"), null;
};
bL.displayName = "JVR.Copied";
var qne = ["className", "style", "value", "children", "collapsed", "shouldExpandNodeInitially", "indentWidth", "displayObjectSize", "shortenTextAfterLength", "highlightUpdates", "enableClipboard", "displayDataTypes", "objectSortKeys", "onExpand", "onCopied"], ze = /* @__PURE__ */ _u((e, t) => {
  var {
    className: n = "",
    style: r,
    value: a,
    children: i,
    collapsed: s,
    shouldExpandNodeInitially: u,
    indentWidth: c = 15,
    displayObjectSize: d = !0,
    shortenTextAfterLength: p = 30,
    highlightUpdates: f = !0,
    enableClipboard: m = !0,
    displayDataTypes: h = !0,
    objectSortKeys: E = !1,
    onExpand: y,
    onCopied: w
  } = e, x = Be(e, qne), I = K({
    lineHeight: 1.4,
    fontFamily: "var(--w-rjv-font-family, Menlo, monospace)",
    color: "var(--w-rjv-color, #002b36)",
    backgroundColor: "var(--w-rjv-background-color, #00000000)",
    fontSize: 13
  }, r), S = ["w-json-view-container", "w-rjv", n].filter(Boolean).join(" ");
  return /* @__PURE__ */ R.jsxs(bO, {
    initialState: {
      value: a,
      objectSortKeys: E,
      indentWidth: c,
      shouldExpandNodeInitially: u,
      displayObjectSize: d,
      collapsed: s,
      enableClipboard: m,
      shortenTextAfterLength: p,
      highlightUpdates: f,
      onCopied: w,
      onExpand: y
    },
    initialTypes: {
      displayDataTypes: h
    },
    children: [/* @__PURE__ */ R.jsx(mE, K({
      value: a
    }, x, {
      ref: t,
      className: S,
      style: I
    })), i]
  });
});
ze.Bigint = aL;
ze.Date = iL;
ze.False = oL;
ze.Float = sL;
ze.Int = lL;
ze.Map = uL;
ze.Nan = cL;
ze.Null = dL;
ze.Set = pL;
ze.String = fL;
ze.True = gL;
ze.Undefined = mL;
ze.Url = hL;
ze.ValueQuote = rL;
ze.Arrow = eL;
ze.Colon = tL;
ze.Quote = nL;
ze.Ellipsis = WO;
ze.BraceLeft = XO;
ze.BraceRight = ZO;
ze.BracketsLeft = JO;
ze.BracketsRight = QO;
ze.Copied = bL;
ze.CountInfo = HO;
ze.CountInfoExtra = zO;
ze.KeyName = FO;
ze.Row = BO;
ze.displayName = "JVR.JsonView";
const zne = "Errors", Zk = {
  code: `${zne}-code`
}, Gne = cn(Er)({}), Hne = ({ errors: e, reactJsonOptions: t }) => {
  const n = Uy();
  return !e || e.length === 0 ? null : /* @__PURE__ */ R.jsxs(
    Gne,
    {
      container: !0,
      sx: {
        [`& .${Zk.code}`]: {
          marginLeft: n.spacing(2)
        },
        "& .MuiTableCell-root": {
          color: n.palette.text.primary,
          borderBottomColor: n.palette.divider
        },
        "& .MuiTableCell-head": {
          color: `${n.palette.text.primary} !important`,
          fontWeight: 500
        },
        "& .MuiTypography-root": {
          color: n.palette.text.primary
        },
        "& .MuiTable-root": {
          backgroundColor: n.palette.background.paper
        }
      },
      children: [
        /* @__PURE__ */ R.jsx(Er, { component: "div", size: { xs: 12 }, children: /* @__PURE__ */ R.jsx(ye, { variant: "h5", children: "Errors" }) }),
        /* @__PURE__ */ R.jsx(Er, { component: "div", size: { xs: 12 }, children: /* @__PURE__ */ R.jsxs(bc, { children: [
          /* @__PURE__ */ R.jsx(Ec, { children: /* @__PURE__ */ R.jsxs(Wa, { children: [
            /* @__PURE__ */ R.jsx(en, { children: "Code" }),
            /* @__PURE__ */ R.jsx(en, { children: "Message" }),
            /* @__PURE__ */ R.jsx(en, { children: "Data" })
          ] }) }),
          /* @__PURE__ */ R.jsx(vc, { children: e.map((r) => /* @__PURE__ */ R.jsxs(Wa, { children: [
            /* @__PURE__ */ R.jsx(en, { component: "th", scope: "row", children: r.code }),
            /* @__PURE__ */ R.jsx(en, { children: r.message }),
            /* @__PURE__ */ R.jsx(en, { className: Zk.code, children: Ru.isObject(r.data) ? /* @__PURE__ */ R.jsx(ze, { value: r.data, ...t, enableClipboard: !1 }) : r.data })
          ] }, r.code)) })
        ] }) })
      ]
    }
  );
}, Vne = "ExamplePairing", yL = {
  description: `${Vne}-description`
}, Wne = cn(Er)(({ theme: e }) => ({
  [`& .${yL.description}`]: {
    color: e.palette.text.primary
  }
}));
class Kne extends xr {
  render() {
    const { examplePairing: t, paramStructure: n, methodName: r, uiSchema: a } = this.props;
    if (Ru.isUndefined(t) || Ru.isUndefined(r))
      return null;
    const i = n === "by-name" ? t.params.reduce((s, u) => (s[u.name] = u.value, s), {}) : t.params.map((s) => s.value);
    return /* @__PURE__ */ R.jsxs(Wne, { container: !0, spacing: 10, children: [
      /* @__PURE__ */ R.jsx(Er, { size: { xs: 12 }, children: /* @__PURE__ */ R.jsx(
        Bs,
        {
          uiSchema: a,
          source: t.description,
          className: yL.description
        }
      ) }),
      /* @__PURE__ */ R.jsx(Er, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ R.jsxs(zx, { children: [
        /* @__PURE__ */ R.jsx(Gx, { title: "Request" }),
        /* @__PURE__ */ R.jsx(Hx, { children: t.params && /* @__PURE__ */ R.jsx(
          ze,
          {
            value: {
              id: 1,
              jsonrpc: "2.0",
              method: r,
              params: i
            },
            ...this.props.reactJsonOptions
          }
        ) })
      ] }) }),
      /* @__PURE__ */ R.jsxs(Er, { size: { xs: 12, sm: 6 }, children: [
        /* @__PURE__ */ R.jsx(Gx, { title: "Result" }),
        /* @__PURE__ */ R.jsx(zx, { children: /* @__PURE__ */ R.jsx(Hx, { children: t.result && /* @__PURE__ */ R.jsx(
          ze,
          {
            value: {
              id: 1,
              jsonrpc: "2.0",
              result: t.result.value
            },
            ...this.props.reactJsonOptions
          }
        ) }) })
      ] })
    ] });
  }
}
const Jk = (e) => e && typeof e == "object" && !Array.isArray(e), Yne = (e) => {
  if (!e)
    return [];
  if (!e.params)
    return [];
  const t = [];
  e.params.forEach((r, a) => {
    r.schema && Jk(r.schema) && r.schema.examples && r.schema.examples.length > 0 && r.schema.examples.forEach((i, s) => {
      t[s] ? t[s].params.push({
        name: r.name,
        value: i
      }) : t.push({
        name: "generated-example",
        params: [
          {
            name: r.name,
            value: i
          }
        ],
        result: {
          name: "example-result",
          value: null
        }
      });
    });
  });
  const n = e.result;
  return n && n.schema && Jk(n.schema) && n.schema.examples && n.schema.examples.length > 0 && n.schema.examples.forEach((r, a) => {
    t[a] ? t[a].result = {
      name: n.name,
      value: r
    } : t.push({
      name: "generated-example",
      params: [],
      result: {
        name: n.name,
        value: r
      }
    });
  }), t;
};
class Xne extends xr {
  constructor(t) {
    super(t), this.state = {
      anchorEl: null,
      selectedIndex: 0
    };
  }
  componentDidMount() {
    !this.props || !this.props.examples || this.setState({
      currentExample: this.props.examples[0]
    });
  }
  handleClickListItem = (t) => {
    this.setState({
      anchorEl: t.currentTarget
    });
  };
  handleMenuItemClick = (t, n) => {
    this.setState({ selectedIndex: n, anchorEl: null });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    let { examples: t } = this.props;
    const { method: n, uiSchema: r } = this.props, { anchorEl: a } = this.state;
    return t = t || Yne(n), !t || t.length === 0 ? null : /* @__PURE__ */ R.jsx(jy, { children: /* @__PURE__ */ R.jsxs(Er, { container: !0, children: [
      /* @__PURE__ */ R.jsx(Er, { size: { xs: 12 }, children: /* @__PURE__ */ R.jsx(ye, { variant: "h5", children: "Examples" }) }),
      /* @__PURE__ */ R.jsx(Er, { size: { xs: 12 }, children: /* @__PURE__ */ R.jsxs(YU, { component: "nav", children: [
        /* @__PURE__ */ R.jsx(
          XU,
          {
            component: "div",
            "aria-haspopup": "true",
            "aria-controls": "menu-menu",
            "aria-label": "Method Examples",
            onClick: this.handleClickListItem,
            children: /* @__PURE__ */ R.jsx(
              ZU,
              {
                primary: t[this.state.selectedIndex].name,
                secondary: t[this.state.selectedIndex].summary
              }
            )
          }
        ),
        /* @__PURE__ */ R.jsx(
          JU,
          {
            id: "menu-menu",
            anchorEl: a,
            open: !!a,
            onClose: this.handleClose,
            children: t.map((i, s) => /* @__PURE__ */ R.jsx(
              QU,
              {
                selected: s === this.state.selectedIndex,
                onClick: (u) => this.handleMenuItemClick(u, s),
                children: i.name
              },
              i.name
            ))
          }
        )
      ] }) }),
      /* @__PURE__ */ R.jsx(Er, { size: { xs: 12 }, children: t && /* @__PURE__ */ R.jsx(
        Kne,
        {
          uiSchema: r,
          paramStructure: this.props.method && this.props.method.paramStructure,
          examplePairing: t[this.state.selectedIndex],
          methodName: this.props.method && this.props.method.name,
          reactJsonOptions: this.props.reactJsonOptions
        }
      ) })
    ] }) }, "examples");
  }
}
const Yb = "ExpansionTable", Xb = {
  heading: `${Yb}-heading`,
  root: `${Yb}-root`,
  secondaryHeading: `${Yb}-secondaryHeading`
}, Zne = cn(bc)(({ theme: e }) => ({
  [`& .${Xb.heading}`]: {
    flexBasis: "33.33%",
    flexShrink: 0,
    fontSize: e.typography.pxToRem(15)
  },
  [`& .${Xb.root}`]: {
    marginBottom: e.spacing(2),
    marginTop: e.spacing(6),
    width: "100%"
  },
  [`& .${Xb.secondaryHeading}`]: {
    alignSelf: "end",
    color: e.palette.text.secondary,
    fontSize: e.typography.pxToRem(15)
  },
  "& .MuiTableCell-root": {
    color: e.palette.text.primary,
    borderBottomColor: e.palette.divider
  },
  "& .MuiTableCell-head": {
    color: `${e.palette.text.primary} !important`,
    fontWeight: 500
  },
  "& .MuiTableCell-alignRight": {
    color: `${e.palette.text.primary} !important`
  }
}));
class vL extends xr {
  render() {
    const { headers: t, children: n } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ R.jsxs(Zne, { children: [
      /* @__PURE__ */ R.jsx(Ec, { children: /* @__PURE__ */ R.jsx(Wa, { children: t.map((r, a) => /* @__PURE__ */ R.jsx(en, { align: a === 0 ? void 0 : "right", children: r }, a)) }) }),
      /* @__PURE__ */ R.jsx(vc, { children: n })
    ] });
  }
}
const Zb = "Info", Ba = {
  button: `${Zb}-button`,
  chip: `${Zb}-chip`,
  description: `${Zb}-description`
}, Jne = i0("div")(({ theme: e }) => ({
  [`& .${Ba.button}`]: {
    margin: e.spacing(2)
  },
  [`& .${Ba.chip}`]: {
    margin: e.spacing(2)
  },
  [`& .${Ba.description}`]: {
    color: e.palette.text.primary,
    padding: `${e.spacing(2)}px 0 ${e.spacing(2)}px 0`
  }
}));
class Qne extends xr {
  render() {
    const { schema: t } = this.props;
    if (!t || !t.info)
      return null;
    const n = t.info;
    return /* @__PURE__ */ R.jsxs(Jne, { children: [
      n.title && /* @__PURE__ */ R.jsx(ye, { variant: "h2", gutterBottom: !0, children: n.title }),
      n.version && /* @__PURE__ */ R.jsx(du, { label: n.version }),
      n.license && n.license.name && n.license.url && /* @__PURE__ */ R.jsx(
        du,
        {
          component: "a",
          href: n.license.url,
          className: Ba.chip,
          clickable: !0,
          color: "primary",
          label: n.license.name
        }
      ),
      n.description && /* @__PURE__ */ R.jsx(aE, { className: Ba.description, children: n.description }),
      n.termsOfService && /* @__PURE__ */ R.jsx(Wl, { className: Ba.button, variant: "contained", href: n.termsOfService, children: "Terms Of Service" }),
      n.contact && n.contact.url && n.contact.name && /* @__PURE__ */ R.jsxs(Wl, { className: Ba.button, variant: "contained", href: n.contact.url, children: [
        "Contact ",
        n.contact.name
      ] }),
      n.contact && n.contact.email && /* @__PURE__ */ R.jsxs(
        Wl,
        {
          className: Ba.button,
          variant: "contained",
          href: `mailto:${n.contact.email}`,
          children: [
            "Email ",
            n.contact.name
          ]
        }
      )
    ] });
  }
}
const ere = {
  900: "#f57f17"
}, Ct = {
  cellWidth: {
    width: "70px"
  }
}, tre = (e) => Array.isArray(e), Qk = ({ schema: e, required: t, name: n }) => {
  if (e.anyOf)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "any of" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: e.anyOf.map((i, s) => /* @__PURE__ */ R.jsx(hi, { schema: i }, s)) }) })
    ] });
  if (e.allOf)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "all of" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: e.allOf.map((i, s) => /* @__PURE__ */ R.jsx(hi, { schema: i }, s)) }) })
    ] });
  if (e.oneOf)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title || n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "one of" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: e.oneOf.map((i, s) => /* @__PURE__ */ R.jsx(hi, { schema: i }, s)) }) })
    ] });
  if (e.items instanceof Array)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "array of" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: e.items.map((i, s) => /* @__PURE__ */ R.jsx(hi, { schema: i }, s)) }) })
    ] });
  if (e.items)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "array of" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx(hi, { schema: e.items }) }) })
    ] });
  if (e.properties)
    return /* @__PURE__ */ R.jsxs(Oa, { children: [
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", children: "object" }) }),
      /* @__PURE__ */ R.jsx(qe, { colSpan: 5, children: /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsxs(ej, { children: [
        /* @__PURE__ */ R.jsx(tj, { children: /* @__PURE__ */ R.jsxs(Oa, { children: [
          /* @__PURE__ */ R.jsx(qe, { children: "Name" }),
          /* @__PURE__ */ R.jsx(qe, { children: "Title" }),
          /* @__PURE__ */ R.jsx(qe, { children: "Type" }),
          /* @__PURE__ */ R.jsx(qe, { children: "Pattern" }),
          /* @__PURE__ */ R.jsx(qe, { children: "Required" }),
          /* @__PURE__ */ R.jsx(qe, { children: "Description" })
        ] }) }),
        /* @__PURE__ */ R.jsx(nj, { children: e.properties && Object.entries(e.properties).map(([i, s]) => /* @__PURE__ */ R.jsx(
          hi,
          {
            schema: s,
            name: i,
            hideHeader: !0,
            required: e.required && tre(e.required) && e.required.includes(i)
          },
          i
        )) })
      ] }) }) })
    ] });
  const r = (i) => Array.isArray(i) ? i.join(" | ") : i, a = {
    any: Ql[500],
    array: Ma[300],
    boolean: Ma[500],
    integer: Da[800],
    null: ere[900],
    number: Da[500],
    string: ci[500],
    undefined: Ql[500],
    union: Ql[500]
  };
  return /* @__PURE__ */ R.jsxs(Oa, { children: [
    /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: n }),
    /* @__PURE__ */ R.jsx(qe, { colSpan: 1, style: Ct.cellWidth, children: e.title }),
    /* @__PURE__ */ R.jsx(
      qe,
      {
        style: {
          ...Ct.cellWidth,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          color: Array.isArray(e.type) ? a.union : a[e.type]
        },
        children: r(e.type)
      }
    ),
    /* @__PURE__ */ R.jsx(qe, { style: Ct.cellWidth, children: e.pattern }),
    /* @__PURE__ */ R.jsx(qe, { style: Ct.cellWidth, children: t ? "true" : "false" }),
    /* @__PURE__ */ R.jsx(qe, { style: Ct.cellWidth, children: e.description })
  ] }, e.title);
}, nre = "WrappedJSONSchemaFields", rre = {
  table: `${nre}-table`
};
class are extends xr {
  render() {
    const { schema: t, name: n, required: r, hideHeader: a } = this.props;
    return !t || Ru.isEmpty(t) ? null : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      !a && /* @__PURE__ */ R.jsxs(bc, { className: rre.table, children: [
        /* @__PURE__ */ R.jsx(Ec, { children: /* @__PURE__ */ R.jsxs(Wa, { children: [
          /* @__PURE__ */ R.jsx(en, { children: "Name" }),
          /* @__PURE__ */ R.jsx(en, { children: "Title" }),
          /* @__PURE__ */ R.jsx(en, { children: "Type" }),
          /* @__PURE__ */ R.jsx(en, { children: "Pattern" }),
          /* @__PURE__ */ R.jsx(en, { children: "Required" }),
          /* @__PURE__ */ R.jsx(en, { children: "Description" })
        ] }) }),
        /* @__PURE__ */ R.jsx(vc, { children: /* @__PURE__ */ R.jsx(Qk, { schema: t, required: r, name: n }) })
      ] }),
      a && /* @__PURE__ */ R.jsx(Qk, { schema: t, required: r, name: n })
    ] });
  }
}
const hi = are;
class Ure extends xr {
  render() {
    const { schema: t } = this.props;
    return /* @__PURE__ */ R.jsx(hi, { schema: t });
  }
}
function ire(e) {
  return typeof e.main == "string";
}
function ore(e, t = []) {
  if (!ire(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function sre(e = []) {
  return ([, t]) => t && ore(t, e);
}
function lre(e) {
  return Sn("MuiTypography", e);
}
xn("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const ure = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, cre = FG(), dre = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: a,
    variant: i,
    classes: s
  } = e, u = {
    root: ["root", i, e.align !== "inherit" && `align${En(t)}`, n && "gutterBottom", r && "noWrap", a && "paragraph"]
  };
  return Dn(u, lre, s);
}, pre = Gt("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${En(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(tr(({
  theme: e
}) => ({
  margin: 0,
  variants: [{
    props: {
      variant: "inherit"
    },
    style: {
      // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
      font: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  }, ...Object.entries(e.typography).filter(([t, n]) => t !== "inherit" && n && typeof n == "object").map(([t, n]) => ({
    props: {
      variant: t
    },
    style: n
  })), ...Object.entries(e.palette).filter(sre()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette?.text || {}).filter(([, t]) => typeof t == "string").map(([t]) => ({
    props: {
      color: `text${En(t)}`
    },
    style: {
      color: (e.vars || e).palette.text[t]
    }
  })), {
    props: ({
      ownerState: t
    }) => t.align !== "inherit",
    style: {
      textAlign: "var(--Typography-textAlign)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.noWrap,
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.gutterBottom,
    style: {
      marginBottom: "0.35em"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.paragraph,
    style: {
      marginBottom: 16
    }
  }]
}))), e0 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Wr = /* @__PURE__ */ B.forwardRef(function(t, n) {
  const {
    color: r,
    ...a
  } = Tn({
    props: t,
    name: "MuiTypography"
  }), i = !ure[r], s = cre({
    ...a,
    ...i && {
      color: r
    }
  }), {
    align: u = "inherit",
    className: c,
    component: d,
    gutterBottom: p = !1,
    noWrap: f = !1,
    paragraph: m = !1,
    variant: h = "body1",
    variantMapping: E = e0,
    ...y
  } = s, w = {
    ...s,
    align: u,
    color: r,
    className: c,
    component: d,
    gutterBottom: p,
    noWrap: f,
    paragraph: m,
    variant: h,
    variantMapping: E
  }, x = d || (m ? "p" : E[h] || e0[h]) || "span", I = dre(w);
  return /* @__PURE__ */ R.jsx(pre, {
    as: x,
    ref: n,
    className: pt(I.root, c),
    ...y,
    ownerState: w,
    style: {
      ...u !== "inherit" && {
        "--Typography-textAlign": u
      },
      ...y.style
    }
  });
}), zl = "Servers", ma = {
  description: `${zl}-description`,
  heading: `${zl}-heading`,
  paramsMargin: `${zl}-paramsMargin`,
  secondaryHeading: `${zl}-secondaryHeading`
}, fre = cn("div")(({ theme: e }) => ({
  [`& .${ma.description}`]: {
    color: e.palette.text.primary
  },
  [`& .${ma.heading}`]: {
    flexBasis: "33.33%",
    flexShrink: 0,
    fontSize: e.typography.pxToRem(15)
  },
  [`& .${ma.paramsMargin}`]: {
    marginTop: e.spacing(2)
  },
  [`& .${ma.secondaryHeading}`]: {
    alignSelf: "end",
    color: e.palette.text.secondary,
    fontSize: e.typography.pxToRem(15)
  }
}));
class EL extends xr {
  render() {
    const { servers: t, noTitle: n, reactJsonOptions: r, uiSchema: a } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ R.jsxs(fre, { children: [
      n ? null : /* @__PURE__ */ R.jsx(ye, { variant: "h2", children: "Servers" }),
      /* @__PURE__ */ R.jsx(vL, { headers: ["Name", "Url", "Summary"], children: /* @__PURE__ */ R.jsx(Wa, { children: /* @__PURE__ */ R.jsx(en, { colSpan: 6, children: t.map((i, s) => /* @__PURE__ */ R.jsx("div", { style: { width: "100%" }, children: /* @__PURE__ */ R.jsxs(
        o0,
        {
          style: { width: "100%" },
          defaultExpanded: a && a.servers["ui:defaultExpanded"],
          children: [
            /* @__PURE__ */ R.jsxs(
              s0,
              {
                style: { justifyContent: "space-between" },
                expandIcon: /* @__PURE__ */ R.jsx(_s, {}),
                sx: {
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    order: -1,
                    marginRight: 1,
                    marginLeft: 0
                  },
                  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                    transform: "rotate(90deg)"
                  }
                },
                children: [
                  /* @__PURE__ */ R.jsx(ye, { className: ma.heading, children: i.name }),
                  /* @__PURE__ */ R.jsx(ye, { className: ma.secondaryHeading, children: i.url }),
                  /* @__PURE__ */ R.jsx(ye, { className: ma.secondaryHeading, children: i.summary })
                ]
              },
              "servers-header"
            ),
            /* @__PURE__ */ R.jsxs(jy, { style: { display: "block" }, children: [
              i.description && /* @__PURE__ */ R.jsx(
                Bs,
                {
                  uiSchema: a,
                  source: i.description,
                  className: ma.description
                }
              ),
              i.variables && /* @__PURE__ */ R.jsx(ye, { variant: "h6", gutterBottom: !0, className: ma.paramsMargin, children: "Variables" }),
              i.variables && /* @__PURE__ */ R.jsx(ze, { value: i.variables, ...r })
            ] }, "servers-body")
          ]
        },
        s
      ) }, s)) }) }) })
    ] });
  }
}
const Jb = "Links", Qb = {
  heading: `${Jb}-heading`,
  paramsMargin: `${Jb}-paramsMargin`,
  secondaryHeading: `${Jb}-secondaryHeading`
}, gre = i0(vL)(({ theme: e }) => ({}));
class mre extends xr {
  render() {
    const { links: t, uiSchema: n, reactJsonOptions: r } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ R.jsx(gre, { headers: ["Method", "Summary"], children: /* @__PURE__ */ R.jsx(Wa, { children: /* @__PURE__ */ R.jsx(en, { colSpan: 6, children: t.map((a, i) => /* @__PURE__ */ R.jsx("div", { style: { width: "100%" }, children: /* @__PURE__ */ R.jsxs(
      o0,
      {
        style: { width: "100%" },
        defaultExpanded: n && n.links["ui:defaultExpanded"],
        children: [
          /* @__PURE__ */ R.jsx(
            s0,
            {
              style: { justifyContent: "space-between" },
              expandIcon: /* @__PURE__ */ R.jsx(_s, {}),
              sx: {
                "& .MuiAccordionSummary-expandIconWrapper": {
                  order: -1,
                  marginRight: 1,
                  marginLeft: 0
                },
                "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                  transform: "rotate(90deg)"
                }
              },
              children: /* @__PURE__ */ R.jsxs("div", { className: "method-summary-container", children: [
                /* @__PURE__ */ R.jsx(Wr, { className: Qb.heading, children: a.method }),
                /* @__PURE__ */ R.jsx(Wr, { className: Qb.secondaryHeading, children: a.summary })
              ] })
            },
            "links-header"
          ),
          /* @__PURE__ */ R.jsxs(jy, { style: { display: "block" }, children: [
            a.description && /* @__PURE__ */ R.jsx(aE, { children: a.description }),
            a.params && /* @__PURE__ */ R.jsx(Wr, { variant: "h6", gutterBottom: !0, children: "Params" }),
            a.params && /* @__PURE__ */ R.jsx(ze, { value: a.params, ...r }),
            a.server && /* @__PURE__ */ R.jsx(Wr, { variant: "h6", gutterBottom: !0, className: Qb.paramsMargin, children: "Server" }),
            a.server && /* @__PURE__ */ R.jsx(
              EL,
              {
                servers: [a.server],
                noTitle: !0,
                reactJsonOptions: r
              }
            )
          ] }, "links-body")
        ]
      },
      i
    ) }, i)) }) }) });
  }
}
const Gl = "Params", Ei = {
  schema: `${Gl}-schema`,
  table: `${Gl}-table`,
  tableEnd: `${Gl}-tableEnd`,
  tableStart: `${Gl}-tableStart`
}, hre = cn(bc)(({ theme: e }) => ({
  [`& .${Ei.schema}`]: {
    marginLeft: e.spacing(8)
  },
  [`&.${Ei.table}`]: {
    padding: e.spacing(2),
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary
  },
  [`& .${Ei.tableEnd}`]: {
    paddingLeft: e.spacing(3),
    color: e.palette.text.primary
  },
  [`& .${Ei.tableStart}`]: {
    paddingLeft: e.spacing(3),
    color: e.palette.text.primary
  },
  // Add theme colors to all table components
  "& .MuiTableCell-root": {
    color: e.palette.text.primary,
    borderBottomColor: `${e.palette.divider} !important`
  },
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      color: `${e.palette.text.primary} !important`,
      fontWeight: e.typography.fontWeightMedium
    }
  },
  "& .MuiTableBody-root": {
    "& .MuiTableCell-root": {
      color: `${e.palette.text.primary} !important`
    }
  }
}));
class bre extends xr {
  render() {
    const { params: t, uiSchema: n } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ R.jsxs(hre, { className: Ei.table, children: [
      /* @__PURE__ */ R.jsx(Ec, { children: /* @__PURE__ */ R.jsxs(Wa, { children: [
        /* @__PURE__ */ R.jsx(en, { className: Ei.tableStart, children: "Parameter Name" }, 1),
        /* @__PURE__ */ R.jsx(en, { align: "right", children: "Summary" }, 2),
        /* @__PURE__ */ R.jsx(en, { align: "right", className: Ei.tableEnd, children: "Required" }, 3)
      ] }) }),
      /* @__PURE__ */ R.jsx(vc, { children: /* @__PURE__ */ R.jsx(Wa, { children: /* @__PURE__ */ R.jsx(en, { colSpan: 6, children: t.map((r) => /* @__PURE__ */ R.jsx(
        iE,
        {
          contentDescriptor: r,
          uiSchema: n,
          disableTransitionProps: this.props.disableTransitionProps
        },
        r.name
      )) }) }) })
    ] });
  }
}
const yre = [
  /* 14 tones, 19 colors */
  /* 16 colors without last 4 tones */
  // Red,     Pink,       Purple,     Deep Purple, Indigo, Blue,      Light Blue, Cyan,     Teal,      Green,     Light Green, Lime,    Yellow,    Amber,     Orange,   Deep Orange, Brown,   Grey,     Blue Grey
  /*  50*/
  [
    "#FFEBEE",
    "#FCE4EC",
    "#F3E5F5",
    "#EDE7F6",
    "#E8EAF6",
    "#E3F2FD",
    "#E1F5FE",
    "#E0F7FA",
    "#E0F2F1",
    "#E8F5E9",
    "#F1F8E9",
    "#F9FBE7",
    "#FFFDE7",
    "#FFF8E1",
    "#FFF3E0",
    "#FBE9E7",
    "#EFEBE9",
    "#FAFAFA",
    "#ECEFF1"
  ],
  /* 100*/
  [
    "#FFCDD2",
    "#F8BBD0",
    "#E1BEE7",
    "#D1C4E9",
    "#C5CAE9",
    "#BBDEFB",
    "#B3E5FC",
    "#B2EBF2",
    "#B2DFDB",
    "#C8E6C9",
    "#DCEDC8",
    "#F0F4C3",
    "#FFF9C4",
    "#FFECB3",
    "#FFE0B2",
    "#FFCCBC",
    "#D7CCC8",
    "#F5F5F5",
    "#CFD8DC"
  ],
  /* 200*/
  [
    "#EF9A9A",
    "#F48FB1",
    "#CE93D8",
    "#B39DDB",
    "#9FA8DA",
    "#90CAF9",
    "#81D4FA",
    "#80DEEA",
    "#80CBC4",
    "#A5D6A7",
    "#C5E1A5",
    "#E6EE9C",
    "#FFF59D",
    "#FFE082",
    "#FFCC80",
    "#FFAB91",
    "#BCAAA4",
    "#EEEEEE",
    "#B0BEC5"
  ],
  /* 300*/
  [
    "#E57373",
    "#F06292",
    "#BA68C8",
    "#9575CD",
    "#7986CB",
    "#64B5F6",
    "#4FC3F7",
    "#4DD0E1",
    "#4DB6AC",
    "#81C784",
    "#AED581",
    "#DCE775",
    "#FFF176",
    "#FFD54F",
    "#FFB74D",
    "#FF8A65",
    "#A1887F",
    "#E0E0E0",
    "#90A4AE"
  ],
  /* 400*/
  [
    "#EF5350",
    "#EC407A",
    "#AB47BC",
    "#7E57C2",
    "#5C6BC0",
    "#42A5F5",
    "#29B6F6",
    "#26C6DA",
    "#26A69A",
    "#66BB6A",
    "#9CCC65",
    "#D4E157",
    "#FFEE58",
    "#FFCA28",
    "#FFA726",
    "#FF7043",
    "#8D6E63",
    "#BDBDBD",
    "#78909C"
  ],
  /* 500*/
  [
    "#F44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#2196F3",
    "#03A9F4",
    "#00BCD4",
    "#009688",
    "#4CAF50",
    "#8BC34A",
    "#CDDC39",
    "#FFEB3B",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#795548",
    "#9E9E9E",
    "#607D8B"
  ],
  /* 600*/
  [
    "#E53935",
    "#D81B60",
    "#8E24AA",
    "#5E35B1",
    "#3949AB",
    "#1E88E5",
    "#039BE5",
    "#00ACC1",
    "#00897B",
    "#43A047",
    "#7CB342",
    "#C0CA33",
    "#FDD835",
    "#FFB300",
    "#FB8C00",
    "#F4511E",
    "#6D4C41",
    "#757575",
    "#546E7A"
  ],
  /* 700*/
  [
    "#D32F2F",
    "#C2185B",
    "#7B1FA2",
    "#512DA8",
    "#303F9F",
    "#1976D2",
    "#0288D1",
    "#0097A7",
    "#00796B",
    "#388E3C",
    "#689F38",
    "#AFB42B",
    "#FBC02D",
    "#FFA000",
    "#F57C00",
    "#E64A19",
    "#5D4037",
    "#616161",
    "#455A64"
  ],
  /* 800*/
  [
    "#C62828",
    "#AD1457",
    "#6A1B9A",
    "#4527A0",
    "#283593",
    "#1565C0",
    "#0277BD",
    "#00838F",
    "#00695C",
    "#2E7D32",
    "#558B2F",
    "#9E9D24",
    "#F9A825",
    "#FF8F00",
    "#EF6C00",
    "#D84315",
    "#4E342E",
    "#424242",
    "#37474F"
  ],
  /* 900*/
  [
    "#B71C1C",
    "#880E4F",
    "#4A148C",
    "#311B92",
    "#1A237E",
    "#0D47A1",
    "#01579B",
    "#006064",
    "#004D40",
    "#1B5E20",
    "#33691E",
    "#827717",
    "#F57F17",
    "#FF6F00",
    "#E65100",
    "#BF360C",
    "#3E2723",
    "#212121",
    "#263238"
  ],
  /*A100*/
  [
    "#FF8A80",
    "#FF80AB",
    "#EA80FC",
    "#B388FF",
    "#8C9EFF",
    "#82B1FF",
    "#80D8FF",
    "#84FFFF",
    "#A7FFEB",
    "#B9F6CA",
    "#CCFF90",
    "#F4FF81",
    "#FFFF8D",
    "#FFE57F",
    "#FFD180",
    "#FF9E80"
  ],
  /*A200*/
  [
    "#FF5252",
    "#FF4081",
    "#E040FB",
    "#7C4DFF",
    "#536DFE",
    "#448AFF",
    "#40C4FF",
    "#18FFFF",
    "#64FFDA",
    "#69F0AE",
    "#B2FF59",
    "#EEFF41",
    "#FFFF00",
    "#FFD740",
    "#FFAB40",
    "#FF6E40"
  ],
  /*A400*/
  [
    "#FF1744",
    "#F50057",
    "#D500F9",
    "#651FFF",
    "#3D5AFE",
    "#2979FF",
    "#00B0FF",
    "#00E5FF",
    "#1DE9B6",
    "#00E676",
    "#76FF03",
    "#C6FF00",
    "#FFEA00",
    "#FFC400",
    "#FF9100",
    "#FF3D00"
  ],
  /*A700*/
  [
    "#D50000",
    "#C51162",
    "#AA00FF",
    "#6200EA",
    "#304FFE",
    "#2962FF",
    "#0091EA",
    "#00B8D4",
    "#00BFA5",
    "#00C853",
    "#64DD17",
    "#AEEA00",
    "#FFD600",
    "#FFAB00",
    "#FF6D00",
    "#DD2C00"
  ]
];
function vre(e, { darkColors: t = !0, accentColors: n = !0 } = {}) {
  if (!e?.length)
    throw new Error("Input string is required");
  const r = t ? 18 : 15;
  let a = n ? 13 : 9;
  const i = t0(e) % r;
  t && i > 15 && (a = 9);
  const s = t0(e) % a;
  return yre[s][i];
}
function t0(e) {
  let t = 5381;
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t = (t << 5) + t + r;
  }
  return Math.abs(t);
}
class Ere extends xr {
  render() {
    const { tags: t } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ R.jsx(R.Fragment, { children: t.map((n) => /* @__PURE__ */ R.jsx(
      du,
      {
        label: n.name,
        style: { backgroundColor: vre(n.name) }
      },
      n.name
    )) });
  }
}
const Sre = xn("MuiBox", ["root"]), xre = j0(), Tre = sz({
  themeId: av,
  defaultTheme: xre,
  defaultClassName: Sre.root,
  generateClassName: _0.generate
}), wre = "SupportedExtensions-ErrorGroups", n0 = {
  code: `${wre}-code`
};
cn(Er)(({ theme: e }) => ({
  [`& .${n0.code}`]: {
    marginLeft: e.spacing(2)
  },
  [`& .${n0.code}`]: {
    marginLeft: e.spacing(2)
  },
  "& .MuiTableCell-root": {
    color: e.palette.text.primary,
    borderBottomColor: e.palette.divider
  },
  "& .MuiTableCell-head": {
    color: `${e.palette.text.primary} !important`,
    fontWeight: 500
  },
  "& .MuiTypography-root": {
    color: e.palette.text.primary
  },
  "& .MuiTable-root": {
    backgroundColor: e.palette.background.paper
  }
}));
const Are = (e) => e["x-error-group"], Ire = (e, t) => {
  const n = t ? t.flat() : [];
  return [...e || [], ...n].filter(
    (i, s, u) => s === u.findIndex((c) => X1.isEqual(c, i))
  );
}, Hl = "Methods", Ua = {
  description: `${Hl}-description`,
  heading: `${Hl}-heading`,
  root: `${Hl}-root`,
  secondaryHeading: `${Hl}-secondaryHeading`
}, Rre = cn(Tre)(({ theme: e }) => ({
  [`& .${Ua.description}`]: {
    color: e.palette.text.primary,
    width: "100%"
  },
  [`& .${Ua.heading}`]: {
    flexBasis: "33.33%",
    flexShrink: 0,
    fontSize: e.typography.pxToRem(15),
    color: e.palette.text.primary
  },
  [`&.${Ua.root}`]: {
    marginBottom: e.spacing(2),
    marginTop: e.spacing(3),
    width: "100%",
    backgroundColor: e.palette.background.default
  },
  [`& .${Ua.secondaryHeading}`]: {
    color: e.palette.text.secondary,
    fontSize: e.typography.pxToRem(15)
  },
  "& .MuiAccordion-Heading": {
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary
  },
  "& .MuiAccordion-root": {
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary,
    borderColor: `${e.palette.divider} !important`,
    position: "relative",
    "&::before": {
      backgroundColor: `${e.palette.divider} !important`
    }
  },
  "& .MuiAccordionSummary-root": {
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary
  },
  "& .MuiAccordionDetails-root": {
    backgroundColor: e.palette.background.paper,
    color: e.palette.text.primary
  },
  "& .MuiTypography-root": {
    color: e.palette.text.primary
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: `${e.palette.text.primary} !important`
  },
  "& .MuiAccordionSummary-expandIconWrapper svg": {
    color: `${e.palette.text.primary} !important`
  },
  "& .MuiSvgIcon-root": {
    color: `${e.palette.text.primary} !important`
  }
})), _re = ({
  schema: e,
  uiSchema: t,
  reactJsonOptions: n,
  methodPlugins: r,
  disableTransitionProps: a,
  onMethodToggle: i
}) => {
  if (!e || !e || !e.methods)
    return null;
  const s = e.methods;
  return s && s.length > 0 ? /* @__PURE__ */ R.jsxs(Rre, { className: Ua.root, children: [
    /* @__PURE__ */ R.jsx(Wr, { variant: "h3", gutterBottom: !0, children: "Methods" }),
    s.map((c, d) => {
      const p = Ire(c.errors, Are(c));
      return /* @__PURE__ */ R.jsxs(
        uv,
        {
          id: c.name,
          TransitionProps: { unmountOnExit: !a },
          onChange: (f, m) => {
            i && i(c.name, m);
          },
          defaultExpanded: t && t.methods && (t.methods["ui:defaultExpanded"] === !0 || t.methods["ui:defaultExpanded"] && t.methods["ui:defaultExpanded"][c.name] === !0),
          children: [
            /* @__PURE__ */ R.jsxs(
              cv,
              {
                expandIcon: /* @__PURE__ */ R.jsx(_s, {}),
                sx: {
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    order: -1,
                    marginRight: 1,
                    marginLeft: 0
                  },
                  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                    transform: "rotate(90deg)"
                  }
                },
                children: [
                  /* @__PURE__ */ R.jsx(Wr, { className: Ua.heading, children: c.name }),
                  /* @__PURE__ */ R.jsx(Wr, { className: Ua.secondaryHeading, children: c.summary })
                ]
              }
            ),
            c.tags && c.tags.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(Ere, { tags: c.tags }) }, "tags"),
            c.description && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(
              Bs,
              {
                uiSchema: t,
                source: c.description,
                className: Ua.description
              }
            ) }, "description"),
            c.params && c.params.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(Wr, { variant: "h5", children: "Params" }) }, "params-title"),
            c.params && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(bre, { params: c.params, uiSchema: t }) }, "params"),
            c.result && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(Wr, { variant: "h5", children: "Result" }) }, "result-title"),
            c.result && c.result.schema && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(
              iE,
              {
                contentDescriptor: c.result,
                hideRequired: !0,
                uiSchema: t
              }
            ) }, "result"),
            p && p.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(Hne, { errors: p, reactJsonOptions: n }) }, "errors"),
            /* @__PURE__ */ R.jsx(
              Xne,
              {
                uiSchema: t,
                examples: c.examples,
                method: c,
                reactJsonOptions: n
              },
              "example-pairings"
            ),
            c.links && c.links.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(Wr, { variant: "h5", children: "Links" }) }, "links-title"),
            c.links && c.links.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: /* @__PURE__ */ R.jsx(mre, { links: c.links, reactJsonOptions: n }) }, "links"),
            r && r.length > 0 && /* @__PURE__ */ R.jsx(fr, { children: r.map((f, m) => /* @__PURE__ */ R.jsx(f, { openrpcMethodObject: c }, `method-plugin-${m}`)) }, "method-plugins")
          ]
        },
        d + c.name
      );
    })
  ] }) : null;
}, Cre = lv(/* @__PURE__ */ R.jsx("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew"), kre = lv(/* @__PURE__ */ R.jsx("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1z"
}), "Lock"), Xo = "Extension", Hn = {
  description: `${Xo}-description`,
  heading: `${Xo}-heading`,
  secondaryHeading: `${Xo}-secondaryHeading`,
  sectionTitle: `${Xo}-sectionTitle`,
  sectionContent: `${Xo}-sectionContent`
}, Nre = cn(uv)({}), Ore = cn(qy)(({ theme: e }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: e.spacing(1),
  marginTop: e.spacing(1),
  marginBottom: e.spacing(2)
})), Vl = cn(qy)(({ theme: e }) => ({
  marginBottom: e.spacing(3)
})), Lre = ({ extension: e, hideIcon: t, uiSchema: n, disableTransitionProps: r }) => {
  const a = Uy();
  if (!e || typeof e != "object" || e === null)
    return null;
  const i = e.name || "";
  return /* @__PURE__ */ R.jsxs(
    Nre,
    {
      style: { width: "100%" },
      TransitionProps: { unmountOnExit: !r },
      defaultExpanded: n && n.extensions && n.extensions["ui:defaultExpanded"],
      expanded: i ? void 0 : !0,
      sx: {
        [`& .${Hn.description}`]: {
          color: a.palette.text.primary
        },
        [`& .${Hn.heading}`]: {
          flexBasis: "33.33%",
          flexShrink: 0,
          fontSize: a.typography.pxToRem(15),
          color: a.palette.text.primary
        },
        [`& .${Hn.secondaryHeading}`]: {
          alignSelf: "end",
          color: a.palette.text.secondary,
          fontSize: a.typography.pxToRem(15)
        },
        [`& .${Hn.sectionTitle}`]: {
          color: a.palette.primary.main,
          marginBottom: a.spacing(1),
          fontWeight: 500
        },
        [`& .${Hn.sectionContent}`]: {
          marginBottom: a.spacing(2)
        },
        "& .MuiAccordionSummary-root": {
          backgroundColor: a.palette.background.paper,
          color: a.palette.text.primary
        },
        "& .MuiAccordionSummary-expandIconWrapper": {
          color: `${a.palette.text.primary} !important`
        },
        "& .MuiAccordionSummary-expandIconWrapper svg": {
          color: `${a.palette.text.primary} !important`
        },
        "& .MuiAccordionDetails-root": {
          backgroundColor: a.palette.background.paper,
          color: a.palette.text.primary,
          padding: a.spacing(2, 3, 3)
        },
        "& .MuiTypography-root": {
          color: a.palette.text.primary
        },
        "& .MuiTypography-colorPrimary": {
          color: a.palette.primary.main
        }
      },
      children: [
        /* @__PURE__ */ R.jsx(
          cv,
          {
            style: { justifyContent: "space-between" },
            expandIcon: !i || t ? null : /* @__PURE__ */ R.jsx(_s, {}),
            sx: {
              "& .MuiAccordionSummary-expandIconWrapper": {
                order: -1,
                marginRight: 1,
                marginLeft: 0
              },
              "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                transform: "rotate(90deg)"
              }
            },
            children: /* @__PURE__ */ R.jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  height: "100%",
                  alignItems: "center"
                },
                children: [
                  /* @__PURE__ */ R.jsx(ye, { className: Hn.heading, children: i }),
                  /* @__PURE__ */ R.jsx(ye, { className: Hn.secondaryHeading, children: e.summary }),
                  e.version && /* @__PURE__ */ R.jsxs(ye, { className: Hn.secondaryHeading, children: [
                    "v",
                    e.version
                  ] })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ R.jsx(fr, { style: { display: "block", overflowX: "auto" }, children: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          e.description && /* @__PURE__ */ R.jsx(Vl, { children: /* @__PURE__ */ R.jsx(
            Bs,
            {
              uiSchema: n,
              source: e.description,
              className: Hn.description
            }
          ) }),
          e.restricted && e.restricted.length > 0 && /* @__PURE__ */ R.jsxs(Vl, { children: [
            /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", className: Hn.sectionTitle, children: "Restricted to" }),
            /* @__PURE__ */ R.jsx(Ore, { children: e.restricted.map((s, u) => /* @__PURE__ */ R.jsx(
              du,
              {
                label: s,
                size: "small",
                icon: /* @__PURE__ */ R.jsx(kre, {}),
                color: "primary",
                variant: "outlined",
                sx: {
                  borderRadius: "4px",
                  "& .MuiChip-icon": {
                    color: "inherit"
                  }
                }
              },
              `${s}-${u}`
            )) })
          ] }),
          e.externalDocumentation && /* @__PURE__ */ R.jsxs(Vl, { children: [
            /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", className: Hn.sectionTitle, children: "External Documentation" }),
            /* @__PURE__ */ R.jsxs(qy, { className: Hn.sectionContent, children: [
              e.externalDocumentation.description && /* @__PURE__ */ R.jsx(ye, { variant: "body2", gutterBottom: !0, children: e.externalDocumentation.description }),
              /* @__PURE__ */ R.jsx(
                Wl,
                {
                  variant: "outlined",
                  color: "primary",
                  size: "small",
                  endIcon: /* @__PURE__ */ R.jsx(Cre, {}),
                  href: e.externalDocumentation.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  sx: { mt: 1 },
                  children: "View Documentation"
                }
              )
            ] })
          ] }),
          e.schema && /* @__PURE__ */ R.jsxs(Vl, { children: [
            /* @__PURE__ */ R.jsx(ye, { variant: "body1", color: "primary", className: Hn.sectionTitle, children: "Schema" }),
            /* @__PURE__ */ R.jsx(KN, { schema: e.schema })
          ] })
        ] }) })
      ]
    }
  );
};
class Dre extends xr {
  render() {
    const { schema: t, disableTransitionProps: n } = this.props;
    if (!t || !t["x-extensions"])
      return null;
    const r = t["x-extensions"];
    return !r || r.length === 0 ? null : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(ye, { variant: "h3", gutterBottom: !0, children: "Extensions" }),
      r.map((a, i) => /* @__PURE__ */ R.jsx(
        Lre,
        {
          extension: a,
          disableTransitionProps: n,
          uiSchema: this.props.uiSchema,
          hideIcon: !1
        },
        `extension-${i}-${a.name}`
      ))
    ] });
  }
}
const jre = ({
  schema: e,
  uiSchema: t,
  reactJsonOptions: n,
  methodPlugins: r,
  onMethodToggle: a
}) => {
  if (!e)
    return null;
  const i = !(t && t.contentDescriptors && t.contentDescriptors["ui:hidden"] === !0), s = !(t && t.extensions && t.extensions["ui:hidden"] === !0);
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(Qne, { schema: e }),
    /* @__PURE__ */ R.jsx(EL, { servers: e.servers, reactJsonOptions: n }),
    /* @__PURE__ */ R.jsx(
      _re,
      {
        onMethodToggle: a,
        schema: e,
        uiSchema: t,
        reactJsonOptions: n,
        methodPlugins: r
      }
    ),
    i && /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsx(Ste, { schema: e, uiSchema: t }) }),
    s && /* @__PURE__ */ R.jsx(Dre, { schema: e, uiSchema: t })
  ] });
};
export {
  iE as ContentDescriptor,
  Ste as ContentDescriptors,
  jre as Documentation,
  Hne as Errors,
  Kne as ExamplePairing,
  Xne as ExamplePairings,
  vL as ExpansionTable,
  Qne as Info,
  Ure as JSONSchema,
  mre as Links,
  _re as Methods,
  bre as Params,
  EL as Servers,
  Ere as Tags
};
